webpackJsonp([0],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jokes = ['Hold on, moving satellites into positions..', 'Waiting until the stars align, please wait..', 'Making coffee, please wait..'];

var rand = Math.floor(Math.random() * jokes.length);

var Loading = function Loading(_ref) {
	var error = _ref.error,
	    withLogo = _ref.withLogo;
	return _react2.default.createElement(
		'div',
		{ className: 'isLoading', style: { backgroundImage: withLogo ? 'url("/images/bg.png")' : null, position: 'absolute', top: 0, right: 0, left: 0, bottom: 0 } },
		_react2.default.createElement(
			'div',
			null,
			withLogo ? _react2.default.createElement(
				'div',
				{ style: { position: 'absolute', marginLeft: 'auto', marginRight: 'auto', left: 0, right: 0 } },
				_react2.default.createElement('img', { style: { marginTop: '-160px', width: '200px' }, src: '/assets/images/logo.png' })
			) : null,
			error !== false ? _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement('i', { style: { fontSize: '50px' }, className: 'icon wb-thumb-down' }),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				'This didn\'t go as expected. Try refreshing the page..',
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'strong',
					null,
					'Message:'
				),
				' ',
				error
			) : _react2.default.createElement(
				'div',
				{ className: 'spin2win' },
				_react2.default.createElement('div', { className: 'double-bounce1' }),
				_react2.default.createElement('div', { className: 'double-bounce2' })
			),
			error !== false ? null : _react2.default.createElement(
				'div',
				{ style: { position: 'absolute', marginLeft: 'auto', marginRight: 'auto', left: 0, right: 0 } },
				_react2.default.createElement(
					'p',
					{ style: { fontWeight: 'bold', marginTop: withLogo === true ? '40px' : '30px' } },
					jokes[rand]
				)
			)
		)
	);
};

exports.default = Loading;

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _redux = __webpack_require__(4);

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

var _Login = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Auth = function () {
	function Auth() {
		_classCallCheck(this, Auth);
	}

	_createClass(Auth, null, [{
		key: 'authenticate',
		value: function authenticate(token) {
			var account_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var state = _store2.default.getState();

			if (account_id != state.auth.currentAccount && account_id != false) {
				_store2.default.dispatch((0, _Login.setCurrentAccount)(account_id));
			}

			if (!account_id) {
				account_id = state.auth.currentAccount;
			}

			if (!account_id && localStorage.getItem('last_account_id')) {
				account_id = localStorage.getItem('last_account_id');
				_store2.default.dispatch((0, _Login.setCurrentAccount)(account_id));

				return {
					action: 'redirect',
					url: '/dashboard'
				};
			}

			if (token) {
				_axios2.default.defaults.headers.common['Authorized-account'] = account_id;
				_axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			} else {
				delete _axios2.default.defaults.headers.common['Authorized-account'];
				delete _axios2.default.defaults.headers.common['Authorization'];
			}

			Auth.setToken(token);

			return true;
		}
	}, {
		key: 'isStaff',
		value: function isStaff() {
			return localStorage.getItem('is_staff');
		}
	}, {
		key: 'setToken',
		value: function setToken(token) {
			if (token) {
				localStorage.setItem('crallAuthToken', token);
			} else {
				localStorage.removeItem('crallAuthToken');
			}
		}
	}, {
		key: 'getToken',
		value: function getToken() {
			return localStorage.crallAuthToken || false;
		}
	}]);

	return Auth;
}();

exports.default = Auth;

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutabilityHelper = __webpack_require__(518);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _row = __webpack_require__(328);

var _row2 = _interopRequireDefault(_row);

var _FileUpload = __webpack_require__(329);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var deepFreeze = __webpack_require__(1032);


var builderReducer = function builderReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		sidebar: {
			selectedTab: 'components',
			visible: false,
			selectedElement: false,
			selectedRow: false,
			selectedSetting: false
		},
		stop_on: '',
		status: 0,

		ui: {
			'isHoveringRow': false,
			'isHoveringElement': false
		},

		page: {},

		components: {},

		elements: {},

		rows: {},
		tags: {},
		rules: {}
	};
	var action = arguments[1];


	var newState = state;
	var updateSortOrder = {};
	var merge = {};
	var el = false;

	switch (action.type) {
		case 'BUILDER_SET_SIDEBAR_TAB':
			if (action.payload == state.sidebar.selectedTab) {
				return state;
			}
			newState = (0, _immutabilityHelper2.default)(state, {
				sidebar: _defineProperty({}, "selectedTab", {
					$set: action.payload
				})
			});

			break;

		case 'SET_TAG':
			newState = _extends({}, state, {
				tags: _extends({}, state.tags, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;

		case 'BUILDER_CHANGE_RULE':
			newState = _extends({}, state, {
				rules: _extends({}, state.rules, _defineProperty({}, action.payload.index, _extends({}, state.rules[action.payload.index], _defineProperty({}, action.payload.key, action.payload.value))))
			});

			break;

		case 'BUILDER_DELETE_ROW':

			merge = Object.keys(newState.rows).filter(function (key) {
				return key != action.payload;
			}).reduce(function (result, current) {
				result[current] = newState.rows[current];
				return result;
			}, {});
			newState = _extends({}, newState, { rows: merge });

			break;

		case 'BUILDER_SET_GLOBAL_KEY_STATE':
			newState = _extends({}, state, _defineProperty({}, action.payload.key, action.payload.value));
			break;

		case 'BUILDER_DELETE_ELEMENT':

			newState = (0, _immutabilityHelper2.default)(state, {
				rows: _defineProperty({}, state.elements[action.payload].rowId, {
					elements: {
						$splice: [[state.rows[state.elements[action.payload].rowId].elements.indexOf(action.payload), 1]]
					}
				})
			});

			newState = _extends({}, newState, {
				ui: _extends({}, newState.ui, {
					isHoveringRow: false,
					isHoveringElement: false
				}),
				sidebar: _extends({}, newState.sidebar, {
					'visible': false,
					selectedRow: false,
					selectedElement: false
				})
			});

			merge = Object.keys(newState.elements).filter(function (key) {
				return key != action.payload;
			}).reduce(function (result, current) {
				result[current] = newState.elements[current];
				return result;
			}, {});
			newState = _extends({}, newState, { elements: merge });

			merge = Object.keys(newState.components).filter(function (key) {
				return key != action.payload;
			}).reduce(function (result, current) {
				result[current] = newState.components[current];
				return result;
			}, {});
			newState = _extends({}, newState, { components: merge });

			break;

		case 'BUILDER_SET_SIDEBAR_STATE':
			merge = Object.assign({}, state.sidebar, action.payload);

			newState = _extends({}, state, {
				sidebar: merge
			});
			break;

		case 'BUILDER_SET_GLOBAL_TYPE_STATE':
			if (action.payload.id == false) {
				merge = Object.assign({}, state[action.payload.key], action.payload.changes);

				newState = _extends({}, state, _defineProperty({}, action.payload.key, merge));
			} else {
				merge = Object.assign({}, state[action.payload.key][action.payload.id], action.payload.changes);

				newState = _extends({}, state, _defineProperty({}, action.payload.key, _extends({}, state[action.payload.key], _defineProperty({}, action.payload.id, merge))));
			}

			break;

		case 'BUILDER_SET_UI_STATE':
			merge = Object.assign({}, state.ui, action.payload);

			newState = _extends({}, state, {
				ui: merge
			});

			break;

		case 'BUILDER_SET_COMPONENT_STATE':
			merge = Object.assign({}, state.components[action.payload.id], action.payload.changes);

			newState = _extends({}, state, {
				components: _extends({}, state.components, _defineProperty({}, action.payload.id, merge))
			});
			break;

		case 'BUILDER_ADD_ROW':
			newState = _extends({}, state, {
				rows: _extends({}, state.rows, _defineProperty({}, action.payload.id, _extends({}, state.rows[action.payload.id], {
					type: 'row'
				})))
			});

			break;

		case 'BUILDER_SET_SELECTED_ROW':
			newState = _extends({}, state, {
				sidebar: _extends({}, state.sidebar, {
					selectedRow: action.payload
				})
			});
			break;

		case 'BUILDER_CONVERT_TO_ELEMENT':
			newState = _extends({}, state, {
				elements: _extends({}, state.elements, _defineProperty({}, action.payload.element.id, action.payload.element))
			});

			newState = _extends({}, newState, {
				components: _extends({}, newState.components, _defineProperty({}, action.payload.element.id, action.payload.el.output()))
			});

			break;

		case 'BUILDER_REMOVE_ELEMENT':
			if (!rowExists(state, action.payload.rowId)) {
				return state;
			}

			newState = (0, _immutabilityHelper2.default)(state, {
				rows: _defineProperty({}, action.payload.rowId, {
					elements: {
						$splice: [[state.rows[action.payload.rowId].elements.indexOf(action.payload.id), 1]]
					}
				})
			});

			Object.keys(newState).filter(function (key) {
				return key !== action.payload.id;
			}).reduce(function (result, current) {
				result[current] = newState[current];
				return result;
			}, {});

			break;

		case 'BUILDER_MOVE_ELEMENT':
			deepFreeze(state);

			var old_row_id = state.elements[action.payload.newPosition.id].rowId;
			var old_col_id = state.elements[action.payload.newPosition.id].col;

			updateSortOrder = {};
			for (var i in action.payload.newSorting.list) {
				updateSortOrder[i] = {
					sorting: {
						$set: action.payload.newSorting.list[i]
					}
				};
			}
			newState = (0, _immutabilityHelper2.default)(state, {
				elements: updateSortOrder
			});

			var draggedElement = {};
			var hoveredElement = {};

			//Add element if its not in column
			if (typeof action.payload.newSorting.list[action.payload.newPosition.id] === 'undefined') {
				newState = (0, _immutabilityHelper2.default)(state, {
					elements: _defineProperty({}, action.payload.newPosition.id, {
						sorting: {
							$set: action.payload.newPosition.sorting
						},
						rowId: {
							$set: action.payload.newPosition.rowId
						},
						col: {
							$set: action.payload.newPosition.col
						}
					})
				});
			}

			if (action.payload.newPosition.rowId != old_row_id || action.payload.newPosition.col != old_col_id) {
				newState = (0, _immutabilityHelper2.default)(newState, {
					rows: _defineProperty({}, old_row_id, {
						elements: {
							$splice: [[newState.rows[old_row_id].elements.indexOf(action.payload.newPosition.id), 1]]
						}
					})
				});

				newState = (0, _immutabilityHelper2.default)(newState, {
					rows: _defineProperty({}, action.payload.newPosition.rowId, {
						elements: {
							$push: [action.payload.newPosition.id]
						}
					})
				});
			}

			/*
   			if(action.payload.hover.id !== false) {
   				newState = update(newState,{
   					elements: {
   						[action.payload.hover.id]: {
   							sorting: {
   								$set:action.payload.drag.index
   							}
   						}
   					}
   				});
   			}
   
   
   			*/
			break;

		case 'BUILDER_ADD_PLACEHOLDER':

			updateSortOrder = {};
			for (var _i in action.payload.newSorting.list) {
				updateSortOrder[_i] = {
					sorting: {
						$set: action.payload.newSorting.list[_i]
					}
				};
			}
			newState = (0, _immutabilityHelper2.default)(state, {
				elements: updateSortOrder
			});

			newState = _extends({}, newState, {
				elements: _extends({}, newState.elements, _defineProperty({}, action.payload.newPosition.id, action.payload.newPosition))
			});

			newState = (0, _immutabilityHelper2.default)(newState, {
				rows: _defineProperty({}, action.payload.newPosition.rowId, {
					elements: {
						$push: [action.payload.newPosition.id]
					}
				})
			});
			break;

		case 'BUILDER_ADD_ROW_PLACEHOLDER':
			updateSortOrder = {};
			for (var _i2 in action.payload.newSorting.list) {
				updateSortOrder[_i2] = {
					sorting: {
						$set: action.payload.newSorting.list[_i2]
					}
				};
			}
			newState = (0, _immutabilityHelper2.default)(state, {
				rows: updateSortOrder
			});

			var newRow = new _row2.default(false);
			newRow.item.type = 'placeholder';
			newRow.item.id = action.payload.newPosition.id;
			newRow.item.sorting = action.payload.newPosition.sorting;
			newRow.item.columns = action.payload.newPosition.columns;

			newState = _extends({}, newState, {
				rows: _extends({}, newState.rows, _defineProperty({}, action.payload.newPosition.id, newRow.output()))
			});

			break;

		case 'BUILDER_MOVE_ROW':
			updateSortOrder = {};
			for (var _i3 in action.payload.newSorting.list) {
				updateSortOrder[_i3] = {
					sorting: {
						$set: action.payload.newSorting.list[_i3]
					}
				};
			}
			newState = (0, _immutabilityHelper2.default)(state, {
				rows: updateSortOrder
			});

			break;
	}

	return newState;
};

function rowExists(state, rowId) {
	if (typeof state.rows[rowId] === 'undefined') {
		return false;
	}

	return true;
}

function elementExists(state, elementId) {}

exports.default = builderReducer;

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var auth = function auth() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		token: '',
		wsStatus: false,
		loadedVisitors: false,
		hadConnection: false,
		isAuthenticated: false,
		currentAccount: false,
		user: {}
	};
	var action = arguments[1];


	var newState = state;

	switch (action.type) {
		case 'UPDATE_SETTING_KEY':
			newState = _extends({}, state, {
				user: _extends({}, state.user, {
					settings: _extends({}, state.user.settings, _defineProperty({}, action.payload.key, action.payload.value))
				})
			});
			break;
		case 'AUTH_SET_USER_KEY':
			newState = _extends({}, state, {
				user: _extends({}, state.user, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;
		case 'AUTH_SET_CONNECTION_STATUS':
			newState = _extends({}, state, {
				wsStatus: action.payload,
				hadConnection: true
			});
			break;

		case 'AUTH_SET_LOADED_VISITORS':
			newState = _extends({}, state, {
				loadedVisitors: action.payload
			});
			break;

		case 'AUTH_SET_CURRENT_ACCOUNT':
			localStorage.setItem('last_account_id', action.payload);

			newState = _extends({}, state, {
				currentAccount: action.payload
			});
			break;
		case 'AUTH_SET_CURRENT_USER':
			if (action.payload.token == false) {
				newState = _extends({}, state, {
					token: '',
					isAuthenticated: false,
					currentAccount: false,
					user: {}
				});
			} else {

				newState = _extends({}, state, {
					token: action.payload.token,
					isAuthenticated: true,
					user: action.payload.user
				});
			}
			break;

	}

	return newState;
};

exports.default = auth;

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutabilityHelper = __webpack_require__(518);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _lodash = __webpack_require__(192);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var chat = function chat() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		visitors: {},
		messages: {},
		subscribers: {},
		pages: {},
		cart: {},

		conversations: {},

		initialized: false,
		isOnline: false,
		filterOptions: [],
		currentTab: 1,
		currentChat: false,
		waitingForVisitorResponse: false
	};
	var action = arguments[1];


	var newState = state;
	var i = 0;

	switch (action.type) {

		case 'CHAT_SET_VISITOR_KEY':
			newState = _extends({}, state, {
				visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, _extends({}, state.visitors[action.payload.uid], _defineProperty({}, action.payload.key, action.payload.value))))
			});
			break;

		case 'CHAT_ADD_MESSAGE':

			var message = JSON.parse(action.payload.message);

			if (!state.conversations[action.payload.uid]) {
				state = _extends({}, state, {
					conversations: _extends({}, state.conversations, _defineProperty({}, action.payload.uid, []))
				});
			}

			if (parseInt(message.from) == 0) {
				state = _extends({}, state, {
					visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, _extends({}, state.visitors[action.payload.uid], {
						unreadMessages: parseInt(state.visitors[action.payload.uid].unreadMessages) + 1
					})))
				});
			} else {
				state = _extends({}, state, {
					visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, _extends({}, state.visitors[action.payload.uid], {
						unreadMessages: 0
					})))
				});
			}

			newState = _extends({}, state, {
				conversations: _extends({}, state.conversations, _defineProperty({}, action.payload.uid, [].concat(_toConsumableArray(state.conversations[action.payload.uid]), [action.payload.message])))
			});

			break;

		case 'CHAT_REMOVE_VISITOR':
			newState = _extends({}, state, {
				visitors: _lodash2.default.omit(state.visitors, action.payload)
			});
			break;

		case 'CHAT_SET_ASSIGNEE':
			newState = _extends({}, state, {
				visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, _extends({}, state.visitors[action.payload.uid], {
					assignee_id: action.payload.user_id
				})))
			});
			break;

		case 'CHAT_SET_STATUS':

			if (action.payload == 'true') {
				action.payload = true;
			}
			if (action.payload == 'false') {
				action.payload = false;
			}

			newState = _extends({}, state, {
				isOnline: action.payload != 'none' ? action.payload : !state.isOnline
			});

			break;

		case 'CHAT_SET_INIT':
			newState = _extends({}, state, {
				initialized: action.payload
			});

			break;

		case 'CHAT_SET_GLOBAL_KEY':
			newState = _extends({}, state, _defineProperty({}, action.payload.key, action.payload.value));

			break;

		case 'CHAT_ADD_VISITOR_DATA':
			newState = _extends({}, state, _defineProperty({}, action.payload.key, _extends({}, state[action.payload.key], _defineProperty({}, action.payload.uid, action.payload.data))));
			break;
		case 'CHAT_SET_OPEN_CHAT':

			newState = _extends({}, state, {
				currentTab: action.payload.tab,
				currentChat: action.payload.uid
			});
			break;

		case 'CHAT_SET_TAB':
			newState = _extends({}, state, {
				currentTab: action.payload
			});
			break;

		case 'CHAT_ADD_VISITOR':
			newState = _extends({}, state, {
				visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, action.payload))
			});
			break;

		case 'CHAT_UPDATE_VISITOR':
			newState = _extends({}, state, {
				visitors: _extends({}, state.visitors, _defineProperty({}, action.payload.uid, action.payload))
			});

			break;

		case 'CHAT_ADD_VISITORS':
			newState = _extends({}, state, {
				visitors: action.payload
			});
			break;

		case 'CHAT_ADD_CARTS':
			newState = _extends({}, state, {
				cart: action.payload
			});
			break;

		case 'CHAT_ADD_PAGES':
			newState = _extends({}, state, {
				pages: action.payload
			});
			break;

		case 'CHAT_RESET_FILTER':
			newState = _extends({}, state, {
				filterOptions: []
			});
			break;

		case 'CHAT_SET_FILTER_OPTION':
			var found = false;

			for (var _i in state.filterOptions) {
				if (state.filterOptions[_i].key == action.payload.key) {
					found = true;
				}
			}

			if (!found) {
				newState = _extends({}, state, {
					filterOptions: [].concat(_toConsumableArray(state.filterOptions), [action.payload])
				});
			}
			break;

		case 'CHAT_REMOVE_FILTER_OPTION':
			newState = _extends({}, state, {
				filterOptions: state.filterOptions.filter(function (item, i) {
					return i !== action.payload;
				})
			});
			break;

	}

	return newState;
};

exports.default = chat;

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var General = function General() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		scripts: [],
		users: [],
		settings: {},
		account: {},
		apps: [],
		plans: [],
		platform: {},
		showProcessing: false,
		sidebarOpen: false,
		companySearchOpen: false,
		dealerSearchOpen: false,
		fullScreen: false,
		showChatReconnection: false,
		needUpdate: false,
		notifications: null,
		shownMessages: [],
		windowHasFocus: null
	};
	var action = arguments[1];


	var newState = state;

	switch (action.type) {
		case 'GENERAL_ADD_MESSAGE':
			newState = _extends({}, state, {
				shownMessages: [].concat(_toConsumableArray(state.shownMessages), [action.payload])
			});
			break;

		case 'GENERAL_ADD_SCRIPT':
			newState = _extends({}, state, {
				scripts: [].concat(_toConsumableArray(state.scripts), [action.payload])
			});
			break;
		case 'GENERAL_SET_SETTING':
			newState = _extends({}, state, {
				settings: _extends({}, state.settings, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;
		case 'GENERAL_SET_GLOBAL_KEY':
			newState = _extends({}, state, _defineProperty({}, action.payload.key, action.payload.value));
			break;
		case 'GENERAL_ADD_USERS':
			newState = _extends({}, state, {
				users: action.payload
			});
			break;

		case 'GENERAL_ADD_ACCOUNT':
			newState = _extends({}, state, {
				account: action.payload
			});
			break;

		case 'GENERAL_ADD_SETTINGS':
			newState = _extends({}, state, {
				settings: action.payload
			});
			break;

	}

	return newState;
};

exports.default = General;

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var app = function app() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		app: {}

	};
	var action = arguments[1];


	var newState = state;

	switch (action.type) {
		case 'APP_SET_APP':
			newState = _extends({}, state, {
				app: action.payload
			});
			break;

	}

	return newState;
};

exports.default = app;

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var popup = function popup() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		popup: {},
		stage: 2,
		component: false,
		rules: {}

	};
	var action = arguments[1];


	var newState = state;
	var merge = false;

	switch (action.type) {
		case 'POPUP_REMOVE_RULE':
			merge = Object.keys(newState.rules).filter(function (key) {
				return key != action.payload;
			}).reduce(function (result, current) {
				result[current] = newState.rules[current];
				return result;
			}, {});
			newState = _extends({}, newState, { rules: merge });
			break;
		case 'POPUP_SET_RULE':
			newState = _extends({}, state, {
				rules: _extends({}, state.rules, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;

		case 'POPUP_SET_GLOBAL_KEY':
			newState = _extends({}, state, _defineProperty({}, action.payload.key, action.payload.value));
			break;

		case 'POPUP_SET_POPUP_KEY':
			newState = _extends({}, state, {
				popup: _extends({}, state.popup, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;

		case 'POPUP_SET_SETTING_DATA':
			newState = _extends({}, state, {
				popup: _extends({}, state.popup, {
					settings: _extends({}, state.popup.settings, _defineProperty({}, action.payload.key, action.payload.value))
				})
			});
			break;

		case 'POPUP_SET_CONTENT_DATA':
			newState = _extends({}, state, {
				popup: _extends({}, state.popup, {
					content: _extends({}, state.popup.content, _defineProperty({}, action.payload.key, action.payload.value))
				})
			});
			break;

		case 'POPUP_SET_STYLE_DATA':
			newState = _extends({}, state, {
				popup: _extends({}, state.popup, {
					style: _extends({}, state.popup.style, _defineProperty({}, action.payload.selector, _extends({}, state.popup.style[action.payload.selector], _defineProperty({}, action.payload.key, action.payload.value))))
				})
			});
			break;

		case 'POPUP_SET_STYLE':
			newState = _extends({}, state, {
				popup: _extends({}, state.popup, {
					style: _extends({}, state.popup.style, _defineProperty({}, action.payload.key, action.payload.value))
				})
			});
			break;

		case 'POPUP_SET_COMPONENT_STYLE':
			newState = _extends({}, state, {
				component: _extends({}, state.popup, _defineProperty({}, action.payload.key, action.payload.value))
			});
			break;

	}

	return newState;
};

exports.default = popup;

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var segmentReducer = function segmentReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        list: []

    };
    var action = arguments[1];


    var newState = state;
    var segments = false;

    switch (action.type) {
        case 'SEGMENT_SET':
            newState = _extends({}, state, {
                list: action.payload
            });
            break;

        case 'SEGMENT_UPDATE':
            segments = [].concat(_toConsumableArray(state.list));
            segments[action.payload.index] = action.payload.segment;

            newState = _extends({}, state, {
                list: segments
            });

            break;

    }
    //SEGMENT_UPDATE

    return newState;
};

exports.default = segmentReducer;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontPicker = function (_React$Component) {
    _inherits(FontPicker, _React$Component);

    function FontPicker(props) {
        _classCallCheck(this, FontPicker);

        var _this = _possibleConstructorReturn(this, (FontPicker.__proto__ || Object.getPrototypeOf(FontPicker)).call(this, props));

        _this.fonts = [{ value: 'inherit', clearableValue: false, label: _this.renderLabel('inherit', 'Inherit') }, { value: 'helvetica neue,helvetica,arial,verdana,sans-serif', clearableValue: false, label: _this.renderLabel('helvetica neue,helvetica,arial,verdana,sans-serif', 'Helvetica') }, { value: 'arial,helvetica neue,helvetica,sans-serif', clearableValue: false, label: _this.renderLabel('arial,helvetica neue,helvetica,sans-serif', 'Arial') }, { value: 'lucida sans unicode,lucida grande,sans-serif', clearableValue: false, label: _this.renderLabel('lucida sans unicode,lucida grande,sans-serif', 'Lucida') }, { value: 'tahoma,verdana,segoe,sans-serif', clearableValue: false, label: _this.renderLabel('tahoma,verdana,segoe,sans-serif', 'Tahoma') }, { value: 'verdana,geneva,sans-serif', clearableValue: false, label: _this.renderLabel('helvetica neue,helvetica,arial,verdana,sans-serif', 'Verdana') }, { value: "'Open Sans', sans-serif", clearableValue: false, label: _this.renderLabel("'Open Sans', sans-serif", "Open Sans") }, { value: "'Source Sans Pro', sans-serif", clearableValue: false, label: _this.renderLabel("'Source Sans Pro', sans-serif", "Source Sans Pro") }, { value: "'Roboto', sans-serif", clearableValue: false, label: _this.renderLabel("'Roboto', sans-serif", "Roboto") }, { value: "'Lato', sans-serif", clearableValue: false, label: _this.renderLabel("'Lato', sans-serif", "Lato") }, { value: "'Exo', sans-serif", clearableValue: false, label: _this.renderLabel("'Exo', sans-serif", "Exo") }];

        _this.sizes = [{ value: 'inherit', clearableValue: false, label: 'Inherit' }];

        for (var i = 10; i <= 72; i++) {
            _this.sizes.push({ value: i + 'px', clearableValue: false, label: i + 'px' });
        }

        _this.onChangeFont = _this.onChangeFont.bind(_this);
        _this.onChangeSize = _this.onChangeSize.bind(_this);
        _this.onChangeColor = _this.onChangeColor.bind(_this);

        return _this;
    }

    _createClass(FontPicker, [{
        key: 'renderLabel',
        value: function renderLabel(value, label) {
            return _react2.default.createElement(
                'span',
                { style: { fontFamily: value } },
                label
            );
        }
    }, {
        key: 'onChangeFont',
        value: function onChangeFont(v) {
            this.props.handleChange(this.props.fontId, v.value);
        }
    }, {
        key: 'onChangeSize',
        value: function onChangeSize(v) {
            this.props.handleChange(this.props.sizeId, v.value);
        }
    }, {
        key: 'onChangeColor',
        value: function onChangeColor(id, v) {
            this.props.handleChange(id, v);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4 p-0' },
                    _react2.default.createElement(_reactSelect2.default, {
                        allowCreate: false,
                        searchable: false,
                        clearable: false,
                        name: 'form-field-name',
                        value: this.props.font,
                        options: this.fonts,
                        onChange: this.onChangeFont
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    _react2.default.createElement(_reactSelect2.default, {
                        allowCreate: false,
                        searchable: false,
                        clearable: false,
                        name: 'form-field-name',
                        value: this.props.size,
                        options: this.sizes,
                        onChange: this.onChangeSize
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    _react2.default.createElement(_ColorPicker2.default, { id: this.props.colorId, color: this.props.color, handleColorChange: this.onChangeColor })
                )
            );
        }
    }]);

    return FontPicker;
}(_react2.default.Component);

exports.default = FontPicker;

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(1051);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactSAlert = __webpack_require__(519);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _SocketManager = __webpack_require__(334);

var _SocketManager2 = _interopRequireDefault(_SocketManager);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _General = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.crall_audio = {};
window.crall_audio.message_pling = new Audio('/pling.mp3');

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _SocketManager2.default.start();

            window.onfocus = function () {
                _this2.props.setGlobalKey('windowHasFocus', true);
            };
            window.onblur = function () {
                _this2.props.setGlobalKey('windowHasFocus', false);
            };

            this.props.setGlobalKey('windowHasFocus', document.hasFocus());
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            _SocketManager2.default.start();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'root', style: { height: '100%' } },
                _react2.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } }),
                this.props.children
            );
        }
    }]);

    return App;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setGlobalKey: _General.setGlobalKey }, dispatch);
};

App = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports.default = App;

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helpers = __webpack_require__(128);

var _helpers2 = _interopRequireDefault(_helpers);

var _cookiesJs = __webpack_require__(1079);

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var wsClient = function () {
    function wsClient() {
        _classCallCheck(this, wsClient);

        this.buffer = [];
        this.connection = false;
    }

    _createClass(wsClient, [{
        key: 'configure',
        value: function configure(params) {
            var _this = this;

            this.sid = false;
            this.reconnectCount = 1;
            this.connectionErrorNext = 0;
            this.user = params.user || false;
            this.info = params.info || false;
            this.account = params.account || false;

            this.messageHandler = params.messageHandler;
            this.connect();

            this.connectionMonitor = setInterval(function () {
                if (!_this.isConnected()) {

                    if (typeof _this.messageHandler.onDisconnect == 'function') {
                        _this.messageHandler.onDisconnect();
                    }

                    _this.reconnectCount++;

                    if (_this.reconnectCount >= _this.connectionErrorNext) {
                        _this.connectionErrorNext = _this.reconnectCount * (_this.reconnectCount - 1);
                        _this.removeEvents();
                        _this.connect();
                    }
                } else {
                    _this.reconnectCount = 1;
                    _this.connectionErrorNext = 0;
                    _this.messageHandler.onConnected();
                }
            }, 4000);
        }
    }, {
        key: 'isConnected',
        value: function isConnected() {
            if (!this.connection) {
                return false;
            }
            if (this.connection.readyState == '1') {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: 'connect',
        value: function connect() {
            this.sid = _helpers2.default.randomStr();
            var url = _helpers2.default.url().ws + "/socket?sid=" + this.sid;
            if (this.user != false) {
                url += '&a';
            }

            this.connection = new WebSocket(url);
            this.bindEvents();
        }
    }, {
        key: 'connected',
        value: function connected(sid) {
            this.sid = sid;
        }
    }, {
        key: 'beacon',
        value: function beacon() {
            var data = {};

            if (this.user) {
                data.user = this.user;
            }

            if (this.info) {
                data.info = this.info;
            }

            if (this.account) {
                data.account = this.account;
            }

            data.uid = _cookiesJs2.default.get('crall_uid');

            this.sendMessage('beacon', data);

            if (typeof this.messageHandler.onReady == 'function') {
                this.messageHandler.onReady();
            }
        }
    }, {
        key: 'removeEvents',
        value: function removeEvents() {
            var _this2 = this;

            this.connection.onopen = function () {};

            this.connection.onerror = function () {};
            this.connection.onclose = function () {};

            this.connection.onmessage = function () {};

            window.onbeforeunload = function () {
                _this2.connection.onclose = function () {};
            };
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this3 = this;

            this.connection.onopen = function (event) {
                _this3.beacon();
            };

            this.connection.onerror = function (event) {};
            this.connection.onclose = function () {
                _this3.connection.close();
            };

            this.connection.onmessage = function (event) {
                _this3.parseIncomingMessage(event.data);
            };

            window.onbeforeunload = function () {
                _this3.connection.onclose = function () {};
                clearInterval(_this3.connectionMonitor);
                _this3.connection.close();
            };
        }
    }, {
        key: 'send',
        value: function send(action) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.isConnected()) {
                var out = { 'action': action };
                if (data) {
                    out.data = data;
                }

                this.connection.send(JSON.stringify(out));
            } else {
                this.buffer.push({ 'action': action, data: data });
            }
        }
    }, {
        key: 'disconnect',
        value: function disconnect() {
            if (typeof this.messageHandler.onDisconnect == 'function') {
                this.messageHandler.onDisconnect();
            }
            clearInterval(this.connectionMonitor);
            this.connected = false;
            this.connection.close();
        }
    }, {
        key: 'broadcastMessage',
        value: function broadcastMessage(action, data) {
            this.parent.emit(action, data);
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(action) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var payload = {};
            payload.action = action;
            payload.payload = data;
            payload.sender = this.sid;
            this.connection.send(JSON.stringify(payload));
        }
    }, {
        key: 'parseIncomingMessage',
        value: function parseIncomingMessage(data) {
            this.connected = true;

            if (data == '1') {
                return true;
            }
            data = JSON.parse(data);

            // this.broadcastMessage(data.action,data);

            if (typeof this[data.action] == 'function') {
                this[data.action](data);
                return true;
            }

            if (typeof this.messageHandler[data.action] == 'function') {
                this.messageHandler[data.action](data);
                return true;
            }
        }
    }, {
        key: 'connected',
        value: function connected(data) {}
    }, {
        key: 'init',
        value: function init(data) {
            var _this4 = this;

            _cookiesJs2.default.set('crall_uid', data.payload.uid);
            this.buffer.map(function (item) {
                _this4.send(item.action, item.data);
            });

            if (typeof this.messageHandler['setOnlineStatus'] == 'function' && typeof data.payload.online !== 'undefined') {
                this.messageHandler['setOnlineStatus'](data.payload.online);
            }

            if (typeof this.messageHandler['setSettings'] == 'function' && typeof data.payload.settings !== 'undefined') {
                this.messageHandler['setSettings'](data.payload.settings);
            }

            this.buffer = [];
        }
    }]);

    return wsClient;
}();

exports.default = wsClient;

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Builder = function (_React$Component) {
	_inherits(Builder, _React$Component);

	function Builder() {
		_classCallCheck(this, Builder);

		return _possibleConstructorReturn(this, (Builder.__proto__ || Object.getPrototypeOf(Builder)).apply(this, arguments));
	}

	_createClass(Builder, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ id: 'builder', className: 'height-100' },
				this.props.children
			);
		}
	}]);

	return Builder;
}(_react2.default.Component);

exports.default = Builder;

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _jsonStableStringify = __webpack_require__(550);

var _jsonStableStringify2 = _interopRequireDefault(_jsonStableStringify);

var _reactDnd = __webpack_require__(163);

var _reactDndHtml5Backend = __webpack_require__(1181);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _Builder = __webpack_require__(34);

var _Spin2Win = __webpack_require__(252);

var _Spin2Win2 = _interopRequireDefault(_Spin2Win);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _Nav = __webpack_require__(369);

var _Nav2 = _interopRequireDefault(_Nav);

var _DroppableElement = __webpack_require__(256);

var _DroppableElement2 = _interopRequireDefault(_DroppableElement);

var _DraggableElement = __webpack_require__(1239);

var _DraggableElement2 = _interopRequireDefault(_DraggableElement);

var _Row = __webpack_require__(1240);

var _Row2 = _interopRequireDefault(_Row);

var _SidebarTabButton = __webpack_require__(634);

var _SidebarTabButton2 = _interopRequireDefault(_SidebarTabButton);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

var _SidebarRowElement = __webpack_require__(1450);

var _SidebarRowElement2 = _interopRequireDefault(_SidebarRowElement);

var _SidebarPageElement = __webpack_require__(1451);

var _SidebarPageElement2 = _interopRequireDefault(_SidebarPageElement);

var _Preview = __webpack_require__(1452);

var _Preview2 = _interopRequireDefault(_Preview);

var _text = __webpack_require__(588);

var _text2 = _interopRequireDefault(_text);

var _upload = __webpack_require__(589);

var _upload2 = _interopRequireDefault(_upload);

var _row = __webpack_require__(328);

var _row2 = _interopRequireDefault(_row);

var _spacing = __webpack_require__(590);

var _spacing2 = _interopRequireDefault(_spacing);

var _page = __webpack_require__(1453);

var _page2 = _interopRequireDefault(_page);

var _cart = __webpack_require__(591);

var _cart2 = _interopRequireDefault(_cart);

var _element = __webpack_require__(1454);

var _element2 = _interopRequireDefault(_element);

var _functions = __webpack_require__(371);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _RuleSelector = __webpack_require__(1455);

var _RuleSelector2 = _interopRequireDefault(_RuleSelector);

var _RuleSendAfter = __webpack_require__(1470);

var _RuleSendAfter2 = _interopRequireDefault(_RuleSendAfter);

var _RuleListenForEvent = __webpack_require__(1471);

var _RuleListenForEvent2 = _interopRequireDefault(_RuleListenForEvent);

var _RuleOrderSum = __webpack_require__(1472);

var _RuleOrderSum2 = _interopRequireDefault(_RuleOrderSum);

var _RuleCartSum = __webpack_require__(1473);

var _RuleCartSum2 = _interopRequireDefault(_RuleCartSum);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _RuleFollowUpEvent = __webpack_require__(1474);

var _RuleFollowUpEvent2 = _interopRequireDefault(_RuleFollowUpEvent);

var _RuleSendToSegmentEvent = __webpack_require__(1475);

var _RuleSendToSegmentEvent2 = _interopRequireDefault(_RuleSendToSegmentEvent);

var _RuleSendOnTrigger = __webpack_require__(1546);

var _RuleSendOnTrigger2 = _interopRequireDefault(_RuleSendOnTrigger);

var _RulePicker = __webpack_require__(667);

var _RulePicker2 = _interopRequireDefault(_RulePicker);

var _DiscountPicker = __webpack_require__(384);

var _DiscountPicker2 = _interopRequireDefault(_DiscountPicker);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _StopOn = __webpack_require__(1547);

var _StopOn2 = _interopRequireDefault(_StopOn);

var _EmailListPicker = __webpack_require__(1548);

var _EmailListPicker2 = _interopRequireDefault(_EmailListPicker);

var _DateTimePicker = __webpack_require__(1549);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var components = {
    RuleSendToSegmentEvent: _RuleSendToSegmentEvent2.default,
    RuleSendAfter: _RuleSendAfter2.default,
    RuleListenForEvent: _RuleListenForEvent2.default,
    RuleOrderSum: _RuleOrderSum2.default,
    RuleFollowUpEvent: _RuleFollowUpEvent2.default,
    RuleSendOnTrigger: _RuleSendOnTrigger2.default,
    RuleCartSum: _RuleCartSum2.default
};

function byIndex(a, b) {
    if (a.sorting < b.sorting) return -1;
    if (a.sorting > b.sorting) return 1;
    return 0;
}

var Email = function (_React$Component) {
    _inherits(Email, _React$Component);

    function Email(props) {
        _classCallCheck(this, Email);

        var _this = _possibleConstructorReturn(this, (Email.__proto__ || Object.getPrototypeOf(Email)).call(this, props));

        _this.buildableTags = function () {
            var tags = _extends({}, _this.props.builder.tags);

            if (Object.keys(tags).length == 0) {
                return [];
            }

            if (tags.SendType === "immediately") {
                tags.SendAt = 0;
            } else {
                tags.SendAt = (0, _moment2.default)(tags.SendAt).add(-(0, _moment2.default)().utcOffset(), "m").format("YYYY-MM-DD HH:mm:ss");
            }

            return tags;
        };

        _this.postSave = function () {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (_this.props.builder.page.subject == "") {
                _Notification2.default.error("E-mail subject can't be empty");
                return;
            }

            _Notification2.default.info("Saving...");

            if (typeof _this.props.params.email_id !== "undefined") {
                _this.update(options);
                return;
            }

            var saveObject = _this.buildSaveableObject();

            if (options.completed == 1) {
                saveObject.completed = 1;
            }

            _axios2.default.post("/emails", saveObject).then(function (response) {
                _Notification2.default.success("E-mail saved");
            }).catch(function (error) {
                console.dir(error);
                _Notification2.default.error(error.message);
            });
        };

        _this.handleSchedulerChange = function (e) {
            _this.props.setTag("SendType", e.target.value);
        };

        _this.handleScheduleDateChange = function (date) {
            _this.props.setTag("SendAt", date);
        };

        _this.getRedirectLink = function () {
            if (!_this.props.params.type) {
                return _this.backLink();
            }

            if (_this.props.params.type == "emails") {
                return _General2.default.Link2("/emails/templates");
            }

            var split = _this.props.params.type.split("-");

            if (split.length != 2) {
                return _this.backLink();
            }

            if (split[0] == "f") {
                return _General2.default.Link2("/flows/builder/" + split[1]);
            }

            return _this.backLink();
        };

        _this.backLink = function () {
            var link = _General2.default.Link("/emails");

            if (_this.isUsingFlows()) {
                link = _General2.default.Link2("/emails/campaigns");
            }

            if (_this.props.builder.page.type == "NEWSLETTER") {
                link = _General2.default.Link("/newsletters");
            }

            return link;
        };

        _this.handleListLoadingChange = function (value) {
            _this.setState({
                isLoadingNewsletterLists: value
            });
        };

        _this.seveNewsletter = function () {
            _this.save();
        };

        _this.sendNewsletter = function () {
            var hasList = false;
            Object.keys(_this.props.builder.rules).map(function (i) {
                if (_this.props.builder.rules[i].key == "SendToList" && _this.props.builder.rules[i].value != "") {
                    hasList = true;
                }
            });

            if (!hasList) {
                _Notification2.default.error("You must select a recipient list");
                return;
            }

            _this.postSave({
                completed: 1,
                redirect: true
            });
        };

        _this.renderRows = _this.renderRows.bind(_this);
        _this.setSelectedTab = _this.setSelectedTab.bind(_this);
        _this.moveRow = _this.moveRow.bind(_this);
        _this.setSelectedRow = _this.setSelectedRow.bind(_this);
        _this.removeElement = _this.removeElement.bind(_this);
        _this.addRowPlaceholder = _this.addRowPlaceholder.bind(_this);
        _this.addRow = _this.addRow.bind(_this);
        _this.renderSidebarElement = _this.renderSidebarElement.bind(_this);
        _this.renderSidebarRow = _this.renderSidebarRow.bind(_this);
        _this.renderTab = _this.renderTab.bind(_this);
        _this.renderBuilder = _this.renderBuilder.bind(_this);
        _this.renderLoading = _this.renderLoading.bind(_this);
        _this.save = _this.save.bind(_this);
        _this.buildSaveableObject = _this.buildSaveableObject.bind(_this);
        _this.get = _this.get.bind(_this);
        _this.rebuildSave = _this.rebuildSave.bind(_this);
        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
        _this.handleSubjectChange = _this.handleSubjectChange.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.displayPreview = _this.displayPreview.bind(_this);
        _this.overview = _this.overview.bind(_this);
        _this.renderStopOn = _this.renderStopOn.bind(_this);
        _this.state = {
            isLoading: true,
            previewOpen: false,
            isAddingRule: true,
            showOverview: false,
            isAddingDiscount: false,
            isLoadingNewsletterLists: true
        };

        _this.addRule = _this.addRule.bind(_this);

        contextTypes: {
            router: _react2.default.PropTypes.object.isRequired;
        }
        return _this;
    }

    _createClass(Email, [{
        key: "renderStopOn",
        value: function renderStopOn(rule) {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                {
                    className: "rules m-t-40 text-center col-sm-12",
                    key: "stop-follow-up"
                },
                _react2.default.createElement(
                    "div",
                    { className: "m-b-20 strike" },
                    _react2.default.createElement(
                        "span",
                        null,
                        "Stop followup"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-10 text-center offset-sm-1 p-0" },
                    _react2.default.createElement(
                        "p",
                        null,
                        "Don't send this e-mail and stop followup chain on this events"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12 bg-grey-100 text-left list-group bg-inherit" },
                        _react2.default.createElement(_StopOn2.default, {
                            save: function save(value) {
                                return _this2.props.setGlobalKeyState("stop_on", value);
                            },
                            data: this.props.builder.stop_on
                        })
                    )
                )
            );
        }
    }, {
        key: "addRule",
        value: function addRule(rule) {
            this.props.setGlobalTypeState("rules", rule.id, rule);
            this.setState({ isAddingRule: false });
        }
    }, {
        key: "handleSubjectChange",
        value: function handleSubjectChange(e) {
            this.props.setGlobalTypeState("page", false, {
                subject: e.target.value
            });
        }
    }, {
        key: "handleStatusChange",
        value: function handleStatusChange(value) {
            var val = value == true ? 1 : 0;
            this.props.setGlobalKeyState("status", val);
        }
    }, {
        key: "overview",
        value: function overview(e) {
            e.stopPropagation();
            this.setState({ showOverview: true });
        }
    }, {
        key: "isUsingFlows",
        value: function isUsingFlows() {
            return this.props.general.settings.FLOW == "1" ? true : false;
        }
    }, {
        key: "displayPreview",
        value: function displayPreview() {
            this.setState({ previewOpen: !this.state.previewOpen });
        }
    }, {
        key: "addRow",
        value: function addRow(row) {
            this.props.addRow(row);
        }
    }, {
        key: "handleRuleKeyChange",
        value: function handleRuleKeyChange(index, key, value) {
            this.props.changeRule(index, key, value);
        }
    }, {
        key: "buildSaveableObject",
        value: function buildSaveableObject() {
            return {
                stop_on: this.props.builder.stop_on,
                rules: this.props.builder.rules,
                status: this.props.builder.status,
                subject: this.props.builder.page.subject,
                tags: this.buildableTags(),
                data: (0, _jsonStableStringify2.default)(this.props.builder)
            };
        }
    }, {
        key: "rebuildSave",
        value: function rebuildSave(save) {
            var _this3 = this;

            var data = JSON.parse(save.data);

            var page = new _page2.default(data.page);

            page.item.type = save.type;
            page.item.subject = save.subject;

            this.props.setGlobalTypeState("sidebar", false, {
                selectedTab: "components",
                visible: false,
                selectedElement: false,
                selectedRow: false,
                selectedSetting: false
            });

            var stop_on = save.stop_on;
            if (stop_on == "" || !stop_on) {
                stop_on = "";
            }

            this.props.setGlobalTypeState("page", false, page.output());
            this.props.setGlobalKeyState("stop_on", stop_on);
            this.props.setGlobalKeyState("status", save.status);
            this.props.setGlobalKeyState("isAbTesting", save.isAbTesting);
            this.props.setGlobalKeyState("rows", {});
            this.props.setGlobalKeyState("elements", {});
            this.props.setGlobalKeyState("components", {});
            this.props.setGlobalKeyState("rules", {});
            this.props.setGlobalKeyState("tags", {});

            if (save.tags) {
                Object.keys(save.tags).map(function (key) {
                    if (key == "SendAt") {
                        if (save.tags[key] == "0") {
                            save.tags[key] = (0, _moment2.default)((0, _moment2.default)().add(7, "days"));
                        } else {
                            save.tags[key] = _moment2.default.utc(save.tags[key], "YYYY-MM-DD HH:mm:ss").local();
                        }
                    }
                });

                this.props.setGlobalKeyState("tags", save.tags);
            }

            Object.keys(data.rows).map(function (key) {
                var row = new _row2.default(data.rows[key]);
                _this3.props.setGlobalTypeState("rows", row.item.id, row.output());
            });

            var components = {};

            Object.keys(data.elements).map(function (key) {
                var element = new _element2.default(data.elements[key]);
                components[element.item.id] = element.item.type;
                _this3.props.setGlobalTypeState("elements", element.item.id, element.output());
            });

            Object.keys(data.components).map(function (key) {
                var component = (0, _functions.getItemObject)(components[key], data.components[key]);
                _this3.props.setGlobalTypeState("components", component.item.id, component.output());
            });

            if (save.rules.length > 0) {
                save.rules.map(function (rule) {
                    _this3.props.setGlobalTypeState("rules", rule.id, rule);
                });
            }

            this.setState({ isLoading: false });
        }
    }, {
        key: "get",
        value: function get(id) {
            var _this4 = this;

            _axios2.default.get("/emails/" + id).then(function (response) {
                _this4.rebuildSave(response.data);
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: "update",
        value: function update() {
            var _this5 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.setState({ showOverview: false });

            var saveObject = this.buildSaveableObject();

            if (options.completed == 1) {
                saveObject.completed = 1;
            }

            _axios2.default.put("/emails/" + this.props.params.email_id, saveObject).then(function (response) {
                _Notification2.default.success("E-mail saved");
                if (options.redirect) {
                    if (_this5.isUsingFlows()) {
                        window.location = _this5.getRedirectLink();
                    } else {
                        _this5.props.router.push(_this5.backLink());
                    }
                }
            }).catch(function (error) {
                console.dir(error);
                _Notification2.default.error(error.message);
            });
        }
    }, {
        key: "save",
        value: function save(e) {
            var redirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (e) {
                e.stopPropagation();
            }

            this.postSave({
                redirect: redirect
            });
        }
    }, {
        key: "renderRow",
        value: function renderRow(row) {
            var columns = [];
            var maxCols = parseInt(row.columns) - 1;

            for (var i = 0; i <= maxCols; i++) {
                var elements = [];

                for (var i2 in this.props.c.elements) {
                    var el = this.props.c.elements[i2];
                    if (row.index == el.rowId && el.colId == i) {
                        elements.push(el);
                    }
                }

                elements.sort(byIndex);

                columns.push(_react2.default.createElement(DropTd, {
                    row: row,
                    move: this.move,
                    colId: i,
                    elements: elements,
                    addElement: this.props.addElement
                }));
            }

            return _react2.default.createElement(
                "table",
                { className: "" },
                _react2.default.createElement(
                    "tr",
                    null,
                    columns
                )
            );
        }
    }, {
        key: "moveRow",
        value: function moveRow(newPosition, newSorting) {
            this.props.moveRow(newPosition, newSorting);
        }
    }, {
        key: "addRowPlaceholder",
        value: function addRowPlaceholder(newPosition, newSorting) {
            newPosition.id = (0, _v2.default)();
            newPosition.type = "placeholder";
            this.props.addRowPlaceholder(newPosition, newSorting);
            return newPosition;
        }
    }, {
        key: "setSelectedRow",
        value: function setSelectedRow(id) {
            if (id != this.props.builder.sidebar.selectedRow) {
                this.props.setSelectedRow(id);
            }
        }
    }, {
        key: "removeElement",
        value: function removeElement(el) {
            if (el.type == "row") {
                this.props.deleteRow(el.id);
            } else {
                this.props.removeElement(el);
            }
        }
    }, {
        key: "renderRows",
        value: function renderRows() {
            var _this6 = this;

            var ret = [];
            var sortableRow = [];
            var sortedElements = {};
            var rows = [];

            var _loop = function _loop(i) {
                var r = _this6.props.builder.rows[i];
                var elements = [];
                if (r.elements.length > 0) {
                    r.elements.map(function (el) {
                        elements.push(_this6.props.builder.elements[el]);
                    });
                    elements.sort(byIndex);
                }
                sortedElements[r.id] = elements;
                sortableRow.push(r);
            };

            for (var i in this.props.builder.rows) {
                _loop(i);
            }

            sortableRow.map(function (r) {
                rows.push(r);
            });

            sortableRow.sort(byIndex);
            sortableRow.map(function (r) {
                if (r.type == "placeholder") {
                    ret.push(_react2.default.createElement(_Row2.default, {
                        isSelected: _this6.props.builder.sidebar.selectedRow == r.id ? true : false,
                        key: r.id,
                        setSelectedRow: _this6.setSelectedRow,
                        addRowPlaceholder: _this6.addRowPlaceholder,
                        addRow: _this6.addRow,
                        deleteRow: _this6.deleteRow,
                        moveRow: _this6.moveRow,
                        rows: rows,
                        row: r,
                        elements: sortedElements[r.id]
                    }));
                } else {
                    ret.push(_react2.default.createElement(_Row2.default, {
                        isSelected: _this6.props.builder.sidebar.selectedRow == r.id ? true : false,
                        key: r.id,
                        deleteRow: _this6.deleteRow,
                        setSelectedRow: _this6.setSelectedRow,
                        addRowPlaceholder: _this6.addRowPlaceholder,
                        moveRow: _this6.moveRow,
                        addRow: _this6.addRow,
                        rows: rows,
                        row: r,
                        elements: sortedElements[r.id]
                    }));
                }
            });
            return ret;
        }
    }, {
        key: "setSelectedTab",
        value: function setSelectedTab(tab) {
            this.props.setSelectedTab(tab);
        }
    }, {
        key: "renderLayout",
        value: function renderLayout() {
            return _react2.default.createElement(
                "div",
                { className: "p-l-15 component-wrapper m-t-20" },
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "One column",
                    type: "row",
                    settings: { columns: 1 },
                    dragType: _ItemTypes2.default.NEW_ROW,
                    image: "/images/svg/1col.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Two columns",
                    type: "row",
                    settings: { columns: 2 },
                    dragType: _ItemTypes2.default.NEW_ROW,
                    image: "/images/svg/2col.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Three columns",
                    type: "row",
                    settings: { columns: 3 },
                    dragType: _ItemTypes2.default.NEW_ROW,
                    image: "/images/svg/3col.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Header",
                    type: "header",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/header.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Footer",
                    type: "footer",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/footer.svg"
                })
            );
        }
    }, {
        key: "renderComponents",
        value: function renderComponents() {
            return _react2.default.createElement(
                "div",
                { className: "p-l-15 component-wrapper m-t-20" },
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Text",
                    type: "text",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/text.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Image",
                    type: "upload",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/image.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Button",
                    type: "button",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/button.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Spacing",
                    type: "spacing",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/spacing.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Divider",
                    type: "divider",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/divider.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Social follow",
                    type: "socialfollow",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/social.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Discount",
                    type: "discount",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/discount.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "List",
                    type: "list",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/list.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Custom Html",
                    type: "customhtml",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/coding.svg"
                }),
                _react2.default.createElement(_DraggableElement2.default, {
                    key: "recommendation",
                    removeElement: this.removeElement,
                    text: "Recommendation",
                    type: "crallrecommendationdynamo",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/recommendation.svg"
                }),
                this.props.builder.page.type == "ORDER_CONFIRMATION" ? _react2.default.createElement(_DraggableElement2.default, {
                    key: "orderdetails",
                    removeElement: this.removeElement,
                    text: "Order details",
                    type: "ordersummary",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/orderdetails.svg"
                }) : null,
                this.props.builder.page.type == "ORDER_CONFIRMATION" ? _react2.default.createElement(_DraggableElement2.default, {
                    key: "recheckout",
                    removeElement: this.removeElement,
                    text: "Recheckout",
                    type: "recheckout",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/refresh.svg"
                }) : null,
                this.props.builder.page.type == "CART_REMINDER" ? _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Abandoned cart",
                    type: "cart",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/cart2.svg"
                }) : null,
                this.props.builder.page.type == "SEGMENT" || this.props.builder.page.type == "NEWSLETTER" || this.props.builder.page.type == "TRIGGER" ? _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Product selection",
                    type: "productselection",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/cart2.svg"
                }) : null,
                this.props.builder.page.type == "BASIC" || this.props.builder.page.type == "TRIGGER" ? _react2.default.createElement(_DraggableElement2.default, {
                    removeElement: this.removeElement,
                    text: "Shipping tracker",
                    type: "shippingtracker",
                    settings: {},
                    dragType: _ItemTypes2.default.NEW_ELEMENT,
                    image: "/images/svg/package.svg"
                }) : null
            );
        }
    }, {
        key: "renderDraggable",
        value: function renderDraggable() {
            return _react2.default.createElement(
                "div",
                { className: "slide-in" },
                _react2.default.createElement(
                    "div",
                    {
                        className: "btn-group col-sm-12  m-t-20",
                        "aria-label": "Default button group",
                        role: "group"
                    },
                    _react2.default.createElement(_SidebarTabButton2.default, {
                        setSelectedTab: this.setSelectedTab,
                        selectedTab: this.props.builder.sidebar.selectedTab,
                        tab: "components",
                        text: "Components"
                    }),
                    _react2.default.createElement(_SidebarTabButton2.default, {
                        setSelectedTab: this.setSelectedTab,
                        selectedTab: this.props.builder.sidebar.selectedTab,
                        tab: "layout",
                        text: "Rows"
                    }),
                    _react2.default.createElement(_SidebarTabButton2.default, {
                        setSelectedTab: this.setSelectedTab,
                        selectedTab: this.props.builder.sidebar.selectedTab,
                        tab: "settings",
                        text: "Settings"
                    })
                ),
                _react2.default.createElement("div", { className: "clearfix" }),
                this.renderTab(),
                _react2.default.createElement("div", { className: "clearfix" })
            );
        }
    }, {
        key: "renderRule",
        value: function renderRule(rule) {
            var Comp = components["Rule" + rule.key];
            return _react2.default.createElement(Comp, {
                setGlobalTypeState: this.props.setGlobalTypeState,
                rule: rule,
                key: rule.id
            });
        }
    }, {
        key: "renderTab",
        value: function renderTab() {
            switch (this.props.builder.sidebar.selectedTab) {
                case "components":
                    return this.renderComponents();
                    break;

                case "settings":
                    return this.renderSidebarPage();
                    break;

                default:
                    return this.renderLayout();
                    break;
            }
        }
    }, {
        key: "renderSidebarElement",
        value: function renderSidebarElement() {
            return (0, _functions.getItemComponent)(this.props.builder.elements[this.props.builder.sidebar.selectedElement], 1, true);
        }
    }, {
        key: "renderSidebarRow",
        value: function renderSidebarRow() {
            return _react2.default.createElement(_SidebarRowElement2.default, {
                setGlobalTypeState: this.props.setGlobalTypeState,
                setSidebarState: this.props.setSidebarState,
                row: this.props.builder.rows[this.props.builder.sidebar.selectedRow]
            });
        }
    }, {
        key: "renderSidebarPage",
        value: function renderSidebarPage() {
            return _react2.default.createElement(_SidebarPageElement2.default, {
                isUsingFlow: this.isUsingFlows(),
                components: components,
                subject: this.props.builder.page.subject,
                rules: this.props.builder.rules,
                selectedSetting: this.props.builder.sidebar.selectedSetting,
                setGlobalTypeState: this.props.setGlobalTypeState,
                page: this.props.builder.page,
                setSidebarState: this.props.setSidebarState
            });
        }
    }, {
        key: "renderSidebar",
        value: function renderSidebar() {
            if (this.state.isLoading) {
                return false;
            }
            switch (this.props.builder.sidebar.visible) {
                case "element":
                    return this.renderSidebarElement();
                    break;

                case "row":
                    return this.renderSidebarRow();
                    break;

                default:
                    return this.renderDraggable();
                    break;
            }
        }
    }, {
        key: "renderBuilder",
        value: function renderBuilder() {
            if (this.state.isLoading) {
                return;
            }

            if (Object.keys(this.props.builder.page).length == 0) {
                return;
            }

            var page_style = {};
            page_style.fontFamily = this.props.builder.page.font;
            page_style.fontSize = this.props.builder.page.fontSize;
            page_style.color = this.props.builder.page.color;
            page_style.backgroundColor = this.props.builder.page.backgroundColor;
            page_style.borderTop = this.props.builder.page.borderTop.replace(/\|/g, " ");
            page_style.borderBottom = this.props.builder.page.borderBottom.replace(/\|/g, " ");

            return _react2.default.createElement(
                "table",
                {
                    id: "builder-page",
                    className: "parent-table",
                    style: page_style
                },
                _react2.default.createElement(
                    "tbody",
                    null,
                    _react2.default.createElement(
                        "tr",
                        null,
                        _react2.default.createElement(
                            _DroppableElement2.default,
                            {
                                acceptDropType: _ItemTypes2.default.ROW,
                                classes: "valign-top",
                                type: "td"
                            },
                            this.renderRows()
                        )
                    )
                )
            );
        }
    }, {
        key: "renderLoading",
        value: function renderLoading() {
            if (!this.state.isLoading) {
                return;
            }

            return _react2.default.createElement(
                "div",
                { className: "loading" },
                _react2.default.createElement(_Spin2Win2.default, null)
            );
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            if (typeof this.props.params.email_id !== "undefined") {
                this.get(this.props.params.email_id);
            } else {
                var page = new _page2.default(false);
                this.props.setGlobalTypeState("page", false, page.output());

                this.setState({ isLoading: false });
            }
        }
    }, {
        key: "render",


        //this.renderSidebar()
        value: function render() {
            var _this7 = this;

            return _react2.default.createElement(
                "div",
                { className: "height-100" },
                _react2.default.createElement(
                    _Nav2.default,
                    {
                        backLink: this.getRedirectLink(),
                        backText: "Back to emails"
                    },
                    _react2.default.createElement(
                        "li",
                        { className: "nav-item hidden-float" },
                        _react2.default.createElement(
                            "a",
                            {
                                className: "nav-link",
                                href: "javascript:void(0)",
                                onClick: function onClick(e) {
                                    e.stopPropagation();
                                    _this7.displayPreview();
                                }
                            },
                            "Preview / Test"
                        )
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "nav-item hidden-float" },
                        _react2.default.createElement(
                            "a",
                            {
                                className: "nav-link",
                                href: "javascript:void(0)",
                                onClick: function onClick(e) {
                                    return _this7.save(e, false);
                                }
                            },
                            "Quick save"
                        )
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "nav-item hidden-float save-and-continue" },
                        _react2.default.createElement(
                            "a",
                            {
                                className: "nav-link ",
                                href: "javascript:void(0)",
                                onClick: function onClick(e) {
                                    return _this7.overview(e);
                                }
                            },
                            "Save and continue",
                            " ",
                            _react2.default.createElement("i", {
                                className: "fa fa-chevron-right",
                                style: { fontSize: "12px" },
                                "aria-hidden": "true"
                            })
                        )
                    )
                ),
                this.renderLoading(),
                _react2.default.createElement(
                    "div",
                    { className: "height-100" },
                    _react2.default.createElement(
                        "div",
                        { className: "sidebar height-100 col-sm-4 p-0" },
                        this.renderSidebar()
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "main-content col-sm-8 p-0 height-100" },
                        this.renderBuilder()
                    )
                ),
                !this.state.isLoading && this.props.builder.page.type == "NEWSLETTER" ? _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        closeOnEsc: true,
                        onClose: function onClose(e) {
                            _this7.setState({ showOverview: false });
                        },
                        isOpened: this.state.showOverview
                    },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(
                            "div",
                            { className: "overview m-t-30 col-sm-6 offset-sm-3 text-center" },
                            _react2.default.createElement(
                                "h1",
                                null,
                                "Almost ready to launch!"
                            ),
                            _react2.default.createElement(
                                "h2",
                                null,
                                "Please take your time and look over the settings for this e-mail."
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "E-mail subject"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1" },
                                    _react2.default.createElement("input", {
                                        type: "text",
                                        onChange: this.handleSubjectChange,
                                        className: "form-control form-control-lg",
                                        value: this.props.builder.page.subject,
                                        placeholder: "My awesome e-mail"
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "rules m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "Send to"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1 text-left p-0" },
                                    _react2.default.createElement(_EmailListPicker2.default, {
                                        handleChangeList: function handleChangeList(e) {
                                            _this7.props.setTag("SendToList", e);
                                        },
                                        handleLoadingChange: this.handleListLoadingChange,
                                        listId: parseInt(this.props.builder.tags.SendToList)
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "rules m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "When do you want to send your newsletter?"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1 text-left p-0" },
                                    _react2.default.createElement(
                                        "div",
                                        { className: "form-group row" },
                                        _react2.default.createElement(
                                            "label",
                                            { className: "col-md-3 col-form-label" },
                                            _react2.default.createElement(
                                                "div",
                                                { className: "radio-custom radio-primary" },
                                                _react2.default.createElement("input", {
                                                    type: "radio",
                                                    value: "immediately",
                                                    onChange: this.handleSchedulerChange,
                                                    checked: this.props.builder.tags.SendType === "immediately"
                                                }),
                                                _react2.default.createElement(
                                                    "label",
                                                    null,
                                                    "Immediately"
                                                )
                                            )
                                        ),
                                        _react2.default.createElement("div", { className: "col-md-9" })
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        { className: "form-group row" },
                                        _react2.default.createElement(
                                            "label",
                                            { className: "col-md-3 col-form-label" },
                                            _react2.default.createElement(
                                                "div",
                                                { className: "radio-custom radio-primary" },
                                                _react2.default.createElement("input", {
                                                    type: "radio",
                                                    value: "send_at",
                                                    onChange: this.handleSchedulerChange,
                                                    checked: this.props.builder.tags.SendType !== "immediately"
                                                }),
                                                _react2.default.createElement(
                                                    "label",
                                                    null,
                                                    "Sent at"
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            "div",
                                            { className: "col-md-9" },
                                            _react2.default.createElement(_DateTimePicker2.default, {
                                                isChecked: this.props.builder.tags.SendType !== "immediately",
                                                handleDateChange: this.handleScheduleDateChange,
                                                date: this.props.builder.tags.SendAt
                                            })
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "col-sm-10 offset-sm-1 m-t-50 m-b-50" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-12" },
                                    _react2.default.createElement(
                                        "button",
                                        {
                                            type: "button",
                                            onClick: this.sendNewsletter,
                                            className: "btn p-l-40 p-r-40 btn-dark btn-lg",
                                            disabled: this.state.isLoadingNewsletterLists
                                        },
                                        _react2.default.createElement("i", {
                                            className: "icon fa-send",
                                            "aria-hidden": "true"
                                        }),
                                        this.props.builder.tags.SendType === "send_at" ? "Schedule e-mail" : "Send now"
                                    ),
                                    _react2.default.createElement("br", null),
                                    _react2.default.createElement("br", null),
                                    _react2.default.createElement(
                                        "button",
                                        {
                                            type: "button",
                                            onClick: this.seveNewsletter,
                                            className: "btn btn-outline btn-dark",
                                            disabled: this.state.isLoadingNewsletterLists
                                        },
                                        _react2.default.createElement("i", {
                                            className: "icon fa-save",
                                            "aria-hidden": "true"
                                        }),
                                        " ",
                                        "I'll finish this later"
                                    )
                                )
                            )
                        )
                    )
                ) : null,
                !this.state.isLoading && this.props.builder.page.type != "NEWSLETTER" ? _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        closeOnEsc: true,
                        onClose: function onClose(e) {
                            _this7.setState({ showOverview: false });
                        },
                        isOpened: this.state.showOverview
                    },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(
                            "div",
                            { className: "overview m-t-30 col-sm-6 offset-sm-3 text-center" },
                            _react2.default.createElement(
                                "h1",
                                null,
                                "Almost done!"
                            ),
                            _react2.default.createElement(
                                "h2",
                                null,
                                "Please take your time and look over the settings for this e-mail."
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    this.props.builder.page.type != "TEMPLATE" ? _react2.default.createElement(
                                        "span",
                                        null,
                                        "E-mail subject ( Will be visible for the customer )"
                                    ) : _react2.default.createElement(
                                        "span",
                                        null,
                                        "Template name"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1" },
                                    _react2.default.createElement("input", {
                                        type: "text",
                                        onChange: this.handleSubjectChange,
                                        className: "form-control form-control-lg",
                                        value: this.props.builder.page.subject,
                                        placeholder: "My awesome e-mail"
                                    })
                                )
                            ),
                            Object.keys(this.props.builder.rules).filter(function (i) {
                                return _this7.props.builder.rules[i].action == "Who" && _this7.props.builder.page.type != "TEMPLATE" && !_this7.isUsingFlows() ? true : false;
                            }).length > 0 ? _react2.default.createElement(
                                "div",
                                { className: "rules m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "Who"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit" },
                                    Object.keys(this.props.builder.rules).map(function (i) {
                                        return _this7.props.builder.rules[i].action == "Who" ? _this7.renderRule(_this7.props.builder.rules[i]) : null;
                                    })
                                )
                            ) : null,
                            Object.keys(this.props.builder.rules).filter(function (i) {
                                return _this7.props.builder.rules[i].action == "When" && _this7.props.builder.page.type != "TEMPLATE" && !_this7.isUsingFlows() ? true : false;
                            }).length > 0 ? _react2.default.createElement(
                                "div",
                                { className: "rules m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "When"
                                    )
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit" },
                                    Object.keys(this.props.builder.rules).map(function (i) {
                                        return _this7.props.builder.rules[i].action == "When" ? _this7.renderRule(_this7.props.builder.rules[i]) : null;
                                    })
                                )
                            ) : null,
                            Object.keys(this.props.builder.rules).map(function (i) {
                                return _this7.props.builder.rules[i].key == "FollowUpEvent" ? _this7.renderStopOn(_this7.props.builder.rules[i]) : null;
                            }),
                            this.props.builder.page.type != "TEMPLATE" && !this.isUsingFlows() ? _react2.default.createElement(
                                "div",
                                { className: "m-t-40 col-sm-12" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "m-b-20 strike" },
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        "E-mail status"
                                    )
                                ),
                                this.props.general.settings.PACKAGE_EMAIL == "1" ? _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1" },
                                    this.props.builder.isAbTesting ? _react2.default.createElement(
                                        "div",
                                        {
                                            className: "alert alert-icon alert-warning alert-dismissible",
                                            role: "alert"
                                        },
                                        _react2.default.createElement("i", {
                                            className: "icon wb-bell",
                                            "aria-hidden": "true"
                                        }),
                                        " ",
                                        "This e-mail is part of an A/B test. You must disable the A/B before you can enable/disable this e-mail."
                                    ) : _react2.default.createElement(
                                        "div",
                                        null,
                                        _react2.default.createElement(
                                            "div",
                                            { className: "col-sm-4 text-right" },
                                            "Activate e-mail"
                                        ),
                                        _react2.default.createElement(
                                            "div",
                                            { className: "col-sm-6 text-right" },
                                            _react2.default.createElement(_rcSwitch2.default, {
                                                onChange: this.handleStatusChange,
                                                checked: this.props.builder.status == 1 ? true : false,
                                                checkedChildren: _react2.default.createElement("i", { className: "icon fa-check" }),
                                                unCheckedChildren: _react2.default.createElement("i", { className: "icon fa-close" })
                                            })
                                        )
                                    )
                                ) : _react2.default.createElement(
                                    "div",
                                    { className: "col-sm-10 offset-sm-1" },
                                    _react2.default.createElement(_UpgradeRequired2.default, { message: "If you want to enable e-mails, you need to upgrade your account to a larger package" })
                                )
                            ) : null,
                            _react2.default.createElement(
                                "div",
                                { className: "col-sm-10 offset-sm-1" },
                                _react2.default.createElement(
                                    "button",
                                    {
                                        type: "button",
                                        onClick: this.save,
                                        className: "btn p-l-40 p-r-40 btn-dark btn-lg m-t-50 m-b-50"
                                    },
                                    "Save"
                                )
                            )
                        )
                    )
                ) : null,
                this.state.previewOpen ? _react2.default.createElement(_Preview2.default, {
                    id: this.props.router.params.email_id,
                    auth: this.props.auth,
                    displayPreview: this.displayPreview
                }) : null
            );
        }
    }]);

    return Email;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        builder: state.builder,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setTag: _Builder.setTag,
        changeRule: _Builder.changeRule,
        setGlobalKeyState: _Builder.setGlobalKeyState,
        deleteRow: _Builder.deleteRow,
        setGlobalTypeState: _Builder.setGlobalTypeState,
        setSidebarState: _Builder.setSidebarState,
        addRow: _Builder.addRow,
        addRowPlaceholder: _Builder.addRowPlaceholder,
        removeElement: _Builder.removeElement,
        setSelectedTab: _Builder.setSelectedTab,
        setSelectedRow: _Builder.setSelectedRow,
        moveRow: _Builder.moveRow
    }, dispatch);
};

Email = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(Email);
Email = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Email);
exports.default = Email;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSAlert = __webpack_require__(519);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function generateBox(icon, message) {
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement('i', { style: { fontWeight: 'bold' }, className: icon }),
		_react2.default.createElement(
			'span',
			{ style: { paddingLeft: '20px' } },
			message
		)
	);
}

var Notification = function () {
	function Notification() {
		_classCallCheck(this, Notification);
	}

	_createClass(Notification, null, [{
		key: 'clear',
		value: function clear() {
			_reactSAlert2.default.closeAll();
		}
	}, {
		key: 'success',
		value: function success(message) {
			_reactSAlert2.default.closeAll();
			return _reactSAlert2.default.success(generateBox('icon wb-check', message), {
				position: 'top-right',
				effect: 'slide',
				timeout: 5000
			});
		}
	}, {
		key: 'error',
		value: function error(message) {
			_reactSAlert2.default.closeAll();
			_reactSAlert2.default.error(generateBox('icon wb-alert', message), {
				position: 'top-right',
				effect: 'slide',
				timeout: 5000
			});
		}
	}, {
		key: 'warning',
		value: function warning(message) {
			_reactSAlert2.default.closeAll();
			_reactSAlert2.default.warning(generateBox('icon wb-alert', message), {
				position: 'top-right',
				effect: 'slide',
				timeout: 5000
			});
		}
	}, {
		key: 'info',
		value: function info(message) {
			_reactSAlert2.default.closeAll();
			_reactSAlert2.default.info(generateBox('icon wb-bell', message), {
				position: 'top-right',
				effect: 'slide',
				timeout: 5000
			});
		}
	}]);

	return Notification;
}();

exports.default = Notification;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AskUpgrade = function (_React$Component) {
    _inherits(AskUpgrade, _React$Component);

    function AskUpgrade(props) {
        _classCallCheck(this, AskUpgrade);

        return _possibleConstructorReturn(this, (AskUpgrade.__proto__ || Object.getPrototypeOf(AskUpgrade)).call(this, props));
    }

    _createClass(AskUpgrade, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.inline) {
                return _react2.default.createElement(
                    'div',
                    { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        this.props.title
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        this.props.body
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'm-t-30' },
                        _react2.default.createElement(
                            'button',
                            { onClick: function onClick(e) {
                                    e.stopPropagation();_this2.props.onAccept(_this2.props.param);
                                }, className: 'btn btn-lg btn-dark' },
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement('i', { className: 'icon wb-check' }),
                                this.props.accept ? this.props.accept : "I want to upgrade"
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                        _react2.default.createElement(
                            'h1',
                            null,
                            this.props.title
                        ),
                        _react2.default.createElement(
                            'h2',
                            null,
                            this.props.body
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'm-t-30' },
                            _react2.default.createElement(
                                'button',
                                { onClick: this.props.onClose, className: 'btn btn-lg btn-danger' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { style: { color: '#fff' }, className: 'icon wb-close' }),
                                    this.props.cancel ? this.props.cancel : 'No thanks'
                                )
                            ),
                            '\xA0\xA0\xA0',
                            _react2.default.createElement(
                                'button',
                                { onClick: function onClick(e) {
                                        e.stopPropagation();_this2.props.onAccept(_this2.props.param);
                                    }, className: 'btn btn-lg btn-dark' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon wb-check' }),
                                    this.props.accept ? this.props.accept : "I want to upgrade"
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AskUpgrade;
}(_react2.default.Component);

exports.default = AskUpgrade;

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(163);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cardSource = {
	beginDrag: function beginDrag(props) {
		return {
			id: false,
			text: props.text,
			type: props.type,
			new: true,
			settings: props.settings,
			dragType: props.dragType
		};
	},
	endDrag: function endDrag(props, monitor) {
		var _monitor$getItem = monitor.getItem(),
		    droppedId = _monitor$getItem.id,
		    originalIndex = _monitor$getItem.originalIndex;

		var didDrop = monitor.didDrop();

		if (!didDrop) {
			props.removeElement(monitor.getItem());
		}
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	};
}

var propTypes = {
	text: _react.PropTypes.string.isRequired,

	// Injected by React DnD:
	isDragging: _react.PropTypes.bool.isRequired,
	connectDragSource: _react.PropTypes.func.isRequired
};

var DraggableElement = function (_React$Component) {
	_inherits(DraggableElement, _React$Component);

	function DraggableElement() {
		_classCallCheck(this, DraggableElement);

		return _possibleConstructorReturn(this, (DraggableElement.__proto__ || Object.getPrototypeOf(DraggableElement)).apply(this, arguments));
	}

	_createClass(DraggableElement, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    isDragging = _props.isDragging,
			    connectDragSource = _props.connectDragSource,
			    text = _props.text,
			    icon = _props.icon,
			    image = _props.image;

			return connectDragSource(_react2.default.createElement(
				'div',
				{ className: 'col-sm-3 draggable-component text-center', style: { opacity: isDragging ? 0.5 : 1 } },
				_react2.default.createElement('img', { style: { width: '70px' }, src: image }),
				_react2.default.createElement(
					'div',
					{ style: { paddingTop: '6px' } },
					text
				)
			));
		}
	}]);

	return DraggableElement;
}(_react2.default.Component);

DraggableElement.propTypes = propTypes;

// Export the wrapped component:
exports.default = (0, _reactDnd.DragSource)(function (props) {
	return props.dragType;
}, cardSource, collect)(DraggableElement);

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactDnd = __webpack_require__(163);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

var _Toolbar = __webpack_require__(370);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _DroppableElement = __webpack_require__(256);

var _DroppableElement2 = _interopRequireDefault(_DroppableElement);

var _ElementWrapper = __webpack_require__(1241);

var _ElementWrapper2 = _interopRequireDefault(_ElementWrapper);

var _DropContentElement = __webpack_require__(1449);

var _DropContentElement2 = _interopRequireDefault(_DropContentElement);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _FileUpload = __webpack_require__(329);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _Text = __webpack_require__(628);

var _Text2 = _interopRequireDefault(_Text);

var _Spacing = __webpack_require__(619);

var _Spacing2 = _interopRequireDefault(_Spacing);

var _functions = __webpack_require__(371);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function calculateSorting(newPosition, direction, newSorting) {
	var highest = Object.keys(newSorting).length;

	if (highest == 0) {
		return { 'new': 1, 'list': newSorting };
	}

	// Element is moved inside same column. Just change newSorting
	if (typeof newSorting[newPosition.id] !== 'undefined') {
		var old = { 'id': false, 'sorting': false };

		for (var id in newSorting) {
			if (newSorting[id] == newPosition.sorting) {
				old.id = id;
			}
			if (id == newPosition.id) {
				old.sorting = newSorting[id];
			}
		}

		newSorting[newPosition.id] = newPosition.sorting;
		newSorting[old.id] = old.sorting;

		return { 'new': newPosition.sorting, 'list': newSorting };
	}

	if (highest == newPosition.sorting) {
		if (direction == 'UP') {
			return { 'new': highest - 1, 'list': newSorting };
		} else {
			return { 'new': highest + 1, 'list': newSorting };
		}
	}

	for (var i in newSorting) {
		if (newSorting[i] >= newPosition.sorting) {
			newSorting[i] = newSorting[i] + 1;
		}
	}
	// TODO når man flytter plass på to eksisterende virker det ikke på det øverste. dvs flytte 2 -> 1. Tror det kommer av at newsorting begynner på 2, mens newindex = 1


	return { 'new': newPosition.sorting, 'list': newSorting };
}

var cardSource = {
	beginDrag: function beginDrag(props) {
		return {
			type: props.type,
			sorting: props.row.sorting,
			id: props.row.id,
			settings: props.settings
		};
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	};
}
function collectDrop(connect, monitor) {
	return {
		// Call this function inside render()
		// to let React DnD handle the drag events:
		connectDropTarget: connect.dropTarget(),
		// You can ask the monitor about the current drag state:
		isOver: monitor.isOver(),
		isOverCurrent: monitor.isOver({ shallow: true }),
		canDrop: monitor.canDrop(),
		itemType: monitor.getItemType()
	};
}

var propTypes = {

	// Injected by React DnD:
	isDragging: _react.PropTypes.bool.isRequired,
	connectDragSource: _react.PropTypes.func.isRequired,
	connectDragPreview: _react.PropTypes.func.isRequired,
	moveRow: _react.PropTypes.func.isRequired
};

var chessSquareTarget = {
	canDrop: function canDrop(props, monitor) {
		var item = monitor.getItemType();
		return true;
	},
	hover: function hover(props, monitor, component) {
		var dragIndex = monitor.getItem().sorting;
		var hoverIndex = props.row.sorting;

		// Don't replace items with themselves
		if (dragIndex === hoverIndex) {
			return;
		}

		// Determine rectangle on screen
		var hoverBoundingRect = _reactDom2.default.findDOMNode(component).getBoundingClientRect();

		// Get vertical middle
		var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

		// Determine mouse position
		var clientOffset = monitor.getClientOffset();

		// Get pixels to the top
		var hoverClientY = clientOffset.y - hoverBoundingRect.top;

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return;
		}

		// Dragging upwards
		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return;
		}

		var oldPosition = {
			id: monitor.getItem().id,
			sorting: monitor.getItem().index,
			index: monitor.getItem().index
		};

		var newPosition = {
			sorting: hoverIndex == 0 ? 1 : hoverIndex,
			index: hoverIndex == 0 ? 1 : hoverIndex,
			id: monitor.getItem().id
		};

		var newSorting = [];
		var c = 1;

		for (var i in props.rows) {
			var el = props.rows[i];
			if (el.col == newPosition.col) {
				newSorting[el.id] = props.rows[i].sorting;
				c++;
			}
		}
		var direction = 'DOWN';
		if (hoverClientY < hoverMiddleY) {
			direction = 'UP';
		}

		var calculatedSorting = calculateSorting(newPosition, direction, newSorting);
		newPosition.sorting = calculatedSorting.new;

		if (newPosition.id == false) {
			newPosition.columns = monitor.getItem().settings.columns;
			var placeholder = props.addRowPlaceholder(newPosition, calculatedSorting);
			monitor.getItem().id = placeholder.id;
		} else {
			props.moveRow(newPosition, calculatedSorting);
		}

		monitor.getItem().sorting = newPosition.sorting;
	},
	drop: function drop(props, monitor, component) {
		console.log('drop');
		if (monitor.didDrop()) {
			return;
		}
		var item = monitor.getItem();

		if (item.new === true) {
			props.addRow(item);
		}
	}
};

var Row = function (_React$Component) {
	_inherits(Row, _React$Component);

	function Row(props) {
		_classCallCheck(this, Row);

		var _this = _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).call(this, props));

		_this.renderColumns = _this.renderColumns.bind(_this);
		_this.renderElements = _this.renderElements.bind(_this);
		_this.moveElement = _this.moveElement.bind(_this);
		_this.addElement = _this.addElement.bind(_this);
		_this.addPlaceholder = _this.addPlaceholder.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
		_this.deleteElement = _this.deleteElement.bind(_this);
		_this.deleteRow = _this.deleteRow.bind(_this);
		return _this;
	}

	_createClass(Row, [{
		key: 'addPlaceholder',
		value: function addPlaceholder(newPosition, newSorting) {
			newPosition.id = (0, _v2.default)();
			newPosition.type = 'placeholder';

			this.props.addPlaceholder(newPosition, newSorting);
			return newPosition;
		}
	}, {
		key: 'addElement',
		value: function addElement(element) {
			var el = (0, _functions.getItemObject)(element.type, false);

			el.item.id = element.id;

			this.props.convertToElement(element, el);
		}
	}, {
		key: 'renderElements',
		value: function renderElements(col_num) {
			var _this2 = this;

			var elements = [];

			if (this.props.elements.length > 0) {
				this.props.elements.map(function (el) {
					if (el.col == col_num) {
						elements.push(_react2.default.createElement(_ElementWrapper2.default, { deleteElement: _this2.deleteElement, row_cols: _this2.props.row.columns, isHoveringElement: _this2.props.builder.ui.isHoveringElement, setUiState: _this2.props.setUiState, setSidebarState: _this2.props.setSidebarState, elements: _this2.props.elements, addPlaceholder: _this2.addPlaceholder, addElement: _this2.addElement, moveElement: _this2.moveElement, key: 'row-' + _this2.props.row.id + '-column-' + col_num + '-element-' + el.id, element: el }));
					}
				});
			}

			if (elements.length == 0) {
				//elements.push(<DropContentElement col={col_num} rowId={this.props.row.id} moveElement={this.moveElement} key={`row-${this.props.rowId}-empty-column-${col_num}`}>Drop content here</DropContentElement>);

				elements.push(_react2.default.createElement(_ElementWrapper2.default, { deleteElement: this.deleteElement, addPlaceholder: this.addPlaceholder, addElement: this.addElement, moveElement: this.moveElement, key: 'row-' + this.props.row.id + '-column-' + col_num + '-empty-column', element: { type: 'empty-column', rowId: this.props.row.id, 'col': col_num } }));
			}

			return elements;
		}
	}, {
		key: 'renderColumns',
		value: function renderColumns() {
			var cols = [];

			for (var i = 1; i <= this.props.row.columns; i++) {
				var styles = {};

				styles.width = 100 / this.props.row.columns + '%';
				styles.padding = this.props.row.innerPadding;

				cols.push(_react2.default.createElement(
					_DroppableElement2.default,
					{ acceptDropType: _ItemTypes2.default.ELEMENT, styles: styles, key: 'row-' + this.props.rowId + '-col-' + i, classes: 'valign-top', type: 'td' },
					this.renderElements(i)
				));
			}

			//cols.push(this.renderPlaceholder());

			return cols;
		}
	}, {
		key: 'moveElement',
		value: function moveElement(newPosition, newSorting) {
			this.props.moveElement(newPosition, newSorting);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter() {
			this.props.setUiState({ 'isHoveringRow': this.props.row.id });
		}
	}, {
		key: 'handleMouseLeave',
		value: function handleMouseLeave() {
			this.props.setUiState({ 'isHoveringRow': false });
		}
	}, {
		key: 'deleteRow',
		value: function deleteRow() {
			for (var e in this.props.row.elements) {
				this.deleteElement(this.props.row.elements[e]);
			}

			if (Object.keys(this.props.builder.rows).length == 1) {
				alert('Ikke lov å slette siste row. Lag ny og slett');
				return;
			}

			this.props.deleteRow(this.props.row.id);
		}
	}, {
		key: 'deleteElement',
		value: function deleteElement(id) {
			this.props.deleteElement(id);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    isDragging = _props.isDragging,
			    connectDragPreview = _props.connectDragPreview,
			    connectDragSource = _props.connectDragSource,
			    connectDropTarget = _props.connectDropTarget;

			var opacity = isDragging ? 0 : 1;

			var rowClasses = 'table-wrapper';
			if (this.props.builder.ui.isHoveringRow == this.props.row.id && this.props.builder.ui.isHoveringElement === false) {
				rowClasses += ' selected';
			}

			if (this.props.row.type == 'placeholder') {
				return connectDropTarget(_react2.default.createElement(
					'div',
					{ className: 'row-placeholder' },
					'Place row here'
				));
			}

			var outer_table_style = {};
			var inner_table_style = {};

			outer_table_style.backgroundColor = this.props.row.outerBackgroundColor;
			outer_table_style.borderTop = this.props.row.outerBorderTop.replace(/\|/g, ' ');
			outer_table_style.borderBottom = this.props.row.outerBorderBottom.replace(/\|/g, ' ');

			inner_table_style.backgroundColor = this.props.row.innerBackgroundColor;
			inner_table_style.borderTop = this.props.row.innerBorderTop.replace(/\|/g, ' ');
			inner_table_style.borderBottom = this.props.row.innerBorderBottom.replace(/\|/g, ' ');

			return connectDropTarget(connectDragPreview(_react2.default.createElement(
				'div',
				{ onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, className: rowClasses, style: { opacity: opacity } },
				_react2.default.createElement(
					'table',
					{ className: 'outer-table', style: outer_table_style },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'e toolbar' },
									_react2.default.createElement(
										'div',
										{ className: 'btn-group btn-group-sm', role: 'group' },
										connectDragSource(_react2.default.createElement(
											'button',
											{ type: 'button', className: 'btn btn-icon btn-default btn-outline' },
											_react2.default.createElement('i', { className: 'icon wb-move', 'aria-hidden': 'true' })
										)),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: function onClick(e) {
													_this3.props.setSidebarState({ 'visible': 'row', 'selectedRow': _this3.props.row.id });e.stopPropagation();
												}, className: 'btn btn-icon btn-default btn-outline' },
											_react2.default.createElement('i', { className: 'icon wb-settings', 'aria-hidden': 'true' })
										),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: function onClick(e) {
													_this3.deleteRow();e.stopPropagation();
												}, className: 'btn btn-icon btn-default btn-outline' },
											_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
										)
									)
								),
								_react2.default.createElement(
									'table',
									{ className: 'e-row', style: inner_table_style },
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											this.renderColumns()
										)
									)
								)
							)
						)
					)
				)
			)));
		}
	}]);

	return Row;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ deleteRow: _Builder.deleteRow, deleteElement: _Builder.deleteElement, setUiState: _Builder.setUiState, setSidebarState: _Builder.setSidebarState, convertToElement: _Builder.convertToElement, addPlaceholder: _Builder.addPlaceholder, moveElement: _Builder.moveElement }, dispatch);
};

Row.propTypes = propTypes;
Row = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Row);
Row = (0, _reactDnd.DropTarget)([_ItemTypes2.default.ROW, _ItemTypes2.default.NEW_ROW], chessSquareTarget, collectDrop)(Row);
// Export the wrapped component:
exports.default = (0, _reactDnd.DragSource)(_ItemTypes2.default.ROW, cardSource, collect)(Row);

/***/ }),

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactDnd = __webpack_require__(163);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

var _Toolbar = __webpack_require__(370);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _DroppableElement = __webpack_require__(256);

var _DroppableElement2 = _interopRequireDefault(_DroppableElement);

var _functions = __webpack_require__(371);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cardSource = {
	beginDrag: function beginDrag(props) {
		return {
			type: props.type,
			sorting: props.element.sorting,
			id: props.element.id,
			rowId: props.element.rowId,
			col: props.element.col
		};
	}
};

function calculateSorting(newPosition, direction, newSorting) {
	var highest = Object.keys(newSorting).length;

	if (highest == 0) {
		return { 'new': 1, 'list': newSorting };
	}

	// Element is moved inside same column. Just change newSorting
	if (typeof newSorting[newPosition.id] !== 'undefined') {
		var old = { 'id': false, 'sorting': false };

		for (var id in newSorting) {
			if (newSorting[id] == newPosition.sorting) {
				old.id = id;
			}
			if (id == newPosition.id) {
				old.sorting = newSorting[id];
			}
		}

		newSorting[newPosition.id] = newPosition.sorting;
		newSorting[old.id] = old.sorting;

		return { 'new': newPosition.sorting, 'list': newSorting };
	}

	if (highest == newPosition.sorting) {
		if (direction == 'UP') {
			return { 'new': highest - 1, 'list': newSorting };
		} else {
			return { 'new': highest + 1, 'list': newSorting };
		}
	}

	for (var i in newSorting) {
		if (newSorting[i] >= newPosition.sorting) {
			newSorting[i] = newSorting[i] + 1;
		}
	}
	// TODO når man flytter plass på to eksisterende virker det ikke på det øverste. dvs flytte 2 -> 1. Tror det kommer av at newsorting begynner på 2, mens newindex = 1


	return { 'new': newPosition.sorting, 'list': newSorting };
}

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	};
}
function collectDrop(connect, monitor) {
	return {
		// Call this function inside render()
		// to let React DnD handle the drag events:
		connectDropTarget: connect.dropTarget(),
		// You can ask the monitor about the current drag state:
		isOver: monitor.isOver(),
		isOverCurrent: monitor.isOver({ shallow: true }),
		canDrop: monitor.canDrop(),
		itemType: monitor.getItemType()
	};
}

var propTypes = {

	// Injected by React DnD:
	isDragging: _react.PropTypes.bool.isRequired,
	connectDragSource: _react.PropTypes.func.isRequired,
	connectDragPreview: _react.PropTypes.func.isRequired,
	moveElement: _react.PropTypes.func.isRequired
};

var chessSquareTarget = {
	canDrop: function canDrop(props, monitor) {
		var item = monitor.getItemType();
		return true;
	},
	hover: function hover(props, monitor, component) {

		var dragItemType = monitor.getItemType();

		var dragIndex = monitor.getItem().sorting;
		var hoverIndex = props.element.sorting;

		// Don't replace items with themselves
		if (monitor.getItem().id === props.element.id) {
			return;
		} else {
			if (hoverIndex == dragIndex && monitor.getItem().col == props.element.col) {
				return;
			}
		}

		// Determine rectangle on screen
		var hoverBoundingRect = _reactDom2.default.findDOMNode(component).getBoundingClientRect();

		// Get vertical middle
		var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

		// Determine mouse position
		var clientOffset = monitor.getClientOffset();

		// Get pixels to the top
		var hoverClientY = clientOffset.y - hoverBoundingRect.top;

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return;
		}

		// Dragging upwards
		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return;
		}

		var oldPosition = {
			id: monitor.getItem().id,
			sorting: monitor.getItem().index,
			rowId: monitor.getItem().rowId,
			col: monitor.getItem().col
		};

		var newPosition = {
			sorting: hoverIndex == 0 ? 1 : hoverIndex,
			id: monitor.getItem().id,
			rowId: props.element.rowId,
			col: props.element.col
		};

		var newSorting = [];
		var c = 1;

		for (var i in props.elements) {
			var el = props.elements[i];
			if (el.col == newPosition.col) {
				newSorting[el.id] = c;
				c++;
			}
		}
		var direction = 'DOWN';
		if (hoverClientY < hoverMiddleY) {
			direction = 'UP';
		}

		var calculatedSorting = calculateSorting(newPosition, direction, newSorting);
		newPosition.sorting = calculatedSorting.new;

		switch (dragItemType) {
			case 'element':
				props.moveElement(newPosition, calculatedSorting);
				break;

			case 'new_element':
				if (component.props.element.type == 'empty-column') {
					/*	drag.sorting = 1;
     	hover.sorting = 1;
     	hover.index = 1;
     	hover.id = false;*/
				}
				if (monitor.getItem().id == false) {
					var placeholder = props.addPlaceholder(newPosition, calculatedSorting);
					monitor.getItem().id = placeholder.id;
				} else {
					props.moveElement(newPosition, calculatedSorting);
				}

				break;
		}

		// Note: we're mutating the monitor item here!
		// Generally it's better to avoid mutations,
		// but it's good here for the sake of performance
		// to avoid expensive index searches.
		monitor.getItem().sorting = newPosition.sorting;
		monitor.getItem().col = newPosition.col;
		monitor.getItem().rowId = newPosition.rowId;
	},
	drop: function drop(props, monitor, component) {
		if (monitor.didDrop()) {
			return;
		}
		var item = monitor.getItem();

		if (item.new === true) {
			props.addElement(item);
		}
	}
};

var ElementWrapper = function (_React$Component) {
	_inherits(ElementWrapper, _React$Component);

	function ElementWrapper(props) {
		_classCallCheck(this, ElementWrapper);

		var _this = _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).call(this, props));

		_this.openSidebar = _this.openSidebar.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
		return _this;
	}

	_createClass(ElementWrapper, [{
		key: 'renderElement',
		value: function renderElement() {
			return (0, _functions.getItemComponent)(this.props.element, this.props.row_cols);
		}
	}, {
		key: 'openSidebar',
		value: function openSidebar(e) {
			e.stopPropagation();
			this.props.setSidebarState({ 'visible': 'element', 'selectedElement': this.props.element.id });
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter() {
			this.props.setUiState({ 'isHoveringElement': this.props.element.id });
		}
	}, {
		key: 'handleMouseLeave',
		value: function handleMouseLeave() {
			this.props.setUiState({ 'isHoveringElement': false });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    isDragging = _props.isDragging,
			    connectDragPreview = _props.connectDragPreview,
			    connectDragSource = _props.connectDragSource,
			    connectDropTarget = _props.connectDropTarget;

			var opacity = isDragging ? 0 : 1;
			var rowClasses = 'table-wrapper element';

			if (this.props.isHoveringElement == this.props.element.id) {
				rowClasses += ' selected';
			}

			if (this.props.element.type == 'empty-column') {
				return connectDropTarget(_react2.default.createElement(
					'div',
					{ className: 'empty-column' },
					_react2.default.createElement(
						'div',
						{ className: 'wrap' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							'Drop content here'
						)
					)
				));
			}

			if (this.props.element.type == 'placeholder') {
				return connectDropTarget(_react2.default.createElement(
					'div',
					{ className: 'empty-column' },
					_react2.default.createElement(
						'div',
						{ className: 'wrap' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							'Place block here'
						)
					)
				));
			}

			return connectDropTarget(connectDragPreview(_react2.default.createElement(
				'div',
				{ onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, className: rowClasses, style: { opacity: opacity } },
				_react2.default.createElement(
					'div',
					{ className: 'toolbar' },
					_react2.default.createElement(
						'div',
						{ className: 'btn-group btn-group-sm', role: 'group' },
						connectDragSource(_react2.default.createElement(
							'button',
							{ type: 'button', className: 'btn btn-icon btn-default btn-outline' },
							_react2.default.createElement('i', { className: 'icon wb-move', 'aria-hidden': 'true' })
						)),
						_react2.default.createElement(
							'button',
							{ type: 'button', onClick: function onClick(e) {
									_this2.openSidebar(e);
								}, className: 'btn btn-icon btn-default btn-outline' },
							_react2.default.createElement('i', { className: 'icon wb-settings', 'aria-hidden': 'true' })
						),
						_react2.default.createElement(
							'button',
							{ type: 'button', onClick: function onClick(e) {
									_this2.props.deleteElement(_this2.props.element.id);e.stopPropagation();
								}, className: 'btn btn-icon btn-default btn-outline' },
							_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
						)
					)
				),
				_react2.default.createElement(
					'table',
					{ className: 'e-element' },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								this.renderElement()
							)
						)
					)
				)
			)));
		}
	}]);

	return ElementWrapper;
}(_react2.default.Component);

ElementWrapper.propTypes = propTypes;
ElementWrapper = (0, _reactDnd.DropTarget)([_ItemTypes2.default.NEW_ELEMENT, _ItemTypes2.default.ELEMENT], chessSquareTarget, collectDrop)(ElementWrapper);
// Export the wrapped component:
exports.default = (0, _reactDnd.DragSource)(_ItemTypes2.default.ELEMENT, cardSource, collect)(ElementWrapper);

/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Button = function () {
	function Button(r) {
		_classCallCheck(this, Button);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Button, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('value')) {
				this.item.value = 'Click me';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('url')) {
				this.item.url = '';
			}

			if (!this.isset('backgroundColor')) {
				this.item.backgroundColor = '#4e97d9';
			}

			if (!this.isset('color')) {
				this.item.color = '#ffffff';
			}

			if (!this.isset('align')) {
				this.item.align = 'center';
			}

			if (!this.isset('border')) {
				this.item.border = '1px|solid|#4e97d9';
			}

			if (!this.isset('padding')) {
				this.item.padding = '10px 10px 10px 10px';
			}
		}
	}]);

	return Button;
}();

exports.default = Button;

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Socialfollow = function () {
	function Socialfollow(r) {
		_classCallCheck(this, Socialfollow);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Socialfollow, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('paddingBottom')) {
				this.item.paddingBottom = '10px';
			}

			if (!this.isset('paddingTop')) {
				this.item.paddingTop = '10px';
			}

			if (!this.isset('align')) {
				this.item.align = 'center';
			}

			if (!this.isset('type')) {
				this.item.type = '2';
			}

			if (!this.isset('facebook')) {
				this.item.facebook = '';
			}

			if (!this.isset('facebook_active')) {
				this.item.facebook_active = true;
			}

			if (!this.isset('googleplus')) {
				this.item.googleplus = '';
			}

			if (!this.isset('googleplus_active')) {
				this.item.googleplus_active = false;
			}

			if (!this.isset('tumblr')) {
				this.item.tumblr = '';
			}

			if (!this.isset('tumblr_active')) {
				this.item.tumblr_active = false;
			}

			if (!this.isset('linkedin')) {
				this.item.linkedin = '';
			}

			if (!this.isset('linkedin_active')) {
				this.item.linkedin_active = false;
			}

			if (!this.isset('twitter')) {
				this.item.twitter = '';
			}

			if (!this.isset('twitter_active')) {
				this.item.twitter_active = true;
			}

			if (!this.isset('instagram')) {
				this.item.instagram = '';
			}

			if (!this.isset('instagram_active')) {
				this.item.instagram_active = true;
			}

			if (!this.isset('web')) {
				this.item.web = '';
			}

			if (!this.isset('web_active')) {
				this.item.web_active = false;
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}
		}
	}]);

	return Socialfollow;
}();

exports.default = Socialfollow;

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cart = function () {
	function Cart(r) {
		_classCallCheck(this, Cart);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Cart, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('paddingBottom')) {
				this.item.paddingBottom = '10px';
			}

			if (!this.isset('paddingTop')) {
				this.item.paddingTop = '10px';
			}

			if (!this.isset('width')) {
				this.item.width = '100%';
			}

			if (!this.isset('border_top')) {
				this.item.border_top = '2px|solid|#000000';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}
		}
	}]);

	return Cart;
}();

exports.default = Cart;

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Header = function () {
	function Header(r) {
		_classCallCheck(this, Header);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Header, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {

			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('paddingTop')) {
				this.item.paddingTop = '20px';
			}

			if (!this.isset('left_text')) {
				this.item.left_text = '';
			}

			if (!this.isset('left_font')) {
				this.item.left_font = 'inherit';
			}

			if (!this.isset('left_color')) {
				this.item.left_color = 'inherit';
			}

			if (!this.isset('left_size')) {
				this.item.left_size = 'inherit';
			}

			if (!this.isset('right_text')) {
				this.item.right_text = 'Having trouble reading this email?';
			}

			if (!this.isset('right_font')) {
				this.item.right_font = 'inherit';
			}

			if (!this.isset('right_color')) {
				this.item.right_color = 'inherit';
			}

			if (!this.isset('right_size')) {
				this.item.right_size = 'inherit';
			}
		}
	}]);

	return Header;
}();

exports.default = Header;

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Footer = function () {
	function Footer(r) {
		_classCallCheck(this, Footer);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Footer, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('text')) {
				this.item.text = ' HEEEEEI HALLO';
			}

			if (!this.isset('unsubscribe_text')) {
				this.item.unsubscribe_text = 'Unsubscribe';
			}
		}
	}]);

	return Footer;
}();

exports.default = Footer;

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSummery = function () {
	function OrderSummery(r) {
		_classCallCheck(this, OrderSummery);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(OrderSummery, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {

			if (!this.isset('translate_total')) {
				this.item.translate_total = 'Total';
			}

			if (!this.isset('text_color')) {
				this.item.text_color = 'inherit';
			}

			if (!this.isset('text_size')) {
				this.item.text_size = 'inherit';
			}

			if (!this.isset('text_font')) {
				this.item.text_font = 'inherit';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('padding')) {
				this.item.padding = '10px 10px 10px 10px';
			}
		}
	}]);

	return OrderSummery;
}();

exports.default = OrderSummery;

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Recommendation = function () {
    function Recommendation(r) {
        _classCallCheck(this, Recommendation);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(Recommendation, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('text_color')) {
                this.item.text_color = 'inherit';
            }

            if (!this.isset('text_size')) {
                this.item.text_size = 'inherit';
            }

            if (!this.isset('text_font')) {
                this.item.text_font = 'inherit';
            }

            if (!this.isset('button_text')) {
                this.item.button_text = 'Buy now';
            }

            if (!this.isset('button_background')) {
                this.item.button_background = '#4e97d9';
            }

            if (!this.isset('rows')) {
                this.item.rows = 1;
            }

            if (!this.isset('padding')) {
                this.item.padding = '10px 10px 10px 10px';
            }

            if (!this.isset('type')) {
                this.item.type = 'Relevant';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return Recommendation;
}();

exports.default = Recommendation;

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Discount = function () {
    function Discount(r) {
        _classCallCheck(this, Discount);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(Discount, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('value')) {
                this.item.value = 'Click me';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }

            if (!this.isset('discount_id')) {
                this.item.discount_id = 0;
            }

            if (!this.isset('backgroundColor')) {
                this.item.backgroundColor = '#4e97d9';
            }

            if (!this.isset('align')) {
                this.item.align = 'center';
            }

            if (!this.isset('border')) {
                this.item.border = '1px|solid|#4e97d9';
            }

            if (!this.isset('padding')) {
                this.item.padding = '10px 10px 10px 10px';
            }
        }
    }]);

    return Discount;
}();

exports.default = Discount;

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var List = function () {
    function List(r) {
        _classCallCheck(this, List);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(List, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('align')) {
                this.item.align = 'left';
            }

            if (!this.isset('font')) {
                this.item.font = 'inherit';
            }

            if (!this.isset('size')) {
                this.item.size = 'inherit';
            }

            if (!this.isset('color')) {
                this.item.color = 'inherit';
            }

            if (!this.isset('line1_text')) {
                this.item.line1_text = 'Item 1';
            }
            if (!this.isset('line1_link')) {
                this.item.line1_link = '';
            }

            if (!this.isset('line2_text')) {
                this.item.line2_text = 'Item 2';
            }
            if (!this.isset('line2_link')) {
                this.item.line2_link = '';
            }

            if (!this.isset('line3_text')) {
                this.item.line3_text = '';
            }
            if (!this.isset('line3_link')) {
                this.item.line3_link = '';
            }

            if (!this.isset('line4_text')) {
                this.item.line4_text = '';
            }
            if (!this.isset('line4_link')) {
                this.item.line4_link = '';
            }

            if (!this.isset('line5_text')) {
                this.item.line5_text = '';
            }
            if (!this.isset('line5_link')) {
                this.item.line5_link = '';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return List;
}();

exports.default = List;

/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductSelection = function () {
    function ProductSelection(r) {
        _classCallCheck(this, ProductSelection);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(ProductSelection, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('text_color')) {
                this.item.text_color = 'inherit';
            }

            if (!this.isset('text_size')) {
                this.item.text_size = 'inherit';
            }

            if (!this.isset('text_font')) {
                this.item.text_font = 'inherit';
            }

            if (!this.isset('button_text')) {
                this.item.button_text = 'Buy now';
            }

            if (!this.isset('button_background')) {
                this.item.button_background = '#4e97d9';
            }

            if (!this.isset('rows')) {
                this.item.rows = 1;
            }

            if (!this.isset('padding')) {
                this.item.padding = '10px 10px 10px 10px';
            }

            if (!this.isset('type')) {
                this.item.type = 'Bestsellers';
            }

            if (!this.isset('categories')) {
                this.item.categories = false;
            }

            if (!this.isset('manufacturers')) {
                this.item.manufacturers = false;
            }

            if (!this.isset('min_price')) {
                this.item.min_price = 0;
            }

            if (!this.isset('min_price')) {
                this.item.sort_by = 'none';
            }

            if (!this.isset('only_on_sale')) {
                this.item.only_on_sale = false;
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return ProductSelection;
}();

exports.default = ProductSelection;

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomHtml = function () {
    function CustomHtml(r) {
        _classCallCheck(this, CustomHtml);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(CustomHtml, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {
            if (!this.isset('value')) {
                this.item.value = 'Insert custom HTML here';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return CustomHtml;
}();

exports.default = CustomHtml;

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CrallRecommendation = function () {
    function CrallRecommendation(r) {
        _classCallCheck(this, CrallRecommendation);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(CrallRecommendation, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {
            if (!this.isset('recommendation_id')) {
                this.item.value = 0;
            }

            if (!this.isset('html')) {
                this.item.html = '';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return CrallRecommendation;
}();

exports.default = CrallRecommendation;

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CrallRecommendationDynamo = function () {
    function CrallRecommendationDynamo(r) {
        _classCallCheck(this, CrallRecommendationDynamo);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(CrallRecommendationDynamo, [{
        key: "isset",
        value: function isset(key) {
            if (typeof this.item[key] === "undefined") {
                return false;
            }

            return true;
        }
    }, {
        key: "output",
        value: function output() {
            var data = this.item;

            if (data.recommendations) {
                delete data.recommendations;
            }

            return data;
        }
    }, {
        key: "defaults",
        value: function defaults() {
            if (!this.isset("text_color")) {
                this.item.text_color = "inherit";
            }

            if (!this.isset("text_size")) {
                this.item.text_size = "inherit";
            }

            if (!this.isset("text_font")) {
                this.item.text_font = "inherit";
            }

            if (!this.isset("button_text")) {
                this.item.button_text = "Buy now";
            }

            if (!this.isset("button_background")) {
                this.item.button_background = "#4e97d9";
            }

            if (!this.isset("rows")) {
                this.item.rows = 1;
            }

            if (!this.isset("padding")) {
                this.item.padding = "10px 10px 10px 10px";
            }

            if (!this.isset("type")) {
                this.item.type = "Relevant";
            }

            if (!this.isset("id")) {
                this.item.id = false;
            }
        }
    }]);

    return CrallRecommendationDynamo;
}();

exports.default = CrallRecommendationDynamo;

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Shippingtracker = function () {
    function Shippingtracker(r) {
        _classCallCheck(this, Shippingtracker);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(Shippingtracker, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('primary_color')) {
                this.item.primary_color = '#cd7eae';
            }

            if (!this.isset('text_package_tracking')) {
                this.item.text_package_tracking = 'Shipment tracking';
            }

            if (!this.isset('text_package_tracking_button')) {
                this.item.text_package_tracking_button = 'Open tracking page';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }
        }
    }]);

    return Shippingtracker;
}();

exports.default = Shippingtracker;

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Recheckout = function () {
    function Recheckout(r) {
        _classCallCheck(this, Recheckout);

        this.item = {};
        if (r != false) {
            this.item = r;
        }

        this.defaults();
    }

    _createClass(Recheckout, [{
        key: 'isset',
        value: function isset(key) {
            if (typeof this.item[key] === 'undefined') {
                return false;
            }

            return true;
        }
    }, {
        key: 'output',
        value: function output() {
            return this.item;
        }
    }, {
        key: 'defaults',
        value: function defaults() {

            if (!this.isset('value')) {
                this.item.value = 'Click here to recheckout';
            }

            if (!this.isset('id')) {
                this.item.id = false;
            }

            if (!this.isset('backgroundColor')) {
                this.item.backgroundColor = '#4e97d9';
            }

            if (!this.isset('align')) {
                this.item.align = 'center';
            }

            if (!this.isset('border')) {
                this.item.border = '1px|solid|#4e97d9';
            }

            if (!this.isset('padding')) {
                this.item.padding = '10px 10px 10px 10px';
            }
        }
    }]);

    return Recheckout;
}();

exports.default = Recheckout;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Helpers = function () {
    function Helpers() {
        _classCallCheck(this, Helpers);
    }

    _createClass(Helpers, null, [{
        key: "redirectToNewAdmin",
        value: function redirectToNewAdmin() {
            var url = "";
            if (Helpers.isProduction()) {
                url = "https://app.crall.io/v2/#/login";
            } else {
                url = "https://app.crall.dev:3000/#/login";
            }

            window.location.href = url;
        }
    }, {
        key: "url",
        value: function url() {
            var ret = {};

            if (Helpers.isProduction()) {
                ret.cdn = 'https://cdn.crall.io';
                ret.ws = 'wss://events.crall.io';
            } else {
                ret.cdn = 'https://cdn.crall.dev';
                ret.ws = 'wss://app.crall.dev:1337';
            }

            return ret;
        }
    }, {
        key: "getDomain",
        value: function getDomain(url) {
            var domain;
            //find & remove protocol (http, ftp, etc.) and get domain
            if (url.indexOf("://") > -1) {
                domain = url.split('/')[2];
            } else {
                domain = url.split('/')[0];
            }

            //find & remove port number
            domain = domain.split(':')[0];

            return domain;
        }
    }, {
        key: "isProduction",
        value: function isProduction() {
            if (location.hostname.split('.').pop() == 'dev' || location.hostname == 'localhost') {
                return false;
            }
            return true;
        }
    }, {
        key: "randomStr",
        value: function randomStr() {
            return Math.round(Math.pow(36, 20 + 1) - Math.random() * Math.pow(36, 20)).toString(36).slice(1);
        }
    }]);

    return Helpers;
}();

exports.default = Helpers;

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cart = function (_React$Component) {
	_inherits(Cart, _React$Component);

	function Cart(props) {
		_classCallCheck(this, Cart);

		var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);

		_this.items = _this.items.bind(_this);
		_this.image = _this.image.bind(_this);
		_this.quantity = _this.quantity.bind(_this);
		_this.details = _this.details.bind(_this);
		_this.handleChange = _this.handleChange.bind(_this);
		_this.onButtonChange = _this.onButtonChange.bind(_this);

		return _this;
	}

	_createClass(Cart, [{
		key: 'onButtonChange',
		value: function onButtonChange(e) {
			this.props.setComponentState(this.el().id, { 'button_text': e.target.value });
		}
	}, {
		key: 'handleChange',
		value: function handleChange(id, s) {
			var changes = {};
			changes[id] = s;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'items',
		value: function items() {
			var _this2 = this;

			var lines = [];
			var products = [{
				'id': 1,
				'name': 'Product line 1',
				'description': 'This is the description for product line 1.',
				'image': 'https://cdn.crall.io/uploads/test.jpg',
				'quantity': 2
			}, {
				'id': 2,
				'name': 'Product line 2',
				'description': 'This is the description for product line 2.',
				'image': 'https://cdn.crall.io/uploads/test.jpg',
				'quantity': 1
			}];

			products.map(function (item) {
				lines.push(_react2.default.createElement(
					'tr',
					{ key: item.id },
					_react2.default.createElement(
						'td',
						{ className: 'table-width-20 table-top', style: { padding: '5px' } },
						_this2.image(item)
					),
					_react2.default.createElement(
						'td',
						{ className: 'table-width-60 table-top', style: { padding: '5px', color: _this2.el().text_color } },
						_this2.details(item)
					),
					_react2.default.createElement(
						'td',
						{ className: 'table-width-20', style: { padding: '5px', color: _this2.el().text_color } },
						_this2.quantity(item)
					)
				));
			});

			return lines;
		}
	}, {
		key: 'image',
		value: function image(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement('img', { src: item.image, style: { maxWidth: '130px' } })
						)
					)
				)
			);
		}
	}, {
		key: 'quantity',
		value: function quantity(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block table-text-center' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
								'x',
								item.quantity
							)
						)
					)
				)
			);
		}
	}, {
		key: 'details',
		value: function details(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block table-text-left' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().link_size, color: this.el().link_color, fontFamily: this.el().link_font } },
								item.name
							)
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
								item.description
							)
						)
					)
				)
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Abandoned cart' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'container', parent: 'cart-settings', title: 'Container' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Font style' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'text_font',
									sizeId: 'text_size',
									colorId: 'text_color',
									font: this.el().text_font,
									size: this.el().text_size,
									color: this.el().text_color,
									handleChange: this.handleChange
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'link', parent: 'cart-product', title: 'Product line' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Link font settings' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'link_font',
									sizeId: 'link_size',
									colorId: 'link_color',
									font: this.el().link_font,
									size: this.el().link_size,
									color: this.el().link_color,
									handleChange: this.handleChange
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'button', parent: 'cart-settings', title: 'Button' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Text' },
								_react2.default.createElement('input', { type: 'text', value: this.el().button_text, onChange: this.onButtonChange, className: 'form-control' })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Font style' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'button_font',
									sizeId: 'button_size',
									colorId: 'button_color',
									font: this.el().button_font,
									size: this.el().button_size,
									color: this.el().button_color,
									handleChange: this.handleChange
								})
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Border' },
								_react2.default.createElement(_BorderPicker2.default, { id: 'button_border', handleBorderChange: this.handleChange, data: this.el().button_border })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Background color' },
								_react2.default.createElement(_ColorPicker2.default, { id: 'button_background', color: this.el().button_background, handleColorChange: this.handleChange })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Horizontal position' },
								_react2.default.createElement(_AlignPicker2.default, { id: 'button_align', align: this.el().button_align, handleChange: this.handleChange })
							)
						)
					)
				);
			} else {
				var button_style = { fontSize: this.el().button_size, color: this.el().button_color, fontFamily: this.el().button_font, border: this.el().button_border.replace(/\|/g, ' '), backgroundColor: this.el().button_background };

				return _react2.default.createElement(
					'table',
					{ className: 'table-block', style: { width: '100%' } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { padding: this.el().padding } },
								_react2.default.createElement(
									'table',
									{ className: 'table-block' },
									_react2.default.createElement(
										'tbody',
										null,
										this.items()
									)
								)
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { padding: this.el().padding } },
								_react2.default.createElement(
									'table',
									{ className: 'table-block', style: { width: '100%' } },
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												{ style: { textAlign: this.el().button_align } },
												_react2.default.createElement(
													'a',
													{ className: 'click-button', style: button_style, href: 'javascript:void(0)' },
													this.el().button_text
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}
	}]);

	return Cart;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Cart = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Cart);

exports.default = Cart;

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _rcSlider = __webpack_require__(200);

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Divider = function (_React$Component) {
	_inherits(Divider, _React$Component);

	function Divider(props) {
		_classCallCheck(this, Divider);

		var _this = _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.handleChange = _this.handleChange.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.onPaddingBottomChange = _this.onPaddingBottomChange.bind(_this);
		_this.onPaddingTopChange = _this.onPaddingTopChange.bind(_this);

		return _this;
	}

	_createClass(Divider, [{
		key: 'handleChange',
		value: function handleChange(id, s) {
			var changes = {};
			changes[id] = s;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { width: v + '%' });
		}
	}, {
		key: 'onPaddingTopChange',
		value: function onPaddingTopChange(v) {
			this.props.setComponentState(this.el().id, { paddingTop: v + 'px' });
		}
	}, {
		key: 'onPaddingBottomChange',
		value: function onPaddingBottomChange(v) {
			this.props.setComponentState(this.el().id, { paddingBottom: v + 'px' });
		}
	}, {
		key: 'render',
		value: function render() {

			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Divider' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'divider-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'divider', parent: 'divider-settings', title: 'Divider' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Divider' },
								_react2.default.createElement(_BorderPicker2.default, { id: 'border_top', handleBorderChange: this.handleChange, data: this.el().border_top })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Width' },
								_react2.default.createElement(_rcSlider2.default, { value: parseInt(this.el().width.replace('%', '')),
									onChange: this.onChange,
									min: 5,
									max: 100
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'spacing', parent: 'divider-settings', title: 'Spacing' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Spacing top' },
								_react2.default.createElement(_rcSlider2.default, {
									value: parseInt(this.el().paddingTop.replace('px', '')),
									onChange: this.onPaddingTopChange,

									min: 5,
									max: 100
								})
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Spacing bottom' },
								_react2.default.createElement(_rcSlider2.default, {
									value: parseInt(this.el().paddingBottom.replace('px', '')),
									onChange: this.onPaddingBottomChange,
									min: 5,
									max: 100
								})
							)
						)
					)
				);
			} else {

				return _react2.default.createElement(
					'table',
					{ className: 'table-block', style: { width: '100%' } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { paddingBottom: this.el().paddingBottom, paddingTop: this.el().paddingTop } },
								_react2.default.createElement(
									'table',
									{ style: { margin: "0 auto", borderTop: this.el().border_top.replace(/\|/g, ' '), width: this.el().width } },
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												null,
												_react2.default.createElement('span', null)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}
	}]);

	return Divider;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Divider = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Divider);

exports.default = Divider;

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _rcSlider = __webpack_require__(200);

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Socialfollow = function (_React$Component) {
	_inherits(Socialfollow, _React$Component);

	function Socialfollow(props) {
		_classCallCheck(this, Socialfollow);

		var _this = _possibleConstructorReturn(this, (Socialfollow.__proto__ || Object.getPrototypeOf(Socialfollow)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.available = ['web', 'facebook', 'instagram', 'googleplus', 'twitter', 'tumblr', 'linkedin'];
		_this.renderIcons = _this.renderIcons.bind(_this);
		_this.onPaddingBottomChange = _this.onPaddingBottomChange.bind(_this);
		_this.onPaddingTopChange = _this.onPaddingTopChange.bind(_this);
		_this.renderLabel = _this.renderLabel.bind(_this);
		_this.renderLinks = _this.renderLinks.bind(_this);
		_this.onPaddingChange = _this.onPaddingChange.bind(_this);
		_this.setActive = _this.setActive.bind(_this);
		_this.handleLinkChange = _this.handleLinkChange.bind(_this);

		_this.options = [{ value: '1', clearableValue: false, label: _this.renderLabel(1) }, { value: '2', clearableValue: false, label: _this.renderLabel(2) }];
		return _this;
	}

	_createClass(Socialfollow, [{
		key: 'setActive',
		value: function setActive(e) {
			this.props.setComponentState(this.el().id, _defineProperty({}, e.target.id, !this.el()[e.target.id]));
		}
	}, {
		key: 'handleLinkChange',
		value: function handleLinkChange(e) {
			this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
		}
	}, {
		key: 'renderLinks',
		value: function renderLinks() {
			var links = [];

			for (var i in this.available) {
				links.push(_react2.default.createElement(
					'div',
					{ className: 'form-group', key: i },
					_react2.default.createElement(
						'div',
						{ className: 'input-group input-group-icon' },
						_react2.default.createElement(
							'span',
							{ className: 'input-group-addon' },
							_react2.default.createElement(
								'div',
								{ style: { display: 'inline-block', marginRight: '10px' }, className: 'checkbox-custom checkbox-primary' },
								_react2.default.createElement('input', { type: 'checkbox', id: this.available[i] + '_active', onChange: this.setActive, checked: this.el()[this.available[i] + '_active'] }),
								_react2.default.createElement('label', { htmlFor: this.available[i] + '_active' })
							),
							_react2.default.createElement('img', { style: { width: '15px' }, src: '/images/marketing/brands/' + this.el().type + '/' + this.available[i] + '.png' })
						),
						_react2.default.createElement('input', { type: 'text', 'data-id': this.available[i], onChange: this.handleLinkChange, value: this.el()[this.available[i]], className: 'form-control', placeholder: 'https://' })
					)
				));
			}

			return links;
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel(id) {
			var icons = [];

			for (var i in this.available) {
				icons.push(_react2.default.createElement('img', { style: { marginRight: '20px', width: '15px' }, key: i, src: '/images/marketing/brands/' + id + '/' + this.available[i] + '.png' }));
			}

			return _react2.default.createElement(
				'div',
				null,
				icons
			);
		}
	}, {
		key: 'renderIcons',
		value: function renderIcons() {
			var icons = [];

			for (var i in this.available) {
				if (this.el()[this.available[i] + '_active'] == true) {
					icons.push(_react2.default.createElement(
						'a',
						{ href: '#', key: i, style: { paddingRight: '10px' } },
						_react2.default.createElement('img', { style: { width: '30px' }, src: '/images/marketing/brands/' + this.el().type + '/' + this.available[i] + '.png' })
					));
				}
			}

			return icons;
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'renderSettings',
		value: function renderSettings() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
				'Dette er en test'
			);
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { type: v.value });
		}
	}, {
		key: 'onPaddingTopChange',
		value: function onPaddingTopChange(v) {
			this.props.setComponentState(this.el().id, { paddingTop: v + 'px' });
		}
	}, {
		key: 'onPaddingBottomChange',
		value: function onPaddingBottomChange(v) {
			this.props.setComponentState(this.el().id, { paddingBottom: v + 'px' });
		}
	}, {
		key: 'onPaddingChange',
		value: function onPaddingChange(id, padding) {
			var changes = {};
			changes[id] = padding;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'render',
		value: function render() {

			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Spacing' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'Socialfollow-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'icontypes', parent: 'Socialfollow-settings', title: 'Icon' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Icon types' },
								_react2.default.createElement(_reactSelect2.default, {
									allowCreate: false,
									searchable: false,
									clearable: false,
									name: 'form-field-name',
									value: this.el().type,
									options: this.options,
									onChange: this.onChange
								})
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Icon links' },
								this.renderLinks()
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'spacing', parent: 'Socialfollow-settings', title: 'Spacing' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Horizontal position' },
								_react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.onPaddingChange })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Spacing top' },
								_react2.default.createElement(_rcSlider2.default, {
									value: parseInt(this.el().paddingTop.replace('px', '')),
									onChange: this.onPaddingTopChange,

									min: 5,
									max: 100
								})
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Spacing bottom' },
								_react2.default.createElement(_rcSlider2.default, {
									value: parseInt(this.el().paddingBottom.replace('px', '')),
									onChange: this.onPaddingBottomChange,
									min: 5,
									max: 100
								})
							)
						)
					)
				);
			} else {
				return _react2.default.createElement(
					'table',
					{ className: 'table-block', style: { width: '100%' } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { textAlign: this.el().align, paddingTop: this.el().paddingTop, paddingBottom: this.el().paddingBottom } },
								this.renderIcons()
							)
						)
					)
				);
			}
		}
	}]);

	return Socialfollow;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Socialfollow = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Socialfollow);

exports.default = Socialfollow;

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _rcSlider = __webpack_require__(200);

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_React$Component) {
	_inherits(Header, _React$Component);

	function Header(props) {
		_classCallCheck(this, Header);

		var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onTextChange = _this.onTextChange.bind(_this);
		_this.handleChange = _this.handleChange.bind(_this);
		_this.onChange = _this.onChange.bind(_this);

		return _this;
	}

	_createClass(Header, [{
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { paddingTop: v + 'px' });
		}
	}, {
		key: 'onTextChange',
		value: function onTextChange(e) {
			this.props.setComponentState(this.el().id, _defineProperty({}, e.target.id, e.target.value));
		}
	}, {
		key: 'handleChange',
		value: function handleChange(id, s) {
			var changes = {};
			changes[id] = s;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Header' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'text-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'right', parent: 'text-settings', title: 'Text right' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Text' },
								_react2.default.createElement('input', { type: 'text', value: this.el().right_text, id: 'right_text', onChange: this.onTextChange, className: 'form-control' })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Font style' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'right_font',
									sizeId: 'right_size',
									colorId: 'right_color',
									font: this.el().right_font,
									size: this.el().right_size,
									color: this.el().right_color,
									handleChange: this.handleChange
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'left', parent: 'text-settings', title: 'Text left' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Text' },
								_react2.default.createElement('input', { type: 'text', value: this.el().left_text, id: 'left_text', onChange: this.onTextChange, className: 'form-control' })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Font style' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'left_font',
									sizeId: 'left_size',
									colorId: 'left_color',
									font: this.el().left_font,
									size: this.el().left_size,
									color: this.el().left_color,
									handleChange: this.handleChange
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'padding', parent: 'text-settings', title: 'Spacing' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Spacing top' },
								_react2.default.createElement(_rcSlider2.default, { value: parseInt(this.el().paddingTop.replace('px', '')),
									onChange: this.onChange,
									min: 0,
									max: 400
								})
							)
						)
					)
				);
			} else {
				return _react2.default.createElement(
					'table',
					{ style: { width: '100%', marginTop: this.el().paddingTop } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { textAlign: 'left', width: '50%' } },
								_react2.default.createElement(
									'span',
									{ style: { fontSize: this.el().left_size, fontFamily: this.el().left_font, color: this.el().left_color } },
									this.el().left_text
								)
							),
							_react2.default.createElement(
								'td',
								{ style: { textAlign: 'right', width: '50%' } },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement(
										'a',
										{ href: '#', style: { fontSize: this.el().right_size, fontFamily: this.el().right_font, color: this.el().right_color } },
										this.el().right_text
									)
								)
							)
						)
					)
				);
			}
		}
	}]);

	return Header;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Header = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

exports.default = Header;

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
	_inherits(Footer, _React$Component);

	function Footer(props) {
		_classCallCheck(this, Footer);

		var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

		_this.onPaddingChange = _this.onPaddingChange.bind(_this);
		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.componentDidMount = _this.componentDidMount.bind(_this);
		_this.renderEditor = _this.renderEditor.bind(_this);
		_this.instance = false;

		_this.state = {
			// Bytt mellom textarea virker ikke. TEkst blir ikke oppdatert.
		};
		return _this;
	}

	_createClass(Footer, [{
		key: 'onPaddingChange',
		value: function onPaddingChange(id, padding) {
			var changes = {};
			changes[id] = padding;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { text: v });
		}
	}, {
		key: 'renderEditor',
		value: function renderEditor() {
			var _this2 = this;

			if (this.instance !== false) {
				this.instance.destroy();
				this.instance = false;
			}

			this.instance = CKEDITOR.replace(this.textInput, {
				customConfig: '/js/editorConfig.js',
				width: '100%',
				height: '100%',
				on: {
					change: function change(evt) {
						_this2.onChange(_this2.instance.getData());
					}
				}
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.sidebar) {
				this.renderEditor();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			if (this.props.sidebar) {
				if (next.builder.components[next.id].id != this.props.id) {
					this.instance.destroy();
				}
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.props.sidebar) {
				this.renderEditor();
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(props, state) {
			if (this.props.sidebar && props.id == this.props.id) {
				return false;
			}
			return true;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Text' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'text-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'content', parent: 'text-settings', title: 'Content' },
							_react2.default.createElement('textarea', { ref: function ref(input) {
									_this3.textInput = input;
								}, onChange: function onChange() {
									return null;
								}, value: this.el().text })
						)
					)
				);
			} else {
				return _react2.default.createElement('div', { className: 'text main', style: { textAlign: 'left' }, dangerouslySetInnerHTML: { __html: this.el().text } });
			}
		}
	}]);

	return Footer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Footer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Footer);

exports.default = Footer;

/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderSummery = function (_React$Component) {
	_inherits(OrderSummery, _React$Component);

	function OrderSummery(props) {
		_classCallCheck(this, OrderSummery);

		var _this = _possibleConstructorReturn(this, (OrderSummery.__proto__ || Object.getPrototypeOf(OrderSummery)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);

		_this.items = _this.items.bind(_this);
		_this.image = _this.image.bind(_this);
		_this.quantity = _this.quantity.bind(_this);
		_this.details = _this.details.bind(_this);
		_this.handleChange = _this.handleChange.bind(_this);
		_this.onButtonChange = _this.onButtonChange.bind(_this);
		_this.onTextChange = _this.onTextChange.bind(_this);

		return _this;
	}

	_createClass(OrderSummery, [{
		key: 'onButtonChange',
		value: function onButtonChange(e) {
			this.props.setComponentState(this.el().id, { 'button_text': e.target.value });
		}
	}, {
		key: 'onTextChange',
		value: function onTextChange(e) {
			this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
		}
	}, {
		key: 'handleChange',
		value: function handleChange(id, s) {
			var changes = {};
			changes[id] = s;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'items',
		value: function items() {
			var _this2 = this;

			var lines = [];
			var products = [{
				'id': 1,
				'name': 'Product line 1',
				'sum': 200,
				'image': 'https://cdn.crall.io/uploads/test.jpg',
				'quantity': 2
			}, {
				'id': 2,
				'name': 'Product line 2',
				'sum': 100,
				'image': 'https://cdn.crall.io/uploads/test.jpg',
				'quantity': 1
			}];

			products.map(function (item) {
				lines.push(_react2.default.createElement(
					'tr',
					{ key: item.id },
					_react2.default.createElement(
						'td',
						{ className: 'table-width-20 table-top', style: { padding: '5px' } },
						_this2.image(item)
					),
					_react2.default.createElement(
						'td',
						{ className: 'table-width-60 ', style: { padding: '5px', color: _this2.el().text_color } },
						_this2.details(item)
					),
					_react2.default.createElement(
						'td',
						{ className: 'table-width-10', style: { padding: '5px', color: _this2.el().text_color } },
						_this2.quantity(item)
					),
					_react2.default.createElement(
						'td',
						{ className: 'table-width-10 ', style: { padding: '5px', color: _this2.el().text_color } },
						_this2.sum(item)
					)
				));
			});

			return lines;
		}
	}, {
		key: 'image',
		value: function image(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement('img', { src: item.image, style: { maxWidth: '130px' } })
						)
					)
				)
			);
		}
	}, {
		key: 'quantity',
		value: function quantity(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block table-text-center' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
								item.quantity
							)
						)
					)
				)
			);
		}
	}, {
		key: 'sum',
		value: function sum(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block table-text-right', style: { textAlign: 'right' } },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
								item.sum
							)
						)
					)
				)
			);
		}
	}, {
		key: 'details',
		value: function details(item) {
			return _react2.default.createElement(
				'table',
				{ className: 'table-block table-text-left' },
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
								item.name
							)
						)
					)
				)
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Order summary' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'container', parent: 'cart-settings', title: 'Container' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Font style' },
								_react2.default.createElement(_FontPicker2.default, {
									fontId: 'text_font',
									sizeId: 'text_size',
									colorId: 'text_color',
									font: this.el().text_font,
									size: this.el().text_size,
									color: this.el().text_color,
									handleChange: this.handleChange
								})
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'container', parent: 'cart-translation', title: 'Translation' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Total' },
								_react2.default.createElement('input', { type: 'text', value: this.el().translate_total, 'data-id': 'translate_total', onChange: this.onTextChange, className: 'form-control' })
							)
						)
					)
				);
			} else {

				return _react2.default.createElement(
					'table',
					{ className: 'table-block', style: { width: '100%', fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { padding: this.el().padding } },
								_react2.default.createElement(
									'table',
									{ className: 'table-block' },
									_react2.default.createElement(
										'tbody',
										null,
										this.items()
									)
								)
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { padding: this.el().padding } },
								_react2.default.createElement(
									'table',
									{ className: 'table-block', style: { width: '100%' } },
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												{ style: { textAlign: 'right' } },
												_react2.default.createElement(
													'table',
													{ style: { marginLeft: 'auto', marginRight: 0, width: '50%' } },
													_react2.default.createElement(
														'tbody',
														null,
														_react2.default.createElement(
															'tr',
															null,
															_react2.default.createElement(
																'td',
																{ style: { textAlign: 'right', width: '70%' } },
																'@@SHIPPING_METHOD@@',
																_react2.default.createElement('br', null)
															),
															_react2.default.createElement(
																'td',
																{ style: { textAlign: 'right', width: '30%' } },
																'79'
															)
														),
														_react2.default.createElement(
															'tr',
															null,
															_react2.default.createElement(
																'td',
																{ style: { textAlign: 'right', width: '70%' } },
																this.el().translate_total
															),
															_react2.default.createElement(
																'td',
																{ style: { textAlign: 'right', width: '30%' } },
																'379'
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}
	}]);

	return OrderSummery;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

OrderSummery = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderSummery);

exports.default = OrderSummery;

/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recommendation = function (_React$Component) {
    _inherits(Recommendation, _React$Component);

    function Recommendation(props) {
        _classCallCheck(this, Recommendation);

        var _this = _possibleConstructorReturn(this, (Recommendation.__proto__ || Object.getPrototypeOf(Recommendation)).call(this, props));

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);

        _this.handleChange = _this.handleChange.bind(_this);
        _this.onButtonChange = _this.onButtonChange.bind(_this);
        _this.onTextChange = _this.onTextChange.bind(_this);
        _this.rows = _this.rows.bind(_this);

        return _this;
    }

    _createClass(Recommendation, [{
        key: 'rows',
        value: function rows() {
            var ret = [];

            for (var i = 1; i <= this.el().rows; i++) {
                ret.push(_react2.default.createElement(
                    'tr',
                    { key: i },
                    this.productBox(),
                    this.productBox(),
                    this.productBox()
                ));
            }

            return ret;
        }
    }, {
        key: 'onButtonChange',
        value: function onButtonChange(e) {
            this.props.setComponentState(this.el().id, { 'button_text': e.target.value });
        }
    }, {
        key: 'onTextChange',
        value: function onTextChange(e) {
            this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
        }
    }, {
        key: 'handleChange',
        value: function handleChange(id, s) {
            var changes = {};
            changes[id] = s;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'productBox',
        value: function productBox() {
            return _react2.default.createElement(
                'td',
                { style: { width: '25%', padding: this.el().padding } },
                _react2.default.createElement(
                    'table',
                    { className: 'product-box table-block' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement('img', { src: 'https://cdn.crall.io/uploads/test.jpg' })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                'Product name'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                '1.232,-'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { padding: '10px', color: '#fff', backgroundColor: this.el().button_background } },
                                this.el().button_text
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Recommendation' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-settings', title: 'Container' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Font style' },
                                _react2.default.createElement(_FontPicker2.default, {
                                    fontId: 'text_font',
                                    sizeId: 'text_size',
                                    colorId: 'text_color',
                                    font: this.el().text_font,
                                    size: this.el().text_size,
                                    color: this.el().text_color,
                                    handleChange: this.handleChange
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-recommendation', title: 'Recommendation' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Type' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.el().type, 'data-id': 'type', onChange: this.onTextChange },
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'Relevant' },
                                        'Relevant'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'Bestsellers' },
                                        'Bestsellers'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Rows' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.el().rows, 'data-id': 'rows', onChange: this.onTextChange },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '1' },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '2' },
                                        '2'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-translation', title: 'Button' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().button_text, 'data-id': 'button_text', onChange: this.onTextChange, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Background color' },
                                _react2.default.createElement(_ColorPicker2.default, { id: 'button_background', color: this.el().button_background, handleColorChange: this.handleChange })
                            )
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%', fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.rows()
                    )
                );
            }
        }
    }]);

    return Recommendation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Recommendation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Recommendation);

exports.default = Recommendation;

/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _DiscountPicker = __webpack_require__(384);

var _DiscountPicker2 = _interopRequireDefault(_DiscountPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Discount = function (_React$Component) {
    _inherits(Discount, _React$Component);

    function Discount(props) {
        _classCallCheck(this, Discount);

        var _this = _possibleConstructorReturn(this, (Discount.__proto__ || Object.getPrototypeOf(Discount)).call(this, props));

        _this.state = {
            isAddingDiscount: false
        };

        _this.onPaddingChange = _this.onPaddingChange.bind(_this);
        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.componentDidMount = _this.componentDidMount.bind(_this);
        _this.handleLinkChange = _this.handleLinkChange.bind(_this);
        _this.handleAlignChange = _this.handleAlignChange.bind(_this);
        _this.handleBorderChange = _this.handleBorderChange.bind(_this);
        _this.useDiscount = _this.useDiscount.bind(_this);

        return _this;
    }

    _createClass(Discount, [{
        key: 'useDiscount',
        value: function useDiscount(id) {
            this.props.setComponentState(this.el().id, { 'discount_id': id });
            this.setState({ isAddingDiscount: false });
        }
    }, {
        key: 'handleAlignChange',
        value: function handleAlignChange(id, s) {
            this.props.setComponentState(this.el().id, { 'align': s });
        }
    }, {
        key: 'handleLinkChange',
        value: function handleLinkChange(id, s) {

            this.props.setComponentState(this.el().id, s);
        }
    }, {
        key: 'onPaddingChange',
        value: function onPaddingChange(id, padding) {
            var changes = {};
            changes[id] = padding;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'onChange',
        value: function onChange(v) {
            this.props.setComponentState(this.el().id, { value: v.target.value });
        }
    }, {
        key: 'handleBorderChange',
        value: function handleBorderChange(id, border) {
            var changes = {};
            changes[id] = border;

            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Button' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'button-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'button', parent: 'button-settings', title: 'Button' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().value, onChange: this.onChange, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Border' },
                                _react2.default.createElement(_BorderPicker2.default, { id: 'border', handleBorderChange: this.handleBorderChange, data: this.el().border })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Background color' },
                                _react2.default.createElement(_ColorPicker2.default, { transparent: true, id: 'backgroundColor', color: this.el().backgroundColor, handleColorChange: this.handleBorderChange })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Text color' },
                                _react2.default.createElement(_ColorPicker2.default, { transparent: false, id: 'color', color: this.el().color, handleColorChange: this.handleBorderChange })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Horizontal position' },
                                _react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.handleAlignChange })
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'link', parent: 'button-settings', title: 'Discount' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Discount' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-dark btn-block', onClick: function onClick() {
                                            return _this2.setState({ isAddingDiscount: true });
                                        } },
                                    'Select a discount code'
                                ),
                                this.el().discount_id > 0 && this.el().discount_id ? _react2.default.createElement(
                                    'div',
                                    { className: 'm-t-10', style: { width: '100%', textAlign: 'center', fontSize: '16px' } },
                                    'Using discount id: #',
                                    this.el().discount_id
                                ) : null
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'spacing', parent: 'button-settings', title: 'Spacing' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Padding' },
                                _react2.default.createElement(_PaddingPicker2.default, { id: 'padding', handlePaddingChange: this.onPaddingChange, data: this.el().padding })
                            )
                        )
                    ),
                    _react2.default.createElement(_DiscountPicker2.default, { useDiscount: this.useDiscount, sidebar: true, onClose: function onClose() {
                            _this2.setState({ isAddingDiscount: false });
                        }, param: this.state.isAddingDiscount })
                );
            } else {
                var button_style = {
                    border: this.el().border.replace(/\|/g, ' '),
                    backgroundColor: this.el().backgroundColor,
                    color: this.el().color ? this.el().color : '#ffffff'
                };

                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: this.el().align, padding: this.el().padding } },
                                _react2.default.createElement(
                                    'a',
                                    { className: 'click-button', style: button_style, href: 'javascript:void(0)' },
                                    this.el().value
                                )
                            )
                        )
                    )
                );
            }
        }
    }]);

    return Discount;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Discount = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Discount);

exports.default = Discount;

/***/ }),

/***/ 1439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _rcSlider = __webpack_require__(200);

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_React$Component) {
    _inherits(List, _React$Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.renderList = _this.renderList.bind(_this);
        _this.renderFields = _this.renderFields.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleAlignChange = _this.handleAlignChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);

        return _this;
    }

    _createClass(List, [{
        key: 'handleChange',
        value: function handleChange(id, s) {
            var changes = {};
            changes[id] = s;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'handleAlignChange',
        value: function handleAlignChange(id, s) {
            this.props.setComponentState(this.el().id, { 'align': s });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'renderFields',
        value: function renderFields() {
            var list = [];

            for (var i = 1; i <= 5; i++) {
                var item = {};
                item.text = this.el()['line' + i + '_text'];
                item.link = this.el()['line' + i + '_link'];
                list.push(_react2.default.createElement(
                    'tr',
                    { key: i },
                    _react2.default.createElement(
                        'td',
                        null,
                        'Line ',
                        i
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('input', { className: 'form-control', 'data-id': 'line' + i + '_text', onChange: this.handleInputChange, value: this.el()['line' + i + '_text'], placeholder: 'Text' })
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('input', { className: 'form-control', 'data-id': 'line' + i + '_link', onChange: this.handleInputChange, value: this.el()['line' + i + '_link'], placeholder: 'https://' })
                    )
                ));
            }

            return list;
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var list = [];

            for (var i = 1; i <= 5; i++) {
                if (this.el()['line' + i + '_text'] != '') {
                    list.push(_react2.default.createElement(
                        'li',
                        { key: i },
                        this.el()['line' + i + '_text']
                    ));
                }
            }

            return list;
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'List' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'Socialfollow-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'icontypes', parent: 'Socialfollow-settings', title: 'List items' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Items' },
                                _react2.default.createElement(
                                    'table',
                                    { style: { width: '100%' } },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.renderFields()
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'font', parent: 'Socialfollow-settings', title: 'Font' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Font style' },
                                _react2.default.createElement(_FontPicker2.default, {
                                    fontId: 'font',
                                    sizeId: 'size',
                                    colorId: 'color',
                                    font: this.el().font,
                                    size: this.el().size,
                                    color: this.el().color,
                                    handleChange: this.handleChange
                                })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Horizontal position' },
                                _react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.handleAlignChange })
                            )
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: this.el().align } },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'link-list', style: { fontSize: this.el().size, color: this.el().color, fontFamily: this.el().font } },
                                    this.renderList()
                                )
                            )
                        )
                    )
                );
            }
        }
    }]);

    return List;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

List = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);

exports.default = List;

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _ManufacturerPicker = __webpack_require__(385);

var _ManufacturerPicker2 = _interopRequireDefault(_ManufacturerPicker);

var _CategoryPicker = __webpack_require__(386);

var _CategoryPicker2 = _interopRequireDefault(_CategoryPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductSelection = function (_React$Component) {
    _inherits(ProductSelection, _React$Component);

    function ProductSelection(props) {
        _classCallCheck(this, ProductSelection);

        var _this = _possibleConstructorReturn(this, (ProductSelection.__proto__ || Object.getPrototypeOf(ProductSelection)).call(this, props));

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);

        _this.handleChange = _this.handleChange.bind(_this);
        _this.onButtonChange = _this.onButtonChange.bind(_this);
        _this.onTextChange = _this.onTextChange.bind(_this);
        _this.rows = _this.rows.bind(_this);
        _this.handleDropDown = _this.handleDropDown.bind(_this);
        _this.onSaleChange = _this.onSaleChange.bind(_this);

        return _this;
    }

    _createClass(ProductSelection, [{
        key: 'handleDropDown',
        value: function handleDropDown(type, o, values) {
            var v = [];

            for (var i in values) {
                if (type == 'manufacturers') {
                    v.push(values[i].manufacturer);
                } else {
                    v.push(values[i].id);
                }
            }
            v = v.join(',');

            if (v == '') {
                v = false;
            }

            this.props.setComponentState(this.el().id, _defineProperty({}, type, v));
        }
    }, {
        key: 'rows',
        value: function rows() {
            var ret = [];

            for (var i = 1; i <= this.el().rows; i++) {
                ret.push(_react2.default.createElement(
                    'tr',
                    { key: i },
                    this.productBox(),
                    this.productBox(),
                    this.productBox()
                ));
            }

            return ret;
        }
    }, {
        key: 'onButtonChange',
        value: function onButtonChange(e) {
            this.props.setComponentState(this.el().id, { 'button_text': e.target.value });
        }
    }, {
        key: 'onTextChange',
        value: function onTextChange(e) {
            this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
        }
    }, {
        key: 'onSaleChange',
        value: function onSaleChange(e) {
            var v = !this.el()[e.target.getAttribute('data-id')];

            this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute('data-id'), v));
        }
    }, {
        key: 'handleChange',
        value: function handleChange(id, s) {
            var changes = {};
            changes[id] = s;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'productBox',
        value: function productBox() {
            return _react2.default.createElement(
                'td',
                { style: { width: '25%', padding: this.el().padding } },
                _react2.default.createElement(
                    'table',
                    { className: 'product-box table-block' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement('img', { src: 'https://cdn.crall.io/uploads/test.jpg' })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                'Product name'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                '1.232,-'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { padding: '10px', color: '#fff', backgroundColor: this.el().button_background } },
                                this.el().button_text
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text product-selection ', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Product selection' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-settings', title: 'Container' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Font style' },
                                _react2.default.createElement(_FontPicker2.default, {
                                    fontId: 'text_font',
                                    sizeId: 'text_size',
                                    colorId: 'text_color',
                                    font: this.el().text_font,
                                    size: this.el().text_size,
                                    color: this.el().text_color,
                                    handleChange: this.handleChange
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-recommendation', title: 'Products' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Type' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.el().type, 'data-id': 'type', onChange: this.onTextChange },
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'Random' },
                                        'Random'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'Bestsellers' },
                                        'Bestsellers'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Must be in category (OR)' },
                                _react2.default.createElement(_CategoryPicker2.default, { handleRuleChange: this.handleDropDown, rule: {
                                        value: this.el().categories,
                                        id: this.el().id
                                    }, index: 'categories' }),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    'Does not match child categories. Each child category must be added separately.'
                                )
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Must have manufacturer (OR)' },
                                _react2.default.createElement(_ManufacturerPicker2.default, { handleRuleChange: this.handleDropDown, rule: {
                                        value: this.el().manufacturers,
                                        id: this.el().id
                                    }, index: 'manufacturers' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Minimum product price' },
                                _react2.default.createElement('input', { type: 'text', placeholder: 'Minimum price', 'data-id': 'min_price', onChange: this.onTextChange, value: this.el().min_price, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Rows' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.el().rows, 'data-id': 'rows', onChange: this.onTextChange },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '1' },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '2' },
                                        '2'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '3' },
                                        '3'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '4' },
                                        '4'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '5' },
                                        '5'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '6' },
                                        '6'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '7' },
                                        '7'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '8' },
                                        '8'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Sort by' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.el().sort_by, 'data-id': 'sort_by', onChange: this.onTextChange },
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'none' },
                                        'No sorting'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'newest' },
                                        'Newest'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'price_low' },
                                        'Price low -> high'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: 'price_high' },
                                        'Price high -> low'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'On sale' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'checkbox-custom checkbox-default' },
                                    _react2.default.createElement('input', { type: 'checkbox', checked: this.el().only_on_sale, 'data-id': 'only_on_sale', onChange: this.onSaleChange }),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Only display products on sale'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'container', parent: 'cart-translation', title: 'Button' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().button_text, 'data-id': 'button_text', onChange: this.onTextChange, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Background color' },
                                _react2.default.createElement(_ColorPicker2.default, { id: 'button_background', color: this.el().button_background, handleColorChange: this.handleChange })
                            )
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%', fontSize: this.el().text_size, color: this.el().text_color, fontFamily: this.el().text_font } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.rows()
                    )
                );
            }
        }
    }]);

    return ProductSelection;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

ProductSelection = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProductSelection);

exports.default = ProductSelection;

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _reactCodemirror = __webpack_require__(202);

var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);

__webpack_require__(387);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomHtml = function (_React$Component) {
    _inherits(CustomHtml, _React$Component);

    function CustomHtml(props) {
        _classCallCheck(this, CustomHtml);

        var _this = _possibleConstructorReturn(this, (CustomHtml.__proto__ || Object.getPrototypeOf(CustomHtml)).call(this, props));

        _this.codeMirrorOptions = {
            lineNumbers: true,
            mode: 'text/html'
        };

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.handleHtmlChange = _this.handleHtmlChange.bind(_this);
        return _this;
    }

    _createClass(CustomHtml, [{
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
                'Dette er en test'
            );
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'onChange',
        value: function onChange(v) {
            this.props.setComponentState(this.el().id, { value: v + 'px' });
        }
    }, {
        key: 'handleHtmlChange',
        value: function handleHtmlChange(code) {
            this.props.setComponentState(this.el().id, { value: code });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Custom HTML' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-warning', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                        ' ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Warning:'
                        ),
                        ' Advanced users only. Adding custom HTML could break email structure and can get rendering issues. Use at own risk.',
                        _react2.default.createElement('br', null),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Adding clickable links to the html MAY result in lowered click tracking/conversion rate from Crall.'
                        )
                    ),
                    _react2.default.createElement(_reactCodemirror2.default, { value: this.el().value, onChange: this.handleHtmlChange, options: this.codeMirrorOptions })
                );
            } else {
                return _react2.default.createElement('div', { className: 'text main', dangerouslySetInnerHTML: { __html: this.el().value } });
            }
        }
    }]);

    return CustomHtml;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

CustomHtml = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomHtml);

exports.default = CustomHtml;

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShippingTracker = function (_React$Component) {
    _inherits(ShippingTracker, _React$Component);

    function ShippingTracker(props) {
        _classCallCheck(this, ShippingTracker);

        var _this = _possibleConstructorReturn(this, (ShippingTracker.__proto__ || Object.getPrototypeOf(ShippingTracker)).call(this, props));

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);

        _this.items = _this.items.bind(_this);

        _this.handleChange = _this.handleChange.bind(_this);
        _this.onButtonChange = _this.onButtonChange.bind(_this);

        return _this;
    }

    _createClass(ShippingTracker, [{
        key: 'onButtonChange',
        value: function onButtonChange(e) {
            this.props.setComponentState(this.el().id, { 'button_text': e.target.value });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(id, s) {
            var changes = {};
            changes[id] = s;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'items',
        value: function items() {
            var _this2 = this;

            var lines = [];
            var products = [{
                'id': 1,
                'time': '2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': ''
            }, {
                'id': 2,
                'time': '2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': ''
            }, {
                'id': 3,
                'time': '2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': ''
            }, {
                'id': 4,
                'time': '2018-02-21 11:46',
                'description': 'The electronic shipping instructions have been received',
                'location': 'Oslo'
            }];

            products.map(function (item) {
                lines.push(_react2.default.createElement(
                    'tr',
                    { key: item.id },
                    _react2.default.createElement(
                        'td',
                        { className: 'table-width-20 table-top', style: { padding: '10px' } },
                        _this2.col(item.time)
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'table-width-60 table-top', style: { padding: '10px' } },
                        _this2.col(item.description)
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'table-width-20', style: { padding: '10px' } },
                        _this2.col(item.location)
                    )
                ));
            });

            return lines;
        }
    }, {
        key: 'col',
        value: function col(text) {
            return _react2.default.createElement(
                'table',
                { style: { verticalAlign: 'top', width: '100%' } },
                _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            text
                        )
                    )
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Shipping tracker' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'button', parent: 'cart-settings', title: 'Settings' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Header text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().text_package_tracking, onChange: function onChange(e) {
                                        _this3.handleChange('text_package_tracking', e.target.value);
                                    }, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Button text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().text_package_tracking_button, onChange: function onChange(e) {
                                        _this3.handleChange('text_package_tracking_button', e.target.value);
                                    }, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Primary color' },
                                _react2.default.createElement(_ColorPicker2.default, { id: 'primary_color', color: this.el().primary_color, handleColorChange: this.handleChange })
                            )
                        )
                    )
                );
            } else {
                var button_style = {
                    backgroundColor: this.el().primary_color
                };
                return _react2.default.createElement(
                    'table',
                    { className: 'shipping-tracker table-block', style: { width: '100%' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    { style: { width: '100%', backgroundColor: this.el().primary_color, color: '#fff' } },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { style: { textAlign: 'left', padding: '10px' } },
                                                this.el().text_package_tracking,
                                                ' - @@SHIPPING_PROVIDER@@ ( @@TRACKING_NUMBER@@ )'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    { className: 'tracker table-block' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.items()
                                    )
                                )
                            )
                        ),
                        this.el().text_package_tracking_button != '' ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    { className: 'table-block', style: { width: '100%', marginTop: '15px' } },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { style: { textAlign: 'center' } },
                                                _react2.default.createElement(
                                                    'a',
                                                    { className: 'click-button', style: button_style, href: 'javascript:void(0)' },
                                                    this.el().text_package_tracking_button
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ) : null
                    )
                );
            }
        }
    }]);

    return ShippingTracker;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

ShippingTracker = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShippingTracker);

exports.default = ShippingTracker;

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recheckout = function (_React$Component) {
    _inherits(Recheckout, _React$Component);

    function Recheckout(props) {
        _classCallCheck(this, Recheckout);

        var _this = _possibleConstructorReturn(this, (Recheckout.__proto__ || Object.getPrototypeOf(Recheckout)).call(this, props));

        _this.state = {
            isAddingDiscount: false
        };

        _this.onPaddingChange = _this.onPaddingChange.bind(_this);
        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.componentDidMount = _this.componentDidMount.bind(_this);
        _this.handleLinkChange = _this.handleLinkChange.bind(_this);
        _this.handleAlignChange = _this.handleAlignChange.bind(_this);
        _this.handleBorderChange = _this.handleBorderChange.bind(_this);
        _this.useDiscount = _this.useDiscount.bind(_this);

        return _this;
    }

    _createClass(Recheckout, [{
        key: 'useDiscount',
        value: function useDiscount(id) {
            this.props.setComponentState(this.el().id, { 'discount_id': id });
            this.setState({ isAddingDiscount: false });
        }
    }, {
        key: 'handleAlignChange',
        value: function handleAlignChange(id, s) {
            this.props.setComponentState(this.el().id, { 'align': s });
        }
    }, {
        key: 'handleLinkChange',
        value: function handleLinkChange(id, s) {

            this.props.setComponentState(this.el().id, s);
        }
    }, {
        key: 'onPaddingChange',
        value: function onPaddingChange(id, padding) {
            var changes = {};
            changes[id] = padding;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'onChange',
        value: function onChange(v) {
            this.props.setComponentState(this.el().id, { value: v.target.value });
        }
    }, {
        key: 'handleBorderChange',
        value: function handleBorderChange(id, border) {
            var changes = {};
            changes[id] = border;

            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Button' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'button-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'button', parent: 'button-settings', title: 'Button' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Text' },
                                _react2.default.createElement('input', { type: 'text', value: this.el().value, onChange: this.onChange, className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Border' },
                                _react2.default.createElement(_BorderPicker2.default, { id: 'border', handleBorderChange: this.handleBorderChange, data: this.el().border })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Background color' },
                                _react2.default.createElement(_ColorPicker2.default, { transparent: true, id: 'backgroundColor', color: this.el().backgroundColor, handleColorChange: this.handleBorderChange })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Horizontal position' },
                                _react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.handleAlignChange })
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'spacing', parent: 'button-settings', title: 'Spacing' },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: 'Padding' },
                                _react2.default.createElement(_PaddingPicker2.default, { id: 'padding', handlePaddingChange: this.onPaddingChange, data: this.el().padding })
                            )
                        )
                    )
                );
            } else {
                var button_style = { border: this.el().border.replace(/\|/g, ' '), backgroundColor: this.el().backgroundColor };

                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: this.el().align, padding: this.el().padding } },
                                _react2.default.createElement(
                                    'a',
                                    { className: 'click-button', style: button_style, href: 'javascript:void(0)' },
                                    this.el().value
                                )
                            )
                        )
                    )
                );
            }
        }
    }]);

    return Recheckout;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Recheckout = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Recheckout);

exports.default = Recheckout;

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _reactCodemirror = __webpack_require__(202);

var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);

__webpack_require__(387);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _RecommendationHelper = __webpack_require__(633);

var _RecommendationHelper2 = _interopRequireDefault(_RecommendationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrallRecommendation = function (_React$Component) {
    _inherits(CrallRecommendation, _React$Component);

    function CrallRecommendation(props) {
        _classCallCheck(this, CrallRecommendation);

        var _this = _possibleConstructorReturn(this, (CrallRecommendation.__proto__ || Object.getPrototypeOf(CrallRecommendation)).call(this, props));

        _this.changeRecommendation = function (value) {
            _this.props.setComponentState(_this.el().id, { recommendation_id: value.id });
        };

        _this.getRecommendations = function () {
            return _axios2.default.get('/recommendations?type=email').then(function (res) {
                _this.props.setComponentState(_this.el().id, { recommendations: res.data });

                res.data = res.data.map(function (p) {
                    return p;
                });

                return { options: res.data };
            });
        };

        _this.getRecommendationCode = function () {
            var code = '<span></span>';
            var recommendations = _this.el().recommendations;

            for (var i in recommendations) {
                if (recommendations[i].id == _this.el().recommendation_id) {
                    code = _RecommendationHelper2.default.emailCode(recommendations[i], 'crall');
                }
            }

            if (_this.el().html != code) {
                _this.props.setComponentState(_this.el().id, { html: code });
            }

            return code;
        };

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(CrallRecommendation, [{
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
                'Dette er en test'
            );
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'onChange',
        value: function onChange(v) {
            this.props.setComponentState(this.el().id, { value: v + 'px' });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'sidebar text', style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Recommendation' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-info', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                        'To create or edit recommendations you need to visit the recommendation page in the admin area.',
                        _react2.default.createElement('br', null),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: "btn btn-dark", to: _General2.default.Link("/recommendations") },
                            'Open recommendations'
                        )
                    ),
                    _react2.default.createElement(
                        _SidebarElementSetting2.default,
                        { text: 'Select recommendation' },
                        _react2.default.createElement(_reactSelect2.default.Async, {
                            autoload: true,
                            valueKey: 'id',
                            labelKey: 'description',
                            simpleValue: false,
                            multi: false,
                            name: 'form-field-name',
                            value: this.el().recommendation_id,
                            loadOptions: this.getRecommendations,
                            onChange: this.changeRecommendation
                        })
                    )
                );
            } else {
                if (this.el().recommendation_id == '' || !this.el().recommendation_id || this.el().recommendation_id == '0') {
                    return _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-info', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Note:'
                        ),
                        ' Please select a recommendation from the sidebar'
                    );
                } else {

                    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.getRecommendationCode() } });
                }
            }
        }
    }]);

    return CrallRecommendation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder,
        general: state.general

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

CrallRecommendation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CrallRecommendation);

exports.default = CrallRecommendation;

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrallRecommendationDynamo = function (_React$Component) {
    _inherits(CrallRecommendationDynamo, _React$Component);

    function CrallRecommendationDynamo(props) {
        _classCallCheck(this, CrallRecommendationDynamo);

        var _this = _possibleConstructorReturn(this, (CrallRecommendationDynamo.__proto__ || Object.getPrototypeOf(CrallRecommendationDynamo)).call(this, props));

        _this.changeRecommendation = function (value) {
            _this.props.setComponentState(_this.el().id, {
                recommendation_id: value.id
            });
        };

        _this.getRecommendations = function () {
            return _axios2.default.get("/recommendations?type=email").then(function (res) {
                _this.props.setComponentState(_this.el().id, {
                    recommendations: res.data
                });

                res.data = res.data.map(function (p) {
                    return p;
                });

                return { options: res.data };
            });
        };

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);

        _this.handleChange = _this.handleChange.bind(_this);
        _this.onButtonChange = _this.onButtonChange.bind(_this);
        _this.onTextChange = _this.onTextChange.bind(_this);
        _this.rows = _this.rows.bind(_this);
        return _this;
    }

    _createClass(CrallRecommendationDynamo, [{
        key: "rows",
        value: function rows() {
            var ret = [];

            for (var i = 1; i <= this.el().rows; i++) {
                ret.push(_react2.default.createElement(
                    "tr",
                    { key: i },
                    this.productBox(),
                    this.productBox(),
                    this.productBox()
                ));
            }

            return ret;
        }
    }, {
        key: "onButtonChange",
        value: function onButtonChange(e) {
            this.props.setComponentState(this.el().id, {
                button_text: e.target.value
            });
        }
    }, {
        key: "onTextChange",
        value: function onTextChange(e) {
            this.props.setComponentState(this.el().id, _defineProperty({}, e.target.getAttribute("data-id"), e.target.value));
        }
    }, {
        key: "handleChange",
        value: function handleChange(id, s) {
            var changes = {};
            changes[id] = s;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: "el",
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: "handleBackClick",
        value: function handleBackClick() {
            this.props.setSidebarState({ visible: false });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {}
    }, {
        key: "productBox",
        value: function productBox() {
            return _react2.default.createElement(
                "td",
                { style: { width: "25%", padding: this.el().padding } },
                _react2.default.createElement(
                    "table",
                    { className: "product-box table-block" },
                    _react2.default.createElement(
                        "tbody",
                        null,
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                null,
                                _react2.default.createElement("img", { src: "https://cdn.crall.io/uploads/test.jpg" })
                            )
                        ),
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                null,
                                "Product name"
                            )
                        ),
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                null,
                                "1.232,-"
                            )
                        ),
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                {
                                    style: {
                                        padding: "10px",
                                        color: "#fff",
                                        backgroundColor: this.el().button_background
                                    }
                                },
                                this.el().button_text
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    "div",
                    { className: "sidebar text", style: this.props.style },
                    _react2.default.createElement(_SidebarElementHeader2.default, {
                        handleBackClick: this.handleBackClick,
                        text: "Recommendation"
                    }),
                    _react2.default.createElement(
                        "div",
                        {
                            className: "panel-group panel-group-continuous",
                            id: "cart-settings",
                            "aria-multiselectable": "true",
                            role: "tablist"
                        },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            {
                                selectedSetting: false,
                                optionKey: "container",
                                parent: "cart-settings",
                                title: "Container"
                            },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: "Font style" },
                                _react2.default.createElement(_FontPicker2.default, {
                                    fontId: "text_font",
                                    sizeId: "text_size",
                                    colorId: "text_color",
                                    font: this.el().text_font,
                                    size: this.el().text_size,
                                    color: this.el().text_color,
                                    handleChange: this.handleChange
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            {
                                selectedSetting: false,
                                optionKey: "container",
                                parent: "cart-recommendation",
                                title: "Recommendation"
                            },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: "Type" },
                                _react2.default.createElement(_reactSelect2.default.Async, {
                                    autoload: true,
                                    valueKey: "id",
                                    labelKey: "description",
                                    simpleValue: false,
                                    multi: false,
                                    name: "form-field-name",
                                    value: this.el().recommendation_id,
                                    loadOptions: this.getRecommendations,
                                    onChange: this.changeRecommendation
                                })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: "Rows" },
                                _react2.default.createElement(
                                    "select",
                                    {
                                        className: "form-control",
                                        value: this.el().rows,
                                        "data-id": "rows",
                                        onChange: this.onTextChange
                                    },
                                    _react2.default.createElement(
                                        "option",
                                        { value: "1" },
                                        "1"
                                    ),
                                    _react2.default.createElement(
                                        "option",
                                        { value: "2" },
                                        "2"
                                    ),
                                    _react2.default.createElement(
                                        "option",
                                        { value: "3" },
                                        "3"
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            {
                                selectedSetting: false,
                                optionKey: "container",
                                parent: "cart-translation",
                                title: "Button"
                            },
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: "Text" },
                                _react2.default.createElement("input", {
                                    type: "text",
                                    value: this.el().button_text,
                                    "data-id": "button_text",
                                    onChange: this.onTextChange,
                                    className: "form-control"
                                })
                            ),
                            _react2.default.createElement(
                                _SidebarElementSetting2.default,
                                { text: "Background color" },
                                _react2.default.createElement(_ColorPicker2.default, {
                                    id: "button_background",
                                    color: this.el().button_background,
                                    handleColorChange: this.handleChange
                                })
                            )
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    "table",
                    {
                        className: "table-block",
                        style: {
                            width: "100%",
                            fontSize: this.el().text_size,
                            color: this.el().text_color,
                            fontFamily: this.el().text_font
                        }
                    },
                    _react2.default.createElement(
                        "tbody",
                        null,
                        this.rows()
                    )
                );
            }
        }
    }]);

    return CrallRecommendationDynamo;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

CrallRecommendationDynamo = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CrallRecommendationDynamo);

exports.default = CrallRecommendationDynamo;

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactDnd = __webpack_require__(163);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

var _Toolbar = __webpack_require__(370);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _DroppableElement = __webpack_require__(256);

var _DroppableElement2 = _interopRequireDefault(_DroppableElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cardSource = {
	beginDrag: function beginDrag(props) {
		return {
			type: props.type,
			sorting: props.element.sorting,
			id: props.element.id,
			rowId: props.element.rowId,
			col: props.element.col
		};
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	};
}
function collectDrop(connect, monitor) {
	return {
		// Call this function inside render()
		// to let React DnD handle the drag events:
		connectDropTarget: connect.dropTarget(),
		// You can ask the monitor about the current drag state:
		isOver: monitor.isOver(),
		isOverCurrent: monitor.isOver({ shallow: true }),
		canDrop: monitor.canDrop(),
		itemType: monitor.getItemType()
	};
}

var propTypes = {

	// Injected by React DnD:
	moveElement: _react.PropTypes.func.isRequired
};

var chessSquareTarget = {
	canDrop: function canDrop(props, monitor) {
		var item = monitor.getItemType();
		return true;
	},
	hover: function hover(props, monitor, component) {
		return;
	},
	drop: function drop(props, monitor, component) {
		if (monitor.didDrop()) {
			return;
		}

		var item = monitor.getItem();

		var drag = {
			index: item.sorting,
			id: item.id,
			rowId: item.rowId,
			col: item.col
		};

		var hover = {
			index: 1,
			id: false,
			rowId: props.rowId,
			col: props.col
		};

		// Time to actually perform the action
		props.moveElement(drag, hover);
	}
};

var DropContentElement = function (_React$Component) {
	_inherits(DropContentElement, _React$Component);

	function DropContentElement(props) {
		_classCallCheck(this, DropContentElement);

		return _possibleConstructorReturn(this, (DropContentElement.__proto__ || Object.getPrototypeOf(DropContentElement)).call(this, props));
	}

	_createClass(DropContentElement, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    isDragging = _props.isDragging,
			    connectDragPreview = _props.connectDragPreview,
			    connectDragSource = _props.connectDragSource,
			    connectDropTarget = _props.connectDropTarget;


			return connectDropTarget(_react2.default.createElement(
				'div',
				{ className: 'empty-column' },
				this.props.children
			));
		}
	}]);

	return DropContentElement;
}(_react2.default.Component);

DropContentElement.propTypes = propTypes;
exports.default = (0, _reactDnd.DropTarget)([_ItemTypes2.default.NEW_ELEMENT, _ItemTypes2.default.ELEMENT], chessSquareTarget, collectDrop)(DropContentElement);

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactColor = __webpack_require__(610);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarRowElement = function (_React$Component) {
	_inherits(SidebarRowElement, _React$Component);

	function SidebarRowElement(props) {
		_classCallCheck(this, SidebarRowElement);

		var _this = _possibleConstructorReturn(this, (SidebarRowElement.__proto__ || Object.getPrototypeOf(SidebarRowElement)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.handleColorChange = _this.handleColorChange.bind(_this);
		_this.handleBorderChange = _this.handleBorderChange.bind(_this);
		_this.onPaddingChange = _this.onPaddingChange.bind(_this);
		return _this;
	}

	_createClass(SidebarRowElement, [{
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'renderSettings',
		value: function renderSettings() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
				'Dette er en test'
			);
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { value: v });
		}
	}, {
		key: 'handleColorChange',
		value: function handleColorChange(id, color) {
			var changes = {};
			changes[id] = color;
			this.props.setGlobalTypeState('rows', this.props.row.id, changes);
		}
	}, {
		key: 'handleBorderChange',
		value: function handleBorderChange(id, border) {
			var changes = {};
			changes[id] = border;

			this.props.setGlobalTypeState('rows', this.props.row.id, changes);
		}
	}, {
		key: 'onPaddingChange',
		value: function onPaddingChange(id, padding) {
			var changes = {};
			changes[id] = padding;
			this.props.setGlobalTypeState('rows', this.props.row.id, changes);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'sidebar text', style: this.props.style },
				_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Row' }),
				_react2.default.createElement(
					'div',
					{ className: 'panel-group panel-group-continuous', id: 'row-settings', 'aria-multiselectable': 'true', role: 'tablist' },
					_react2.default.createElement(
						_SidebarSettingAccordion2.default,
						{ selectedSetting: false, optionKey: 'outer', parent: 'row-settings', title: 'Outer style' },
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Background color' },
							_react2.default.createElement(_ColorPicker2.default, { transparent: true, id: 'outerBackgroundColor', color: this.props.row.outerBackgroundColor, handleColorChange: this.handleColorChange })
						),
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Border top' },
							_react2.default.createElement(_BorderPicker2.default, { id: 'outerBorderTop', handleBorderChange: this.handleBorderChange, data: this.props.row.outerBorderTop, handleColorChange: this.handleColorChange })
						),
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Border bottom' },
							_react2.default.createElement(_BorderPicker2.default, { id: 'outerBorderBottom', handleBorderChange: this.handleBorderChange, data: this.props.row.outerBorderBottom, handleColorChange: this.handleColorChange })
						)
					),
					_react2.default.createElement(
						_SidebarSettingAccordion2.default,
						{ selectedSetting: false, optionKey: 'inner', parent: 'row-settings', title: 'Inner style' },
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Background color' },
							_react2.default.createElement(_ColorPicker2.default, { transparent: true, id: 'innerBackgroundColor', color: this.props.row.innerBackgroundColor, handleColorChange: this.handleColorChange })
						),
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Border top' },
							_react2.default.createElement(_BorderPicker2.default, { id: 'innerBorderTop', handleBorderChange: this.handleBorderChange, data: this.props.row.innerBorderTop, handleColorChange: this.handleColorChange })
						),
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Border bottom' },
							_react2.default.createElement(_BorderPicker2.default, { id: 'innerBorderBottom', handleBorderChange: this.handleBorderChange, data: this.props.row.innerBorderBottom, handleColorChange: this.handleColorChange })
						),
						_react2.default.createElement(
							_SidebarElementSetting2.default,
							{ text: 'Padding' },
							_react2.default.createElement(_PaddingPicker2.default, { id: 'innerPadding', handlePaddingChange: this.onPaddingChange, data: this.props.row.innerPadding })
						)
					)
				)
			);
		}
	}]);

	return SidebarRowElement;
}(_react2.default.Component);

exports.default = SidebarRowElement;

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _FontPicker = __webpack_require__(105);

var _FontPicker2 = _interopRequireDefault(_FontPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarPageElement = function (_React$Component) {
    _inherits(SidebarPageElement, _React$Component);

    function SidebarPageElement(props) {
        _classCallCheck(this, SidebarPageElement);

        var _this = _possibleConstructorReturn(this, (SidebarPageElement.__proto__ || Object.getPrototypeOf(SidebarPageElement)).call(this, props));

        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.handleColorChange = _this.handleColorChange.bind(_this);
        _this.handleBorderChange = _this.handleBorderChange.bind(_this);
        _this.onPaddingChange = _this.onPaddingChange.bind(_this);
        _this.outputRule = _this.outputRule.bind(_this);
        _this.handleSubjectChange = _this.handleSubjectChange.bind(_this);
        return _this;
    }

    _createClass(SidebarPageElement, [{
        key: 'handleSubjectChange',
        value: function handleSubjectChange(e) {
            this.props.setGlobalTypeState('page', false, { 'subject': e.target.value });
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
                'Dette er en test'
            );
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'onChange',
        value: function onChange(v) {
            this.props.setComponentState(this.el().id, { value: v });
        }
    }, {
        key: 'handleColorChange',
        value: function handleColorChange(id, color) {
            var changes = {};
            changes[id] = color;
            this.props.setGlobalTypeState('page', false, changes);
        }
    }, {
        key: 'handleBorderChange',
        value: function handleBorderChange(id, border) {
            var changes = {};
            changes[id] = border;
            this.props.setGlobalTypeState('page', false, changes);
        }
    }, {
        key: 'onPaddingChange',
        value: function onPaddingChange(id, padding) {
            var changes = {};
            changes[id] = padding;
            this.props.setGlobalTypeState('page', false, changes);
        }
    }, {
        key: 'outputRule',
        value: function outputRule(rule) {
            var Comp = this.props.components['Rule' + rule.key];
            return _react2.default.createElement(Comp, { setGlobalTypeState: this.props.setGlobalTypeState, rule: rule, key: rule.id });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var rule_options = [{
                'value': 'mobile',
                'label': 'mobile'
            }, {
                'value': 'desktop',
                'label': 'desktop'
            }, {
                'value': 'both',
                'label': 'both'
            }];

            return _react2.default.createElement(
                'div',
                { className: 'settings m-t-20', style: this.props.style },
                _react2.default.createElement(
                    'div',
                    { className: 'panel-group panel-group-continuous', id: 'sidebar-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                    _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: this.props.selectedSetting, optionKey: 'email', parent: 'sidebar-settings', title: 'E-mail options' },
                        _react2.default.createElement(
                            _SidebarElementSetting2.default,
                            { text: 'E-mail subject' },
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: this.handleSubjectChange, value: this.props.subject, placeholder: 'Subject' })
                        )
                    ),
                    _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: this.props.selectedSetting, optionKey: 'layout', parent: 'sidebar-settings', title: 'Layout' },
                        _react2.default.createElement(
                            _SidebarElementSetting2.default,
                            { text: 'Font style' },
                            _react2.default.createElement(_FontPicker2.default, {
                                fontId: 'font',
                                sizeId: 'fontSize',
                                colorId: 'color',
                                font: this.props.page.font,
                                size: this.props.page.fontSize,
                                color: this.props.page.color,
                                handleChange: this.handleBorderChange
                            })
                        ),
                        _react2.default.createElement(
                            _SidebarElementSetting2.default,
                            { text: 'Background color' },
                            _react2.default.createElement(_ColorPicker2.default, { id: 'backgroundColor', color: this.props.page.backgroundColor, handleColorChange: this.handleColorChange })
                        ),
                        _react2.default.createElement(
                            _SidebarElementSetting2.default,
                            { text: 'Border top' },
                            _react2.default.createElement(_BorderPicker2.default, { id: 'borderTop', handleBorderChange: this.handleBorderChange, data: this.props.page.borderTop, handleColorChange: this.handleColorChange })
                        ),
                        _react2.default.createElement(
                            _SidebarElementSetting2.default,
                            { text: 'Border bottom' },
                            _react2.default.createElement(_BorderPicker2.default, { id: 'borderBottom', handleBorderChange: this.handleBorderChange, data: this.props.page.borderBottom, handleColorChange: this.handleColorChange })
                        )
                    ),
                    this.props.page.type == 'NEWSLETTER' || this.props.isUsingFlow ? null : _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: this.props.selectedSetting, optionKey: 'who', parent: 'sidebar-settings', title: 'Who' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'list-group bg-blue-grey-100 bg-inherit' },
                                Object.keys(this.props.rules).map(function (i) {
                                    if (_this2.props.rules[i].action != 'Who') {
                                        return null;
                                    }
                                    return _this2.outputRule(_this2.props.rules[i]);
                                })
                            )
                        )
                    ),
                    this.props.page.type == 'NEWSLETTER' || this.props.isUsingFlow ? null : _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: this.props.selectedSetting, optionKey: 'when', parent: 'sidebar-settings', title: 'When' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-group bg-blue-grey-100 bg-inherit' },
                            Object.keys(this.props.rules).map(function (i) {
                                if (_this2.props.rules[i].action != 'When') {
                                    return null;
                                }

                                return _this2.outputRule(_this2.props.rules[i]);
                            })
                        )
                    )
                )
            );
        }
    }]);

    return SidebarPageElement;
}(_react2.default.Component);

exports.default = SidebarPageElement;

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Preview = function (_React$Component) {
    _inherits(Preview, _React$Component);

    function Preview(props) {
        _classCallCheck(this, Preview);

        var _this = _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).call(this, props));

        _this.state = {
            mode: 'mobile',
            email: '',
            html: ''
        };

        _this.changeEmail = _this.changeEmail.bind(_this);
        _this.sendTest = _this.sendTest.bind(_this);
        return _this;
    }

    _createClass(Preview, [{
        key: 'changeEmail',
        value: function changeEmail(e) {
            this.setState({ 'email': e.target.value });
        }
    }, {
        key: 'sendTest',
        value: function sendTest(e) {
            var _this2 = this;

            _Notification2.default.clear();
            if (this.state.email == '') {
                _Notification2.default.error('E-mail can\'t be empty');
                return;
            }
            _Notification2.default.info('Sending email...');

            _axios2.default.post('/emails/' + this.props.id + '/test', { 'email': this.state.email }).then(function (response) {
                _Notification2.default.clear();
                _Notification2.default.success(_react2.default.createElement(
                    'span',
                    null,
                    'E-mail sent to ',
                    _react2.default.createElement(
                        'span',
                        { style: { fontWeight: '300' } },
                        _this2.state.email
                    )
                ));
            }).catch(function (error) {
                _Notification2.default.clear();
                _Notification2.default.error(error.message);
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.refs.previewer.contentWindow.document.open();
            this.refs.previewer.contentWindow.document.write(this.state.html);
            this.refs.previewer.contentWindow.document.close();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            $(this.refs.modal).modal('show');

            _axios2.default.get('/emails/' + this.props.id + '/preview').then(function (res) {
                _this3.setState({ 'html': res.data });
            });
        }
    }, {
        key: 'preview',
        value: function preview() {
            if (this.state.mode == 'desktop') {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement('iframe', { ref: 'previewer', style: { border: '1px solid #ccc', width: '100%', height: '610px' } })
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement('img', { style: { zIndex: '2', left: "50%", transform: "translate(-50%, 0)", position: 'absolute' }, src: '/images/builder/phone.png' }),
                    _react2.default.createElement('iframe', { ref: 'previewer', style: { zIndex: '3', top: '60px', marginLeft: '0px', left: "50%", transform: "translate(-50%, 0)", position: 'absolute', border: '1px solid #979797', width: '326px', height: '507px' } }),
                    _react2.default.createElement('div', { className: 'clearfix' })
                );
            }
        }
    }, {
        key: 'switch',
        value: function _switch(mode) {
            this.setState({ mode: mode });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                { ref: 'modal', className: 'modal fade modal-fade-in-scale-up', id: 'aaa', 'aria-hidden': 'true', role: 'dialog', tabIndex: '-1' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-dialog modal-lg' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-content', style: { height: '1000px' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-header' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', onClick: function onClick(e) {
                                        e.stopPropagation();_this4.props.displayPreview();
                                    }, className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '\xD7'
                                )
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'modal-title' },
                                'Preview'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: ' 1px solid #e4eaec' } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-9 p-0' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-group input-group-icon' },
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'input-group-addon' },
                                                _react2.default.createElement('span', { className: 'icon wb-envelope', 'aria-hidden': 'true' })
                                            ),
                                            _react2.default.createElement('input', { type: 'text', value: this.state.email, onChange: this.changeEmail, className: 'form-control', placeholder: 'Email' })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-3' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', onClick: function onClick(e) {
                                                    e.stopPropagation();_this4.sendTest();
                                                }, className: 'btn-block btn btn-dark' },
                                            _react2.default.createElement('i', { className: 'icon wb-check', 'aria-hidden': 'true' }),
                                            ' Send test'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: ' 1px solid #e4eaec' } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-group col-sm-12', 'aria-label': 'Default button group', role: 'group' },
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                        return _this4.switch('desktop');
                                                    }, className: 'col-sm-6 btn btn-outline btn-default ' + (this.state.mode == 'desktop' ? 'current' : null) },
                                                'Desktop'
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                        return _this4.switch('mobile');
                                                    }, className: 'col-sm-6 btn btn-outline btn-default ' + (this.state.mode == 'mobile' ? 'current' : null) },
                                                'Mobile'
                                            )
                                        ),
                                        _react2.default.createElement('div', { className: 'clearfix' })
                                    )
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clearfix' }),
                            this.preview(),
                            _react2.default.createElement('div', { className: 'clearfix' })
                        )
                    )
                )
            );
        }
    }]);

    return Preview;
}(_react2.default.Component);

exports.default = Preview;

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Page = function () {
	function Page(r) {
		_classCallCheck(this, Page);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Page, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('backgroundColor')) {
				this.item.backgroundColor = '#ecf3f5';
			}

			if (!this.isset('padding')) {
				this.item.padding = '0px 0px 0px 0px';
			}

			if (!this.isset('font')) {
				this.item.type = 'inherit';
			}

			if (!this.isset('fontSize')) {
				this.item.fontSize = 'inherit';
			}

			if (!this.isset('color')) {
				this.item.color = 'inherit';
			}

			if (!this.isset('type')) {
				this.item.type = '';
			}

			if (!this.isset('subject')) {
				this.item.subject = '';
			}

			if (!this.isset('borderTop')) {
				this.item.borderTop = 'none';
			}

			if (!this.isset('borderBottom')) {
				this.item.borderBottom = 'none';
			}
		}
	}]);

	return Page;
}();

exports.default = Page;

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Element = function () {
	function Element(r) {
		_classCallCheck(this, Element);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Element, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('type')) {
				this.item.type = false;
			}

			if (!this.isset('rowId')) {
				this.item.rowId = false;
			}

			if (!this.isset('col')) {
				this.item.col = 1;
			}

			if (!this.isset('sorting')) {
				this.item.sorting = 1;
			}

			if (!this.isset('id')) {
				this.item.id = (0, _v2.default)();
			}
		}
	}]);

	return Element;
}();

exports.default = Element;

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = __webpack_require__(192);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactPopover = __webpack_require__(1456);

var _reactPopover2 = _interopRequireDefault(_reactPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleSelector = function (_React$Component) {
    _inherits(RuleSelector, _React$Component);

    function RuleSelector(props) {
        _classCallCheck(this, RuleSelector);

        var _this = _possibleConstructorReturn(this, (RuleSelector.__proto__ || Object.getPrototypeOf(RuleSelector)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.showSelector = _this.showSelector.bind(_this);
        _this.changeDropdown = _this.changeDropdown.bind(_this);
        _this.changeOptionValue = _this.changeOptionValue.bind(_this);
        _this.handleTextChange = _this.handleTextChange.bind(_this);

        _this.defaultState(props);

        return _this;
    }

    _createClass(RuleSelector, [{
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false
            };
        }
    }, {
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'changeOptionValue',
        value: function changeOptionValue(e, value) {
            e.stopPropagation();
            this.swapEdit();
        }
    }, {
        key: 'changeDropdown',
        value: function changeDropdown() {}
    }, {
        key: 'getLabelFromValue',
        value: function getLabelFromValue() {
            if (typeof this.props.options === 'undefined') {
                return this.props.value;
            } else {
                return _lodash2.default.find(this.props.options, { 'value': this.props.value }).value;
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange() {
            this.swapEdit();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (typeof this.props.options === 'undefined' && this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'showSelector',
        value: function showSelector() {
            var _this2 = this;

            if (this.state.isEditing == false) {
                return _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.getLabelFromValue()
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'popover bottom' },
                _react2.default.createElement('div', { className: 'arrow' }),
                _react2.default.createElement(
                    'h3',
                    { className: 'popover-title' },
                    'asd'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'close-btn' },
                    _react2.default.createElement('i', { className: 'icon wb-close' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'popover-content' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sed posuere consectetur est at lobortis. Aenean eu leo quam.'
                    )
                )
            );

            if (typeof this.props.options === 'undefined') {
                return _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', onKeyDown: this.handleTextChange, value: this.props.value })
                );
                //return <input type="text"  className="form-control" onKeyDown={this.handleTextChange} value={this.props.value} />
            }

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary dropdown-toggle btn-sm', id: 'exampleActiveDropdown', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.getLabelFromValue(),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'dropdown-menu', 'aria-labelledby': 'exampleActiveDropdown', role: 'menu' },
                    this.props.options.map(function (o) {
                        if (o.value == _this2.props.value) {
                            return _react2.default.createElement(
                                'li',
                                { key: o.value, onClick: function onClick(e) {
                                        return _this2.changeOptionValue(e, o.value);
                                    }, className: 'active', role: 'presentation' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    o.label
                                )
                            );
                        } else {
                            return _react2.default.createElement(
                                'li',
                                { key: o.value, onClick: function onClick(e) {
                                        return _this2.changeOptionValue(e, o.value);
                                    }, role: 'presentation' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    o.label
                                )
                            );
                        }
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                ' ',
                this.props.prepend,
                '\xA0',
                this.showSelector(),
                '\xA0',
                this.props.append
            );
        }
    }]);

    return RuleSelector;
}(_react2.default.Component);

exports.default = RuleSelector;

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleSendAfter = function (_React$Component) {
    _inherits(RuleSendAfter, _React$Component);

    function RuleSendAfter(props) {
        _classCallCheck(this, RuleSendAfter);

        var _this = _possibleConstructorReturn(this, (RuleSendAfter.__proto__ || Object.getPrototypeOf(RuleSendAfter)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.showSelector = _this.showSelector.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.defaultState(props);
        _this.displayValue = _this.displayValue.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.saveCustom = _this.saveCustom.bind(_this);
        _this.available = {
            '0': 'a couple of seconds',
            '1': '1 hour',
            '2': '2 hours',
            '3': '3 hours',
            '4': '4 hours',
            '5': '5 hours',
            '6': '6 hours',
            '7': '7 hours',
            '8': '8 hours',
            '9': '9 hours',
            '10': '10 hours',
            '11': '11 hours',
            '12': '12 hours',
            '13': '13 hours',
            '14': '14 hours',
            '15': '15 hours',
            '16': '16 hours',
            '17': '17 hours',
            '18': '18 hours',
            '19': '19 hours',
            '20': '20 hours',
            '21': '21 hours',
            '22': '22 hours',
            '23': '23 hours',
            '24': '1 day',
            '36': '1 1/2 days',
            '48': '2 days',
            '72': '3 days',
            '96': '4 days',
            '120': '5 days',
            '144': '6 days',
            '168': '1 week',
            '336': '2 weeks',
            '504': '3 weeks',
            '730': '1 month',
            '1460': '2 months',
            '2190': '3 months',
            '2920': '4 months',
            '3650': '5 months',
            '4380': '6 months',
            '5110': '7 months',
            '5840': '8 months',
            '6570': '9 months',
            '7300': '10 months',
            '8030': '11 months',
            '8760': '12 months'
        };

        return _this;
    }

    _createClass(RuleSendAfter, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'isCustom': false,
                'custom': ''
            };
        }
    }, {
        key: 'displayValue',
        value: function displayValue(value) {
            value = parseInt(value);

            if (this.available[value]) {
                return this.available[value];
            }

            return Math.round(parseInt(value) / 24) + ' days';
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.onlyDescription) {
                return;
            }
            if (this.props.rule.value == '') {
                this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': 4 });
            }
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(i) {
            this.swapEdit();
            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': i });
        }
    }, {
        key: 'saveCustom',
        value: function saveCustom(e) {
            e.stopPropagation();
            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': parseInt(this.state.custom) * 24 });
            this.setState({ 'isCustom': false, 'custom': '', isEditing: false });
        }
    }, {
        key: 'showSelector',
        value: function showSelector() {
            var _this2 = this;

            if (!this.state.isEditing) {
                return _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.displayValue(this.props.rule.value)
                );
            }

            if (this.state.isCustom) {
                return _react2.default.createElement(
                    'div',
                    { className: 'dropdown open' },
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                        this.state.custom == false ? 'Click here to add days' : this.displayValue(parseInt(this.state.custom) * 24),
                        _react2.default.createElement('span', { className: 'caret' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-menu' },
                        _react2.default.createElement(
                            'div',
                            { className: 'mega-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group' },
                                    _react2.default.createElement('input', { className: 'form-control', type: 'text', value: this.state.custom, onChange: function onChange(e) {
                                            _this2.setState({ 'custom': e.target.value });
                                        }, placeholder: 'Enter number of days' }),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'input-group-addon' },
                                        'days'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12 m-t-5 m-b-10' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-6 p-0 ' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-danger btn-block', onClick: function onClick() {
                                                _this2.setState({ 'isCustom': false, 'custom': '' });
                                            } },
                                        'Don\'t use custom'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-6 p-0 ' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-dark btn-block', onClick: this.saveCustom },
                                        'Save'
                                    )
                                )
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.displayValue(this.props.rule.value),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-submenu' },
                        _react2.default.createElement(
                            'a',
                            { href: 'javascript:void(0)', className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                            'Hours'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-menu', role: 'menu' },
                            Object.keys(this.available).map(function (i) {
                                if (i < 24) {
                                    return _react2.default.createElement(
                                        'a',
                                        { key: i, onClick: function onClick(e) {
                                                e.stopPropagation();_this2.handleOnChange(i);
                                            }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                                        _this2.available[i]
                                    );
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-submenu' },
                        _react2.default.createElement(
                            'a',
                            { href: 'javascript:void(0)', className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                            'Days'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-menu', role: 'menu' },
                            Object.keys(this.available).map(function (i) {
                                if (i >= 24 && i <= 144) {
                                    return _react2.default.createElement(
                                        'a',
                                        { key: i, onClick: function onClick(e) {
                                                e.stopPropagation();_this2.handleOnChange(i);
                                            }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                                        _this2.available[i]
                                    );
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-submenu' },
                        _react2.default.createElement(
                            'a',
                            { href: 'javascript:void(0)', className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                            'Weeks'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-menu', role: 'menu' },
                            Object.keys(this.available).map(function (i) {
                                if (i >= 146 && i <= 504) {
                                    return _react2.default.createElement(
                                        'a',
                                        { key: i, onClick: function onClick(e) {
                                                e.stopPropagation();_this2.handleOnChange(i);
                                            }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                                        _this2.available[i]
                                    );
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-submenu' },
                        _react2.default.createElement(
                            'a',
                            { href: 'javascript:void(0)', className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                            'Months'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-menu', role: 'menu' },
                            Object.keys(this.available).map(function (i) {
                                if (i > 504) {
                                    return _react2.default.createElement(
                                        'a',
                                        { key: i, onClick: function onClick(e) {
                                                e.stopPropagation();_this2.handleOnChange(i);
                                            }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                                        _this2.available[i]
                                    );
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', className: 'dropdown-item', role: 'button', onClick: function onClick() {
                                _this2.setState({ 'isCustom': true, 'custom': '' });
                            }, tabIndex: '-1' },
                        'Custom'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Display limit', description: 'Define how many times this popup should be shown to the same customer' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Send after ',
                this.showSelector()
            );
        }
    }]);

    return RuleSendAfter;
}(_react2.default.Component);

exports.default = RuleSendAfter;

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleListenForEvent = function (_React$Component) {
    _inherits(RuleListenForEvent, _React$Component);

    function RuleListenForEvent(props) {
        _classCallCheck(this, RuleListenForEvent);

        var _this = _possibleConstructorReturn(this, (RuleListenForEvent.__proto__ || Object.getPrototypeOf(RuleListenForEvent)).call(this, props));

        _this.displayValue = _this.displayValue.bind(_this);
        _this.available = {
            'NEW_ORDER': 'Send to customer when a new order is placed in your store',
            'CART_REMINDER': 'Send to customers who add products to cart, but don’t complete their purchase',
            'NO_PURCHASE': 'Send to customers who hasn\'t placed an order since last order',
            'BIRTHDAY': 'Send to customers when they have a birthday'
        };
        return _this;
    }

    _createClass(RuleListenForEvent, [{
        key: 'displayValue',
        value: function displayValue(value) {
            return this.available[value];
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.onlyDescription) {
                return _react2.default.createElement('li', null);
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement(
                    'div',
                    null,
                    this.displayValue(this.props.rule.value)
                )
            );
        }
    }]);

    return RuleListenForEvent;
}(_react2.default.Component);

exports.default = RuleListenForEvent;

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Operator = __webpack_require__(635);

var _Operator2 = _interopRequireDefault(_Operator);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleOrderSum = function (_React$Component) {
    _inherits(RuleOrderSum, _React$Component);

    function RuleOrderSum(props) {
        _classCallCheck(this, RuleOrderSum);

        var _this = _possibleConstructorReturn(this, (RuleOrderSum.__proto__ || Object.getPrototypeOf(RuleOrderSum)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(RuleOrderSum, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': value });
            this.setState({ value: value });

            if (e.key === 'Enter') {
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Display limit', description: 'Define how many times this popup should be shown to the same customer' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Send to customers where order sum ',
                _react2.default.createElement(_Operator2.default, { setGlobalTypeState: this.props.setGlobalTypeState, include: ['<=', '>='], rule: this.props.rule }),
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                )
            );
        }
    }]);

    return RuleOrderSum;
}(_react2.default.Component);

exports.default = RuleOrderSum;

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Operator = __webpack_require__(635);

var _Operator2 = _interopRequireDefault(_Operator);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleCartSum = function (_React$Component) {
    _inherits(RuleCartSum, _React$Component);

    function RuleCartSum(props) {
        _classCallCheck(this, RuleCartSum);

        var _this = _possibleConstructorReturn(this, (RuleCartSum.__proto__ || Object.getPrototypeOf(RuleCartSum)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(RuleCartSum, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': value });
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'Who', ruleKey: this.props.ruleKey, title: 'Cart sum', description: 'Define how many times this popup should be shown to the same customer' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Send to customers where cart sum ',
                _react2.default.createElement(_Operator2.default, { setGlobalTypeState: this.props.setGlobalTypeState, include: ['<=', '>='], rule: this.props.rule }),
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                )
            );
        }
    }]);

    return RuleCartSum;
}(_react2.default.Component);

exports.default = RuleCartSum;

/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RuleFollowUpEvent = function (_React$Component) {
    _inherits(RuleFollowUpEvent, _React$Component);

    function RuleFollowUpEvent(props) {
        _classCallCheck(this, RuleFollowUpEvent);

        return _possibleConstructorReturn(this, (RuleFollowUpEvent.__proto__ || Object.getPrototypeOf(RuleFollowUpEvent)).call(this, props));
    }

    _createClass(RuleFollowUpEvent, [{
        key: "render",
        value: function render() {
            if (this.props.onlyDescription) {
                return _react2.default.createElement("li", null);
            }
            return _react2.default.createElement(
                "div",
                { className: "list-group-item blue-grey-500" },
                _react2.default.createElement(
                    "div",
                    null,
                    "Send to customers who received e-mail id ",
                    _react2.default.createElement(
                        "strong",
                        null,
                        "#",
                        this.props.rule.value
                    )
                )
            );
        }
    }]);

    return RuleFollowUpEvent;
}(_react2.default.Component);

exports.default = RuleFollowUpEvent;

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SegmentsNew = __webpack_require__(390);

var _SegmentsNew2 = _interopRequireDefault(_SegmentsNew);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.editDropdown = _this.editDropdown.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        _this.changeDropdown = _this.changeDropdown.bind(_this);
        _this.createSegment = _this.createSegment.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'handleSave',
        value: function handleSave(segment) {
            this.setState({
                segment: segment
            });

            this.changeDropdown(segment.id);
        }
    }, {
        key: 'createSegment',
        value: function createSegment() {
            this.setState({
                createSegment: !this.state.createSegment
            });
        }
    }, {
        key: 'changeDropdown',
        value: function changeDropdown(value) {
            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': value });
            this.setState({ value: value });
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'displayText',
        value: function displayText(value) {
            if (this.state.isLoading) {
                return 'Loading..';
            }

            if (!this.state.segment) {
                return 'None';
            }

            return this.state.segment.name;
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.displayText(this.state.value),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.createSegment();
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'Create new segment'
                    ),
                    this.state.segment ? _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.createSegment();
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'Edit current segment'
                    ) : null
                )
            );
        }
    }, {
        key: 'editDropdown',
        value: function editDropdown() {
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditingDropdown': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value,
                'segment': false,
                'isLoading': true,
                'createSegment': false
            };
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            if (this.props.rule.value != 0) {
                _axios2.default.get('/segments/' + this.props.rule.value).then(function (res) {
                    _this3.setState({
                        isLoading: false,
                        segment: res.data
                    });
                });
            } else {
                this.setState({
                    isLoading: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement('li', null);
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Send to customers matching segment: \xA0',
                !this.state.isEditingDropdown ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this4.editDropdown(e);
                        }, className: 'selected-rule' },
                    this.displayText(this.props.rule.value)
                ) : this.renderDropdown(),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this4.setState({ createSegment: false });
                        }, isOpened: this.state.createSegment },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        { zIndex: '99999' },
                        _react2.default.createElement(_SegmentsNew2.default, { handleSave: this.handleSave, segmentId: this.state.segment ? this.state.segment.id : false, onClose: function onClose(e) {
                                _this4.setState({ createSegment: false });
                            } })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _constants = __webpack_require__(1484);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _reactDates = __webpack_require__(205);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Text = __webpack_require__(1539);

var _Text2 = _interopRequireDefault(_Text);

var _ProductPicker = __webpack_require__(1540);

var _ProductPicker2 = _interopRequireDefault(_ProductPicker);

var _ManufacturerPicker = __webpack_require__(385);

var _ManufacturerPicker2 = _interopRequireDefault(_ManufacturerPicker);

var _CategoryPicker = __webpack_require__(386);

var _CategoryPicker2 = _interopRequireDefault(_CategoryPicker);

var _NumberPicker = __webpack_require__(1541);

var _NumberPicker2 = _interopRequireDefault(_NumberPicker);

var _DayPicker = __webpack_require__(1542);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _GenderPicker = __webpack_require__(1543);

var _GenderPicker2 = _interopRequireDefault(_GenderPicker);

var _PopupPicker = __webpack_require__(1544);

var _PopupPicker2 = _interopRequireDefault(_PopupPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var components = {
    GenderPicker: _GenderPicker2.default,
    Text: _Text2.default,
    DayPicker: _DayPicker2.default,
    NumberPicker: _NumberPicker2.default,
    ProductPicker: _ProductPicker2.default,
    ManufacturerPicker: _ManufacturerPicker2.default,
    CategoryPicker: _CategoryPicker2.default,
    PopupPicker: _PopupPicker2.default
};

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.state = {
            initialStart: (0, _moment2.default)((0, _moment2.default)().subtract(30, 'days')),
            initialEnd: (0, _moment2.default)(),
            focusedInput: null,
            lastValidation: true
        };

        _this.renderValuePicker = _this.renderValuePicker.bind(_this);
        _this.handleLimitCheckbox = _this.handleLimitCheckbox.bind(_this);
        _this.parseDate = _this.parseDate.bind(_this);
        _this.onFocusChange = _this.onFocusChange.bind(_this);
        _this.onDatesChange = _this.onDatesChange.bind(_this);
        _this.handleAndCheckbox = _this.handleAndCheckbox.bind(_this);
        _this.renderAndTooltip = _this.renderAndTooltip.bind(_this);
        _this.relative_text = _this.relative_text.bind(_this);
        _this.handleRelativeCheckbox = _this.handleRelativeCheckbox.bind(_this);
        _this.handleRealtiveChange = _this.handleRealtiveChange.bind(_this);
        _this.drawAndOption = _this.drawAndOption.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: 'drawAndOption',
        value: function drawAndOption() {
            if (_constants.rule_settings[this.props.rule.key].has_and !== true) {
                return false;
            }

            if (_constants.rule_settings[this.props.rule.key].hide_and_rule === true && this.props.rule.operator == '!=') {
                return false;
            }

            return _react2.default.createElement(
                _rcTooltip2.default,
                { placement: 'top', overlay: _react2.default.createElement(
                        'span',
                        null,
                        this.renderAndTooltip()
                    ) },
                _react2.default.createElement(
                    'div',
                    { className: 'checkbox-custom checkbox-primary' },
                    _react2.default.createElement('input', { type: 'checkbox', id: this.props.rule.id + '-and-checkbox', checked: this.props.rule.is_and, onChange: this.handleAndCheckbox }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: this.props.rule.id + '-and-checkbox' },
                        ' Rule must match all values'
                    )
                )
            );
        }
    }, {
        key: 'handleRealtiveChange',
        value: function handleRealtiveChange(a, b, value) {
            this.props.handleRuleChange(this.props.index, 'relative', value);
        }
    }, {
        key: 'relative_text',
        value: function relative_text() {
            var _this2 = this;

            var html = [];

            _constants.rule_settings[this.props.rule.key].relative_text.split('%').map(function (item, index) {
                if (item == 'days') {
                    html.push(_react2.default.createElement(
                        'div',
                        { key: index, style: { width: '100px', marginTop: '-7px', marginRight: '5px', float: 'left', lineHeight: '32px', display: 'inline-block' } },
                        _react2.default.createElement(_DayPicker2.default, { disabled: _this2.props.rule.use_relative == '0' || _this2.props.rule.use_relative == '' || !_this2.props.rule.use_relative ? true : false, rule: { value: _this2.props.rule.relative == 0 || _this2.props.rule.relative == '' || !_this2.props.rule.relative ? 30 : _this2.props.rule.relative }, index: 0, handleRuleChange: _this2.handleRealtiveChange })
                    ));
                } else {
                    html.push(_react2.default.createElement(
                        'div',
                        { style: { marginTop: '-7px', marginRight: '5px', float: 'left', lineHeight: '36px', display: 'inline-block' }, key: index },
                        item
                    ));
                }
            });

            return html;
        }
    }, {
        key: 'parseDate',
        value: function parseDate(d, type) {
            if (typeof d === 'string') {
                if ((0, _moment2.default)(d, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                    d = (0, _moment2.default)(d);
                }
            }

            return d;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var validation = _constants.rule_settings[this.props.rule.key].validate(this.props.rule, this.props.rules);

            if (this.state.lastValidation != validation) {
                if (validation !== true) {
                    this.props.handleRuleError(true, this.props.rule.id, validation);
                } else {
                    this.props.handleRuleError(false, this.props.rule.id, true);
                }

                this.setState({
                    lastValidation: validation
                });
            }

            return validation !== true ? false : true;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.validate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.validate();
        }
    }, {
        key: 'renderAndTooltip',
        value: function renderAndTooltip() {
            var str = 'Currently matching';

            if (_typeof(this.props.rule.value) != 'object') {
                return str + ' nothing';
            }

            if (this.props.rule.value.length == 0) {
                return str + ' nothing';
            }

            var spacing = this.props.rule.is_and == 1 ? 'AND' : 'OR';

            return _react2.default.createElement(
                'span',
                null,
                'Currently matching \xA0',
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.rule.value.map(function (t, i) {
                        return _react2.default.createElement(
                            'span',
                            { key: 'and-name-' + t.id },
                            t.name
                        );
                    }).reduce(function (prev, curr) {
                        return [prev, _react2.default.createElement(
                            'strong',
                            { key: 'and-bold-' + prev.id },
                            ' ',
                            spacing,
                            ' '
                        ), curr];
                    })
                )
            );
        }
    }, {
        key: 'handleLimitCheckbox',
        value: function handleLimitCheckbox(e) {
            var value = false;

            if (e.target.checked) {
                value = true;
            }

            this.props.handleRuleChange(this.props.index, 'use_limit', value);
            this.props.handleRuleChange(this.props.index, 'from', null);
            this.props.handleRuleChange(this.props.index, 'to', null);
        }
    }, {
        key: 'handleAndCheckbox',
        value: function handleAndCheckbox(e) {
            var value = false;

            if (e.target.checked) {
                value = true;
            }

            this.props.handleRuleChange(this.props.index, 'is_and', value);
        }
    }, {
        key: 'handleRelativeCheckbox',
        value: function handleRelativeCheckbox(e) {
            var value = false;

            if (e.target.checked) {
                value = true;
            }

            this.props.handleRuleChange(this.props.index, 'use_relative', value);
        }
    }, {
        key: 'onDatesChange',
        value: function onDatesChange(_ref) {
            var startDate = _ref.startDate,
                endDate = _ref.endDate;

            if (startDate) {
                this.props.handleRuleChange(this.props.index, 'from', startDate.format('YYYY-MM-DD HH:mm:ss'));
            }
            if (endDate) {
                this.props.handleRuleChange(this.props.index, 'to', endDate.format('YYYY-MM-DD HH:mm:ss'));
            }
        }
    }, {
        key: 'onFocusChange',
        value: function onFocusChange(focusedInput) {
            this.setState({ focusedInput: focusedInput });
        }
    }, {
        key: 'renderValuePicker',
        value: function renderValuePicker() {
            var _this3 = this;

            var Comp = components[_constants.rule_settings[this.props.rule.key].value_type];
            return _react2.default.createElement(Comp, { handleRuleChange: function handleRuleChange(index, operator, value) {
                    return _this3.props.handleRuleChange(_this3.props.index, 'value', value);
                }, rule: this.props.rule, index: this.props.index, key: this.props.rule.id });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var borderColor = {
                border: this.state.lastValidation !== true ? '1px solid #f96868' : '1px solid #e4eaec'
            };

            return _react2.default.createElement(
                'li',
                { className: 'timeline-item timeline-reverse' },
                _react2.default.createElement(
                    'div',
                    { className: 'timeline-dot bg-blue-grey-800' },
                    _react2.default.createElement('i', { className: 'icon wb-chevron-right', 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'timeline-content text-left' },
                    _react2.default.createElement(
                        'div',
                        { className: 'card card-article card-shadow', style: borderColor },
                        this.state.lastValidation !== true ? _react2.default.createElement(
                            'div',
                            { style: { position: 'absolute',
                                    top: '-15px',
                                    left: '20px',
                                    borderRadius: '4px',
                                    backgroundColor: '#f96868',
                                    color: '#fff',
                                    padding: '3px',
                                    paddingLeft: '10px',
                                    paddingRight: '10px' } },
                            this.state.lastValidation
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'card-block' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-5' },
                                    _react2.default.createElement(_reactSelect2.default, {
                                        allowCreate: false,
                                        searchable: false,
                                        clearable: false,
                                        name: 'form-field-name',
                                        value: this.props.rule.key,
                                        options: (0, _constants.rule_selector)(),
                                        onChange: function onChange(e) {
                                            return _this4.props.handleRuleChange(_this4.props.index, 'key', e.value);
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-3' },
                                    _react2.default.createElement(_reactSelect2.default, {
                                        allowCreate: false,
                                        searchable: false,
                                        clearable: false,
                                        name: 'form-field-name',
                                        value: this.props.rule.operator,
                                        options: (0, _constants.operator_selector)(this.props.rule.key),
                                        onChange: function onChange(e) {
                                            return _this4.props.handleRuleChange(_this4.props.index, 'operator', e.value);
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-4' },
                                    this.renderValuePicker()
                                ),
                                _react2.default.createElement('hr', { style: {
                                        clear: 'both',
                                        marginTop: '50px',
                                        marginBottom: ' 9px'
                                    } }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-10 p-0' },
                                        _constants.rule_settings[this.props.rule.key].date_range && this.props.exportable == '1' ? _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-4 p-0' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'checkbox-custom checkbox-primary' },
                                                _react2.default.createElement('input', { type: 'checkbox', id: this.props.rule.id + '-checkbox', checked: this.props.rule.use_limit, onChange: this.handleLimitCheckbox }),
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: this.props.rule.id + '-checkbox' },
                                                    ' Limit condition by date range'
                                                )
                                            )
                                        ) : null,
                                        _constants.rule_settings[this.props.rule.key].has_relative === true && this.props.exportable != '1' ? _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-12 p-0' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'checkbox-custom checkbox-primary' },
                                                _react2.default.createElement('input', { style: { float: 'left' }, type: 'checkbox', id: this.props.rule.id + '-relative-checkbox', checked: this.props.rule.use_relative, onChange: this.handleRelativeCheckbox }),
                                                _react2.default.createElement('label', { style: { float: 'left' }, htmlFor: this.props.rule.id + '-relative-checkbox' }),
                                                _react2.default.createElement(
                                                    'div',
                                                    { style: { float: 'left', marginLeft: '10px' } },
                                                    this.relative_text()
                                                )
                                            )
                                        ) : null,
                                        this.props.rule.use_limit && _constants.rule_settings[this.props.rule.key].date_range ? _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-8 p-0' },
                                            _react2.default.createElement(_reactDates.DateRangePicker, {
                                                onDatesChange: this.onDatesChange,
                                                onFocusChange: this.onFocusChange,
                                                focusedInput: this.state.focusedInput,
                                                startDateId: 'start_date',
                                                endDateId: 'end_date',
                                                small: true,
                                                startDate: this.parseDate(this.props.rule.from, 'from'),
                                                endDate: this.parseDate(this.props.rule.to, 'to'),
                                                isOutsideRange: function isOutsideRange() {
                                                    return false;
                                                },
                                                anchorDirection: 'left',
                                                showDefaultInputIcon: true
                                            })
                                        ) : null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-4 p-0' },
                                            this.drawAndOption()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card-actions pull-xs-right' },
                                        _react2.default.createElement(
                                            'a',
                                            { onClick: function onClick(e) {
                                                    return _this4.props.remove(_this4.props.rule.id);
                                                }, href: 'javascript:void(0)' },
                                            _react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rule_selector = exports.rule_selector = function rule_selector() {
    var ret = [];
    Object.keys(rule_settings).map(function (key) {
        ret.push({
            clearableValue: false,
            label: rule_settings[key].text,
            value: key
        });
    });

    return ret;
};

var stand_alone_error = "This rule can't be used alone. It needs to be combined with a rule that does more visitor filtering.";

var operator_selector = exports.operator_selector = function operator_selector(current_key) {
    var ret = [];

    var available = rule_settings[current_key]['operators'];

    Object.keys(available).map(function (key) {
        ret.push({
            clearableValue: false,
            label: available[key],
            value: key
        });
    });

    return ret;
};

var operators = exports.operators = {
    '==': {
        text: 'equals'
    },
    '!=': {
        text: 'not equals'
    },
    '>=': {
        text: 'greater than'
    },
    '<=': {
        text: 'less than'
    },
    '%%': {
        text: 'contains'
    }
};

var str = {
    eq: 'equals',
    neq: 'not equals',
    gt: 'greater or equal to',
    lt: 'less or equal to',
    c: 'contains'
};

var rule_settings = exports.rule_settings = {
    'BoughtFromCategory': {
        text: 'Has/Has not Bought from Category',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought'
        },
        value_type: 'CategoryPicker',
        relative_text: 'Customer must have bought item(s) %days% ago',
        date_range: true,
        has_relative: true,
        has_and: true,
        hide_and_rule: true,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one category";
            }

            return true;
        }

    },
    'BoughtManufacturer': {
        text: 'Has/Has not Bought Manufacturer',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought'
        },
        value_type: 'ManufacturerPicker',
        relative_text: 'Customer must have bought item(s) %days% ago',
        date_range: true,
        has_relative: true,
        has_and: true,
        hide_and_rule: true,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == '' || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one manufacturer";
            }

            return true;
        }
    },

    'BoughtProduct': {
        text: 'Has/Has not Bought Product',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought'
        },
        value_type: 'ProductPicker',
        relative_text: 'Customer must have bought item(s) %days% ago',
        date_range: true,
        has_relative: true,
        has_and: true,
        hide_and_rule: true,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one product";
            }

            return true;
        }
    },

    'BrowsedCategory': {
        text: 'Has browsed Category',
        operators: {
            '==': 'has browsed'
        },
        value_type: 'CategoryPicker',
        relative_text: 'Customer has browsed category %days% ago',
        date_range: true,
        has_relative: true,
        has_and: true,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one category";
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'BrowsedProduct': {
        text: 'Has seen Product',
        operators: {
            '==': 'has seen'
        },
        value_type: 'ProductPicker',
        relative_text: 'Customer has seen product(s) %days% ago',
        date_range: true,
        has_relative: true,
        has_and: true,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one product";
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'PopupSubscriber': {
        text: 'Subscribed to popup',
        operators: {
            '==': 'is subscribing to'
        },
        value_type: 'PopupPicker',
        date_range: false,
        has_relative: false,
        has_and: false,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one popup";
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'LastOrder': {
        text: 'Last order order placed',
        operators: {
            '>=': 'for more than'
        },
        value_type: 'DayPicker',
        date_range: false,
        has_and: false,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (parseInt(rule.value) <= 0 || !rule.value) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    },

    'LastSeen': {
        text: 'Last seen in store',
        operators: {
            '>=': 'for more than'
        },
        value_type: 'DayPicker',
        date_range: false,
        has_and: false,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Sessions': {
        text: 'Number of store sessions is',
        operators: {
            '==': str.eq,
            '>=': str.gt,
            '<=': str.lt
        },
        value_type: 'NumberPicker',
        date_range: false,
        has_and: false,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Age': {
        text: 'Customers age is',
        operators: {
            '<=': 'younger than',
            '>=': 'older than'
        },
        value_type: 'NumberPicker',
        date_range: false,
        has_and: false,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Gender': {
        text: 'Customers gender is',
        operators: {
            '==': 'equal to'
        },
        value_type: 'GenderPicker',
        date_range: false,
        has_and: false,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'OrderSum': {
        text: 'Total generated order sum is',
        operators: {
            '==': str.eq,
            '!=': str.neq,
            '>=': str.gt,
            '<=': str.lt
        },
        value_type: 'NumberPicker',
        date_range: true,
        has_and: false,
        stand_alone: true,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if (parseInt(rule.value) <= 0 || !rule.value) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    },

    'OrderCount': {
        text: 'Number of orders placed in store is',
        operators: {
            '==': str.eq,
            '!=': str.neq,
            '>=': str.gt,
            '<=': str.lt
        },
        value_type: 'NumberPicker',
        date_range: true,
        has_and: false,
        stand_alone: false,
        validate: function validate(rule, rules) {
            if (rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }
            if (parseInt(rule.value) <= 0 && !hasStandAlonerule(rules)) {
                return stand_alone_error;
            }
            if (!rule.value && rule.value !== 0) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    }
};

function hasStandAlonerule(rules) {
    var res = false;
    for (var i in rules) {
        if (rule_settings[rules[i].key].stand_alone === true) {
            res = true;
        }
    }

    return res;
}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSmall = function LoadingSmall() {
	return _react2.default.createElement(
		"div",
		{ className: "col-sm-12" },
		_react2.default.createElement(
			"div",
			{ className: "loading-small-squeeze text-center" },
			_react2.default.createElement("span", null),
			_react2.default.createElement("span", null),
			_react2.default.createElement("span", null),
			_react2.default.createElement("span", null),
			_react2.default.createElement("span", null)
		)
	);
};

exports.default = LoadingSmall;

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = function (_React$Component) {
    _inherits(Text, _React$Component);

    function Text(props) {
        _classCallCheck(this, Text);

        return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props));
    }

    _createClass(Text, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement("input", { className: "form-control" })
            );
        }
    }]);

    return Text;
}(_react2.default.Component);

exports.default = Text;

/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.state = {
            isLoading: true,
            value: 'chocolate',
            initialProducts: {}
        };

        _this.getOptions = _this.getOptions.bind(_this);
        _this.parseValue = _this.parseValue.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: 'handleSelectChange',
        value: function handleSelectChange(value) {
            console.dir(value);
            console.log('You\'ve selected:', value);
            this.setState({ value: value });
        }
    }, {
        key: 'parseValue',
        value: function parseValue(values) {
            var _this2 = this;

            if (typeof values == 'string') {
                var ret = [];
                values.split(',').map(function (value) {
                    ret.push({
                        id: value,
                        name: _this2.state.initialProducts[value]
                    });
                });
                return ret;
            }

            return values;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            if (!this.props.rule.value || this.props.rule.value == '') {
                this.setState({ isLoading: false });
                return true;
            }

            _axios2.default.get('/products?product_id=' + this.props.rule.value).then(function (res) {
                var products = {};
                var values = [];

                res.data.map(function (p) {
                    products[p.product_id] = p.name;
                    values.push({
                        id: p.product_id,
                        name: p.name
                    });
                });

                _this3.props.handleRuleChange(_this3.props.index, 'operator', values);

                _this3.setState({
                    isLoading: false,
                    initialProducts: products
                });
            });
        }
    }, {
        key: 'getOptions',
        value: function getOptions(value) {
            var param = 'product_id=' + this.props.rule.value;

            if (value) {
                param = 'name=' + value;
            }
            return _axios2.default.get('/products?' + param).then(function (res) {
                res.data = res.data.map(function (p) {
                    p.id = p.product_id;
                    return p;
                });
                return { options: res.data };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                null,
                this.state.isLoading ? null : _react2.default.createElement(_reactSelect2.default.Async, {

                    autoload: true,
                    valueKey: 'product_id',
                    labelKey: 'name',
                    simpleValue: false,
                    multi: true,
                    name: 'form-field-name',
                    value: this.parseValue(this.props.rule.value),
                    loadOptions: this.getOptions,
                    onChange: function onChange(e) {
                        return _this4.props.handleRuleChange(_this4.props.index, 'operator', e);
                    }
                })
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.minus = _this.minus.bind(_this);
        _this.plus = _this.plus.bind(_this);
        _this.getValue = _this.getValue.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: 'minus',
        value: function minus(e) {
            e.stopPropagation();
            var newVal = parseInt(this.props.rule.value);
            newVal--;
            if (newVal < 0) {
                newVal = 0;
            }

            this.onChange(newVal);
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            var newVal = this.props.rule.value;

            if (!isNaN(parseFloat(this.props.rule.value)) && isFinite(this.props.rule.value)) {
                newVal = parseInt(this.props.rule.value);
            } else {
                newVal = 0;
            }

            return newVal;
        }
    }, {
        key: 'plus',
        value: function plus(e) {
            e.stopPropagation();
            var newVal = this.getValue();
            newVal++;
            this.onChange(newVal);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var val = e.target.value;
            this.onChange(val);
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur(e) {
            var val = e.target.value;

            if (val < 0) {
                val = 0;
            }

            this.onChange(val);
        }
    }, {
        key: 'onChange',
        value: function onChange(val) {
            this.props.handleRuleChange(this.props.index, 'value', val);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'input-group' },
                _react2.default.createElement(
                    'span',
                    { className: 'input-group-btn' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-outline btn-default', onClick: this.minus, type: 'button' },
                        _react2.default.createElement('i', { className: 'wb-minus' })
                    )
                ),
                _react2.default.createElement('input', { type: 'text', className: 'form-control', onBlur: this.handleBlur, onChange: this.handleChange, value: this.getValue(), style: { textAlign: 'center' } }),
                _react2.default.createElement(
                    'span',
                    { className: 'input-group-btn' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.plus, className: 'btn btn-outline btn-default', type: 'button' },
                        _react2.default.createElement('i', { className: 'wb-plus' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.getOptions = _this.getOptions.bind(_this);

        return _this;
    }

    _createClass(Rule, [{
        key: 'getOptions',
        value: function getOptions() {
            var ret = [{
                clearableValue: false,
                label: '1 day',
                value: 1
            }];

            for (var i = 2; i <= 29; i++) {
                ret.push({
                    clearableValue: false,
                    label: i + ' days',
                    value: i
                });
            }

            ret.push({
                clearableValue: false,
                label: '1 month',
                value: 30
            });

            for (var _i = 2; _i <= 12; _i++) {
                ret.push({
                    clearableValue: false,
                    label: _i + ' months',
                    value: parseInt(_i * 30)
                });
            }

            return ret;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactSelect2.default, {
                    disabled: this.props.disabled === true ? true : false,
                    clearable: false,
                    name: 'form-field-name',
                    value: parseInt(this.props.rule.value),
                    options: this.getOptions(),
                    onChange: function onChange(e) {
                        _this2.props.handleRuleChange(_this2.props.index, 'operator', e.value);
                    }
                })
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenderPicker = function (_React$Component) {
    _inherits(GenderPicker, _React$Component);

    function GenderPicker(props) {
        _classCallCheck(this, GenderPicker);

        var _this = _possibleConstructorReturn(this, (GenderPicker.__proto__ || Object.getPrototypeOf(GenderPicker)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.parseValue = _this.parseValue.bind(_this);
        return _this;
    }

    _createClass(GenderPicker, [{
        key: 'parseValue',
        value: function parseValue(value) {
            if (value == '' || value == 'false' || !value) {
                value = 'male';
            }

            return value;
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.handleRuleChange(this.props.index, 'value', e.target.value);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'select',
                    { className: 'form-control', value: this.parseValue(this.props.rule.value), onChange: this.handleChange },
                    _react2.default.createElement(
                        'option',
                        { value: 'male' },
                        'Male'
                    ),
                    _react2.default.createElement(
                        'option',
                        { value: 'female' },
                        'Female'
                    )
                )
            );
        }
    }]);

    return GenderPicker;
}(_react2.default.Component);

exports.default = GenderPicker;

/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.state = {
            isLoading: true,
            value: 'chocolate',
            initialProducts: {}
        };

        _this.getOptions = _this.getOptions.bind(_this);
        _this.parseValue = _this.parseValue.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.fetchData = _this.fetchData.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: 'handleSelectChange',
        value: function handleSelectChange(value) {
            console.dir(value);
            console.log('You\'ve selected:', value);
            this.setState({ value: value });
        }
    }, {
        key: 'parseValue',
        value: function parseValue(values) {
            var _this2 = this;

            if (typeof values == 'string') {
                var ret = [];
                values.split(',').map(function (value) {
                    ret.push({
                        id: value,
                        name: _this2.state.initialProducts[value]
                    });
                });
                return ret;
            }

            return values;
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var _this3 = this;

            if (this.props.rule.value === false || this.props.rule.value == 'false') {
                this.setState({ isLoading: false });
                return;
            }
            _axios2.default.get('/popups?id=' + this.props.rule.value).then(function (res) {
                var products = {};

                res.data.map(function (p) {
                    products[p.id] = p.name;
                });

                _this3.setState({
                    isLoading: false,
                    initialProducts: products
                });
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.rule.id != prevProps.rule.id) {
                this.setState({ isLoading: true });
                this.fetchData();
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.props.rule.value || this.props.rule.value == '') {
                this.setState({ isLoading: false });
                return true;
            }

            this.fetchData();
        }
    }, {
        key: 'getOptions',
        value: function getOptions(value) {
            var _this4 = this;

            var param = 'id=' + this.props.rule.value;

            if (value) {
                param = 'name=' + value;
            }
            return _axios2.default.get('/popups?' + param).then(function (res) {
                var products = _extends({}, _this4.state.initialProducts);

                for (var i in res.data) {
                    products[res.data[i].id] = res.data[i].name;
                }

                _this4.setState({
                    initialProducts: products
                });

                return { options: res.data };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            return _react2.default.createElement(
                'div',
                null,
                this.state.isLoading ? null : _react2.default.createElement(_reactSelect2.default.Async, {

                    autoload: true,
                    valueKey: 'id',
                    labelKey: 'name',
                    simpleValue: false,
                    multi: true,
                    name: 'form-field-name',
                    value: this.parseValue(this.props.rule.value),
                    loadOptions: this.getOptions,
                    onChange: function onChange(e) {
                        return _this5.props.handleRuleChange(_this5.props.index, 'operator', e);
                    }
                })
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelToken = _axios2.default.CancelToken;
var cancel = void 0;

var AudiencePicker = function (_React$Component) {
    _inherits(AudiencePicker, _React$Component);

    function AudiencePicker(props) {
        _classCallCheck(this, AudiencePicker);

        var _this = _possibleConstructorReturn(this, (AudiencePicker.__proto__ || Object.getPrototypeOf(AudiencePicker)).call(this, props));

        _this.state = {
            'isLoading': true,
            'audiences': [],
            'error': false,
            'isCreating': false,
            'audiance_name': ''
        };

        _this.buildAudienceList = _this.buildAudienceList.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onInteractionChange = _this.onInteractionChange.bind(_this);
        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.addToList = _this.addToList.bind(_this);
        return _this;
    }

    _createClass(AudiencePicker, [{
        key: 'addToList',
        value: function addToList() {
            var _this2 = this;

            this.setState({
                isLoading: true,
                isCreating: false
            });

            _axios2.default.post('/apps/FacebookAds/CreateAudience', { name: this.state.audiance_name }).then(function (res) {
                _this2.getAudience();
            });
        }
    }, {
        key: 'handleNameChange',
        value: function handleNameChange(e) {
            this.setState({ audiance_name: e.target.value });
        }
    }, {
        key: 'onInteractionChange',
        value: function onInteractionChange(e) {
            this.props.change('remove_on_interaction', e.target.checked);
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.props.change('audience_id', e);
        }
    }, {
        key: 'getAudience',
        value: function getAudience() {
            var _this3 = this;

            _axios2.default.get('/apps/FacebookAds/GetAudiences').then(function (res) {

                if (res.data.success === false) {
                    _this3.setState({
                        isLoading: false,
                        error: res.data.message
                    });
                } else {
                    _this3.setState({
                        isLoading: false,
                        audiences: res.data
                    });
                }
            });
        }
    }, {
        key: 'buildAudienceList',
        value: function buildAudienceList() {
            var list = [];

            this.state.audiences.map(function (item) {
                list.push({
                    'label': item.name,
                    'value': item.id
                });
            });

            return list;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getAudience();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                );
            }

            if (this.state.error !== false) {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger alert-dismissible', role: 'alert' },
                        this.state.error
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-10 offset-sm-2' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    _react2.default.createElement(_reactSelect2.default, {
                        value: this.props.segment.audience_id,
                        onChange: this.onChange,
                        options: this.buildAudienceList(),
                        placeholder: 'Select an existing audience',
                        simpleValue: true
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    this.state.isCreating === false ? _react2.default.createElement(
                        'button',
                        { className: 'btn btn-block btn-dark', onClick: function onClick() {
                                _this4.setState({ isCreating: true, audiance_name: '' });
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-plus' }),
                        ' Or create a new audience'
                    ) : _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { type: 'text', ref: 'audiance_name', placeholder: 'My new custom audiance', value: this.state.audiance_name, onChange: this.handleNameChange, className: 'form-control' }),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-block btn-dark', onClick: this.addToList },
                            'Add to list'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox-custom checkbox-primary' },
                        _react2.default.createElement('input', { type: 'checkbox', checked: this.props.segment.remove_on_interaction, onChange: this.onInteractionChange }),
                        _react2.default.createElement(
                            'label',
                            null,
                            ' Remove from audience on customer interaction'
                        )
                    )
                )
            );
        }
    }]);

    return AudiencePicker;
}(_react2.default.Component);

exports.default = AudiencePicker;

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': value });

            this.setState({ value: value });

            if (e.key === 'Enter') {
                if (value == '') {
                    this.props.setGlobalTypeState('rules', this.props.rule.id, { 'value': 'No value' });
                    this.setState({ value: 'No value' });
                }
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement('li', null);
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Send e-mail to customer when event \xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 is triggered.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StopOn = function (_React$Component) {
    _inherits(StopOn, _React$Component);

    function StopOn(props) {
        _classCallCheck(this, StopOn);

        var _this = _possibleConstructorReturn(this, (StopOn.__proto__ || Object.getPrototypeOf(StopOn)).call(this, props));

        _this.types = [{
            'key': 'NewOrder',
            'description': 'Customer placed an order'
        }];

        _this.renderOption = _this.renderOption.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);

        return _this;
    }

    _createClass(StopOn, [{
        key: 'handleChange',
        value: function handleChange(e) {
            var key = e.target.getAttribute('data-key');
            var data = this.props.data.split(',');

            if (data.includes(key)) {
                data = data.filter(function (item) {
                    return item == key ? false : true;
                });
            } else {
                data.push(key);
            }

            this.props.save(data.join(','));
        }
    }, {
        key: 'renderOption',
        value: function renderOption(type) {
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500', key: type.key },
                _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block', marginRight: '10px' }, className: 'checkbox-custom checkbox-primary' },
                    _react2.default.createElement('input', { type: 'checkbox', id: 'stop_followup_on_' + type.key, 'data-key': type.key, onChange: this.handleChange, checked: this.props.data.split(',').includes(type.key) }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'stop_followup_on_' + type.key },
                        type.description
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                this.types.map(function (type) {
                    return _this2.renderOption(type);
                })
            );
        }
    }]);

    return StopOn;
}(_react2.default.Component);

exports.default = StopOn;

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailListPicker = function (_React$Component) {
    _inherits(EmailListPicker, _React$Component);

    function EmailListPicker(props) {
        _classCallCheck(this, EmailListPicker);

        var _this = _possibleConstructorReturn(this, (EmailListPicker.__proto__ || Object.getPrototypeOf(EmailListPicker)).call(this, props));

        _this.isLoading = function (val) {
            _this.props.handleLoadingChange(val);
        };

        _this.state = {
            'isLoading': true,
            'lists': [],
            'error': false,
            'isCreating': false,
            'list_name': ''
        };

        _this.currentList = _this.currentList.bind(_this);
        _this.subscriberCount = _this.subscriberCount.bind(_this);
        _this.onChange = _this.onChange.bind(_this);

        return _this;
    }

    _createClass(EmailListPicker, [{
        key: 'onChange',
        value: function onChange(e) {
            this.props.handleChangeList(e);
        }
    }, {
        key: 'subscriberCount',
        value: function subscriberCount() {
            var list = this.currentList();

            if (!list) {
                return 0;
            }

            return list.subscribers_count;
        }
    }, {
        key: 'getLists',
        value: function getLists() {
            var _this2 = this;

            this.isLoading(true);
            _axios2.default.get('/newsletters/lists').then(function (res) {
                _this2.isLoading(false);
                _this2.setState({
                    isLoading: false,
                    lists: res.data
                });
            });
        }
    }, {
        key: 'buildList',
        value: function buildList() {
            var list = [];

            this.state.lists.map(function (item) {
                list.push({
                    'label': item.name,
                    'value': item.id
                });
            });

            return list;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getLists();
        }
    }, {
        key: 'currentList',
        value: function currentList() {

            for (var i in this.state.lists) {
                if (this.props.listId == this.state.lists[i].id) {
                    return this.state.lists[i];
                }
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                );
            }

            if (this.state.error !== false) {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger alert-dismissible', role: 'alert' },
                        this.state.error
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement(_reactSelect2.default, {
                        value: parseInt(this.props.listId),
                        onChange: this.onChange,
                        options: this.buildList(),
                        placeholder: 'Select an existing audience',
                        simpleValue: true
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4 text-center' },
                    this.subscriberCount(),
                    _react2.default.createElement('br', null),
                    'Subscribers'
                )
            );
        }
    }]);

    return EmailListPicker;
}(_react2.default.Component);

exports.default = EmailListPicker;

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDates = __webpack_require__(205);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimePicker = function (_React$Component) {
    _inherits(DateTimePicker, _React$Component);

    function DateTimePicker(props) {
        _classCallCheck(this, DateTimePicker);

        var _this = _possibleConstructorReturn(this, (DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call(this, props));

        _this.pushChange = function (date) {
            _this.props.handleDateChange(date);
        };

        _this.handleCheckChange = function (e) {
            _this.props.handleCheckChange(!_this.props.isChecked);
        };

        _this.handleHourChange = function (e) {
            var date = (0, _moment2.default)(_this.props.date).hour(e.target.value).second(0);
            _this.pushChange(date);
        };

        _this.handleMinuteChange = function (e) {
            var date = (0, _moment2.default)(_this.props.date).minute(e.target.value).second(0);
            _this.pushChange(date);
        };

        _this.getHourFromDate = function () {
            return _this.props.date.hour();
        };

        _this.getMinuteFromDate = function () {
            return _this.props.date.minute();
        };

        _this.state = {
            focused: false
        };

        _this.handleDateChange = _this.handleDateChange.bind(_this);
        _this.hours = _this.hours.bind(_this);
        return _this;
    }

    _createClass(DateTimePicker, [{
        key: 'handleDateChange',
        value: function handleDateChange(d) {
            var date = d.hour(this.props.date.hour()).minute(this.props.date.minute());
            this.pushChange(date);
        }
    }, {
        key: 'hours',
        value: function hours() {
            var ret = [];

            for (var i = 0; i <= 23; i++) {
                if (i.toString().length == 1) {
                    i = '0' + i.toString();
                }
                ret.push(_react2.default.createElement(
                    'option',
                    { key: i, value: i },
                    i
                ));
            }

            return ret;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    _react2.default.createElement(_reactDates.SingleDatePicker, {
                        disabled: !this.props.isChecked,
                        displayFormat: 'MMMM Do YYYY',
                        small: true,
                        block: true,
                        date: this.props.date,
                        onDateChange: this.handleDateChange,
                        focused: this.state.focused,
                        onFocusChange: function onFocusChange(_ref) {
                            var focused = _ref.focused;
                            return _this2.setState({ focused: focused });
                        }
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    _react2.default.createElement(
                        'table',
                        { style: { width: '100%' } },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control input-lg', value: this.getHourFromDate(), onChange: this.handleHourChange, disabled: !this.props.isChecked },
                                        this.hours()
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    '\xA0:'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control input-lg', value: this.getMinuteFromDate(), onChange: this.handleMinuteChange, disabled: !this.props.isChecked },
                                        _react2.default.createElement(
                                            'option',
                                            { value: '00' },
                                            '00'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: '15' },
                                            '15'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: '30' },
                                            '30'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: '45' },
                                            '45'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return DateTimePicker;
}(_react2.default.Component);

exports.default = DateTimePicker;

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _Spin2Win = __webpack_require__(252);

var _Spin2Win2 = _interopRequireDefault(_Spin2Win);

var _Nav = __webpack_require__(369);

var _Nav2 = _interopRequireDefault(_Nav);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picker = function (_React$Component) {
    _inherits(Picker, _React$Component);

    function Picker(props) {
        _classCallCheck(this, Picker);

        var _this = _possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

        _this.getRedirectLink = function () {
            if (!_this.isUsingFlows()) {
                return _General2.default.Link(_this.emailOrPopup());
            }

            return _General2.default.Link2("/popups");
        };

        _this.state = {
            'selectedStep1': false,
            'selectedStep2': false,
            'selectedStep3': false,
            'isLoading': true,
            'askUpgrade': false,
            'categories': []
        };

        contextTypes: {
            router: _react2.default.PropTypes.object.isRequired;
        }

        _this.onSelect = _this.onSelect.bind(_this);
        _this.currentStep = _this.currentStep.bind(_this);
        _this.validate = _this.validate.bind(_this);
        _this.restart = _this.restart.bind(_this);

        return _this;
    }

    _createClass(Picker, [{
        key: 'restart',
        value: function restart() {
            this.props.router.push(_General2.default.Link('/builder/' + this.props.router.params.type + '/picker/1'));
        }
    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            _axios2.default.get('/picker/' + this.props.router.params.type).then(function (response) {
                _this2.setState({ 'categories': response.data, 'isLoading': false });
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'currentStep',
        value: function currentStep() {
            return parseInt(this.props.router.routes[this.props.router.routes.length - 1].path);
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            var next = this.currentStep() + 1;
            if (typeof this.state['selectedStep' + next] === 'undefined') {
                next = false;
            }
            return next;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var previousSteps = this.currentStep() - 1;
            for (var i = 1; i <= previousSteps; i++) {
                if (this.state['selectedStep' + i] == false) {
                    return i;
                }
            }

            return true;
        }
    }, {
        key: 'onSelect',
        value: function onSelect(val) {
            var _this3 = this;

            if (val == 3 && this.currentStep() == 1) {
                if (this.props.general.settings.PACKAGE_OC != '1' && this.props.general.settings.PACKAGE_EMAIL != '1') {
                    this.setState({ askUpgrade: true });
                    return;
                }
            }

            if (this.props.router.params.type == 'email' && this.currentStep() == 2) {
                if (this.props.general.settings.PACKAGE_EMAIL != '1') {
                    this.setState({ askUpgrade: true });
                    return;
                }
            }

            if (this.props.router.params.type == 'popup' && this.currentStep() == 2) {
                if (this.props.general.settings.PACKAGE_POPUP != '1') {
                    this.setState({ askUpgrade: true });
                    return;
                }
            }

            var step_state = _extends({}, this.state, _defineProperty({}, 'selectedStep' + this.currentStep(), val));

            //skip step two for email segemnts
            if (this.props.router.params.type == 'email' && this.currentStep() == 1 && val == 9) {
                if (this.props.general.settings.PACKAGE_SEGMENTS != '1') {
                    this.setState({ askUpgrade: true });
                    return;
                } else {
                    step_state['selectedStep2'] = '-';
                    this.setState(step_state);
                    this.props.router.push(_General2.default.Link('/builder/' + this.props.router.params.type + '/picker/3'));
                    return;
                }
            }

            //skip step two for email triggers
            if (this.props.router.params.type == 'email' && this.currentStep() == 1 && val == 10) {
                if (this.props.general.settings.PACKAGE_TRIGGERS != '1') {
                    this.setState({ askUpgrade: true });
                    return;
                } else {
                    step_state['selectedStep2'] = '-';
                    this.setState(step_state);
                    this.props.router.push(_General2.default.Link('/builder/' + this.props.router.params.type + '/picker/3'));
                    return;
                }
            }

            this.setState(step_state);

            if (this.nextStep() === false) {
                this.setState({ isLoading: true });
                _axios2.default.post('/picker/' + this.props.router.params.type, {
                    step1: this.state.selectedStep1,
                    step2: this.state.selectedStep2,
                    step3: val
                }).then(function (res) {
                    _this3.props.router.push(_General2.default.Link('/builder/' + _this3.props.router.params.type + '/' + res.data.id));
                });
            } else {
                this.props.router.push(_General2.default.Link('/builder/' + this.props.router.params.type + '/picker/' + this.nextStep()));
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.addBodyClass(true);
            if (this.validate() !== true) {
                this.props.router.push(_General2.default.Link('/builder/' + this.props.router.params.type + '/picker/' + this.validate()));
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.addBodyClass(true);
            if (this.validate() !== true) {
                this.restart();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.addBodyClass(false);
        }
    }, {
        key: 'addBodyClass',
        value: function addBodyClass(add) {
            if (add) {
                document.body.classList.add('picker');
            } else {
                document.body.classList.remove('picker');
            }
        }
    }, {
        key: 'isUsingFlows',
        value: function isUsingFlows() {
            return this.props.general.settings.FLOW == '1' ? true : false;
        }
    }, {
        key: 'emailOrPopup',
        value: function emailOrPopup() {
            return this.props.router.params.type == 'email' ? '/emails' : '/popups';
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.load();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
                return _react2.default.cloneElement(child, {
                    onSelect: _this4.onSelect,
                    categories: _this4.state.categories,
                    selectedStep1: _this4.state.selectedStep1,
                    selectedStep2: _this4.state.selectedStep2,
                    selectedStep3: _this4.state.selectedStep3,
                    restart: _this4.restart
                });
            });
            return _react2.default.createElement(
                'div',
                { className: 'height-100' },
                _react2.default.createElement(_Nav2.default, { backLink: this.getRedirectLink(), backText: 'Back to ' + (this.props.router.params.type == 'email' ? 'emails' : 'popups') }),
                this.state.isLoading ? _react2.default.createElement(
                    'div',
                    { className: 'loading' },
                    _react2.default.createElement(_Spin2Win2.default, null)
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row margin-top-20' },
                    _react2.default.createElement(
                        'div',
                        { className: '' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-8 offset-sm-2' },
                            childrenWithProps
                        )
                    )
                ),
                _react2.default.createElement(_AskUpgrade2.default, { onAccept: function onAccept(e) {
                        _this4.setState({ askUpgrade: false });_this4.props.router.push(_General2.default.Link('/settings/billing/plan'));
                    }, onClose: function onClose() {
                        _this4.setState({ askUpgrade: false });
                    }, param: this.state.askUpgrade, title: 'Upgrade required', body: 'To use this feature you must upgrade to a larger package.' })
            );
        }
    }]);

    return Picker;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        picker: state.picker,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setGlobalTypeState: _Builder.setGlobalTypeState, setSidebarState: _Builder.setSidebarState, addRow: _Builder.addRow, addRowPlaceholder: _Builder.addRowPlaceholder, removeElement: _Builder.removeElement, setSelectedTab: _Builder.setSelectedTab, setSelectedRow: _Builder.setSelectedRow, moveRow: _Builder.moveRow }, dispatch);
};

Picker = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Picker);
exports.default = Picker;

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Spin2Win = __webpack_require__(252);

var _Spin2Win2 = _interopRequireDefault(_Spin2Win);

var _SidebarTabButton = __webpack_require__(634);

var _SidebarTabButton2 = _interopRequireDefault(_SidebarTabButton);

var _PopupPreview = __webpack_require__(1552);

var _PopupPreview2 = _interopRequireDefault(_PopupPreview);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _jsonStableStringify = __webpack_require__(550);

var _jsonStableStringify2 = _interopRequireDefault(_jsonStableStringify);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _NewsletterListPicker = __webpack_require__(669);

var _NewsletterListPicker2 = _interopRequireDefault(_NewsletterListPicker);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _reactCopyToClipboard = __webpack_require__(670);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _reactCodemirror = __webpack_require__(202);

var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);

__webpack_require__(632);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _CKeditor = __webpack_require__(1556);

var _CKeditor2 = _interopRequireDefault(_CKeditor);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _CustomCss = __webpack_require__(1557);

var _CustomCss2 = _interopRequireDefault(_CustomCss);

var _PopupSetting = __webpack_require__(1558);

var _PopupSetting2 = _interopRequireDefault(_PopupSetting);

var _Nav = __webpack_require__(369);

var _Nav2 = _interopRequireDefault(_Nav);

var _builderPopup = __webpack_require__(668);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _RulePicker = __webpack_require__(667);

var _RulePicker2 = _interopRequireDefault(_RulePicker);

var _RuleRunMax = __webpack_require__(1559);

var _RuleRunMax2 = _interopRequireDefault(_RuleRunMax);

var _RuleRunTimeSpent = __webpack_require__(1560);

var _RuleRunTimeSpent2 = _interopRequireDefault(_RuleRunTimeSpent);

var _RuleShowToProductName = __webpack_require__(1561);

var _RuleShowToProductName2 = _interopRequireDefault(_RuleShowToProductName);

var _RuleShowToCartSum = __webpack_require__(1562);

var _RuleShowToCartSum2 = _interopRequireDefault(_RuleShowToCartSum);

var _RuleShowToLeaving = __webpack_require__(1563);

var _RuleShowToLeaving2 = _interopRequireDefault(_RuleShowToLeaving);

var _RuleShowToReturning = __webpack_require__(1564);

var _RuleShowToReturning2 = _interopRequireDefault(_RuleShowToReturning);

var _RuleShowOnPath = __webpack_require__(1565);

var _RuleShowOnPath2 = _interopRequireDefault(_RuleShowOnPath);

var _RuleShowToReferrer = __webpack_require__(1566);

var _RuleShowToReferrer2 = _interopRequireDefault(_RuleShowToReferrer);

var _RuleRunAfter = __webpack_require__(1567);

var _RuleRunAfter2 = _interopRequireDefault(_RuleRunAfter);

var _RuleShowOnDevice = __webpack_require__(1568);

var _RuleShowOnDevice2 = _interopRequireDefault(_RuleShowOnDevice);

var _RuleShowToVisitorType = __webpack_require__(1569);

var _RuleShowToVisitorType2 = _interopRequireDefault(_RuleShowToVisitorType);

var _RuleHideFromReferrer = __webpack_require__(1570);

var _RuleHideFromReferrer2 = _interopRequireDefault(_RuleHideFromReferrer);

var _RuleHideOnPath = __webpack_require__(1571);

var _RuleHideOnPath2 = _interopRequireDefault(_RuleHideOnPath);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _General3 = __webpack_require__(8);

var _General4 = _interopRequireDefault(_General3);

var _DiscountPicker = __webpack_require__(384);

var _DiscountPicker2 = _interopRequireDefault(_DiscountPicker);

var _reactDatepicker = __webpack_require__(1572);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _RuleRunPrDay = __webpack_require__(1575);

var _RuleRunPrDay2 = _interopRequireDefault(_RuleRunPrDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var components = {
    RuleShowOnDevice: _RuleShowOnDevice2.default,
    RuleRunAfter: _RuleRunAfter2.default,
    RuleShowToReferrer: _RuleShowToReferrer2.default,
    RuleShowOnPath: _RuleShowOnPath2.default,
    RuleRunMax: _RuleRunMax2.default,
    RuleShowToProductName: _RuleShowToProductName2.default,
    RuleShowToCartSum: _RuleShowToCartSum2.default,
    RuleShowToLeaving: _RuleShowToLeaving2.default,
    RuleShowToReturning: _RuleShowToReturning2.default,
    RuleHideFromReferrer: _RuleHideFromReferrer2.default,
    RuleShowToVisitorType: _RuleShowToVisitorType2.default,
    RuleHideOnPath: _RuleHideOnPath2.default,
    RuleRunTimeSpent: _RuleRunTimeSpent2.default,
    RuleRunPrDay: _RuleRunPrDay2.default
};

var Popup = function (_React$Component) {
    _inherits(Popup, _React$Component);

    function Popup(props) {
        _classCallCheck(this, Popup);

        var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

        _this.copyCampaignLink = function () {
            _Notification2.default.success('The link is added to your clipboard');
        };

        _this.getCampaignLink = function () {
            var url = _this.props.general.settings.SHOP_URL;

            if (!url.endsWith('/')) {
                url += '/';
            }

            url += '?cCampaign=' + _this.props.builderPopup.popup.uid;

            return url;
        };

        _this.getRedirectLink = function () {
            if (!_this.isUsingFlows()) {
                return _General4.default.Link('/popups');
            }

            return _General4.default.Link2("/popups");
        };

        _this.state = {
            isLoading: true,
            isError: false,
            isAddingRule: false,
            types: {},
            customCssOpen: false,
            css: '',
            isUploading: false,
            showOverview: false,
            isAddingDiscount: false
        };

        _this.codeMirrorOptions = {
            lineNumbers: true,
            mode: 'text/css'
        };

        _this.handleHtmlChange = _this.handleHtmlChange.bind(_this);
        _this.setStage = _this.setStage.bind(_this);
        _this.stageTypes = _this.stageTypes.bind(_this);
        _this.clickedContentBox = _this.clickedContentBox.bind(_this);
        _this.renderComponent = _this.renderComponent.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleColorChange = _this.handleColorChange.bind(_this);
        _this.handleBorderChange = _this.handleBorderChange.bind(_this);
        _this.renderCss = _this.renderCss.bind(_this);
        _this.resetCss = _this.resetCss.bind(_this);
        _this.handleCssChange = _this.handleCssChange.bind(_this);
        _this.saveCss = _this.saveCss.bind(_this);
        _this.renderContainer = _this.renderContainer.bind(_this);
        _this.save = _this.save.bind(_this);
        _this.overview = _this.overview.bind(_this);
        _this.handleDisableStage = _this.handleDisableStage.bind(_this);
        _this.renderMail = _this.renderMail.bind(_this);
        _this.handleAppSave = _this.handleAppSave.bind(_this);
        _this.renderRule = _this.renderRule.bind(_this);
        _this.handleImageUpload = _this.handleImageUpload.bind(_this);
        _this.handleClickUpload = _this.handleClickUpload.bind(_this);
        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.handlePopupChange = _this.handlePopupChange.bind(_this);
        _this.handleDataChange = _this.handleDataChange.bind(_this);
        _this.sidebarSuccess = _this.sidebarSuccess.bind(_this);
        _this.addRule = _this.addRule.bind(_this);
        _this.handleUseActivation = _this.handleUseActivation.bind(_this);
        _this.handleScheduleChange = _this.handleScheduleChange.bind(_this);
        _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
        return _this;
    }

    _createClass(Popup, [{
        key: 'addRule',
        value: function addRule(rule) {
            this.props.popupSetRule(rule.id, rule);
            this.setState({ isAddingRule: false });
        }
    }, {
        key: 'sidebarSuccess',
        value: function sidebarSuccess() {
            if (typeof this.state.types['crall-container'] === 'undefined') {
                return _react2.default.createElement(_SidebarTabButton2.default, { setSelectedTab: this.setStage, colSize: 'col-sm-3', disabled: false, selectedTab: this.props.builderPopup.stage, tab: '3', text: 'Success' });
            }

            var disabled = true;

            this.state.types['crall-container'].map(function (item) {
                if (item.id == 'container-stage-3') {
                    disabled = false;
                }
            });

            return _react2.default.createElement(_SidebarTabButton2.default, { setSelectedTab: this.setStage, colSize: 'col-sm-3', disabled: disabled, selectedTab: this.props.builderPopup.stage, tab: '3', text: 'Success' });
        }
    }, {
        key: 'handleDataChange',
        value: function handleDataChange(e) {
            this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, e.target.getAttribute('data-id'), e.target.value);
        }
    }, {
        key: 'handleStatusChange',
        value: function handleStatusChange(value) {
            var val = value == true ? 1 : 0;
            this.props.popupSetPopupKey('status', val);
        }
    }, {
        key: 'handleUseActivation',
        value: function handleUseActivation(e) {
            this.props.popupSetPopupKey('use_active_period', !this.props.builderPopup.popup.use_active_period);
        }
    }, {
        key: 'handlePopupChange',
        value: function handlePopupChange(e) {
            this.props.popupSetPopupKey([e.target.getAttribute('data-id')], e.target.value);
        }
    }, {
        key: 'handleScheduleChange',
        value: function handleScheduleChange(value, type) {
            if (!value) {
                this.props.popupSetPopupKey([type], null);
                return;
            }

            if (type == 'active_from' && this.props.builderPopup.popup.active_to != '' && this.props.builderPopup.popup.active_to) {
                if (value.isAfter((0, _moment2.default)(this.props.builderPopup.popup.active_to))) {
                    _Notification2.default.error('Invalid date range. From must be a date before To');
                    return;
                }
            }

            if (type == 'active_to' && this.props.builderPopup.popup.active_from != '' && this.props.builderPopup.popup.active_from) {
                if (value.isBefore((0, _moment2.default)(this.props.builderPopup.popup.active_from))) {
                    _Notification2.default.error('Invalid date range. To must be a date after From');
                    return;
                }
            }

            this.props.popupSetPopupKey([type], value.format('YYYY-MM-DD'));
        }
    }, {
        key: 'handleClickUpload',
        value: function handleClickUpload() {
            this.refs.dropzone.open();
        }
    }, {
        key: 'handleImageUpload',
        value: function handleImageUpload(files) {
            var _this2 = this;

            if (files.length == 0) {
                return;
            }

            this.setState({ isUploading: true });

            var data = new FormData();
            data.append('file', files[0]);

            _axios2.default.post('/ajax/upload_image', data).then(function (res) {
                _this2.setState({ isUploading: false });
                _this2.props.popupSetContentData('@@' + _this2.props.builderPopup.component.id + '@@', res.data.url);
            }).catch(function (err) {
                _this2.setState({ isUploading: false });
            });
        }
    }, {
        key: 'handleAppSave',
        value: function handleAppSave(app) {
            this.props.popupSetPopupKey('app', app);
        }
    }, {
        key: 'renderMail',
        value: function renderMail() {
            var apps = _General2.default.appGetType('newsletter');

            if (apps.length == 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    'No mail provider detected'
                );
            }
            return _react2.default.createElement(_NewsletterListPicker2.default, { data: this.props.builderPopup.popup.app, handleSave: this.handleAppSave, inputs: this.state.types['crall-input'], apps: apps });
        }
    }, {
        key: 'handleDisableStage',
        value: function handleDisableStage() {
            this.props.popupSetSettingData('disableStage' + this.props.builderPopup.stage, !this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage]);
        }
    }, {
        key: 'buildSaveableObject',
        value: function buildSaveableObject() {
            var data = {};

            data.name = this.props.builderPopup.popup.name;
            data.custom = this.props.builderPopup.popup.custom;
            data.style = (0, _jsonStableStringify2.default)(this.props.builderPopup.popup.style);
            data.app = (0, _jsonStableStringify2.default)(this.props.builderPopup.popup.app);
            data.content = (0, _jsonStableStringify2.default)(this.props.builderPopup.popup.content);
            data.settings = (0, _jsonStableStringify2.default)(this.props.builderPopup.popup.settings);
            data.rules = this.props.builderPopup.rules;
            data.status = this.props.builderPopup.popup.status;
            data.position = this.props.builderPopup.popup.position;
            data.use_active_period = this.props.builderPopup.popup.use_active_period;
            data.active_from = this.props.builderPopup.popup.active_from;
            data.active_to = this.props.builderPopup.popup.active_to;

            return data;
        }
    }, {
        key: 'overview',
        value: function overview(e) {
            e.stopPropagation();
            this.setState({ showOverview: true });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.setState({ showOverview: false });

            _Notification2.default.info('Saving...');

            _axios2.default.put('/popups/' + this.props.params.popup_id, this.buildSaveableObject()).then(function (response) {
                _Notification2.default.success('Popup saved');
                if (redirect) {
                    if (_this3.isUsingFlows()) {
                        window.location = _this3.getRedirectLink();
                    } else {
                        _this3.props.router.push(_General2.default.Link('/popups'));
                    }
                }
            }).catch(function (error) {
                _Notification2.default.error(error.message);
            });
        }
    }, {
        key: 'handleCssChange',
        value: function handleCssChange(code) {
            this.setState({ css: code });
        }
    }, {
        key: 'saveCss',
        value: function saveCss() {
            this.props.popupSetPopupKey('custom', this.state.css);
            this.resetCss();
        }
    }, {
        key: 'resetCss',
        value: function resetCss() {
            this.setState({
                css: '',
                customCssOpen: false
            });
        }
    }, {
        key: 'renderCss',
        value: function renderCss() {
            return _react2.default.createElement(
                'div',
                { className: 'm-t-20' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(_reactCodemirror2.default, { value: this.state.css, onChange: this.handleCssChange, options: this.codeMirrorOptions })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 p-l-0' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-block btn-danger', onClick: this.resetCss },
                            'Discard'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 p-r-0' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-block btn-dark', onClick: this.saveCss },
                            'Save'
                        )
                    )
                )
            );
        }
    }, {
        key: 'toggleCss',
        value: function toggleCss() {
            this.setState({
                css: this.props.builderPopup.popup.custom
            });
            this.setState({ customCssOpen: true });
        }
    }, {
        key: 'handleColorChange',
        value: function handleColorChange(id, value) {
            switch (id) {
                case 'container':
                    this.props.popupSetStyleData('#container-stage-' + this.props.builderPopup.stage, 'background-color', value);
                    break;

                default:
                    this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, 'background-color', value);
                    break;
            }
        }
    }, {
        key: 'handleBorderChange',
        value: function handleBorderChange(id, border) {
            switch (id) {
                case 'container':
                    this.props.popupSetStyleData('#container-stage-' + this.props.builderPopup.stage, 'border', border);
                    break;

                default:
                    this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, 'border', border);
                    break;
            }
        }
    }, {
        key: 'clickedContentBox',
        value: function clickedContentBox() {
            this.props.popupSetGlobalKey('component', false);
        }
    }, {
        key: 'addStyle',
        value: function addStyle(id, key, value) {
            if (!this.props.builderPopup.popup.style['#' + id][key]) {
                return true;
            }

            return false;
        }
    }, {
        key: 'stageTypes',
        value: function stageTypes(types) {
            var _this4 = this;

            for (var i in types) {
                types[i].map(function (item) {
                    var s = {};

                    if (!_this4.props.builderPopup.popup.style['#' + item.id]) {
                        _this4.props.popupSetStyle('#' + item.id, {});
                    }

                    for (var style in item.styles) {
                        switch (style) {
                            case 'backgroundColor':
                                if (_this4.addStyle(item.id, 'background-color', item.styles[style])) {
                                    _this4.props.popupSetStyleData('#' + item.id, 'background-color', item.styles[style]);
                                }
                                break;

                            case 'link':
                                if (_this4.addStyle(item.id, 'link', item.styles[style])) {
                                    _this4.props.popupSetStyleData('#' + item.id, 'link', item.styles[style]);
                                }
                                break;

                            case 'border':
                                if (_this4.addStyle(item.id, 'border', item.styles[style])) {
                                    _this4.props.popupSetStyleData('#' + item.id, 'border', item.styles[style].borderWidth + ' ' + item.styles[style].borderStyle + ' ' + item.styles[style].borderColor);
                                }
                                break;
                        }
                    }
                });
            }
            this.setState({ types: types });
        }
    }, {
        key: 'get',
        value: function get(id) {
            var _this5 = this;

            _axios2.default.get('/popups/' + id).then(function (response) {
                response.data.template.content = JSON.parse(response.data.template.content);
                try {
                    response.data.content = JSON.parse(response.data.content);
                } catch (e) {
                    response.data.content = {};
                }

                try {
                    response.data.style = JSON.parse(response.data.style);
                } catch (e) {
                    response.data.style = {};
                }

                try {
                    response.data.app = JSON.parse(response.data.app);
                } catch (e) {
                    response.data.app = {};
                }

                try {
                    response.data.settings = JSON.parse(response.data.settings);
                } catch (e) {
                    response.data.settings = {};
                }

                if (!response.data.custom) {
                    response.data.custom = '';
                }

                if (!response.data.settings) {
                    response.data.settings = {};
                }

                if (!response.data.app) {
                    response.data.app = {};
                }

                if (!response.data.style) {
                    response.data.style = {};
                }

                if (!response.data.content) {
                    response.data.content = {};
                }

                response.data.settings = new _PopupSetting2.default(response.data.settings).item;

                for (var i in response.data.template.content) {
                    if (!response.data.content[i]) {
                        response.data.content[i] = response.data.template.content[i];
                    }
                }

                if (!response.data.style) {
                    response.data.style = {};
                }

                var rules = {};

                response.data.rules.map(function (rule) {
                    rules[rule.id] = rule;
                });

                _this5.props.popupSetGlobalKey('rules', rules);

                delete response.data.rules;
                _this5.props.popupSetGlobalKey('popup', response.data);

                _this5.setState({ isLoading: false });
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setStage(2);
            if (typeof this.props.params.popup_id !== 'undefined') {
                this.get(this.props.params.popup_id);
            } else {
                this.setState({ isLoading: false });
            }
        }
    }, {
        key: 'handleHtmlChange',
        value: function handleHtmlChange(value) {
            this.props.popupSetContentData('@@' + this.props.builderPopup.component.id + '@@', value);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.popupSetContentData('@@' + this.props.builderPopup.component.id + '@@', e.target.value);
        }
    }, {
        key: 'handleCheckboxChange',
        value: function handleCheckboxChange(e) {
            e.stopPropagation();
            this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, e.target.getAttribute('data-id'), e.target.checked);
        }
    }, {
        key: 'setStage',
        value: function setStage(stage) {
            this.props.popupSetGlobalKey('component', false);
            this.props.popupSetGlobalKey('stage', stage);
        }
    }, {
        key: 'renderType',
        value: function renderType(type, types) {
            return _react2.default.createElement(
                'div',
                { className: 'panel-group panel-group-continuous', id: 'el-setting-' + type, 'aria-multiselectable': 'true', role: 'tablist' },
                types.map(function (el, i) {
                    return _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { key: i, selectedSetting: false, optionKey: 'el-setting-' + type + '-' + i, id: 'el-setting-' + type, title: el.title },
                        'asdfasdfasdf'
                    );
                })
            );
        }
    }, {
        key: 'renderRule',
        value: function renderRule(rule) {
            var Comp = components['Rule' + rule.key];
            return _react2.default.createElement(Comp, { handleRemove: this.props.popupRemoveRule, handleChange: this.props.popupSetRule, rule: rule, key: rule.id });
        }
    }, {
        key: 'handleNameChange',
        value: function handleNameChange(e) {
            this.props.popupSetPopupKey('name', e.target.value);
        }
    }, {
        key: 'renderComponent',
        value: function renderComponent() {
            var options = [];

            //managed by placeholders
            for (var i in this.props.builderPopup.component.styles) {
                switch (i) {
                    case 'openNewWindow':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-openNewWindow@@', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'checkbox-custom checkbox-primary' },
                                _react2.default.createElement('input', { key: '@@' + this.props.builderPopup.component.id + '@@', checked: this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['openNewWindow'], 'data-id': 'openNewWindow', onChange: this.handleCheckboxChange, type: 'checkbox' }),
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Open link in new window?'
                                )
                            )
                        ));
                        break;
                    case 'html':
                        options.push(_react2.default.createElement(_CKeditor2.default, { key: '@@' + this.props.builderPopup.component.id + '-html@@', component: '@@' + this.props.builderPopup.component.id + '@@', change: this.handleHtmlChange, html: this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@'] }));
                        break;

                    case 'text':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-text@@', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Text'
                            ),
                            _react2.default.createElement('input', { className: 'form-control', key: '@@' + this.props.builderPopup.component.id + '@@', value: this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@'], 'data-id': 'text', onChange: this.handleChange })
                        ));
                        break;

                    case 'link':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-link@@', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Link to page'
                            ),
                            _react2.default.createElement('input', { className: 'form-control', placeholder: 'http://www.website.com', key: '@@' + this.props.builderPopup.component.id + '@@', value: this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['link'], 'data-id': 'link', onChange: this.handleDataChange })
                        ));
                        break;

                    case 'video':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-video@@', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Youtube video ID'
                            ),
                            _react2.default.createElement('input', { className: 'form-control', key: '@@' + this.props.builderPopup.component.id + '@@', value: this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@'], 'data-id': 'text', onChange: this.handleChange })
                        ));
                        break;

                    case 'image':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-image@@', className: 'form-group col-sm-12' },
                            this.state.isUploading ? _react2.default.createElement(
                                'div',
                                { className: 'locked-overlay' },
                                _react2.default.createElement(_LoadingSmall2.default, null)
                            ) : null,
                            _react2.default.createElement(
                                _reactDropzone2.default,
                                { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.handleImageUpload },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', onClick: this.handleClickUpload, className: 'btn btn-dark btn-block btn-sm' },
                                    _react2.default.createElement('i', { className: 'icon wb-search', 'aria-hidden': 'true' }),
                                    ' Upload image'
                                )
                            )
                        ));
                        break;

                    case 'placeholder':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '@@' + this.props.builderPopup.component.id + '-placeholder@@', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Text'
                            ),
                            _react2.default.createElement('input', { className: 'form-control', key: '@@' + this.props.builderPopup.component.id + '@@', value: this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@'], 'data-id': 'placeholder', onChange: this.handleChange })
                        ));
                        break;

                    case 'border':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '\'@@' + this.props.builderPopup.component.id + '-border', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Border'
                            ),
                            _react2.default.createElement(_BorderPicker2.default, { id: this.props.builderPopup.component.id, handleBorderChange: this.handleBorderChange, format: true, data: this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['border'] })
                        ));
                        break;

                    case 'backgroundColor':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '\'@@' + this.props.builderPopup.component.id + '-background-color', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Background color'
                            ),
                            _react2.default.createElement(_ColorPicker2.default, { id: this.props.builderPopup.component.id, color: this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['background-color'], handleColorChange: this.handleColorChange })
                        ));
                        break;
                }
            }

            //managed by styles


            return _react2.default.createElement(
                'div',
                null,
                options,
                _react2.default.createElement('div', { className: 'clearfix' })
            );
        }
    }, {
        key: 'renderContainer',
        value: function renderContainer() {
            var options = [];

            for (var i in this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]) {
                switch (i) {
                    case 'border':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '\'#container-stage-' + this.props.builderPopup.stage + '-border', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Border'
                            ),
                            _react2.default.createElement(_BorderPicker2.default, { id: 'container', handleBorderChange: this.handleBorderChange, format: true, data: this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]['border'] })
                        ));
                        break;

                    case 'background-color':
                        options.push(_react2.default.createElement(
                            'div',
                            { key: '\'#container-stage-' + this.props.builderPopup.stage + '-background-color', className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label font-size-12' },
                                'Background color'
                            ),
                            _react2.default.createElement(_ColorPicker2.default, { id: 'container', color: this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]['background-color'], handleColorChange: this.handleColorChange })
                        ));
                        break;
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                options,
                _react2.default.createElement('div', { className: 'clearfix' })
            );
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var _this6 = this;

            return _react2.default.createElement(
                'div',
                { className: 'sidebar text m-t-20', style: this.props.style },
                _react2.default.createElement(
                    'div',
                    { className: 'panel-group panel-group-continuous', id: 'popup-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                    this.props.builderPopup.popup.template.email_collection == 1 ? _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: false, optionKey: 'popup-mail', parent: 'popup-settings', title: 'Newsletter integration' },
                        this.renderMail()
                    ) : null,
                    _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: false, optionKey: 'popup-dates', parent: 'popup-settings', title: 'Scheduled activation' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'checkbox-custom checkbox-primary' },
                                _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleUseActivation, checked: this.props.builderPopup.popup.use_active_period }),
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Use scheduled activation'
                                )
                            )
                        ),
                        this.props.builderPopup.popup.use_active_period ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group col-sm-12' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'control-label font-size-12' },
                                    'From'
                                ),
                                _react2.default.createElement(_reactDatepicker2.default, { dateFormat: 'DD-MM-YYYY', placeholderText: 'Click to select a date', selected: this.props.builderPopup.popup.active_from == '' || !this.props.builderPopup.popup.active_from ? '' : (0, _moment2.default)(this.props.builderPopup.popup.active_from), 'data-id': 'active_from', className: 'form-control', onChange: function onChange(e) {
                                        _this6.handleScheduleChange(e, 'active_from');
                                    } })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group col-sm-12' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'control-label font-size-12' },
                                    'To'
                                ),
                                _react2.default.createElement(_reactDatepicker2.default, { dateFormat: 'DD-MM-YYYY', placeholderText: 'Click to select a date', selected: this.props.builderPopup.popup.active_to == '' || !this.props.builderPopup.popup.active_to ? '' : (0, _moment2.default)(this.props.builderPopup.popup.active_to), 'data-id': 'active_to', className: 'form-control', onChange: function onChange(e) {
                                        _this6.handleScheduleChange(e, 'active_to');
                                    } })
                            )
                        ) : null
                    ),
                    _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: false, optionKey: 'popup-who', parent: 'popup-settings', title: 'Who' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-group bg-blue-grey-100 bg-inherit' },
                            Object.keys(this.props.builderPopup.rules).map(function (i) {
                                return _this6.props.builderPopup.rules[i].action == 'Who' ? _this6.renderRule(_this6.props.builderPopup.rules[i]) : null;
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', onClick: function onClick(e) {
                                    e.stopPropagation();_this6.setState({ isAddingRule: true });
                                }, className: 'btn btn-dark btn-block' },
                            'Add new rule'
                        )
                    ),
                    _react2.default.createElement(
                        _SidebarSettingAccordion2.default,
                        { selectedSetting: false, optionKey: 'popup-when', parent: 'popup-settings', title: 'When' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-group bg-blue-grey-100 bg-inherit' },
                            Object.keys(this.props.builderPopup.rules).map(function (i) {
                                return _this6.props.builderPopup.rules[i].action == 'When' ? _this6.renderRule(_this6.props.builderPopup.rules[i]) : null;
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', onClick: function onClick(e) {
                                    e.stopPropagation();_this6.setState({ isAddingRule: true });
                                }, className: 'btn btn-dark btn-block' },
                            'Add new rule'
                        )
                    )
                )
            );
        }
    }, {
        key: 'renderSidebarContent',
        value: function renderSidebarContent(stage) {
            if (this.state.customCssOpen) {
                return this.renderCss();
            }

            if (this.props.builderPopup.stage == 4) {
                return this.renderSettings();
            }

            return _react2.default.createElement(
                'div',
                { className: 'sidebar text m-t-20', style: this.props.style },
                this.props.builderPopup.stage == 1 || this.props.builderPopup.stage == 3 ? _react2.default.createElement(
                    'div',
                    { className: 'component m-b-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox-custom checkbox-primary' },
                        _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleDisableStage, checked: this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage] }),
                        _react2.default.createElement(
                            'label',
                            null,
                            'Don\'t show ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                this.props.builderPopup.stage == 1 ? 'Minimized' : 'Success'
                            ),
                            ' window to visitor.'
                        )
                    )
                ) : null,
                this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage] == false || this.props.builderPopup.stage == 2 ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-group panel-group-continuous', id: 'box-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                        _react2.default.createElement(
                            _SidebarSettingAccordion2.default,
                            { selectedSetting: false, optionKey: 'content-box', parent: 'box-settings', title: 'Container' },
                            this.renderContainer()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'component' },
                        this.props.builderPopup.component == false ? _react2.default.createElement(
                            'div',
                            { className: 'text-center' },
                            _react2.default.createElement('img', { style: { width: '40px' }, src: '/images/svg/click.svg' }),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Click on the element you wan\'t to edit.'
                            )
                        ) : this.renderComponent()
                    )
                ) : null
            );
        }
    }, {
        key: 'renderPreview',
        value: function renderPreview() {
            var _this7 = this;

            return _react2.default.createElement(_PopupPreview2.default, { ref: function ref(iframe) {
                    _this7.iframe = iframe;
                }, stageTypes: this.stageTypes });
        }
    }, {
        key: 'isUsingFlows',
        value: function isUsingFlows() {
            return this.props.general.settings.FLOW == '1' ? true : false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }
            return _react2.default.createElement(
                'div',
                { className: 'height-100' },
                _react2.default.createElement(
                    _Nav2.default,
                    { backLink: this.getRedirectLink(), backText: 'Back to popups' },
                    _react2.default.createElement(
                        'li',
                        { className: 'nav-item hidden-float' },
                        _react2.default.createElement(
                            'a',
                            { className: 'nav-link', href: 'javascript:void(0)', onClick: function onClick(e) {
                                    return _this8.setState({ isAddingDiscount: true });
                                } },
                            'Add discount ',
                            _react2.default.createElement('i', { className: 'icon fa-tag', style: { fontSize: '12px' }, 'aria-hidden': 'true' })
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'nav-item hidden-float' },
                        _react2.default.createElement(
                            _reactCopyToClipboard.CopyToClipboard,
                            {
                                onCopy: this.copyCampaignLink,
                                options: { message: 'Whoa!' },
                                text: this.getCampaignLink() },
                            _react2.default.createElement(
                                'a',
                                { className: 'nav-link', href: 'javascript:void(0)', onClick: this.copyCampaignLink },
                                'Copy campaign link ',
                                _react2.default.createElement('i', { className: 'icon fa-copy', style: { fontSize: '12px' }, 'aria-hidden': 'true' })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'nav-item hidden-float' },
                        _react2.default.createElement(
                            'a',
                            { className: 'nav-link', href: 'javascript:void(0)', onClick: function onClick(e) {
                                    return _this8.toggleCss();
                                } },
                            'Custom CSS ',
                            _react2.default.createElement('i', { className: 'icon wb-code-unfold', style: { fontSize: '12px' }, 'aria-hidden': 'true' })
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'nav-item hidden-float' },
                        _react2.default.createElement(
                            'a',
                            { className: 'nav-link', href: 'javascript:void(0)', onClick: function onClick(e) {
                                    return _this8.save(false);
                                } },
                            'Quick save'
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'nav-item save-and-continue hidden-float' },
                        _react2.default.createElement(
                            'a',
                            { className: 'nav-link', href: 'javascript:void(0)', onClick: function onClick(e) {
                                    return _this8.overview(e);
                                } },
                            'Save and continue ',
                            _react2.default.createElement('i', { className: 'fa fa-chevron-right', style: { fontSize: '12px' }, 'aria-hidden': 'true' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'height-100' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sidebar height-100 col-sm-4 p-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'slide-in' },
                            _react2.default.createElement(
                                'div',
                                { className: 'btn-group col-sm-12  m-t-20', 'aria-label': 'Default button group', role: 'group' },
                                _react2.default.createElement(_SidebarTabButton2.default, { setSelectedTab: this.setStage, colSize: 'col-sm-3', selectedTab: this.props.builderPopup.stage, tab: '1', text: 'Minimized' }),
                                _react2.default.createElement(_SidebarTabButton2.default, { setSelectedTab: this.setStage, colSize: 'col-sm-3', selectedTab: this.props.builderPopup.stage, tab: '2', text: 'Maximized' }),
                                this.sidebarSuccess(),
                                _react2.default.createElement(_SidebarTabButton2.default, { setSelectedTab: this.setStage, colSize: 'col-sm-3', selectedTab: this.props.builderPopup.stage, tab: '4', text: 'Settings' })
                            ),
                            _react2.default.createElement('div', { className: 'clearfix' }),
                            this.renderSidebarContent(this.props.builderPopup.stage),
                            _react2.default.createElement('div', { className: 'clearfix' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'main-content col-sm-8 p-0 height-100' },
                        this.renderPreview()
                    )
                ),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this8.setState({ showOverview: false });
                        }, isOpened: this.state.showOverview },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                'Almost done!'
                            ),
                            _react2.default.createElement(
                                'h2',
                                null,
                                'Please take your time and look over the settings for this popup.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'm-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Name'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 offset-sm-1' },
                                    _react2.default.createElement('input', { type: 'text', onChange: this.handleNameChange, className: 'form-control form-control-lg', value: this.props.builderPopup.popup.name, placeholder: 'My awesome popup' })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'm-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Position'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 offset-sm-1' },
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control', value: this.props.builderPopup.popup.position, 'data-id': 'position', onChange: this.handlePopupChange },
                                        _react2.default.createElement(
                                            'option',
                                            { value: 'center' },
                                            'Center'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: 'bottom-left' },
                                            'Bottom-left'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: 'bottom-right' },
                                            'Bottom-right'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'rules m-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Who'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit' },
                                    Object.keys(this.props.builderPopup.rules).map(function (i) {
                                        return _this8.props.builderPopup.rules[i].action == 'Who' ? _this8.renderRule(_this8.props.builderPopup.rules[i]) : null;
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'rules m-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'When'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit' },
                                    Object.keys(this.props.builderPopup.rules).map(function (i) {
                                        return _this8.props.builderPopup.rules[i].action == 'When' ? _this8.renderRule(_this8.props.builderPopup.rules[i]) : null;
                                    })
                                )
                            ),
                            this.props.builderPopup.popup.template.email_collection == 1 ? _react2.default.createElement(
                                'div',
                                { className: 'm-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Newsletter integration'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-8 offset-sm-2' },
                                    this.renderMail()
                                )
                            ) : null,
                            _react2.default.createElement(
                                'div',
                                { className: 'm-t-40 col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'm-b-20 strike' },
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Popup status'
                                    )
                                ),
                                this.props.general.settings.PACKAGE_POPUP == '1' ? _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 offset-sm-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4 text-right' },
                                        'Activate popup'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6 text-right' },
                                        _react2.default.createElement(_rcSwitch2.default, { onChange: this.handleStatusChange,
                                            checked: this.props.builderPopup.popup.status == 1 ? true : false,
                                            checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
                                            unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
                                        })
                                    )
                                ) : _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-10 offset-sm-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-10 offset-sm-1' },
                                        _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to enable popups, you need to upgrade your account to a larger package' })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-10 offset-sm-1' },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', onClick: this.save, className: 'btn p-l-40 p-r-40 btn-dark btn-lg m-t-50 m-b-50' },
                                    'Save'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_DiscountPicker2.default, { onClose: function onClose() {
                        _this8.setState({ isAddingDiscount: false });
                    }, param: this.state.isAddingDiscount }),
                _react2.default.createElement(_RulePicker2.default, { rules: this.props.builderPopup.rules, addRule: this.addRule, renderRule: this.renderRule, available: components, onClose: function onClose() {
                        _this8.setState({ isAddingRule: false });
                    }, param: this.state.isAddingRule })
            );
        }
    }]);

    return Popup;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        builderPopup: state.builderPopup,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ popupRemoveRule: _builderPopup.popupRemoveRule, popupSetSettingData: _builderPopup.popupSetSettingData, popupSetRule: _builderPopup.popupSetRule, popupSetStyleData: _builderPopup.popupSetStyleData, popupSetPopupKey: _builderPopup.popupSetPopupKey, popupSetGlobalKey: _builderPopup.popupSetGlobalKey, popupSetContentData: _builderPopup.popupSetContentData, popupSetStyle: _builderPopup.popupSetStyle }, dispatch);
};

Popup = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Popup);
exports.default = Popup;

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _builderPopup = __webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupPreview = function (_React$Component) {
	_inherits(PopupPreview, _React$Component);

	function PopupPreview(props) {
		_classCallCheck(this, PopupPreview);

		var _this = _possibleConstructorReturn(this, (PopupPreview.__proto__ || Object.getPrototypeOf(PopupPreview)).call(this, props));

		_this.state = {};
		_this.send = _this.send.bind(_this);
		_this.incMessage = _this.incMessage.bind(_this);
		return _this;
	}

	_createClass(PopupPreview, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.updateIframe();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			if (next.builderPopup.stage != this.props.builderPopup.stage) {
				this.editor().showStage(next.builderPopup.stage);
			}

			if (next.builderPopup.component.id) {
				var update = {};
				update.content = next.builderPopup.popup.content['@@' + next.builderPopup.component.id + '@@'];
				update.style = next.builderPopup.popup.style['#' + next.builderPopup.component.id];
				update.id = '#' + next.builderPopup.component.id;
				update.type = next.builderPopup.component.type;
				this.editor().updateElm(update);
			}

			var container = {};
			container.content = false;
			container.style = next.builderPopup.popup.style['#container-stage-' + next.builderPopup.stage];
			container.id = '#container-stage-' + next.builderPopup.stage;
			container.type = 'crall-container';
			this.editor().updateElm(container);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(props, state) {
			if (this.props.builderPopup.popup.custom != props.builderPopup.popup.custom) {
				this.updateIframe();
			}
		}
	}, {
		key: 'generateStyle',
		value: function generateStyle() {
			var style = "";
			for (var selector in this.props.builderPopup.popup.style) {
				style += selector + " {\n";
				for (var key in this.props.builderPopup.popup.style[selector]) {
					style += key + ":" + this.props.builderPopup.popup.style[selector][key] + ";\n";
				}
				style += "}\n";
			}

			style += this.props.builderPopup.popup.custom;

			return style;
		}
	}, {
		key: 'buildHtml',
		value: function buildHtml() {
			var html = '\n\t\t' + this.props.builderPopup.popup.header + '\n\t\t' + this.props.builderPopup.popup.template.style + '\n\t\t' + this.generateStyle() + '\n\t\t.box-stage-1,.box-stage-2,.box-stage-3 {\n\t\t\tleft: 0; \n\t\t\tright: 0; \n\t\t\tmargin-left: auto; \n\t\t\tmargin-right: auto;\n\t\t}\n\t\t.editable:hover {\n\t\t\tbox-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\n\t\t\tborder:1px solid #cccccc;\n\t\t\tcursor:pointer;\n\t\t}\n\t\t</style></head><body>\n\t\t' + this.props.builderPopup.popup.template.body + '\n\t\t' + this.props.builderPopup.popup.footer + '\n\t\t';

			html = this.replaceContent(html);

			return html;
		}
	}, {
		key: 'replaceContent',
		value: function replaceContent(html) {
			for (var i in this.props.builderPopup.popup.content) {
				html = html.replace(i, this.props.builderPopup.popup.content[i]);
			}
			return html;
		}
	}, {
		key: 'updateIframe',
		value: function updateIframe() {
			this.bindEvents();
			this.refs.preview.contentWindow.document.open();
			this.refs.preview.contentWindow.document.write(this.buildHtml());
			this.refs.preview.contentWindow.document.close();
		}
	}, {
		key: 'editor',
		value: function editor() {
			return this.refs.preview.contentWindow._crallEditor;
		}
	}, {
		key: 'send',
		value: function send(obj) {
			if (typeof this.refs.preview.contentWindow.postMessage == 'function') {
				this.refs.preview.contentWindow.postMessage(obj, "*");
			}
		}
	}, {
		key: 'afterUpdate',
		value: function afterUpdate() {
			this.editor().showStage(this.props.builderPopup.stage);
			this.props.stageTypes(this.editor().getAllTypes());
		}
	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			window.addEventListener("message", this.incMessage, false);
		}
	}, {
		key: 'incMessage',
		value: function incMessage(event) {
			switch (event.data.action) {
				case 'clicked':
					this.props.popupSetGlobalKey('component', event.data.payload);
					break;

				case 'ready':
					this.afterUpdate();
					break;
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('message', this.incMessage, false);
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ className: 'height-100' },
				_react2.default.createElement('iframe', { ref: 'preview', style: { width: '100%', height: '100%', 'border': 0 } })
			);
		}
	}]);

	return PopupPreview;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		builderPopup: state.builderPopup
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ popupSetGlobalKey: _builderPopup.popupSetGlobalKey }, dispatch);
};

PopupPreview = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PopupPreview);
exports.default = PopupPreview;

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CKeditor = function (_React$Component) {
	_inherits(CKeditor, _React$Component);

	function CKeditor(props) {
		_classCallCheck(this, CKeditor);

		var _this = _possibleConstructorReturn(this, (CKeditor.__proto__ || Object.getPrototypeOf(CKeditor)).call(this, props));

		_this.state = {
			// Bytt mellom textarea virker ikke. TEkst blir ikke oppdatert.
			instance: false
		};

		_this.renderEditor = _this.renderEditor.bind(_this);
		return _this;
	}

	_createClass(CKeditor, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.renderEditor();
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.change(v);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			if (next.component != this.props.component) {
				this.state.instance.destroy();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.state.instance.destroy();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			//this.renderEditor();
		}
	}, {
		key: 'renderEditor',
		value: function renderEditor() {
			var _this2 = this;

			if (this.state.instance !== false) {
				this.state.instance.destroy();
				this.state.instance = false;
			}

			this.state.instance = CKEDITOR.replace(this.refs.editor, {
				customConfig: '/assets/js/ckeditor//editorConfig.js',
				width: '100%',
				height: '100%',
				on: {
					change: function change(evt) {
						_this2.onChange(_this2.state.instance.getData());
					}
				}
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement('div', { ref: 'editor', dangerouslySetInnerHTML: { __html: this.props.html } });
		}
	}]);

	return CKeditor;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builderPopup: state.builderPopup
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

CKeditor = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CKeditor);

exports.default = CKeditor;

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomCss = function (_React$Component) {
    _inherits(CustomCss, _React$Component);

    function CustomCss(props) {
        _classCallCheck(this, CustomCss);

        var _this = _possibleConstructorReturn(this, (CustomCss.__proto__ || Object.getPrototypeOf(CustomCss)).call(this, props));

        _this.state = {};

        return _this;
    }

    _createClass(CustomCss, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            $(this.refs.modal).modal('show');
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { ref: 'modal', className: 'modal fade modal-fade-in-scale-up', id: 'aaa', 'aria-hidden': 'true', role: 'dialog', tabIndex: '-1' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-dialog modal-lg' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-content', style: { height: '1000px' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-header' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '\xD7'
                                )
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'modal-title' },
                                'Custom CSS'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-body' },
                            _react2.default.createElement('textarea', { className: 'form-control', style: { width: '100%', 'height': '100%' } })
                        )
                    )
                )
            );
        }
    }]);

    return CustomCss;
}(_react2.default.Component);

exports.default = CustomCss;

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupSetting = function () {
	function PopupSetting(r) {
		_classCallCheck(this, PopupSetting);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(PopupSetting, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('disableStage1')) {
				this.item.disableStage1 = false;
			}

			if (!this.isset('disableStage3')) {
				this.item.disableStage3 = true;
			}
		}
	}]);

	return PopupSetting;
}();

exports.default = PopupSetting;

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Display limit', description: 'Define how many times this popup should be shown to the same customer' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value == '0' ? '∞' : this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 times to the same visitor.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Timer spent in shop', description: 'Define how long it should take before the popup is shown based on time spent in the shop.' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitor after they spent \xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 seconds in the shop.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'Click here to edit', operator: '==', action: 'Who', ruleKey: this.props.ruleKey, title: 'Product', description: 'Only show to customers who has a spesific product in their cart' });
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who has a product name matching ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.editOperator = _this.editOperator.bind(_this);
        _this.renderOperator = _this.renderOperator.bind(_this);
        _this.changeOperator = _this.changeOperator.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'changeOperator',
        value: function changeOperator(operator) {
            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                operator: operator
            }));

            this.setState({ operator: operator });
            this.setState({ 'isEditingOperator': !this.state.isEditingOperator });
        }
    }, {
        key: 'renderOperator',
        value: function renderOperator() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.state.operator == '<=' ? 'less' : 'more',
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeOperator('>=');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'More'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeOperator('<=');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'Less'
                    )
                )
            );
        }
    }, {
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditingValue': !this.state.isEditingValue });
        }
    }, {
        key: 'editOperator',
        value: function editOperator() {
            this.setState({ 'isEditingOperator': !this.state.isEditingOperator });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'isEditingOperator': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value,
                'operator': this.props.onlyDescription ? false : this.props.rule.operator
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditingValue) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'Who', ruleKey: this.props.ruleKey, title: 'Cart sum', description: 'Only show to customers who has X amount in cart' });
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who has a cart sum that is \xA0',
                !this.state.isEditingOperator ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.editOperator(e);
                        }, className: 'selected-rule' },
                    this.props.rule.operator == '<=' ? 'less' : 'more'
                ) : this.renderOperator(),
                '\xA0than\xA0',
                !this.state.isEditingValue ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this3.props.handleRemove(_this3.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        return _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));
    }

    _createClass(Rule, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'true', operator: '==', action: 'Who', ruleKey: this.props.ruleKey, title: 'Leaving customers', description: 'Only show to customers who are about to leave' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who are about to leave your shop.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.editDropdown = _this.editDropdown.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        _this.changeDropdown = _this.changeDropdown.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'changeDropdown',
        value: function changeDropdown(value) {
            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));

            this.setState({ value: value });
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.state.value == 'true' ? 'is' : 'is not',
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('true');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'is'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('false');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'is not'
                    )
                )
            );
        }
    }, {
        key: 'editDropdown',
        value: function editDropdown() {
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditingDropdown': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'true', operator: '==', action: 'Who', ruleKey: this.props.ruleKey, title: 'Returning customers', description: 'Only show to returning customers' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who \xA0',
                !this.state.isEditingDropdown ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.editDropdown(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value == 'true' ? 'is' : 'is not'
                ) : this.renderDropdown(),
                '\xA0a returning visitor.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this3.props.handleRemove(_this3.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));

            if (e.key === 'Enter') {

                this.setState({ value: value });
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'Click here to add address', operator: '%%', action: 'Who', ruleKey: this.props.ruleKey, title: 'Address', description: 'Only show to customers who are visiting a spesific address' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who is at a url matching ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'Click here to add address', operator: '%%', action: 'Who', ruleKey: this.props.ruleKey, title: 'Traffic source', description: 'Only show to customers who are coming from a spesific source' });
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitors who is coming from a url matching ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Timer after pageload', description: 'Define how long it should take before the popup is shown after a pageload' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display to visitor \xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 seconds after pageload.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.editDropdown = _this.editDropdown.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        _this.changeDropdown = _this.changeDropdown.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'changeDropdown',
        value: function changeDropdown(value) {
            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));

            this.setState({ value: value });
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'displayText',
        value: function displayText(value) {
            switch (value) {
                case 'mobile':
                    return 'mobile';
                    break;

                case 'desktop':
                    return 'desktop';
                    break;

                default:
                    return 'mobile and desktop';
                    break;
            }
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.displayText(this.state.value),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('mobile');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'mobile'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('desktop');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'desktop'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('both');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'mobile and desktop'
                    )
                )
            );
        }
    }, {
        key: 'editDropdown',
        value: function editDropdown() {
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditingDropdown': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'both', operator: '==', action: 'Who', ruleKey: this.props.ruleKey, title: 'Device', description: 'Only show popup to visitors on a certain device' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display only to visitors using \xA0',
                !this.state.isEditingDropdown ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.editDropdown(e);
                        }, className: 'selected-rule' },
                    this.displayText(this.props.rule.value)
                ) : this.renderDropdown(),
                '\xA0.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this3.props.handleRemove(_this3.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.editDropdown = _this.editDropdown.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        _this.changeDropdown = _this.changeDropdown.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'changeDropdown',
        value: function changeDropdown(value) {
            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));

            this.setState({ value: value });
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'displayText',
        value: function displayText(value) {
            switch (value) {
                case 'anonymous':
                    return 'anonymous';
                    break;

                default:
                    return 'not anonymous';
                    break;
            }
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.displayText(this.state.value),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('anonymous');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'anonymous'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.changeDropdown('known');
                            }, className: 'dropdown-item', role: 'button', tabIndex: '-1' },
                        'not anonymous'
                    )
                )
            );
        }
    }, {
        key: 'editDropdown',
        value: function editDropdown() {
            this.setState({ 'isEditingDropdown': !this.state.isEditingDropdown });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditingDropdown': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'anonymous', operator: '==', action: 'Who', ruleKey: this.props.ruleKey, title: 'Visitor type', description: 'Only show to anonymous or known customers' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display only to \xA0',
                !this.state.isEditingDropdown ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.editDropdown(e);
                        }, className: 'selected-rule' },
                    this.displayText(this.props.rule.value)
                ) : this.renderDropdown(),
                '\xA0visitors.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this3.props.handleRemove(_this3.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'Click here to add address', operator: '%%', action: 'Who', ruleKey: this.props.ruleKey, title: 'Hide from traffic source', description: 'Only show to customers who are not coming from a spesific source' });
            }

            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Don\'t show to visitors who is coming from a url matching ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value;

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));

            if (e.key === 'Enter') {

                this.setState({ value: value });
                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: 'Click here to add address', operator: '%%', action: 'Who', ruleKey: this.props.ruleKey, title: 'Hide on address', description: 'Don\'t show to customers who are visiting a spesific address' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Hide from visitors who is at a url matching ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '*'
                ),
                '.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRuleItem = __webpack_require__(52);

var _AddRuleItem2 = _interopRequireDefault(_AddRuleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleTextChange = _this.handleTextChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.defaultState();
        return _this;
    }

    _createClass(Rule, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false,
                'value': this.props.onlyDescription ? false : this.props.rule.value
            };
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            var value = e.target.value.replace(/[^0-9.]+/g, "");

            this.props.handleChange(this.props.rule.id, _extends({}, this.props.rule, {
                value: value
            }));
            this.setState({ value: value });

            if (e.key === 'Enter') {

                this.swapEdit();
            }
        }
    }, {
        key: 'handleTextChange',
        value: function handleTextChange(e) {
            this.setState({ value: e.target.value });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isEditing) {
                this.refs.valuetext.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.onlyDescription) {
                return _react2.default.createElement(_AddRuleItem2.default, { select: this.props.addRule, value: '0', operator: '>=', action: 'When', ruleKey: this.props.ruleKey, title: 'Display pr day', description: 'Define how many times this popup should be shown to the same customer each day' });
            }
            return _react2.default.createElement(
                'div',
                { className: 'list-group-item blue-grey-500' },
                _react2.default.createElement('i', { className: 'icon wb-arrow-right', 'aria-hidden': 'true' }),
                'Display\xA0',
                !this.state.isEditing ? _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this2.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.props.rule.value == '0' ? '∞' : this.props.rule.value
                ) : _react2.default.createElement(
                    'div',
                    { className: 'form-group form-material' },
                    _react2.default.createElement('input', { type: 'text', ref: 'valuetext', className: 'form-control', style: { width: '60px' }, onChange: this.handleTextChange, onKeyUp: this.handleKeyPress, value: this.state.value })
                ),
                '\xA0 times to the same visitor pr day.',
                _react2.default.createElement(
                    'div',
                    { className: 'remove-rule' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.handleRemove(_this2.props.rule.id);
                            } },
                        _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PickerWidget = __webpack_require__(671);

var _PickerWidget2 = _interopRequireDefault(_PickerWidget);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Step1 = function (_React$Component) {
	_inherits(Step1, _React$Component);

	function Step1(props) {
		_classCallCheck(this, Step1);

		return _possibleConstructorReturn(this, (Step1.__proto__ || Object.getPrototypeOf(Step1)).call(this, props));
	}

	_createClass(Step1, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_OptionColumn2.default,
				{ title: 'Goal', description: 'What is your goal with this ' + (this.props.router.params.type == 'email' ? 'email' : 'popup') },
				_react2.default.createElement(
					'ul',
					{ className: 'list-group list-group-full' },
					this.props.categories.map(function (c) {
						return _react2.default.createElement(_PickerWidget2.default, {
							key: c.id,
							heading: c.title,
							description: c.description,
							image: c.image,
							item: c.id,
							onSelect: _this2.props.onSelect
						});
					})
				)
			);
		}
	}]);

	return Step1;
}(_react2.default.Component);

exports.default = Step1;

/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PickerWidget = __webpack_require__(671);

var _PickerWidget2 = _interopRequireDefault(_PickerWidget);

var _lodash = __webpack_require__(192);

var _lodash2 = _interopRequireDefault(_lodash);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Step2 = function (_React$Component) {
	_inherits(Step2, _React$Component);

	function Step2(props) {
		_classCallCheck(this, Step2);

		var _this = _possibleConstructorReturn(this, (Step2.__proto__ || Object.getPrototypeOf(Step2)).call(this, props));

		_this.findTypes = _this.findTypes.bind(_this);
		return _this;
	}

	_createClass(Step2, [{
		key: 'findTypes',
		value: function findTypes() {
			var types = _lodash2.default.find(this.props.categories, { 'id': this.props.selectedStep1 });

			return !types ? [] : types.types;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (this.props.categories.length == 0 || this.props.selectedStep1 === false) {
				this.props.restart();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			if (this.props.categories.length == 0) {
				return null;
			}
			return _react2.default.createElement(
				_OptionColumn2.default,
				{ title: 'Behaviour', description: 'Select ' + (this.props.router.params.type == 'email' ? 'email' : 'popup') + ' behaviour' },
				_react2.default.createElement(
					'ul',
					{ className: 'list-group list-group-full' },
					this.findTypes().map(function (c) {
						return _react2.default.createElement(_PickerWidget2.default, {
							key: c.id,
							heading: c.title,
							description: c.description,
							image: c.image,
							item: c.id,
							onSelect: _this2.props.onSelect
						});
					})
				)
			);
		}
	}]);

	return Step2;
}(_react2.default.Component);

exports.default = Step2;

/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PickerTemplate = __webpack_require__(1579);

var _PickerTemplate2 = _interopRequireDefault(_PickerTemplate);

var _lodash = __webpack_require__(192);

var _lodash2 = _interopRequireDefault(_lodash);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Step3 = function (_React$Component) {
	_inherits(Step3, _React$Component);

	function Step3(props) {
		_classCallCheck(this, Step3);

		var _this = _possibleConstructorReturn(this, (Step3.__proto__ || Object.getPrototypeOf(Step3)).call(this, props));

		_this.findCategory = _this.findCategory.bind(_this);
		_this.findTemplates = _this.findTemplates.bind(_this);
		return _this;
	}

	_createClass(Step3, [{
		key: 'findCategory',
		value: function findCategory() {
			return _lodash2.default.find(this.props.categories, { 'id': this.props.selectedStep1 });
		}
	}, {
		key: 'findTemplates',
		value: function findTemplates() {
			var category = this.findCategory();

			return !category ? [] : category.templates;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (this.props.categories.length == 0 || this.props.selectedStep1 === false) {
				this.props.restart();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			if (this.props.categories.length == 0) {
				return null;
			}
			return _react2.default.createElement(
				_OptionColumn2.default,
				{ title: 'Template', description: 'Select a template for this ' + (this.props.router.params.type == 'email' ? 'email' : 'popup') },
				_react2.default.createElement(
					'ul',
					{ className: 'list-group list-group-full' },
					this.findTemplates().map(function (c) {
						return _react2.default.createElement(_PickerTemplate2.default, {
							key: c.id,
							item: c.id,
							template: c,
							type: _this2.props.router.params.type,
							onSelect: _this2.props.onSelect
						});
					})
				)
			);
		}
	}]);

	return Step3;
}(_react2.default.Component);

exports.default = Step3;

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PickerTemplate = function (_React$Component) {
    _inherits(PickerTemplate, _React$Component);

    function PickerTemplate(props) {
        _classCallCheck(this, PickerTemplate);

        var _this = _possibleConstructorReturn(this, (PickerTemplate.__proto__ || Object.getPrototypeOf(PickerTemplate)).call(this, props));

        _this.renderImage = _this.renderImage.bind(_this);
        return _this;
    }

    _createClass(PickerTemplate, [{
        key: 'renderImage',
        value: function renderImage() {
            var image = '/images/picker/custom.png';
            if (this.props.template.custom == 1) {
                if (this.props.template.image != 'loading' && this.props.template.image) {
                    image = this.props.template.image;
                }
            } else {
                if (this.props.template.owner_email.image && this.props.template.owner_email.image != 'loading') {
                    image = this.props.template.owner_email.image;
                }
            }

            return image;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'card card-shadow' },
                _react2.default.createElement(
                    'div',
                    { className: 'text-center card-header card-header-transparent card-header-bordered white p-30' },
                    this.props.type == 'email' ? _react2.default.createElement('img', { src: this.renderImage(), style: { width: '400px' } }) : _react2.default.createElement('img', { src: '/images/picker/' + (this.props.template.custom == '1' ? 'custom' : this.props.item) + '.png', style: { width: '250px' } })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-block' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-block btn-dark', onClick: function onClick(e) {
                                e.stopPropagation();_this2.props.onSelect(_this2.props.template.custom == '1' ? _this2.props.item + '-custom' : _this2.props.item);
                            }, style: { borderRadius: 0 } },
                        'Select ',
                        this.props.template.custom == '1' ? '"' + this.props.template.title + '"' : null
                    )
                )
            );
        }
    }]);

    return PickerTemplate;
}(_react2.default.Component);

exports.default = PickerTemplate;

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactCountup = __webpack_require__(672);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _lodash = __webpack_require__(192);

var _lodash2 = _interopRequireDefault(_lodash);

var _uaParserJs = __webpack_require__(396);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _reactChartjs = __webpack_require__(673);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _helpers = __webpack_require__(128);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dashboard = function (_React$Component) {
	_inherits(Dashboard, _React$Component);

	function Dashboard(props) {
		_classCallCheck(this, Dashboard);

		var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

		_this.hasPackage = function () {
			return false;
		};

		_this.blurry = function () {
			if (_this.hasPackage()) {
				return '';
			}

			return 'blurred';
		};

		_this.updateStats = function () {
			var today = (0, _moment2.default)().format();
			_axios2.default.get('/orders/stats?date=' + encodeURIComponent(today)).then(function (res) {
				_this.setState({
					referrer: res.data.referrer,
					orders: res.data.orders,
					subtotal: res.data.subtotal,
					average_subtotal_sum: res.data.average_subtotal_sum,
					average_total_orders: res.data.average_total_orders,
					today_subtotal_sum: res.data.today_subtotal_sum,
					today_total_orders: res.data.today_total_orders,
					week_subtotal_sum: res.data.week_subtotal_sum,
					week_total_orders: res.data.week_total_orders
				});
			});
		};

		_this.interval = null;
		_this.updateStatsInterval = null;

		_this.state = {
			total_cart_sum: 0,
			total_visitors: 0,
			known_visitors: 0,
			referrer: [],
			mobile: 0,
			score: [],
			desktop: 0,
			popularPages: [],
			popularProducts: [],
			interval: null,
			orders: {},
			subtotal: {},
			average_subtotal_sum: 0,
			average_total_orders: 0,
			today_subtotal_sum: 0,
			today_total_orders: 0,
			week_subtotal_sum: 0,
			week_total_orders: 0,
			total_carts: 0

		};

		_this.options = {
			responsiveAnimationDuration: 0,
			showLines: true,
			responsive: true,
			animation: {
				duration: 0
			},
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					ticks: {
						display: false
					},
					gridLines: {
						display: false
					},
					display: false
				}],
				yAxes: [{
					display: false,
					ticks: {
						display: false
					},
					gridLines: {
						display: false
					}
				}]
			}
		};

		_this.oldState = _extends({}, _this.state);

		_this.placeholderSize = 80;
		_this.recalculate = _this.recalculate.bind(_this);
		_this.renderPopularPages = _this.renderPopularPages.bind(_this);
		_this.renderMostValuableCustomer = _this.renderMostValuableCustomer.bind(_this);
		return _this;
	}

	_createClass(Dashboard, [{
		key: 'renderRevenueBySourceTable',
		value: function renderRevenueBySourceTable() {
			var data = this.placeholderRow(4, 4);

			for (var i in this.state.referrer) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: i, className: '' + this.blurry() },
					_react2.default.createElement(
						'td',
						null,
						parseInt(i) + 1,
						'.'
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.referrer[i].referrer
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.referrer[i].sum
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.referrer[i].orders
					)
				);
			}

			return data;
		}
	}, {
		key: 'renderRevenueBySource',
		value: function renderRevenueBySource() {
			return _react2.default.createElement(
				'div',
				{ className: 'card-block p-0' },
				_react2.default.createElement(
					'div',
					{ className: this.state.referrer.length == 0 ? 'col-sm-12' : 'col-sm-7' },
					_react2.default.createElement(
						'table',
						{ className: 'table ' + (this.state.referrer.length == 0 ? '' : 'split-right') },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'#'
								),
								_react2.default.createElement(
									'th',
									null,
									'Source'
								),
								_react2.default.createElement(
									'th',
									null,
									'Sum'
								),
								_react2.default.createElement(
									'th',
									null,
									'Number of orders'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							this.renderRevenueBySourceTable()
						)
					)
				),
				this.state.referrer.length > 0 ? _react2.default.createElement(
					'div',
					{ className: 'col-sm-5' },
					this.renderRevenueBySourceGraph()
				) : null
			);
		}
	}, {
		key: 'renderRevenueBySourceGraph',
		value: function renderRevenueBySourceGraph() {
			var labels = [];
			var orders = [];

			for (var i in this.state.referrer) {
				labels.push(this.state.referrer[i].referrer);
				orders.push(this.state.referrer[i].raw);
			}

			var data = {
				labels: labels,
				datasets: [{
					data: orders,
					backgroundColor: ['#FA9898', '#A2CAEE', '#7DD3AE', '#F8E59B'],
					hoverBackgroundColor: ['#FA9898', '#A2CAEE', '#7DD3AE', '#F8E59B']
				}]
			};

			var options = {
				responsive: true,
				animation: {
					animateScale: false
				},
				legend: {
					labels: {}
				},
				tooltips: {
					enabled: false
				}
			};

			return _react2.default.createElement(_reactChartjs.Pie, { data: data, height: 100, options: options });
		}
	}, {
		key: 'renderWeeklyOrderGraph',
		value: function renderWeeklyOrderGraph() {

			var orders = [];
			var haveData = false;

			for (var i in this.state.orders) {
				if (this.state.orders[i] != 0) {
					haveData = true;
				}
				orders.push(this.state.orders[i]);
			}

			//if(!haveData) {
			return null;
			//}

			var data = {
				labels: Object.keys(this.state.orders),
				datasets: [{
					label: 'Orders: ',
					fill: true,
					lineTension: 0.1,
					backgroundColor: 'rgba(42, 54, 60,0.5)',
					borderColor: 'rgba(42, 54, 60,0.5)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(42, 54, 60,1)',
					pointBackgroundColor: '#fff',
					pointBorderWidth: 0,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: '#ffffff',
					pointHoverBorderColor: '#ffffff',
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,
					data: orders
				}]
			};

			return _react2.default.createElement(_reactChartjs.Line, { data: data, height: 100, options: this.options });
		}
	}, {
		key: 'renderWeeklySubtotalGraph',
		value: function renderWeeklySubtotalGraph() {

			var orders = [];
			var haveData = false;

			for (var i in this.state.subtotal) {
				if (this.state.subtotal[i] != 0) {
					haveData = true;
				}
				orders.push(this.state.subtotal[i]);
			}

			//if(!haveData) {
			return null;
			//}

			var data = {
				labels: Object.keys(this.state.subtotal),
				datasets: [{
					label: 'Orders: ',
					fill: true,
					lineTension: 0.1,
					backgroundColor: 'rgba(42, 54, 60,0.5)',
					borderColor: 'rgba(42, 54, 60,0.5)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(42, 54, 60,1)',
					pointBackgroundColor: '#fff',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: '#ffffff',
					pointHoverBorderColor: '#ffffff',
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,
					data: orders
				}]
			};

			return _react2.default.createElement(_reactChartjs.Line, { data: data, height: 100, options: this.options });
		}
	}, {
		key: 'placeholder',
		value: function placeholder() {
			return _react2.default.createElement(
				'span',
				{ className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
				'\xA0'
			);
		}
	}, {
		key: 'placeholderRow',
		value: function placeholderRow(rows, cols) {
			var td = [];
			for (var i = 1; i <= cols; i++) {
				td.push(_react2.default.createElement(
					'td',
					{ key: i },
					this.placeholder()
				));
			}

			var row = [];
			for (var _i = 1; _i <= rows; _i++) {
				row.push(_react2.default.createElement(
					'tr',
					{ key: _i },
					td
				));
			}

			return row;
		}
	}, {
		key: 'renderScore',
		value: function renderScore(score) {
			var color = '';

			if (score > 90) {
				color = '#cc0000';
			} else if (score > 80) {
				color = '#ff0000';
			} else if (score > 50) {
				color = '#ff3300';
			} else if (score > 20) {
				color = '#ff5c33';
			} else {
				color = '#000000';
			}

			return _react2.default.createElement(
				'span',
				{ style: { color: color } },
				score
			);
		}
	}, {
		key: 'renderMostValuableCustomer',
		value: function renderMostValuableCustomer() {
			var data = this.placeholderRow(5, 6);

			var dataCounter = 0;
			for (var i in this.state.score) {

				if (this.state.score[i].online === 0) {
					continue;
				}

				data[dataCounter] = _react2.default.createElement(
					'tr',
					{ key: this.state.score[i].uid, className: '' + this.blurry() },
					_react2.default.createElement(
						'td',
						null,
						this.state.score[i].name ? this.state.score[i].name : this.state.score[i].email !== "" && typeof this.state.score[i].email === 'string' ? this.state.score[i].email : 'Unknown'
					),
					_react2.default.createElement(
						'td',
						null,
						parseInt(this.state.score[i].isMobile) === 0 ? _react2.default.createElement('i', { className: 'icon fa-desktop', style: { fontSize: '20px' }, 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'icon fa-mobile-phone', style: { fontSize: '20px' }, 'aria-hidden': 'true' })
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.score[i].path
					),
					_react2.default.createElement(
						'td',
						null,
						'-'
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.score[i].cart_total
					),
					_react2.default.createElement(
						'td',
						null,
						this.hasPackage() ? _react2.default.createElement(
							_reactRouter.Link,
							{ to: _General2.default.Link('/chat/' + this.props.auth.user.id + '/' + this.state.score[i].uid), className: 'btn btn-sm btn-dark btn-icon' },
							_react2.default.createElement('i', { className: 'icon wb-chat' })
						) : null
					)
				);

				dataCounter = dataCounter + 1;
			}

			return data;
		}
	}, {
		key: 'renderPopularProducts',
		value: function renderPopularProducts() {
			var data = this.placeholderRow(5, 2);

			for (var i in this.state.popularProducts) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: i, className: '' + this.blurry() },
					_react2.default.createElement(
						'td',
						null,
						this.state.popularProducts[i].name
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.popularProducts[i].count
					)
				);
			}
			return data;
		}
	}, {
		key: 'renderPopularPages',
		value: function renderPopularPages() {
			var data = this.placeholderRow(5, 3);

			for (var i in this.state.popularPages) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: i, className: 'counter-number ' + this.blurry() },
					_react2.default.createElement(
						'td',
						null,
						this.state.popularPages[i].title
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.popularPages[i].path
					),
					_react2.default.createElement(
						'td',
						null,
						this.state.popularPages[i].visitors
					)
				);
			}
			return data;
		}
	}, {
		key: 'recalculate',
		value: function recalculate() {
			var cart_sum = 0;
			var mobile = 0;
			var desktop = 0;
			var visitors = 0;
			var pages = [];
			var products = [];
			var known = 0;
			var score = [];
			var total_carts = 0;

			for (var i in this.props.chat.cart) {
				var cart = this.props.chat.cart[i];
				var visitor = this.props.chat.visitors[i];

				if (typeof this.props.chat.visitors[i] !== 'undefined') {
					if (visitor.online === 0) {
						continue;
					}
				}

				for (var pI in cart) {
					var found_p = false;
					for (var pI2 in products) {
						if (products[pI2].id == cart[pI].id) {
							products[pI2].count = parseInt(cart[pI].quantity) + products[pI2].count;
							found_p = true;
						}
					}

					if (!found_p) {
						products.push({
							name: cart[pI].name,
							id: cart[pI].id,
							count: parseInt(cart[pI].quantity)
						});
					}
				}
			}

			for (var _i2 in this.props.chat.visitors) {
				var _visitor = this.props.chat.visitors[_i2];

				if (_visitor.online === 0) {
					continue;
				}
				cart_sum += parseInt(_visitor.cart_total);

				if (parseInt(_visitor.cart_total) > 0) {
					total_carts++;
				}
				visitors++;
				if (_visitor.isMobile === 1) {
					mobile++;
				} else {
					desktop++;
				}

				if (_visitor.email !== "" && typeof _visitor.email === 'string') {
					known++;
				}

				var found_page = false;
				for (var _pI in pages) {
					if (pages[_pI].path == _visitor.path) {
						pages[_pI].visitors++;
						found_page = true;
					}
				}
				if (!found_page) {
					pages.push({
						url: _visitor.url,
						path: _visitor.path,
						title: _visitor.page_title,
						visitors: 1
					});
				}
			}

			pages = _lodash2.default.sortBy(pages, 'visitors').reverse();
			pages = pages.slice(0, 5);

			products = _lodash2.default.sortBy(products, 'count').reverse();
			products = products.slice(0, 5);

			score = _lodash2.default.sortBy(this.props.chat.visitors, 'score').reverse();
			score = _lodash2.default.filter(score, function (visitor) {
				return visitor.online === 1;
			});
			score = score.slice(0, 5);

			if (desktop > 0) {
				desktop = desktop * 100 / visitors;
				desktop = Math.floor(desktop);
				mobile = 100 - desktop;
			}

			if (known > 0) {
				known = known * 100 / visitors;
			}

			this.oldState = _extends({}, this.state);

			this.setState({
				total_cart_sum: cart_sum,
				total_visitors: visitors,
				known_visitors: known,
				popularPages: pages,
				popularProducts: products,
				score: score,
				desktop: desktop,
				mobile: mobile,
				total_carts: total_carts
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearInterval(this.interval);
			clearInterval(this.updateStatsInterval);
			/*
   		this.setState({
   			interval:null,
   		});*/
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.recalculate();
			this.interval = setInterval(this.recalculate, 3400);
			this.updateStatsInterval = setInterval(this.updateStats, 30000);
			/*
           this.setState({
               interval:intervalID,
           });*/

			this.updateStats();
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ style: {
						position: 'absolute',
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(241, 244, 245, 0.8705882352941177)',
						zIndex: 999
					} },
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 text-center' },
						_react2.default.createElement(
							'h3',
							null,
							'Kontrollpanelet er flyttet'
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', justifyContent: 'center', width: '100%' } },
							_react2.default.createElement(
								'button',
								{ onClick: function onClick() {
										return _helpers2.default.redirectToNewAdmin();
									}, style: { width: '200px' }, className: 'btn btn-success btn-icon btn-block' },
								'G\xE5 til nytt kontrollpanel'
							)
						)
					)
				)
			);

			return _react2.default.createElement(
				'div',
				{ id: 'dashboard', className: 'page-content' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Dashboard | Crall.io' }),
				this.hasPackage() ? null : _react2.default.createElement(
					'div',
					{ style: {
							position: 'absolute',
							width: '100%',
							height: '100%',
							backgroundColor: 'rgba(241, 244, 245, 0.8705882352941177)',
							zIndex: 999
						} },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12 text-center' },
							_react2.default.createElement(
								'h3',
								null,
								'Kontrollpanelet er flyttet'
							),
							_react2.default.createElement(
								'h5',
								null,
								'This page will show you live customer data from your store. How much each customer has in their cart, what products are popular and what pages they\'re browsing.'
							),
							_react2.default.createElement(
								'h5',
								null,
								'You don\'t have access to this feature. You need to subscribe to the "Platform Package" to gain access.'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-3' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-block p-30' },
							_react2.default.createElement(
								'div',
								{ className: 'card-watermark blue-grey-500 font-size-60 m-15' },
								_react2.default.createElement('i', { className: 'icon wb-shopping-cart', 'aria-hidden': 'true' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'counter counter-md counter-inverse text-xs-left' },
								_react2.default.createElement(
									'div',
									{ className: 'counter-number-group ' },
									_react2.default.createElement(
										'span',
										{ className: 'counter-number blue-grey-500 ' + this.blurry() },
										_react2.default.createElement(_reactCountup2.default, { start: this.oldState.total_cart_sum, end: this.state.total_cart_sum, duration: 2 })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart-total' },
									this.state.total_carts > 0 ? this.state.total_carts : null
								),
								_react2.default.createElement(
									'div',
									{ className: 'counter-label blue-grey-500 text-capitalize' },
									'total cart sum'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-3' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-block p-30' },
							_react2.default.createElement(
								'div',
								{ className: 'card-watermark blue-grey-500 font-size-60 m-15' },
								_react2.default.createElement('i', { className: 'icon wb-eye', 'aria-hidden': 'true' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'counter counter-md counter-inverse text-xs-left' },
								_react2.default.createElement(
									'div',
									{ className: 'counter-number-group ' },
									_react2.default.createElement(
										'span',
										{ className: 'counter-number blue-grey-500 ' + this.blurry() },
										_react2.default.createElement(_reactCountup2.default, { start: this.oldState.total_visitors, end: this.state.total_visitors, duration: 2 })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'counter-label blue-grey-500 text-capitalize' },
									'Active visitors'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-3' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-block p-30' },
							_react2.default.createElement(
								'div',
								{ className: 'card-watermark blue-grey-500 font-size-60 m-15' },
								_react2.default.createElement('i', { className: 'icon wb-user-circle', 'aria-hidden': 'true' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'counter counter-md counter-inverse text-xs-left' },
								_react2.default.createElement(
									'div',
									{ className: 'counter-number-group ' },
									_react2.default.createElement(
										'span',
										{ className: 'counter-number blue-grey-500' },
										_react2.default.createElement(
											'div',
											{ className: 'progress progress-xl m-b-10', style: { height: '37px' } },
											_react2.default.createElement('div', { className: 'progress-bar progress-bar-striped progress-bar-info bg-blue-600', style: { width: this.state.known_visitors + '%' }, 'aria-valuenow': '70.3', 'aria-valuemin': '0', 'aria-valuemax': '100', role: 'progressbar' })
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'counter-label blue-grey-500 text-capitalize' },
									'Known visitors'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-3' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-block p-30' },
							_react2.default.createElement(
								'div',
								{ className: 'card-watermark blue-grey-500 font-size-60 m-15' },
								_react2.default.createElement('i', { className: 'icon wb-desktop', 'aria-hidden': 'true' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'counter counter-md counter-inverse text-xs-left' },
								_react2.default.createElement(
									'div',
									{ className: 'counter-number-group ' },
									_react2.default.createElement(
										'span',
										{ className: 'counter-number blue-grey-500' },
										_react2.default.createElement(
											'div',
											{ className: 'progress progress-xl m-b-10', style: { height: '37px' } },
											_react2.default.createElement('div', { className: 'progress-bar progress-bar-primary progress-bar-striped', style: { width: this.state.mobile + '%' }, role: 'progressbar' }),
											_react2.default.createElement('div', { className: 'progress-bar progress-bar-success progress-bar-striped', style: { width: this.state.desktop + '%' }, role: 'progressbar' })
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'counter-label blue-grey-500 text-capitalize' },
									_react2.default.createElement(
										'span',
										{ className: 'margin-left-15 font-weight-400' },
										_react2.default.createElement('i', { className: 'fa fa-square', style: { color: '#62a8ea' }, 'aria-hidden': 'true' }),
										' Mobile / \xA0\xA0',
										_react2.default.createElement('i', { className: 'fa fa-square', style: { color: '#46be8a' }, 'aria-hidden': 'true' }),
										' Desktop'
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-6' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-graph-up' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Weekly orders'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Today'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.today_total_orders
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Average'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.average_total_orders
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Week'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.week_total_orders
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-block p-0' },
								this.renderWeeklyOrderGraph()
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-6' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-graph-up' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Weekly order sum'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Today'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.today_subtotal_sum
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Average'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.average_subtotal_sum
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4' },
										_react2.default.createElement(
											'div',
											{ className: 'counter counter-sm' },
											_react2.default.createElement(
												'div',
												{ className: 'counter-label text-uppercase' },
												'Week'
											),
											_react2.default.createElement(
												'div',
												{ className: 'counter-number-group' },
												_react2.default.createElement(
													'span',
													{ className: 'counter-number green-600 ' + this.blurry() },
													this.state.week_subtotal_sum
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-block p-0' },
								this.renderWeeklySubtotalGraph()
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-shopping-cart' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Most valuable customers right now'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-block p-0' },
								_react2.default.createElement(
									'table',
									{ className: 'table' },
									_react2.default.createElement(
										'thead',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'th',
												null,
												'Customer name'
											),
											_react2.default.createElement(
												'th',
												null,
												'Device'
											),
											_react2.default.createElement(
												'th',
												null,
												'Page'
											),
											_react2.default.createElement(
												'th',
												null,
												'Latest order'
											),
											_react2.default.createElement(
												'th',
												null,
												'Cart sum'
											),
											_react2.default.createElement(
												'th',
												null,
												'Actions'
											)
										)
									),
									_react2.default.createElement(
										'tbody',
										null,
										this.renderMostValuableCustomer()
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-link' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Top 5 revenue sources'
								)
							),
							this.renderRevenueBySource()
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-users' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Most popular pages right now'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-block p-0' },
								_react2.default.createElement(
									'table',
									{ className: 'table' },
									_react2.default.createElement(
										'thead',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'th',
												null,
												'Page'
											),
											_react2.default.createElement(
												'th',
												null,
												'Url'
											),
											_react2.default.createElement(
												'th',
												null,
												'Visitors'
											)
										)
									),
									_react2.default.createElement(
										'tbody',
										null,
										this.renderPopularPages()
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'div',
							{ className: 'card card-shadow p-0' },
							_react2.default.createElement(
								'div',
								{ className: 'card-header card-header-transparent card-header-bordered' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-sm btn-dark' },
									_react2.default.createElement('i', { className: 'icon wb-users' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'm-l-15 font-weight-400' },
									'Most popular products right now'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-block p-0' },
								_react2.default.createElement(
									'table',
									{ className: 'table' },
									_react2.default.createElement(
										'thead',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'th',
												null,
												'Name'
											),
											_react2.default.createElement(
												'th',
												null,
												'Quantity'
											)
										)
									),
									_react2.default.createElement(
										'tbody',
										null,
										this.renderPopularProducts()
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return Dashboard;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general,
		chat: state.chat
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Dashboard = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboard);
exports.default = Dashboard;

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.history = undefined;

var _reducers = __webpack_require__(863);

var _reducers2 = _interopRequireDefault(_reducers);

var _redux = __webpack_require__(4);

var _reactRouterRedux = __webpack_require__(487);

var _reactRouter = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = {};

var store = void 0;

if (true) {
    store = (0, _redux.createStore)(_reducers2.default);
} else {
    store = (0, _redux.createStore)(_reducers2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
}

var history = exports.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, store);

exports.default = store;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.switchChatStatus = switchChatStatus;
exports.addMessage = addMessage;
exports.setVisitorKey = setVisitorKey;
exports.chatSetGlobalKey = chatSetGlobalKey;
exports.addCarts = addCarts;
exports.addPages = addPages;
exports.addVisitors = addVisitors;
exports.setInit = setInit;
exports.setAssignee = setAssignee;
exports.removeVisitor = removeVisitor;
exports.removeFilterOption = removeFilterOption;
exports.setFilterOption = setFilterOption;
exports.resetFilterOption = resetFilterOption;
exports.addVisitor = addVisitor;
exports.updateVisitor = updateVisitor;
exports.setOpenChat = setOpenChat;
exports.addVisitorData = addVisitorData;
exports.setCurrentTab = setCurrentTab;
function switchChatStatus() {
	var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'none';

	return {
		type: 'CHAT_SET_STATUS',
		payload: status
	};
}

function addMessage(uid, message) {
	return {
		type: 'CHAT_ADD_MESSAGE',
		payload: { uid: uid, message: message }
	};
}

function setVisitorKey(uid, key, value) {
	return {
		type: 'CHAT_SET_VISITOR_KEY',
		payload: { uid: uid, key: key, value: value }
	};
}

function chatSetGlobalKey(key, value) {
	return {
		type: 'CHAT_SET_GLOBAL_KEY',
		payload: { key: key, value: value }
	};
}

function addCarts(carts) {
	return {
		type: 'CHAT_ADD_CARTS',
		payload: carts
	};
}

function addPages(pages) {
	return {
		type: 'CHAT_ADD_PAGES',
		payload: pages
	};
}

function addVisitors(visitors) {
	return {
		type: 'CHAT_ADD_VISITORS',
		payload: visitors
	};
}
function setInit(status) {
	return {
		type: 'CHAT_SET_INIT',
		payload: status
	};
}

function setAssignee(user_id, uid) {
	return {
		type: 'CHAT_SET_ASSIGNEE',
		payload: { uid: uid, user_id: user_id }
	};
}
function removeVisitor(uid) {
	return {
		type: 'CHAT_REMOVE_VISITOR',
		payload: uid
	};
}
function removeFilterOption(index) {
	return {
		type: 'CHAT_REMOVE_FILTER_OPTION',
		payload: index
	};
}
function setFilterOption(option) {
	return {
		type: 'CHAT_SET_FILTER_OPTION',
		payload: option
	};
}
function resetFilterOption() {
	return {
		type: 'CHAT_RESET_FILTER',
		payload: true
	};
}
function addVisitor(visitor) {
	return {
		type: 'CHAT_ADD_VISITOR',
		payload: visitor
	};
}
function updateVisitor(visitor) {
	return {
		type: 'CHAT_UPDATE_VISITOR',
		payload: visitor
	};
}
function setOpenChat(uid, tab) {
	return {
		type: 'CHAT_SET_OPEN_CHAT',
		payload: { uid: uid, tab: tab }
	};
}

function addVisitorData(key, uid, data) {
	return {
		type: 'CHAT_ADD_VISITOR_DATA',
		payload: { key: key, uid: uid, data: data }
	};
}

function setCurrentTab(tab) {
	return {
		type: 'CHAT_SET_TAB',
		payload: tab
	};
}

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Protected = function (_React$Component) {
	_inherits(Protected, _React$Component);

	function Protected() {
		_classCallCheck(this, Protected);

		return _possibleConstructorReturn(this, (Protected.__proto__ || Object.getPrototypeOf(Protected)).apply(this, arguments));
	}

	_createClass(Protected, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				this.props.children
			);
		}
	}]);

	return Protected;
}(_react2.default.Component);

exports.default = Protected;

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _reactRouter = __webpack_require__(6);

var _redux = __webpack_require__(4);

var _General = __webpack_require__(53);

var _Login = __webpack_require__(75);

var _Chat = __webpack_require__(161);

var _SocketManager = __webpack_require__(334);

var _SocketManager2 = _interopRequireDefault(_SocketManager);

var _BrowserNotification = __webpack_require__(535);

var _BrowserNotification2 = _interopRequireDefault(_BrowserNotification);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _General2 = __webpack_require__(8);

var _General3 = _interopRequireDefault(_General2);

var _General4 = __webpack_require__(44);

var _General5 = _interopRequireDefault(_General4);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _reactHotkeys = __webpack_require__(1635);

var _CompanySearch = __webpack_require__(1640);

var _CompanySearch2 = _interopRequireDefault(_CompanySearch);

var _Chat2 = __webpack_require__(161);

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _YesNo = __webpack_require__(1644);

var _YesNo2 = _interopRequireDefault(_YesNo);

var _AcceptTerms = __webpack_require__(1645);

var _AcceptTerms2 = _interopRequireDefault(_AcceptTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var map = {
    toggleSearchCompany: "ctrl+shift+k",
    toggleFullScreen: "ctrl+shift+f"
};

var FullPage = function (_React$Component) {
    _inherits(FullPage, _React$Component);

    function FullPage(props) {
        _classCallCheck(this, FullPage);

        var _this = _possibleConstructorReturn(this, (FullPage.__proto__ || Object.getPrototypeOf(FullPage)).call(this, props));

        _this.toggleDealerSearch = function () {
            _this.props.setGlobalKey("dealerSearchOpen", !_this.props.general.dealerSearchOpen);
        };

        _this.toggleFullScreen = function () {
            _this.props.setGlobalKey("fullScreen", !_this.props.general.fullScreen);
        };

        _this.switchChatStatus = _this.switchChatStatus.bind(_this);
        _this.toggleSidebar = _this.toggleSidebar.bind(_this);
        _this.toggleSearchCompany = _this.toggleSearchCompany.bind(_this);
        _this.switchAccount = _this.switchAccount.bind(_this);
        return _this;
    }

    _createClass(FullPage, [{
        key: "toggleSidebar",
        value: function toggleSidebar() {
            this.props.setGlobalKey("sidebarOpen", !this.props.general.sidebarOpen);
        }
    }, {
        key: "switchChatStatus",
        value: function switchChatStatus(status) {
            _SocketManager2.default.setOnline(status);
        }
    }, {
        key: "toggleSearchCompany",
        value: function toggleSearchCompany() {
            if (!_Auth2.default.isStaff()) {
                return;
            }
            this.props.setGlobalKey("companySearchOpen", !this.props.general.companySearchOpen);
        }
    }, {
        key: "handleLogout",
        value: function handleLogout(e) {
            e.stopPropagation();
            _Auth2.default.authenticate(false);
            this.props.setCurrentUser(false);
            this.props.router.push("/login");
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {}
    }, {
        key: "switchAccount",
        value: function switchAccount(e, id) {
            e.stopPropagation();
            this.props.router.push("/" + id + "/dashboard");
            location.reload();
        }
    }, {
        key: "trialExpired",
        value: function trialExpired() {
            if (this.props.general.account.expired == true && !_Auth2.default.isStaff()) {
                if (!this.props.router.isActive(_General3.default.LinkIsActive("/settings/billing"))) {
                    this.props.router.push(_General3.default.Link("/settings/billing/subscribe"));
                }
            }
        }
    }, {
        key: "onboardingComplete",
        value: function onboardingComplete() {
            if (this.props.general.settings.ONBOARDING == 0) {
                if (!this.props.router.isActive(_General3.default.LinkIsActive("/setup"))) {
                    this.props.router.push(_General3.default.Link("/setup"));
                }
            }
        }
    }, {
        key: "runChecks",
        value: function runChecks() {
            this.trialExpired();
            this.onboardingComplete();

            if (this.props.general.settings.ONBOARDING == 1 && !localStorage.getItem("getting_started")) {
                if (!this.props.router.isActive(_General3.default.LinkIsActive("/welcome"))) {
                    this.props.router.push(_General3.default.Link("/welcome"));
                }
            }

            if (this.props.auth.loadedVisitors === false) {
                this.props.setLoadedVisitors(true);

                _SocketManager2.default.loadStaticVisitorList();
            }

            if (this.props.general.sidebarOpen) {
                document.body.classList.add("site-menubar-open");
                document.body.classList.remove("site-menubar-hide");
            } else {
                document.body.classList.remove("site-menubar-open");
                document.body.classList.add("site-menubar-hide");
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.runChecks();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.runChecks();
        }
    }, {
        key: "menuSettings",
        value: function menuSettings() {
            return _react2.default.createElement(
                "ul",
                { className: "site-menu", "data-plugin": "menu" },
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-category" },
                    "Settings"
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/me") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-user",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Profile"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/users") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-users",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Users"
                        )
                    )
                ),
                this.props.general.settings.PACKAGE_CHAT == "1" ? _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/chat") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-chat",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Chat"
                        )
                    )
                ) : null,
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/emails") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-envelope",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "E-mails"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/company") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-briefcase",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Company"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/discount") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-tag",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Discount"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/billing") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-payment",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Billing"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/billing/invoices") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-order",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Invoices"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/settings/sync") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-code-working",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Data sync"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/events") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon fa-list",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Events"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item m-t-20" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/dashboard") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-arrow-left",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Back"
                        )
                    )
                )
            );
        }
    }, {
        key: "menuNormal",
        value: function menuNormal() {
            var _this2 = this;

            return _react2.default.createElement(
                "ul",
                { className: "site-menu", "data-plugin": "menu" },
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-category" },
                    "General"
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        "a",
                        { href: _General3.default.Link2("/dashboard") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-heart",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "New admin"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/dashboard") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-dashboard",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Dashboard"
                        )
                    )
                ),
                this.props.general.settings.PACKAGE_CHAT == "1" ? _react2.default.createElement(
                    "li",
                    { className: "site-menu-item hidden-sm-down" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/chat") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-chat",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Chat"
                        )
                    )
                ) : null,
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General3.default.Link("/insights") },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-graph-up",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Insights"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item m-t-10" },
                    _react2.default.createElement(
                        "a",
                        {
                            href: "https://support.mystore.no/no-no/knowledge/crall",
                            target: "blank"
                        },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-help",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Help"
                        )
                    )
                ),
                _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        "a",
                        {
                            onClick: function onClick(e) {
                                return _this2.handleLogout(e);
                            },
                            href: "javascript:void(0)"
                        },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-power",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Logout"
                        )
                    )
                ),
                this.props.auth.user.dealer_id ? _react2.default.createElement(
                    "li",
                    { className: "site-menu-category" },
                    "Dealer"
                ) : null,
                this.props.auth.user.dealer_id ? _react2.default.createElement(
                    "li",
                    { className: "site-menu-item" },
                    _react2.default.createElement(
                        "a",
                        {
                            href: "javascript:void(0)",
                            onClick: this.toggleDealerSearch
                        },
                        _react2.default.createElement("i", {
                            className: "site-menu-icon wb-extension",
                            "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                            "span",
                            { className: "site-menu-title" },
                            "Customers"
                        )
                    )
                ) : null
            );
        }
    }, {
        key: "renderMenuItems",
        value: function renderMenuItems() {
            if (this.props.router.isActive(_General3.default.LinkIsActive("/settings"))) {
                return this.menuSettings();
            }

            if (this.props.router.isActive(_General3.default.LinkIsActive("/staff"))) {
                return this.menuStaff();
            }

            return this.menuNormal();
        }
    }, {
        key: "renderMenu",
        value: function renderMenu() {
            var _this3 = this;

            var usage = parseInt(this.props.general.settings.CURRENT_USAGE * 100 / this.props.general.settings.QUOTA);
            return _react2.default.createElement(
                "div",
                { className: "site-menubar" },
                _react2.default.createElement(
                    "div",
                    { className: "site-menubar-body" },
                    _react2.default.createElement(
                        "div",
                        null,
                        _react2.default.createElement(
                            "div",
                            null,
                            this.props.general.account.trial ? _react2.default.createElement(
                                "div",
                                { className: " ribbon-clip ribbon ribbon-reverse ribbon-danger" },
                                _react2.default.createElement(
                                    "span",
                                    { className: "ribbon-inner" },
                                    "Trial ends",
                                    " ",
                                    (0, _moment2.default)().to(this.props.general.account.trial_ends_at)
                                )
                            ) : null,
                            this.props.general.settings.PACKAGE_CHAT == "1" ? _react2.default.createElement(
                                "div",
                                {
                                    className: "site-menubar-section",
                                    style: {
                                        marginBottom: 0,
                                        textAlign: "center"
                                    }
                                },
                                _react2.default.createElement(
                                    "div",
                                    { className: "btn-group", role: "group" },
                                    _react2.default.createElement(
                                        "button",
                                        {
                                            type: "button",
                                            className: "btn btn-dark dropdown-toggle",
                                            "data-toggle": "dropdown",
                                            "aria-expanded": "false"
                                        },
                                        this.props.chat.isOnline ? _react2.default.createElement(
                                            "span",
                                            null,
                                            _react2.default.createElement("i", {
                                                className: "icon wb-large-point",
                                                style: {
                                                    color: "#1eb848"
                                                },
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            "Agent: Online"
                                        ) : _react2.default.createElement(
                                            "span",
                                            null,
                                            _react2.default.createElement("i", {
                                                className: "icon wb-large-point",
                                                style: {
                                                    color: "#b81e1e"
                                                },
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            "Agent: Offline"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        {
                                            className: "dropdown-menu",
                                            style: { width: "50%" },
                                            role: "menu"
                                        },
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                className: "dropdown-item",
                                                onClick: function onClick() {
                                                    return _this3.switchChatStatus(true);
                                                },
                                                role: "menuitem"
                                            },
                                            _react2.default.createElement("i", {
                                                className: "icon wb-large-point",
                                                style: { color: "#1eb848" },
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            "Online"
                                        ),
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                className: "dropdown-item",
                                                onClick: function onClick() {
                                                    return _this3.switchChatStatus(false);
                                                },
                                                role: "menuitem"
                                            },
                                            _react2.default.createElement("i", {
                                                className: "icon wb-large-point",
                                                style: { color: "#b81e1e" },
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            "Offline"
                                        )
                                    )
                                )
                            ) : null,
                            this.renderMenuItems()
                        )
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var handlers = {
                toggleSearchCompany: this.toggleSearchCompany,
                toggleFullScreen: this.toggleFullScreen
            };

            var unreadMessages = 0;
            var yourConversations = 0;
            var unassignedConversations = 0;

            for (var i in this.props.chat.visitors) {
                var visitor = this.props.chat.visitors[i];
                if (visitor.assignee_id == this.props.auth.user.id) {
                    yourConversations++;
                }

                if (visitor.assignee_id == 0 && visitor.started == 1) {
                    unassignedConversations++;
                }

                if ((visitor.assignee_id == this.props.auth.user.id || visitor.assignee_id == 0) && visitor.unreadMessages > 0) {
                    unreadMessages++;
                }
            }

            return _react2.default.createElement(
                _reactHotkeys.HotKeys,
                { handlers: handlers, keyMap: map, focused: true },
                _react2.default.createElement(
                    "div",
                    {
                        className: "full-height " + (this.props.general.fullScreen ? "fullscreen-mode" : "")
                    },
                    this.props.general.showProcessing ? _react2.default.createElement(
                        "div",
                        { className: "full-page-transparent-loading" },
                        _react2.default.createElement(
                            "div",
                            { className: "lds-ring" },
                            _react2.default.createElement("div", null),
                            _react2.default.createElement("div", null),
                            _react2.default.createElement("div", null),
                            _react2.default.createElement("div", null)
                        ),
                        _react2.default.createElement(
                            "div",
                            {
                                style: {
                                    paddingLeft: "20px",
                                    fontWeight: "bold"
                                }
                            },
                            "Processing.."
                        )
                    ) : null,
                    _react2.default.createElement(
                        "nav",
                        {
                            className: "site-navbar navbar navbar-default navbar-fixed-top navbar-mega",
                            role: "navigation"
                        },
                        _react2.default.createElement(
                            "div",
                            { className: "navbar-header" },
                            _react2.default.createElement(
                                "button",
                                {
                                    type: "button",
                                    onClick: this.toggleSidebar,
                                    style: { zIndex: 3 },
                                    className: "navbar-toggler hamburger hamburger-close navbar-toggler-left hided",
                                    "data-toggle": "menubar"
                                },
                                _react2.default.createElement(
                                    "span",
                                    { className: "sr-only" },
                                    "Toggle navigation"
                                ),
                                _react2.default.createElement("span", { className: "hamburger-bar" })
                            ),
                            _react2.default.createElement(
                                "button",
                                {
                                    type: "button",
                                    style: { zIndex: 3 },
                                    className: "navbar-toggler collapsed",
                                    "data-target": "#site-navbar-collapse",
                                    "data-toggle": "collapse"
                                },
                                _react2.default.createElement("i", {
                                    className: "icon wb-more-horizontal",
                                    "aria-hidden": "true"
                                })
                            ),
                            _react2.default.createElement(
                                "div",
                                {
                                    className: "navbar-brand navbar-brand-center site-gridmenu-toggle",
                                    "data-toggle": "gridmenu"
                                },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: _General3.default.Link("/dashboard") },
                                    _react2.default.createElement("img", {
                                        className: "navbar-brand-logo",
                                        src: "/assets/images/logo.png"
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "navbar-container container-fluid" },
                            _react2.default.createElement(
                                "div",
                                {
                                    className: "collapse navbar-collapse navbar-collapse-toolbar",
                                    id: "site-navbar-collapse"
                                },
                                _react2.default.createElement(
                                    "ul",
                                    { className: "nav navbar-toolbar" },
                                    _react2.default.createElement(
                                        "li",
                                        { className: "nav-item hidden-float padding-button" },
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                href: _General3.default.Link2("/dashboard"),
                                                className: "btn btn-primary btn-sm"
                                            },
                                            _react2.default.createElement("i", {
                                                className: "icon wb-heart",
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            "Go to new admin"
                                        )
                                    ),
                                    _SocketManager2.default.isDisconnected() ? _react2.default.createElement(
                                        "li",
                                        {
                                            style: { marginLeft: "10px" },
                                            className: "nav-item hidden-float padding-button delay-rendering"
                                        },
                                        _react2.default.createElement(
                                            _rcTooltip2.default,
                                            {
                                                placement: "top",
                                                overlay: _react2.default.createElement(
                                                    "span",
                                                    null,
                                                    "Connection between you and our live update server has been lost. If the connection is down for a long period, try refreshing the page."
                                                )
                                            },
                                            _react2.default.createElement(
                                                "button",
                                                { className: "btn btn-danger btn-sm" },
                                                _react2.default.createElement("i", {
                                                    className: "icon wb-warning",
                                                    "aria-hidden": "true"
                                                }),
                                                " ",
                                                "Connection error"
                                            )
                                        )
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    "ul",
                                    { className: "nav navbar-toolbar navbar-right navbar-toolbar-right" },
                                    _react2.default.createElement(
                                        "li",
                                        { className: "nav-item" },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            {
                                                className: "nav-link",
                                                to: _General3.default.Link("/chat")
                                            },
                                            _react2.default.createElement(
                                                "span",
                                                {
                                                    className: unreadMessages > 0 ? "tag tag-round tag-danger" : "tag tag-outline tag-default"
                                                },
                                                "Unread messages:",
                                                " ",
                                                unreadMessages
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        { className: "nav-item" },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            {
                                                className: "nav-link",
                                                to: _General3.default.Link("/chat")
                                            },
                                            _react2.default.createElement(
                                                "span",
                                                {
                                                    className: unassignedConversations > 0 ? "tag tag-round tag-danger" : "tag tag-outline tag-default"
                                                },
                                                "Unassigned conversations:",
                                                " ",
                                                unassignedConversations
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        { className: "nav-item" },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            {
                                                className: "nav-link",
                                                to: _General3.default.Link("/chat")
                                            },
                                            _react2.default.createElement(
                                                "span",
                                                {
                                                    className: yourConversations > 0 ? "tag tag-round tag-warning" : "tag tag-outline tag-default"
                                                },
                                                "Your conversations:",
                                                " ",
                                                yourConversations
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        { className: "nav-item dropdown logged-in-user" },
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                className: "nav-link navbar-avatar",
                                                "data-toggle": "dropdown",
                                                href: "javascript:void(0)",
                                                "aria-expanded": "false",
                                                "data-animation": "scale-up",
                                                role: "button"
                                            },
                                            _react2.default.createElement(
                                                "span",
                                                { className: "name" },
                                                this.props.auth.user.firstname,
                                                " ",
                                                this.props.auth.user.lastname,
                                                _react2.default.createElement(
                                                    "strong",
                                                    null,
                                                    " ",
                                                    "-",
                                                    " ",
                                                    this.props.general.account.company ? this.props.general.account.company : this.props.general.account.company_name
                                                )
                                            ),
                                            _react2.default.createElement(
                                                "span",
                                                { className: "avatar avatar-online" },
                                                _react2.default.createElement("img", {
                                                    src: this.props.auth.user.image
                                                }),
                                                this.props.chat.isOnline == true ? _react2.default.createElement("i", null) : null
                                            )
                                        ),
                                        _react2.default.createElement(
                                            "div",
                                            {
                                                className: "dropdown-menu dropdown-menu-left",
                                                role: "menu"
                                            },
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                {
                                                    to: _General3.default.Link("/settings"),
                                                    className: "dropdown-item",
                                                    href: "javascript:void(0)",
                                                    role: "menuitem"
                                                },
                                                _react2.default.createElement("i", {
                                                    className: "icon wb-settings",
                                                    "aria-hidden": "true"
                                                }),
                                                " ",
                                                "Settings"
                                            ),
                                            _react2.default.createElement("div", {
                                                className: "dropdown-divider",
                                                role: "presentation"
                                            }),
                                            _react2.default.createElement(
                                                "a",
                                                {
                                                    className: "dropdown-item",
                                                    onClick: function onClick(e) {
                                                        return _this4.handleLogout(e);
                                                    },
                                                    href: "javascript:void(0)",
                                                    role: "menuitem"
                                                },
                                                _react2.default.createElement("i", {
                                                    className: "icon wb-power",
                                                    "aria-hidden": "true"
                                                }),
                                                " ",
                                                "Logout"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    this.renderMenu(),
                    _react2.default.createElement(
                        "div",
                        { className: "page" },
                        _BrowserNotification2.default.askForNotifications() === true ? _react2.default.createElement(
                            "div",
                            {
                                style: {
                                    margin: 0,
                                    borderRadius: 0,
                                    position: "relative",
                                    zIndex: "999",
                                    width: "100%"
                                },
                                className: "alert dark alert-alt alert-warning alert-dismissible",
                                role: "alert"
                            },
                            _react2.default.createElement(
                                "p",
                                null,
                                "Crall needs your permissions to enable desktop notifications."
                            ),
                            _react2.default.createElement(
                                "p",
                                { className: "m-t-15" },
                                _react2.default.createElement(
                                    "button",
                                    {
                                        className: "btn btn-warning btn-inverse btn-outline",
                                        onClick: function onClick(e) {
                                            e.stopPropagation();
                                            _BrowserNotification2.default.getPermission();
                                        },
                                        type: "button"
                                    },
                                    _react2.default.createElement("i", { className: "icon wb-check" }),
                                    "I want notifications"
                                ),
                                _react2.default.createElement(
                                    "button",
                                    {
                                        className: "btn btn-link white",
                                        type: "button",
                                        onClick: function onClick(e) {
                                            e.stopPropagation();
                                            _BrowserNotification2.default.dontAskAgain();
                                        }
                                    },
                                    "No, I don't want to be notified"
                                )
                            )
                        ) : null,
                        this.props.children
                    ),
                    _react2.default.createElement(_YesNo2.default, {
                        cancel: "Stay offline",
                        accept: "Go online",
                        onAccept: function onAccept(e) {
                            _this4.props.setGlobalKey("showChatReconnection", false);
                            _this4.switchChatStatus(true);
                        },
                        onDecline: function onDecline(e) {
                            _this4.props.setGlobalKey("showChatReconnection", false);
                            _this4.switchChatStatus(false);
                        },
                        onClose: function onClose(e) {
                            _this4.props.setGlobalKey("showChatReconnection", false);
                        },
                        param: this.props.general.showChatReconnection,
                        title: "You are now offline",
                        body: "You have been disconnected from the chat due to inactivity. Do you want appear online?"
                    }),
                    this.props.general.settings.ACCEPTED_TERMS != "1" ? _react2.default.createElement(_AcceptTerms2.default, {
                        onAccept: function onAccept(e) {
                            location.reload();
                        },
                        param: true
                    }) : null,
                    _Auth2.default.isStaff() && this.props.general.companySearchOpen ? _react2.default.createElement(_CompanySearch2.default, {
                        router: this.props.router,
                        setCurrentAccount: this.props.setCurrentAccount,
                        setGlobalKey: this.props.setGlobalKey,
                        onClose: function onClose() {
                            _this4.props.setGlobalKey("companySearchOpen", false);
                        },
                        param: this.props.general.companySearchOpen
                    }) : null,
                    this.props.general.dealerSearchOpen ? _react2.default.createElement(_CompanySearch2.default, {
                        router: this.props.router,
                        isDealer: true,
                        setCurrentAccount: this.props.setCurrentAccount,
                        setGlobalKey: this.props.setGlobalKey,
                        onClose: function onClose() {
                            _this4.props.setGlobalKey("dealerSearchOpen", false);
                        },
                        param: this.props.general.dealerSearchOpen
                    }) : null
                )
            );
        }
    }]);

    return FullPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        chat: state.chat,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        chatSetGlobalKey: _Chat2.chatSetGlobalKey,
        addPages: _Chat2.addPages,
        addVisitors: _Chat2.addVisitors,
        addCarts: _Chat2.addCarts,
        setInit: _Chat2.setInit,
        setLoadedVisitors: _Login.setLoadedVisitors,
        setGlobalKey: _General.setGlobalKey,
        switchChatStatus: _Chat.switchChatStatus,
        addUsers: _General.addUsers,
        setCurrentUser: _Login.setCurrentUser,
        setCurrentAccount: _Login.setCurrentAccount
    }, dispatch);
};

FullPage = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FullPage);
exports.default = FullPage;

/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _General = __webpack_require__(53);

var _redux = __webpack_require__(4);

var _reactRedux = __webpack_require__(3);

var _Login = __webpack_require__(75);

var _newinvoice = __webpack_require__(1641);

var _newinvoice2 = _interopRequireDefault(_newinvoice);

var _stats = __webpack_require__(1642);

var _stats2 = _interopRequireDefault(_stats);

var _account_settings = __webpack_require__(1643);

var _account_settings2 = _interopRequireDefault(_account_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var components = {
    newinvoice: _newinvoice2.default,
    account_settings: _account_settings2.default,
    stats: _stats2.default
};

var CompanySearch = function (_React$Component) {
    _inherits(CompanySearch, _React$Component);

    function CompanySearch(props) {
        _classCallCheck(this, CompanySearch);

        var _this = _possibleConstructorReturn(this, (CompanySearch.__proto__ || Object.getPrototypeOf(CompanySearch)).call(this, props));

        _this.state = {
            results: [],
            search: '',
            show: 'switch'
        };

        _this.login = _this.login.bind(_this);
        _this.search = _this.search.bind(_this);
        _this.changeSearch = _this.changeSearch.bind(_this);
        _this.switch = _this.switch.bind(_this);
        _this.renderComponent = _this.renderComponent.bind(_this);
        _this.show = _this.show.bind(_this);
        return _this;
    }

    _createClass(CompanySearch, [{
        key: 'show',
        value: function show(s) {
            this.setState({
                show: s
            });
        }
    }, {
        key: 'renderComponent',
        value: function renderComponent() {
            var Comp = components[this.state.show];
            return _react2.default.createElement(Comp, { general: this.props.general });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.s.focus();
        }
    }, {
        key: 'login',
        value: function login(account_id) {
            localStorage.setItem('is_staff', true);
            this.props.setGlobalKey('companySearchOpen', false);
            this.props.setCurrentAccount(account_id);
            this.props.router.push(account_id + '/dashboard');
            location.reload();
        }
    }, {
        key: 'changeSearch',
        value: function changeSearch(e) {
            this.setState({ search: e.target.value });
        }
    }, {
        key: 'search',
        value: function search(e) {
            var _this2 = this;

            if (e.key == 'Enter') {
                _axios2.default.get('/users?email=' + this.state.search + '&company_name=' + this.state.search).then(function (res) {
                    _this2.setState({ results: res.data });
                });
            }
        }
    }, {
        key: 'switch',
        value: function _switch() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'Search for company'
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    'Will match e-mail and company name.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-30' },
                    _react2.default.createElement('input', { type: 'text', ref: 's', value: this.state.search, onKeyDown: this.search, onChange: this.changeSearch, className: 'form-control form-control-lg', placeholder: 'Babybanden' })
                ),
                this.state.results.length > 0 ? _react2.default.createElement(
                    'table',
                    { className: 'table outline' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                'Id'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'E-mail'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Action'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.state.results.map(function (account) {
                            return _react2.default.createElement(
                                'tr',
                                { key: account.id },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    account.id
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    account.company_name
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick(e) {
                                                e.stopPropagation();_this3.login(account.id);
                                            }, className: 'btn btn-dark btn-sm' },
                                        account.company_name
                                    )
                                )
                            );
                        })
                    )
                ) : _react2.default.createElement(
                    'div',
                    { className: 'panel panel-bordered', style: { border: '1px solid #e4eaec' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-body text-center', style: { textAlign: 'center' } },
                        _react2.default.createElement('br', null),
                        _react2.default.createElement('i', { className: 'icon wb-alert-circle', 'aria-hidden': 'true', style: { fontSize: '80px' } }),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement('br', null),
                            'No users or accounts found'
                        ),
                        _react2.default.createElement('br', null)
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { id: 'adm' },
                        this.props.isDealer !== true ? _react2.default.createElement(
                            'div',
                            { className: 'sb' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Current version: ',
                                    this.props.general.platform.version
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                return _this4.show('switch');
                                            } },
                                        'Switch company'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                return _this4.show('newinvoice');
                                            } },
                                        'Invoice'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                return _this4.show('stats');
                                            } },
                                        'Stats'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                return _this4.show('account_settings');
                                            } },
                                        'Account settings'
                                    )
                                )
                            )
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'cont' },
                            this.state.show == 'switch' ? this.switch() : this.renderComponent()
                        )
                    )
                )
            );
        }
    }, {
        key: 'render2',
        value: function render2() {
            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(_FullScreenOverlay2.default, null)
            );
        }
    }]);

    return CompanySearch;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setUserKey: _Login.setUserKey, setCurrentUser: _Login.setCurrentUser }, dispatch);
};

CompanySearch = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CompanySearch);
exports.default = CompanySearch;

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var newinvoice = function (_React$Component) {
    _inherits(newinvoice, _React$Component);

    function newinvoice(props) {
        _classCallCheck(this, newinvoice);

        var _this = _possibleConstructorReturn(this, (newinvoice.__proto__ || Object.getPrototypeOf(newinvoice)).call(this, props));

        _this.state = {
            isBilling: false,
            error: false,
            billed: false,
            lines: []
        };

        _this.line = _this.line.bind(_this);
        _this.addNewLine = _this.addNewLine.bind(_this);
        _this.removeLine = _this.removeLine.bind(_this);
        _this.bill = _this.bill.bind(_this);
        _this.outputValue = _this.outputValue.bind(_this);

        _this.changeQty = _this.changeQty.bind(_this);
        _this.changeDesc = _this.changeDesc.bind(_this);
        _this.changePercent = _this.changePercent.bind(_this);
        _this.changeExTax = _this.changeExTax.bind(_this);
        _this.changeTotal = _this.changeTotal.bind(_this);
        _this.formatValues = _this.formatValues.bind(_this);
        return _this;
    }

    _createClass(newinvoice, [{
        key: 'formatValues',
        value: function formatValues() {
            this.setState({
                lines: this.state.lines.map(function (line) {
                    line.amount_ex_tax = parseFloat(line.amount_ex_tax).toFixed(2);
                    return line;
                })
            });
        }
    }, {
        key: 'bill',
        value: function bill() {
            var _this2 = this;

            this.setState({
                isBilling: true
            });

            var data = {
                lines: this.state.lines,
                account_id: this.props.general.account.account_id
            };

            _axios2.default.post('/account/invoice', data).then(function (res) {
                _this2.setState({
                    error: false,
                    isBilling: false,
                    billed: true
                });
                window.open('https://app.crall.' + (location.hostname.split('.').pop() == 'dev' ? 'dev' : 'io') + '/' + _this2.props.general.account.account_id + '/invoices/' + res.data.stripe_id);
            }).catch(function (err) {
                _this2.setState({
                    error: err.response.data.error.message,
                    isBilling: false
                });
            });
        }
    }, {
        key: 'changeQty',
        value: function changeQty(e, index) {
            this.updateLine(index, 'quantity', parseInt(e.target.value));
        }
    }, {
        key: 'changePercent',
        value: function changePercent(e, index) {
            this.updateLine(index, 'tax_percent', parseInt(e.target.value));
        }
    }, {
        key: 'changeExTax',
        value: function changeExTax(e, index) {
            this.updateLine(index, 'amount_ex_tax', e.target.value);
        }
    }, {
        key: 'parseValue',
        value: function parseValue(val) {
            if (val.toString().slice(-1) == '.' || val.toString().slice(-1) == ',') {
                val = parseFloat(parseFloat(val).toString(2));
            }

            return parseFloat(val);
        }
    }, {
        key: 'outputValue',
        value: function outputValue(val) {
            return parseFloat(val).toFixed(2);
        }
    }, {
        key: 'changeTotal',
        value: function changeTotal(e, index) {
            var val = e.target.value;

            if (this.state.lines[index].tax_percent > 0) {
                val = e.target.value / (1 + this.state.lines[index].tax_percent / 100);
            }

            this.updateLine(index, 'amount_ex_tax', val);
        }
    }, {
        key: 'changeDesc',
        value: function changeDesc(e, index) {
            this.updateLine(index, 'description', e.target.value);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.updateTotals();
        }
    }, {
        key: 'updateTotals',
        value: function updateTotals() {
            var totals = {
                total_ex_tax: 0.00,
                total_inc_tax: 0.00,
                total_tax: 0.00
            };

            this.state.lines.map(function (line) {
                var tax = 0;

                totals.total_ex_tax += parseFloat(line.amount_ex_tax);

                if (line.tax_percent == 0 || line.tax_percent == '') {
                    totals.total_inc_tax += parseFloat(line.amount_ex_tax);
                } else {
                    totals.total_inc_tax += parseFloat(line.amount_ex_tax) * (1 + line.tax_percent / 100);
                    tax = parseFloat(line.amount_ex_tax) * (1 + line.tax_percent / 100) - parseFloat(line.amount_ex_tax);
                }

                totals.total_tax += tax;
            });

            return totals;
        }
    }, {
        key: 'updateLine',
        value: function updateLine(index, key, value) {
            this.setState({
                lines: this.state.lines.map(function (line, i) {
                    if (i == index) {
                        line[key] = value;
                    }
                    return line;
                })

            });
        }
    }, {
        key: 'addNewLine',
        value: function addNewLine() {
            var line = {
                quantity: 1,
                description: '',
                amount_ex_tax: 100,
                tax_percent: 25
            };

            this.setState({
                lines: [].concat(_toConsumableArray(this.state.lines), [line])
            });
        }
    }, {
        key: 'removeLine',
        value: function removeLine(index) {
            this.setState({
                lines: this.state.lines.filter(function (line, i) {
                    return i !== index;
                })
            });
        }
    }, {
        key: 'line',
        value: function line(_line, i) {
            var _this3 = this;

            var tax_percent = _line.tax_percent;
            var total = _line.amount_ex_tax;
            if (tax_percent > 0) {
                total = _line.amount_ex_tax * (1 + tax_percent / 100);
            }

            return _react2.default.createElement(
                'tr',
                { key: i },
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: _line.quantity, onChange: function onChange(e) {
                            _this3.changeQty(e, i);
                        } })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: _line.description, onChange: function onChange(e) {
                            _this3.changeDesc(e, i);
                        } })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: tax_percent, onBlur: this.formatValues, onChange: function onChange(e) {
                            _this3.changePercent(e, i);
                        } })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: _line.amount_ex_tax, onBlur: this.formatValues, onChange: function onChange(e) {
                            _this3.changeExTax(e, i);
                        } })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: total, onBlur: this.formatValues, onChange: function onChange(e) {
                            _this3.changeTotal(e, i);
                        } })
                ),
                _react2.default.createElement(
                    'td',
                    { style: { textAlign: 'right' } },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-danger', onClick: function onClick(e) {
                                return _this3.removeLine(i);
                            } },
                        _react2.default.createElement('i', { className: 'icon fa-trash' })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            if (this.state.billed) {
                return _react2.default.createElement(
                    'span',
                    null,
                    'OK'
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'table invoice' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                'Qty'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Description'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Percent'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Amount ex mva'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Total'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Action'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.state.lines.map(function (line, i) {
                            return _this4.line(line, i);
                        }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 5 },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'right' } },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-success', onClick: this.addNewLine },
                                    _react2.default.createElement('i', { className: 'icon fa-plus' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { colSpan: 3 }),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'right' } },
                                'Tax'
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'right' } },
                                this.outputValue(this.updateTotals().total_tax)
                            ),
                            _react2.default.createElement('td', null)
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { colSpan: 3 }),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'right' } },
                                'Total'
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'right' } },
                                this.outputValue(this.updateTotals().total_inc_tax)
                            ),
                            _react2.default.createElement('td', null)
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 4 },
                                this.state.error ? _react2.default.createElement(
                                    'div',
                                    { className: 'alert dark alert-danger' },
                                    this.state.error
                                ) : null
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                this.state.isBilling ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-success btn-block', onClick: this.bill },
                                    'Charge'
                                )
                            ),
                            _react2.default.createElement('td', null)
                        )
                    )
                )
            );
        }
    }]);

    return newinvoice;
}(_react2.default.Component);

exports.default = newinvoice;

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stats = function (_React$Component) {
    _inherits(stats, _React$Component);

    function stats(props) {
        _classCallCheck(this, stats);

        var _this = _possibleConstructorReturn(this, (stats.__proto__ || Object.getPrototypeOf(stats)).call(this, props));

        _this.state = {
            'revenue': [],
            'total': 0
        };

        return _this;
    }

    _createClass(stats, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/managment/stats').then(function (res) {
                var total = 0;
                var lines = [];

                Object.keys(res.data.revenue).map(function (key) {
                    lines.push({
                        name: key,
                        total: res.data.revenue[key]
                    });

                    total += res.data.revenue[key];
                });

                _this2.setState({
                    revenue: lines,
                    total: total
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.state.revenue.map(function (line) {
                            return _react2.default.createElement(
                                'tr',
                                { key: line.name },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    line.name
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    Math.round(line.total)
                                )
                            );
                        }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                'Total'
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                Math.round(this.state.total)
                            )
                        )
                    )
                )
            );
        }
    }]);

    return stats;
}(_react2.default.Component);

exports.default = stats;

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactDates = __webpack_require__(205);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var account_settings = function (_React$Component) {
    _inherits(account_settings, _React$Component);

    function account_settings(props) {
        _classCallCheck(this, account_settings);

        var _this = _possibleConstructorReturn(this, (account_settings.__proto__ || Object.getPrototypeOf(account_settings)).call(this, props));

        _this.defaultCurrentPlan = function () {
            return {
                label: null,
                value: null
            };
        };

        _this.updateDemoDate = function () {
            _axios2.default.put('/managment/set_demo_date', {
                trial_ends_at: _this.state.demo_ends_at.format('YYYY-MM-DD')
            }).then(function (res) {
                _Notification2.default.success('Updated');
            });
        };

        _this.getAllPlans = function () {
            return _this.state.plans.map(function (plan) {
                return {
                    value: plan.id,
                    label: plan.name
                };
            });
        };

        _this.handlePlanChange = function (e) {
            _this.setState({
                currentPlan: e
            });
        };

        _this.addPlan = function () {
            _this.setState({
                currentPlan: _this.defaultCurrentPlan()
            });
        };

        _this.state = {
            focused: null,
            currentPlan: _this.defaultCurrentPlan(),
            plans: [],
            demo_ends_at: _moment2.default.utc(_this.props.general.account.trial_ends_at)
        };

        console.dir(_this.state.demo_ends_at);

        return _this;
    }

    _createClass(account_settings, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/managment/plans').then(function (res) {
                _this2.setState({
                    plans: res.data
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-5' },
                            'Demo ends at:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-5' },
                            _react2.default.createElement(_reactDates.SingleDatePicker, {
                                displayFormat: 'YYYY-MM-DD',
                                small: true,
                                date: this.state.demo_ends_at // momentPropTypes.momentObj or null
                                , onDateChange: function onDateChange(demo_ends_at) {
                                    return _this3.setState({ demo_ends_at: demo_ends_at });
                                } // PropTypes.func.isRequired
                                , focused: this.state.focused // PropTypes.bool
                                , onFocusChange: function onFocusChange(_ref) {
                                    var focused = _ref.focused;
                                    return _this3.setState({ focused: focused });
                                } // PropTypes.func.isRequired
                                , id: 'demo_ends_at' // PropTypes.string.isRequired,
                            }),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark', onClick: this.updateDemoDate },
                                'Save'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(_reactSelect2.default, {
                                value: this.state.currentPlan.value,
                                onChange: this.handlePlanChange,
                                options: this.getAllPlans()
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-5' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark', onClick: this.addPlan },
                                'Add'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return account_settings;
}(_react2.default.Component);

exports.default = account_settings;

/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YesNo = function (_React$Component) {
	_inherits(YesNo, _React$Component);

	function YesNo(props) {
		_classCallCheck(this, YesNo);

		return _possibleConstructorReturn(this, (YesNo.__proto__ || Object.getPrototypeOf(YesNo)).call(this, props));
	}

	_createClass(YesNo, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_reactPortal2.default,
				{ onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
				_react2.default.createElement(
					_FullScreenOverlay2.default,
					null,
					_react2.default.createElement(
						'div',
						{ className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
						_react2.default.createElement(
							'h1',
							null,
							this.props.title
						),
						_react2.default.createElement(
							'h2',
							null,
							this.props.body
						),
						_react2.default.createElement(
							'div',
							{ className: 'm-t-30' },
							_react2.default.createElement(
								'button',
								{ onClick: this.props.onDecline, className: 'btn btn-lg btn-danger' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('i', { style: { color: '#fff' }, className: 'icon wb-close' }),
									this.props.cancel ? this.props.cancel : 'Cancel'
								)
							),
							'\xA0\xA0\xA0',
							_react2.default.createElement(
								'button',
								{ onClick: function onClick(e) {
										e.stopPropagation();_this2.props.onAccept(_this2.props.param);
									}, className: 'btn btn-lg btn-dark' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('i', { className: 'icon wb-check' }),
									this.props.accept ? this.props.accept : "Let's do it!"
								)
							)
						)
					)
				)
			);
		}
	}]);

	return YesNo;
}(_react2.default.Component);

exports.default = YesNo;

/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcceptTerms = function (_React$Component) {
    _inherits(AcceptTerms, _React$Component);

    function AcceptTerms(props) {
        _classCallCheck(this, AcceptTerms);

        var _this = _possibleConstructorReturn(this, (AcceptTerms.__proto__ || Object.getPrototypeOf(AcceptTerms)).call(this, props));

        _this.accept = function (e) {
            e.stopPropagation();

            _axios2.default.post('/accounts/terms').then(function () {});

            _this.props.onAccept(_this.props.param);
        };

        _this.canContinue = function () {
            return _this.state.accepted_terms && _this.state.accepted_dpa && _this.state.accepted_privacy;
        };

        _this.acceptTerms = function () {
            _this.setState({
                accepted_terms: !_this.state.accepted_terms
            });
        };

        _this.acceptDpa = function () {
            _this.setState({
                accepted_dpa: !_this.state.accepted_dpa
            });
        };

        _this.acceptPrivacy = function () {
            _this.setState({
                accepted_privacy: !_this.state.accepted_privacy
            });
        };

        _this.state = {
            accepted_terms: false,
            accepted_dpa: false,
            accepted_privacy: false
        };
        return _this;
    }

    _createClass(AcceptTerms, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactPortal2.default,
                { onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    { hideCloseButton: true },
                    _react2.default.createElement(
                        'div',
                        { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                        _react2.default.createElement(
                            'h1',
                            null,
                            'Terms and agreements'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 text-center' },
                            _react2.default.createElement(
                                'h2',
                                null,
                                'Thank you for using Crall.io and we\'re glad to have you as a customer.',
                                _react2.default.createElement('br', null),
                                'Before you can use our services we need you to accept the following terms.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'm-t-30 col-sm-6 offset-sm-4 text-left' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'checkbox-custom checkbox-default' },
                                        _react2.default.createElement('input', { type: 'checkbox', onChange: this.acceptTerms, checked: this.state.accepted_terms, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'I accept the ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'https://crall.io/terms/', target: '_blank' },
                                                'Terms and conditions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'checkbox-custom checkbox-default' },
                                        _react2.default.createElement('input', { type: 'checkbox', onChange: this.acceptPrivacy, checked: this.state.accepted_privacy, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'I accept the ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'https://crall.io/privacy/', target: '_blank' },
                                                'Privacy Policy'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'checkbox-custom checkbox-default' },
                                        _react2.default.createElement('input', { type: 'checkbox', onChange: this.acceptDpa, checked: this.state.accepted_dpa, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'I accept the ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'https://crall.io/data-processing-agreement/', target: '_blank' },
                                                'Data Processing Agreement'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'm-t-30 text-center col-sm-12' },
                            _react2.default.createElement(
                                'button',
                                { disabled: !this.canContinue(), onClick: this.accept, className: 'btn btn-lg btn-dark' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon wb-check' }),
                                    'Continue'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AcceptTerms;
}(_react2.default.Component);

exports.default = AcceptTerms;

/***/ }),

/***/ 1646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _helpers = __webpack_require__(128);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = function (_React$Component) {
	_inherits(Login, _React$Component);

	function Login(props) {
		_classCallCheck(this, Login);

		var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

		_this.state = {
			error: false
		};
		_this.handleLogin = _this.handleLogin.bind(_this);
		return _this;
	}

	_createClass(Login, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			if (this.props.route.path === 'login') {
				_helpers2.default.redirectToNewAdmin();
				return;
			}

			if (localStorage.getItem('v2')) {
				_helpers2.default.redirectToNewAdmin();
				return;
			}

			if (this.props.auth.isAuthenticated) {
				this.props.router.push(_General2.default.Link('/dashboard'));
				return;
			}
			this.addBodyClass(true);

			if (this.props.location.query.next) {
				if (this.props.location.query.next.indexOf('undefined') !== -1) {
					this.props.router.push('/login');
				}
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.addBodyClass(false);
		}
	}, {
		key: 'addBodyClass',
		value: function addBodyClass(add) {
			if (add) {
				document.body.classList.add('page-login-v3');
				document.body.classList.add('layout-full');
			} else {
				document.body.classList.remove('page-login-v3');
				document.body.classList.remove('layout-full');
			}
		}
	}, {
		key: 'handleLogin',
		value: function handleLogin(e) {
			var _this2 = this;

			e.stopPropagation();

			_axios2.default.post('/auth/login', { email: this.refs.email.value, password: this.refs.password.value }).then(function (res) {
				_this2.setState({ error: false });
				_Auth2.default.authenticate(res.data.token, res.data.account_id);

				if (_this2.props.location.query.next) {
					_this2.props.router.push(_this2.props.location.query.next);
				} else {
					_this2.props.router.push(res.data.account_id + '/dashboard');
				}
			}).catch(function (res) {
				if (typeof res.response == 'undefined') {
					_ravenJs2.default.captureException(res);
					throw res;
					return;
				}
				switch (res.response.data.code) {
					case 'AUTH_FAIL':
						_this2.setState({ error: 'Wrong e-mail or password' });
						break;

					case 'TOKEN_EXPIRED':

						break;

					case 'TOKEN_INVALID':

						break;

					case 'GENERIC_ERROR':

						break;

					default:

						break;
				}
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
				'>',
				_react2.default.createElement(
					'div',
					{ className: 'page-content vertical-align-middle animation-slide-top animation-duration-1' },
					_react2.default.createElement(
						'div',
						{ className: 'panel' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'div',
								{ className: 'brand' },
								_react2.default.createElement('img', { className: 'brand-img', style: { width: '100%' }, src: '/assets/images/logo.png', alt: '...' })
							),
							_react2.default.createElement(
								'form',
								{ method: 'post', action: '#' },
								this.state.error ? _react2.default.createElement(
									'span',
									{ style: { color: '#d6494b', fontWeight: 400 } },
									this.state.error
								) : null,
								_react2.default.createElement(
									'div',
									{ className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
									_react2.default.createElement('input', { ref: 'email', type: 'email', className: 'form-control', name: 'email' }),
									_react2.default.createElement(
										'label',
										{ className: 'floating-label' },
										'Email'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
									_react2.default.createElement('input', { ref: 'password', type: 'password', className: 'form-control', name: 'password' }),
									_react2.default.createElement(
										'label',
										{ className: 'floating-label' },
										'Password'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-group clearfix' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/forgot', className: 'pull-xs-right' },
										'Forgot password?'
									)
								),
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-primary btn-block btn-lg m-t-40', onClick: function onClick(e) {
											return _this3.handleLogin(e);
										} },
									'Sign in'
								)
							)
						)
					)
				)
			);
		}
	}]);

	return Login;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
};
Login = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

exports.default = Login;

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Forgot = function (_React$Component) {
    _inherits(Forgot, _React$Component);

    function Forgot(props) {
        _classCallCheck(this, Forgot);

        var _this = _possibleConstructorReturn(this, (Forgot.__proto__ || Object.getPrototypeOf(Forgot)).call(this, props));

        _this.state = {
            isLoading: false,
            error: true
        };
        _this.sendLink = _this.sendLink.bind(_this);
        return _this;
    }

    _createClass(Forgot, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.auth.isAuthenticated) {
                this.props.router.push(_General2.default.Link('/dashboard'));
            }
            this.addBodyClass(true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.addBodyClass(false);
        }
    }, {
        key: 'addBodyClass',
        value: function addBodyClass(add) {
            if (add) {
                document.body.classList.add('page-login-v3');
                document.body.classList.add('layout-full');
            } else {
                document.body.classList.remove('page-login-v3');
                document.body.classList.remove('layout-full');
            }
        }
    }, {
        key: 'sendLink',
        value: function sendLink(e) {
            var _this2 = this;

            e.stopPropagation();

            this.setState({ isLoading: true });

            _axios2.default.post('/users/forgot', { email: this.refs.email.value }).then(function (res) {
                _this2.setState({ isLoading: false });
                _Notification2.default.success('A reset e-mail has been sent to you.');
                _this2.props.router.push('/login');
            }).catch(function (res) {
                _this2.setState({ isLoading: false, error: false });
                _Notification2.default.error('Account not found.');
                if (typeof res.response == 'undefined') {
                    _ravenJs2.default.captureException(res);
                    throw res;
                    return;
                }
                switch (res.response.data.code) {
                    case 'AUTH_FAIL':

                        break;

                    case 'TOKEN_EXPIRED':

                        break;

                    case 'TOKEN_INVALID':

                        break;

                    case 'GENERIC_ERROR':

                        break;

                    default:

                        break;
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
                '>',
                _react2.default.createElement(
                    'div',
                    { className: 'page-content vertical-align-middle animation-slide-top animation-duration-1' },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'brand' },
                                _react2.default.createElement('img', { className: 'brand-img', style: { width: '100%' }, src: '/assets/images/logo.png', alt: '...' })
                            ),
                            _react2.default.createElement(
                                'form',
                                { method: 'post', action: '#' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
                                    _react2.default.createElement('input', { ref: 'email', type: 'email', className: 'form-control', name: 'email' }),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'floating-label' },
                                        'Email'
                                    )
                                ),
                                this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-primary btn-block btn-lg m-t-40', onClick: function onClick(e) {
                                            return _this3.sendLink(e);
                                        } },
                                    'Send link'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Forgot;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
};
Forgot = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Forgot);

exports.default = Forgot;

/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reset = function (_React$Component) {
    _inherits(Reset, _React$Component);

    function Reset(props) {
        _classCallCheck(this, Reset);

        var _this = _possibleConstructorReturn(this, (Reset.__proto__ || Object.getPrototypeOf(Reset)).call(this, props));

        _this.state = {
            error: false,
            isLoading: true,
            user: false
        };
        _this.reset = _this.reset.bind(_this);
        return _this;
    }

    _createClass(Reset, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            if (this.props.auth.isAuthenticated) {
                this.props.router.push(_General2.default.Link('/dashboard'));
            }
            this.addBodyClass(true);
            _axios2.default.get('/users/getReset?reset=' + this.props.router.params.token).then(function (res) {
                _this2.setState({ isLoading: false, user: res.data });
            }).catch(function (err) {
                _this2.setState({ isLoading: false, error: true });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.addBodyClass(false);
        }
    }, {
        key: 'addBodyClass',
        value: function addBodyClass(add) {
            if (add) {
                document.body.classList.add('page-login-v3');
                document.body.classList.add('layout-full');
            } else {
                document.body.classList.remove('page-login-v3');
                document.body.classList.remove('layout-full');
            }
        }
    }, {
        key: 'reset',
        value: function reset(e) {
            var _this3 = this;

            e.stopPropagation();

            _axios2.default.post('/users/reset', { token: this.props.router.params.token, password: this.refs.password.value }).then(function (res) {
                _Auth2.default.authenticate(res.data.token, res.data.account_id);

                if (_this3.props.location.query.next) {
                    _this3.props.router.push(_this3.props.location.query.next);
                } else {
                    _this3.props.router.push(res.data.account_id + '/dashboard');
                }
            }).catch(function (res) {
                if (typeof res.response == 'undefined') {
                    _ravenJs2.default.captureException(res);
                    throw res;
                    return;
                }
                switch (res.response.data.code) {
                    case 'AUTH_FAIL':

                        break;

                    case 'TOKEN_EXPIRED':

                        break;

                    case 'TOKEN_INVALID':

                        break;

                    case 'GENERIC_ERROR':

                        break;

                    default:

                        break;
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                { className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
                '>',
                _react2.default.createElement(
                    'div',
                    { className: 'page-content vertical-align-middle animation-slide-top animation-duration-1' },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'brand' },
                                _react2.default.createElement('img', { className: 'brand-img', style: { width: '100%' }, src: '/assets/images/logo.png', alt: '...' })
                            ),
                            _react2.default.createElement(
                                'form',
                                { method: 'post', action: '#' },
                                this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : this.state.error ? 'Invalid reset link' : _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
                                        _react2.default.createElement('input', { ref: 'password', type: 'password', className: 'form-control', name: 'password' }),
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'floating-label' },
                                            'New password'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-primary btn-block btn-lg m-t-40', onClick: function onClick(e) {
                                                return _this4.reset(e);
                                            } },
                                        'Reset password'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Reset;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
};
Reset = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Reset);

exports.default = Reset;

/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ 1650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotFound = function (_React$Component) {
	_inherits(NotFound, _React$Component);

	function NotFound() {
		_classCallCheck(this, NotFound);

		return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	}

	_createClass(NotFound, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			this.addBodyClass(true);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.addBodyClass(false);
		}
	}, {
		key: 'addBodyClass',
		value: function addBodyClass(add) {
			if (add) {
				document.body.classList.add('layout-full');
				document.body.classList.add('page-error-404');
				document.body.classList.add('page-error');
			} else {
				document.body.classList.remove('layout-full');
				document.body.classList.remove('page-error-404');
				document.body.classList.remove('page-error');
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
				_react2.default.createElement(
					'div',
					{ className: 'page-content vertical-align-middle' },
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(
							'h1',
							{ className: 'animation-slide-top' },
							'404'
						),
						_react2.default.createElement(
							'p',
							null,
							'Page Not Found !'
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'error-advise' },
						'I\'M LOST, HELP!'
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: _General2.default.Link('/dashboard'), className: 'btn btn-primary btn-round' },
						'GET ME BACK TO SAFETY'
					)
				)
			);
		}
	}]);

	return NotFound;
}(_react2.default.Component);

exports.default = NotFound;

/***/ }),

/***/ 1651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _InvitationForm = __webpack_require__(1652);

var _InvitationForm2 = _interopRequireDefault(_InvitationForm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Invite = function (_React$Component) {
	_inherits(Invite, _React$Component);

	function Invite(props) {
		_classCallCheck(this, Invite);

		var _this = _possibleConstructorReturn(this, (Invite.__proto__ || Object.getPrototypeOf(Invite)).call(this, props));

		_this.state = {
			'locked': false,
			'isLoading': true,
			'invitation': false,
			'error': false,
			'firstname': '',
			'lastname': '',
			'didLoad': false
		};

		_this.handleSubmit = _this.handleSubmit.bind(_this);
		return _this;
	}

	_createClass(Invite, [{
		key: 'handleSubmit',
		value: function handleSubmit(data) {
			var _this2 = this;

			if (this.state.locked) {
				return;
			}
			this.setState({
				locked: true
			});
			_axios2.default.put('/invitation/' + this.props.router.location.query.id, data).then(function (res) {
				_Notification2.default.success('Success!');

				localStorage.setItem('crallAuthToken', res.data);
				_this2.props.router.push(_this2.state.invitation.account_id + '/dashboard');
				_this2.setState({
					locked: false
				});
			}).catch(function (err) {
				_ravenJs2.default.captureException(err);
				_Notification2.default.error('Error accepting invitation..');
				_this2.setState({
					locked: false
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.start();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.start();
		}
	}, {
		key: 'start',
		value: function start() {
			var _this3 = this;

			if (this.props.auth.isAuthenticated) {
				this.props.router.push(_General2.default.Link('/dashboard'));
			}
			if (this.state.didLoad) {
				return;
			}
			this.addBodyClass(true);

			_axios2.default.get('/invitation/' + this.props.router.location.query.id).then(function (res) {
				_this3.setState({
					'isLoading': false,
					'invitation': res.data,
					'didLoad': true
				});
			}).catch(function (error) {
				_this3.setState({
					'isLoading': true,
					'error': true,
					'didLoad': true
				});
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.addBodyClass(false);
		}
	}, {
		key: 'addBodyClass',
		value: function addBodyClass(add) {
			if (add) {
				document.body.classList.add('page-login-v3');
				document.body.classList.add('layout-full');
			} else {
				document.body.classList.remove('page-login-v3');
				document.body.classList.remove('layout-full');
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.isLoading) {
				return _react2.default.createElement(
					'div',
					{ className: 'isLoading' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ style: { position: 'absolute', marginLeft: 'auto', marginRight: 'auto', left: 0, right: 0 } },
							_react2.default.createElement('img', { style: { marginTop: '-210px', width: '200px' }, src: '/assets/images/logo.png' })
						),
						this.state.error == true ? _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { style: { fontSize: '50px' }, className: 'icon wb-thumb-down' }),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'This didn\'t go as expected. Try refreshing the page..',
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'strong',
								null,
								'Message:'
							),
							' Invalid invitation.'
						) : _react2.default.createElement(
							'div',
							{ className: 'spin2win' },
							_react2.default.createElement('div', { className: 'double-bounce1' }),
							_react2.default.createElement('div', { className: 'double-bounce2' })
						)
					)
				);
			}
			return _react2.default.createElement(
				'div',
				{ className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
				'>',
				_react2.default.createElement(
					'div',
					{ className: 'page-content vertical-align-middle animation-slide-top animation-duration-1' },
					_react2.default.createElement(
						'div',
						{ className: 'panel' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'div',
								{ className: 'brand' },
								_react2.default.createElement('img', { className: 'brand-img', style: { width: '100%' }, src: '/assets/images/logo.png', alt: '...' })
							),
							_react2.default.createElement(_InvitationForm2.default, { onSubmit: this.handleSubmit })
						)
					)
				)
			);
		}
	}]);

	return Invite;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
};
Invite = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Invite);

exports.default = Invite;

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};
    if (!values.firstname) {
        errors.firstname = 'Required';
    }

    if (!values.lastname) {
        errors.lastname = 'Required';
    }

    if (!values.password) {
        errors.password = 'Required';
    } else if (values.password.length < 6) {
        errors.password = 'Password must have minimum 6 characters';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var InvitationForm = function (_React$Component) {
    _inherits(InvitationForm, _React$Component);

    function InvitationForm() {
        _classCallCheck(this, InvitationForm);

        return _possibleConstructorReturn(this, (InvitationForm.__proto__ || Object.getPrototypeOf(InvitationForm)).apply(this, arguments));
    }

    _createClass(InvitationForm, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(_reduxForm.Field, { component: renderField, placeholder: 'John', title: 'Firstname', type: 'text', className: 'form-control', name: 'firstname' }),
                _react2.default.createElement(_reduxForm.Field, { component: renderField, placeholder: 'Doe', title: 'Lastname', type: 'text', className: 'form-control', name: 'lastname' }),
                _react2.default.createElement(_reduxForm.Field, { component: renderField, title: 'Desired password', type: 'password', className: 'form-control', name: 'password' }),
                _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-block btn-lg m-t-40' },
                    'Register'
                )
            );
        }
    }]);

    return InvitationForm;
}(_react2.default.Component);

// Decorate the form component


InvitationForm = (0, _reduxForm.reduxForm)({
    form: 'InvitationForm',
    validate: validate
})(InvitationForm);

exports.default = InvitationForm;

/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _SignupForm = __webpack_require__(1654);

var _SignupForm2 = _interopRequireDefault(_SignupForm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Signup = function (_React$Component) {
	_inherits(Signup, _React$Component);

	function Signup(props) {
		_classCallCheck(this, Signup);

		var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props));

		_this.state = {
			'locked': false,
			'isLoading': true,
			'invitation': false,
			'error': '',
			'email': '',
			'password': '',
			'didLoad': false
		};

		if (window.demo_signup_email) {
			_this.state = _extends({}, _this.state, { email: window.demo_signup_email });
		}

		if (window.demo_signup_pass) {
			_this.state = _extends({}, _this.state, { password: window.demo_signup_pass });
		}

		_this.handleSubmit = _this.handleSubmit.bind(_this);
		return _this;
	}

	_createClass(Signup, [{
		key: 'handleSubmit',
		value: function handleSubmit(data) {
			this.setState({
				email: data.email,
				password: data.password
			});

			this.doRequest(data.email, data.password);
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.start();

			if (this.state.password != '' && this.state.email) {
				this.doRequest();
			} else {
				this.setState({
					isLoading: false
				});
			}
		}
	}, {
		key: 'doRequest',
		value: function doRequest() {
			var _this2 = this;

			var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			if (!email) {
				email = this.state.email;
			}
			if (!password) {
				password = this.state.password;
			}

			_axios2.default.post('/signup', { email: email, password: password }).then(function (res) {
				localStorage.setItem('crallAuthToken', res.data.token);
				_this2.props.router.push(res.data.account_id + '/dashboard');
			}).catch(function (err) {
				_this2.setState({ isLoading: false, error: err.response.data.error.message });
			});
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.start();
		}
	}, {
		key: 'start',
		value: function start() {
			if (this.props.auth.isAuthenticated) {
				this.props.router.push(_General2.default.Link('/dashboard'));
			}

			this.addBodyClass(true);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.addBodyClass(false);
		}
	}, {
		key: 'addBodyClass',
		value: function addBodyClass(add) {
			if (add) {
				document.body.classList.add('page-login-v3');
				document.body.classList.add('layout-full');
			} else {
				document.body.classList.remove('page-login-v3');
				document.body.classList.remove('layout-full');
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.isLoading) {
				return _react2.default.createElement(
					'div',
					{ className: 'isLoading' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ style: { position: 'absolute', marginLeft: 'auto', marginRight: 'auto', left: 0, right: 0 } },
							_react2.default.createElement('img', { style: { marginTop: '-210px', width: '200px' }, src: '/assets/images/logo.png' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'spin2win' },
							_react2.default.createElement('div', { className: 'double-bounce1' }),
							_react2.default.createElement('div', { className: 'double-bounce2' })
						)
					)
				);
			}
			return _react2.default.createElement(
				'div',
				{ className: 'page vertical-align text-xs-center', 'data-animsition-in': 'fade-in', 'data-animsition-out': 'fade-out' },
				'>',
				_react2.default.createElement(
					'div',
					{ className: 'page-content vertical-align-middle animation-slide-top animation-duration-1' },
					_react2.default.createElement(
						'div',
						{ className: 'panel' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'div',
								{ className: 'brand' },
								_react2.default.createElement('img', { className: 'brand-img', style: { width: '100%' }, src: '/assets/images/logo.png', alt: '...' })
							),
							this.state.error != '' ? _react2.default.createElement(
								'span',
								{ style: { color: '#d6494b', fontWeight: 400 } },
								this.state.error
							) : null,
							_react2.default.createElement(_SignupForm2.default, { initialValues: { email: this.state.email, password: this.state.password }, onSubmit: this.handleSubmit })
						)
					)
				)
			);
		}
	}]);

	return Signup;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
};
Signup = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Signup);

exports.default = Signup;

/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};
    if (!values.email) {
        errors.email = 'Required';
    }

    if (!values.password) {
        errors.password = 'Required';
    } else if (values.password.length < 6) {
        errors.password = 'Password must have minimum 6 characters';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var SignupForm = function (_React$Component) {
    _inherits(SignupForm, _React$Component);

    function SignupForm() {
        _classCallCheck(this, SignupForm);

        return _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).apply(this, arguments));
    }

    _createClass(SignupForm, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(_reduxForm.Field, { component: renderField, placeholder: 'E-mail', title: 'E-mail', type: 'text', className: 'form-control', name: 'email' }),
                _react2.default.createElement(_reduxForm.Field, { component: renderField, placeholder: 'Password', title: 'Password', type: 'password', className: 'form-control', name: 'password' }),
                _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-block btn-lg m-t-40' },
                    'Sign up'
                )
            );
        }
    }]);

    return SignupForm;
}(_react2.default.Component);

// Decorate the form component


SignupForm = (0, _reduxForm.reduxForm)({
    form: 'SignupForm',
    validate: validate
})(SignupForm);

exports.default = SignupForm;

/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _ColumnPicker = __webpack_require__(265);

var _ColumnPicker2 = _interopRequireDefault(_ColumnPicker);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _abtest = __webpack_require__(678);

var _abtest2 = _interopRequireDefault(_abtest);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Emails = function (_React$Component) {
	_inherits(Emails, _React$Component);

	function Emails(props) {
		_classCallCheck(this, Emails);

		var _this = _possibleConstructorReturn(this, (Emails.__proto__ || Object.getPrototypeOf(Emails)).call(this, props));

		_this.changeStatus = function (id, status) {
			var emails = [].concat(_toConsumableArray(_this.state.emails));

			_axios2.default.put('/emails/' + id + '/status', {});

			if (_this.props.general.settings.PACKAGE_EMAIL != "1") {
				_Notification2.default.error("You're not subscribed to the platform package.");
				return;
			}
			emails = emails.map(function (email) {
				if (email.id == id) {
					email.status = status == 1 ? 0 : 1;
				}

				email.followup = email.followup.map(function (followup) {
					if (followup.id == id) {
						followup.status = status == 1 ? 0 : 1;
					}
					return followup;
				});

				return email;
			});

			_this.setState({
				emails: emails
			});
		};

		_this.state = {
			isLoading: true,
			isError: false,
			askCreate: false,
			askUpgrade: false,
			askDelete: false,
			followUpFor: false,
			columns: [],
			emails: [],
			currentTest: false,
			showDialog: false
		};

		_this.followup = _this.followup.bind(_this);
		_this.rows = _this.rows.bind(_this);
		_this.templateRow = _this.templateRow.bind(_this);
		_this.duplicate = _this.duplicate.bind(_this);
		_this.templateRows = _this.templateRows.bind(_this);
		_this.newTemplate = _this.newTemplate.bind(_this);
		_this.handleSave = _this.handleSave.bind(_this);
		_this.update = _this.update.bind(_this);
		return _this;
	}

	_createClass(Emails, [{
		key: 'newTemplate',
		value: function newTemplate() {
			var _this2 = this;

			this.setState({ isLoading: true });

			_axios2.default.post('/emails/template').then(function (res) {
				_this2.setState({ isLoading: false });
				_this2.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
			});
		}
	}, {
		key: 'handleSave',
		value: function handleSave() {
			this.update();
		}
	}, {
		key: 'update',
		value: function update() {
			var _this3 = this;

			_axios2.default.get('/emails').then(function (res) {
				_this3.setState(_extends({}, _this3.state, {
					'isError': false,
					'isLoading': false,
					'emails': res.data
				}));
			}).catch(function (res) {
				_this3.setState({ 'isError': res.message });
			});
		}
	}, {
		key: 'createFollowup',
		value: function createFollowup() {
			var _this4 = this;

			this.setState({
				askCreate: false
			});

			if (this.props.general.settings.PACKAGE_FOLLOWUP != '1') {
				this.setState({
					askUpgrade: true
				});
			} else {
				this.setState({ isLoading: true });
				_axios2.default.post('/emails/' + this.state.followUpFor + '/followup').then(function (res) {
					_this4.setState({ isLoading: false });
					_this4.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
				});
			}
		}
	}, {
		key: 'duplicate',
		value: function duplicate(id) {
			var _this5 = this;

			this.setState({
				isLoading: true
			});

			_axios2.default.post('/emails/' + id + '/duplicate').then(function (res) {
				_this5.setState({ isLoading: false });
				_this5.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
			});
		}
	}, {
		key: 'followup',
		value: function followup(id) {
			this.setState({
				askCreate: true,
				followUpFor: id
			});
		}
	}, {
		key: 'placeholder',
		value: function placeholder() {
			return _react2.default.createElement(
				'span',
				{ className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
				'\xA0'
			);
		}
	}, {
		key: 'askDelete',
		value: function askDelete(id) {
			this.setState({ askDelete: id });
		}
	}, {
		key: 'delete',
		value: function _delete(id) {
			var _this6 = this;

			this.setState({ askDelete: false, isLoading: true });
			_axios2.default.delete('/emails/' + id).then(function (res) {
				_axios2.default.get('/emails').then(function (res) {
					_this6.setState({
						'isError': false,
						'isLoading': false,
						'emails': res.data
					});
				});
			});
		}
	}, {
		key: 'rowOptions',
		value: function rowOptions(email) {
			var _this7 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'btn-group', role: 'group' },
				_react2.default.createElement(
					_rcTooltip2.default,
					{ placement: 'top', overlay: _react2.default.createElement(
							'span',
							null,
							'Statistics'
						) },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: _General2.default.Link('/stats/emails/' + email.id), className: 'btn btn-icon btn-default btn-outline' },
						_react2.default.createElement('i', { className: 'icon wb-graph-up', 'aria-hidden': 'true' })
					)
				),
				email.type != 'TEMPLATE' ? _react2.default.createElement(
					_rcTooltip2.default,
					{ placement: 'top', overlay: _react2.default.createElement(
							'span',
							null,
							'Create followup'
						) },
					_react2.default.createElement(
						'button',
						{ onClick: function onClick() {
								return _this7.followup(email.id);
							}, className: 'btn btn-icon btn-default btn-outline' },
						_react2.default.createElement('i', { className: 'icon fa-level-up', 'aria-hidden': 'true' })
					)
				) : null,
				_react2.default.createElement(
					_rcTooltip2.default,
					{ placement: 'top', overlay: _react2.default.createElement(
							'span',
							null,
							'Edit e-mail'
						) },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: _General2.default.Link('/builder/email/' + email.id), className: 'btn btn-icon btn-default btn-outline' },
						_react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
					)
				),
				_react2.default.createElement(
					_rcTooltip2.default,
					{ placement: 'top', overlay: _react2.default.createElement(
							'span',
							null,
							'Duplicate e-mail'
						) },
					_react2.default.createElement(
						'button',
						{ onClick: function onClick() {
								return _this7.duplicate(email.id);
							}, className: 'btn btn-icon btn-default btn-outline' },
						_react2.default.createElement('i', { className: 'icon wb-copy', 'aria-hidden': 'true' })
					)
				),
				_react2.default.createElement(
					_rcTooltip2.default,
					{ placement: 'top', overlay: _react2.default.createElement(
							'span',
							null,
							'Delete e-mail'
						) },
					_react2.default.createElement(
						'button',
						{ onClick: function onClick(e) {
								_this7.askDelete(email.id);
							}, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
						_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
					)
				)
			);
		}
	}, {
		key: 'templateRow',
		value: function templateRow(email) {

			return _react2.default.createElement(
				'tr',
				{ key: 'email-' + email.id },
				_react2.default.createElement(
					'td',
					null,
					'#',
					email.id
				),
				_react2.default.createElement(
					'td',
					{ style: { width: '80%', 'textAlign': 'left' } },
					email.subject
				),
				_react2.default.createElement(
					'td',
					null,
					this.rowOptions(email)
				)
			);
		}
	}, {
		key: 'emailRow',
		value: function emailRow(email) {
			var _this8 = this,
			    _React$createElement;

			var followup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var ret = [];

			var td_style = {};
			if (followup) {
				td_style.backgroundColor = '#fafafa';
			}

			ret.push(_react2.default.createElement(
				'tr',
				{ key: 'email-' + email.id },
				_react2.default.createElement(
					'td',
					{ style: td_style },
					'#',
					email.id
				),
				_react2.default.createElement(
					'td',
					{ style: td_style },
					_react2.default.createElement(
						'div',
						{ style: { position: 'relative' } },
						followup ? _react2.default.createElement('i', { className: 'icon fa-level-up', style: { position: 'absolute', 'left': 0, top: 4, fontSize: '17px', transform: 'scale(-1, 1)' } }) : null,
						email.subject
					)
				),
				this.state.columns.includes('t') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.description
				) : null,
				this.state.columns.includes('cs') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.clicked
				) : null,
				this.state.columns.includes('cr') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.clickRate,
					'%'
				) : null,
				this.state.columns.includes('o') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.opened
				) : null,
				this.state.columns.includes('or') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.openRate,
					'%'
				) : null,
				this.state.columns.includes('s') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.sent
				) : null,
				this.state.columns.includes('q') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.queued
				) : null,
				this.state.columns.includes('r') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.revenue
				) : null,
				this.state.columns.includes('c') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.converted
				) : null,
				this.state.columns.includes('cvr') ? _react2.default.createElement(
					'td',
					{ style: td_style },
					email.rate,
					'%'
				) : null,
				email.status == 2 ? _react2.default.createElement(
					'td',
					{ style: td_style, className: 'column-status s-' + email.status },
					_react2.default.createElement(
						'span',
						null,
						email.status > 0 ? _react2.default.createElement('i', { className: 'icon wb-check' }) : _react2.default.createElement('i', { className: 'icon wb-close' })
					)
				) : _react2.default.createElement(
					'td',
					(_React$createElement = { style: td_style }, _defineProperty(_React$createElement, 'style', { cursor: 'pointer' }), _defineProperty(_React$createElement, 'onClick', function onClick() {
						return _this8.changeStatus(email.id, email.status);
					}), _defineProperty(_React$createElement, 'className', 'column-status s-' + email.status), _React$createElement),
					_react2.default.createElement(
						_rcTooltip2.default,
						{ placement: 'top', overlay: '' + (email.status == 1 ? 'Click here to deactivate e-email' : 'Click here to activate e-mail') },
						_react2.default.createElement(
							'span',
							null,
							email.status > 0 ? _react2.default.createElement('i', { className: 'icon wb-check' }) : _react2.default.createElement('i', { className: 'icon wb-close' })
						)
					)
				),
				_react2.default.createElement(
					'td',
					{ style: td_style },
					this.rowOptions(email)
				)
			));

			for (var i in email.followup) {
				var rows = this.emailRow(email.followup[i], true);

				for (var r in rows) {
					ret.push(rows[r]);
				}
			}

			return ret;
		}
	}, {
		key: 'rows',
		value: function rows() {
			var _this9 = this;

			var data = [];
			this.state.emails.map(function (email, i) {
				if (email.type != 'TEMPLATE') {
					data.push(_this9.emailRow(email));
				}
			});

			if (data.length < 10) {
				var placeholder = this.placeholderRow(10 - data.length, this.state.columns.length + 4);
				for (var i in placeholder) {
					data.push(placeholder[i]);
				}
			}

			return data;
		}
	}, {
		key: 'templateRows',
		value: function templateRows() {
			var _this10 = this;

			var data = [];
			this.state.emails.map(function (email, i) {
				if (email.type == 'TEMPLATE') {
					data.push(_this10.templateRow(email));
				}
			});

			if (data.length < 10) {
				var placeholder = this.placeholderRow(10 - data.length, 3);
				for (var i in placeholder) {
					data.push(placeholder[i]);
				}
			}

			return data;
		}
	}, {
		key: 'placeholderRow',
		value: function placeholderRow(rows, cols) {
			var td = [];
			for (var i = 1; i <= cols; i++) {
				td.push(_react2.default.createElement(
					'td',
					{ key: i },
					this.placeholder()
				));
			}

			var row = [];
			for (var _i = 1; _i <= rows; _i++) {
				row.push(_react2.default.createElement(
					'tr',
					{ key: _i },
					td
				));
			}

			return row;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.update();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this11 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
			}

			if (this.state.emails.length == 0) {
				return _react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'E-mails | Crall.io' }),
					_react2.default.createElement(_NoResult2.default, {
						header: 'No e-mails found',
						body: 'You have not created a e-mail yet. Click the button to get started.',
						link: '/builder/email/picker',
						button: 'Create my first e-mail'
					})
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-envelope' }),
						' Live e-mails'
					),
					_react2.default.createElement(
						'div',
						{ className: 'page-header-actions' },
						_react2.default.createElement(_ColumnPicker2.default, { update: function update(data) {
								_this11.setState({ columns: data });
							}, storage: 'email_list', columns: [{
								'key': 'cr',
								'text': 'Click rate',
								'default': true
							}, {
								'key': 'cs',
								'text': 'Clicks'
							}, {
								'key': 'or',
								'text': 'Open rate',
								'default': true
							}, {
								'key': 'cvr',
								'text': 'Conversion rate',
								'default': true
							}, {
								'key': 'o',
								'text': 'Opened'
							}, {
								'key': 'c',
								'text': 'Conversions'
							}, {
								'key': 'r',
								'text': 'Revenue',
								'default': true
							},, {
								'key': 's',
								'text': 'Sent'
							}, {
								'key': 't',
								'text': 'Type',
								'default': true
							}, {
								'key': 'q',
								'text': 'Queued',
								'default': false
							}] }),
						_react2.default.createElement(
							'div',
							{ style: { marginRight: '10px' }, className: 'btn-group dropdown' },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
								_react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
								' Create new'
							),
							_react2.default.createElement(
								'div',
								{ className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ className: 'dropdown-item', to: _General2.default.Link("/builder/email/picker"), role: 'menuitem' },
									'Live e-mail'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 p-0 inherit-position' },
						_react2.default.createElement(_reactHelmet2.default, { title: 'Live e-mails | Crall.io' }),
						_react2.default.createElement(
							_OptionColumn2.default,
							{ title: 'E-mails', cols: { 'left': 2, 'right': 10 }, panel: false, description: 'List of all e-mails connected to your account.' },
							_react2.default.createElement(
								'table',
								{ className: 'table outline' },
								_react2.default.createElement(
									'tbody',
									null,
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'th',
											null,
											'#'
										),
										_react2.default.createElement(
											'th',
											null,
											'Subject'
										),
										this.state.columns.includes('t') ? _react2.default.createElement(
											'th',
											null,
											'Type'
										) : null,
										this.state.columns.includes('cs') ? _react2.default.createElement(
											'th',
											null,
											'Clicks'
										) : null,
										this.state.columns.includes('cr') ? _react2.default.createElement(
											'th',
											null,
											'Click rate'
										) : null,
										this.state.columns.includes('o') ? _react2.default.createElement(
											'th',
											null,
											'Opened'
										) : null,
										this.state.columns.includes('or') ? _react2.default.createElement(
											'th',
											null,
											'Open rate'
										) : null,
										this.state.columns.includes('s') ? _react2.default.createElement(
											'th',
											null,
											'Sent'
										) : null,
										this.state.columns.includes('q') ? _react2.default.createElement(
											'th',
											null,
											'In queue'
										) : null,
										this.state.columns.includes('r') ? _react2.default.createElement(
											'th',
											null,
											'Revenue'
										) : null,
										this.state.columns.includes('c') ? _react2.default.createElement(
											'th',
											null,
											'Conversions'
										) : null,
										this.state.columns.includes('cvr') ? _react2.default.createElement(
											'th',
											null,
											'Conversion rate'
										) : null,
										_react2.default.createElement(
											'th',
											null,
											'Status'
										),
										_react2.default.createElement(
											'th',
											null,
											'Actions'
										)
									)
								),
								_react2.default.createElement(
									'tbody',
									null,
									this.rows()
								)
							)
						),
						_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
								_this11.delete(e);
							}, onClose: function onClose() {
								_this11.setState({ askDelete: false });
							}, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this e-mail?' }),
						_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
								_this11.createFollowup(e);
							}, onClose: function onClose() {
								_this11.setState({ askCreate: false });
							}, param: this.state.askCreate, title: 'New follow up e-mail', body: 'This will create a new e-mail that will be triggered after sending the selected e-mail.' }),
						_react2.default.createElement(_AskUpgrade2.default, { onAccept: function onAccept(e) {
								_this11.setState({ askUpgrade: false });_this11.props.router.push(_General2.default.Link('/settings/billing/plan'));
							}, onClose: function onClose() {
								_this11.setState({ askUpgrade: false });
							}, param: this.state.askUpgrade, title: 'Upgrade required', body: 'To use this feature you must upgrade to a larger package.' })
					),
					_react2.default.createElement(_SplitRow2.default, null)
				)
			);
		}
	}]);

	return Emails;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Emails = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Emails);
exports.default = Emails;

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _ColumnPicker = __webpack_require__(265);

var _ColumnPicker2 = _interopRequireDefault(_ColumnPicker);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _abtest = __webpack_require__(678);

var _abtest2 = _interopRequireDefault(_abtest);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Abtests = function (_React$Component) {
    _inherits(Abtests, _React$Component);

    function Abtests(props) {
        _classCallCheck(this, Abtests);

        var _this = _possibleConstructorReturn(this, (Abtests.__proto__ || Object.getPrototypeOf(Abtests)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            askCreate: false,
            askUpgrade: false,
            askDelete: false,
            followUpFor: false,
            tests: [],
            currentTest: false,
            showDialog: false
        };

        _this.handleSave = _this.handleSave.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.portal = _this.portal.bind(_this);
        _this.renderTest = _this.renderTest.bind(_this);
        _this.renderEmailLine = _this.renderEmailLine.bind(_this);
        _this.generateResult = _this.generateResult.bind(_this);
        _this.askDelete = _this.askDelete.bind(_this);
        _this.delete = _this.delete.bind(_this);
        return _this;
    }

    _createClass(Abtests, [{
        key: 'askDelete',
        value: function askDelete(id) {
            this.setState({ askDelete: id });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this2 = this;

            this.setState({ askDelete: false, isLoading: true });
            _axios2.default.delete('/emails/abtests/' + id).then(function (res) {
                _this2.update();
            });
        }
    }, {
        key: 'generateResult',
        value: function generateResult(test) {
            if (parseInt(test.sent_a) < 100 || parseInt(test.sent_b) < 100) {
                return _react2.default.createElement(
                    'p',
                    null,
                    'Not enough data. Minimum sent e-mails must be more than 100.'
                );
            }

            if (!test.stats.isSignificant) {
                return _react2.default.createElement(
                    'p',
                    null,
                    'E-mail ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        '"',
                        test.stats.winner.toString().toUpperCase(),
                        '"'
                    ),
                    ' is converting ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        test.stats.upLift,
                        '%'
                    ),
                    ' better than ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        '"',
                        test.stats.winner == 'a' ? 'B' : 'A',
                        '"'
                    ),
                    '. Unfortunately, your results are not statistically significant.'
                );
            }

            return _react2.default.createElement(
                'p',
                null,
                'E-mail ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '"',
                    test.stats.winner.toString().toUpperCase(),
                    '"'
                ),
                ' is converting ',
                _react2.default.createElement(
                    'strong',
                    null,
                    test.stats.upLift,
                    '%'
                ),
                ' better than ',
                _react2.default.createElement(
                    'strong',
                    null,
                    '"',
                    test.stats.winner == 'a' ? 'B' : 'A',
                    '"'
                ),
                '. Your A/B test is statistically significant!'
            );
        }
    }, {
        key: 'round',
        value: function round(num) {
            return num;
        }
    }, {
        key: 'renderEmailLine',
        value: function renderEmailLine(test, aOrB) {
            console.dir(test);
            return _react2.default.createElement(
                'tr',
                { key: aOrB },
                _react2.default.createElement(
                    'td',
                    null,
                    aOrB.toString().toUpperCase(),
                    ' - #',
                    test['email_id_' + aOrB]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    test['email_' + aOrB] ? test['email_' + aOrB]['subject'] : '-'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.round(test.stats[aOrB].open),
                    '%'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.round(test.stats[aOrB].click),
                    '%'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.round(test.stats[aOrB].converted),
                    '%'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    test['sent_' + aOrB]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'div',
                        { style: { position: 'relative' } },
                        test.stats.winner == aOrB && test.stats.isSignificant ? _react2.default.createElement(
                            'div',
                            { className: 'ribbon ribbon-bookmark ribbon-reverse ribbon-warning adjust-to-td' },
                            _react2.default.createElement(
                                'span',
                                { className: 'ribbon-inner' },
                                _react2.default.createElement('i', { className: 'icon fa-trophy', 'aria-hidden': 'true' })
                            )
                        ) : null
                    )
                )
            );
        }
    }, {
        key: 'renderTest',
        value: function renderTest(test) {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { key: test.id },
                _react2.default.createElement(
                    'div',
                    { className: 'col-lg-12 col-xs-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel-heading' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'panel-title' },
                                'Test #',
                                test.id,
                                ' - ',
                                test.description
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-actions' },
                                _react2.default.createElement('button', { onClick: function onClick(e) {
                                        _this3.askDelete(test.id);
                                    }, className: 'btn btn-dark icon wb-trash' }),
                                '\xA0',
                                _react2.default.createElement('button', { onClick: function onClick(e) {
                                        _this3.setState({ currentTest: test.id, showDialog: true });
                                    }, className: 'btn btn-dark icon wb-pencil' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            this.generateResult(test)
                        ),
                        _react2.default.createElement(
                            'table',
                            { className: 'table table-hover' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'A/B'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Subject'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Open rate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Click rate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Conversion rate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sample size'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.renderEmailLine(test, 'a'),
                                this.renderEmailLine(test, 'b')
                            )
                        )
                    )
                ),
                _react2.default.createElement(_SplitRow2.default, null)
            );
        }
    }, {
        key: 'portal',
        value: function portal() {
            var _this4 = this;

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: function onClose(e) {
                        _this4.setState({ currentTest: false, showDialog: false });
                    }, isOpened: this.state.showDialog },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(_abtest2.default, { handleSave: this.handleSave, enabled: this.props.general.settings.PACKAGE_ABTEST, onClose: function onClose(e) {
                            _this4.setState({ currentTest: false, showDialog: false });
                        }, testId: this.state.currentTest })
                )
            );
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this5 = this;

            _axios2.default.get('/emails/abtests').then(function (res) {
                _this5.setState(_extends({}, _this5.state, {
                    'isError': false,
                    'isLoading': false,
                    'tests': res.data
                }));
            }).catch(function (res) {
                _this5.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.tests.length == 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'E-mails | Crall.io' }),
                    _react2.default.createElement(_NoResult2.default, {
                        header: 'No tests found',
                        body: 'You have not created a test yet. Click the button to get started.',
                        action: function action(e) {
                            _this6.setState({ currentTest: 0, showDialog: true });
                        },
                        button: 'Create my first test'
                    }),
                    this.portal()
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height', id: 'tests' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-flask' }),
                        ' A/B tests'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            'div',
                            { style: { marginRight: '10px' }, className: 'btn-group dropdown' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
                                _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                                ' Create new'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
                                _react2.default.createElement(
                                    'a',
                                    { onClick: function onClick(e) {
                                            _this6.setState({ currentTest: 0, showDialog: true });
                                        }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem' },
                                    'A/B test'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'A/B tests | Crall.io' }),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'A/B tests', panel: false, description: 'List of all your A/B tests' },
                        this.state.tests.map(function (test) {
                            return _this6.renderTest(test);
                        })
                    )
                ),
                _react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
                        _this6.delete(e);
                    }, onClose: function onClose() {
                        _this6.setState({ askDelete: false });
                    }, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this test?' }),
                this.portal()
            );
        }
    }]);

    return Abtests;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Abtests = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Abtests);
exports.default = Abtests;

/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Templates = function (_React$Component) {
    _inherits(Templates, _React$Component);

    function Templates(props) {
        _classCallCheck(this, Templates);

        var _this = _possibleConstructorReturn(this, (Templates.__proto__ || Object.getPrototypeOf(Templates)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            askCreate: false,
            askUpgrade: false,
            askDelete: false,
            followUpFor: false,
            columns: [],
            emails: [],
            currentTest: false,
            showDialog: false
        };

        _this.followup = _this.followup.bind(_this);
        _this.rows = _this.rows.bind(_this);
        _this.templateRow = _this.templateRow.bind(_this);
        _this.duplicate = _this.duplicate.bind(_this);
        _this.templateRows = _this.templateRows.bind(_this);
        _this.newTemplate = _this.newTemplate.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        _this.update = _this.update.bind(_this);
        return _this;
    }

    _createClass(Templates, [{
        key: 'newTemplate',
        value: function newTemplate() {
            var _this2 = this;

            this.setState({ isLoading: true });

            _axios2.default.post('/emails/template').then(function (res) {
                _this2.setState({ isLoading: false });
                _this2.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
            });
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            _axios2.default.get('/emails').then(function (res) {
                _this3.setState(_extends({}, _this3.state, {
                    'isError': false,
                    'isLoading': false,
                    'emails': res.data
                }));
            }).catch(function (res) {
                _this3.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'createFollowup',
        value: function createFollowup() {
            var _this4 = this;

            this.setState({
                askCreate: false
            });

            if (this.props.general.settings.PACKAGE_FOLLOWUP != '1') {
                this.setState({
                    askUpgrade: true
                });
            } else {
                this.setState({ isLoading: true });
                _axios2.default.post('/emails/' + this.state.followUpFor + '/followup').then(function (res) {
                    _this4.setState({ isLoading: false });
                    _this4.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
                });
            }
        }
    }, {
        key: 'duplicate',
        value: function duplicate(id) {
            var _this5 = this;

            this.setState({
                isLoading: true
            });

            _axios2.default.post('/emails/' + id + '/duplicate').then(function (res) {
                _this5.setState({ isLoading: false });
                _this5.props.router.push(_General2.default.Link('/builder/email/' + res.data.id));
            });
        }
    }, {
        key: 'followup',
        value: function followup(id) {
            this.setState({
                askCreate: true,
                followUpFor: id
            });
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'askDelete',
        value: function askDelete(id) {
            this.setState({ askDelete: id });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this6 = this;

            this.setState({ askDelete: false, isLoading: true });
            _axios2.default.delete('/emails/' + id).then(function (res) {
                _axios2.default.get('/emails').then(function (res) {
                    _this6.setState({
                        'isError': false,
                        'isLoading': false,
                        'emails': res.data
                    });
                });
            });
        }
    }, {
        key: 'rowOptions',
        value: function rowOptions(email) {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                { className: 'btn-group', role: 'group' },
                email.type != 'TEMPLATE' ? _react2.default.createElement(
                    _rcTooltip2.default,
                    { placement: 'top', overlay: _react2.default.createElement(
                            'span',
                            null,
                            'Create followup'
                        ) },
                    _react2.default.createElement(
                        'button',
                        { onClick: function onClick() {
                                return _this7.followup(email.id);
                            }, className: 'btn btn-icon btn-default btn-outline' },
                        _react2.default.createElement('i', { className: 'icon fa-level-up', 'aria-hidden': 'true' })
                    )
                ) : null,
                _react2.default.createElement(
                    _rcTooltip2.default,
                    { placement: 'top', overlay: _react2.default.createElement(
                            'span',
                            null,
                            'Edit e-mail'
                        ) },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _General2.default.Link('/builder/email/' + email.id), className: 'btn btn-icon btn-default btn-outline' },
                        _react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
                    )
                ),
                _react2.default.createElement(
                    _rcTooltip2.default,
                    { placement: 'top', overlay: _react2.default.createElement(
                            'span',
                            null,
                            'Duplicate e-mail'
                        ) },
                    _react2.default.createElement(
                        'button',
                        { onClick: function onClick() {
                                return _this7.duplicate(email.id);
                            }, className: 'btn btn-icon btn-default btn-outline' },
                        _react2.default.createElement('i', { className: 'icon wb-copy', 'aria-hidden': 'true' })
                    )
                ),
                _react2.default.createElement(
                    _rcTooltip2.default,
                    { placement: 'top', overlay: _react2.default.createElement(
                            'span',
                            null,
                            'Delete e-mail'
                        ) },
                    _react2.default.createElement(
                        'button',
                        { onClick: function onClick(e) {
                                _this7.askDelete(email.id);
                            }, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
                        _react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
                    )
                )
            );
        }
    }, {
        key: 'templateRow',
        value: function templateRow(email) {

            return _react2.default.createElement(
                'tr',
                { key: 'email-' + email.id },
                _react2.default.createElement(
                    'td',
                    null,
                    '#',
                    email.id
                ),
                _react2.default.createElement(
                    'td',
                    { style: { width: '80%', 'textAlign': 'left' } },
                    email.subject
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.rowOptions(email)
                )
            );
        }
    }, {
        key: 'emailRow',
        value: function emailRow(email) {
            var followup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var ret = [];

            var td_style = {};
            if (followup) {
                td_style.backgroundColor = '#fafafa';
            }

            ret.push(_react2.default.createElement(
                'tr',
                { key: 'email-' + email.id },
                _react2.default.createElement(
                    'td',
                    { style: td_style },
                    '#',
                    email.id
                ),
                _react2.default.createElement(
                    'td',
                    { style: td_style },
                    _react2.default.createElement(
                        'div',
                        { style: { position: 'relative' } },
                        followup ? _react2.default.createElement('i', { className: 'icon fa-level-up', style: { position: 'absolute', 'left': 0, top: 4, fontSize: '17px', transform: 'scale(-1, 1)' } }) : null,
                        email.subject
                    )
                ),
                this.state.columns.includes('t') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.description
                ) : null,
                this.state.columns.includes('cs') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.clicked
                ) : null,
                this.state.columns.includes('cr') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.clickRate,
                    '%'
                ) : null,
                this.state.columns.includes('o') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.opened
                ) : null,
                this.state.columns.includes('or') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.openRate,
                    '%'
                ) : null,
                this.state.columns.includes('s') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.sent
                ) : null,
                this.state.columns.includes('q') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.queued
                ) : null,
                this.state.columns.includes('r') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.revenue
                ) : null,
                this.state.columns.includes('c') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.converted
                ) : null,
                this.state.columns.includes('cvr') ? _react2.default.createElement(
                    'td',
                    { style: td_style },
                    email.rate,
                    '%'
                ) : null,
                _react2.default.createElement(
                    'td',
                    { style: td_style, className: 'column-status s-' + email.status },
                    _react2.default.createElement(
                        'span',
                        null,
                        email.status > 0 ? _react2.default.createElement('i', { className: 'icon wb-check' }) : _react2.default.createElement('i', { className: 'icon wb-close' })
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { style: td_style },
                    this.rowOptions(email)
                )
            ));

            for (var i in email.followup) {
                var rows = this.emailRow(email.followup[i], true);

                for (var r in rows) {
                    ret.push(rows[r]);
                }
            }

            return ret;
        }
    }, {
        key: 'rows',
        value: function rows() {
            var _this8 = this;

            var data = [];
            this.state.emails.map(function (email, i) {
                if (email.type != 'TEMPLATE') {
                    data.push(_this8.emailRow(email));
                }
            });

            if (data.length < 10) {
                var placeholder = this.placeholderRow(10 - data.length, this.state.columns.length + 4);
                for (var i in placeholder) {
                    data.push(placeholder[i]);
                }
            }

            return data;
        }
    }, {
        key: 'templateRows',
        value: function templateRows() {
            var _this9 = this;

            var data = [];
            this.state.emails.map(function (email, i) {
                if (email.type == 'TEMPLATE') {
                    data.push(_this9.templateRow(email));
                }
            });

            if (data.length < 10) {
                var placeholder = this.placeholderRow(10 - data.length, 3);
                for (var i in placeholder) {
                    data.push(placeholder[i]);
                }
            }

            return data;
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.emails.length == 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'E-mails | Crall.io' }),
                    _react2.default.createElement(_NoResult2.default, {
                        header: 'No e-mails found',
                        body: 'You have not created a e-mail yet. Click the button to get started.',
                        link: '/builder/email/picker',
                        button: 'Create my first e-mail'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-files-o' }),
                        ' Templates'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            'div',
                            { style: { marginRight: '10px' }, className: 'btn-group dropdown' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
                                _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                                ' Create new'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
                                _react2.default.createElement(
                                    'a',
                                    { onClick: this.newTemplate, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem' },
                                    'Template'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Templates | Crall.io' }),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Templates', cols: { 'left': 2, 'right': 10 }, panel: false, description: 'List of all your custom e-mail templates' },
                        _react2.default.createElement(
                            'table',
                            { className: 'table outline' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        '#'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: { textAlign: 'left' } },
                                        'Description'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Actions'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.templateRows()
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Templates;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Templates = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Templates);
exports.default = Templates;

/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popups = function (_React$Component) {
	_inherits(Popups, _React$Component);

	function Popups(props) {
		_classCallCheck(this, Popups);

		var _this = _possibleConstructorReturn(this, (Popups.__proto__ || Object.getPrototypeOf(Popups)).call(this, props));

		_this.changeStatus = function (id, status) {
			var popups = [].concat(_toConsumableArray(_this.state.popups));
			if (_this.props.general.settings.PACKAGE_POPUP != "1") {
				_Notification2.default.error("You're not subscribed to the platform package.");
				return;
			}

			_axios2.default.put('/popups/' + id + '/status', {});

			popups = popups.map(function (popup) {
				if (popup.id == id) {
					popup.status = status == 1 ? 0 : 1;
				}

				return popup;
			});

			_this.setState({
				popups: popups
			});
		};

		_this.state = {
			isLoading: true,
			isError: false,
			askDelete: false,
			popups: []
		};

		_this.rows = _this.rows.bind(_this);
		_this.export = _this.export.bind(_this);
		_this.duplicate = _this.duplicate.bind(_this);
		return _this;
	}

	_createClass(Popups, [{
		key: 'placeholder',
		value: function placeholder() {
			return _react2.default.createElement(
				'span',
				{ className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
				'\xA0'
			);
		}
	}, {
		key: 'export',
		value: function _export(id) {
			var _this2 = this;

			this.setState({
				isLoading: true
			});
			_axios2.default.get('/popups/' + id + '/export').then(function (res) {
				_this2.setState({
					isLoading: false
				});
				document.location = res.data.url;
			});
		}
	}, {
		key: 'duplicate',
		value: function duplicate(id) {
			var _this3 = this;

			this.setState({
				isLoading: true
			});

			_axios2.default.post('/popups/' + id + '/duplicate').then(function (res) {
				_this3.setState({ isLoading: false });
				_this3.props.router.push(_General2.default.Link('/builder/popup/' + res.data.id));
			});
		}
	}, {
		key: 'rows',
		value: function rows() {
			var _this4 = this;

			var data = this.placeholderRow(10, 7);

			this.state.popups.map(function (popup, i) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: 'popup-' + popup.id },
					_react2.default.createElement(
						'td',
						null,
						'#',
						popup.id
					),
					_react2.default.createElement(
						'td',
						null,
						popup.name
					),
					_react2.default.createElement(
						'td',
						null,
						popup.views
					),
					_react2.default.createElement(
						'td',
						null,
						popup.leads
					),
					_react2.default.createElement(
						'td',
						null,
						popup.rate,
						'%'
					),
					_react2.default.createElement(
						'td',
						{ style: { cursor: 'pointer' }, onClick: function onClick() {
								return _this4.changeStatus(popup.id, popup.status);
							}, className: 'column-status s-' + popup.status },
						_react2.default.createElement(
							_rcTooltip2.default,
							{ placement: 'top', overlay: '' + (popup.status == 1 ? 'Click here to deactivate popup' : 'Click here to activate popup') },
							_react2.default.createElement(
								'span',
								null,
								popup.status == 1 ? _react2.default.createElement('i', { className: 'icon wb-check' }) : _react2.default.createElement('i', { className: 'icon wb-close' })
							)
						)
					),
					_react2.default.createElement(
						'td',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'btn-group', role: 'group' },
							_react2.default.createElement(
								_rcTooltip2.default,
								{ placement: 'top', overlay: _react2.default.createElement(
										'span',
										null,
										'Export subscribers'
									) },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick(e) {
											_this4.export(popup.id);
										}, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
									_react2.default.createElement('i', { className: 'icon wb-print', 'aria-hidden': 'true' })
								)
							),
							_react2.default.createElement(
								_rcTooltip2.default,
								{ placement: 'top', overlay: _react2.default.createElement(
										'span',
										null,
										'Edit popup'
									) },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: _General2.default.Link('/builder/popup/' + popup.id), className: 'btn btn-icon btn-default btn-outline' },
									_react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
								)
							),
							_react2.default.createElement(
								_rcTooltip2.default,
								{ placement: 'top', overlay: _react2.default.createElement(
										'span',
										null,
										'Duplicate popup'
									) },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick() {
											return _this4.duplicate(popup.id);
										}, className: 'btn btn-icon btn-default btn-outline' },
									_react2.default.createElement('i', { className: 'icon wb-copy', 'aria-hidden': 'true' })
								)
							),
							_react2.default.createElement(
								_rcTooltip2.default,
								{ placement: 'top', overlay: _react2.default.createElement(
										'span',
										null,
										'Delete popup'
									) },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick(e) {
											_this4.askDelete(popup.id);
										}, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
									_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
								)
							)
						)
					)
				);
			});

			return data;
		}
	}, {
		key: 'askDelete',
		value: function askDelete(id) {
			this.setState({ askDelete: id });
		}
	}, {
		key: 'delete',
		value: function _delete(id) {
			var _this5 = this;

			this.setState({ askDelete: false, isLoading: true });
			_axios2.default.delete('/popups/' + id).then(function (res) {
				_axios2.default.get('/popups').then(function (res) {
					_this5.setState({
						'isError': false,
						'isLoading': false,
						'popups': res.data
					});
				});
			});
		}
	}, {
		key: 'placeholderRow',
		value: function placeholderRow(rows, cols) {
			var td = [];
			for (var i = 1; i <= cols; i++) {
				td.push(_react2.default.createElement(
					'td',
					{ key: i },
					this.placeholder()
				));
			}

			var row = [];
			for (var _i = 1; _i <= rows; _i++) {
				row.push(_react2.default.createElement(
					'tr',
					{ key: _i },
					td
				));
			}

			return row;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this6 = this;

			_axios2.default.get('/popups').then(function (res) {
				_this6.setState(_extends({}, _this6.state, {
					'isError': false,
					'isLoading': false,
					'popups': res.data
				}));
			}).catch(function (res) {
				_this6.setState({ 'isError': res.message });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this7 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
			}

			if (this.state.popups.length == 0) {
				return _react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Popups | Crall.io' }),
					_react2.default.createElement(_NoResult2.default, {
						header: 'No popups found',
						body: 'You have not created a popup yet. Click the button to get started.',
						link: '/builder/popup/picker',
						button: 'Create my first popup'
					})
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-layout' }),
						' Popups'
					),
					_react2.default.createElement(
						'div',
						{ className: 'page-header-actions' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: _General2.default.Link("/builder/popup/picker"), className: 'btn btn-dark' },
							_react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
							'  New'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 p-0' },
						_react2.default.createElement(_reactHelmet2.default, { title: 'Popups | Crall.io' }),
						_react2.default.createElement(
							'table',
							{ className: 'table outline' },
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'#'
									),
									_react2.default.createElement(
										'th',
										null,
										'Name'
									),
									_react2.default.createElement(
										'th',
										null,
										'Views'
									),
									_react2.default.createElement(
										'th',
										null,
										'Leads'
									),
									_react2.default.createElement(
										'th',
										null,
										'Conversion rate'
									),
									_react2.default.createElement(
										'th',
										null,
										'Status'
									),
									_react2.default.createElement(
										'th',
										null,
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.rows()
							)
						),
						_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
								_this7.delete(e);
							}, onClose: function onClose() {
								_this7.setState({ askDelete: false });
							}, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this popup?' })
					)
				)
			);
		}
	}]);

	return Popups;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Popups = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Popups);
exports.default = Popups;

/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Discounts = function (_React$Component) {
	_inherits(Discounts, _React$Component);

	function Discounts(props) {
		_classCallCheck(this, Discounts);

		var _this = _possibleConstructorReturn(this, (Discounts.__proto__ || Object.getPrototypeOf(Discounts)).call(this, props));

		_this.state = {
			isLoading: true,
			isError: false,
			unknownDiscounts: [],
			discounts: []
		};

		_this.handleEdit = _this.handleEdit.bind(_this);
		_this.rows = _this.rows.bind(_this);
		_this.unknownRows = _this.unknownRows.bind(_this);
		return _this;
	}

	_createClass(Discounts, [{
		key: 'handleEdit',
		value: function handleEdit(id) {
			this.props.router.push(_General2.default.Link('/discounts/' + id));
		}
	}, {
		key: 'placeholder',
		value: function placeholder() {
			return _react2.default.createElement(
				'span',
				{ className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
				'\xA0'
			);
		}
	}, {
		key: 'unknownRows',
		value: function unknownRows() {
			var data = this.placeholderRow(10, 4);

			this.state.unknownDiscounts.map(function (discount, i) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: 'unknown-' + discount.discount_code },
					_react2.default.createElement(
						'td',
						null,
						discount.discount_code
					),
					_react2.default.createElement(
						'td',
						null,
						discount.total
					),
					_react2.default.createElement(
						'td',
						null,
						discount.c
					),
					_react2.default.createElement(
						'td',
						null,
						(0, _moment2.default)(_General4.default.toLocalTime(discount.created_at)).fromNow()
					)
				);
			});

			return data;
		}
	}, {
		key: 'rows',
		value: function rows() {
			var _this2 = this;

			var data = this.placeholderRow(10, 9);

			this.state.discounts.map(function (discount, i) {
				data[i] = _react2.default.createElement(
					'tr',
					{ key: 'discount-' + discount.id },
					_react2.default.createElement(
						'td',
						null,
						discount.id
					),
					_react2.default.createElement(
						'td',
						null,
						discount.name
					),
					_react2.default.createElement(
						'td',
						null,
						discount.generated_amount
					),
					_react2.default.createElement(
						'td',
						null,
						discount.generated_orders
					),
					_react2.default.createElement(
						'td',
						null,
						discount.auto_update == 1 ? '-' : discount.code
					),
					_react2.default.createElement(
						'td',
						null,
						discount.auto_update == 1 ? discount.amount : '-'
					),
					_react2.default.createElement(
						'td',
						null,
						discount.auto_update == 1 ? discount.type == 'sum' ? 'Amount off' : 'Percent' : '-'
					),
					_react2.default.createElement(
						'td',
						null,
						(0, _moment2.default)(_General4.default.toLocalTime(discount.created_at)).fromNow()
					),
					_react2.default.createElement(
						'td',
						{ className: 'text-center' },
						_react2.default.createElement(
							'div',
							{ className: 'btn-group', role: 'group' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: function onClick(e) {
										e.stopPropagation();_this2.handleEdit(discount.id);
									}, className: 'btn btn-icon btn-default btn-outline' },
								_react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
							)
						)
					)
				);
			});

			return data;
		}
	}, {
		key: 'placeholderRow',
		value: function placeholderRow(rows, cols) {
			var td = [];
			for (var i = 1; i <= cols; i++) {
				td.push(_react2.default.createElement(
					'td',
					{ key: i },
					this.placeholder()
				));
			}

			var row = [];
			for (var _i = 1; _i <= rows; _i++) {
				row.push(_react2.default.createElement(
					'tr',
					{ key: _i },
					td
				));
			}

			return row;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this3 = this;

			_axios2.default.get('/discounts').then(function (res) {
				_this3.setState(_extends({}, _this3.state, {
					'isError': false,
					'isLoading': false,
					'discounts': res.data
				}));
			}).catch(function (res) {
				_this3.setState({ 'isError': res.message });
			});

			_axios2.default.get('/discounts/unknown').then(function (res) {
				_this3.setState({
					'unknownDiscounts': res.data
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
			}

			if (!_General2.default.appHasType('ecommerce')) {
				return _react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Discounts | Crall.io' }),
					_react2.default.createElement(_NoResult2.default, {
						header: 'No ecommerce addon installed',
						body: 'Before you can use discounts you must connect Crall to your shop. Do this by installing an app.',
						link: '/apps',
						button: 'Install app'
					})
				);
			}

			if (this.state.discounts.length == 0) {
				return _react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Discounts | Crall.io' }),
					_react2.default.createElement(_NoResult2.default, {
						header: 'No discounts found',
						body: 'You have not created a discount yet. Click the button to get stated.',
						link: '/discounts/new',
						button: 'Create my first discount'
					})
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-tag' }),
						' Discounts'
					),
					_react2.default.createElement(
						'div',
						{ className: 'page-header-actions' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: _General2.default.Link("/discounts/new"), className: 'btn btn-dark' },
							_react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
							'  New'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Discounts | Crall.io' }),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Added discounts', panel: false, description: 'Overview of the discounts you\'ve added.' },
						_react2.default.createElement(
							'table',
							{ className: 'table outline inherit-position' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Id'
									),
									_react2.default.createElement(
										'th',
										null,
										'Name'
									),
									_react2.default.createElement(
										'th',
										null,
										'Generated amount'
									),
									_react2.default.createElement(
										'th',
										null,
										'Times used'
									),
									_react2.default.createElement(
										'th',
										null,
										'Code'
									),
									_react2.default.createElement(
										'th',
										null,
										'Amount'
									),
									_react2.default.createElement(
										'th',
										null,
										'Type'
									),
									_react2.default.createElement(
										'th',
										null,
										'Created'
									),
									_react2.default.createElement(
										'th',
										{ className: 'text-center' },
										'Actions'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.rows()
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Unknown discounts', panel: false, description: 'List of discounts used in your store that Crall don\'t recognize.' },
						_react2.default.createElement(
							'table',
							{ className: 'table outline' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Code'
									),
									_react2.default.createElement(
										'th',
										null,
										'Generated amount'
									),
									_react2.default.createElement(
										'th',
										null,
										'Times used'
									),
									_react2.default.createElement(
										'th',
										null,
										'Last used'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.unknownRows()
							)
						)
					)
				)
			);
		}
	}]);

	return Discounts;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Discounts = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Discounts);
exports.default = Discounts;

/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Discount = __webpack_require__(631);

var _Discount2 = _interopRequireDefault(_Discount);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Discounts = function (_React$Component) {
	_inherits(Discounts, _React$Component);

	function Discounts(props) {
		_classCallCheck(this, Discounts);

		var _this = _possibleConstructorReturn(this, (Discounts.__proto__ || Object.getPrototypeOf(Discounts)).call(this, props));

		_this.state = {
			isLoading: false,
			isError: false,
			discount: false,
			current: false
		};

		_this.handleSubmit = _this.handleSubmit.bind(_this);
		_this.refresh = _this.refresh.bind(_this);
		return _this;
	}

	_createClass(Discounts, [{
		key: 'handleSubmit',
		value: function handleSubmit(values) {
			var _this2 = this;

			_Notification2.default.info('Saving...');

			var method = 'post';
			var url = '/discounts';

			if (this.props.router.params.discount_id) {
				method = 'put';
				url += '/' + this.props.router.params.discount_id;
			}

			values.auto_update = values.auto_update === true ? 1 : 0;
			values.clone = values.clone === true ? 1 : 0;

			_axios2.default[method](url, values).then(function (response) {
				_Notification2.default.success('Discount saved');
				_this2.props.router.push(_General2.default.Link('/discounts'));
			}).catch(function (error) {
				_Notification2.default.error(error.message);
			});
		}
	}, {
		key: 'getCurrent',
		value: function getCurrent() {
			var current = 'new';
			if (this.props.router.params.discount_id) {
				current = this.props.router.params.discount_id;
			}

			return current;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {

			this.setState({ 'current': this.getCurrent() });
			this.refresh();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(props, state) {
			if (this.state.current != this.getCurrent()) {
				this.setState({ 'current': this.getCurrent() });
				this.refresh();
			}
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			var _this3 = this;

			if (this.props.router.params.discount_id) {
				this.setState({ isLoading: true });

				_axios2.default.get('/discounts/' + this.props.router.params.discount_id).then(function (response) {
					response.data.auto_update = response.data.auto_update == 1 ? true : false;
					response.data.clone = response.data.clone == 1 ? true : false;
					_this3.setState({ 'isLoading': false, 'isError': false, discount: response.data });
				}).catch(function (error) {
					_this3.setState({ isError: error.message });
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
			}

			if (!_General2.default.appHasType('ecommerce')) {
				return _react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Discounts | Crall.io' }),
					_react2.default.createElement(_NoResult2.default, {
						header: 'No ecommerce addon installed',
						body: 'Before you can use discounts you must connect Crall to your shop. Do this by installing an app.',
						link: '/apps',
						button: 'Install app'
					})
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-tag' }),
						' Discounts'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Discounts | Crall.io' }),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Settings', description: 'Define your discount' },
						_react2.default.createElement(_Discount2.default, { errorMessage: this.state.error, initialValues: this.state.discount ? this.state.discount : { clone: false, auto_update: false, expire: 1, type: 'percent' }, isWaiting: this.state.isWaiting, onSubmit: this.handleSubmit })
					)
				)
			);
		}
	}]);

	return Discounts;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Discounts = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Discounts);
exports.default = Discounts;

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _Toolbar = __webpack_require__(1662);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Chat = __webpack_require__(161);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Chat = function (_React$Component) {
	_inherits(Chat, _React$Component);

	function Chat(props) {
		_classCallCheck(this, Chat);

		var _this = _possibleConstructorReturn(this, (Chat.__proto__ || Object.getPrototypeOf(Chat)).call(this, props));

		_this.clickTab = _this.clickTab.bind(_this);
		_this.getTemplates = _this.getTemplates.bind(_this);
		_this.state = {
			askUpgrade: false,
			templates: []
		};
		return _this;
	}

	_createClass(Chat, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.router.params.user_id) {
				if (this.props.router.params.uid) {
					this.props.setOpenChat(this.props.router.params.uid, this.props.auth.user.id);
				} else {
					this.props.setCurrentTab(this.props.router.params.user_id);
				}
			} else {
				this.props.setCurrentTab(false);
			}
		}
	}, {
		key: 'getTemplates',
		value: function getTemplates() {
			var _this2 = this;

			this.setState({
				isLoading: true
			});

			_axios2.default.get('/chat').then(function (res) {
				_this2.setState({
					isLoading: false,
					templates: res.data.templates
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			_General2.default.loadScript('https://maps.google.com/maps/api/js?key=AIzaSyAYAu0_5_ANHFR6pLe0amZqPmt7uweOEBs');
			this.getTemplates();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.props.general.settings.PACKAGE_CHAT != '1' && !this.state.askUpgrade) {
				this.setState({ askUpgrade: true });
			}
		}
	}, {
		key: 'clickTab',
		value: function clickTab(val) {
			this.props.setCurrentTab(val);
			if (val == false) {
				this.props.router.push(_General2.default.Link('/chat/overview'));
			} else {
				this.props.router.push(_General2.default.Link('/chat/' + val));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (!this.props.chat.initialized) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			if (this.props.general.settings.PACKAGE_CHAT != '1' && !this.state.askUpgrade) {
				this.setState({ askUpgrade: true });
			}

			var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
				return _react2.default.cloneElement(child, {
					templates: _this3.state.templates,
					getTemplates: _this3.getTemplates
				});
			});

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, {
					title: 'Chat | Crall.io'
				}),
				_react2.default.createElement(_Toolbar2.default, { isOnline: this.props.chat.isOnline, setCurrentTab: this.clickTab, currentTab: this.props.chat.currentTab, me: this.props.auth.user, users: this.props.general.users }),
				_react2.default.createElement(
					'div',
					{ id: 'chat', className: 'chat-wrapper' },
					childrenWithProps
				)
			);
		}
	}]);

	return Chat;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		general: state.general,
		auth: state.auth,
		chat: state.chat
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setOpenChat: _Chat.setOpenChat, setCurrentTab: _Chat.setCurrentTab }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Chat);

/***/ }),

/***/ 1662:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toolbar = function (_React$Component) {
	_inherits(Toolbar, _React$Component);

	function Toolbar(props) {
		_classCallCheck(this, Toolbar);

		return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));
	}

	_createClass(Toolbar, [{
		key: 'handleToolbarClick',
		value: function handleToolbarClick(val) {
			this.props.setCurrentTab(val);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'conversation-wrapper' },
				_react2.default.createElement(
					'ul',
					{ className: 'nav nav-tabs nav-tabs-solid', 'data-plugin': 'nav-tabs', role: 'tablist' },
					_react2.default.createElement(
						'li',
						{ key: 'overview', className: 'nav-item ' + (this.props.currentTab === false ? 'current' : ''), role: 'presentation' },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									return _this2.handleToolbarClick(false);
								}, className: 'nav-link', 'data-toggle': 'tab', role: 'tab' },
							'Overview'
						)
					),
					_react2.default.createElement(
						'li',
						{ key: this.props.me.id, className: 'nav-item ' + (this.props.currentTab == this.props.me.id ? 'current' : ''), role: 'presentation' },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									return _this2.handleToolbarClick(_this2.props.me.id);
								}, className: 'nav-link', 'data-toggle': 'tab', role: 'tab' },
							_react2.default.createElement('img', { style: { width: '20px', borderRadius: '50%' }, src: this.props.me.image }),
							' ',
							this.props.me.firstname,
							' (Me)'
						)
					),
					this.props.users.map(function (user) {
						if (user.id == _this2.props.me.id) {
							return null;
						}
						return _react2.default.createElement(
							'li',
							{ key: user.id, className: 'nav-item ' + (_this2.props.currentTab == user.id ? 'current' : ''), role: 'presentation' },
							_react2.default.createElement(
								'a',
								{ onClick: function onClick() {
										return _this2.handleToolbarClick(user.id);
									}, className: 'nav-link', 'data-toggle': 'tab', role: 'tab' },
								_react2.default.createElement('img', { style: { width: '20px', borderRadius: '50%' }, src: user.image }),
								' ',
								user.firstname
							)
						);
					})
				),
				_react2.default.createElement(
					'div',
					{ style: { position: 'absolute', right: '10px', top: '16px' } },
					this.props.isOnline ? _react2.default.createElement(
						'span',
						{ className: 'tag tag-success' },
						'You are online'
					) : _react2.default.createElement(
						'span',
						{ className: 'tag tag-danger' },
						'You are offline'
					)
				)
			);
		}
	}]);

	return Toolbar;
}(_react2.default.Component);

exports.default = Toolbar;

/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactTimeago = __webpack_require__(266);

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(8);

var _General4 = _interopRequireDefault(_General3);

var _reactGravatar = __webpack_require__(267);

var _reactGravatar2 = _interopRequireDefault(_reactGravatar);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Chat = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatOverview = function (_React$Component) {
	_inherits(ChatOverview, _React$Component);

	function ChatOverview(props) {
		_classCallCheck(this, ChatOverview);

		var _this = _possibleConstructorReturn(this, (ChatOverview.__proto__ || Object.getPrototypeOf(ChatOverview)).call(this, props));

		_this.getConversationStatus = function (visitor) {
			if (visitor.started == 1 && visitor.assignee_id == 0) {
				return 'Open and not assigned';
			}

			if (visitor.started == 1 && visitor.assignee_id > 0) {
				return 'Open and assigned';
			}

			return '-';
		};

		_this.openChat = _this.openChat.bind(_this);
		_this.renderUnread = _this.renderUnread.bind(_this);
		return _this;
	}

	_createClass(ChatOverview, [{
		key: 'openChat',
		value: function openChat(uid) {
			this.props.setOpenChat(uid, this.props.auth.user.id);
			this.props.router.push(_General4.default.Link('/chat/' + this.props.auth.user.id + '/' + uid));
		}
	}, {
		key: 'setFilterOption',
		value: function setFilterOption(option, text) {

			if (option === false) {
				this.props.resetFilterOption();
			} else {
				var value = { 'text': text, 'key': option };
				var exist = false;

				for (var i in this.props.chat.filterOptions) {
					if (this.props.chat.filterOptions[i].key == option) {
						exist = true;
					}
				}

				if (!exist) {
					this.props.setFilterOption(value);
				}
			}
		}
	}, {
		key: 'initFilter',
		value: function initFilter() {
			if (typeof localStorage.chatFilter === 'undefined') {
				localStorage.chatFilter = JSON.stringify([]);
			} else {
				return JSON.parse(localStorage.chatFilter);
			}

			return [];
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			this.initFilter().map(function (item) {
				_this2.props.setFilterOption(item);
			});
		}
	}, {
		key: 'removeFilterOption',
		value: function removeFilterOption(option) {
			var _this3 = this;

			this.props.chat.filterOptions.map(function (item, i) {
				if (item.key == option) {
					_this3.props.removeFilterOption(i);
				}
			});
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			localStorage.chatFilter = JSON.stringify(this.props.chat.filterOptions);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions(option) {
			var _this4 = this;

			return _react2.default.createElement(
				'li',
				{ key: option.key + '-filter' },
				_react2.default.createElement(
					'a',
					{ href: 'javascript:void(0)', onClick: function onClick(e) {
							e.stopPropagation();_this4.removeFilterOption(option.key);
						}, className: 'btn btn-outline btn-default' },
					option.text,
					' ',
					_react2.default.createElement('i', { className: 'icon wb-close-mini', 'aria-hidden': 'true' })
				)
			);
		}
	}, {
		key: 'shouldIncludeInFilter',
		value: function shouldIncludeInFilter(visitor) {
			if (this.props.chat.filterOptions.length == 0) {
				return true;
			}

			var include = true;

			for (var i in this.props.chat.filterOptions) {
				var option = this.props.chat.filterOptions[i];
				switch (option.key) {
					case 'open_conversations':
						if (visitor.started != true) {
							include = false;
						}
						break;

					case 'anonymous_visitors':
						if (visitor.email != '') {
							include = false;
						}
						break;

					case 'identified_visitors':
						if (visitor.email == '') {
							include = false;
						}
						break;

					case 'has_products_in_cart':
						if (visitor.cart_items == 0) {
							include = false;
						}
						break;

					case 'no_products_in_cart':
						if (visitor.cart_items > 0) {
							include = false;
						}
						break;
				}
			}

			return include;
		}
	}, {
		key: 'renderTableItem',
		value: function renderTableItem(visitor) {
			var _this5 = this;

			var total = 0;

			if (visitor.started != 1) {
				if (visitor.online != 1) {
					return false;
				}
			}

			if (!this.shouldIncludeInFilter(visitor)) {
				return false;
			}

			return _react2.default.createElement(
				'tr',
				{ key: visitor.uid, onClick: function onClick() {
						return _this5.openChat(visitor.uid);
					} },
				_react2.default.createElement(
					'td',
					null,
					visitor.email == false ? 'Unknown' : visitor.email
				),
				_react2.default.createElement(
					'td',
					null,
					this.getConversationStatus(visitor)
				),
				_react2.default.createElement(
					'td',
					null,
					visitor.unreadMessages > 0 ? _react2.default.createElement(
						'span',
						{ className: 'tag tag-danger' },
						visitor.unreadMessages
					) : 0
				),
				_react2.default.createElement(
					'td',
					null,
					(0, _moment2.default)(visitor.last_seen).fromNow()
				),
				_react2.default.createElement(
					'td',
					null,
					visitor.cart_items
				),
				_react2.default.createElement(
					'td',
					null,
					visitor.cart_total
				),
				_react2.default.createElement(
					'td',
					null,
					visitor.title
				),
				_react2.default.createElement(
					'td',
					null,
					visitor.referrer == false ? 'Direct' : visitor.referrer
				)
			);
		}
	}, {
		key: 'renderUnread',
		value: function renderUnread() {
			var _this6 = this;

			var visitors = [];

			{
				Object.keys(this.props.chat.visitors).map(function (i) {
					if (_this6.props.chat.visitors[i].unreadMessages == 0) {
						return true;
					}
					visitors.push(_react2.default.createElement(
						'div',
						{ key: i, onClick: function onClick(e) {
								e.stopPropagation();_this6.openChat(_this6.props.chat.visitors[i].uid);
							}, className: 'card col-sm-4 col-md-3 col-p-t-10 m-t-20 m-r-20', style: { cursor: 'pointer', backgroundColor: '#f3f7fa', border: '1px solid #eee' } },
						_react2.default.createElement(
							'div',
							{ className: 'ribbon ribbon-badge ribbon-danger' },
							_react2.default.createElement(
								'span',
								{ className: 'ribbon-inner' },
								_react2.default.createElement('i', { className: 'icon wb-chat' }),
								' ',
								_react2.default.createElement(
									'strong',
									null,
									_this6.props.chat.visitors[i].unreadMessages
								)
							)
						),
						_react2.default.createElement(_reactGravatar2.default, { email: _this6.props.chat.visitors[i].email ? _this6.props.chat.visitors[i].email : 'nobody', size: 100, rating: 'pg', 'default': 'identicon', className: 'avatar avatar-100 bg-white m-b-10 m-xs-0 img-bordered' }),
						_react2.default.createElement(
							'div',
							{ className: 'card-block' },
							_react2.default.createElement(
								'h4',
								{ className: 'card-title' },
								_this6.props.chat.visitors[i].name ? _this6.props.chat.visitors[i].name : 'Unknown'
							),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_this6.props.chat.visitors[i].email ? _this6.props.chat.visitors[i].email : 'Unknown'
							),
							_react2.default.createElement(
								'p',
								{ className: 'card-text' },
								_react2.default.createElement(
									'small',
									{ className: 'text-muted' },
									'Last active ',
									(0, _moment2.default)(_this6.props.chat.visitors[i].last_seen).fromNow()
								)
							)
						)
					));
				});
			}

			if (visitors.length == 0) {
				return;
			}

			return _react2.default.createElement(
				'div',
				{ className: 'col-sm-12 masonry-item p-0' },
				_react2.default.createElement(
					'div',
					{ className: 'card card-shadow avatar-group' },
					_react2.default.createElement(
						'div',
						{ className: 'card-header bg-white text-xs-center p-30' },
						_react2.default.createElement(
							'div',
							{ className: 'card-deck-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'card-deck' },
								visitors
							)
						)
					)
				)
			);
		}
	}, {
		key: 'renderVisitors',
		value: function renderVisitors() {
			var _this7 = this;

			var data = [];
			var result = true;

			{
				Object.keys(this.props.chat.visitors).map(function (i) {
					var item = _this7.renderTableItem(_this7.props.chat.visitors[i]);
					if (item !== false) {
						data.push(item);
					}
				});
			}

			if (data.length == 0) {
				if (this.props.chat.filterOptions.length == 0) {
					return _react2.default.createElement(_NoResult2.default, {
						header: 'No visitors',
						body: 'You currently have no visitors.'
					});
				} else {
					return _react2.default.createElement(_NoResult2.default, {
						header: 'No matches',
						body: 'Your current filter didn\'t return any matches.'
					});
				}
			}

			return _react2.default.createElement(
				'table',
				null,
				_react2.default.createElement(
					'thead',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'E-mail'
						),
						_react2.default.createElement(
							'th',
							null,
							'Status'
						),
						_react2.default.createElement(
							'th',
							null,
							'Unread Messages'
						),
						_react2.default.createElement(
							'th',
							null,
							'Last activity'
						),
						_react2.default.createElement(
							'th',
							null,
							'Products in cart'
						),
						_react2.default.createElement(
							'th',
							null,
							'Total'
						),
						_react2.default.createElement(
							'th',
							null,
							'Current page'
						),
						_react2.default.createElement(
							'th',
							null,
							'Referrer'
						)
					)
				),
				_react2.default.createElement(
					'tbody',
					null,
					data
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this8 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'options pull-right' },
					_react2.default.createElement(
						'ul',
						{ className: 'nav nav-tabs nav-tabs-solid' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'dropdown' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-default btn-outline dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
									'Filter list',
									_react2.default.createElement('span', { className: 'caret' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'dropdown-menu dropdown-menu-right', role: 'menu' },
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-item', onClick: function onClick() {
												return _this8.setFilterOption('open_conversations', 'Open conversations');
											}, href: 'javascript:void(0)', role: 'menuitem' },
										'Open conversations'
									),
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-item', onClick: function onClick() {
												return _this8.setFilterOption('anonymous_visitors', 'Anonymous visitors');
											}, href: 'javascript:void(0)', role: 'menuitem' },
										'Anonymous visitors'
									),
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-item', onClick: function onClick() {
												return _this8.setFilterOption('identified_visitors', 'Identified visitors');
											}, href: 'javascript:void(0)', role: 'menuitem' },
										'Identified visitors'
									),
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-item', onClick: function onClick() {
												return _this8.setFilterOption('has_products_in_cart', 'Has products in cart');
											}, href: 'javascript:void(0)', role: 'menuitem' },
										'Has products in cart'
									),
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-item', onClick: function onClick() {
												return _this8.setFilterOption('no_products_in_cart', 'Don\'t have products in cart');
											}, href: 'javascript:void(0)', role: 'menuitem' },
										'Don\'t have products in cart'
									)
								)
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: function onClick() {
										return _this8.setFilterOption(false, false);
									}, className: 'btn btn-default btn-outline' },
								'Clear filter'
							)
						),
						_react2.default.createElement(
							'li',
							{ className: 'filter-options' },
							_react2.default.createElement(
								'ul',
								null,
								this.props.chat.filterOptions.map(function (option) {
									return _this8.filterOptions(option);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ id: 'overview', className: 'col-sm-12 ' },
					this.renderUnread(),
					this.renderVisitors(),
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null)
				)
			);
		}
	}]);

	return ChatOverview;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		chat: state.chat,
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setOpenChat: _Chat.setOpenChat, resetFilterOption: _Chat.resetFilterOption, setFilterOption: _Chat.setFilterOption, removeFilterOption: _Chat.removeFilterOption }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatOverview);

/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _uaParserJs = __webpack_require__(396);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactTimeago = __webpack_require__(266);

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRouter = __webpack_require__(6);

var _General3 = __webpack_require__(8);

var _General4 = _interopRequireDefault(_General3);

var _SocketManager = __webpack_require__(334);

var _SocketManager2 = _interopRequireDefault(_SocketManager);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Chat = __webpack_require__(161);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _reactGravatar = __webpack_require__(267);

var _reactGravatar2 = _interopRequireDefault(_reactGravatar);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _Template = __webpack_require__(680);

var _Template2 = _interopRequireDefault(_Template);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _ConversationListElement = __webpack_require__(1671);

var _ConversationListElement2 = _interopRequireDefault(_ConversationListElement);

var _ConversationInfo = __webpack_require__(1672);

var _ConversationInfo2 = _interopRequireDefault(_ConversationInfo);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _string = __webpack_require__(1673);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatConversation = function (_React$Component) {
	_inherits(ChatConversation, _React$Component);

	function ChatConversation(props) {
		_classCallCheck(this, ChatConversation);

		var _this = _possibleConstructorReturn(this, (ChatConversation.__proto__ || Object.getPrototypeOf(ChatConversation)).call(this, props));

		_this.openChat = function (uid) {
			var user_id = _this.currentUserView();

			_this.setState({
				'loaded': false
			});
			_this.props.setOpenChat(uid, user_id);
			_this.props.router.push(_General4.default.Link('/chat/' + user_id + '/' + uid));
		};

		_this.currentUserView = function () {
			var user_id = _this.props.auth.user.id;
			if (_this.props.router.params.user_id) {
				user_id = _this.props.router.params.user_id;
			}

			return user_id;
		};

		_this.load = function () {
			if (!_this.props.chat.visitors[_this.props.router.params.uid] || _this.props.chat.waitingForVisitorResponse) {
				return;
			}

			_this.newConversationOpened();

			_this.didDrawMap = false;

			_this.setState({
				loaded: true
			});

			_axios2.default.post('/ajax/IpLocation', { 'ip': _this.props.chat.visitors[_this.props.router.params.uid].ip }).then(function (res) {
				_this.setState({
					location: res.data
				});
				try {
					setTimeout(function () {
						_this.drawMap();
					}, 1000);
				} catch (err) {
					console.dir(err);
				}
			});
		};

		_this.assignedTo = function () {
			var a2 = 'Nobody';

			if (_this.props.general.users.length == 0 || !_this.props.chat.visitors[_this.props.router.params.uid]) {
				return 'Nobody';
			}

			for (var i in _this.props.general.users) {
				if (_this.props.general.users[i].id == _this.props.chat.visitors[_this.props.router.params.uid].assignee_id) {
					var name = 'Me';
					if (_this.props.general.users[i].id != _this.props.auth.user.id) {
						name = _this.props.general.users[i].firstname;
					}
					a2 = name;
				}
			}

			return a2;
		};

		_this.messages = function () {
			if (!_this.exists()) {
				return [];
			}

			if (!_this.props.chat.conversations[_this.props.router.params.uid]) {
				return [];
			}

			var messages = [].concat(_toConsumableArray(_this.props.chat.conversations[_this.props.router.params.uid]));

			messages = messages.map(function (message) {
				return JSON.parse(message);
			});

			return messages;
		};

		_this.renderMessages = function () {
			var ret = [];
			_this.messages().map(function (message, i) {
				ret.push(_react2.default.createElement(
					'div',
					{ key: i, className: '' + (message.from == 0 ? '' : 'chat-left') },
					_react2.default.createElement(
						'div',
						{ className: 'chat-avatar' },
						_react2.default.createElement(
							'a',
							{ className: 'avatar' },
							message.from == 0 ? _react2.default.createElement(_reactGravatar2.default, { email: _this.info().email ? _this.info().email : 'nobody', size: 100, rating: 'pg', 'default': 'identicon', className: 'img-responsive' }) : _react2.default.createElement('img', { src: message.image, className: 'img-responsive' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'chat-body' },
						message.url != '' && message.url ? _react2.default.createElement(
							_rcTooltip2.default,
							{ placement: 'top', overlay: _react2.default.createElement(
									'span',
									null,
									'Sent from ',
									message.url
								) },
							_this.message(message)
						) : _this.message(message)
					)
				));
			});

			return ret;
		};

		_this.setValue = function (val) {
			_this.setState({ 'inputValue': val });
		};

		_this.handleInput = function (e) {
			_this.setValue(e.target.value);
		};

		_this.operatorIsTyping = function (status) {
			_SocketManager2.default.operatorIsTyping(_this.props.router.params.uid, _this.props.auth.user.id, status);
		};

		_this.handleKeypress = function (e) {
			if (e.key == 'Meta') {
				return false;
			}

			if (parseInt(_this.info().online) == 1) {
				if (_this.type_timer === null) {
					_this.operatorIsTyping(1);
				}
				clearTimeout(_this.type_timer);

				_this.type_timer = setTimeout(function () {
					_this.type_timer = null;
					_this.operatorIsTyping(0);
				}, 6000);
			}

			if (e.key == 'Enter') {
				e.preventDefault();

				if (!_this.state.inputValue.replace(/\s/g, '').length) {
					return false;
				}

				var message = {
					'text': _this.state.inputValue,
					'image': _this.props.auth.user.image,
					'from': _this.props.auth.user.id,
					'uid': _this.info().uid,
					'created_at': (0, _moment2.default)().utc().format()
				};

				if (_this.info().online == 0 && _this.isEmail(_this.info().email)) {
					message.email = 1;
				}

				if (_this.info().online != 0) {
					clearTimeout(_this.type_timer);
					_this.type_timer = null;

					_this.operatorIsTyping(0);
				}

				_SocketManager2.default.sendMessage(message);

				if (_this.info().online == 0 && _this.isEmail(_this.info().email)) {
					_axios2.default.post('/conversations/' + _this.info().uid + '/email', { message: message });
				}

				if (_this.info().online == 0 && !_this.isEmail(_this.info().email)) {
					_Notification2.default.error("Couldn't send message by e-mail. Unknown e-mail address.");
				}

				if (_this.info().assignee_id == 0) {
					_this.assign(_this.props.auth.user.id);
				}

				_this.setValue('');
			}
		};

		_this.applyTemplate = function (e) {
			_this.setState({
				showTemplates: false,
				inputValue: _this.props.templates[e.value].message
			});

			_this.refs.input_message.focus();
		};

		_this.handleTemplateSubmit = function (e) {};

		_this.getMessageTemplates = function () {
			var ret = [];

			for (var i in _this.props.templates) {
				ret.push({
					clearableValue: false,
					label: _this.props.templates[i].name,
					value: i
				});
			}

			return ret;
		};

		_this.renderConversation = function () {
			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'col-md-5 c' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 p-10 top' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6' },
							_react2.default.createElement(
								'div',
								{ className: 'dropdown' },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-default btn-sm dropdown-toggle', id: 'assignee', 'data-toggle': 'dropdown', 'aria-expanded': 'true' },
									_react2.default.createElement(
										'strong',
										null,
										'Assigned to:'
									),
									' ',
									_this.assignedTo()
								),
								_react2.default.createElement(
									'div',
									{ className: 'dropdown-menu', 'aria-labelledby': 'assignee', role: 'menu' },
									_this.props.general.users.map(function (user) {
										return _react2.default.createElement(
											'a',
											{ key: user.id, onClick: function onClick(e) {
													e.stopPropagation();_this.assign(user.id);
												}, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem' },
											user.firstname
										);
									})
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6 text-right' },
							_react2.default.createElement(
								'button',
								{ onClick: function onClick() {
										_this.setState({ askClose: true });
									}, className: 'btn btn-sm btn-default' },
								_react2.default.createElement('i', { className: 'icon wb-close' }),
								'Close conversation'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'messages', className: 'messages' },
						_this.renderMessages(),
						_this.renderIsTyping()
					),
					_react2.default.createElement(
						'form',
						{ className: 'app-message-input' },
						_react2.default.createElement(
							'div',
							{ className: 'message-input' },
							_react2.default.createElement('textarea', {
								ref: 'input_message',
								className: 'form-control message',
								rows: '1',
								placeholder: 'Write a message, <enter> to send',
								value: _this.state.inputValue,
								onChange: _this.handleInput,
								onKeyDown: _this.handleKeypress,
								disabled: !_this.props.chat.isOnline
							}),
							_this.state.showTemplates ? _react2.default.createElement(
								'div',
								{ className: 'chat-templates' },
								_react2.default.createElement(
									'div',
									{ className: 'select-up template-arrow_box' },
									_react2.default.createElement(_reactSelect2.default, {
										clearable: false,
										name: 'form-field-name',
										value: false,
										autofocus: true,
										options: _this.getMessageTemplates(),
										onChange: _this.applyTemplate
									}),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'button',
										{ onClick: function onClick(e) {
												e.preventDefault();e.stopPropagation();_this.setState({ isEditingTemplate: true });
											}, className: 'btn btn-sm btn-dark' },
										_react2.default.createElement('i', { className: 'icon wb-plus' }),
										' Add template'
									)
								)
							) : null,
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', 'top': 0, right: 0 } },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick(e) {
											e.stopPropagation();_this.setState({ showTemplates: !_this.state.showTemplates });
										}, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
									_react2.default.createElement('i', { className: 'icon wb-star', 'aria-hidden': 'true' })
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-md-4 d' },
					_react2.default.createElement(
						'div',
						{ id: 'customGmap', style: { height: '300px' }, className: 'height-300' },
						_react2.default.createElement('i', { className: 'icon wb-map', 'aria-hidden': 'true' })
					),
					_this.exists() ? _react2.default.createElement(_ConversationInfo2.default, { city: _this.state.location.city, pages: _this.props.chat.pages[_this.props.router.params.uid], cart: _this.props.chat.cart[_this.props.router.params.uid], country: _this.state.location.country, visitor: _this.props.chat.visitors[_this.props.router.params.uid] }) : null
				),
				_react2.default.createElement(
					_reactPortal2.default,
					{ closeOnEsc: true, onClose: function onClose(e) {
							_this.setState({ currentTemplate: false, isEditingTemplate: false });
						}, isOpened: _this.state.isEditingTemplate },
					_react2.default.createElement(
						_FullScreenOverlay2.default,
						null,
						_react2.default.createElement(_Template2.default, { handleSave: _this.props.getTemplates, onClose: function onClose(e) {
								_this.setState({ currentTemplate: false, isEditingTemplate: false });
							}, templateId: _this.state.currentTemplate ? _this.state.currentTemplate : false })
					)
				),
				_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
						_this.closeConversation(e);
					}, onClose: function onClose() {
						_this.setState({ askClose: false });
					}, param: _this.state.askClose, title: 'Are you sure?', body: 'Close this conversation?' })
			);
		};

		_this.state = {
			'inputValue': '',
			'location': false,
			'loaded': false,
			'askClose': false,
			showTemplates: false,
			currentTemplate: false,
			isEditingTemplate: false
		};

		_this.type_timer = null;

		_this.didDrawMap = false;

		return _this;
	}

	_createClass(ChatConversation, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			if (!next.chat.visitors[this.props.router.params.uid] && this.props.router.params.uid) {
				this.props.router.push(_General4.default.Link('/chat/' + this.props.auth.user.id));
				return;
			}

			if (next.chat.currentChat != this.props.chat.currentChat) {
				this.load();
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.router.params.uid && !this.props.chat.currentChat) {
				var user_id = this.currentUserView();

				this.setState({
					'loaded': false
				});
				this.props.setOpenChat(this.props.router.params.uid, user_id);
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (!this.exists() && this.props.router.params.uid) {
				this.props.router.push(_General4.default.Link('/chat/' + this.props.auth.user.id));
				return;
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (!this.state.loaded) {
				this.load();
			}

			this.scrollToBottom();
		}
	}, {
		key: 'scrollToBottom',
		value: function scrollToBottom() {
			if (this.props.router.params.uid && this.refs.messages) {
				this.refs.messages.scrollTop = this.refs.messages.scrollHeight;
			}
		}
	}, {
		key: 'info',
		value: function info() {
			return this.props.chat.visitors[this.props.router.params.uid];
		}
	}, {
		key: 'convertLinkToHTML',
		value: function convertLinkToHTML(message) {
			return (0, _string2.default)(message, {
				className: 'crall-chat-link'
			});
		}
	}, {
		key: 'message',
		value: function message(_message) {
			return _react2.default.createElement(
				'div',
				{ className: 'chat-content' },
				_react2.default.createElement('p', { dangerouslySetInnerHTML: _General2.default.createDangerousHtml(this.convertLinkToHTML(_message.text)) }),
				_react2.default.createElement(
					'span',
					{ className: 'chat-time' },
					(0, _moment2.default)(_General2.default.toLocalTime(_message.created_at)).fromNow()
				),
				_react2.default.createElement(
					'span',
					{ style: { fontSize: '11px' } },
					'Sent by ',
					typeof _message.email === 'undefined' ? 'chat' : _message.email == '1' ? 'email' : 'chat'
				)
			);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.type_timer !== null) {
				clearTimeout(this.type_timer);
				this.type_timer = null;
				this.operatorIsTyping(0);
			}
		}
	}, {
		key: 'isEmail',
		value: function isEmail(email) {
			if (!email) {
				return false;
			}

			if (typeof email !== 'string') {
				return false;
			}

			if (email === '') {
				return false;
			}

			return true;
		}
	}, {
		key: 'renderIsTyping',
		value: function renderIsTyping() {
			if (!this.exists()) {
				return null;
			}

			if (this.info().isTyping == 1) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'chat-body' },
						_react2.default.createElement(
							'div',
							{ className: 'chat-content' },
							_react2.default.createElement(
								'div',
								{ className: 'isTyping' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										{ className: 'p1' },
										_react2.default.createElement('i', { className: 'icon wb-medium-point', 'aria-hidden': 'true' })
									),
									_react2.default.createElement(
										'li',
										{ className: 'p2' },
										_react2.default.createElement('i', { className: 'icon wb-medium-point', 'aria-hidden': 'true' })
									),
									_react2.default.createElement(
										'li',
										{ className: 'p3' },
										_react2.default.createElement('i', { className: 'icon wb-medium-point', 'aria-hidden': 'true' })
									)
								),
								_react2.default.createElement('div', { className: 'clearfix' })
							)
						)
					)
				);
			}
		}
	}, {
		key: 'closeConversation',
		value: function closeConversation() {
			_axios2.default.post('/conversations/' + this.info().uid + '/close');

			_SocketManager2.default.closeConversation(this.info().uid);

			this.props.setVisitorKey(this.info().uid, 'unreadMessages', 0);
			this.props.setVisitorKey(this.info().uid, 'started', 0);
			this.props.setVisitorKey(this.info().uid, 'assignee_id', 0);

			if (this.info().online == 0) {
				this.props.removeVisitor(this.info().uid);
			}

			this.props.router.push(_General4.default.Link('/chat/' + this.props.auth.user.id));
		}
	}, {
		key: 'assign',
		value: function assign(user_id) {
			this.props.setAssignee(user_id, this.props.router.params.uid);
			_SocketManager2.default.setAssignee(user_id, this.props.router.params.uid);
		}
	}, {
		key: 'exists',
		value: function exists() {
			if (this.props.chat.visitors[this.props.router.params.uid]) {
				return true;
			}

			return false;
		}
	}, {
		key: 'drawMap',
		value: function drawMap() {
			if (this.didDrawMap == true) {
				return false;
			}

			if (!this.exists()) {
				return false;
			}

			var lat = this.state.location.lat;
			var lng = this.state.location.long;

			if (!lat || !lng) {
				return '';
			}

			if (!document.querySelector('#customGmap')) {
				return;
			}

			this.didDrawMap = true;

			var map = new GMaps({
				el: '#customGmap',
				lat: lat,
				lng: lng,
				zoom: 7,
				zoomControl: true,
				zoomControlOpt: {
					style: "SMALL",
					position: "TOP_LEFT"
				},
				panControl: true,
				streetViewControl: false,
				mapTypeControl: false,
				overviewMapControl: false

			});

			map.drawOverlay({
				lat: lat,
				lng: lng,
				content: '<i class="wb-map" style="font-size:40px;color:' + "#62a8ea" + ';"></i>'
			});

			map.addStyle({
				styledMapName: "Styled Map",
				styles: [{ featureType: "landscape", elementType: "all", stylers: [{ color: "#ffffff" }] }, { featureType: "poi", elementType: "all", stylers: [{ color: "#ffffff" }] }, { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#37474f" }] }, { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#76838f" }] }, { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#37474f" }] }, { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ color: "#e0e0e0" }] }, { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#e4eaec" }] }, { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#000000" }] }, { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#76838f" }] }, { featureType: "road", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "poi.attraction", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road.local", elementType: "all", stylers: [{ color: "#e4eaec" }, { weight: .5 }] }, { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ccd5db" }] }, { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ visibility: "off" }, { color: "#000000" }] }, { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }, { color: "#000000" }] }, { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "on" }, { color: "#37474f" }] }, { featureType: "road.local", elementType: "labels.text", stylers: [{ color: "#37474f" }] }, { featureType: "transit", elementType: "all", stylers: [{ color: "#e4eaec" }] }, { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#76838f" }] }, { featureType: "road", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#526069" }] }, { featureType: "administrative.neighborhood", elementType: "labels.text", stylers: [{ color: "#76838f" }] }, { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] }, { featureType: "road.highway", elementType: "labels.icon", stylers: [{ visibility: "on" }, { hue: "#ffffff" }, { saturation: -100 }, { lightness: 50 }] }, { featureType: "water", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#ffffff" }] }, { featureType: "administrative.neighborhood", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] }, { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] }, { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#526069" }] }],
				mapTypeId: "map_style"
			});

			map.setStyle("map_style");
		}
	}, {
		key: 'newConversationOpened',
		value: function newConversationOpened() {
			_SocketManager2.default.read(this.props.router.params.uid);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'conversation' },
				_react2.default.createElement(
					'div',
					{ className: 'col-md-3 l' },
					Object.keys(this.props.chat.visitors).filter(function (uid, i) {
						return _this2.props.chat.visitors[uid].assignee_id == _this2.props.router.params.user_id;
					}).length > 0 ? _react2.default.createElement(
						'ul',
						{ className: 'list-group list-group-full' },
						Object.keys(this.props.chat.visitors).map(function (uid, i) {
							if (_this2.props.chat.visitors[uid].assignee_id == _this2.props.router.params.user_id) {
								return _react2.default.createElement(_ConversationListElement2.default, { key: i, openChat: _this2.openChat, visitor: _this2.props.chat.visitors[uid] });
							}
						})
					) : _react2.default.createElement(
						'div',
						{ className: 'no-conversations' },
						_react2.default.createElement('i', { className: 'icon wb-emoticon', 'aria-hidden': 'true' })
					)
				),
				this.props.router.params.uid ? this.renderConversation() : null
			);
		}
	}]);

	return ChatConversation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		chat: state.chat,
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setVisitorKey: _Chat.setVisitorKey, removeVisitor: _Chat.removeVisitor, chatSetGlobalKey: _Chat.chatSetGlobalKey, addMessage: _Chat.addMessage, setAssignee: _Chat.setAssignee, setOpenChat: _Chat.setOpenChat, resetFilterOption: _Chat.resetFilterOption, setFilterOption: _Chat.setFilterOption, removeFilterOption: _Chat.removeFilterOption }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatConversation);

/***/ }),

/***/ 1671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactGravatar = __webpack_require__(267);

var _reactGravatar2 = _interopRequireDefault(_reactGravatar);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConversationListElement = function (_React$Component) {
    _inherits(ConversationListElement, _React$Component);

    function ConversationListElement() {
        _classCallCheck(this, ConversationListElement);

        return _possibleConstructorReturn(this, (ConversationListElement.__proto__ || Object.getPrototypeOf(ConversationListElement)).apply(this, arguments));
    }

    _createClass(ConversationListElement, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'li',
                { onClick: function onClick(e) {
                        e.stopPropagation();_this2.props.openChat(_this2.props.visitor.uid);
                    }, className: 'list-group-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'media', style: { marginLeft: '10px' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'media-left' },
                        _react2.default.createElement(
                            'a',
                            { className: 'avatar', href: 'javascript:void(0)' },
                            _react2.default.createElement(_reactGravatar2.default, { email: this.props.visitor.email ? this.props.visitor.email : 'nobody', size: 100, rating: 'pg', 'default': 'identicon', className: 'img-responsive' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'media-body' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'media-heading' },
                            this.props.visitor.name ? this.props.visitor.name : 'Unknown',
                            ' ',
                            this.props.visitor.online === 0 ? _react2.default.createElement(
                                'span',
                                { className: 'tag tag-danger delay-rendering', style: { paddingTop: '7px', paddingBottom: '5px' } },
                                'Offline'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'small',
                            null,
                            this.props.visitor.email ? this.props.visitor.email : 'Unknown'
                        )
                    ),
                    this.props.visitor.unreadMessages > 0 ? _react2.default.createElement(
                        'div',
                        { className: 'media-right', style: { verticalAlign: 'middle' } },
                        _react2.default.createElement(
                            'span',
                            { className: 'tag tag-danger', style: { paddingTop: '7px', paddingBottom: '5px' } },
                            this.props.visitor.unreadMessages
                        )
                    ) : null
                )
            );
        }
    }]);

    return ConversationListElement;
}(_react2.default.Component);

exports.default = ConversationListElement;

/***/ }),

/***/ 1672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactGravatar = __webpack_require__(267);

var _reactGravatar2 = _interopRequireDefault(_reactGravatar);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _uaParserJs = __webpack_require__(396);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConversationInfo = function (_React$Component) {
    _inherits(ConversationInfo, _React$Component);

    function ConversationInfo() {
        _classCallCheck(this, ConversationInfo);

        return _possibleConstructorReturn(this, (ConversationInfo.__proto__ || Object.getPrototypeOf(ConversationInfo)).apply(this, arguments));
    }

    _createClass(ConversationInfo, [{
        key: 'render',
        value: function render() {
            var parser = (0, _uaParserJs2.default)(this.props.visitor.browser);

            var name = 'Unknown';
            var email = 'Unknown';
            var referrer = 'Direct';

            if (this.props.visitor.name != '') {
                name = this.props.visitor.name;
            }

            if (this.props.visitor.email != '') {
                email = this.props.visitor.email;
            }

            if (this.props.visitor.referrer != '') {
                referrer = _General2.default.stripHtml(this.props.visitor.referrer);
            }

            var total = 0;

            var last = false;
            var next = false;
            var pages = this.props.pages.slice().reverse();

            return _react2.default.createElement(
                'div',
                { className: 'info' },
                _react2.default.createElement(
                    'div',
                    { className: 'details' },
                    _react2.default.createElement(
                        'span',
                        null,
                        'Details'
                    ),
                    _react2.default.createElement(
                        'table',
                        { className: 'table table-striped' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-clock-o' }),
                                    'Current page'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    this.props.visitor.online == 0 ? 'Offline' : this.props.visitor.title
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-clock-o' }),
                                    this.props.visitor.online === 0 ? 'Last online' : 'Idle time'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    (0, _moment2.default)(this.props.visitor.last_seen).fromNow()
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-user' }),
                                    'Name'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    name
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-envelope' }),
                                    'E-mail'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    email
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-map-marker' }),
                                    'City'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    this.props.city
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-globe' }),
                                    'Country'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    this.props.country
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-user' }),
                                    'OS'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    parser.os.name + ' ' + parser.os.version
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-user' }),
                                    'Browser'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    parser.browser.name + ' ' + parser.browser.version
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-info' }),
                                    'IP'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    this.props.visitor.ip
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon fa-arrow-circle-o-right' }),
                                    'Referrer'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'name' },
                                    referrer
                                )
                            )
                        )
                    )
                ),
                this.props.cart.length > 0 ? _react2.default.createElement(
                    'div',
                    { className: 'cart' },
                    _react2.default.createElement(
                        'span',
                        null,
                        'Cart'
                    ),
                    _react2.default.createElement(
                        'table',
                        { className: 'table table-striped' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.cart.map(function (cart, i) {
                                total = parseInt(cart.price) * parseInt(cart.quantity) + total;
                                return _react2.default.createElement(
                                    'tr',
                                    { key: i },
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'col-sm-8 padding-0 padding-bottom-5 padding-top-5' },
                                        cart.name
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'col-sm-2 padding-0 padding-bottom-5 padding-top-5' },
                                        cart.quantity
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'col-sm-2 padding-0 padding-bottom-5 padding-top-5' },
                                        parseInt(cart.price) * parseInt(cart.quantity)
                                    )
                                );
                            }),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { className: 'col-sm-8 padding-0 padding-bottom-5 padding-top-5' },
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Total'
                                    )
                                ),
                                _react2.default.createElement('td', { className: 'col-sm-2 padding-0 padding-bottom-5 padding-top-5' }),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'col-sm-2 padding-0 padding-bottom-5 padding-top-5' },
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        total
                                    )
                                )
                            )
                        )
                    )
                ) : null,
                pages.length > 0 ? _react2.default.createElement(
                    'div',
                    { className: 'pageviews' },
                    _react2.default.createElement(
                        'span',
                        null,
                        'Last pageviews'
                    ),
                    _react2.default.createElement(
                        'table',
                        { className: 'table table-striped' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            pages.map(function (page, i) {
                                if (i == 0) {
                                    return;
                                }
                                last = pages[i - 1].end;
                                last = (0, _moment2.default)(last);
                                next = (0, _moment2.default)(page.start);
                                //
                                //page.start = moment(page.start);
                                return _react2.default.createElement(
                                    'tr',
                                    { key: i },
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'col-sm-12 padding-0 padding-bottom-5 padding-top-5' },
                                        _react2.default.createElement('i', { className: 'icon wb-globe', 'aria-hidden': 'true' }),
                                        ' ',
                                        _react2.default.createElement(
                                            'a',
                                            { href: page.url, target: 'blank' },
                                            page.title
                                        )
                                    )
                                );
                            })
                        )
                    )
                ) : null
            );
        }
    }]);

    return ConversationInfo;
}(_react2.default.Component);

exports.default = ConversationInfo;

/***/ }),

/***/ 1680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	}

	_createClass(Settings, [{
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'render',
		value: function render() {

			return this.props.children;
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _UserDetails = __webpack_require__(1682);

var _UserDetails2 = _interopRequireDefault(_UserDetails);

var _UserPassword = __webpack_require__(1683);

var _UserPassword2 = _interopRequireDefault(_UserPassword);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _Login = __webpack_require__(75);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsProfile = function (_React$Component) {
	_inherits(SettingsProfile, _React$Component);

	function SettingsProfile(props) {
		_classCallCheck(this, SettingsProfile);

		var _this = _possibleConstructorReturn(this, (SettingsProfile.__proto__ || Object.getPrototypeOf(SettingsProfile)).call(this, props));

		_this.handleNotificationChange = function (key, e) {
			if (e === true) {
				e = 1;
			}

			if (e === false) {
				e = 0;
			}

			_this.props.setUserSetting(key, e);
		};

		_this.handleNotificationSave = function () {
			_Notification2.default.info('Saving..');

			_axios2.default.put('/me/settings', {
				settings: _this.props.auth.user.settings
			}).then(function (res) {
				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_Notification2.default.error(err.response.data.error.message);
			});
		};

		_this.state = {
			isSavingDetails: false,
			isUploading: false
		};

		_this.handleImageReset = _this.handleImageReset.bind(_this);

		_this.handleSubmit = _this.handleSubmit.bind(_this);
		_this.onOpenClick = _this.onOpenClick.bind(_this);
		_this.onDrop = _this.onDrop.bind(_this);
		_this.resetNotifications = _this.resetNotifications.bind(_this);
		return _this;
	}

	_createClass(SettingsProfile, [{
		key: 'onDrop',
		value: function onDrop(files) {
			var _this2 = this;

			if (files.length == 0) {
				return;
			}

			this.setState({ isUploading: true });

			var data = new FormData();
			data.append('file', files[0]);

			_axios2.default.post('/ajax/upload_profile_image', data).then(function (res) {
				_this2.setState({ isUploading: false });
				_this2.props.setUserKey('image', res.data.image);
			}).catch(function (err) {
				_this2.setState({ isUploading: false });
			});
		}
	}, {
		key: 'onOpenClick',
		value: function onOpenClick() {
			this.refs.dropzone.open();
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'resetNotifications',
		value: function resetNotifications() {
			localStorage.removeItem('notifications');
			location.reload();
		}
	}, {
		key: 'handleImageReset',
		value: function handleImageReset() {
			var _this3 = this;

			_axios2.default.post('/ajax/upload_profile_image').then(function (res) {
				_this3.setState({ isUploading: false });
				_this3.props.setUserKey('image', res.data.image);
			}).catch(function (err) {
				_this3.setState({ isUploading: false });
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit(values) {
			var _this4 = this;

			this.setState({
				isSavingDetails: true
			});

			_axios2.default.put('/me', values).then(function (res) {
				_this4.setState({
					isSavingDetails: false
				});
				_this4.props.setCurrentUser(_Auth2.default.getToken(), res.data);

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this4.setState({
					isSavingDetails: false
				});
				_Notification2.default.error(err.response.data.error.message);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Profile | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-user' }),
						' Profile'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Details', description: 'Change your user details.' },
						_react2.default.createElement(_UserDetails2.default, { isSavingDetails: this.state.isSavingDetails, onSubmit: this.handleSubmit })
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Profile', description: 'Change profile picture. This picture will be visible to other users and visitors.' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6 text-center' },
							_react2.default.createElement('img', { src: this.props.auth.user.image, style: { width: '200px' } })
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_reactDropzone2.default,
								{ ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
								this.state.isUploading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
									'button',
									{ type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark btn-block' },
									'Upload image'
								)
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-dark btn-block', onClick: this.handleImageReset },
								'Reset image'
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Password', description: 'Change your password' },
						_react2.default.createElement(_UserPassword2.default, { isSavingDetails: this.state.isSavingDetails, onSubmit: this.handleSubmit })
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'E-mail notifications', description: 'Enable or disable notifiactions' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12' },
							'Select which events you wan\'t to be notified about.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'table',
								{ className: 'table ' },
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'New offline chat message'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_rcSwitch2.default, { onChange: function onChange(e) {
												return _this5.handleNotificationChange('NOTIFY_NEW_CHAT_MESSAGE', e);
											},
											checked: this.props.auth.user.settings.NOTIFY_NEW_CHAT_MESSAGE == '1' ? true : false,
											checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
											unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
										})
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12' },
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-dark btn-block', onClick: this.handleNotificationSave },
								'Save'
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Browser notifications', description: 'Re-run notification activation process' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6' },
							'If you are experiencing issues regarding receiving alerts / notifications from Crall you can try to reset your settings.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'1. Follow the steps in this ',
							_react2.default.createElement(
								'a',
								{ target: '_blank', href: 'http://docs.crall.io/chat/varsel-ved-nye-meldinger' },
								'guide'
							),
							_react2.default.createElement('br', null),
							'2. Click "Reset notifications" to the right'
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6' },
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-dark btn-block', onClick: this.resetNotifications },
								'Reset notifiations'
							)
						)
					)
				)
			);
		}
	}]);

	return SettingsProfile;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setUserKey: _Login.setUserKey, setCurrentUser: _Login.setCurrentUser, setUserSetting: _Login.setUserSetting }, dispatch);
};

SettingsProfile = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsProfile);
exports.default = SettingsProfile;

/***/ }),

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import { load as loadAccount } from './account'


var validate = function validate(values) {
    var errors = {};

    if (!values.firstname) {
        errors.firstname = 'Required';
    }

    if (!values.lastname) {
        errors.lastname = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var UserDetails = function (_React$Component) {
    _inherits(UserDetails, _React$Component);

    function UserDetails() {
        _classCallCheck(this, UserDetails);

        return _possibleConstructorReturn(this, (UserDetails.__proto__ || Object.getPrototypeOf(UserDetails)).apply(this, arguments));
    }

    _createClass(UserDetails, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'firstname', placeholder: 'John', title: 'Lastname', className: 'form-control' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'lastname', placeholder: 'Doe', title: 'Firstname', className: 'form-control' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isSavingDetails ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            'Update'
                        )
                    )
                )
            );
        }
    }]);

    return UserDetails;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
UserDetails = (0, _reduxForm.reduxForm)({
    form: 'UserDetails',
    validate: validate
})(UserDetails);

UserDetails = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {
            firstname: state.auth.user.firstname,
            lastname: state.auth.user.lastname
        }
    };
})(UserDetails);

exports.default = UserDetails;

/***/ }),

/***/ 1683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import { load as loadAccount } from './account'


var validate = function validate(values) {
    var errors = {};

    if (!values.oldpassword) {
        errors.oldpassword = 'Required';
    }

    if (!values.newpassword) {
        errors.newpassword = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var UserPassword = function (_React$Component) {
    _inherits(UserPassword, _React$Component);

    function UserPassword() {
        _classCallCheck(this, UserPassword);

        return _possibleConstructorReturn(this, (UserPassword.__proto__ || Object.getPrototypeOf(UserPassword)).apply(this, arguments));
    }

    _createClass(UserPassword, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'password', name: 'oldpassword', placeholder: 'Password', title: 'Old password', className: 'form-control' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'password', name: 'newpassword', placeholder: 'Password', title: 'New password', className: 'form-control' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isSavingDetails ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            'Update'
                        )
                    )
                )
            );
        }
    }]);

    return UserPassword;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
UserPassword = (0, _reduxForm.reduxForm)({
    form: 'UserPassword',
    validate: validate
})(UserPassword);

UserPassword = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {}
    };
})(UserPassword);

exports.default = UserPassword;

/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(8);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsUser = function (_React$Component) {
	_inherits(SettingsUser, _React$Component);

	function SettingsUser(props) {
		_classCallCheck(this, SettingsUser);

		var _this = _possibleConstructorReturn(this, (SettingsUser.__proto__ || Object.getPrototypeOf(SettingsUser)).call(this, props));

		_this.getBlacklist = function () {
			_axios2.default.get('/ip_blacklist').then(function (res) {
				_this.setState({
					blacklist: res.data
				});
			});
		};

		_this.addIpToBlacklist = function () {
			if (_this.state.ip == '') {
				_Notification2.default.error("Ip can't be empty.");
				return;
			}

			if (!_this.validateIp(_this.state.ip)) {
				_Notification2.default.error("Invalid IP-address.");
				return;
			}

			var ip = _this.state.ip;

			_this.setState({
				ip: ''
			});

			_axios2.default.post('/ip_blacklist', {
				ip: ip
			}).then(function (res) {
				_Notification2.default.success("The IP has been added.");

				var blacklist = [].concat(_toConsumableArray(_this.state.blacklist), [res.data]);

				_this.setState({
					blacklist: blacklist
				});
			});
		};

		_this.removeIp = function (index, id) {
			var blacklist = [].concat(_toConsumableArray(_this.state.blacklist.slice(0, index)), _toConsumableArray(_this.state.blacklist.slice(index + 1)));
			_this.setState({
				blacklist: blacklist
			});
			_axios2.default.delete('/ip_blacklist/' + id);
		};

		_this.askDeleteUser = function (id) {
			_this.setState({ askDelete: id });
		};

		_this.handleIpChange = function (e) {
			_this.setState({
				ip: e.target.value
			});
		};

		_this.state = {
			ip: '',
			'email_invite': '',
			apiKeys: [],
			blacklist: [],
			askDelete: false
		};

		_this.handleInviteInput = _this.handleInviteInput.bind(_this);
		_this.handleSendInvite = _this.handleSendInvite.bind(_this);
		_this.generateKey = _this.generateKey.bind(_this);

		return _this;
	}

	_createClass(SettingsUser, [{
		key: 'deleteUser',
		value: function deleteUser(id) {
			this.setState({ askDelete: false, isLoading: true });
			_axios2.default.delete('/users/' + id).then(function (res) {
				_General4.default.fetchGeneral();
			});
		}
	}, {
		key: 'handleInviteInput',
		value: function handleInviteInput(e) {
			this.setState({ 'email_invite': e.target.value });
		}
	}, {
		key: 'handleSendInvite',
		value: function handleSendInvite(e) {
			var _this2 = this;

			e.stopPropagation();
			_Notification2.default.success("Sending...");

			if (this.state.email_invite == '') {
				_Notification2.default.error("E-mail address can't be empty.");
				return;
			}

			_axios2.default.post('/ajax/invite_new_user', { email: this.state.email_invite }).then(function (res) {
				_Notification2.default.success("Invitation sent to " + _this2.state.email_invite);
				_this2.setState({ 'email_invite': '' });
			}).catch(function (error) {
				_Notification2.default.error('Error sending e-mail.. Invitation not sent.');
			});
		}
	}, {
		key: 'getKeys',
		value: function getKeys() {
			var _this3 = this;

			_axios2.default.get('/api/keys').then(function (res) {
				_this3.setState({
					apiKeys: res.data
				});
			});
		}
	}, {
		key: 'generateKey',
		value: function generateKey() {
			var _this4 = this;

			_axios2.default.post('/api/keys').then(function (res) {
				_this4.setState({
					apiKeys: [].concat(_toConsumableArray(_this4.state.apiKeys), [res.data])
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.getKeys();
			this.getBlacklist();
		}
	}, {
		key: 'validateIp',
		value: function validateIp(ipaddress) {
			if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
				return true;
			}

			return false;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Users | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-users' }),
						' Users'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Invite new user', description: 'Send an e-mail invitation to a new user.' },
						_react2.default.createElement(
							'div',
							{ className: 'form-group col-sm-12' },
							_react2.default.createElement(
								'label',
								{ className: 'control-label' },
								'New users e-mail address'
							),
							_react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.email_invite, onChange: this.handleInviteInput, placeholder: 'user@example.com' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group col-sm-12' },
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-dark btn-block', onClick: this.handleSendInvite },
								_react2.default.createElement('i', { className: 'icon fa fa-paper-plane' }),
								' Send invite'
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Existing users', description: 'Manage existing users' },
						_react2.default.createElement(
							'ul',
							{ className: 'list-group list-group-full' },
							this.props.general.users.map(function (user, i) {
								return _react2.default.createElement(
									'li',
									{ key: i, className: 'list-group-item' },
									_react2.default.createElement(
										'div',
										{ className: 'media' },
										_react2.default.createElement(
											'div',
											{ className: 'media-left' },
											_react2.default.createElement(
												'a',
												{ className: 'avatar', href: 'javascript:void(0)' },
												_react2.default.createElement('img', { className: 'img-fluid', src: user.image, alt: '...' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'media-body' },
											_react2.default.createElement(
												'h4',
												{ className: 'media-heading' },
												user.firstname,
												' ',
												user.lastname
											),
											_react2.default.createElement(
												'small',
												null,
												user.email
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'media-right' },
											user.id != _this5.props.auth.user.id ? _react2.default.createElement(
												'div',
												{ className: 'btn-group', role: 'group' },
												_react2.default.createElement(
													'button',
													{ onClick: function onClick() {
															return _this5.askDeleteUser(user.id);
														}, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
													_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
												)
											) : null
										)
									)
								);
							})
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'API', description: 'Manage and generate API-keys' },
						this.state.apiKeys.length > 0 ? _react2.default.createElement(
							'table',
							{ className: 'table table-striped' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Key'
									),
									_react2.default.createElement(
										'th',
										null,
										'Last accessed'
									),
									_react2.default.createElement(
										'th',
										null,
										'Created'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.state.apiKeys.map(function (key, i) {
									return _react2.default.createElement(
										'tr',
										{ key: i },
										_react2.default.createElement(
											'td',
											{ style: { width: '50%' } },
											key.token
										),
										_react2.default.createElement(
											'td',
											null,
											!key.last_accessed ? 'Never' : (0, _moment2.default)(_General2.default.toLocalTime(key.last_accessed)).fromNow()
										),
										_react2.default.createElement(
											'td',
											null,
											(0, _moment2.default)(_General2.default.toLocalTime(key.created_at)).fromNow()
										)
									);
								})
							)
						) : null,
						_react2.default.createElement(
							'button',
							{ onClick: this.generateKey, className: 'btn btn-dark pull-right' },
							'Generate key'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Blacklist', description: 'Ip-addresses that should be excluded from Crall' },
						this.state.blacklist.length > 0 ? _react2.default.createElement(
							'table',
							{ className: 'table table-striped' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Ip'
									),
									_react2.default.createElement(
										'th',
										null,
										'Date added'
									),
									_react2.default.createElement('th', null)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.state.blacklist.map(function (key, i) {
									return _react2.default.createElement(
										'tr',
										{ key: i },
										_react2.default.createElement(
											'td',
											{ style: { width: '50%' } },
											key.ip
										),
										_react2.default.createElement(
											'td',
											null,
											(0, _moment2.default)(_General2.default.toLocalTime(key.created_at)).fromNow()
										),
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'btn-group', role: 'group' },
												_react2.default.createElement(
													'button',
													{ type: 'button', onClick: function onClick() {
															_this5.removeIp(i, key.id);
														}, className: 'btn btn-icon btn-default btn-outline' },
													_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
												)
											)
										)
									);
								})
							)
						) : null,
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-8' },
								_react2.default.createElement('input', { type: 'text', value: this.state.ip, onChange: this.handleIpChange, placeholder: '127.0.0.1', className: 'form-control' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-4' },
								_react2.default.createElement(
									'button',
									{ onClick: this.addIpToBlacklist, className: 'btn btn-dark pull-right' },
									'Add IP to blacklist'
								)
							)
						)
					),
					_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
							_this5.deleteUser(e);
						}, onClose: function onClose() {
							_this5.setState({ askDelete: false });
						}, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this user?' })
				)
			);
		}
	}]);

	return SettingsUser;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

SettingsUser = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsUser);
exports.default = SettingsUser;

/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _EmailDetails = __webpack_require__(269);

var _EmailDetails2 = _interopRequireDefault(_EmailDetails);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _General5 = __webpack_require__(53);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _CampanyDetails = __webpack_require__(1686);

var _CampanyDetails2 = _interopRequireDefault(_CampanyDetails);

var _NewsletterListPicker = __webpack_require__(669);

var _NewsletterListPicker2 = _interopRequireDefault(_NewsletterListPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsEmails = function (_React$Component) {
	_inherits(SettingsEmails, _React$Component);

	function SettingsEmails(props) {
		_classCallCheck(this, SettingsEmails);

		var _this = _possibleConstructorReturn(this, (SettingsEmails.__proto__ || Object.getPrototypeOf(SettingsEmails)).call(this, props));

		_this.handleBlacklistEmailChange = function (e) {
			_this.setState({
				blacklist_email: e.target.value
			});
		};

		_this.blacklistEmail = function () {
			if (!_General4.default.validateEmail(_this.state.blacklist_email)) {
				_Notification2.default.error('Invalid e-mail address');
				return;
			}

			_this.setState({
				blacklist_email: ''
			});

			_axios2.default.post('/blacklist', {
				email: _this.state.blacklist_email
			}).then(function (res) {
				_Notification2.default.success('E-mail added to blacklist');
			});
		};

		_this.handleGrabberChange = function (e) {
			_this.props.setSetting(e.target.getAttribute('data-key'), e.target.value);
		};

		_this.saveGrabberData = function () {
			var data = {
				EMAIL_LOOKUP_STATUS: _this.props.general.settings.EMAIL_LOOKUP_STATUS,
				EMAIL_LOOKUP_BTN_DECLINE: _this.props.general.settings.EMAIL_LOOKUP_BTN_DECLINE,
				EMAIL_LOOKUP_BTN_ACCEPT: _this.props.general.settings.EMAIL_LOOKUP_BTN_ACCEPT,
				EMAIL_LOOKUP_TEXT_BODY: _this.props.general.settings.EMAIL_LOOKUP_TEXT_BODY,
				EMAIL_LOOKUP_TEXT_HEADER: _this.props.general.settings.EMAIL_LOOKUP_TEXT_HEADER
			};

			_axios2.default.put('/settings', data).then(function (res) {
				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_Notification2.default.error('Error!');
			});
		};

		_this.handleNewsletterSave = function (data) {
			_axios2.default.put('/account/newsletter_integration', data).then(function (res) {
				_Notification2.default.success('Success!');

				_this.props.setSetting('ESP_INTEGRATION', data);
			}).catch(function (err) {});
		};

		_this.getNewsletterSettings = function () {
			if (!_this.props.general.settings.ESP_INTEGRATION || _this.props.general.settings.ESP_INTEGRATION == '') {
				return {};
			}

			var data = JSON.parse(_this.props.general.settings.ESP_INTEGRATION);

			return data;
		};

		_this.state = {
			isUploading: false,
			isLoading: true,
			isSavingDetails: false,
			blacklistCount: 0,
			blacklist_email: ''
		};

		_this.handleSubmit = _this.handleSubmit.bind(_this);
		_this.onDrop = _this.onDrop.bind(_this);
		_this.onOpenClick = _this.onOpenClick.bind(_this);
		_this.sendVerification = _this.sendVerification.bind(_this);
		_this.switchBackupServerStatus = _this.switchBackupServerStatus.bind(_this);
		_this.handleDetails = _this.handleDetails.bind(_this);
		return _this;
	}

	_createClass(SettingsEmails, [{
		key: 'switchBackupServerStatus',
		value: function switchBackupServerStatus(val) {
			this.props.setSetting('BACKUP_EMAIL_STATUS', val);

			_axios2.default.post('/ajax/backup_email_server', {
				status: val
			}).then(function (res) {
				_Notification2.default.success('Success');
			});
		}
	}, {
		key: 'sendVerification',
		value: function sendVerification() {
			_axios2.default.post('/ajax/send_verification', {}).then(function (res) {
				if (res.data.status == 'EXIST') {
					_Notification2.default.info('E-mail already verified');
				} else {
					_Notification2.default.success('Verification sent');
				}
			});
		}
	}, {
		key: 'onDrop',
		value: function onDrop(files) {
			var _this2 = this;

			if (files.length == 0) {
				return;
			}

			this.setState({ isUploading: true });

			var data = new FormData();
			data.append('file', files[0]);

			_axios2.default.post('/blacklist/upload', data).then(function (res) {
				_this2.setState({ isUploading: false });
				_axios2.default.get('/blacklist/stats').then(function (res) {
					_this2.setState({ blacklistCount: res.data.count });
				});
			}).catch(function (err) {
				_this2.setState({ isUploading: false });
			});
		}
	}, {
		key: 'onOpenClick',
		value: function onOpenClick() {
			this.refs.dropzone.open();
		}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit(values) {
			var _this3 = this;

			this.setState({
				isSavingDetails: true
			});

			var data = {
				EMAIL_SENDER_NAME: values.name,
				EMAIL_SENDER_EMAIL: values.email
			};

			_axios2.default.put('/settings', data).then(function (res) {
				_this3.setState({
					isSavingDetails: false
				});
				_this3.props.setSetting('EMAIL_SENDER_NAME', values.name);
				_this3.props.setSetting('EMAIL_SENDER_EMAIL', values.email);

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this3.setState({
					isSavingDetails: false
				});
			});
		}
	}, {
		key: 'handleDetails',
		value: function handleDetails(data) {
			var _this4 = this;

			this.setState({
				isSavingDetails: true
			});

			_axios2.default.put('/settings', data).then(function (res) {
				_this4.setState({
					isSavingDetails: false
				});

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this4.setState({
					isSavingDetails: false
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this5 = this;

			_General2.default.fetchGeneral().then(function () {
				_axios2.default.get('/blacklist/stats').then(function (res) {
					_this5.setState({ isLoading: false, blacklistCount: res.data.count });
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'E-mails | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-envelope' }),
						' E-mails'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Sender', description: 'This values will be displayed to your e-mail recipients.' },
						_react2.default.createElement(_EmailDetails2.default, { isSavingDetails: this.state.isSavingDetails, onSubmit: this.handleSubmit })
					),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Required footer details', description: 'This information will be visible in the e-mail footer. Empty fields will default to your billing information.' },
						_react2.default.createElement(_CampanyDetails2.default, { isSavingDetails: this.state.isSavingDetails, onSubmit: this.handleDetails })
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'E-mail grabber', description: 'Settings related to e-mail grabber popup' },
						_react2.default.createElement(
							'div',
							{ className: 'form-group col-sm-12' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-6' },
								_react2.default.createElement(
									'h5',
									null,
									'Status'
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-12 text-center' },
									'Off \xA0\xA0',
									_react2.default.createElement(_rcSwitch2.default, { onChange: function onChange(val) {
											if (val == 'true' || val === true) {
												val = '1';
											} else {
												val = '0';
											}_this6.props.setSetting('EMAIL_LOOKUP_STATUS', val);
										},
										checked: this.props.general.settings.EMAIL_LOOKUP_STATUS == '1' || this.props.general.settings.EMAIL_LOOKUP_STATUS === 1 ? true : false,
										checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
										unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
									}),
									' \xA0On'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'alert alert-info alert-dismissible', role: 'alert' },
									'When "E-mail grabber" is activated Crall will automatically search and collect e-mails from the visitor. If we detect an e-mail we\'ll display a popup asking the customer if they accept us to user their e-mail.'
								)
							)
						),
						_react2.default.createElement(
							'h5',
							null,
							'Translations'
						),
						_react2.default.createElement(
							'table',
							{ className: 'table table-striped' },
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Header text'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement('input', { type: 'text', 'data-key': 'EMAIL_LOOKUP_TEXT_HEADER', onChange: this.handleGrabberChange, value: this.props.general.settings.EMAIL_LOOKUP_TEXT_HEADER, className: 'form-control' })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Body text'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement('input', { type: 'text', 'data-key': 'EMAIL_LOOKUP_TEXT_BODY', onChange: this.handleGrabberChange, value: this.props.general.settings.EMAIL_LOOKUP_TEXT_BODY, className: 'form-control' })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Accept button'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement('input', { type: 'text', 'data-key': 'EMAIL_LOOKUP_BTN_ACCEPT', onChange: this.handleGrabberChange, value: this.props.general.settings.EMAIL_LOOKUP_BTN_ACCEPT, className: 'form-control' })
									)
								),
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'td',
										null,
										'Decline button'
									),
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement('input', { type: 'text', 'data-key': 'EMAIL_LOOKUP_BTN_DECLINE', onChange: this.handleGrabberChange, value: this.props.general.settings.EMAIL_LOOKUP_BTN_DECLINE, className: 'form-control' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12 m-t-20' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.saveGrabberData, className: 'btn btn-dark btn-block' },
								'Save'
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Newsletter integration', description: 'Transfer e-mails collected by Crall to your ESP.' },
						_react2.default.createElement(_NewsletterListPicker2.default, { data: this.getNewsletterSettings(), handleSave: this.handleNewsletterSave, inputs: [{
								id: 'email',
								styles: {
									placeholder: "E-mail"
								},
								type: 'crall-input'
							}], apps: _General2.default.appGetType('newsletter') })
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Blacklist', description: 'Import blacklisted e-mail addresses' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-4' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12' },
								_react2.default.createElement(
									'div',
									{ className: 'card card-block p-0 m-0' },
									_react2.default.createElement(
										'div',
										{ className: 'counter counter-lg' },
										_react2.default.createElement(
											'span',
											{ className: 'counter-number' },
											this.state.blacklistCount
										),
										_react2.default.createElement(
											'div',
											{ className: 'counter-label text-uppercase' },
											'Blacklisted e-mails'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-8 text-center' },
							_react2.default.createElement(
								'p',
								null,
								'If you have an existing e-mail blacklist and you wan\'t to ignore them in Crall. Please upload a CSV file containing only e-mails you wish to ignore.'
							),
							_react2.default.createElement(
								_reactDropzone2.default,
								{ ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
								this.state.isUploading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
									'button',
									{ type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark' },
									'Upload blacklist'
								)
							),
							_react2.default.createElement(_SplitRow2.default, null),
							'You can also add a single e-mails address to the blacklist without uploading a file.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-8' },
									_react2.default.createElement('input', { type: 'text', value: this.state.blacklist_email, onChange: this.handleBlacklistEmailChange, placeholder: 'someone@example.com', className: 'form-control' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-4' },
									_react2.default.createElement(
										'button',
										{ onClick: this.blacklistEmail, className: 'btn btn-dark pull-right' },
										'Add e-mail to blacklist'
									)
								)
							)
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Advanced setting', description: 'Use an alternative e-mailserver for order confirmations.' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-5' },
							_react2.default.createElement(
								'h5',
								null,
								'Status'
							),
							_react2.default.createElement(
								'div',
								{ className: 'alert dark alert-icon alert-warning alert-dismissible', role: 'alert' },
								_react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
								' Before turning this feature on, you must complete the verification process to the right.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12 text-center' },
								'Off \xA0\xA0',
								_react2.default.createElement(_rcSwitch2.default, { onChange: this.switchBackupServerStatus,
									checked: this.props.general.settings.BACKUP_EMAIL_STATUS == '1' ? true : false,
									checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
									unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
								}),
								' \xA0On'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-7' },
							_react2.default.createElement(
								'h5',
								null,
								'Verification'
							),
							'To start using this feature you must verify that you are the owner of ',
							_react2.default.createElement(
								'strong',
								null,
								'"',
								this.props.general.settings.EMAIL_SENDER_EMAIL,
								'"'
							),
							'. When clicking the button we\'ll send a verification e-mail to ',
							_react2.default.createElement(
								'strong',
								null,
								'"',
								this.props.general.settings.EMAIL_SENDER_EMAIL,
								'"'
							),
							'. In the e-mails there will be a button you must click.',
							_react2.default.createElement(
								'strong',
								null,
								'After clicking the link you can turn on this feature to the left.'
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12 text-center' },
								_react2.default.createElement(
									'button',
									{ onClick: this.sendVerification, className: 'btn btn-dark' },
									'Send verification e-mail'
								)
							)
						)
					)
				)
			);
		}
	}]);

	return SettingsEmails;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setSetting: _General5.setSetting }, dispatch);
};

SettingsEmails = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsEmails);
exports.default = SettingsEmails;

/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.COMPANY_NAME) {
        errors.COMPANY_NAME = 'Required';
    }

    if (!values.COMPANY_ADDRESS_1) {
        errors.COMPANY_ADDRESS_1 = 'Required';
    }

    if (!values.COMPANY_POSTCODE) {
        errors.COMPANY_POSTCODE = 'Required';
    }

    if (!values.COMPANY_CITY) {
        errors.COMPANY_CITY = 'Required';
    }

    if (!values.EMAIL_REASON) {
        errors.EMAIL_REASON = 'Required';
    }

    if (!values.COMPANY_COUNTRY) {
        errors.COMPANY_COUNTRY = 'Required';
    }

    if (!values.EMAIL_UNSUBSCRIBE) {
        errors.EMAIL_UNSUBSCRIBE = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var CompanyDetails = function (_React$Component) {
    _inherits(CompanyDetails, _React$Component);

    function CompanyDetails() {
        _classCallCheck(this, CompanyDetails);

        return _possibleConstructorReturn(this, (CompanyDetails.__proto__ || Object.getPrototypeOf(CompanyDetails)).apply(this, arguments));
    }

    _createClass(CompanyDetails, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row p-15' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Acme Inc', name: 'COMPANY_NAME', className: 'form-control', title: 'Company name' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Kirkeveien 1', name: 'COMPANY_ADDRESS_1', className: 'form-control', title: 'Address line 1' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'COMPANY_ADDRESS_2', className: 'form-control', title: 'Address line 2' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Oslo', name: 'COMPANY_CITY', className: 'form-control', title: 'City' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: '0034', name: 'COMPANY_POSTCODE', className: 'form-control', title: 'Postcode' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Norway', name: 'COMPANY_COUNTRY', className: 'form-control', title: 'Country' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: '', name: 'EMAIL_REASON', className: 'form-control', title: 'Reason why customers are receiving e-mails from you' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: '', name: 'EMAIL_UNSUBSCRIBE', className: 'form-control', title: 'Unsubscribe text' })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row m-t-20' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { type: 'submit', className: 'btn btn-dark btn-block' },
                                'Update'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CompanyDetails;
}(_react2.default.Component);

var selector = (0, _reduxForm.formValueSelector)('CompanyDetails');

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
CompanyDetails = (0, _reduxForm.reduxForm)({
    form: 'CompanyDetails',
    validate: validate
})(CompanyDetails);

CompanyDetails = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {
            COMPANY_NAME: state.general.settings.COMPANY_NAME,
            COMPANY_ADDRESS_1: state.general.settings.COMPANY_ADDRESS_1,
            COMPANY_ADDRESS_2: state.general.settings.COMPANY_ADDRESS_2,
            COMPANY_COUNTRY: state.general.settings.COMPANY_COUNTRY,
            COMPANY_CITY: state.general.settings.COMPANY_CITY,
            COMPANY_POSTCODE: state.general.settings.COMPANY_POSTCODE,
            EMAIL_UNSUBSCRIBE: state.general.settings.EMAIL_UNSUBSCRIBE,
            EMAIL_REASON: state.general.settings.EMAIL_REASON
        }
    };
})(CompanyDetails);

exports.default = CompanyDetails;

/***/ }),

/***/ 1687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _EmailDetails = __webpack_require__(269);

var _EmailDetails2 = _interopRequireDefault(_EmailDetails);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

var _ChatTranslation = __webpack_require__(1688);

var _ChatTranslation2 = _interopRequireDefault(_ChatTranslation);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _ChatTemplate = __webpack_require__(681);

var _ChatTemplate2 = _interopRequireDefault(_ChatTemplate);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _Template = __webpack_require__(680);

var _Template2 = _interopRequireDefault(_Template);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsChat = function (_React$Component) {
	_inherits(SettingsChat, _React$Component);

	function SettingsChat(props) {
		var _this$state;

		_classCallCheck(this, SettingsChat);

		var _this = _possibleConstructorReturn(this, (SettingsChat.__proto__ || Object.getPrototypeOf(SettingsChat)).call(this, props));

		_this.state = (_this$state = {
			isLoading: true,
			templates: [],
			isSavingTranslation: false,

			isSavingTemplate: false,
			isEditingTemplate: false,
			currentTemplate: false,

			isUpdatingColors: false,
			isUpdating_CHAT_TEXT_BYLINE: false,
			CHAT_TEXT_BYLINE: _this.props.general.settings.CHAT_TEXT_BYLINE
		}, _defineProperty(_this$state, 'CHAT_TEXT_BYLINE', _this.props.general.settings.CHAT_TEXT_BYLINE), _defineProperty(_this$state, 'isUpdating_CHAT_MINIMIZED_TEXT', false), _defineProperty(_this$state, 'CHAT_MINIMIZED_MESSAGE', _this.props.general.settings.CHAT_MINIMIZED_MESSAGE), _defineProperty(_this$state, 'isUpdating_CHAT_POSITION', false), _defineProperty(_this$state, 'CHAT_POSITION', _this.props.general.settings.CHAT_POSITION), _defineProperty(_this$state, 'isUpdating_isUpdating_CHAT_OFFLINE_MODE', false), _defineProperty(_this$state, 'CHAT_OFFLINE_MODE', _this.props.general.settings.CHAT_OFFLINE_MODE), _defineProperty(_this$state, 'CHAT_HEADER_BACKGROUND', _this.props.general.settings.CHAT_HEADER_BACKGROUND), _defineProperty(_this$state, 'CHAT_HEADER_FONT', _this.props.general.settings.CHAT_HEADER_FONT), _defineProperty(_this$state, 'CHAT_BUTTON_BACKGROUND', _this.props.general.settings.CHAT_BUTTON_BACKGROUND), _defineProperty(_this$state, 'CHAT_BUTTON_FONT', _this.props.general.settings.CHAT_BUTTON_FONT), _defineProperty(_this$state, 'CHAT_VISITOR_BACKGROUND', _this.props.general.settings.CHAT_VISITOR_BACKGROUND), _defineProperty(_this$state, 'CHAT_VISITOR_MESSAGE_FONT', _this.props.general.settings.CHAT_VISITOR_MESSAGE_FONT), _defineProperty(_this$state, 'CHAT_OPERATOR_BACKGROUND', _this.props.general.settings.CHAT_OPERATOR_BACKGROUND), _defineProperty(_this$state, 'CHAT_OPERATOR_MESSAGE_FONT', _this.props.general.settings.CHAT_OPERATOR_MESSAGE_FONT), _this$state);

		_this.saveColors = _this.saveColors.bind(_this);
		_this.updateKey = _this.updateKey.bind(_this);
		_this.handleChange = _this.handleChange.bind(_this);
		_this.handleColorChange = _this.handleColorChange.bind(_this);
		_this.handleTranslationSubmit = _this.handleTranslationSubmit.bind(_this);
		_this.handleTemplateSubmit = _this.handleTemplateSubmit.bind(_this);
		_this.deleteTemplate = _this.deleteTemplate.bind(_this);
		_this.getTemplates = _this.getTemplates.bind(_this);
		return _this;
	}

	_createClass(SettingsChat, [{
		key: 'deleteTemplate',
		value: function deleteTemplate(id) {
			var _this2 = this;

			this.setState({
				isLoading: true
			});

			_axios2.default.delete('/chat/templates/' + id).then(function (res) {
				_this2.getTemplates();
			}).catch(function (res) {
				_this2.setState({ 'isError': 'Template not found' });
			});
		}
	}, {
		key: 'saveColors',
		value: function saveColors() {
			var _this3 = this;

			this.setState({
				isUpdatingColors: true
			});

			var values = {};

			for (var i in this.state) {
				if (i.startsWith('CHAT_')) {
					values[i] = this.state[i];
				}
			}

			_axios2.default.put('/settings', values).then(function (res) {
				_this3.setState({
					isUpdatingColors: false
				});

				for (var _i in values) {
					_this3.props.setSetting(_i, values[_i]);
				}

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this3.setState({
					isUpdatingColors: false
				});
			});
		}
	}, {
		key: 'handleColorChange',
		value: function handleColorChange(key, value) {
			this.setState(_defineProperty({}, key, value));
		}
	}, {
		key: 'updateKey',
		value: function updateKey(key) {
			var _this4 = this;

			this.setState(_defineProperty({}, 'isUpdating' + key, true));

			_axios2.default.put('/settings/' + key, { value: this.state[key] }).then(function (res) {
				_this4.setState(_defineProperty({}, 'isUpdating' + key, false));

				_this4.props.setSetting(key, _this4.state[key]);

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this4.setState(_defineProperty({}, 'isUpdating' + key, false));
			});
		}
	}, {
		key: 'handleTemplateSubmit',
		value: function handleTemplateSubmit(values) {
			var templates = _extends({}, this.state.templates, {
				values: values
			});

			this.getTemplates();
		}
	}, {
		key: 'handleTranslationSubmit',
		value: function handleTranslationSubmit(values) {
			var _this5 = this;

			this.setState({
				isSavingTranslation: true
			});

			_axios2.default.put('/settings', values).then(function (res) {
				_this5.setState({
					isSavingTranslation: false
				});

				for (var i in values) {
					_this5.props.setSetting(i, values[i]);
				}

				_Notification2.default.success('Success!');
			}).catch(function (err) {
				_this5.setState({
					isSavingTranslation: false
				});
			});
		}
	}, {
		key: 'handleChange',
		value: function handleChange(e) {
			this.setState(_extends({}, this.state, _defineProperty({}, e.target.getAttribute('data-key'), e.target.value)));
		}
	}, {
		key: 'getTemplates',
		value: function getTemplates() {
			var _this6 = this;

			this.setState({
				isLoading: true
			});

			_axios2.default.get('/chat').then(function (res) {
				_this6.setState({
					isLoading: false,
					templates: res.data.templates
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this7 = this;

			_General2.default.fetchGeneral().then(function () {
				_this7.setState({ isLoading: false });
			});
			this.getTemplates();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this8 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Chat | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-chat' }),
						' Chat'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Offline Mode', description: 'Turn off or on Offline mode' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-5' },
							_react2.default.createElement(
								'h5',
								null,
								'Status'
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12 text-center' },
								'Off \xA0\xA0',
								_react2.default.createElement(_rcSwitch2.default, { onChange: function onChange(val) {
										if (val) {
											val = 1;
										} else {
											val = 0;
										}
										_this8.setState({
											CHAT_OFFLINE_MODE: val
										});
									},
									checked: this.state.CHAT_OFFLINE_MODE == 1 ? true : false,
									checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
									unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
								}),
								' \xA0On'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6' },
							_react2.default.createElement(
								'div',
								{ className: 'alert alert-info alert-dismissible', role: 'alert' },
								'"Offline mode" will leave the chat visible when all agents are set to "Offline". Visitors can leave a message, and you can reply them when you\'re online again.'
							)
						),
						_react2.default.createElement('div', { className: 'col-sm-12 m-t-10' }),
						this.props.isUpdating_CHAT_OFFLINE_MODE ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this8.updateKey('CHAT_OFFLINE_MODE');
								} },
							'Update'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Colors', description: 'Change chat window colors.' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Header background'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_HEADER_BACKGROUND })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_HEADER_BACKGROUND', color: this.state.CHAT_HEADER_BACKGROUND, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Header font'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_HEADER_FONT })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_HEADER_FONT', color: this.state.CHAT_HEADER_FONT, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Button background'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_BUTTON_BACKGROUND })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_BUTTON_BACKGROUND', color: this.state.CHAT_BUTTON_BACKGROUND, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Button font'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_BUTTON_FONT })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_BUTTON_FONT', color: this.state.CHAT_BUTTON_FONT, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Visitor chat bubble background'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_VISITOR_BACKGROUND })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_VISITOR_BACKGROUND', color: this.state.CHAT_VISITOR_BACKGROUND, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Visitor chat bubble font'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_VISITOR_MESSAGE_FONT })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_VISITOR_MESSAGE_FONT', color: this.state.CHAT_VISITOR_MESSAGE_FONT, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Operator chat bubble background'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_OPERATOR_BACKGROUND })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_OPERATOR_BACKGROUND', color: this.state.CHAT_OPERATOR_BACKGROUND, handleColorChange: this.handleColorChange })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'form-group col-sm-6' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-9' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'Operator chat bubble font'
									),
									_react2.default.createElement('input', { className: 'form-control', onChange: function onChange(e) {}, value: this.state.CHAT_OPERATOR_MESSAGE_FONT })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-3 p-l-0' },
									_react2.default.createElement(
										'label',
										{ className: 'control-label' },
										'\xA0'
									),
									_react2.default.createElement(_ColorPicker2.default, { id: 'CHAT_OPERATOR_MESSAGE_FONT', color: this.state.CHAT_OPERATOR_MESSAGE_FONT, handleColorChange: this.handleColorChange })
								)
							)
						),
						this.state.isUpdatingColors ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this8.saveColors();
								} },
							'Update'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Position', description: 'Position of the chat window and bobble.' },
						_react2.default.createElement(
							'select',
							{ className: 'form-control', onChange: this.handleChange, 'data-key': 'CHAT_POSITION', value: this.state.CHAT_POSITION },
							_react2.default.createElement(
								'option',
								{ value: 'left' },
								'Bottom left'
							),
							_react2.default.createElement(
								'option',
								{ value: 'right' },
								'Bottom right'
							)
						),
						_react2.default.createElement('br', null),
						this.props.isUpdating_CHAT_POSITION ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this8.updateKey('CHAT_POSITION');
								} },
							'Update'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Minimized button text', description: 'This text will be visible inside the minimized chat bubble.' },
						_react2.default.createElement('input', { type: 'text', onChange: this.handleChange, 'data-key': 'CHAT_MINIMIZED_MESSAGE', value: this.state.CHAT_MINIMIZED_MESSAGE, className: 'form-control' }),
						_react2.default.createElement('br', null),
						this.props.isUpdating_CHAT_MINIMIZED_TEXT ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this8.updateKey('CHAT_MINIMIZED_MESSAGE');
								} },
							'Update'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Byline', description: 'This message will be displayed for customers first time they\'re opening a chat window.' },
						_react2.default.createElement('textarea', { placeholder: 'Type in message..', onChange: this.handleChange, 'data-key': 'CHAT_TEXT_BYLINE', value: this.state.CHAT_TEXT_BYLINE, className: 'form-control' }),
						_react2.default.createElement('br', null),
						this.props.isUpdating_CHAT_TEXT_BYLINE ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this8.updateKey('CHAT_TEXT_BYLINE');
								} },
							'Update'
						)
					),
					_react2.default.createElement(_SplitRow2.default, null),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Translations', description: 'Translate strings to your native language.' },
						_react2.default.createElement(_ChatTranslation2.default, { isSavingTranslation: this.state.isSavingTranslation, onSubmit: this.handleTranslationSubmit })
					),
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Templates', description: 'Predefined message templates' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12 text-right' },
							this.state.templates.length > 0 ? _react2.default.createElement('button', { onClick: function onClick(e) {
									return _this8.setState({ isEditingTemplate: true });
								}, className: 'btn btn-pure btn-default icon wb-plus' }) : null
						),
						this.state.templates.length > 0 ? _react2.default.createElement(
							'table',
							{ className: 'table table-striped' },
							_react2.default.createElement(
								'tbody',
								null,
								this.state.templates.map(function (template, i) {
									return _react2.default.createElement(
										'tr',
										{ key: template.id },
										_react2.default.createElement(
											'td',
											{ style: { width: '70%' } },
											template.name
										),
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'btn-group pull-right', role: 'group' },
												_react2.default.createElement(
													'button',
													{ className: 'btn btn-icon btn-default btn-outline', onClick: function onClick(e) {
															e.stopPropagation();_this8.setState({ isEditingTemplate: true, currentTemplate: template.id });
														} },
													_react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
												),
												_react2.default.createElement(
													'button',
													{ className: 'btn btn-icon btn-default btn-outline', onClick: function onClick(e) {
															e.stopPropagation();_this8.deleteTemplate(template.id);
														} },
													_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
												)
											)
										)
									);
								})
							)
						) : _react2.default.createElement(
							'button',
							{ onClick: function onClick(e) {
									return _this8.setState({ isEditingTemplate: true });
								}, className: 'btn btn-dark' },
							_react2.default.createElement('i', { className: 'icon wb-plus' }),
							' Add template'
						)
					)
				),
				_react2.default.createElement(
					_reactPortal2.default,
					{ closeOnEsc: true, onClose: function onClose(e) {
							_this8.setState({ currentTemplate: false, isEditingTemplate: false });
						}, isOpened: this.state.isEditingTemplate },
					_react2.default.createElement(
						_FullScreenOverlay2.default,
						null,
						_react2.default.createElement(_Template2.default, { handleSave: this.handleTemplateSubmit, onClose: function onClose(e) {
								_this8.setState({ currentTemplate: false, isEditingTemplate: false });
							}, templateId: this.state.currentTemplate ? this.state.currentTemplate : false })
					)
				)
			);
		}
	}]);

	return SettingsChat;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setSetting: _General3.setSetting }, dispatch);
};

SettingsChat = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsChat);
exports.default = SettingsChat;

/***/ }),

/***/ 1688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.CHAT_TEXT_SEND) {
        errors.CHAT_TEXT_SEND = 'Required';
    }

    if (!values.CHAT_TEXT_TYPE_MESSAGE) {
        errors.CHAT_TEXT_TYPE_MESSAGE = 'Required';
    }

    if (!values.CHAT_TEXT_EMAIL) {
        errors.CHAT_TEXT_EMAIL = 'Required';
    }

    if (!values.CHAT_TEXT_NAME) {
        errors.CHAT_TEXT_NAME = 'Required';
    }

    if (!values.CHAT_HEADER_MAXIMIZED_TEXT) {
        errors.CHAT_HEADER_MAXIMIZED_TEXT = 'Required';
    }

    if (!values.CHAT_TEXT_OPERATOR_REPLY_TIME) {
        errors.CHAT_TEXT_OPERATOR_REPLY_TIME = 'Required';
    }

    if (!values.CHAT_TEXT_GET_NOTIFIED) {
        errors.CHAT_TEXT_GET_NOTIFIED = 'Required';
    }

    if (!values.CHAT_TEXT_OFFLINE_MESSAGE) {
        errors.CHAT_TEXT_OFFLINE_MESSAGE = 'Required';
    }

    if (!values.CHAT_TEXT_CLOSED_MESSAGE) {
        errors.CHAT_TEXT_CLOSED_MESSAGE = 'Required';
    }

    if (!values.CHAT_TEXT_CLOSED_BTN) {
        errors.CHAT_TEXT_CLOSED_BTN = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var ChatTranslation = function (_React$Component) {
    _inherits(ChatTranslation, _React$Component);

    function ChatTranslation() {
        _classCallCheck(this, ChatTranslation);

        return _possibleConstructorReturn(this, (ChatTranslation.__proto__ || Object.getPrototypeOf(ChatTranslation)).apply(this, arguments));
    }

    _createClass(ChatTranslation, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Name', name: 'CHAT_TEXT_NAME', className: 'form-control', title: 'Name' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'E-mail', name: 'CHAT_TEXT_EMAIL', className: 'form-control', title: 'E-mail' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Send', name: 'CHAT_TEXT_SEND', className: 'form-control', title: 'Send' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Type a message...', name: 'CHAT_TEXT_TYPE_MESSAGE', className: 'form-control', title: 'Type a message...' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Chat with us!', name: 'CHAT_HEADER_MAXIMIZED_TEXT', className: 'form-control', title: 'Chat with us!' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Agent typically replies in a few hours. Don\'t miss their reply.', name: 'CHAT_TEXT_OPERATOR_REPLY_TIME', className: 'form-control', title: 'Agent typically replies in a few hours. Don\'t miss their reply.' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Get notified by e-mail', name: 'CHAT_TEXT_GET_NOTIFIED', className: 'form-control', title: 'Get notified by e-mail' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'We\'re not around right now. Please type your e-mail below and leave your question. We\'ll get back to you as soon as we can.', name: 'CHAT_TEXT_OFFLINE_MESSAGE', className: 'form-control', title: 'We\'re not around right now. Please type your e-mail below and leave your question. We\'ll get back to you as soon as we can.' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Thanks for chatting with us. Have a nice day.', name: 'CHAT_TEXT_CLOSED_MESSAGE', className: 'form-control', title: 'Thanks for chatting with us. Have a nice day.' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Start a new conversation', name: 'CHAT_TEXT_CLOSED_BTN', className: 'form-control', title: 'Start a new conversation' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row m-t-20' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            this.props.isSavingTranslation ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { type: 'submit', className: 'btn btn-dark btn-block' },
                                'Update'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ChatTranslation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
ChatTranslation = (0, _reduxForm.reduxForm)({
    form: 'ChatTranslation',
    validate: validate
})(ChatTranslation);

ChatTranslation = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {
            CHAT_TEXT_SEND: state.general.settings.CHAT_TEXT_SEND,
            CHAT_TEXT_EMAIL: state.general.settings.CHAT_TEXT_EMAIL,
            CHAT_TEXT_TYPE_MESSAGE: state.general.settings.CHAT_TEXT_TYPE_MESSAGE,
            CHAT_TEXT_NAME: state.general.settings.CHAT_TEXT_NAME,
            CHAT_HEADER_MAXIMIZED_TEXT: state.general.settings.CHAT_HEADER_MAXIMIZED_TEXT,

            CHAT_TEXT_OPERATOR_REPLY_TIME: state.general.settings.CHAT_TEXT_OPERATOR_REPLY_TIME,
            CHAT_TEXT_GET_NOTIFIED: state.general.settings.CHAT_TEXT_GET_NOTIFIED,
            CHAT_TEXT_OFFLINE_MESSAGE: state.general.settings.CHAT_TEXT_OFFLINE_MESSAGE,
            CHAT_TEXT_CLOSED_MESSAGE: state.general.settings.CHAT_TEXT_CLOSED_MESSAGE,
            CHAT_TEXT_CLOSED_BTN: state.general.settings.CHAT_TEXT_CLOSED_BTN

        }
    };
})(ChatTranslation);

exports.default = ChatTranslation;

/***/ }),

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _EmailDetails = __webpack_require__(269);

var _EmailDetails2 = _interopRequireDefault(_EmailDetails);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _PushTranslation = __webpack_require__(1690);

var _PushTranslation2 = _interopRequireDefault(_PushTranslation);

var _NumberPicker = __webpack_require__(398);

var _NumberPicker2 = _interopRequireDefault(_NumberPicker);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsPush = function (_React$Component) {
    _inherits(SettingsPush, _React$Component);

    function SettingsPush(props) {
        _classCallCheck(this, SettingsPush);

        var _this = _possibleConstructorReturn(this, (SettingsPush.__proto__ || Object.getPrototypeOf(SettingsPush)).call(this, props));

        _this.state = {
            isUploading: false,
            isLoading: true,
            isSavingTranslation: false
        };
        _this.updateKey = _this.updateKey.bind(_this);

        _this.handleColorChange = _this.handleColorChange.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleTranslationSubmit = _this.handleTranslationSubmit.bind(_this);
        _this.saveStatus = _this.saveStatus.bind(_this);
        _this.errors = _this.errors.bind(_this);
        return _this;
    }

    _createClass(SettingsPush, [{
        key: 'errors',
        value: function errors() {
            var errors = [];

            if (this.props.general.settings.LOGO_300x200 == '' || !this.props.general.settings.LOGO_300x200) {
                errors.push({
                    'text': 'You must add a 300x200 logo',
                    'link': '/settings/company'
                });
            }

            if (this.props.general.settings.LOGO_64x64 == '' || !this.props.general.settings.LOGO_64x64) {
                errors.push({
                    'text': 'You must add a 64x64 logo',
                    'link': '/settings/company'
                });
            }

            if (this.props.general.settings.SUBDOMAIN == '' || this.props.general.settings.SUBDOMAIN == null || !this.props.general.settings.SUBDOMAIN) {
                errors.push({
                    'text': 'You must add a subdomain',
                    'link': '/settings/company'
                });
            }

            return errors;
        }
    }, {
        key: 'saveStatus',
        value: function saveStatus() {

            if (this.errors().length > 0) {
                _Notification2.default.error('Please correct missing configuration options before saving');
                return;
            }

            this.handleTranslationSubmit({
                PUSH_DELAY: this.props.general.settings.PUSH_DELAY,
                PUSH_ACTIVE: this.props.general.settings.PUSH_ACTIVE,
                PUSH_POSITION: this.props.general.settings.PUSH_POSITION
            });
        }
    }, {
        key: 'handleColorChange',
        value: function handleColorChange(key, value) {
            this.props.setSetting(key, value);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            var subdomain = e.target.value;
            this.props.setSetting('SUBDOMAIN', subdomain);
        }
    }, {
        key: 'handleTranslationSubmit',
        value: function handleTranslationSubmit(values) {
            var _this2 = this;

            this.setState({
                isSavingTranslation: true
            });

            _axios2.default.put('/settings', values).then(function (res) {
                _this2.setState({
                    isSavingTranslation: false
                });

                for (var i in values) {
                    _this2.props.setSetting(i, values[i]);
                }

                _Notification2.default.success('Success!');
            }).catch(function (err) {
                _this2.setState({
                    isSavingTranslation: false
                });
            });
        }
    }, {
        key: 'updateKey',
        value: function updateKey(key) {
            var _this3 = this;

            if (key == 'SUBDOMAIN') {
                var subdomain = this.props.general.settings[key];
                if (subdomain.length < 3) {
                    _Notification2.default.error('Subdomain must contain more than two characters');
                    return;
                }

                var reg = new RegExp(/[^0-9-A-z]/g);

                if (reg.test(subdomain)) {
                    _Notification2.default.error('Subdomain can only contain A-Z and 0-9');
                    return;
                }
            }

            this.setState(_defineProperty({}, 'isSaving' + key, true));

            var data = _defineProperty({}, key, this.props.general.settings[key]);

            _axios2.default.put('/settings', data).then(function (res) {
                _this3.setState(_defineProperty({}, 'isSaving' + key, false));

                _Notification2.default.success('Success!');
            }).catch(function (err) {
                _this3.setState(_defineProperty({}, 'isSaving' + key, false));
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this4 = this;

            _General2.default.fetchGeneral().then(function () {
                _this4.setState({ isLoading: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            var errors = this.errors();

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Push notifications | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-rocket' }),
                        ' Push notifications'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Status and delay', description: 'How long should Crall wait until asking for permission. Turn on/off push notifications' },
                        errors.length > 0 ? _react2.default.createElement(
                            'div',
                            { className: 'alert alert-danger alert-dismissible', role: 'alert' },
                            'Before you can enable push notifications you must configure these options:',
                            _react2.default.createElement(
                                'ul',
                                { style: { paddingLeft: '30px', paddingTop: '20px', paddingBottom: '20px' } },
                                errors.map(function (item, i) {
                                    return _react2.default.createElement(
                                        'li',
                                        { key: i },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { style: { color: '#f96868', fontWeight: 400 }, to: _General2.default.Link(item.link) },
                                            item.text
                                        )
                                    );
                                })
                            ),
                            'Click on each step to configure.'
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'h5',
                                null,
                                'Status'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12 text-center' },
                                'Off \xA0\xA0',
                                _react2.default.createElement(_rcSwitch2.default, { onChange: function onChange(val) {
                                        _this5.props.setSetting('PUSH_ACTIVE', val);
                                    },
                                    checked: this.props.general.settings.PUSH_ACTIVE == '1' ? true : false,
                                    checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
                                    unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
                                }),
                                ' \xA0On'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'h5',
                                null,
                                'Position'
                            ),
                            _react2.default.createElement(
                                'select',
                                { value: this.props.general.settings.PUSH_POSITION, onChange: function onChange(e) {
                                        _this5.props.setSetting('PUSH_POSITION', e.target.value);
                                    }, className: 'form-control' },
                                _react2.default.createElement(
                                    'option',
                                    { value: 'left' },
                                    'Left'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: 'right' },
                                    'Right'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'h5',
                                null,
                                'Delay'
                            ),
                            _react2.default.createElement(_NumberPicker2.default, { min: 0, max: 30, value: this.props.general.settings.PUSH_DELAY, handleChange: function handleChange(val) {
                                    _this5.props.setSetting('PUSH_DELAY', val);
                                }, type: 'seconds' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 m-t-20' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', onClick: this.saveStatus, className: 'btn btn-dark btn-block' },
                                'Update'
                            )
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Translations', description: 'Translate strings to your native language.' },
                        _react2.default.createElement(_PushTranslation2.default, { isSavingTranslation: this.state.isSavingTranslation, onSubmit: this.handleTranslationSubmit })
                    ),
                    _react2.default.createElement(_SplitRow2.default, null)
                )
            );
        }
    }]);

    return SettingsPush;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSetting: _General3.setSetting }, dispatch);
};

SettingsPush = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsPush);
exports.default = SettingsPush;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Types = {
  CARD: 'card',
  ROW: 'row',
  ELEMENT: 'element',
  NEW_ELEMENT: 'new_element',
  NEW_ROW: 'new_row'
};

exports.default = Types;

/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.CHAT_TEXT_SEND) {
        errors.CHAT_TEXT_SEND = 'Required';
    }

    if (!values.CHAT_TEXT_TYPE_MESSAGE) {
        errors.CHAT_TEXT_TYPE_MESSAGE = 'Required';
    }

    if (!values.CHAT_TEXT_EMAIL) {
        errors.CHAT_TEXT_EMAIL = 'Required';
    }

    if (!values.CHAT_TEXT_NAME) {
        errors.CHAT_TEXT_NAME = 'Required';
    }

    if (!values.CHAT_HEADER_MAXIMIZED_TEXT) {
        errors.CHAT_HEADER_MAXIMIZED_TEXT = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var PushTranslation = function (_React$Component) {
    _inherits(PushTranslation, _React$Component);

    function PushTranslation() {
        _classCallCheck(this, PushTranslation);

        return _possibleConstructorReturn(this, (PushTranslation.__proto__ || Object.getPrototypeOf(PushTranslation)).apply(this, arguments));
    }

    _createClass(PushTranslation, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'h5',
                                null,
                                'Notification box'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Allow', name: 'PUSH_BUTTON_DECLINE', className: 'form-control', title: 'Allow button' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'No thanks', name: 'PUSH_BUTTON_ACCEPT', className: 'form-control', title: 'Decline button' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'We want to send you notifications about new offers, sales and upcoming events.', name: 'PUSH_HEADER_TEXT', className: 'form-control', title: 'Box header' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'You can easily disable notifications in your browser settings.', name: 'PUSH_DESKTOP_TEXT', className: 'form-control', title: 'Box subheader' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'h5',
                                null,
                                'Subscription window'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Click "Allow" to subscribe to our notifications', name: 'PUSH_TEXT_UNSUBSCRIBED_HEADER', className: 'form-control', title: 'Instructions' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'You can close this window', name: 'PUSH_TEXT_SUBSCRIBED_SUB', className: 'form-control', title: 'Close window message' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'You\'ll now get notifications from us.', name: 'PUSH_TEXT_SUBSCRIBED_HEADER', className: 'form-control', title: 'Subscribe successful' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row m-t-20' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            this.props.isSavingTranslation ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { type: 'submit', className: 'btn btn-dark btn-block' },
                                'Update'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PushTranslation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
PushTranslation = (0, _reduxForm.reduxForm)({
    form: 'PushTranslation',
    validate: validate
})(PushTranslation);

PushTranslation = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {
            PUSH_TEXT_UNSUBSCRIBED_HEADER: state.general.settings.PUSH_TEXT_UNSUBSCRIBED_HEADER,
            PUSH_TEXT_SUBSCRIBED_SUB: state.general.settings.PUSH_TEXT_SUBSCRIBED_SUB,
            PUSH_TEXT_SUBSCRIBED_HEADER: state.general.settings.PUSH_TEXT_SUBSCRIBED_HEADER,
            PUSH_BUTTON_DECLINE: state.general.settings.PUSH_BUTTON_DECLINE,
            PUSH_BUTTON_ACCEPT: state.general.settings.PUSH_BUTTON_ACCEPT,
            PUSH_DESKTOP_TEXT: state.general.settings.PUSH_DESKTOP_TEXT,
            PUSH_HEADER_TEXT: state.general.settings.PUSH_HEADER_TEXT

        }
    };
})(PushTranslation);

exports.default = PushTranslation;

/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _EmailDetails = __webpack_require__(269);

var _EmailDetails2 = _interopRequireDefault(_EmailDetails);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsCompany = function (_React$Component) {
    _inherits(SettingsCompany, _React$Component);

    function SettingsCompany(props) {
        _classCallCheck(this, SettingsCompany);

        var _this = _possibleConstructorReturn(this, (SettingsCompany.__proto__ || Object.getPrototypeOf(SettingsCompany)).call(this, props));

        _this.state = {
            isUploading: false,
            isUploadLarge: false,
            isLoading: true,
            isSavingPUSH_PRIMARY_COLOR: false,
            isSavingSUBDOMAIN: false,
            isSubdomainSet: false
        };
        _this.updateKey = _this.updateKey.bind(_this);

        _this.handleColorChange = _this.handleColorChange.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);

        _this.onDrop = _this.onDrop.bind(_this);
        _this.onOpenClick = _this.onOpenClick.bind(_this);
        _this.handleImageReset = _this.handleImageReset.bind(_this);

        _this.onDropLarge = _this.onDropLarge.bind(_this);
        _this.onOpenClickLarge = _this.onOpenClickLarge.bind(_this);
        _this.handleImageResetLarge = _this.handleImageResetLarge.bind(_this);
        return _this;
    }

    _createClass(SettingsCompany, [{
        key: 'handleImageReset',
        value: function handleImageReset() {
            var data = {
                'LOGO_64x64': ''
            };

            _axios2.default.put('/settings', data);
            this.props.setSetting('LOGO_64x64', '');
        }
    }, {
        key: 'handleImageResetLarge',
        value: function handleImageResetLarge() {
            var data = {
                'LOGO_300x200': ''
            };

            _axios2.default.put('/settings', data);
            this.props.setSetting('LOGO_300x200', '');
        }
    }, {
        key: 'onDrop',
        value: function onDrop(files) {
            var _this2 = this;

            if (files.length == 0) {
                return;
            }

            this.setState({ isUploading: true });

            var data = new FormData();
            data.append('file', files[0]);
            data.set('key', 'LOGO_64x64');
            data.set('resize_max', '1');
            data.set('resize_min', '1');

            _axios2.default.post('/settings/upload', data).then(function (res) {
                _this2.setState({ isUploading: false });
                _this2.props.setSetting('LOGO_64x64', res.data.value);
            }).catch(function (err) {
                _this2.setState({ isUploading: false });
            });
        }
    }, {
        key: 'onDropLarge',
        value: function onDropLarge(files) {
            var _this3 = this;

            if (files.length == 0) {
                return;
            }

            this.setState({ isUploadingLarge: true });

            var data = new FormData();
            data.append('file', files[0]);
            data.set('key', 'LOGO_300x200');
            data.set('resize_max', '1');

            _axios2.default.post('/settings/upload', data).then(function (res) {
                _this3.setState({ isUploadingLarge: false });
                _this3.props.setSetting('LOGO_300x200', res.data.value);
            }).catch(function (err) {
                _this3.setState({ isUploadingLarge: false });
            });
        }
    }, {
        key: 'onOpenClick',
        value: function onOpenClick() {
            this.refs.dropzone.open();
        }
    }, {
        key: 'onOpenClickLarge',
        value: function onOpenClickLarge() {
            this.refs.dropzoneLarge.open();
        }
    }, {
        key: 'handleColorChange',
        value: function handleColorChange(key, value) {
            this.props.setSetting(key, value);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            var subdomain = e.target.value;
            this.props.setSetting('SUBDOMAIN', subdomain);
        }
    }, {
        key: 'updateKey',
        value: function updateKey(key) {
            var _this4 = this;

            var state = _defineProperty({}, 'isSaving' + key, true);

            if (key == 'SUBDOMAIN') {
                var subdomain = this.props.general.settings[key];
                if (subdomain.length < 3) {
                    _Notification2.default.error('Subdomain must contain more than two characters');
                    return;
                }

                var reg = new RegExp(/[^0-9-A-z]/g);

                if (reg.test(subdomain)) {
                    _Notification2.default.error('Subdomain can only contain A-Z and 0-9');
                    return;
                }

                state.isSubdomainSet = true;
            }

            this.setState(state);

            var data = _defineProperty({}, key, this.props.general.settings[key]);

            _axios2.default.put('/settings', data).then(function (res) {
                _this4.setState(_defineProperty({}, 'isSaving' + key, false));

                _Notification2.default.success('Success!');
            }).catch(function (err) {
                _this4.setState(_defineProperty({}, 'isSaving' + key, false));
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this5 = this;

            _General2.default.fetchGeneral().then(function () {
                var subdomain = false;

                if (_this5.props.general.settings.SUBDOMAIN != '' && _this5.props.general.settings.SUBDOMAIN != null && _this5.props.general.settings.SUBDOMAIN !== false) {
                    subdomain = true;
                }

                _this5.setState({ isLoading: false, isSubdomainSet: subdomain });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Company | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-briefcase' }),
                        ' Company'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Color', description: 'What is your primary and off-color?' },
                        _react2.default.createElement(
                            'h6',
                            null,
                            'Primary'
                        ),
                        _react2.default.createElement(_ColorPicker2.default, { id: 'PRIMARY_COLOR', color: this.props.general.settings.PRIMARY_COLOR, handleColorChange: this.handleColorChange }),
                        _react2.default.createElement(
                            'h6',
                            null,
                            'Off-color'
                        ),
                        _react2.default.createElement(_ColorPicker2.default, { id: 'SECONDARY_COLOR', color: this.props.general.settings.SECONDARY_COLOR, handleColorChange: this.handleColorChange }),
                        _react2.default.createElement('br', null),
                        this.state.isSavingPRIMARY_COLOR ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { className: 'btn btn-dark btn-block', onClick: function onClick(e) {
                                    e.stopPropagation();_this6.updateKey('SECONDARY_COLOR');_this6.updateKey('PRIMARY_COLOR');
                                } },
                            'Update'
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Large logo', description: 'Upload a large logo. Max image size is 300px X 200px' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 text-center' },
                            _react2.default.createElement('img', { src: this.props.general.settings.LOGO_300x200, style: { maxWidth: '300px' } })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                _reactDropzone2.default,
                                { ref: 'dropzoneLarge', style: {}, disableClick: true, multiple: false, onDrop: this.onDropLarge },
                                this.state.isUploadLarge ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                    'button',
                                    { type: 'button', onClick: this.onOpenClickLarge, className: 'btn btn-dark btn-block' },
                                    'Upload logo'
                                )
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark btn-block', onClick: this.handleImageResetLarge },
                                'Reset logo'
                            )
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Small logo', description: 'Upload a small logo. It MUST be 64px X 64px' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 text-center' },
                            _react2.default.createElement('img', { src: this.props.general.settings.LOGO_64x64, style: { width: '64px' } })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                _reactDropzone2.default,
                                { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
                                this.state.isUploading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                    'button',
                                    { type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark btn-block' },
                                    'Upload logo'
                                )
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark btn-block', onClick: this.handleImageReset },
                                'Reset logo'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SettingsCompany;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSetting: _General3.setSetting }, dispatch);
};

SettingsCompany = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsCompany);
exports.default = SettingsCompany;

/***/ }),

/***/ 1692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	}

	_createClass(Settings, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			_General2.default.loadScript('https://js.stripe.com/v2/').then(function () {
				return Stripe.setPublishableKey(_this2.props.general.settings.stripe_key);
			});
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: 'Billing | Crall.io'
				}),
				this.props.children
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

		_this.state = {
			'isLoading': true,
			'accept_cancel': false,
			'isCancelling': false,
			'isResuming': false,
			'next_billing_period': false,
			'invoices': []
		};

		_this.handleResume = _this.handleResume.bind(_this);
		_this.handleChangePlan = _this.handleChangePlan.bind(_this);
		_this.handleCard = _this.handleCard.bind(_this);
		return _this;
	}

	_createClass(Settings, [{
		key: 'handleCard',
		value: function handleCard() {
			this.props.router.push(_General2.default.Link('/settings/billing/card'));
		}
	}, {
		key: 'handleChangePlan',
		value: function handleChangePlan() {
			this.props.router.push(_General2.default.Link('/settings/billing/plan'));
		}
	}, {
		key: 'handleResume',
		value: function handleResume() {
			var _this2 = this;

			this.setState({
				isResuming: true
			});
			_axios2.default.post('/subscriptions/resume').then(function (res) {
				_General2.default.fetchGeneral().then(function (res) {
					_this2.setState({
						isResuming: true
					});
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.router.push(_General2.default.Link('/settings/billing/subscribe'));
			return false;
		}
	}, {
		key: 'renderSubscribed',
		value: function renderSubscribed() {
			var _this3 = this;

			return _react2.default.createElement(
				'div',
				null,
				this.props.general.account.grace_period ? null : _react2.default.createElement(
					_OptionColumn2.default,
					{ title: 'Plan', description: 'The plan you\'re currently subscribed to.' },
					this.props.general.account.downgrade_package ? _react2.default.createElement(
						'div',
						{ className: 'alert col-sm-12 dark alert-icon alert-info alert-dismissible', role: 'alert' },
						_react2.default.createElement('i', { className: 'icon wb-info', 'aria-hidden': 'true' }),
						' You are now on plan ',
						_react2.default.createElement(
							'strong',
							null,
							this.props.general.account.downgrade_package.name
						),
						'. You will still have access to all the features of plan ',
						_react2.default.createElement(
							'strong',
							null,
							this.props.general.account.package.name
						),
						' until ',
						_react2.default.createElement(
							'strong',
							null,
							(0, _moment2.default)(this.state.next_billing_period).format('DD.MM.YYYY')
						),
						'.'
					) : null,
					_react2.default.createElement(
						'table',
						{ className: 'table table-bordered' },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								{ className: 'table-active' },
								_react2.default.createElement(
									'th',
									null,
									'Package'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								),
								_react2.default.createElement(
									'th',
									null,
									'Total'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.name : this.props.general.account.package.name
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'p',
										null,
										'- Billed each month'
									),
									this.props.general.account.country == 'Norway' ? _react2.default.createElement(
										'p',
										null,
										'- Priser eks mva'
									) : '',
									this.state.next_billing_period ? _react2.default.createElement(
										'p',
										null,
										'- Next billing period: ',
										(0, _moment2.default)(this.state.next_billing_period).format('DD.MM.YYYY')
									) : false
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'strong',
										null,
										this.props.general.account.country == 'Norway' ? _react2.default.createElement(
											'p',
											null,
											this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.price_norwegian : this.props.general.account.package.price_norwegian,
											',- NOK'
										) : _react2.default.createElement(
											'p',
											null,
											'$',
											this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.price : this.props.general.account.package.price
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 p-0' },
						_react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this3.handleChangePlan();
								} },
							'Change plan'
						)
					)
				),
				this.props.general.account.grace_period ? null : _react2.default.createElement(_SplitRow2.default, null),
				this.props.general.account.grace_period ? null : _react2.default.createElement(
					_OptionColumn2.default,
					{ title: 'Payment card', description: 'Replace an existing card with a new one.' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-8' },
						_react2.default.createElement('input', { disabled: true, type: 'text', style: { fontWeight: 600, letterSpacing: '2px' }, value: '****-****-****-' + (this.props.general.account.card_last_four ? this.props.general.account.card_last_four : '****'), className: 'form-control' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-4' },
						_react2.default.createElement(
							'button',
							{ className: 'btn btn-dark btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this3.handleCard();
								} },
							'Change'
						)
					)
				),
				this.props.general.account.grace_period ? _react2.default.createElement(_SplitRow2.default, null) : null,
				this.props.general.account.grace_period ? _react2.default.createElement(
					_OptionColumn2.default,
					{ title: 'Cancel', description: 'Cancel your current subscription.' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'p',
							null,
							'Your subscription at crall will end at ',
							_react2.default.createElement(
								'strong',
								null,
								(0, _moment2.default)(this.props.general.account.grace_period).format('DD.MM.YYYY')
							),
							', and will not be billed after this date.'
						),
						this.state.isResuming ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
							'button',
							{ className: 'btn btn-success btn-block', onClick: function onClick(e) {
									e.stopPropagation();_this3.handleResume();
								} },
							'Resume subscription'
						)
					)
				) : null
			);
		}
	}, {
		key: 'render',
		value: function render() {

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-payment' }),
						' Billing'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					this.renderSubscribed()
				)
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _Card = __webpack_require__(270);

var _Card2 = _interopRequireDefault(_Card);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingInvoices = function (_React$Component) {
    _inherits(BillingInvoices, _React$Component);

    function BillingInvoices(props) {
        _classCallCheck(this, BillingInvoices);

        var _this = _possibleConstructorReturn(this, (BillingInvoices.__proto__ || Object.getPrototypeOf(BillingInvoices)).call(this, props));

        _this.state = {
            'isLoading': true,
            'accept_cancel': false,
            'isCancelling': false,
            'isResuming': false,
            'next_billing_period': false,
            'invoices': [],
            'refunds': []

        };

        return _this;
    }

    _createClass(BillingInvoices, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _General2.default.fetchGeneral().then(function () {
                _axios2.default.get('/invoices').then(function (res) {
                    if (_this2.props.general.account.dealer && res.data.invoices.length == 0) {
                        _this2.props.router.push(_General2.default.Link('/settings/billing/dealer'));
                        return;
                    }

                    _this2.setState({ next_billing_period: res.data.next_billing_period, refunds: res.data.refunds, invoices: res.data.invoices, isLoading: false });
                }).catch(function (res) {
                    _this2.setState({ isLoading: false });
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-order' }),
                        ' Invoices'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Invoices', description: 'List of all invoices for this account.' },
                        this.state.invoices.length > 0 ? _react2.default.createElement(
                            'table',
                            { className: 'table table-bordered' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'table-active' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Receipt number'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sum'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.state.invoices.map(function (invoice, i) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: i },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            '#',
                                            invoice.receipt_number
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            invoice.date
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            invoice.total
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'a',
                                                { href: invoice.url, target: '_blank', style: { textDecoration: 'none' }, className: 'btn btn-dark btn-md' },
                                                'Open'
                                            )
                                        )
                                    );
                                })
                            )
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'alert dark alert-icon alert-info alert-dismissible', role: 'alert' },
                            _react2.default.createElement('i', { className: 'icon wb-info', 'aria-hidden': 'true' }),
                            ' We didn\'t find any previous invoices.'
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Credit notes', description: 'List of all credited invoices.' },
                        this.state.refunds.length > 0 ? _react2.default.createElement(
                            'table',
                            { className: 'table table-bordered' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'table-active' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Receipt number'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sum'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.state.refunds.map(function (invoice, i) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: i },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            '#',
                                            invoice.receipt_number
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            invoice.date
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            '-',
                                            invoice.total
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'a',
                                                { href: invoice.url, target: '_blank', style: { textDecoration: 'none' }, className: 'btn btn-dark btn-md' },
                                                'Open'
                                            )
                                        )
                                    );
                                })
                            )
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'alert dark alert-icon alert-info alert-dismissible', role: 'alert' },
                            _react2.default.createElement('i', { className: 'icon wb-info', 'aria-hidden': 'true' }),
                            ' You don\'t have any credited invoices.'
                        )
                    )
                )
            );
        }
    }]);

    return BillingInvoices;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

BillingInvoices = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingInvoices);
exports.default = BillingInvoices;

/***/ }),

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _BillingInformation = __webpack_require__(684);

var _BillingInformation2 = _interopRequireDefault(_BillingInformation);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _EstimatePackageUsage = __webpack_require__(1696);

var _EstimatePackageUsage2 = _interopRequireDefault(_EstimatePackageUsage);

var _General3 = __webpack_require__(53);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
    _inherits(Settings, _React$Component);

    function Settings(props) {
        _classCallCheck(this, Settings);

        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

        _this.hasDiffFromExistingSelection = function () {
            var current = [];
            var i = 0;

            _this.props.general.plans.map(function (plan) {
                if (plan.plan.ends_at) {
                    return plan;
                }
                i++;
                current.push(plan.details.type);
            });

            var found = 0;

            Object.keys(_this.state.selected_packages).map(function (k) {
                if (current.includes(k)) {
                    found++;
                } else {
                    found--;
                }
            });

            if (Object.keys(_this.state.selected_packages).length == 0) {
                return false;
            }

            return found != i;
        };

        _this.hasSelectedSubscriptionType = function (type) {
            if (_typeof(_this.state.selected_packages[type]) != 'object') {
                return false;
            }

            return true;
        };

        _this.getPackageData = function (type) {
            return _this.state.selected_packages[type];
        };

        _this.addFeature = function (type) {
            var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var p = void 0;

            if (i == 0) {
                p = _this.state.packages[type][_this.getPackageWithTier(type, _this.state.tier).i];
            } else {
                p = _this.state.packages[type][i];
            }

            _this.setState({
                selected_packages: _extends({}, _this.state.selected_packages, _defineProperty({}, type, p))
            });
        };

        _this.removeFeature = function (type) {
            var packages = _extends({}, _this.state.selected_packages);

            delete packages[type];

            _this.setState({
                selected_packages: packages
            });
        };

        _this.handlePlanDropdownChange = function (type, e) {
            _this.addFeature(type, e.target.value);
        };

        _this.listPackageType = function (key) {
            var p = _this.state.packages[key];
            var name = key.charAt(0).toUpperCase() + key.substr(1);
            var description = '';

            switch (key) {
                case 'platform':
                    description = 'The base Crall.io platform. Features may include chat, popups, emails, analytics, etc depending on package.';
                    break;
                case 'recommendation':
                    description = 'Show personalized product recommendations in your shop and include them in e-mails.';
                    break;

                case 'search':
                    description = 'Enable personalized search in your shop.';
                    break;
            }

            if (!_this.hasSelectedSubscriptionType(key)) {
                return _react2.default.createElement(
                    'tr',
                    { key: key },
                    _react2.default.createElement(
                        'td',
                        { style: { backgroundColor: '#f7f7f7', 'color': '#000' } },
                        _react2.default.createElement(
                            'strong',
                            null,
                            name
                        ),
                        _react2.default.createElement('br', null),
                        description
                    ),
                    _react2.default.createElement('td', { style: { textAlign: 'center', backgroundColor: '#f7f7f7', verticalAlign: 'middle' } }),
                    _react2.default.createElement('td', { style: { textAlign: 'center', backgroundColor: '#f7f7f7', verticalAlign: 'middle' } }),
                    _react2.default.createElement('td', { style: { textAlign: 'center', backgroundColor: '#f7f7f7', verticalAlign: 'middle' } }),
                    _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right', backgroundColor: '#f7f7f7', verticalAlign: 'middle' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'checkbox-custom checkbox-primary' },
                            _react2.default.createElement('input', { onClick: function onClick() {
                                    return _this.addFeature(key);
                                }, type: 'checkbox', defaultChecked: false }),
                            _react2.default.createElement('label', null)
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'tr',
                { key: key },
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        name
                    ),
                    _react2.default.createElement('br', null),
                    description
                ),
                _react2.default.createElement(
                    'td',
                    { style: { verticalAlign: 'middle' } },
                    _this.getPackageData(key).sessions,
                    '*'
                ),
                _react2.default.createElement(
                    'td',
                    { style: { verticalAlign: 'middle' } },
                    _this.getPackageData(key).emails
                ),
                _react2.default.createElement(
                    'td',
                    { style: { verticalAlign: 'middle' } },
                    _this.getPackageData(key).price
                ),
                _react2.default.createElement(
                    'td',
                    { style: { textAlign: 'right', verticalAlign: 'middle' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox-custom checkbox-primary' },
                        _react2.default.createElement('input', { onClick: function onClick() {
                                return _this.removeFeature(key);
                            }, type: 'checkbox', defaultChecked: true }),
                        _react2.default.createElement('label', null)
                    )
                )
            );
        };

        _this.totalSum = function () {
            var sum = 0;
            for (var i in _this.state.selected_packages) {
                sum += _this.state.selected_packages[i].amount;
            }

            return sum;
        };

        _this.continue = function () {
            _this.setState({
                step: _this.state.step + 1
            });
        };

        _this.previous = function () {
            _this.setState({
                step: _this.state.step - 1
            });
        };

        _this.calculatePrice = function () {
            var sum = _this.totalSum();

            if (_this.props.general.account.country == 'Norway') {
                sum = 'NOK ' + sum + ',- ex tax / month';
            } else {
                sum = '$' + sum + ' / month';
            }

            return sum;
        };

        _this.sumToPay = function () {
            return _this.totalSum();
        };

        _this.getPackageWithTier = function (type, tier) {
            for (var i in _this.state.packages[type]) {
                if (_this.state.packages[type][i].tier == tier && !_this.state.packages[type][i].deprecated) {

                    return {
                        i: i,
                        package: _this.state.packages[type][i]
                    };
                }
            }

            return {
                i: 0,
                package: _this.state.packages[type][0]
            };
        };

        _this.skipEstimate = function () {
            _this.setState({
                pickTier: true
            });
        };

        _this.update = function () {
            if (Object.keys(_this.state.selected_packages).length == 0) {
                _Notification2.default.error("If you want to remove all features, you must cancel you account.");
                return;
            }

            _this.props.setGlobalKey('showProcessing', true);

            _axios2.default.put('/subscriptions', {
                packages: _this.state.selected_packages
            }).then(function (res) {
                _this.setState({
                    forceReload: true
                });
                _Notification2.default.success('Thanks! Your plan has been updated.');
                _this.props.setGlobalKey('showProcessing', false);
                _this.props.router.push(_General2.default.Link('/settings/billing'));
            });
        };

        _this.getPackageWithSession = function (type, sessions) {
            for (var i in _this.state.packages[type]) {
                if (_this.state.packages[type][i]['sessions'] == sessions) {
                    return {
                        i: i,
                        package: _this.state.packages[type][i]
                    };
                }
            }

            return {
                i: 0,
                package: _this.state.packages[type][0]
            };
        };

        _this.handleEstimateResult = function (result) {
            _this.setState({
                estimate: result,
                tier: result.tier,
                pickTier: true
            });

            _this.addFeature('platform', _this.getPackageWithSession('platform', result.sessions).i);
            _this.addFeature('recommendation', _this.getPackageWithSession('recommendation', result.sessions).i);
            _this.addFeature('search', _this.getPackageWithSession('search', result.sessions).i);
        };

        _this.isOnDisabledPlan = function () {
            var disabled = false;

            _this.props.general.plans.map(function (plan) {
                if (!disabled) {
                    disabled = plan.details.disabled;
                }
            });

            return disabled;
        };

        _this.handleTierChange = function (e) {
            _this.setState({
                tier: e.target.value
            });
        };

        _this.pageActions = function () {
            return _react2.default.createElement('div', { className: 'page-header-actions' });
        };

        _this.isSwitchingFromDeprecatedPlan = function () {
            var result = false;

            Object.keys(_this.state.selected_packages).map(function (type) {
                _this.props.general.plans.map(function (plan) {
                    if (type == plan.details.type && plan.plan.plan_id != _this.state.selected_packages[type].id) {
                        result = true;
                    }
                });
            });

            return result;
        };

        _this.state = {
            pickTier: false,
            estimate: false,
            forceReload: false,
            tier: 3,
            tiers: [],
            'packages': [],
            'isLoading': true,
            step: 0,
            'selected_packages': {},
            'error': false,
            'isPaying': false,
            'promo_code': '',
            'promo': false
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.changePackage = _this.changePackage.bind(_this);
        _this.renderDemoExpired = _this.renderDemoExpired.bind(_this);
        _this.applyPromo = _this.applyPromo.bind(_this);
        _this.handlePromoChange = _this.handlePromoChange.bind(_this);
        return _this;
    }

    _createClass(Settings, [{
        key: 'handlePromoChange',
        value: function handlePromoChange(e) {
            this.setState({
                promo_code: e.target.value
            });
        }
    }, {
        key: 'applyPromo',
        value: function applyPromo() {
            var _this2 = this;

            if (this.state.promo_code == '') {
                _Notification2.default.error('No promo code added');
                return;
            }
            this.setState({
                isLoading: true
            });

            _axios2.default.get('/subscriptions/promo?code=' + this.state.promo_code).then(function (res) {
                _this2.setState({
                    isLoading: false,
                    promo: res.data
                });
            }).catch(function (err) {
                _this2.setState({
                    isLoading: false
                });
                _Notification2.default.error('Invalid promo code');
            });
        }
    }, {
        key: 'selectedPackage',
        value: function selectedPackage() {
            return this.state.selected_packages;
        }
    }, {
        key: 'changePackage',
        value: function changePackage() {
            this.setState({
                step: 0
            });
        }
    }, {
        key: 'selectPackage',
        value: function selectPackage(package_id) {
            this.setState({ 'package': package_id });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(values) {
            var _this3 = this;

            this.setState({
                'isPaying': true
            });

            this.props.setGlobalKey('showProcessing', true);

            Stripe.createToken({
                number: values.cardnumber,
                cvc: values.cvc,
                exp_month: values.month,
                exp_year: values.year
            }, function (status, response) {
                if (response.error) {
                    _this3.props.setGlobalKey('showProcessing', false);
                    _this3.setState({ isPaying: false, error: response.error.message });
                } else {
                    values.token = response['id'];
                    values.packages = _this3.state.selected_packages;
                    if (_this3.state.promo_code) {
                        values.promo_code = _this3.state.promo_code;
                    }

                    _axios2.default.post('/subscriptions', values).then(function (res) {
                        _this3.setState({
                            'isPaying': false,
                            forceReload: true
                        });
                        _Notification2.default.success('Thanks! You are now subscribed.');
                        _this3.props.setGlobalKey('showProcessing', false);
                        _this3.props.router.push(_General2.default.Link('/settings/billing'));
                    }).catch(function (err) {
                        _this3.props.setGlobalKey('showProcessing', false);
                        _this3.setState({ isPaying: false, error: err.response.data.error.message });
                    });
                }
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this4 = this;

            _General2.default.fetchGeneral().then(function () {
                if (_this4.props.general.account.dealer) {
                    _this4.props.router.push(_General2.default.Link('/settings/billing/dealer'));
                    return;
                }
                _axios2.default.get('/packages').then(function (res) {
                    _this4.setState({
                        'isLoading': false,
                        'packages': res.data.plans,
                        'tiers': res.data.tiers
                    });
                });

                if (_this4.props.general.plans.length > 0) {
                    var selected_packages = {};
                    var tier = 0;

                    _this4.props.general.plans.map(function (plan) {
                        if (plan.plan.ends_at) {
                            tier = plan.details.tier;
                            return plan;
                        }
                        selected_packages[plan.details.type] = plan.details;
                        tier = plan.details.tier;
                    });

                    _this4.setState({
                        selected_packages: selected_packages,
                        tier: tier
                    });
                }
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            if (this.props.general.account.dealer) {
                this.props.router.push(_General2.default.Link('/settings/billing/dealer'));
                return;
            }
        }
    }, {
        key: 'renderDemoExpired',
        value: function renderDemoExpired() {
            if (this.props.general.account.expired == true) {
                return _react2.default.createElement(
                    'div',
                    { role: 'alert', className: 'alert dark alert-danger alert-dismissible' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Subscription expired'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Your subscription has expired. To continue using our service you need to subscribe.'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'm-t-15' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link('/settings/billing/invoices'), className: 'btn btn-danger btn-inverse btn-outline' },
                            'Click here to see previous invoices'
                        )
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            if (this.state.step == 2) {
                return _react2.default.createElement(
                    'div',
                    { className: 'full-height' },
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header' },
                        _react2.default.createElement(
                            'span',
                            { className: 'page-title' },
                            _react2.default.createElement('i', { className: 'icon wb-payment' }),
                            ' Billing'
                        ),
                        this.pageActions()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-content' },
                        this.renderDemoExpired(),
                        _react2.default.createElement(_BillingInformation2.default, { handlePromoChange: this.handlePromoChange, promo: this.state.promo, applyPromo: this.applyPromo, promo_code: this.state.promo_code, isPaying: this.state.isPaying, errorMessage: this.state.error, p: this.selectedPackage(), changePackage: this.changePackage, sumToPay: this.sumToPay, onSubmit: this.handleSubmit })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-payment' }),
                        ' Billing'
                    ),
                    this.pageActions()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    this.renderDemoExpired(),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 inherit-position' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body' },
                                    this.state.step == 0 && this.props.general.plans.length == 0 ? _react2.default.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        _react2.default.createElement(
                                            _EstimatePackageUsage2.default,
                                            { handleResult: this.handleEstimateResult, packages: this.state.packages },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                'Package size estimation'
                                            ),
                                            _react2.default.createElement('br', null),
                                            'Our packages are limited by the amount of unique sessions you have each month. It can be difficult to figure out how many sessions you need as a new customer.',
                                            _react2.default.createElement('br', null),
                                            'After analyzing our data from existing customers we can give an estimate of how many sessions you\'ll need based on data from Google Analytics.',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement('br', null),
                                            'We can try to estimate the amount of sessions you\'ll need based on your Google Analytics numbers.',
                                            _react2.default.createElement('br', null),
                                            'You can read more about sessions and how to find your Analytic sessions ',
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'http://docs.crall.io/ofte-stilte-sporsmal/hva-er-sessions', target: 'blank' },
                                                'by clicking here.'
                                            ),
                                            this.state.pickTier ? _react2.default.createElement(
                                                'div',
                                                { className: 'row' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'col-sm-5 offset-sm-3 m-t-20 m-b-20' },
                                                    _react2.default.createElement(
                                                        'h2',
                                                        null,
                                                        'Session estimate'
                                                    ),
                                                    _react2.default.createElement(
                                                        'select',
                                                        { className: 'form-control', value: this.state.tier, onChange: this.handleTierChange },
                                                        this.state.tiers.map(function (tier, i) {
                                                            return _react2.default.createElement(
                                                                'option',
                                                                { value: tier.tier, key: i },
                                                                tier.name
                                                            );
                                                        })
                                                    ),
                                                    _react2.default.createElement('br', null),
                                                    _react2.default.createElement(
                                                        'button',
                                                        { className: 'btn btn-dark btn-block', onClick: this.continue },
                                                        'Continue with selected sessions'
                                                    )
                                                )
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { style: { width: '100%', textAlign: 'center' } },
                                            _react2.default.createElement(
                                                'a',
                                                { onClick: function onClick(e) {
                                                        e.preventDefault();_this5.skipEstimate();
                                                    }, href: 'javascript:void(0)' },
                                                '... or click here to skip estimation'
                                            )
                                        )
                                    ) : _react2.default.createElement(
                                        'div',
                                        null,
                                        Object.keys(this.state.selected_packages).length == 0 && this.props.general.plans.length > 0 && !this.props.general.account.isOnGracePeriod ? _react2.default.createElement(
                                            'div',
                                            { role: 'alert', className: 'alert dark alert-danger alert-dismissible' },
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                'No features selected'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                'To use our service you must subscribe to at least one feature. If you wish to cancel your account, please use this link.'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'm-t-15' },
                                                _react2.default.createElement(
                                                    _reactRouter.Link,
                                                    { to: _General2.default.Link('/settings/billing/cancel'), className: 'btn btn-danger btn-inverse btn-outline' },
                                                    'Cancel account'
                                                )
                                            )
                                        ) : null,
                                        this.isSwitchingFromDeprecatedPlan() ? _react2.default.createElement(
                                            'div',
                                            { role: 'alert', className: 'alert dark alert-warning alert-dismissible' },
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                'Deprecated Plan'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                'You are now switching from a deprecated Plan. If you do this you\'ll not be able to resubscribe with the same plan. If you wish to resubscribe at a later time you must select one of our current plans.'
                                            )
                                        ) : null,
                                        this.props.general.account.isOnGracePeriod ? _react2.default.createElement(
                                            'div',
                                            { role: 'alert', className: 'alert dark alert-danger alert-dismissible' },
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                'Account cancelled'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                'You have cancelled your account and it will expire ',
                                                _react2.default.createElement(
                                                    'strong',
                                                    null,
                                                    _moment2.default.utc(this.props.general.account.isOnGracePeriod).local().format('DD-MM-YYYY')
                                                ),
                                                '. If you want to continue using our services, please resubscribe with the services you want to use in the form below.'
                                            )
                                        ) : null,
                                        this.isOnDisabledPlan() ? _react2.default.createElement(
                                            'div',
                                            { role: 'alert', className: 'alert dark alert-danger alert-dismissible' },
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                'Disabled plan'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                'You are currenly subscribed to an old plan/feature that is not available anymore. ',
                                                _react2.default.createElement('br', null),
                                                'If you wish to upgrade / subscribe to additional features please contact us by chat or drop us a line at hi@crall.io.'
                                            )
                                        ) : null,
                                        !this.isOnDisabledPlan() ? _react2.default.createElement(
                                            'table',
                                            { className: 'table', style: { marginTop: '20px' } },
                                            _react2.default.createElement(
                                                'thead',
                                                null,
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'th',
                                                        { style: { width: '30%' } },
                                                        'Product'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Max session usage'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'E-mails'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Price'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        { style: { textAlign: 'center' } },
                                                        'Subscribe to'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                Object.keys(this.state.packages).map(function (key) {
                                                    return _this5.listPackageType(key);
                                                }),
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        { style: { fontWeight: 'bold', backgroundColor: '#f0f0f0' } },
                                                        'Total price'
                                                    ),
                                                    _react2.default.createElement('td', { style: { backgroundColor: '#f0f0f0' } }),
                                                    _react2.default.createElement('td', { style: { backgroundColor: '#f0f0f0' } }),
                                                    _react2.default.createElement(
                                                        'td',
                                                        { style: { fontWeight: 'bold', backgroundColor: '#f0f0f0' } },
                                                        this.calculatePrice()
                                                    ),
                                                    _react2.default.createElement('td', { style: { backgroundColor: '#f0f0f0' } })
                                                ),
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        '* Sessions are not added together when subscribing to multiple features.'
                                                    ),
                                                    _react2.default.createElement('td', null),
                                                    _react2.default.createElement('td', null),
                                                    _react2.default.createElement('td', null),
                                                    _react2.default.createElement('td', null)
                                                )
                                            )
                                        ) : null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-12 p-0' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-sm-6 p-0', style: { textAlign: 'left' } },
                                                this.props.general.plans.length > 0 ? _react2.default.createElement(
                                                    'div',
                                                    null,
                                                    '- ',
                                                    _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        'We are billing your ',
                                                        _react2.default.createElement(
                                                            'strong',
                                                            null,
                                                            this.props.general.account.card_brand
                                                        ),
                                                        ' ending in ',
                                                        _react2.default.createElement(
                                                            'strong',
                                                            null,
                                                            this.props.general.account.card_last_four
                                                        ),
                                                        ' - ',
                                                        _react2.default.createElement(
                                                            _reactRouter.Link,
                                                            { to: _General2.default.Link('/settings/billing/card') },
                                                            'Click here to update card'
                                                        )
                                                    ),
                                                    _react2.default.createElement('br', null),
                                                    !this.props.general.account.isOnGracePeriod ? _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '- ',
                                                        _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            'Do you want to ',
                                                            _react2.default.createElement(
                                                                'strong',
                                                                null,
                                                                'cancel'
                                                            ),
                                                            ' your account? - ',
                                                            _react2.default.createElement(
                                                                _reactRouter.Link,
                                                                { to: _General2.default.Link('/settings/billing/cancel') },
                                                                'Click here'
                                                            )
                                                        )
                                                    ) : null
                                                ) : _react2.default.createElement(
                                                    'button',
                                                    { className: 'btn btn-dark', onClick: this.previous },
                                                    'Back to estimate'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-sm-6 p-0', style: { textAlign: 'right' } },
                                                this.props.general.plans.length > 0 ? _react2.default.createElement(
                                                    'button',
                                                    { className: 'btn btn-dark', onClick: this.update, disabled: !this.hasDiffFromExistingSelection() },
                                                    'Update subscription'
                                                ) : _react2.default.createElement(
                                                    'button',
                                                    { className: 'btn btn-dark', onClick: this.continue, disabled: this.totalSum() === 0 ? true : false },
                                                    'Continue to billing details'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setGlobalKey: _General3.setGlobalKey }, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _helpers = __webpack_require__(128);

var _helpers2 = _interopRequireDefault(_helpers);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstimatePackageUsage = function (_React$Component) {
    _inherits(EstimatePackageUsage, _React$Component);

    function EstimatePackageUsage(props) {
        _classCallCheck(this, EstimatePackageUsage);

        var _this = _possibleConstructorReturn(this, (EstimatePackageUsage.__proto__ || Object.getPrototypeOf(EstimatePackageUsage)).call(this, props));

        _this.calculate = function () {
            if (_this.state.value == '') {
                return;
            }

            var domain = 'https://api.crall.io';
            if (!_helpers2.default.isProduction()) {
                domain = 'https://api.crall.dev';
            }

            _this.setState({
                isLoading: true
            });

            _axios2.default.get(domain + '/plans/estimate?sessions=' + _this.state.value).then(function (result) {
                _this.setState({
                    isLoading: false,
                    result: result.data
                });

                _this.props.handleResult(result.data);
            });
        };

        _this.changeInput = function (e) {
            _this.setState({
                value: e.target.value
            });
        };

        _this.state = {
            value: '',
            isLoading: false,
            result: false
        };
        return _this;
    }

    _createClass(EstimatePackageUsage, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12', style: { backgroundColor: '#fafafa', padding: '10px', border: '1px solid #efefef' } },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12', style: { marginBottom: '10px' } },
                    this.props.children
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement('input', { className: 'form-control', value: this.state.value, onChange: this.changeInput, placeholder: 'Number of sessions' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                        'button',
                        { className: 'btn btn-dark btn-block', onClick: this.calculate },
                        'Estimate package'
                    )
                )
            );
        }
    }]);

    return EstimatePackageUsage;
}(_react2.default.Component);

exports.default = EstimatePackageUsage;

/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _BillingInformation = __webpack_require__(684);

var _BillingInformation2 = _interopRequireDefault(_BillingInformation);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

		_this.state = {
			'packages': [],
			'isLoading': true,
			'error': false
		};

		return _this;
	}

	_createClass(Settings, [{
		key: 'selectPackage',
		value: function selectPackage(package_id) {
			var _this2 = this;

			var current = this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.id : this.props.general.account.package.id;

			if (current == package_id) {
				this.props.router.push(_General2.default.Link('/settings/billing'));
			} else {
				this.setState({ 'isLoading': true });
				_axios2.default.put('/subscriptions/plan', { package_id: package_id }).then(function (res) {
					_this2.setState({ 'isLoading': false });
					_Notification2.default.success('Plan successfully changed.');
					_this2.props.router.push(_General2.default.Link('/settings/billing'));
				}).catch(function (err) {
					_this2.setState({ 'isLoading': false });
					_Notification2.default.error(err.response.data.error.message);
				});
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.router.push(_General2.default.Link('/settings/billing/subscribe'));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			var current = this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.id : this.props.general.account.package.id;

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-payment' }),
						' Subscribe'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						'div',
						{ className: 'pricing-table' },
						this.state.packages.map(function (p, i) {

							return _react2.default.createElement(
								'div',
								{ key: i, className: 'pricing-column-five ' + (current == p.id ? 'featured' : '') },
								_react2.default.createElement(
									'div',
									{ className: 'pricing-header' },
									_react2.default.createElement(
										'div',
										{ className: 'pricing-price' },
										_react2.default.createElement(
											'span',
											{ className: 'pricing-currency' },
											'$'
										),
										_react2.default.createElement(
											'span',
											{ className: 'pricing-amount' },
											p.price
										),
										_react2.default.createElement(
											'span',
											{ className: 'pricing-period' },
											'/ mo'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pricing-title' },
										p.name
									)
								),
								_react2.default.createElement(
									'ul',
									{ className: 'pricing-features' },
									p.data.map(function (data, i) {
										return _react2.default.createElement(
											'li',
											{ key: i },
											data.description
										);
									})
								),
								_react2.default.createElement(
									'div',
									{ className: 'pricing-footer' },
									_react2.default.createElement(
										'button',
										{ onClick: function onClick(e) {
												e.stopPropagation();_this3.selectPackage(p.id);
											}, className: 'btn btn-dark' },
										_react2.default.createElement('i', { className: 'icon wb-arrow-right font-size-16 m-r-15', 'aria-hidden': 'true' }),
										current == p.id ? _react2.default.createElement(
											'span',
											null,
											'Stay on same plan'
										) : _react2.default.createElement(
											'span',
											null,
											'Select plan'
										)
									)
								)
							);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-12 text-center m-t-20' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: _General2.default.Link('/settings/billing/cancel') },
								'Click here if you wish to cancel your account'
							)
						)
					)
				)
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Card = __webpack_require__(270);

var _Card2 = _interopRequireDefault(_Card);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

		_this.state = {
			'packages': [],
			'isLoading': true,
			'isWaiting': false,
			'error': false
		};

		_this.handleSubmit = _this.handleSubmit.bind(_this);

		return _this;
	}

	_createClass(Settings, [{
		key: 'handleSubmit',
		value: function handleSubmit(values) {
			var _this2 = this;

			this.props.setGlobalKey('showProcessing', true);
			Stripe.createToken({
				number: values.cardnumber,
				cvc: values.cvc,
				exp_month: values.month,
				exp_year: values.year
			}, function (status, response) {
				if (response.error) {
					_this2.props.setGlobalKey('showProcessing', false);

					_this2.setState({ error: response.error.message, 'isWaiting': false });
				} else {
					values.token = response['id'];
					values.package_id = _this2.state.package;

					_axios2.default.put('/subscriptions/card', values).then(function (res) {
						_this2.props.setGlobalKey('showProcessing', false);
						_Notification2.default.success('Credit card successfully changed');
						_this2.props.router.push(_General2.default.Link('/settings/billing'));
						_this2.setState({ error: '', 'isWaiting': false });
					}).catch(function (err) {
						_this2.props.setGlobalKey('showProcessing', false);
						_this2.setState({ error: '', 'isWaiting': false });
						_this2.setState({ error: err.response.data.error.message });
					});
				}
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-payment' }),
						' Subscribe'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(_Card2.default, { buttonText: 'Save card', errorMessage: this.state.error, isWaiting: this.state.isWaiting, onSubmit: this.handleSubmit })
				)
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setGlobalKey: _General3.setGlobalKey }, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _Card = __webpack_require__(270);

var _Card2 = _interopRequireDefault(_Card);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

		_this.state = {
			'isLoading': true,
			'accept_cancel': false,
			'isCancelling': false,
			'isResuming': false

		};

		_this.handleCancel = _this.handleCancel.bind(_this);
		_this.handleCancleClick = _this.handleCancleClick.bind(_this);

		return _this;
	}

	_createClass(Settings, [{
		key: 'handleResume',
		value: function handleResume() {
			var _this2 = this;

			this.setState({
				isResuming: true
			});
			_axios2.default.post('/subscriptions/resume').then(function (res) {
				_General2.default.fetchGeneral().then(function (res) {
					_this2.setState({
						isResuming: true
					});
				});
			});
		}
	}, {
		key: 'handleCancel',
		value: function handleCancel() {
			var _this3 = this;

			this.props.setGlobalKey('showProcessing', true);

			_axios2.default.post('/subscriptions/cancel').then(function (res) {
				_General2.default.fetchGeneral().then(function (res) {
					_this3.setState({
						accept_cancel: false
					});

					_Notification2.default.success('Your account is now canceled');
					_this3.props.setGlobalKey('showProcessing', false);
					_this3.props.router.push(_General2.default.Link('/settings/billing'));
				});
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (this.props.general.account.isOnGracePeriod) {
				this.props.router.push(_General2.default.Link('/settings/billing'));
			}
		}
	}, {
		key: 'handleCancleClick',
		value: function handleCancleClick(e) {
			this.setState({
				'accept_cancel': !this.state.accept_cancel
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-payment' }),
						' Cancel'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Cancel', description: 'Cancel your current subscription.' },
						this.props.general.account.grace_period ? _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								'Your subscription at crall will end at ',
								_react2.default.createElement(
									'strong',
									null,
									(0, _moment2.default)(this.props.general.account.grace_period).format('DD.MM.YYYY')
								),
								', and will not be billed after this date.'
							),
							this.state.isResuming ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
								'button',
								{ className: 'btn btn-success btn-block', onClick: function onClick(e) {
										e.stopPropagation();_this4.handleResume();
									} },
								'Resume subscription'
							)
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-12' },
								_react2.default.createElement(
									'div',
									{ className: 'checkbox-custom checkbox-primary' },
									_react2.default.createElement('input', { type: 'checkbox', onChange: this.handleCancleClick, value: this.state.accept_cancel }),
									_react2.default.createElement(
										'label',
										null,
										'Yes, i want to cancel my account.'
									)
								)
							),
							this.state.accept_cancel ? _react2.default.createElement(
								'div',
								{ className: 'col-sm-12' },
								this.state.isCancelling ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-danger btn-block', onClick: function onClick(e) {
												e.stopPropagation();_this4.handleCancel();
											} },
										'Cancel account'
									)
								)
							) : null
						)
					)
				)
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setGlobalKey: _General3.setGlobalKey }, dispatch);
};

Settings = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);
exports.default = Settings;

/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Card = __webpack_require__(270);

var _Card2 = _interopRequireDefault(_Card);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingDealer = function (_React$Component) {
    _inherits(BillingDealer, _React$Component);

    function BillingDealer(props) {
        _classCallCheck(this, BillingDealer);

        var _this = _possibleConstructorReturn(this, (BillingDealer.__proto__ || Object.getPrototypeOf(BillingDealer)).call(this, props));

        _this.getPlanStatus = function (plan) {
            if (plan.ends_at && plan.ends_at != '') {
                return 'Cancelled. Ends at: ' + plan.ends_at;
            }

            return 'Active';
        };

        return _this;
    }

    _createClass(BillingDealer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.props.general.account.dealer) {
                this.props.router.push(_General2.default.Link('/settings/billing/subscribe'));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.general.account.dealer) {
                return _react2.default.createElement('span', null);
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 offset-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-heading' },
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'panel-title' },
                                        'Dealer'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body' },
                                    this.props.general.account.expired == true ? _react2.default.createElement(
                                        'div',
                                        { role: 'alert', className: 'alert dark alert-danger alert-dismissible' },
                                        _react2.default.createElement(
                                            'h4',
                                            null,
                                            'Subscription expired'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Your subscription has expired. To continue using our service you need to subscribe.',
                                            _react2.default.createElement('br', null),
                                            'You must contact your dealer to subscribe.'
                                        )
                                    ) : null,
                                    'Your account is managed by ',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        this.props.general.account.dealer.name
                                    ),
                                    '. Please contact them regarding billing issues, support and other questions.',
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement(
                                        'h5',
                                        null,
                                        'Contact information'
                                    ),
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'E-mail:'
                                    ),
                                    ' ',
                                    this.props.general.account.dealer.email,
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Phone:'
                                    ),
                                    ' ',
                                    this.props.general.account.dealer.phone
                                )
                            )
                        )
                    ),
                    this.props.general.plans.length > 0 ? _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 offset-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-heading' },
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'panel-title' },
                                        'Your subscriptions'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        this.props.general.plans.map(function (plan) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: plan.plan.id },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        plan.details.name
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.getPlanStatus(plan.plan)
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return BillingDealer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setGlobalKey: _General3.setGlobalKey }, dispatch);
};

BillingDealer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingDealer);
exports.default = BillingDealer;

/***/ }),

/***/ 1701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Apps = function (_React$Component) {
	_inherits(Apps, _React$Component);

	function Apps(props) {
		_classCallCheck(this, Apps);

		return _possibleConstructorReturn(this, (Apps.__proto__ || Object.getPrototypeOf(Apps)).call(this, props));
	}

	_createClass(Apps, [{
		key: 'render',
		value: function render() {

			return this.props.children;
		}
	}]);

	return Apps;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Apps = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Apps);
exports.default = Apps;

/***/ }),

/***/ 1702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _AppItem = __webpack_require__(1703);

var _AppItem2 = _interopRequireDefault(_AppItem);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppBrowse = function (_React$Component) {
	_inherits(AppBrowse, _React$Component);

	function AppBrowse(props) {
		_classCallCheck(this, AppBrowse);

		var _this = _possibleConstructorReturn(this, (AppBrowse.__proto__ || Object.getPrototypeOf(AppBrowse)).call(this, props));

		_this.state = {
			'apps': [],
			'askDelete': false,
			'isLoading': true
		};

		_this.apps = [{
			title: 'Mailchimp',
			description: 'Synchronize campaign leads directly to mailchimp.',
			image: '/assets/images/apps/mailchimp.png',
			app: 'Mailchimp'
		}, {
			title: 'Mailmojo',
			description: 'Synchronize campaign leads directly to Mailmojo.',
			image: '/assets/images/apps/mailmojo.png',
			oauth: true,
			app: 'Mailmojo'
		}, {
			title: 'Mailerlite',
			description: 'Synchronize campaign leads directly to mailerlite.',
			image: '/assets/images/apps/mailerlite.png',
			app: 'Mailerlite'
		}, {
			title: 'Apsis',
			description: 'Synchronize campaign leads directly to apsis.',
			image: '/assets/images/apps/apsis.png',
			app: 'Apsis'
		}, {
			title: 'Trustpilot',
			description: 'Use Automatic feedback service in your order confirmations',
			image: '/assets/images/apps/trustpilot.png',
			app: 'Trustpilot'
		}, {
			title: 'Facebook ads',
			description: 'Synchronize segments to facebook audiences',
			image: '/assets/images/apps/facebook.png',
			oauth: true,
			hasOptions: true,
			app: 'FacebookAds'
		}];

		_this.isInstalled = _this.isInstalled.bind(_this);
		_this.app = _this.app.bind(_this);
		_this.uninstall = _this.uninstall.bind(_this);
		_this.askUninstall = _this.askUninstall.bind(_this);
		return _this;
	}

	_createClass(AppBrowse, [{
		key: 'askUninstall',
		value: function askUninstall(key) {
			this.setState({
				askDelete: key
			});
		}
	}, {
		key: 'uninstall',
		value: function uninstall(key) {
			var _this2 = this;

			this.setState({
				askDelete: false,
				isLoading: true
			});

			_axios2.default.post('/apps/' + key + '/uninstall').then(function (res) {
				_General2.default.fetchGeneral().then(function (res) {
					_this2.setState({
						isLoading: false
					});
				}).catch(function (err) {
					return _ravenJs2.default.captureException(err);
				});
			});
		}
	}, {
		key: 'isInstalled',
		value: function isInstalled(key) {
			for (var i in this.props.general.apps) {
				if (this.props.general.apps[i].key == key) {
					return true;
				}
			}

			return false;
		}
	}, {
		key: 'app',
		value: function app(item) {
			var _this3 = this;

			return _react2.default.createElement(_AppItem2.default, { key: item.app, item: item, uninstall: function uninstall(e) {
					e.stopPropagation();_this3.askUninstall(item.app);
				}, title: item.title, description: item.description, image: item.image, app: item.app, installed: this.isInstalled(item.app) });
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this4 = this;

			_General2.default.fetchGeneral().then(function (res) {
				_this4.setState({
					isLoading: false
				});
			}).catch(function (err) {
				return _ravenJs2.default.captureException(res);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Apps | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-extension' }),
						' Apps'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(
						_OptionColumn2.default,
						{ title: 'Available apps', description: 'Install / configure apps' },
						_react2.default.createElement(
							'ul',
							{ className: 'list-group list-group-full' },
							this.apps.map(function (item) {
								return _this5.app(item);
							})
						)
					)
				),
				_react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
						_this5.uninstall(e);
					}, onClose: function onClose() {
						_this5.setState({ askDelete: false });
					}, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to uninstall this app?' })
			);
		}
	}]);

	return AppBrowse;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

AppBrowse = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppBrowse);
exports.default = AppBrowse;

/***/ }),

/***/ 1703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _Button = __webpack_require__(592);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppItem = function AppItem(_ref) {
	var app = _ref.app,
	    image = _ref.image,
	    title = _ref.title,
	    item = _ref.item,
	    uninstall = _ref.uninstall,
	    description = _ref.description,
	    installed = _ref.installed;
	return _react2.default.createElement(
		'li',
		{ className: 'list-group-item' },
		_react2.default.createElement(
			'div',
			{ className: 'media' },
			_react2.default.createElement(
				'div',
				{ className: 'media-left', style: { verticalAlign: 'middle' } },
				_react2.default.createElement(
					'a',
					{ className: 'avatar', style: { width: '100px' }, href: 'javascript:void(0)' },
					_react2.default.createElement('img', { className: 'img-fluid', src: image, alt: '...', style: { borderRadius: 0 } })
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'media-body' },
				_react2.default.createElement(
					'h4',
					{ className: 'media-heading' },
					title,
					installed ? _react2.default.createElement(
						'span',
						{ style: { marginLeft: '10px', fontWeight: '100', fontSize: '12px', marginRight: '0px' } },
						_react2.default.createElement('i', { className: 'icon fa-check-circle-o', style: { color: '#52C643' }, 'aria-hidden': 'true' }),
						' Installed'
					) : null
				),
				_react2.default.createElement(
					'small',
					null,
					description
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'media-right', style: { textAlign: 'right', width: '20%' } },
				installed ? _react2.default.createElement(
					'div',
					{ className: 'btn-group', role: 'group' },
					_react2.default.createElement(
						'button',
						{ onClick: uninstall, type: 'button', className: 'btn btn-icon btn-dark' },
						_react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
					),
					item.oauth === true && item.hasOptions !== true ? null : _react2.default.createElement(
						_reactRouter.Link,
						{ to: _General2.default.Link('/apps/' + app), className: 'btn btn-icon btn-dark' },
						_react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
					)
				) : null,
				!installed ? item.oauth === true ? _react2.default.createElement(
					'button',
					{ onClick: function onClick() {
							_General2.default.requestAccessToken('/apps/' + app + '/RedirectOauth');
						}, className: 'btn btn-dark' },
					'Get started'
				) : _react2.default.createElement(
					_reactRouter.Link,
					{ to: _General2.default.Link('/apps/' + app), className: 'btn btn-dark' },
					'Get started'
				) : null
			)
		)
	);
};

exports.default = AppItem;

/***/ }),

/***/ 1704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Basic = __webpack_require__(1705);

var _Basic2 = _interopRequireDefault(_Basic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var apps = {
	Basic: _Basic2.default
};

var AppIndex = function (_React$Component) {
	_inherits(AppIndex, _React$Component);

	function AppIndex(props) {
		_classCallCheck(this, AppIndex);

		var _this = _possibleConstructorReturn(this, (AppIndex.__proto__ || Object.getPrototypeOf(AppIndex)).call(this, props));

		_this.state = {
			app: {},
			isLoading: true
		};
		_this.setApp = _this.setApp.bind(_this);
		return _this;
	}

	_createClass(AppIndex, [{
		key: 'setApp',
		value: function setApp(app) {
			this.setState({ app: app, isLoading: false });
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			_axios2.default.get('/apps/' + this.props.router.params.app).then(function (res) {
				_this2.setApp(res.data);
			});
		}
	}, {
		key: 'render',
		value: function render() {

			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: false });
			}
			var comp = this.state.app.template ? this.state.app.template : this.props.router.params.app;
			var AppComponent = apps[comp];

			return _react2.default.createElement(
				'div',
				{ className: 'full-height' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Apps | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'page-header' },
					_react2.default.createElement(
						'span',
						{ className: 'page-title' },
						_react2.default.createElement('i', { className: 'icon wb-extension' }),
						' Apps'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'page-content' },
					_react2.default.createElement(AppComponent, { setApp: this.setApp, app: this.state.app })
				)
			);
		}
	}]);

	return AppIndex;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

AppIndex = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppIndex);
exports.default = AppIndex;

/***/ }),

/***/ 1705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AppWrapper = __webpack_require__(1706);

var _AppWrapper2 = _interopRequireDefault(_AppWrapper);

var _ApiKey = __webpack_require__(1707);

var _ApiKey2 = _interopRequireDefault(_ApiKey);

var _TrustPilot = __webpack_require__(1708);

var _TrustPilot2 = _interopRequireDefault(_TrustPilot);

var _FacebookAds = __webpack_require__(1709);

var _FacebookAds2 = _interopRequireDefault(_FacebookAds);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var apps = {
	ApiKey: _ApiKey2.default,
	TrustPilot: _TrustPilot2.default,
	FacebookAds: _FacebookAds2.default
};

var Basic = function (_React$Component) {
	_inherits(Basic, _React$Component);

	function Basic(props) {
		_classCallCheck(this, Basic);

		var _this = _possibleConstructorReturn(this, (Basic.__proto__ || Object.getPrototypeOf(Basic)).call(this, props));

		_this.state = {
			isWaiting: false,
			error: false
		};

		_this.handleInstall = _this.handleInstall.bind(_this);
		_this.handleSubmit = _this.handleSubmit.bind(_this);
		_this.handleUpdate = _this.handleUpdate.bind(_this);
		return _this;
	}

	_createClass(Basic, [{
		key: 'handleSubmit',
		value: function handleSubmit(values) {
			if (this.props.app.installed) {
				this.handleUpdate(values);
			} else {
				this.handleInstall(values);
			}
		}
	}, {
		key: 'handleUpdate',
		value: function handleUpdate(values) {
			var _this2 = this;

			this.setState({ isWaiting: true });
			_axios2.default.put('/apps/' + this.props.app.key, values).then(function (res) {
				_Notification2.default.success('Success!');
				_reactRouter.hashHistory.push(_General2.default.Link('/apps'));
			}).catch(function (err) {
				_this2.setState({ isWaiting: false, 'error': err.response.data.error.message });
			});
		}
	}, {
		key: 'handleInstall',
		value: function handleInstall(values) {
			var _this3 = this;

			this.setState({ isWaiting: true });
			_axios2.default.post('/apps/' + this.props.app.key, values).then(function (res) {
				_Notification2.default.success('Success!');
				_reactRouter.hashHistory.push(_General2.default.Link('/apps'));
			}).catch(function (err) {
				_this3.setState({ isWaiting: false, 'error': err.response.data.error.message });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var FormComponent = apps[this.props.app.form];

			return _react2.default.createElement(
				_AppWrapper2.default,
				{ title: this.props.app.title, image: this.props.app.image },
				_react2.default.createElement(FormComponent, { err: this.state.error, initialValues: this.props.app.installed ? this.props.app.config : {}, app: this.props.app, isWaiting: this.state.isWaiting, onSubmit: this.handleSubmit })
			);
		}
	}]);

	return Basic;
}(_react2.default.Component);

exports.default = Basic;

/***/ }),

/***/ 1706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppWrapper = function AppWrapper(_ref) {
    var image = _ref.image,
        title = _ref.title,
        children = _ref.children;
    return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
            "div",
            { className: "col-sm-8 offset-sm-2" },
            _react2.default.createElement(
                "div",
                { className: "panel", style: { border: "1px solid #e4eaec" } },
                _react2.default.createElement(
                    "div",
                    { className: "panel-heading" },
                    _react2.default.createElement(
                        "h3",
                        { style: { padding: 0, paddingTop: '20px' }, className: "panel-title text-center" },
                        _react2.default.createElement("img", { style: { maxHeight: '80px', maxWidth: '40%' }, src: image })
                    ),
                    _react2.default.createElement("hr", { style: { width: '90%' } })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "panel-body" },
                    _react2.default.createElement(
                        "div",
                        { className: "offset-sm-2 col-sm-8" },
                        children
                    )
                )
            )
        )
    );
};

exports.default = AppWrapper;

/***/ }),

/***/ 1707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.API_KEY) {
        errors.API_KEY = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var ApiKey = function (_React$Component) {
    _inherits(ApiKey, _React$Component);

    function ApiKey() {
        _classCallCheck(this, ApiKey);

        return _possibleConstructorReturn(this, (ApiKey.__proto__ || Object.getPrototypeOf(ApiKey)).apply(this, arguments));
    }

    _createClass(ApiKey, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                this.props.err ? _react2.default.createElement(
                    'div',
                    { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                    _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                    this.props.err
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'API_KEY', placeholder: '', title: 'Api key', className: 'form-control' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            this.props.app.installed ? 'Update' : 'Install'
                        )
                    )
                )
            );
        }
    }]);

    return ApiKey;
}(_react2.default.Component);

// Decorate the form component


ApiKey = (0, _reduxForm.reduxForm)({
    form: 'ApiKey',
    validate: validate
})(ApiKey);

ApiKey = (0, _reactRedux.connect)(function (state) {
    return {};
})(ApiKey);

exports.default = ApiKey;

/***/ }),

/***/ 1708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _dropdown = __webpack_require__(685);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.BCC) {
        errors.BCC = 'Required';
    }

    if (!values.REVIEW_TYPE) {
        errors.REVIEW_TYPE = 'Required';
    }

    if (values.REVIEW_TYPE == '' || values.REVIEW_TYPE == '0') {
        errors.REVIEW_TYPE = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var TrustPilot = function (_React$Component) {
    _inherits(TrustPilot, _React$Component);

    function TrustPilot() {
        _classCallCheck(this, TrustPilot);

        return _possibleConstructorReturn(this, (TrustPilot.__proto__ || Object.getPrototypeOf(TrustPilot)).apply(this, arguments));
    }

    _createClass(TrustPilot, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                this.props.err ? _react2.default.createElement(
                    'div',
                    { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                    _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                    this.props.err
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'BCC', placeholder: '', title: 'Trustpilot BCC e-mail', className: 'form-control' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: _dropdown2.default, placeholder: 'Select invitation type', name: 'REVIEW_TYPE',
                            initialValue: 'PRODUCT',
                            options: [{
                                label: 'Product invitation',
                                value: 'PRODUCT'
                            }, {
                                label: 'Service invitation',
                                value: 'SERVICE'
                            }], title: 'Invitation type' }),
                        this.props.REVIEW_TYPE == 'PRODUCT' ? _react2.default.createElement(
                            'div',
                            { className: 'alert alert-primary', role: 'alert' },
                            _react2.default.createElement(
                                'strong',
                                null,
                                'Important'
                            ),
                            ': Product invitations is only available on Trustpilot ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'PRO'
                            ),
                            ' and ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'Enterprise'
                            ),
                            ' plans. The ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'free'
                            ),
                            ' and ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'lite'
                            ),
                            ' plan only supports Service invitations.'
                        ) : null
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            this.props.app.installed ? 'Update' : 'Install'
                        )
                    )
                )
            );
        }
    }]);

    return TrustPilot;
}(_react2.default.Component);

var selector = (0, _reduxForm.formValueSelector)('TrustPilot');

// Decorate the form component
TrustPilot = (0, _reduxForm.reduxForm)({
    form: 'TrustPilot',
    validate: validate
})(TrustPilot);

TrustPilot = (0, _reactRedux.connect)(function (state) {
    return {
        REVIEW_TYPE: selector(state, 'REVIEW_TYPE')
    };
})(TrustPilot);

exports.default = TrustPilot;

/***/ }),

/***/ 1709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.AD_ACCOUNT || values.AD_ACCOUNT == '') {
        errors.AD_ACCOUNT = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var dropdownField = function dropdownField(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(_reactSelect2.default, {
            value: input.value,
            onChange: input.onChange,
            onBlur: function onBlur() {
                return input.onBlur(input.value);
            },
            options: options,
            placeholder: placeholder,
            simpleValue: true
        }),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var dropdownFieldd = function dropdownFieldd(_ref3) {
    var name = _ref3.name,
        className = _ref3.className,
        title = _ref3.title,
        options = _ref3.options,
        initialValue = _ref3.initialValue,
        _ref3$meta = _ref3.meta,
        touched = _ref3$meta.touched,
        error = _ref3$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control' },
            initialValue ? _react2.default.createElement(
                'option',
                { value: '' },
                initialValue
            ) : null,
            options.map(function (item) {
                return _react2.default.createElement(
                    'option',
                    { key: item.value, value: item.value },
                    item.name
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var FacebookAds = function (_React$Component) {
    _inherits(FacebookAds, _React$Component);

    function FacebookAds(props) {
        _classCallCheck(this, FacebookAds);

        var _this = _possibleConstructorReturn(this, (FacebookAds.__proto__ || Object.getPrototypeOf(FacebookAds)).call(this, props));

        _this.state = {
            accounts: [],
            isLoading: true
        };

        _this.generateAdAccountsList = _this.generateAdAccountsList.bind(_this);
        return _this;
    }

    _createClass(FacebookAds, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/apps/FacebookAds/adAccounts').then(function (res) {
                _this2.setState({ accounts: res.data, isLoading: false });
            });
        }
    }, {
        key: 'generateAdAccountsList',
        value: function generateAdAccountsList() {
            var list = [];

            this.state.accounts.map(function (item) {
                list.push({
                    'label': item.name + ' - ' + item.id.replace('act_', ''),
                    'value': item.id
                });
            });

            return list;
        }
    }, {
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;


            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                this.props.err ? _react2.default.createElement(
                    'div',
                    { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                    _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                    this.props.err
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: dropdownField, placeholder: 'Select ad account', name: 'AD_ACCOUNT',
                            initialValue: 'Select ad account',
                            options: this.generateAdAccountsList(), title: 'Facebook Ad account' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            this.props.app.installed ? 'Update' : 'Install'
                        )
                    )
                )
            );
        }
    }]);

    return FacebookAds;
}(_react2.default.Component);

// Decorate the form component


FacebookAds = (0, _reduxForm.reduxForm)({
    form: 'FacebookAds',
    validate: validate
})(FacebookAds);

FacebookAds = (0, _reactRedux.connect)(function (state) {
    return {};
})(FacebookAds);

exports.default = FacebookAds;

/***/ }),

/***/ 1710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _reactDates = __webpack_require__(205);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Analytics = function (_React$Component) {
    _inherits(Analytics, _React$Component);

    function Analytics(props) {
        _classCallCheck(this, Analytics);

        var _this = _possibleConstructorReturn(this, (Analytics.__proto__ || Object.getPrototypeOf(Analytics)).call(this, props));

        _this.state = {
            isLoading: true,
            data: [],
            startDateId: '1',
            stopDateId: '2',
            initialStart: (0, _moment2.default)((0, _moment2.default)().subtract(7, 'days')),
            initialEnd: (0, _moment2.default)(),
            startDate: (0, _moment2.default)((0, _moment2.default)().subtract(7, 'days')),
            endDate: (0, _moment2.default)(),
            focusedInput: null,
            askUpgrade: false
        };

        _this.onDatesChange = _this.onDatesChange.bind(_this);
        _this.onFocusChange = _this.onFocusChange.bind(_this);
        _this.daterange = _this.daterange.bind(_this);

        return _this;
    }

    _createClass(Analytics, [{
        key: 'daterange',
        value: function daterange() {
            return _react2.default.createElement(
                'span',
                null,
                'between ',
                _react2.default.createElement(
                    'span',
                    { style: { fontWeight: 'bold' } },
                    (0, _moment2.default)(this.state.startDate).format('MM/DD/YYYY')
                ),
                ' and ',
                _react2.default.createElement(
                    'span',
                    { style: { fontWeight: 'bold' } },
                    (0, _moment2.default)(this.state.endDate).format('MM/DD/YYYY')
                )
            );
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.get();
        }
    }, {
        key: 'get',
        value: function get() {
            var _this2 = this;

            var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!from) {
                from = this.state.startDate;
            }
            if (!to) {
                to = this.state.endDate;
            }
            this.setState({
                'isLoading': true
            });

            if (!to || !from) {
                this.setState({
                    startDate: this.state.initialEnd,
                    endDate: this.state.initialStart
                });

                _Notification2.default.error('Error: Invalid date, resetting to last month.');
                to = this.state.initialEnd;
                from = this.state.initialStart;
            }

            _axios2.default.get('/insights', {
                params: {
                    'from': (0, _moment2.default)(from).format('YYYY-MM-DD'),
                    'to': (0, _moment2.default)(to).format('YYYY-MM-DD')
                }
            }).then(function (res) {
                _this2.setState({
                    'isLoading': false,
                    'data': res.data
                });
            });
        }
    }, {
        key: 'onDatesChange',
        value: function onDatesChange(_ref) {
            var startDate = _ref.startDate,
                endDate = _ref.endDate;

            if (this.props.general.settings.PACKAGE_INSIGHTS != '1') {
                this.setState({ askUpgrade: true });
            } else {
                this.setState({ startDate: startDate, endDate: endDate });
                this.get(startDate, endDate);
            }
        }
    }, {
        key: 'onFocusChange',
        value: function onFocusChange(focusedInput) {
            this.setState({ focusedInput: focusedInput });
        }
    }, {
        key: 'render',
        value: function render() {
            var _React$createElement,
                _this3 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-graph-up' }),
                        ' Insights'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'pull-right' },
                        _react2.default.createElement(_reactDates.DateRangePicker, (_React$createElement = {
                            startDateId: this.state.startDateId,
                            endDateId: this.state.stopDateId,
                            onDatesChange: this.onDatesChange,
                            onFocusChange: this.onFocusChange
                        }, _defineProperty(_React$createElement, 'startDateId', 'start_date'), _defineProperty(_React$createElement, 'endDateId', 'end_date'), _defineProperty(_React$createElement, 'small', true), _defineProperty(_React$createElement, 'focusedInput', this.state.focusedInput), _defineProperty(_React$createElement, 'startDate', this.state.startDate), _defineProperty(_React$createElement, 'endDate', this.state.endDate), _defineProperty(_React$createElement, 'isOutsideRange', function isOutsideRange() {
                            return false;
                        }), _defineProperty(_React$createElement, 'anchorDirection', 'left'), _defineProperty(_React$createElement, 'showDefaultInputIcon', true), _React$createElement))
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Insights | Crall.io' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-graph-up', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            this.state.data.average_order_sum
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Average order sum'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-graph-up', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            this.state.data.revenue
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Revenue'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-graph-up', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            this.state.data.orders
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Orders'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Most visited product ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Name'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Views'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.most_viewed_product.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.c
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Most visited category ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Name'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Views'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.most_viewed_category.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.c
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Most valuable customer ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Name'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Sum'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.valuable_customer.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.c
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Most sold product ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Name'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Sold'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.most_sold.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.c
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Most busy hours in period ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Time'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Orders'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.busy.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.at
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.c
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Best revenue source ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Source'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Sum'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.referrer.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.referrer
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.sum
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-shadow p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-header card-header-transparent card-header-bordered' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-sm btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-graph-up' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'm-l-15 font-weight-400' },
                                        'Top 10 revenue by category ',
                                        this.daterange()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-block p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    '#'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Category'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Revenue'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.data.most_sold_category.map(function (i, num) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    { key: num },
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        num + 1
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        i.formatted
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(_AskUpgrade2.default, { onAccept: function onAccept(e) {
                            _this3.setState({ askUpgrade: false });_this3.props.router.push(_General2.default.Link('/settings/billing/plan'));
                        }, onClose: function onClose() {
                            _this3.setState({ askUpgrade: false });
                        }, param: this.state.askUpgrade, title: 'Upgrade required', body: 'To use this feature you must upgrade to Standard Plus' })
                )
            );
        }
    }]);

    return Analytics;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Analytics = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Analytics);
exports.default = Analytics;

/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Spin2Win = __webpack_require__(252);

var _Spin2Win2 = _interopRequireDefault(_Spin2Win);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _Step = __webpack_require__(1712);

var _Step2 = _interopRequireDefault(_Step);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Mystore = __webpack_require__(1713);

var _Mystore2 = _interopRequireDefault(_Mystore);

var _CartReminder = __webpack_require__(1714);

var _CartReminder2 = _interopRequireDefault(_CartReminder);

var _Popup = __webpack_require__(1715);

var _Popup2 = _interopRequireDefault(_Popup);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Setup = function (_React$Component) {
	_inherits(Setup, _React$Component);

	function Setup(props) {
		_classCallCheck(this, Setup);

		var _this = _possibleConstructorReturn(this, (Setup.__proto__ || Object.getPrototypeOf(Setup)).call(this, props));

		_this.language = {};
		_this.language['norwegian'] = {
			step: 'Steg',
			custom_selected: 'Vi ønsker å bygge støtte for flere platformer. Ta kontakt med oss på hi@crall.io for å se på muligheten for å bygge støtte for akkurat din platform.',
			none_of_them: 'Ingen av dem',
			of: 'av',
			name: 'Navn',
			platform: 'Velg leverandør',
			name_is_required: 'Du må oppgi navnet ditt.',
			step1_title: 'Navn',
			step1_description: 'Hva er navnet ditt? Dette vil være synlig for dine kollegaer.',
			step2_title: 'Leverandør',
			step2_description: 'Hvordan platform eller leverandør av nettbutikk bruker du ?',
			start: 'Til kontrollpanelet',
			step0_description: 'Hvilket språk ønsker du at veiviseren skal være på?',
			language: 'Språk',
			company_name: 'Firmanavn',
			company_is_required: 'Vi trenger firmanavnet for å komme oss videre.',
			ask_for_company_description: 'Hva er navnet på firmaet ditt?',
			select_country: 'Land',
			ask_country_description: 'Velg landet hvor bedriften din er registrert. Dette er viktig i forhold til moms.'

		};

		_this.language['english'] = {
			step: 'Step',
			custom_selected: 'Vi ønsker å bygge støtte for flere platformer. Ta kontakt med oss på hi@crall.io for å se på muligheten for å bygge støtte for akkurat din platform.',
			none_of_them: 'None of them',
			of: 'of',
			name: 'Name',
			platform: 'Select platform',
			name_is_required: 'We need your name.',
			step1_title: 'Name',
			step1_description: 'What is your name? This will be visible for other team members.',
			step2_title: 'Platform',
			step2_description: 'Which platform is your shop using?',
			start: 'Go to dashboard',
			step0_description: 'What language do you want in the configuration wizard?',
			language: 'Language',
			company_name: 'Copmany name',
			company_is_required: 'We need your company name.',
			ask_for_company_description: 'What is the name of your company?',
			select_country: 'Country',
			ask_country_description: 'Select the country where your company is registered. This is important because of VAT calculation.'
		};

		_this.steps = ['step0', 'ask_for_country', 'step1', 'ask_for_company_name', 'step2', 'step3', 'step4', 'step5', 'step6'];

		_this.state = {
			isLoading: false,
			isError: false,
			error: false,
			info: false,
			language: 'norwegian',
			step: 0,
			company_name: '',
			name: '',
			platform: 'Mystore',
			country: 'Norway'
		};
		_this.getLanguage = _this.getLanguage.bind(_this);
		_this.handleChangeLangauge = _this.handleChangeLangauge.bind(_this);
		_this.renderStep = _this.renderStep.bind(_this);
		_this.handleLanguageSelect = _this.handleLanguageSelect.bind(_this);
		_this.handleInputChange = _this.handleInputChange.bind(_this);
		_this.handleNextStep = _this.handleNextStep.bind(_this);
		_this.mystoreComplete = _this.mystoreComplete.bind(_this);
		_this.finish = _this.finish.bind(_this);
		_this.handleButtonDown = _this.handleButtonDown.bind(_this);
		_this.dashboard = _this.dashboard.bind(_this);

		return _this;
	}

	_createClass(Setup, [{
		key: 'dashboard',
		value: function dashboard() {
			location.reload();
		}
	}, {
		key: 'mystoreComplete',
		value: function mystoreComplete() {
			this.handleNextStep();
		}
	}, {
		key: 'handleNextStep',
		value: function handleNextStep() {
			if (this.validate()) {
				this.setState({ 'error': false, 'step': this.state.step + 1 });
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var status = true;

			if (!this.steps[this.state.step]) {
				return status;
			}

			switch (this.steps[this.state.step]) {
				case 'step1':
					if (this.state.name.length <= 2) {
						status = false;
					}
					this.setState({ error: this.getLanguage('name_is_required') });
					break;

				case 'ask_for_company_name':
					if (this.state.company_name.length <= 2) {
						status = false;
					}
					this.setState({ error: this.getLanguage('company_is_required') });
					break;
			}

			return status;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (this.props.general.settings.ONBOARDING == '1') {
				this.props.router.push(_General2.default.Link('/dashboard'));
				return;
			}
			this.addBodyClass(true);
		}
	}, {
		key: 'handleLanguageSelect',
		value: function handleLanguageSelect(e) {
			this.setState({ 'step': 1 });
		}
	}, {
		key: 'getLanguage',
		value: function getLanguage(str) {
			return this.language[this.state.language][str];
		}
	}, {
		key: 'finish',
		value: function finish() {
			var _this2 = this;

			this.setState({ isLoading: true });
			var data = {
				name: this.state.name,
				language: this.state.language,
				company_name: this.state.company_name,
				country: this.state.country
			};
			_axios2.default.post('/ajax/setup_complete', data).then(function (res) {
				_this2.setState({ isLoading: false });
			});
			this.handleNextStep();
		}
	}, {
		key: 'handleButtonDown',
		value: function handleButtonDown(e) {
			if (e.key == 'Enter') {
				this.handleNextStep();
			}
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(e) {
			if (e.target.getAttribute('data-id') == 'platform') {
				if (e.target.value == 'Custom') {
					this.setState({ info: this.getLanguage('custom_selected') });
				} else {
					this.setState({ info: false });
				}
			}
			this.setState(_defineProperty({}, e.target.getAttribute('data-id'), e.target.value));
		}
	}, {
		key: 'step0',
		value: function step0() {
			return _react2.default.createElement(
				_Step2.default,
				{ info: this.state.info, language: this.state.language, title: this.getLanguage('language'), handleContinue: this.handleLanguageSelect, description: this.getLanguage('step0_description') },
				_react2.default.createElement(
					'div',
					{ className: 'form-group col-sm-12' },
					_react2.default.createElement(
						'label',
						{ className: 'form-control-label' },
						'Select language'
					),
					_react2.default.createElement(
						'select',
						{ className: 'form-control form-control-lg', value: this.state.language, onChange: this.handleChangeLangauge },
						_react2.default.createElement(
							'option',
							{ value: 'norwegian' },
							'Norsk'
						),
						_react2.default.createElement(
							'option',
							{ value: 'english' },
							'English'
						)
					)
				)
			);
		}
	}, {
		key: 'ask_for_country',
		value: function ask_for_country() {
			return _react2.default.createElement(
				_Step2.default,
				{ info: this.state.info, language: this.state.language, title: this.getLanguage('select_country'), error: this.state.error, handleContinue: this.handleNextStep, description: this.getLanguage('ask_country_description') },
				_react2.default.createElement(
					'div',
					{ className: 'form-group col-sm-12' },
					_react2.default.createElement(
						'label',
						{ className: 'form-control-label' },
						this.getLanguage('select_country')
					),
					_react2.default.createElement(
						'select',
						{ className: 'form-control form-control-lg', value: this.state.country, onChange: this.handleChangeCountry },
						_General4.default.countries().map(function (country, i) {
							return _react2.default.createElement(
								'option',
								{ key: i, value: country },
								country
							);
						})
					)
				)
			);
		}
	}, {
		key: 'step1',
		value: function step1() {
			return _react2.default.createElement(
				_Step2.default,
				{ info: this.state.info, language: this.state.language, title: this.getLanguage('step1_title'), error: this.state.error, handleContinue: this.handleNextStep, description: this.getLanguage('step1_description') },
				_react2.default.createElement(
					'div',
					{ className: 'form-group col-sm-12' },
					_react2.default.createElement(
						'label',
						{ className: 'form-control-label' },
						this.getLanguage('name')
					),
					_react2.default.createElement('input', { type: 'text', 'data-id': 'name', onKeyDown: this.handleButtonDown, className: 'form-control form-control-lg', value: this.state.name, onChange: this.handleInputChange })
				)
			);
		}
	}, {
		key: 'ask_for_company_name',
		value: function ask_for_company_name() {
			return _react2.default.createElement(
				_Step2.default,
				{ info: this.state.info, language: this.state.language, title: this.getLanguage('company_name'), error: this.state.error, handleContinue: this.handleNextStep, description: this.getLanguage('ask_for_company_description') },
				_react2.default.createElement(
					'div',
					{ className: 'form-group col-sm-12' },
					_react2.default.createElement(
						'label',
						{ className: 'form-control-label' },
						this.getLanguage('company_name')
					),
					_react2.default.createElement('input', { type: 'text', 'data-id': 'company_name', onKeyDown: this.handleButtonDown, className: 'form-control form-control-lg', value: this.state.company_name, onChange: this.handleInputChange })
				)
			);
		}
	}, {
		key: 'step2',
		value: function step2() {
			return _react2.default.createElement(
				_Step2.default,
				{ info: this.state.info, language: this.state.language, title: this.getLanguage('step2_title'), error: this.state.error, handleContinue: this.handleNextStep, description: this.getLanguage('step2_description') },
				_react2.default.createElement(
					'div',
					{ className: 'form-group col-sm-12' },
					_react2.default.createElement(
						'label',
						{ className: 'form-control-label' },
						this.getLanguage('platform')
					),
					_react2.default.createElement(
						'select',
						{ className: 'form-control form-control-lg', 'data-id': 'platform', value: this.state.platform, onChange: this.handleInputChange },
						_react2.default.createElement(
							'option',
							{ value: 'Mystore' },
							'Mystore.no'
						),
						_react2.default.createElement(
							'option',
							{ value: 'Custom' },
							this.getLanguage('none_of_them')
						)
					)
				)
			);
		}
	}, {
		key: 'step3',
		value: function step3() {
			var platform = null;

			switch (this.state.platform) {
				case 'Mystore':
					platform = _react2.default.createElement(_Mystore2.default, { handleComplete: this.mystoreComplete, language: this.state.language, handleSubmit: this.submitPlatform });
					break;
			}

			return platform;
		}
	}, {
		key: 'step4',
		value: function step4() {
			return _react2.default.createElement(_CartReminder2.default, { handleComplete: this.handleNextStep, language: this.state.language });
		}
	}, {
		key: 'step5',
		value: function step5() {
			return _react2.default.createElement(_Popup2.default, { handleComplete: this.finish, language: this.state.language });
		}
	}, {
		key: 'step6',
		value: function step6() {
			return _react2.default.createElement(
				'div',
				{ className: 'col-sm-12' },
				_react2.default.createElement(
					'div',
					{ className: 'checkmark' },
					_react2.default.createElement(
						'svg',
						{ id: 'Layer_1', x: '0px', y: '0px', viewBox: '0 0 161.2 161.2', enableBackground: 'new 0 0 161.2 161.2' },
						_react2.default.createElement('path', { className: 'path', fill: 'none', stroke: '#526069', strokeMiterlimit: '10', d: 'M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z' }),
						_react2.default.createElement('circle', { className: 'path', fill: 'none', stroke: '#526069', strokeWidth: '4', strokeMiterlimit: '10', cx: '80.6', cy: '80.6', r: '62.1' }),
						_react2.default.createElement('polyline', { className: 'path', fill: 'none', stroke: '#526069', strokeWidth: '6', strokeLinecap: 'round', strokeMiterlimit: '10', points: '113,52.8 74.1,108.4 48.2,86.4 ' })
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12 m-t-20 m-b-20' },
					_react2.default.createElement(
						'button',
						{ onClick: this.dashboard, className: 'btn btn-lg btn-block btn-success' },
						this.getLanguage('start'),
						' ',
						_react2.default.createElement('i', { className: 'icon wb-arrow-right' })
					)
				)
			);
		}
	}, {
		key: 'renderStep',
		value: function renderStep() {
			return this[this.steps[this.state.step]]();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.addBodyClass(false);
		}
	}, {
		key: 'handleChangeLangauge',
		value: function handleChangeLangauge(e) {
			this.setState({ language: e.target.value });
		}
	}, {
		key: 'handleChangeCountry',
		value: function handleChangeCountry(e) {
			this.setState({ country: e.target.value });
		}
	}, {
		key: 'addBodyClass',
		value: function addBodyClass(add) {
			if (add) {
				document.body.classList.add('layout-full');
			} else {
				document.body.classList.remove('layout-full');
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.isLoading) {
				return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
			}

			return _react2.default.createElement(
				'div',
				{ className: 'height-100', id: 'setup' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'Setup | Crall.io' }),
				_react2.default.createElement(
					'div',
					{ className: 'logo' },
					_react2.default.createElement('img', { src: '/assets/images/logo.png', style: { width: '130px', marginLeft: '20px' } })
				),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'm-t-40 offset-sm-4 col-sm-4' },
						this.renderStep(),
						this.state.step > 0 ? _react2.default.createElement(
							'div',
							{ className: 'col-sm-12 m-t-10 font-size-10 text-center' },
							_react2.default.createElement(
								'span',
								null,
								this.getLanguage('step'),
								' ',
								this.state.step,
								' ',
								this.getLanguage('of'),
								' ',
								this.steps.length - 1
							)
						) : null
					)
				)
			);
		}
	}]);

	return Setup;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		auth: state.auth,
		general: state.general
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({}, dispatch);
};

Setup = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Setup);
exports.default = Setup;

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var l = {};

l['norwegian'] = {
    continue: 'Fortsett'
};

l['english'] = {
    continue: 'Continue'
};

var NoResult = function NoResult(_ref) {
    var info = _ref.info,
        language = _ref.language,
        title = _ref.title,
        description = _ref.description,
        children = _ref.children,
        handleContinue = _ref.handleContinue,
        error = _ref.error;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h1',
            null,
            title
        ),
        _react2.default.createElement(
            'span',
            { className: 'description' },
            description
        ),
        error ? _react2.default.createElement(
            'div',
            { className: 'm-t-10 m-b-10' },
            _react2.default.createElement(
                'div',
                { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                ' ',
                error
            )
        ) : null,
        info ? _react2.default.createElement(
            'div',
            { className: 'm-t-10 m-b-10' },
            _react2.default.createElement(
                'div',
                { className: 'alert dark alert-icon alert-warning alert-dismissible', role: 'alert' },
                _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                ' ',
                info
            )
        ) : null,
        _react2.default.createElement(
            'div',
            { className: 'm-t-20' },
            children
        ),
        _react2.default.createElement(
            'div',
            { className: 'm-t-20 col-sm-12 text-center' },
            _react2.default.createElement(
                'button',
                { className: 'btn btn-dark btn-lg', onClick: handleContinue },
                l[language].continue,
                ' ',
                _react2.default.createElement('i', { className: 'icon wb-arrow-right' })
            )
        )
    );
};

exports.default = NoResult;

/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mystore = function (_React$Component) {
    _inherits(Mystore, _React$Component);

    function Mystore(props) {
        _classCallCheck(this, Mystore);

        var _this = _possibleConstructorReturn(this, (Mystore.__proto__ || Object.getPrototypeOf(Mystore)).call(this, props));

        _this.language = {};
        _this.language['norwegian'] = {
            address: 'Adresse',
            step1_title: "Web adresse",
            step1_description: "Hva er adressen til nettbutikken din?",
            continue: 'Fortsett',
            step2_title: "Pin-kode",
            step2_description_1: "Det er sendt en PIN-kode til ",
            step2_description_2: "Hent koden og skriv den inn koden i feltet under.",
            validate_pin: 'Verifiser PIN-kode',
            get_pin: 'Hent PIN-kode'
        };

        _this.language['english'] = {
            address: 'Url',
            step1_title: "URL",
            step1_description: "What is the url for your shop?",
            continue: 'Continue',
            step2_title: "Pin-code",
            step2_description_1: "We sent a PIN-code to ",
            step2_description_2: "Get your PIN-code and type it in the field below.",
            validate_pin: 'Verify PIN-code',
            get_pin: 'Get PIN-code'
        };

        _this.state = {
            error: false,
            info: false,
            isLoading: false,
            step: 1,
            email: '',
            url: '',
            pin: ''
        };

        _this.getPin = _this.getPin.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.step1 = _this.step1.bind(_this);
        _this.step2 = _this.step2.bind(_this);
        _this.checkPin = _this.checkPin.bind(_this);
        return _this;
    }

    _createClass(Mystore, [{
        key: 'checkPin',
        value: function checkPin() {
            var _this2 = this;

            this.setState({ 'isLoading': true });
            _axios2.default.post('/ajax/Mystore_check_pin', { url: this.state.url, 'pin': this.state.pin }).then(function (res) {
                _this2.props.handleComplete();
            }).catch(function (err) {

                _this2.setState({ 'error': err.response.data.error.message, isLoading: false });
            });
        }
    }, {
        key: 'step1',
        value: function step1() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    null,
                    this.getLanguage('step1_title')
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'description' },
                    this.getLanguage('step1_description')
                ),
                this.state.error ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-10 m-b-10' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.error
                    )
                ) : null,
                this.state.info ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-10 m-b-10' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-warning alert-dismissible', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.info
                    )
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group col-sm-12' },
                        _react2.default.createElement(
                            'label',
                            { className: 'form-control-label' },
                            this.getLanguage('address')
                        ),
                        _react2.default.createElement('input', { type: 'text', 'data-id': 'url', placeholder: 'www.myshop.com', className: 'form-control form-control-lg', value: this.state.url, onChange: this.handleInputChange })
                    )
                ),
                this.state.isLoading ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-dark btn-lg', onClick: this.getPin, type: 'button' },
                        this.getLanguage('get_pin'),
                        ' ',
                        _react2.default.createElement('i', { className: 'icon wb-arrow-right' })
                    )
                )
            );
        }
    }, {
        key: 'step2',
        value: function step2() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    null,
                    this.getLanguage('step2_title')
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'description' },
                    this.getLanguage('step2_description_1'),
                    ' ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        this.state.email
                    ),
                    '.',
                    _react2.default.createElement('br', null),
                    this.getLanguage('step2_description_2')
                ),
                this.state.error ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-10 m-b-10' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.error
                    )
                ) : null,
                this.state.info ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-10 m-b-10' },
                    _react2.default.createElement(
                        'div',
                        { className: 'alert dark alert-icon alert-warning alert-dismissible', role: 'alert' },
                        _react2.default.createElement('i', { className: 'icon wb-alert', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.info
                    )
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group col-sm-12' },
                        _react2.default.createElement(
                            'label',
                            { className: 'form-control-label' },
                            this.getLanguage('step2_title')
                        ),
                        _react2.default.createElement('input', { type: 'text', 'data-id': 'pin', placeholder: '1234', className: 'form-control text-center form-control-lg', value: this.state.pin, onChange: this.handleInputChange })
                    )
                ),
                this.state.isLoading ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-dark btn-lg', onClick: this.checkPin, type: 'button' },
                        this.getLanguage('validate_pin'),
                        ' ',
                        _react2.default.createElement('i', { className: 'icon wb-arrow-right' })
                    )
                )
            );
        }
    }, {
        key: 'getPin',
        value: function getPin() {
            var _this3 = this;

            this.setState({ 'isLoading': true });
            _axios2.default.post('/ajax/Mystore_get_pin', { 'url': this.state.url }).then(function (res) {
                _this3.setState({ 'error': false, isLoading: false, email: res.data.email, step: 2 });
            }).catch(function (err) {
                _this3.setState({ 'error': err.response.data.error.message, isLoading: false });
            });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            var val = e.target.value;

            if (e.target.getAttribute('data-id') == 'pin') {
                if (val.length >= 5) {
                    return;
                }
            }

            this.setState(_defineProperty({}, e.target.getAttribute('data-id'), val));
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage(str) {
            return this.language[this.props.language][str];
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this.state.step == 1 ? this.step1() : this.step2()
            );
        }
    }]);

    return Mystore;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

exports.default = Mystore;

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartReminder = function (_React$Component) {
    _inherits(CartReminder, _React$Component);

    function CartReminder(props) {
        _classCallCheck(this, CartReminder);

        var _this = _possibleConstructorReturn(this, (CartReminder.__proto__ || Object.getPrototypeOf(CartReminder)).call(this, props));

        _this.language = {};
        _this.language['norwegian'] = {
            title: 'Forlatte handlekurver',
            description: 'Ønsker du å innhente tapte ordrer ?',
            details: 'Ved å aktivere "forlatte handlekurver" vil vi etter noen timer automatisk sendte en e-post til kunder som ikke har fullført ordren sin. Dette er et utrolig kraftig verktøy med høy konvertering.',
            question: 'Ønsker du å aktivere "forlatte handlekurver" ?',
            button_accept: 'Aktiver',
            button_decline: 'Hopp over'
        };

        _this.language['english'] = {
            title: 'Forlatte handlekurver',
            description: 'Ønsker du å innhente tapte ordrer ?',
            details: 'Ved å aktivere "forlatte handlekurver" vil vi etter noen timer automatisk sendte en e-post til kunder som ikke har fullført ordren sin. Dette er et utrolig kraftig verktøy med høy konvertering.',
            question: 'Ønsker du å aktivere "forlatte handlekurver" ?',
            button_accept: 'Aktiver',
            button_decline: 'Hopp over'
        };

        _this.state = {
            error: false,
            info: false,
            isLoading: false
        };

        _this.accept = _this.accept.bind(_this);

        return _this;
    }

    _createClass(CartReminder, [{
        key: 'accept',
        value: function accept() {
            var _this2 = this;

            this.setState({ isLoading: true });
            _axios2.default.get('/ajax/setup_copy_email?l=' + this.props.language).then(function (res) {
                _this2.setState({ isLoading: false });
                _this2.props.handleComplete();
            });
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage(str) {
            return this.language[this.props.language][str];
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    null,
                    this.getLanguage('title')
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'description' },
                    this.getLanguage('description')
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-20' },
                    this.getLanguage('details'),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'strong',
                        null,
                        this.getLanguage('question')
                    )
                ),
                this.state.isLoading ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12 text-center' },
                    this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-dark btn-lg btn-outline m-r-10', onClick: this.props.handleComplete, type: 'button' },
                            _react2.default.createElement('i', { className: 'icon wb-close' }),
                            ' ',
                            this.getLanguage('button_decline')
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-dark btn-lg', onClick: this.accept, type: 'button' },
                            _react2.default.createElement('i', { className: 'icon wb-check' }),
                            ' ',
                            this.getLanguage('button_accept')
                        )
                    )
                )
            );
        }
    }]);

    return CartReminder;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

exports.default = CartReminder;

/***/ }),

/***/ 1715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popup = function (_React$Component) {
    _inherits(Popup, _React$Component);

    function Popup(props) {
        _classCallCheck(this, Popup);

        var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

        _this.language = {};
        _this.language['norwegian'] = {
            title: 'Nyhetsbrev abonnenter',
            description: 'Ønsker du flere abonnenter til dine nyhetsbrev ?',
            details: 'Med Crall kan du lage en "popup" som oppfordrer kundene til å melde seg på din nyhetsbrevliste. Dette er viktig for deg, og utrolig viktig for at du skal få mest mulig ut av Crall.',
            question: 'Skal vi aktivere e-postinnsamleren?',
            button_accept: 'Aktiver',
            button_decline: 'Nei takk'
        };

        _this.language['english'] = {
            title: 'Nyhetsbrev abonnenter',
            description: 'Ønsker du flere abonnenter til dine nyhetsbrev ?',
            details: 'Med Crall kan du lage en "popup" som oppfordrer kundene til å melde seg på din nyhetsbrevliste. Dette er viktig for deg, og utrolig viktig for at du skal få mest mulig ut av Crall.',
            question: 'Skal vi aktivere e-postinnsamleren?',
            button_accept: 'Aktiver',
            button_decline: 'Nei takk'
        };

        _this.state = {
            error: false,
            info: false,
            isLoading: false
        };

        _this.accept = _this.accept.bind(_this);

        return _this;
    }

    _createClass(Popup, [{
        key: 'accept',
        value: function accept() {
            var _this2 = this;

            this.setState({ isLoading: true });
            _axios2.default.get('/ajax/setup_copy_popup?l=' + this.props.language).then(function (res) {
                _this2.setState({ isLoading: false });
                _this2.props.handleComplete();
            });
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage(str) {
            return this.language[this.props.language][str];
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    null,
                    this.getLanguage('title')
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'description' },
                    this.getLanguage('description')
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-20' },
                    this.getLanguage('details'),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'strong',
                        null,
                        this.getLanguage('question')
                    )
                ),
                this.state.isLoading ? _react2.default.createElement(
                    'div',
                    { className: 'm-t-20 col-sm-12 text-center' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12 text-center' },
                    this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-dark btn-lg btn-outline m-r-10', onClick: this.props.handleComplete, type: 'button' },
                            _react2.default.createElement('i', { className: 'icon wb-close' }),
                            ' ',
                            this.getLanguage('button_decline')
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-dark btn-lg', onClick: this.accept, type: 'button' },
                            _react2.default.createElement('i', { className: 'icon wb-check' }),
                            ' ',
                            this.getLanguage('button_accept')
                        )
                    )
                )
            );
        }
    }]);

    return Popup;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

exports.default = Popup;

/***/ }),

/***/ 1716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SegmentsNew = __webpack_require__(390);

var _SegmentsNew2 = _interopRequireDefault(_SegmentsNew);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _Segment = __webpack_require__(536);

var _reactTimeago = __webpack_require__(266);

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segments = function (_React$Component) {
    _inherits(Segments, _React$Component);

    function Segments(props) {
        _classCallCheck(this, Segments);

        var _this = _possibleConstructorReturn(this, (Segments.__proto__ || Object.getPrototypeOf(Segments)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            askDelete: false,
            askUpgrade: false,
            showDialog: false,
            currentSegment: false,
            segments: [],
            segment: {}
        };

        _this.rows = _this.rows.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        _this.getSegments = _this.getSegments.bind(_this);
        _this.runSegment = _this.runSegment.bind(_this);
        return _this;
    }

    _createClass(Segments, [{
        key: 'runSegment',
        value: function runSegment(index) {
            var segment = _extends({}, this.props.segments.list[index]);

            segment.is_running = 1;

            this.props.updateSegment(index, segment);

            _axios2.default.post('/segments/' + segment.id + '/generate');
        }
    }, {
        key: 'getSegments',
        value: function getSegments() {
            var _this2 = this;

            this.setState(_extends({}, this.state, {
                'isLoading': true
            }));

            _axios2.default.get('/segments').then(function (res) {

                _this2.props.setSegments(res.data);

                _this2.setState(_extends({}, _this2.state, {
                    'isError': false,
                    'isLoading': false
                }));
            }).catch(function (res) {
                _this2.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.getSegments();
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'rows',
        value: function rows() {
            var _this3 = this;

            var data = this.placeholderRow(10, 6);

            this.props.segments.list.map(function (segment, i) {
                data[i] = _react2.default.createElement(
                    'tr',
                    { key: 'segment-' + segment.id },
                    _react2.default.createElement(
                        'td',
                        null,
                        '#',
                        segment.id
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        segment.name
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        segment.is_running == '1' ? _react2.default.createElement(
                            'button',
                            { className: 'btn btn-warning btn-sm' },
                            _react2.default.createElement(
                                'div',
                                { style: { display: 'inline-block' } },
                                _react2.default.createElement('div', { className: 'loading-small', style: { float: 'left' } }),
                                _react2.default.createElement(
                                    'div',
                                    { style: { display: 'inline-block', paddingTop: '0px', paddingLeft: '5px' } },
                                    'Processing'
                                )
                            )
                        ) : _react2.default.createElement(
                            'button',
                            { className: 'btn  btn-success btn-sm', onClick: function onClick(e) {
                                    e.stopPropagation();_this3.runSegment(i);
                                } },
                            _react2.default.createElement('i', { className: 'icon wb-play' }),
                            'Generate segment'
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        segment.last_run && segment.is_running == '0' ? _react2.default.createElement(
                            'a',
                            { href: segment.url, target: 'blank', style: { textDecoration: 'none' }, className: 'btn btn-dark btn-sm' },
                            'Download'
                        ) : _react2.default.createElement(
                            _rcTooltip2.default,
                            { placement: 'top', overlay: _react2.default.createElement(
                                    'span',
                                    null,
                                    'You must run the segment before you can download the results'
                                ) },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark btn-sm', disabled: true },
                                'Download'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        segment.last_run ? (0, _moment2.default)(_General4.default.toLocalTime(segment.last_run)).fromNow() : 'Never'
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'btn-group', role: 'group' },
                            _react2.default.createElement(
                                _rcTooltip2.default,
                                { placement: 'top', overlay: _react2.default.createElement(
                                        'span',
                                        null,
                                        'Edit segment'
                                    ) },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick(e) {
                                            e.stopPropagation();_this3.setState({ currentSegment: segment.id, showDialog: true });
                                        }, className: 'btn btn-icon btn-default btn-outline' },
                                    _react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
                                )
                            ),
                            _react2.default.createElement(
                                _rcTooltip2.default,
                                { placement: 'top', overlay: _react2.default.createElement(
                                        'span',
                                        null,
                                        'Delete segment'
                                    ) },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick(e) {
                                            _this3.askDelete(segment.id);
                                        }, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
                                    _react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
                                )
                            )
                        )
                    )
                );
            });

            return data;
        }
    }, {
        key: 'askDelete',
        value: function askDelete(id) {
            this.setState({ askDelete: id });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this4 = this;

            this.setState({ askDelete: false, isLoading: true });
            _axios2.default.delete('/segments/' + id).then(function (res) {
                _axios2.default.get('/segments').then(function (res) {
                    _this4.getSegments();
                });
            });
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getSegments();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.askUpgrade) {
                return _react2.default.createElement(_AskUpgrade2.default, { inline: true, onAccept: function onAccept(e) {
                        _this5.setState({ askUpgrade: false });_this5.props.router.push(_General2.default.Link('/settings/billing/plan'));
                    }, onClose: function onClose() {
                        _this5.setState({ askUpgrade: false });
                    }, param: this.state.askUpgrade, title: 'Upgrade required', body: 'To use this feature you must upgrade to a larger package.' });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-code-fork' }),
                        ' Segments'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            'button',
                            { onClick: function onClick(e) {
                                    e.stopPropagation();_this5.setState({ currentSegment: false, showDialog: true });
                                }, className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                            '  New segment'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0' },
                        _react2.default.createElement(_reactHelmet2.default, { title: 'Segments | Crall.io' }),
                        _react2.default.createElement(
                            'table',
                            { className: 'table outline' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        '#'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Name'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Run'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Download'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Last export'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Actions'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.props.segments.list.length == 0 ? this.placeholderRow(10, 6) : this.rows()
                            )
                        ),
                        _react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
                                _this5.delete(e);
                            }, onClose: function onClose() {
                                _this5.setState({ askDelete: false });
                            }, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this popup?' })
                    )
                ),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this5.setState({ currentSegment: false, showDialog: false });
                        }, isOpened: this.state.showDialog },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(_SegmentsNew2.default, { handleSave: this.handleSave, enabled: this.props.general.settings.PACKAGE_SEGMENTS, exportable: 1, onClose: function onClose(e) {
                                _this5.setState({ currentSegment: false, showDialog: false });
                            }, segmentId: this.state.currentSegment })
                    )
                )
            );
        }
    }]);

    return Segments;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general,
        segments: state.segments
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSegments: _Segment.setSegments, updateSegment: _Segment.updateSegment }, dispatch);
};

Segments = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Segments);
exports.default = Segments;

/***/ }),

/***/ 1717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(53);

var _reactTimeago = __webpack_require__(266);

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _General4 = __webpack_require__(44);

var _General5 = _interopRequireDefault(_General4);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Events = function (_React$Component) {
    _inherits(Events, _React$Component);

    function Events(props) {
        _classCallCheck(this, Events);

        var _this = _possibleConstructorReturn(this, (Events.__proto__ || Object.getPrototypeOf(Events)).call(this, props));

        _this.state = {
            isLoading: true,
            events: []
        };

        return _this;
    }

    _createClass(Events, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _General2.default.fetchGeneral().then(function () {
                _axios2.default.get('/events/emails').then(function (res) {
                    _this2.setState({ isLoading: false, events: res.data });
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Events | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-list' }),
                        ' Events'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Emails', description: 'List of the last 500 e-mails' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'table',
                                { className: 'table table-striped' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.events.map(function (event) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: event.id },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: event.text } }),
                                                '\xA0',
                                                (0, _moment2.default)(_General5.default.toLocalTime(event.created_at)).fromNow()
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Events;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSetting: _General3.setSetting }, dispatch);
};

Events = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Events);
exports.default = Events;

/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Orders = function (_React$Component) {
    _inherits(Orders, _React$Component);

    function Orders(props) {
        _classCallCheck(this, Orders);

        var _this = _possibleConstructorReturn(this, (Orders.__proto__ || Object.getPrototypeOf(Orders)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            askDelete: false,
            orders: [],
            count: 0,
            take: 20,
            skip: 0,
            max: 0,
            current: 1,
            pages: 1,
            increment: 20
        };

        _this.rows = _this.rows.bind(_this);
        _this.getOrders = _this.getOrders.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);
        _this.prevPage = _this.prevPage.bind(_this);
        _this.renderNumbers = _this.renderNumbers.bind(_this);
        _this.jumpPrev = _this.jumpPrev.bind(_this);
        _this.jumpNext = _this.jumpNext.bind(_this);
        return _this;
    }

    _createClass(Orders, [{
        key: 'jumpNext',
        value: function jumpNext() {
            this.setState({
                skip: Math.round(this.state.skip + 7 * this.state.increment)
            });
        }
    }, {
        key: 'jumpPrev',
        value: function jumpPrev() {
            var to = this.state.skip - 7 * this.state.increment;

            if (to < this.state.increment) {
                to = 0;
            }

            this.setState({
                skip: Math.round(to)
            });
        }
    }, {
        key: 'switchPage',
        value: function switchPage(page) {
            this.setState({
                skip: page * this.state.increment
            });
        }
    }, {
        key: 'paginatorNum',
        value: function paginatorNum(i) {
            var _this2 = this;

            return _react2.default.createElement(
                'li',
                { key: i, onClick: function onClick(e) {
                        e.stopPropagation();_this2.switchPage(i);
                    }, className: 'page-item ' + (this.state.current == i ? 'active' : '') },
                _react2.default.createElement(
                    'a',
                    { className: 'page-link', href: 'javascript:void(0)' },
                    i
                )
            );
        }
    }, {
        key: 'renderNumbers',
        value: function renderNumbers() {
            var elms = [];
            var i = void 0;
            var allowed_gap = 5;
            var pages_left = this.state.pages - this.state.current;
            var pages_prev = this.state.current - 1;

            if (this.state.current > 1) {
                var prev_start_pos = 1;

                if (this.state.current - allowed_gap > 1) {
                    prev_start_pos = this.state.current - allowed_gap;
                }

                if (prev_start_pos > allowed_gap) {
                    elms.push(_react2.default.createElement(
                        'li',
                        { key: 'jump-prev', onClick: this.jumpPrev, className: 'page-item' },
                        _react2.default.createElement(
                            'a',
                            { className: 'page-link', href: 'javascript:void(0)' },
                            '...'
                        )
                    ));
                }

                for (i = prev_start_pos; i <= this.state.current - 1; i++) {
                    console.dir(i);
                    var elm = this.paginatorNum(i);
                    elms.push(elm);
                }
            }

            if (pages_left > allowed_gap) {
                for (i = this.state.current; i <= this.state.current + allowed_gap; i++) {
                    var _elm = this.paginatorNum(i);
                    elms.push(_elm);
                }
            }

            if (this.state.pages > 10) {
                elms.push(_react2.default.createElement(
                    'li',
                    { key: 'jump-next', onClick: this.jumpNext, className: 'page-item' },
                    _react2.default.createElement(
                        'a',
                        { className: 'page-link', href: 'javascript:void(0)' },
                        '...'
                    )
                ));
            }

            return elms;
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this.setState({
                skip: Math.round(parseInt(this.state.skip) + parseInt(this.state.increment))
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            this.setState({
                skip: Math.round(parseInt(this.state.skip) - parseInt(this.state.increment))
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(props, state) {
            if (state.skip != this.state.skip) {
                this.getOrders();
            }
        }
    }, {
        key: 'rows',
        value: function rows() {
            var data = this.placeholderRow(20, 8);

            this.state.orders.map(function (order, i) {
                data[i] = _react2.default.createElement(
                    'tr',
                    { key: 'order-' + order.id },
                    _react2.default.createElement(
                        'td',
                        null,
                        '#',
                        order.id
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.name
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.billing_address
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.billing_zip
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.billing_city
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.billing_country
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        order.total
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        (0, _moment2.default)(_General4.default.toLocalTime(order.created_at)).fromNow()
                    )
                );
            });

            return data;
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getOrders();
        }
    }, {
        key: 'buildRequest',
        value: function buildRequest() {
            var url = '/orders?';
            url += 'limit=' + this.state.increment + '&skip=' + this.state.skip;
            return url;
        }
    }, {
        key: 'getOrders',
        value: function getOrders() {
            var _this3 = this;

            this.setState({
                isLoading: true
            });

            _axios2.default.get(this.buildRequest()).then(function (res) {
                _this3.setState(_extends({}, _this3.state, {
                    'isError': false,
                    'isLoading': false,
                    'orders': res.data.orders,
                    'count': parseInt(res.data.count),
                    'take': parseInt(res.data.take),
                    skip: parseInt(res.data.skip),
                    max: parseInt(res.data.max),
                    current: parseInt(res.data.current),
                    pages: parseInt(res.data.pages)
                }));
            }).catch(function (res) {
                _this3.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.orders.length == 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Orders | Crall.io' }),
                    _react2.default.createElement(_NoResult2.default, {
                        header: 'No orders found',
                        body: 'Please come back in a while..'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-order' }),
                        ' Orders'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0' },
                        _react2.default.createElement(_reactHelmet2.default, { title: 'Orders | Crall.io' }),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group' },
                                _react2.default.createElement('input', { type: 'text', className: 'form-control', name: '', placeholder: 'Search...' }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn btn-dark' },
                                        _react2.default.createElement('i', { className: 'icon wb-search', 'aria-hidden': 'true' })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'table',
                            { className: 'table outline' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        '#'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Name'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Billing address'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Billing zip'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Billing city'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Billing country'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Total'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.rows()
                            )
                        ),
                        _react2.default.createElement(
                            'nav',
                            { style: { textAlign: 'center' } },
                            _react2.default.createElement(
                                'ul',
                                { className: 'pagination', style: { backgroundColor: '#fff' } },
                                _react2.default.createElement(
                                    'li',
                                    { className: 'disabled page-item' },
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'page-link', onClick: this.prevPage, href: 'javascript:void(0)', 'aria-label': 'Previous' },
                                        _react2.default.createElement(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            '\xAB'
                                        )
                                    )
                                ),
                                this.renderNumbers(),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'page-item' },
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'page-link', onClick: this.nextPage, href: 'javascript:void(0)', 'aria-label': 'Next' },
                                        _react2.default.createElement(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            '\xBB'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Orders;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Orders = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Orders);
exports.default = Orders;

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Startup = function (_React$Component) {
    _inherits(Startup, _React$Component);

    function Startup(props) {
        _classCallCheck(this, Startup);

        var _this = _possibleConstructorReturn(this, (Startup.__proto__ || Object.getPrototypeOf(Startup)).call(this, props));

        _this.emailGrabber = function () {
            return _this.taskElement({
                link: '/settings/emails',
                image: '/images/handshake.png',
                completed: _this.props.general.settings.EMAIL_LOOKUP_STATUS == 1 ? true : false,
                title: 'Collect e-mails and marketing consent',
                description: "Crall will monitor all visitor input to find e-mails. When we find an e-mail, we'll show a popup asking the visitor to allow us to send e-mails.",
                help: 'https://crall.zendesk.com/hc/no/articles/360022017211-Innsamling-av-e-postadresser-og-samtykke'
            });
        };

        _this.state = {
            isLoading: true,
            isError: false,
            askDelete: false,
            config: []
        };

        _this.taskElement = _this.taskElement.bind(_this);
        _this.cartReminder = _this.cartReminder.bind(_this);
        _this.emailCollection = _this.emailCollection.bind(_this);
        _this.cartReminderFollowUp = _this.cartReminderFollowUp.bind(_this);
        return _this;
    }

    _createClass(Startup, [{
        key: 'cartReminder',
        value: function cartReminder() {
            return this.taskElement({
                link: '/builder/email/picker/1',
                image: '/images/cart.png',
                completed: this.state.config.cart_reminder ? true : false,
                title: 'Add a cart reminder e-mail',
                description: 'Send an e-mail notification to customers who abandons their cart',
                help: 'https://crall.zendesk.com/hc/no/articles/360021797992-Hva-er-en-glemt-handlekurv-e-post-'
            });
        }
    }, {
        key: 'emailCollection',
        value: function emailCollection() {
            return this.taskElement({
                link: '/builder/popup/picker/1',
                image: '/images/envelope.png',
                completed: this.state.config.email_collection ? true : false,
                title: 'Add a popup that collects e-mail addresses from visitors',
                description: 'To improve send rate of our cart reminders we need to collect e-mails early as possible',
                help: 'https://crall.zendesk.com/hc/no/articles/360022015731-Hvordan-opprette-en-popup'
            });
        }
    }, {
        key: 'emailApp',
        value: function emailApp() {
            return this.taskElement({
                link: '/apps/browse',
                image: '/images/share.png',
                completed: this.state.config.email_app ? true : false,
                title: 'Install an e-mail integration',
                description: 'Transfer all collected e-mails directly into ESPs such as mailchimp, apsis etc.',
                help: 'https://crall.zendesk.com/hc/no/articles/360022016191-Hvordan-automatisk-overf%C3%B8re-e-postadresser-til-din-ESP'
            });
        }
    }, {
        key: 'birthday',
        value: function birthday() {
            return this.taskElement({
                link: '/builder/email/picker/1',
                image: '/images/heart.png',
                completed: this.state.config.birthday ? true : false,
                title: 'Send a birthday e-mail',
                description: 'Automatically send an e-mail with a discount to customers on their birthday',
                help: 'https://crall.zendesk.com/hc/no/articles/360021798012-Hvordan-opprette-en-e-post'
            });
        }
    }, {
        key: 'cartReminderFollowUp',
        value: function cartReminderFollowUp() {
            return this.taskElement({
                link: '/emails',
                image: '/images/hourglass.png',
                completed: this.state.config.cart_reminder_followup ? true : false,
                title: 'Create a follow-up for a cart reminder',
                description: "Send a new reminder to the visitor if they don't make a purchase after the previous cart reminder.",
                help: 'https://crall.zendesk.com/hc/no/articles/360021798072-Hvordan-opprette-en-oppf%C3%B8lger-til-en-e-post-'
            });
        }
    }, {
        key: 'segments',
        value: function segments() {
            return this.taskElement({
                link: 'advanced',
                image: '/images/pie-chart.png',
                completed: this.state.config.birthday ? true : false,
                title: 'Create automated e-mails based on visitor behavior',
                description: 'Automatically send an e-mail to VIP customers, visitors who bought a specific product, bought from a manufacturer or category. The possibilities are endless. This is an advanced feature, please contact us for more information.'
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/general/startup').then(function (res) {
                _this2.setState(_extends({}, _this2.state, {
                    'isError': false,
                    'isLoading': false,
                    'config': res.data
                }));
            }).catch(function (res) {
                _this2.setState({ 'isError': res.message });
            });

            localStorage.setItem('getting_started', 1);
        }
    }, {
        key: 'taskElement',
        value: function taskElement(options) {
            return _react2.default.createElement(
                'li',
                { className: 'list-group-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'media' },
                    _react2.default.createElement(
                        'div',
                        { className: 'media-left', style: { verticalAlign: 'middle' } },
                        _react2.default.createElement(
                            'a',
                            { className: 'avatar', style: { width: '100px', textAlign: 'center' }, href: 'javascript:void(0)' },
                            _react2.default.createElement('img', { style: { width: '32px', borderRadius: 0, display: 'inline-block' }, className: 'img-fluid', src: options.image, alt: '...' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'media-body' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'media-heading' },
                            options.title
                        ),
                        _react2.default.createElement(
                            'small',
                            null,
                            options.description
                        ),
                        options.help ? _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'a',
                                { href: options.help, target: 'blank', className: 'btn btn-sm btn-primary' },
                                'Go to documentation'
                            )
                        ) : null
                    ),
                    options.link != 'advanced' ? _react2.default.createElement(
                        'div',
                        { className: 'media-right', style: { textAlign: 'right', width: '20%' } },
                        options.completed ? _react2.default.createElement(
                            'button',
                            { className: 'btn btn-success btn-block' },
                            _react2.default.createElement('i', { className: 'icon fa-check-circle-o', 'aria-hidden': 'true' }),
                            ' Completed'
                        ) : _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link(options.link), className: 'btn btn-dark btn-block' },
                            'Setup'
                        )
                    ) : null
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Getting started | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-info-circle' }),
                        ' Getting started'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link("/dashboard"), className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-arrow-left', style: { marginRight: '10px' } }),
                            '  Return to dashboard'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-7 offset-sm-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-body' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    'Welcome to Crall, ',
                                    this.props.auth.user.firstname,
                                    '!'
                                ),
                                'To help you get started, we\'ve added a list of steps you should complete to optimize traffic, revenue and customer interaction.',
                                _react2.default.createElement('br', null),
                                _react2.default.createElement('br', null),
                                'You may access this page again by clicking on "Getting started" in the top left.',
                                _react2.default.createElement('br', null),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'h5',
                                    null,
                                    'Need further assistance?'
                                ),
                                'If you need any help, please check out our norwegian support center by clicking ',
                                _react2.default.createElement(
                                    'a',
                                    { href: 'http://docs.crall.io' },
                                    'here'
                                ),
                                ' or by clicking "Help" in the menu to the left. You can also use our chat in the bottom right to ask us questions or send an e-mail to hi@crall.io.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-7 offset-sm-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-body' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'list-group list-group-full' },
                                    this.cartReminder(),
                                    this.emailCollection(),
                                    this.emailGrabber(),
                                    this.cartReminderFollowUp(),
                                    this.emailApp(),
                                    this.birthday(),
                                    this.segments()
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Startup;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Startup = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Startup);
exports.default = Startup;

/***/ }),

/***/ 1720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Push = function (_React$Component) {
    _inherits(Push, _React$Component);

    function Push(props) {
        _classCallCheck(this, Push);

        var _this = _possibleConstructorReturn(this, (Push.__proto__ || Object.getPrototypeOf(Push)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            unknownDiscounts: [],
            discounts: []
        };

        _this.rows = _this.rows.bind(_this);
        return _this;
    }

    _createClass(Push, [{
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'rows',
        value: function rows() {
            var data = this.placeholderRow(10, 5);

            this.state.data.notifications.map(function (notification, i) {
                data[i] = _react2.default.createElement(
                    'tr',
                    { key: 'notification-' + notification.id },
                    _react2.default.createElement(
                        'td',
                        null,
                        notification.id
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        notification.title
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        notification.clicks
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        notification.received
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        notification.sent == '1' ? (0, _moment2.default)(_General4.default.toLocalTime(notification.created_at)).fromNow() : 'Processing'
                    )
                );
            });

            return data;
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/push?include=subscribers').then(function (res) {
                _this2.setState(_extends({}, _this2.state, {
                    'isError': false,
                    'isLoading': false,
                    'data': res.data
                }));
            }).catch(function (res) {
                _this2.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-rocket' }),
                        ' Push notifications'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link("/push/new"), className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                            '  New'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Push notifications | Crall.io' }),
                    this.props.general.settings.PUSH_ACTIVE != '1' ? _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-4 offset-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'alert alert-icon alert-danger alert-dismissible', role: 'alert' },
                                _react2.default.createElement('i', { className: 'icon wb-bell', 'aria-hidden': 'true' }),
                                ' Push notifications is not enabled.',
                                _react2.default.createElement(
                                    'p',
                                    { className: 'm-t-15' },
                                    _react2.default.createElement(
                                        _reactRouter.Link,
                                        { to: _General2.default.Link("/settings/push"), className: 'btn btn-danger' },
                                        'Configure push notifications'
                                    )
                                )
                            )
                        )
                    ) : null,
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Notifications', panel: false, description: _react2.default.createElement(
                                'span',
                                null,
                                'Overview of sent notifications.',
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'tag tag-default' },
                                    'You have ',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        this.state.data.subscribers
                                    ),
                                    ' subscribers'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'alert dark alert-info', role: 'alert' },
                                    'INFO : This feature is only supported in Chrome / Firefox on PC and newer android devices.'
                                )
                            ) },
                        _react2.default.createElement(
                            'table',
                            { className: 'table outline' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Id'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Title'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Clicks'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Received'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sent at'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.rows()
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Push;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Push = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Push);
exports.default = Push;

/***/ }),

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _PushMessageEditor = __webpack_require__(1722);

var _PushMessageEditor2 = _interopRequireDefault(_PushMessageEditor);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Push = function (_React$Component) {
    _inherits(Push, _React$Component);

    function Push(props) {
        _classCallCheck(this, Push);

        var _this = _possibleConstructorReturn(this, (Push.__proto__ || Object.getPrototypeOf(Push)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false
        };
        _this.handleSave = _this.handleSave.bind(_this);
        return _this;
    }

    _createClass(Push, [{
        key: 'handleSave',
        value: function handleSave(res) {
            this.props.router.push(_General2.default.Link("/push"));
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'render',
        value: function render() {

            if (this.props.general.settings.PUSH_ACTIVE != '1') {
                return _react2.default.createElement(
                    'div',
                    { className: 'full-height' },
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header' },
                        _react2.default.createElement(
                            'span',
                            { className: 'page-title' },
                            _react2.default.createElement('i', { className: 'icon fa-rocket' }),
                            ' Push notifications'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-content' },
                        _react2.default.createElement(_reactHelmet2.default, { title: 'Push notifications | Crall.io' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'offset-sm-3 col-md-6 no-results' },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel panel-bordered', style: { border: '1px solid #e4eaec' } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-body text-center', style: { textAlign: 'center' } },
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement('i', { className: 'icon wb-alert-circle', 'aria-hidden': 'true', style: { fontSize: '80px' } }),
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement('br', null),
                                        'Push notifications is not enabled.',
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _General2.default.Link('/settings/push'), className: 'btn btn-default' },
                                            'Click here to configure push notifications'
                                        )
                                    ),
                                    _react2.default.createElement('br', null)
                                )
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-rocket' }),
                        ' New push notification'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link("/push"), className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-arrow-left', style: { marginRight: '10px' } }),
                            '  Back'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Push Notifications | Crall.io' }),
                    _react2.default.createElement(_PushMessageEditor2.default, { enableSegment: this.props.general.settings.PACKAGE_SEGMENTS, save: this.handleSave, subdomain: this.props.general.settings.SUBDOMAIN, initialValues: {
                            icon: this.props.general.settings.LOGO_64x64
                        } })
                )
            );
        }
    }]);

    return Push;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Push = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Push);
exports.default = Push;

/***/ }),

/***/ 1722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SegmentsNew = __webpack_require__(390);

var _SegmentsNew2 = _interopRequireDefault(_SegmentsNew);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.title) {
        errors.title = 'Required';
    }

    if (values.title) {
        if (values.title.length > 45) {
            errors.title = 'Title must be less than 45 characters';
        }
    }

    if (!values.message) {
        errors.message = 'Required';
    }

    if (values.message) {
        if (values.message.length > 100) {
            errors.message = 'Message must be less than 100 characters';
        }
    }

    if (!values.url) {
        errors.url = 'Required';
    }

    if (values.url) {
        if (!values.url.includes('https://') && !values.url.includes('http://')) {
            errors.url = 'Url must start with https:// or http://';
        }
    }

    if (!values.audience) {
        errors.audience = 'Required';
    }

    if (values.audience == 'select') {
        errors.audience = 'You must select an audience';
    }

    if (values.audience == '1') {
        if (values.segment == '0' || !values.segment) {
            errors.segment = 'You must select a segment';
        }
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        disabled = _ref.disabled,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group ' + (touched && error ? 'has-danger' : '') },
        _react2.default.createElement(
            'label',
            { className: 'form-control-label' },
            title
        ),
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type, disabled: disabled, autoComplete: 'off' })),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var checkbox = function checkbox(_ref2) {
    var input = _ref2.input,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'checkbox-custom checkbox-primary' },
        _react2.default.createElement('input', _extends({}, input, { name: name, type: type })),
        _react2.default.createElement(
            'label',
            null,
            title
        )
    );
};

var radio = function radio(_ref3) {
    var input = _ref3.input,
        name = _ref3.name,
        className = _ref3.className,
        placeholder = _ref3.placeholder,
        title = _ref3.title,
        _ref3$meta = _ref3.meta,
        touched = _ref3$meta.touched,
        error = _ref3$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'radio-custom radio-primary' },
        _react2.default.createElement('input', _extends({}, input, { name: name, type: 'radio' })),
        _react2.default.createElement(
            'label',
            null,
            title
        )
    );
};

var select = function select(_ref4) {
    var input = _ref4.input,
        options = _ref4.options,
        name = _ref4.name,
        className = _ref4.className,
        disabled = _ref4.disabled,
        placeholder = _ref4.placeholder,
        title = _ref4.title,
        type = _ref4.type,
        _ref4$meta = _ref4.meta,
        touched = _ref4$meta.touched,
        error = _ref4$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group ' + (touched && error ? 'has-danger' : '') },
        _react2.default.createElement(
            'select',
            { name: name, disabled: disabled, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var renderDropzoneInput = function renderDropzoneInput(field) {
    var files = field.input.value;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactDropzone2.default,
            {
                multiple: false,
                name: field.name,
                onDrop: function onDrop(filesToUpload, e) {
                    return field.input.onChange(filesToUpload);
                }
            },
            _react2.default.createElement(
                'div',
                null,
                'Try dropping some files here, or click to select files to upload.'
            )
        ),
        field.meta.touched && field.meta.error && _react2.default.createElement(
            'span',
            { className: 'error' },
            field.meta.error
        )
    );
};

var PushMessageEditor = function (_React$Component) {
    _inherits(PushMessageEditor, _React$Component);

    function PushMessageEditor(props) {
        _classCallCheck(this, PushMessageEditor);

        var _this = _possibleConstructorReturn(this, (PushMessageEditor.__proto__ || Object.getPrototypeOf(PushMessageEditor)).call(this, props));

        _this.state = {
            isSaving: false,
            file: false,
            segments: [],
            isLoadingSegments: true,
            currentSegment: false,
            showDialog: false
        };

        _this.onOpenClick = _this.onOpenClick.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.renderSegments = _this.renderSegments.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        return _this;
    }

    _createClass(PushMessageEditor, [{
        key: 'handleSave',
        value: function handleSave() {
            this.getSegments();
        }
    }, {
        key: 'renderSegments',
        value: function renderSegments() {
            var options = [];

            if (this.state.isLoadingSegments) {
                options.push({
                    label: 'Loading segments...',
                    value: 0
                });
            }

            if (this.state.segments.length > 0) {
                options.push({
                    label: 'Select a segment',
                    value: 0
                });
            }

            this.state.segments.map(function (segment, i) {
                options.push({
                    label: segment.name,
                    value: segment.id
                });
            });

            if (this.state.segments.length == 0) {
                options.push({
                    label: '-- None --',
                    value: 0
                });
            }

            return options;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getSegments();
        }
    }, {
        key: 'getSegments',
        value: function getSegments() {
            var _this2 = this;

            this.setState({
                isLoadingSegments: true
            });
            _axios2.default.get('/segments?type=push').then(function (res) {
                _this2.setState({
                    isLoadingSegments: false,
                    segments: res.data
                });
            });
        }
    }, {
        key: 'onOpenClick',
        value: function onOpenClick() {
            this.refs.dropzone.open();
        }
    }, {
        key: 'onDrop',
        value: function onDrop(files) {
            if (files.length == 0) {
                return;
            }

            var file = files[0];

            if (!file.type.includes('image/')) {
                return;
            }

            this.setState({ file: file });
            this.props.change('icon', file.preview);

            return;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(data) {
            var _this3 = this;

            this.setState({
                isSaving: true
            });

            var form = new FormData();

            if (this.state.file !== false) {
                form.append('file', this.state.file);
            }

            for (var i in data) {
                form.append(i, data[i]);
            }

            _axios2.default.post('/push', form).then(function (res) {
                _this3.setState({ isSaving: false });
                _this3.props.save(res);
            }).catch(function (err) {
                _this3.setState({ isSaving: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var handleSubmit = this.props.handleSubmit;


            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit(this.onSubmit.bind(this)) },
                _react2.default.createElement(
                    _OptionColumn2.default,
                    { title: 'Notification', description: 'Add title, message and a icon' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-7' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'title', placeholder: 'Crazy weekend!', title: 'Title', className: 'form-control' }),
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'message', placeholder: '25% off this weekend', title: 'Message', className: 'form-control' }),
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { style: { textAlign: 'center' } },
                                        _react2.default.createElement('img', { width: 80, src: this.props.icon }),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'span',
                                            { style: { fontSize: '10px' } },
                                            'Recommended size: 192x192'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactDropzone2.default,
                                            { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
                                            this.state.isUploading ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                                'button',
                                                { type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark' },
                                                'Change'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        _react2.default.createElement(
                            'h5',
                            null,
                            'Preview'
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: { width: '400px', border: '1px solid #e4eaec' } },
                            _react2.default.createElement(
                                'div',
                                { style: { float: 'left' } },
                                _react2.default.createElement('img', { width: 80, src: this.props.icon })
                            ),
                            _react2.default.createElement(
                                'div',
                                { style: { marginLeft: '80px', padding: '6px', borderLeft: '1px solid #e4eaec' } },
                                _react2.default.createElement(
                                    'div',
                                    { style: { fontSize: '15px', whiteSpace: 'nowrap', overflow: 'hidden' } },
                                    this.props.title ? this.props.title : 'Crazy weekend!'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { style: { fontSize: '13px' } },
                                    this.props.message ? this.props.message : '25% off this weekend'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { style: { marginTop: '8px', fontSize: '13px' } },
                                    this.props.subdomain,
                                    '.crall.io'
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clearfix' })
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            { style: { fontSize: '12px' } },
                            'Notifications will look different on each client depending on browser, operation system and device.'
                        )
                    )
                ),
                _react2.default.createElement(_SplitRow2.default, null),
                _react2.default.createElement(
                    _OptionColumn2.default,
                    { title: 'Target url', description: 'Url to open when user clicks the notification' },
                    _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'url', placeholder: 'https://www.example.com', title: 'Url', className: 'form-control' })
                ),
                _react2.default.createElement(_SplitRow2.default, null),
                _react2.default.createElement(
                    _OptionColumn2.default,
                    { title: 'Audience', description: 'Send message to all or selected subscribers' },
                    _react2.default.createElement(
                        'div',
                        { className: this.props.audience == 1 ? 'col-sm-6' : 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: select, name: 'audience', title: false, options: [{
                                value: 'select',
                                label: 'Send to...'
                            }, {
                                value: 0,
                                label: 'Send to all subscribers'
                            }, {
                                value: 1,
                                label: 'Send to subscribers matching a segment'
                            }] })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6', style: { display: this.props.audience == 1 ? 'block' : 'none' } },
                        this.props.enableSegment == '1' ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-8' },
                                _react2.default.createElement(_reduxForm.Field, { component: select, name: 'segment', disabled: this.state.isLoadingSegments, title: false, options: this.renderSegments() })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick(e) {
                                            e.stopPropagation();_this4.setState({ currentSegment: false, showDialog: true });
                                        }, className: 'btn btn-block btn-dark' },
                                    'New segment'
                                )
                            )
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'alert dark alert-danger' },
                            'Segments isn\'t included in your package. Please upgrade to "Premium plus".'
                        )
                    )
                ),
                _react2.default.createElement(_SplitRow2.default, null),
                _react2.default.createElement(
                    _OptionColumn2.default,
                    { title: 'Finish', description: 'Save notification and add to queue' },
                    this.state.isSaving ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                        'button',
                        { type: 'submit', className: 'btn btn-success btn-icon btn-block' },
                        _react2.default.createElement('i', { className: 'icon fa-rocket' }),
                        ' Send notification'
                    )
                ),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this4.setState({ currentSegment: false, showDialog: false });
                        }, isOpened: this.state.showDialog },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(_SegmentsNew2.default, { handleSave: this.handleSave, type: 'push', onClose: function onClose(e) {
                                _this4.setState({ currentSegment: false, showDialog: false });
                            }, segmentId: this.state.currentSegment })
                    )
                )
            );
        }
    }]);

    return PushMessageEditor;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

var selector = (0, _reduxForm.formValueSelector)('PushMessageEditor');

// Decorate the form component
PushMessageEditor = (0, _reduxForm.reduxForm)({
    form: 'PushMessageEditor',
    validate: validate
})(PushMessageEditor);

PushMessageEditor = (0, _reactRedux.connect)(function (state) {
    return {
        title: selector(state, 'title'),
        message: selector(state, 'message'),
        icon: selector(state, 'icon'),
        audience: selector(state, 'audience')
    };
})(PushMessageEditor);

exports.default = PushMessageEditor;

/***/ }),

/***/ 1723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _General = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsDiscount = function (_React$Component) {
    _inherits(SettingsDiscount, _React$Component);

    function SettingsDiscount(props) {
        _classCallCheck(this, SettingsDiscount);

        var _this = _possibleConstructorReturn(this, (SettingsDiscount.__proto__ || Object.getPrototypeOf(SettingsDiscount)).call(this, props));

        _this.saveStatus = _this.saveStatus.bind(_this);

        return _this;
    }

    _createClass(SettingsDiscount, [{
        key: 'handleTranslationSubmit',
        value: function handleTranslationSubmit(values) {
            var _this2 = this;

            this.setState({
                isSavingTranslation: true
            });

            _axios2.default.put('/settings', values).then(function (res) {
                _this2.setState({
                    isSavingTranslation: false
                });

                for (var i in values) {
                    _this2.props.setSetting(i, values[i]);
                }

                _Notification2.default.success('Success!');
            }).catch(function (err) {
                _this2.setState({
                    isSavingTranslation: false
                });
            });
        }
    }, {
        key: 'saveStatus',
        value: function saveStatus() {

            this.handleTranslationSubmit({
                SAVE_DISCOUNT_ACTIVATED: this.props.general.settings.SAVE_DISCOUNT_ACTIVATED,
                SAVE_DISCOUNT_BG_COLOR: this.props.general.settings.SAVE_DISCOUNT_BG_COLOR,
                SAVE_DISCOUNT_TEXT: this.props.general.settings.SAVE_DISCOUNT_TEXT
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Discount | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-tag' }),
                        ' Discount'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Reminder', description: 'Show a popup discount reminder in right bottom corner' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(
                                    'h5',
                                    null,
                                    'Status'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 text-center' },
                                    'Off \xA0\xA0',
                                    _react2.default.createElement(_rcSwitch2.default, { onChange: function onChange(val) {
                                            if (val == 'true' || val === true) {
                                                val = 'true';
                                            } else {
                                                val = 'false';
                                            }_this3.props.setSetting('SAVE_DISCOUNT_ACTIVATED', val);
                                        },
                                        checked: this.props.general.settings.SAVE_DISCOUNT_ACTIVATED == 'true' || this.props.general.settings.SAVE_DISCOUNT_ACTIVATED === true ? true : false,
                                        checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
                                        unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
                                    }),
                                    ' \xA0On'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group col-sm-6' },
                                _react2.default.createElement(
                                    'h5',
                                    null,
                                    'Background color'
                                ),
                                _react2.default.createElement(_ColorPicker2.default, { id: 'SAVE_DISCOUNT_BG_COLOR', color: this.props.general.settings.SAVE_DISCOUNT_BG_COLOR, handleColorChange: function handleColorChange(val, v) {
                                        _this3.props.setSetting('SAVE_DISCOUNT_BG_COLOR', v);
                                    } }),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'h5',
                                    null,
                                    'Additional text'
                                ),
                                _react2.default.createElement('input', { type: 'text', id: 'SAVE_DISCOUNT_TEXT', className: 'form-control', value: this.props.general.settings.SAVE_DISCOUNT_TEXT, onChange: function onChange(e) {
                                        return _this3.props.setSetting('SAVE_DISCOUNT_TEXT', e.target.value);
                                    } })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 m-t-20' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', onClick: this.saveStatus, className: 'btn btn-dark btn-block' },
                                'Save'
                            )
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null)
                )
            );
        }
    }]);

    return SettingsDiscount;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSetting: _General.setSetting }, dispatch);
};

SettingsDiscount = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsDiscount);
exports.default = SettingsDiscount;

/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _General = __webpack_require__(53);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsSync = function (_React$Component) {
    _inherits(SettingsSync, _React$Component);

    function SettingsSync(props) {
        _classCallCheck(this, SettingsSync);

        var _this = _possibleConstructorReturn(this, (SettingsSync.__proto__ || Object.getPrototypeOf(SettingsSync)).call(this, props));

        _this.getLastSyncDate = function () {
            return _moment2.default.utc(_this.state.last).local().format('DD-MM-YYYY HH:mm:ss');
        };

        _this.isRunning = function () {
            return _this.state.syncing;
        };

        _this.sync = function () {
            clearInterval(_this.interval);

            _axios2.default.get('/sync/start').then(function (result) {
                _this.interval = setInterval(function () {
                    _this.checkStatus();
                }, 5000);

                _this.setState({
                    syncing: true
                });
            });
        };

        _this.getSyncMessage = function () {
            if (_this.isRunning()) {
                return _react2.default.createElement(
                    'span',
                    null,
                    'We are currently syncing data. Please wait..'
                );
            }

            if (!_this.state.last) {
                return _react2.default.createElement(
                    'span',
                    null,
                    'We haven\'t run a sync yet.'
                );
            }

            return _react2.default.createElement(
                'span',
                null,
                'Last sync was done ',
                _react2.default.createElement(
                    'strong',
                    null,
                    _this.getLastSyncDate(),
                    '.'
                )
            );
        };

        _this.interval = null;

        _this.state = {
            isLoading: true,
            syncing: false,
            last: false
        };

        return _this;
    }

    _createClass(SettingsSync, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this.checkStatus();

            this.interval = setInterval(function () {
                _this2.checkStatus();
            }, 5000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.interval);
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus() {
            var _this3 = this;

            _axios2.default.get('/sync/status').then(function (result) {
                _this3.setState({
                    isLoading: false,
                    last: result.data.last,
                    syncing: result.data.status
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Data sync | Crall.io' }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-code-working' }),
                        ' Data sync'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Manual sync', description: 'Force a manual sync of shop data' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 text-center' },
                            this.getSyncMessage()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 text-center' },
                            this.isRunning() ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { onClick: this.sync, className: 'btn btn-dark' },
                                'Start sync'
                            )
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null)
                )
            );
        }
    }]);

    return SettingsSync;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setSetting: _General.setSetting }, dispatch);
};

SettingsSync = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsSync);
exports.default = SettingsSync;

/***/ }),

/***/ 1725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _ColumnPicker = __webpack_require__(265);

var _ColumnPicker2 = _interopRequireDefault(_ColumnPicker);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _template = __webpack_require__(399);

var _template2 = _interopRequireDefault(_template);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recommendations = function (_React$Component) {
    _inherits(Recommendations, _React$Component);

    function Recommendations(props) {
        _classCallCheck(this, Recommendations);

        var _this = _possibleConstructorReturn(this, (Recommendations.__proto__ || Object.getPrototypeOf(Recommendations)).call(this, props));

        _this.changeDisplayType = function (type) {
            _this.setState({
                displayType: type
            });
        };

        _this.state = {
            isLoading: true,
            isError: false,
            askCreate: false,
            askUpgrade: false,
            askDelete: false,
            followUpFor: false,
            recommendations: [],
            currentId: false,
            showDialog: false,
            displayType: 'shop'
        };

        _this.handleSave = _this.handleSave.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.askDelete = _this.askDelete.bind(_this);
        _this.delete = _this.delete.bind(_this);
        return _this;
    }

    _createClass(Recommendations, [{
        key: 'askDelete',
        value: function askDelete(id) {
            this.setState({ askDelete: id });
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this2 = this;

            this.setState({ askDelete: false, isLoading: true });
            _axios2.default.delete('/recommendations/' + id).then(function (res) {
                _this2.update();
            });
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            _axios2.default.get('/recommendations').then(function (res) {
                _this3.setState(_extends({}, _this3.state, {
                    'isError': false,
                    'isLoading': false,
                    'recommendations': res.data
                }));
            }).catch(function (res) {
                _this3.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'rows',
        value: function rows() {
            var _this4 = this;

            var data = this.placeholderRow(10, 7);
            var num = 0;

            this.state.recommendations.map(function (recommendation, i) {
                if (recommendation.type == _this4.state.displayType || _this4.state.displayType == 'shop' && (recommendation.type == '' || !recommendation.type)) {
                    data[num] = _react2.default.createElement(
                        'tr',
                        { key: 'template-' + recommendation.id },
                        _react2.default.createElement(
                            'td',
                            null,
                            '#',
                            recommendation.id
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: { textAlign: 'left' } },
                            recommendation.description
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: { textAlign: 'left' } },
                            recommendation.orders
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: { textAlign: 'left' } },
                            recommendation.clicks
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: { textAlign: 'left' } },
                            recommendation.conversion_rate,
                            '%'
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: { textAlign: 'left' } },
                            recommendation.revenue
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'btn-group', role: 'group' },
                                _react2.default.createElement(
                                    _rcTooltip2.default,
                                    { placement: 'top', overlay: _react2.default.createElement(
                                            'span',
                                            null,
                                            'Edit recommendation'
                                        ) },
                                    _react2.default.createElement(
                                        _reactRouter.Link,
                                        { to: _General2.default.Link('/recommendations/' + recommendation.id), className: 'btn btn-icon btn-default btn-outline', role: 'menuitem' },
                                        _react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
                                    )
                                ),
                                _react2.default.createElement(
                                    _rcTooltip2.default,
                                    { placement: 'top', overlay: _react2.default.createElement(
                                            'span',
                                            null,
                                            'Delete recommendation'
                                        ) },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick(e) {
                                                _this4.askDelete(recommendation.id);
                                            }, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
                                        _react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
                                    )
                                )
                            )
                        )
                    );

                    num++;
                }
            });

            return data;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.recommendations.length == 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Recommendations | Crall.io' }),
                    _react2.default.createElement(_NoResult2.default, {
                        header: 'No recommendations found',
                        body: 'You have not created a recommendation yet. Click the button to get started.',
                        link: '/recommendations/new',
                        button: 'Create my first recommendation'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height', id: 'tests' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-users' }),
                        ' Recommendations'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            'div',
                            { style: { marginRight: '10px' }, className: 'btn-group dropdown' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
                                _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                                ' Create new'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: _General2.default.Link('/recommendations/new'), className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem' },
                                    'Recommendation'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content recommendation-list' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Recommendations | Crall.io' }),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Recommendations', cols: { 'left': 2, 'right': 10 }, panel: false, description: 'List of all your recommendations.' },
                        _react2.default.createElement(
                            'div',
                            { style: { backgroundColor: '#fff' } },
                            _react2.default.createElement(
                                'div',
                                { className: 'nav-tabs-vertical', 'data-plugin': 'tabs' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'nav nav-tabs mr-25', role: 'tablist' },
                                    _react2.default.createElement(
                                        'li',
                                        { className: 'nav-item', role: 'presentation' },
                                        _react2.default.createElement(
                                            _rcTooltip2.default,
                                            { placement: 'left', overlay: _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    'Show shop widgets'
                                                ) },
                                            _react2.default.createElement(
                                                'a',
                                                { onClick: function onClick() {
                                                        return _this5.changeDisplayType('shop');
                                                    }, className: 'nav-link active',
                                                    'data-toggle': 'tab',
                                                    href: '#shop',
                                                    'aria-controls': 'shop',
                                                    role: 'tab' },
                                                _react2.default.createElement('i', { className: 'icon wb-shopping-cart m-0', 'aria-hidden': 'true' })
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        { onClick: function onClick() {
                                                return _this5.changeDisplayType('email');
                                            }, className: 'nav-item', role: 'presentation' },
                                        _react2.default.createElement(
                                            _rcTooltip2.default,
                                            { placement: 'left', overlay: _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    'Show e-mail widgets'
                                                ) },
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'nav-link',
                                                    'data-toggle': 'tab',
                                                    href: '#emails',
                                                    'aria-controls': 'emails',
                                                    role: 'tab' },
                                                _react2.default.createElement('i', { className: 'icon wb-envelope m-0', 'aria-hidden': 'true' })
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'tab-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'tab-pane active', id: 'shop', role: 'tabpanel' },
                                        _react2.default.createElement(
                                            'table',
                                            { className: 'table outline text-left' },
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        '#'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        { style: { width: '25%', textAlign: 'left' } },
                                                        'Description'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Orders'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Clicks'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Conversion'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Revenue'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Actions'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                this.rows()
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'tab-pane', id: 'emails', role: 'tabpanel' },
                                        _react2.default.createElement(
                                            'table',
                                            { className: 'table outline text-left' },
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        '#'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        { style: { width: '25%', textAlign: 'left' } },
                                                        'Description'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Orders'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Clicks'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Conversion'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Revenue'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Actions'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                this.rows()
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
                        _this5.delete(e);
                    }, onClose: function onClose() {
                        _this5.setState({ askDelete: false });
                    }, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this recommendation?' })
            );
        }
    }]);

    return Recommendations;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Recommendations = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Recommendations);
exports.default = Recommendations;

/***/ }),

/***/ 1732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _AskUpgrade = __webpack_require__(120);

var _AskUpgrade2 = _interopRequireDefault(_AskUpgrade);

var _ColumnPicker = __webpack_require__(265);

var _ColumnPicker2 = _interopRequireDefault(_ColumnPicker);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _template = __webpack_require__(399);

var _template2 = _interopRequireDefault(_template);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Templates = function (_React$Component) {
    _inherits(Templates, _React$Component);

    function Templates(props) {
        _classCallCheck(this, Templates);

        var _this = _possibleConstructorReturn(this, (Templates.__proto__ || Object.getPrototypeOf(Templates)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            askCreate: false,
            askUpgrade: false,
            askDelete: false,
            followUpFor: false,
            templates: [],
            currentId: false,
            showDialog: false
        };

        _this.handleSave = _this.handleSave.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.portal = _this.portal.bind(_this);
        _this.askDelete = _this.askDelete.bind(_this);
        _this.delete = _this.delete.bind(_this);
        return _this;
    }

    _createClass(Templates, [{
        key: 'askDelete',
        value: function askDelete(id) {
            this.setState({ askDelete: id });
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this2 = this;

            this.setState({ askDelete: false, isLoading: true });
            _axios2.default.delete('/recommendations/templates/' + id).then(function (res) {
                _this2.update();
            });
        }
    }, {
        key: 'portal',
        value: function portal() {
            var _this3 = this;

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: function onClose(e) {
                        _this3.setState({ currentId: false, showDialog: false });
                    }, isOpened: this.state.showDialog },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(_template2.default, { handleSave: this.handleSave, enabled: true, onClose: function onClose(e) {
                            _this3.setState({ currentId: false, showDialog: false });
                        }, recommendationId: this.state.currentId })
                )
            );
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this4 = this;

            _axios2.default.get('/recommendations/templates').then(function (res) {

                res.data = res.data.filter(function (template) {
                    return template.isLocked !== true;
                });

                _this4.setState(_extends({}, _this4.state, {
                    'isError': false,
                    'isLoading': false,
                    'templates': res.data
                }));
            }).catch(function (res) {
                _this4.setState({ 'isError': res.message });
            });
        }
    }, {
        key: 'duplicate',
        value: function duplicate(id) {
            var _this5 = this;

            this.setState({
                isLoading: true
            });

            _axios2.default.post('/recommendations/templates/' + id + '/duplicate').then(function (res) {
                var templates = [].concat(_toConsumableArray(_this5.state.templates));

                templates.push(res.data);

                _this5.setState({ isLoading: false, templates: templates });
            });
        }
    }, {
        key: 'placeholderRow',
        value: function placeholderRow(rows, cols) {
            var td = [];
            for (var i = 1; i <= cols; i++) {
                td.push(_react2.default.createElement(
                    'td',
                    { key: i },
                    this.placeholder()
                ));
            }

            var row = [];
            for (var _i = 1; _i <= rows; _i++) {
                row.push(_react2.default.createElement(
                    'tr',
                    { key: _i },
                    td
                ));
            }

            return row;
        }
    }, {
        key: 'rows',
        value: function rows() {
            var _this6 = this;

            var data = this.placeholderRow(10, 3);

            this.state.templates.map(function (template, i) {
                data[i] = _react2.default.createElement(
                    'tr',
                    { key: 'template-' + template.id },
                    _react2.default.createElement(
                        'td',
                        null,
                        '#',
                        template.id
                    ),
                    _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'left' } },
                        template.description
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'btn-group', role: 'group' },
                            _react2.default.createElement(
                                _rcTooltip2.default,
                                { placement: 'top', overlay: _react2.default.createElement(
                                        'span',
                                        null,
                                        'Edit template'
                                    ) },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick(e) {
                                            _this6.setState({ currentId: template.id, showDialog: true });
                                        }, className: 'btn btn-icon btn-default btn-outline' },
                                    _react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
                                )
                            ),
                            _react2.default.createElement(
                                _rcTooltip2.default,
                                { placement: 'top', overlay: _react2.default.createElement(
                                        'span',
                                        null,
                                        'Duplicate template'
                                    ) },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick() {
                                            return _this6.duplicate(template.id);
                                        }, className: 'btn btn-icon btn-default btn-outline' },
                                    _react2.default.createElement('i', { className: 'icon wb-copy', 'aria-hidden': 'true' })
                                )
                            ),
                            _react2.default.createElement(
                                _rcTooltip2.default,
                                { placement: 'top', overlay: _react2.default.createElement(
                                        'span',
                                        null,
                                        'Delete template'
                                    ) },
                                _react2.default.createElement(
                                    'button',
                                    { onClick: function onClick(e) {
                                            _this6.askDelete(template.id);
                                        }, type: 'button', className: 'btn btn-icon btn-default btn-outline' },
                                    _react2.default.createElement('i', { className: 'icon wb-trash', 'aria-hidden': 'true' })
                                )
                            )
                        )
                    )
                );
            });

            return data;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            if (this.state.templates.length == 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Templates | Crall.io' }),
                    _react2.default.createElement(_NoResult2.default, {
                        header: 'No templates found',
                        body: 'You have not created a template yet. Click the button to get started.',
                        action: function action(e) {
                            _this7.setState({ currentId: 0, showDialog: true });
                        },
                        button: 'Create my first template'
                    }),
                    this.portal()
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height', id: 'tests' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-files-o' }),
                        ' Templates'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            'div',
                            { style: { marginRight: '10px' }, className: 'btn-group dropdown' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
                                _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                                ' Create new'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
                                _react2.default.createElement(
                                    'a',
                                    { onClick: function onClick(e) {
                                            _this7.setState({ currentId: 0, showDialog: true });
                                        }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem' },
                                    'Template'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Templates | Crall.io' }),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: 'Templates', cols: { 'left': 2, 'right': 10 }, panel: false, description: 'List of all your templates.' },
                        _react2.default.createElement(
                            'table',
                            { className: 'table outline text-left' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        '#'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: { width: '75%', textAlign: 'left' } },
                                        'Description'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Actions'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.rows()
                            )
                        )
                    )
                ),
                _react2.default.createElement(_Confirm2.default, { onAccept: function onAccept(e) {
                        _this7.delete(e);
                    }, onClose: function onClose() {
                        _this7.setState({ askDelete: false });
                    }, param: this.state.askDelete, title: 'Are you sure?', body: 'Do you want to delete this template?' }),
                this.portal()
            );
        }
    }]);

    return Templates;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Templates = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Templates);
exports.default = Templates;

/***/ }),

/***/ 1733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _NewRecommendationForm = __webpack_require__(1734);

var _NewRecommendationForm2 = _interopRequireDefault(_NewRecommendationForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewRecommendation = function (_React$Component) {
    _inherits(NewRecommendation, _React$Component);

    function NewRecommendation(props) {
        _classCallCheck(this, NewRecommendation);

        var _this = _possibleConstructorReturn(this, (NewRecommendation.__proto__ || Object.getPrototypeOf(NewRecommendation)).call(this, props));

        _this.handleSave = function (data) {
            _this.props.router.push(_General2.default.Link('/recommendations/' + data));
        };

        return _this;
    }

    _createClass(NewRecommendation, [{
        key: 'getRecommendationId',
        value: function getRecommendationId() {
            return this.props.router.params.recommendation_id;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon fa-users' }),
                        ' New recommendation'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link("/recommendations"), className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-arrow-left', style: { marginRight: '10px' } }),
                            '  Back'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Recommendations | Crall.io' }),
                    _react2.default.createElement(_NewRecommendationForm2.default, { onSubmit: this.handleSave, hasSearch: this.props.general.settings.PACKAGE_SEARCH, hasRecommendation: this.props.general.settings.PACKAGE_RECOMMENDATIONS, enabled: this.props.general.settings.PACKAGE_RECOMMENDATIONS || this.props.general.settings.PACKAGE_SEARCH, recommendationId: this.getRecommendationId() })
                )
            );
        }
    }]);

    return NewRecommendation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

NewRecommendation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewRecommendation);
exports.default = NewRecommendation;

/***/ }),

/***/ 1734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _text = __webpack_require__(1735);

var _text2 = _interopRequireDefault(_text);

var _dropdown = __webpack_require__(685);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _numberpicker = __webpack_require__(1736);

var _numberpicker2 = _interopRequireDefault(_numberpicker);

var _template = __webpack_require__(399);

var _template2 = _interopRequireDefault(_template);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _Rule = __webpack_require__(1737);

var _Rule2 = _interopRequireDefault(_Rule);

var _Type = __webpack_require__(1738);

var _Type2 = _interopRequireDefault(_Type);

var _WidgetType = __webpack_require__(1739);

var _WidgetType2 = _interopRequireDefault(_WidgetType);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactCopyToClipboard = __webpack_require__(670);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _reactCodemirror = __webpack_require__(202);

var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);

var _RecommendationHelper = __webpack_require__(633);

var _RecommendationHelper2 = _interopRequireDefault(_RecommendationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.description) {
        errors.description = 'Required';
    }

    if (values.description) {
        if (values.description.match(/[^A-Za-z0-9\-_@]/)) {
            errors.description = 'Only A-Z,@ and 0-9';
        }
    }

    if (!values.template_id) {
        errors.template_id = 'Required';
    }

    return errors;
};

var NewRecommendationForm = function (_React$Component) {
    _inherits(NewRecommendationForm, _React$Component);

    function NewRecommendationForm(props) {
        _classCallCheck(this, NewRecommendationForm);

        var _this = _possibleConstructorReturn(this, (NewRecommendationForm.__proto__ || Object.getPrototypeOf(NewRecommendationForm)).call(this, props));

        _this.getTestImages = function () {
            var code = '<center>';
            var t = Math.floor(Date.now() / 1000);

            for (var i = 0; i < _this.props.number_of_products; i++) {
                code += '<img src="https://app.crall.io/beacon/v2/recommendation/' + _this.state.recommendation.account_id + '/' + _this.state.recommendation.description + '/embed?i=' + i + '&timestamp=' + t + '" />';
            }

            code += '</center>';

            return code;
        };

        _this.handleFallbackChange = function (e) {
            var value = e.target.checked;

            if (value == false) {
                value = 1;
            } else {
                value = '';
            }

            _this.setState({
                recommendation: _extends({}, _this.state.recommendation, {
                    fallback: value
                })
            });
        };

        _this.getFallbackValue = function () {
            return _this.state.recommendation.fallback == '' ? true : false;
        };

        _this.changeRecommendationType = function (type) {
            _this.setState({
                recommendation: _extends({}, _this.state.recommendation, {
                    type: type
                })
            });
        };

        _this.testRules = function () {
            _this.setState({
                showTestDialog: true
            });
        };

        _this.renderSaveButton = function () {
            if (!_this.props.enabled) {
                return _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to use recommendations, you\'ll need to subscribe to the \'Recommendation\'-feature.' });
            }

            if (_this.getCurrentAlgorithm().type == 'search' && _this.props.hasSearch != '1') {
                return _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to use personalized search, you need to subscribe to the \'Search\'-feature.' });
            }

            if (_this.getCurrentAlgorithm().type == 'recommendation' && _this.props.hasRecommendation != '1') {
                return _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to use recommendations, you need to subscribe to the \'Recommendation\'-feature.' });
            }

            return _react2.default.createElement(
                'button',
                { type: 'submit', className: 'btn btn-success btn-icon btn-block' },
                _react2.default.createElement('i', { className: 'icon fa-floppy-o' }),
                ' Save recommendation'
            );
        };

        _this.codeMirrorOptions = {
            lineNumbers: true,
            mode: 'text/html',
            indentWithTabs: true,
            styleSelectedText: true,
            tabSize: 5,
            indentUnit: 5
        };

        _this.initialRules = {
            HasAttributes: {
                key: 'has_attributes',
                operator: '=',
                value: 1,
                type: 'and'
            },
            Price: {
                key: 'price',
                operator: '=',
                value: 100,
                type: 'and'
            },
            OnSale: {
                key: 'on_sale',
                operator: '=',
                value: 1,
                type: 'and'
            },
            Quantity: {
                key: 'quantity',
                operator: '>=',
                value: 1,
                type: 'and'
            },
            Category: {
                key: 'category',
                operator: '=',
                value: false,
                type: 'and'
            },
            Brand: {
                key: 'brand',
                operator: '=',
                value: false,
                type: 'and'
            }
        };

        _this.state = {
            codeFor: '',
            provider: '',
            isSaving: false,
            isLoading: false,
            templates: [],
            showTestDialog: false,
            selectedRule: '0',
            recommendation: {
                id: false,
                type: 'shop',
                fallback: '',
                algorithm: 'BestsellersInStore'
            },
            rules: [_this.initialRules.Quantity],
            showAdvancedRules: false,
            showDialog: false
        };

        _this.algorithms = [{
            key: 'BestsellersInStore',
            title: 'Bestsellers in store',
            description: 'Showcase your bestselling products',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'GlobalVisitedProducts',
            title: 'Last product views in store by all customers',
            description: 'Show all products that are viewed by customers right now',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'VisitedProducts',
            title: 'Last visited products',
            description: 'Show the last products the visitor has viewed',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'Newest',
            title: 'Newest products',
            description: 'Showcase your newest products',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'RelevantProduct',
            title: 'Relevant products for a specific product',
            description: 'Products that goes along with a specific product',
            type: 'recommendation',
            usable: 'shop'
        }, {
            key: 'Trending',
            title: 'Trending products',
            description: 'Products that had a sudden increase in number of purchases',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'RelevantBrowsingtIntrest',
            title: 'Recommend by browsing history',
            description: 'Recommend products based on visitor browsing history',
            type: 'recommendation',
            usable: 'all'
        }, {
            key: 'RelevantProductCart',
            title: 'Relevant products based on items in cart',
            description: 'Products that goes along with cart items',
            type: 'recommendation',
            usable: 'shop'
        }, {
            key: 'AlternativeProduct',
            title: 'Alternative products',
            description: 'Products that are similar to a product',
            type: 'recommendation',
            usable: 'shop'
        }, {
            key: 'RelevantOrderRecommendation',
            title: 'Order recommendation',
            description: 'Recommend products based on latest order',
            type: 'recommendation',
            usable: 'all'
        }, {
            usable: 'shop',
            key: 'Search',
            title: 'Search',
            type: 'search',
            description: 'Search for products matching a query. The search result will be weighted based on relevancy, brands, bestsellers and so on.'
        }];

        _this.handleNewTemplate = _this.handleNewTemplate.bind(_this);
        _this.changeRuleDropdown = _this.changeRuleDropdown.bind(_this);
        _this.addRule = _this.addRule.bind(_this);
        _this.handleRuleChange = _this.handleRuleChange.bind(_this);
        _this.deleteRule = _this.deleteRule.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.switchAlgorithm = _this.switchAlgorithm.bind(_this);
        _this.showCode = _this.showCode.bind(_this);
        _this.copyCode = _this.copyCode.bind(_this);
        return _this;
    }

    _createClass(NewRecommendationForm, [{
        key: 'copyCode',
        value: function copyCode() {
            _Notification2.default.success('Code saved to clipboard');
        }
    }, {
        key: 'getCurrentAlgorithm',
        value: function getCurrentAlgorithm() {
            var _this2 = this;

            var algorithm = false;

            this.algorithms.map(function (algo) {
                if (algo.key == _this2.state.recommendation.algorithm) {
                    algorithm = algo;
                }
            });

            return algorithm;
        }
    }, {
        key: 'showCode',
        value: function showCode() {
            var _this3 = this;

            var code = '<div class="crall-recommendation-box" data-recommendation-id="' + this.state.recommendation.description + '"></div>';

            if (this.getCurrentAlgorithm().type == 'search') {
                code = '<div class="crall-search" data-search-container="[CSS_SELECTOR_FOR_SEARCH_INPUT]" data-recommendation-id="' + this.state.recommendation.description + '"></div>';
            }

            if (this.state.recommendation.type == 'email' && this.state.provider != '') {
                code = _RecommendationHelper2.default.emailCode(this.state.recommendation, this.state.provider);
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12' },
                this.state.recommendation.type == 'email' ? _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6' },
                    _react2.default.createElement(
                        'select',
                        { className: 'form-control', value: this.state.provider, onChange: function onChange(e) {
                                return _this3.setState({ provider: e.target.value });
                            } },
                        _react2.default.createElement(
                            'option',
                            { value: '0' },
                            'Select e-mail provider'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'custom' },
                            'Custom'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'apsis' },
                            'Apsis'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'mailchimp' },
                            'Mailchimp'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'crall' },
                            'Crall'
                        )
                    )
                ) : null,
                this.state.recommendation.type == 'shop' || this.state.recommendation.type != '' && this.state.provider != '' ? _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'table',
                        { style: { width: '100%', marginTop: '15px', tableLayout: 'fixed' } },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { style: { width: '80%' }, ref: 'code' },
                                    _react2.default.createElement(_reactCodemirror2.default, { value: code, options: this.codeMirrorOptions })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { textAlign: 'right', width: '20%' } },
                                    _react2.default.createElement(
                                        _reactCopyToClipboard.CopyToClipboard,
                                        {
                                            onCopy: this.copyCode,
                                            options: { message: 'Whoa!' },
                                            text: code },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', onClick: this.copyCode, className: 'btn btn-primary btn-outline' },
                                            'Copy to clipboard'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ) : null
            );
        }
    }, {
        key: 'switchAlgorithm',
        value: function switchAlgorithm(algo) {
            this.props.change('algorithm', algo);

            this.setState({
                recommendation: _extends({}, this.state.recommendation, {
                    algorithm: algo
                })
            });
        }
    }, {
        key: 'deleteRule',
        value: function deleteRule(index) {
            var rules = this.state.rules.filter(function (rule, i) {
                if (i == index) {
                    return false;
                }

                return true;
            });

            this.setState({
                rules: rules
            });
        }
    }, {
        key: 'handleRuleChange',
        value: function handleRuleChange(index, key, value) {

            var rules = this.state.rules.map(function (rule, i) {
                if (i == index) {
                    return Object.assign({}, rule, _defineProperty({}, key, value));
                }

                return rule;
            });

            this.setState({
                rules: rules
            });
        }
    }, {
        key: 'changeRuleDropdown',
        value: function changeRuleDropdown(e) {
            this.setState({ selectedRule: e.target.value });
        }
    }, {
        key: 'addRule',
        value: function addRule() {

            if (this.state.selectedRule == '0') {
                _Notification2.default.error('You must select a rule to add');
                return;
            }

            this.setState({
                rules: [].concat(_toConsumableArray(this.state.rules), [this.initialRules[this.state.selectedRule]]),
                selectedRule: '0'
            });
        }
    }, {
        key: 'handleNewTemplate',
        value: function handleNewTemplate(template) {
            this.setState({
                templates: [].concat(_toConsumableArray(this.state.templates), [template])
            });

            this.props.change('template_id', template.id);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this4 = this;

            _axios2.default.get('/recommendations/templates').then(function (res) {
                _this4.setState({
                    templates: res.data
                });
            });

            if (this.props.recommendationId) {
                this.setState({
                    isLoading: true
                });

                _axios2.default.get('/recommendations/' + this.props.recommendationId).then(function (res) {
                    var rules = res.data.rules;
                    delete res.data.rules;

                    rules = rules.map(function (rule) {
                        if (rule.type == '' || !rule.type) {
                            rule.type = 'and';
                        }
                        return rule;
                    });

                    if (res.data.type == '' || !res.data.type) {
                        res.data.type = 'shop';
                    }

                    if (res.data.fallback == '' || !res.data.fallback) {
                        res.data.fallback = '';
                    }

                    _this4.props.change('description', res.data.description);
                    _this4.props.change('algorithm', res.data.algorithm);
                    _this4.props.change('template_id', res.data.template_id);
                    _this4.props.change('number_of_products', res.data.number_of_products);
                    _this4.props.change('visible', res.data.visible);

                    _this4.setState({
                        recommendation: res.data,
                        rules: rules,
                        isLoading: false
                    });
                });
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(data) {
            var _this5 = this;

            data = Object.assign({}, this.state.recommendation, data);
            data.rules = this.state.rules;
            this.setState({
                isSaving: true
            });

            var method = 'post';
            var url = '/recommendations';

            if (this.props.recommendationId) {
                method = 'put';
                url += '/' + this.props.recommendationId;
            }

            _axios2.default[method](url, data).then(function (response) {
                _Notification2.default.success('Recommendation saved');
                _this5.setState({
                    isSaving: false,
                    recommendation: response.data
                });

                _this5.props.onSubmit(response.data.id);
            }).catch(function (error) {
                _Notification2.default.error(error.message);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var handleSubmit = this.props.handleSubmit;


            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    { onSubmit: handleSubmit(this.onSubmit.bind(this)) },
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '1. Recommendation ID', description: 'Give this recommendation a unique ID. You\'ll use this value when you\'re embedding our recommendations.' },
                        _react2.default.createElement(_reduxForm.Field, { component: _text2.default, name: 'description', placeholder: 'MyAwesomeRecommendation' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            'Recommendation ID can only contain a-z and 0-9'
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '2. Type', description: 'Where do you want to impletement the widget' },
                        _react2.default.createElement(_WidgetType2.default, {
                            key: 'shop',
                            value: this.state.recommendation.type,
                            handleClick: this.changeRecommendationType,
                            type: 'shop',
                            title: 'Shop',
                            description: 'I want to display this widget in my shop.'
                        }),
                        _react2.default.createElement(_WidgetType2.default, {
                            key: 'email',
                            value: this.state.recommendation.type,
                            handleClick: this.changeRecommendationType,
                            type: 'email',
                            title: 'E-mails',
                            description: 'I want to use this widget in my emails'
                        })
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '3. Product selection', description: 'Recommendation type' },
                        this.algorithms.map(function (algo) {
                            if (_this6.state.recommendation.type == algo.usable || algo.usable == 'all') {
                                return _react2.default.createElement(_Type2.default, {
                                    key: algo.key,
                                    value: _this6.state.recommendation.algorithm,
                                    handleClick: _this6.switchAlgorithm,
                                    algorithm: algo.key,
                                    title: algo.title,
                                    description: algo.description
                                });
                            }
                        })
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '4. Product filtering', description: 'Select additional rules' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-5' },
                            _react2.default.createElement(_reduxForm.Field, { component: _numberpicker2.default, min: 1, max: 24, affix: 'products', title: 'How many products should presented to the visitor:', name: 'number_of_products' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-5' },
                            this.getCurrentAlgorithm().type == 'search' ? null : _react2.default.createElement(_reduxForm.Field, { component: _numberpicker2.default, min: 1, max: 10, affix: 'products', title: 'Number of products that should be displayed at once:', name: 'visible' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'form-control-label' },
                                    '\xA0'
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-dark', onClick: function onClick() {
                                            _this6.setState({ showAdvancedRules: !_this6.state.showAdvancedRules });
                                        } },
                                    _react2.default.createElement('i', { className: 'icon wb-more-vertical' }),
                                    'Advanced'
                                )
                            )
                        ),
                        this.state.showAdvancedRules ? _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 ' },
                            _react2.default.createElement(_SplitRow2.default, null),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12 p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 p-0' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-8 p-0' },
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control', value: this.state.selectedRule, onChange: this.changeRuleDropdown },
                                            _react2.default.createElement(
                                                'option',
                                                { value: '0' },
                                                'Select a rule'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'HasAttributes' },
                                                'Has attributes'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'Price' },
                                                'Price'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'OnSale' },
                                                'Is on sale'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'Quantity' },
                                                'Quantity'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'Category' },
                                                'Category'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: 'Brand' },
                                                'Brand'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-2' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-dark', onClick: this.addRule },
                                            _react2.default.createElement('i', { className: 'icon wb-plus' })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-2' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-dark', onClick: this.testRules },
                                            'Test rules'
                                        )
                                    ),
                                    _react2.default.createElement(_SplitRow2.default, null)
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 p-0' },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'table' },
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.rules.map(function (rule, i) {
                                                return _react2.default.createElement(_Rule2.default, { 'delete': _this6.deleteRule, handleRuleChange: _this6.handleRuleChange, key: i, rule: rule, index: i });
                                            })
                                        )
                                    )
                                ),
                                _react2.default.createElement(_SplitRow2.default, null),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 p-0' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'checkbox-custom checkbox-primary' },
                                        _react2.default.createElement('input', { type: 'checkbox', checked: this.getFallbackValue(), onChange: this.handleFallbackChange }),
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Fill with random products if the widget are missing products'
                                        )
                                    )
                                )
                            )
                        ) : null
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '5. Template', description: 'Pick a template to render' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-10' },
                            _react2.default.createElement(_reduxForm.Field, { component: _dropdown2.default, placeholder: 'Select template', name: 'template_id',
                                options: this.state.templates.map(function (template) {
                                    return {
                                        label: '#' + template.id + ' - ' + template.description,
                                        value: template.id
                                    };
                                }) })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-2' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-dark', onClick: function onClick() {
                                        _this6.setState({ showDialog: true });
                                    } },
                                _react2.default.createElement('i', { className: 'icon fa-plus' }),
                                ' New template'
                            )
                        )
                    ),
                    _react2.default.createElement(_SplitRow2.default, null),
                    _react2.default.createElement(
                        _OptionColumn2.default,
                        { title: '6. Code', description: 'Save recommendation and get your implementation code' },
                        _react2.default.createElement(
                            'div',
                            { className: 'alert alert-primary', role: 'alert', style: { display: 'inline-block', width: '100%' } },
                            this.state.recommendation.id ? this.showCode() : "You must save this recommendation before your can get your code."
                        ),
                        this.state.isSaving ? _react2.default.createElement(_LoadingSmall2.default, null) : this.renderSaveButton()
                    ),
                    _react2.default.createElement(_SplitRow2.default, null)
                ),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this6.setState({ showDialog: false });
                        }, isOpened: this.state.showDialog },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(_template2.default, { handleSave: this.handleNewTemplate, enabled: true, onClose: function onClose(e) {
                                _this6.setState({ showDialog: false });
                            }, recommendationId: false })
                    )
                ),
                _react2.default.createElement(
                    _reactPortal2.default,
                    { closeOnEsc: true, onClose: function onClose(e) {
                            _this6.setState({ showTestDialog: false });
                        }, isOpened: this.state.showTestDialog },
                    _react2.default.createElement(
                        _FullScreenOverlay2.default,
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 text-center' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                'Preview'
                            ),
                            _react2.default.createElement(
                                'h2',
                                null,
                                'The products will appear below. It may take a couple of seconds before it loads'
                            ),
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement('div', { style: { width: '600px', marginLeft: 'auto', marginRight: 'auto' }, dangerouslySetInnerHTML: { __html: this.getTestImages() } })
                        )
                    )
                )
            );
        }
    }]);

    return NewRecommendationForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

var selector = (0, _reduxForm.formValueSelector)('NewRecommendationForm');

// Decorate the form component
NewRecommendationForm = (0, _reduxForm.reduxForm)({
    form: 'NewRecommendationForm',
    validate: validate
})(NewRecommendationForm);

NewRecommendationForm = (0, _reactRedux.connect)(function (state) {
    return {
        number_of_products: selector(state, 'number_of_products'),
        initialValues: {
            number_of_products: 12,
            visible: 4,
            algorithm: 'BestsellersInStore'
        }
    };
})(NewRecommendationForm);

exports.default = NewRecommendationForm;

/***/ }),

/***/ 1735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = function field(_ref) {
    var input = _ref.input,
        options = _ref.options,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group ' + (touched && error ? 'has-danger' : '') },
        typeof title === 'undefined' ? null : _react2.default.createElement(
            'label',
            { className: 'form-control-label' },
            title
        ),
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: 'form-control', type: 'text', disabled: typeof disabled === 'undefined' ? false : disabled, autoComplete: 'off' })),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

exports.default = field;

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NumberPicker = __webpack_require__(398);

var _NumberPicker2 = _interopRequireDefault(_NumberPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var field = function field(_ref) {
    var props = _objectWithoutProperties(_ref, []),
        input = _ref.input,
        min = _ref.min,
        max = _ref.max,
        options = _ref.options,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        affix = _ref.affix,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;

    return _react2.default.createElement(
        'div',
        { className: 'form-group ' + (touched && error ? 'has-danger' : '') },
        typeof title === 'undefined' ? null : _react2.default.createElement(
            'label',
            { className: 'form-control-label' },
            title
        ),
        _react2.default.createElement(_NumberPicker2.default, { min: min, max: max, value: props.input.value, handleChange: props.input.onChange, type: affix }),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

exports.default = field;

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NumberPicker = __webpack_require__(398);

var _NumberPicker2 = _interopRequireDefault(_NumberPicker);

var _CategoryPicker = __webpack_require__(386);

var _CategoryPicker2 = _interopRequireDefault(_CategoryPicker);

var _ManufacturerPicker = __webpack_require__(385);

var _ManufacturerPicker2 = _interopRequireDefault(_ManufacturerPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.handleCategoryChange = function (type, o, values) {
            var v = [];

            for (var i in values) {
                if (type == 'manufacturers') {
                    v.push(values[i].manufacturer);
                } else {
                    v.push(values[i].id);
                }
            }
            v = v.join(',');

            if (v == '') {
                v = false;
            }

            _this.props.handleRuleChange(_this.props.index, 'value', v);
        };

        _this.settings = {
            'on_sale': {
                title: 'Product must be on sale',
                isBool: true
            },
            'price': {
                title: 'Price must be',
                isBool: false
            },
            'has_attributes': {
                title: 'Product must have attributes',
                isBool: true
            },
            'quantity': {
                title: 'Product quantity must be',
                isBool: false
            },
            'category': {
                title: 'Product must',
                browseCategory: true
            },
            'brand': {
                title: 'Product must',
                browseBrand: true
            }
        };

        _this.renderOutput = _this.renderOutput.bind(_this);
        _this.handleRuleChange = _this.handleRuleChange.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: "rule",
        value: function rule() {
            return this.settings[this.props.rule.key];
        }
    }, {
        key: "handleRuleChange",
        value: function handleRuleChange(key, value) {
            this.props.handleRuleChange(this.props.index, key, value);
        }
    }, {
        key: "renderOutput",
        value: function renderOutput() {
            var _this2 = this;

            if (this.rule().isBool) {
                return _react2.default.createElement(
                    "select",
                    { value: this.props.rule.value, onChange: function onChange(e) {
                            return _this2.handleRuleChange('value', e.target.value);
                        }, className: "form-control" },
                    _react2.default.createElement(
                        "option",
                        { value: 1 },
                        "Yes"
                    ),
                    _react2.default.createElement(
                        "option",
                        { value: 0 },
                        "No"
                    )
                );
            }

            if (this.rule().browseCategory) {
                return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-3 p-0" },
                        _react2.default.createElement(
                            "select",
                            { value: this.props.rule.operator, onChange: function onChange(e) {
                                    return _this2.handleRuleChange('operator', e.target.value);
                                }, className: "form-control" },
                            _react2.default.createElement(
                                "option",
                                { value: "=" },
                                "be in category"
                            ),
                            _react2.default.createElement(
                                "option",
                                { value: "!=" },
                                "not be in category"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-3 p-0 p-l-5" },
                        _react2.default.createElement(
                            "select",
                            { value: this.props.rule.type, onChange: function onChange(e) {
                                    return _this2.handleRuleChange('type', e.target.value);
                                }, className: "form-control" },
                            _react2.default.createElement(
                                "option",
                                { value: "and" },
                                "match all"
                            ),
                            _react2.default.createElement(
                                "option",
                                { value: "or" },
                                "match one"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6 p-0 p-l-5" },
                        _react2.default.createElement(_CategoryPicker2.default, { handleRuleChange: this.handleCategoryChange, useExternalId: true, rule: {
                                value: this.props.rule.value,
                                id: false
                            }, index: "categories" })
                    )
                );
            }

            if (this.rule().browseBrand) {
                return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-3 p-0" },
                        _react2.default.createElement(
                            "select",
                            { value: this.props.rule.operator, onChange: function onChange(e) {
                                    return _this2.handleRuleChange('operator', e.target.value);
                                }, className: "form-control" },
                            _react2.default.createElement(
                                "option",
                                { value: "=" },
                                "have"
                            ),
                            _react2.default.createElement(
                                "option",
                                { value: "!=" },
                                "not have"
                            )
                        )
                    ),
                    _react2.default.createElement("div", { className: "col-sm-3 p-0 p-l-5" }),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6 p-0 p-l-5" },
                        _react2.default.createElement(_ManufacturerPicker2.default, { handleRuleChange: this.handleCategoryChange, useExternalId: true, rule: {
                                value: this.props.rule.value,
                                id: false
                            }, index: "manufacturers" })
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-3 p-0" },
                    _react2.default.createElement(
                        "select",
                        { value: this.props.rule.operator, onChange: function onChange(e) {
                                return _this2.handleRuleChange('operator', e.target.value);
                            }, className: "form-control" },
                        _react2.default.createElement(
                            "option",
                            { value: "<=" },
                            "less or equal to"
                        ),
                        _react2.default.createElement(
                            "option",
                            { value: ">=" },
                            "more or equal to"
                        )
                    )
                ),
                _react2.default.createElement("div", { className: "col-sm-3 p-0 p-l-5" }),
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-6 p-0 p-l-5" },
                    _react2.default.createElement(_NumberPicker2.default, { min: 1, max: 999999, value: this.props.rule.value, handleChange: function handleChange(e) {
                            return _this2.handleRuleChange('value', e);
                        } })
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                    "td",
                    null,
                    this.rule().title
                ),
                _react2.default.createElement(
                    "td",
                    null,
                    this.renderOutput()
                ),
                _react2.default.createElement(
                    "td",
                    null,
                    _react2.default.createElement(
                        "button",
                        { type: "button", className: "btn btn-danger", onClick: function onClick() {
                                return _this3.props.delete(_this3.props.index);
                            } },
                        _react2.default.createElement("i", { className: "icon wb-trash" })
                    )
                )
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = function field(props) {
    return _react2.default.createElement(
        'div',
        { className: 'col-lg-6 col-xs-12', onClick: function onClick() {
                props.handleClick(props.algorithm);
            } },
        _react2.default.createElement(
            'div',
            { className: 'card card-block p-35 clearfix item-selection ' + (props.algorithm == props.value ? 'selected' : null) },
            _react2.default.createElement(
                'div',
                { className: 'counter counter-md pull-xs-left text-xs-left' },
                _react2.default.createElement(
                    'div',
                    { className: 'counter-number-group font-size-20' },
                    _react2.default.createElement(
                        'span',
                        { className: 'counter-number-related font-size-16' },
                        props.title
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'counter-label font-size-12' },
                    props.description
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'pull-xs-right white' },
                _react2.default.createElement('i', { className: 'icon icon-circle icon-2x wb-check item-status', 'aria-hidden': 'true' })
            )
        )
    );
};

exports.default = field;

/***/ }),

/***/ 1739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = function field(props) {
    return _react2.default.createElement(
        'div',
        { className: 'col-lg-6 col-xs-12', onClick: function onClick() {
                props.handleClick(props.type);
            } },
        _react2.default.createElement(
            'div',
            { className: 'card card-block p-35 clearfix item-selection ' + (props.type == props.value ? 'selected' : null) },
            _react2.default.createElement(
                'div',
                { className: 'counter counter-md pull-xs-left text-xs-left' },
                _react2.default.createElement(
                    'div',
                    { className: 'counter-number-group font-size-20' },
                    _react2.default.createElement(
                        'span',
                        { className: 'counter-number-related font-size-16' },
                        props.title
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'counter-label font-size-12' },
                    props.description
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'pull-xs-right white' },
                _react2.default.createElement('i', { className: 'icon icon-circle icon-2x wb-check item-status', 'aria-hidden': 'true' })
            )
        )
    );
};

exports.default = field;

/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCountup = __webpack_require__(672);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _reactDates = __webpack_require__(205);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactChartjs = __webpack_require__(673);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stats = function (_React$Component) {
    _inherits(Stats, _React$Component);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _this.onDatesChange = function (_ref) {
            var startDate = _ref.startDate,
                endDate = _ref.endDate;

            _this.setState({ startDate: startDate, endDate: endDate });
            _this.get(startDate, endDate);
        };

        _this.onFocusChange = function (focusedInput) {
            _this.setState({ focusedInput: focusedInput });
        };

        _this.generateGraphData = function () {
            var graph = {
                labels: [],
                datasets: [{
                    label: 'Revenue',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0,21,123,0.4)',
                    borderColor: 'rgba(0,21,123,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0,21,123,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0,21,123,1)',
                    pointHoverBorderColor: 'rgba(0,21,123,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                }, {
                    label: 'Orders',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(1,87,155,0.4)',
                    borderColor: 'rgba(1,87,155,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(1,87,155,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(1,87,155,1)',
                    pointHoverBorderColor: 'rgba(1,87,155,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                }, {
                    label: 'Clicks',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(66,66,66,0.4)',
                    borderColor: 'rgba(66,66,66,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(66,66,66,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba66,66,66,1)',
                    pointHoverBorderColor: 'rgba(66,66,66,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                }]
            };

            for (var i in _this.state.report.graph) {
                graph.labels.push(i);
                graph.datasets[0].data.push(_this.state.report.graph[i].revenue / 100);
                graph.datasets[1].data.push(_this.state.report.graph[i].orders);
                graph.datasets[2].data.push(_this.state.report.graph[i].clicks);
            }
            return graph;
        };

        _this.state = {
            isLoading: true,
            isError: false,
            report: false,
            startDateId: '1',
            stopDateId: '2',
            initialStart: (0, _moment2.default)((0, _moment2.default)().subtract(30, 'days')),
            initialEnd: (0, _moment2.default)(),
            startDate: (0, _moment2.default)((0, _moment2.default)().subtract(30, 'days')),
            endDate: (0, _moment2.default)()
        };

        return _this;
    }

    _createClass(Stats, [{
        key: 'get',
        value: function get() {
            var _this2 = this;

            var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            if (!from) {
                from = this.state.startDate;
            }
            if (!to) {
                to = this.state.endDate;
            }
            this.setState({
                'isLoading': true
            });

            if (!to || !from) {
                this.setState({
                    startDate: this.state.initialEnd,
                    endDate: this.state.initialStart
                });

                _Notification2.default.error('Error: Invalid date, resetting to last month.');
                to = this.state.initialEnd;
                from = this.state.initialStart;
            }

            _axios2.default.get('/stats?type=' + this.props.router.params.type + '&id=' + this.props.router.params.id, {
                params: {
                    'from': (0, _moment2.default)(from).format('YYYY-MM-DD'),
                    'to': (0, _moment2.default)(to).format('YYYY-MM-DD')
                }
            }).then(function (res) {
                _this2.setState({
                    isError: false,
                    isLoading: false,
                    report: res.data
                });
            }).catch(function () {
                _this2.setState({
                    isError: true
                });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.get();
        }
    }, {
        key: 'render',
        value: function render() {
            var _React$createElement;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-graph-up' }),
                        ' Statistics'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(_reactDates.DateRangePicker, (_React$createElement = {
                            startDateId: this.state.startDateId,
                            endDateId: this.state.stopDateId,
                            onDatesChange: this.onDatesChange,
                            onFocusChange: this.onFocusChange
                        }, _defineProperty(_React$createElement, 'startDateId', 'start_date'), _defineProperty(_React$createElement, 'endDateId', 'end_date'), _defineProperty(_React$createElement, 'small', true), _defineProperty(_React$createElement, 'focusedInput', this.state.focusedInput), _defineProperty(_React$createElement, 'startDate', this.state.startDate), _defineProperty(_React$createElement, 'endDate', this.state.endDate), _defineProperty(_React$createElement, 'isOutsideRange', function isOutsideRange() {
                            return false;
                        }), _defineProperty(_React$createElement, 'anchorDirection', 'left'), _defineProperty(_React$createElement, 'showDefaultInputIcon', true), _React$createElement))
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Stats | Crall.io' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-thumb-up', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            _react2.default.createElement(_reactCountup2.default, { start: 0, end: this.state.report.clicks, duration: 2 })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Clicks'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-shopping-cart', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            _react2.default.createElement(_reactCountup2.default, { start: 0, end: this.state.report.orders, duration: 2 })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Orders'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-payment', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            _react2.default.createElement(_reactCountup2.default, { start: 0, end: this.state.report.revenue / 100, duration: 2 })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Revenue'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-block p-30' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card-watermark blue-grey-500 font-size-60 m-15' },
                                    _react2.default.createElement('i', { className: 'icon wb-stats-bars', 'aria-hidden': 'true' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'counter counter-md counter-inverse text-xs-left' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-number-group ' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'counter-number blue-grey-500' },
                                            _react2.default.createElement(_reactCountup2.default, { start: 0, end: this.state.report.conversion_rate, duration: 2 }),
                                            '%'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'counter-label blue-grey-500 text-capitalize' },
                                        'Conversion rate'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'card card-block p-30' },
                            _react2.default.createElement(_reactChartjs.Line, { data: this.generateGraphData })
                        )
                    )
                )
            );
        }
    }]);

    return Stats;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Stats = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Stats);
exports.default = Stats;

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _OptionColumn = __webpack_require__(23);

var _OptionColumn2 = _interopRequireDefault(_OptionColumn);

var _SplitRow = __webpack_require__(29);

var _SplitRow2 = _interopRequireDefault(_SplitRow);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(44);

var _General4 = _interopRequireDefault(_General3);

var _reactRouter = __webpack_require__(6);

var _SplitRow3 = __webpack_require__(29);

var _SplitRow4 = _interopRequireDefault(_SplitRow3);

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsletterIndex = function (_React$Component) {
    _inherits(NewsletterIndex, _React$Component);

    function NewsletterIndex(props) {
        _classCallCheck(this, NewsletterIndex);

        var _this = _possibleConstructorReturn(this, (NewsletterIndex.__proto__ || Object.getPrototypeOf(NewsletterIndex)).call(this, props));

        _this.handleEdit = function (id) {
            _this.props.router.push(_General2.default.Link('/builder/email/' + id));
        };

        _this.renderNewsletterRow = function (newsletter) {
            return _react2.default.createElement(
                'tr',
                { key: newsletter.id },
                _react2.default.createElement(
                    'td',
                    { style: { textAlign: 'left', width: '45%' } },
                    _react2.default.createElement(
                        'strong',
                        null,
                        newsletter.subject
                    ),
                    newsletter.status == 1 ? _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'i',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                'List:'
                            ),
                            ' ',
                            newsletter.tags.SendToList
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'i',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                'Sent:'
                            ),
                            ' ',
                            _moment2.default.utc(newsletter.tags.sent).local().calendar()
                        ),
                        _react2.default.createElement('br', null)
                    ) : null
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? 'Sent' : 'Draft'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? newsletter.open : _this.placeholder()
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? newsletter.click : _this.placeholder()
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? newsletter.conversion : _this.placeholder()
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? newsletter.revenue : _this.placeholder()
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 1 ? newsletter.sent : _this.placeholder()
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    newsletter.status == 0 ? _react2.default.createElement(
                        'div',
                        { className: 'btn-group', role: 'group' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', onClick: function onClick(e) {
                                    e.stopPropagation();_this.handleEdit(newsletter.id);
                                }, className: 'btn btn-icon btn-default btn-outline' },
                            _react2.default.createElement('i', { className: 'icon wb-pencil', 'aria-hidden': 'true' })
                        )
                    ) : _this.placeholder()
                )
            );
        };

        _this.state = {
            newsletters: [],
            isLoading: true
        };
        return _this;
    }

    _createClass(NewsletterIndex, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _axios2.default.get('/newsletters').then(function (res) {
                _this2.setState({
                    newsletters: res.data,
                    isLoading: false
                });
            });
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            return _react2.default.createElement(
                'span',
                { className: 'tag tag-default', style: { display: 'inline-block', width: '35%' } },
                '\xA0'
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: false });
            }

            return _react2.default.createElement(
                'div',
                { className: 'full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'span',
                        { className: 'page-title' },
                        _react2.default.createElement('i', { className: 'icon wb-tag' }),
                        ' Newsletters'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'page-header-actions' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: _General2.default.Link("/discounts/new"), className: 'btn btn-dark' },
                            _react2.default.createElement('i', { className: 'icon fa-plus', style: { marginRight: '10px' } }),
                            '  New'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    _react2.default.createElement(_reactHelmet2.default, { title: 'Newsletters | Crall.io' }),
                    this.state.newsletters.map(function (month, i) {
                        return _react2.default.createElement(
                            'div',
                            { key: i },
                            _react2.default.createElement(
                                _OptionColumn2.default,
                                { cols: { left: 2, right: 10 }, title: month.month, panel: false, description: 'Created newsletters' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'table outline' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Subject'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Status'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Opens'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Clicks'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Conversion'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Revenue'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Recipients'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Actions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        month.newsletters.map(function (newsletter) {
                                            return _this3.renderNewsletterRow(newsletter);
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(_SplitRow4.default, null)
                        );
                    })
                )
            );
        }
    }]);

    return NewsletterIndex;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

NewsletterIndex = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewsletterIndex);
exports.default = NewsletterIndex;

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//this.props.router.push(General.Link('/settings/billing/plan'))
var UpgradeRequired = function UpgradeRequired(props) {
    return _react2.default.createElement(
        'div',
        { className: 'alert alert-icon alert-warning alert-dismissible', role: 'alert' },
        _react2.default.createElement('i', { className: 'icon wb-bell', 'aria-hidden': 'true' }),
        '  ',
        props.message,
        _react2.default.createElement(
            'p',
            { className: 'm-t-15' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: _General2.default.Link('/settings/billing/plan'), className: 'btn btn-warning' },
                'Upgrade'
            )
        )
    );
};

exports.default = UpgradeRequired;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoResult = function NoResult(_ref) {
	var button = _ref.button,
	    link = _ref.link,
	    header = _ref.header,
	    body = _ref.body,
	    action = _ref.action;
	return _react2.default.createElement(
		'div',
		{ className: 'offset-sm-3 col-md-6 no-results' },
		_react2.default.createElement(
			'div',
			{ className: 'panel panel-bordered', style: { border: '1px solid #e4eaec' } },
			_react2.default.createElement(
				'div',
				{ className: 'panel-body text-center', style: { textAlign: 'center' } },
				_react2.default.createElement('br', null),
				_react2.default.createElement('i', { className: 'icon wb-alert-circle', 'aria-hidden': 'true', style: { fontSize: '80px' } }),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement('br', null),
					header,
					_react2.default.createElement('br', null),
					body
				),
				link && !action ? _react2.default.createElement(
					_reactRouter.Link,
					{ to: _General2.default.Link(link), className: 'btn btn-default' },
					button
				) : null,
				!link && action ? _react2.default.createElement(
					'button',
					{ onClick: action, className: 'btn btn-default' },
					button
				) : null,
				_react2.default.createElement('br', null)
			)
		)
	);
};

exports.default = NoResult;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionColumn = function OptionColumn(_ref) {
    var title = _ref.title,
        description = _ref.description,
        children = _ref.children,
        panel = _ref.panel,
        cols = _ref.cols;
    return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
            'div',
            { className: 'col-sm-' + (cols ? cols.left : '3') + ' col-description' },
            _react2.default.createElement(
                'div',
                { className: 'title' },
                title
            ),
            _react2.default.createElement(
                'div',
                { className: 'description' },
                description
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'col-sm-' + (cols ? cols.right : '9') + ' inherit-position' },
            panel === false ? children : _react2.default.createElement(
                'div',
                { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                _react2.default.createElement(
                    'div',
                    { className: 'panel-body' },
                    children
                )
            )
        )
    );
};

exports.default = OptionColumn;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spin2Win = function Spin2Win() {
	return _react2.default.createElement(
		"div",
		{ className: "spin2win" },
		_react2.default.createElement("div", { className: "double-bounce1" }),
		_react2.default.createElement("div", { className: "double-bounce2" })
	);
};

exports.default = Spin2Win;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDnd = __webpack_require__(163);

var _ItemTypes = __webpack_require__(169);

var _ItemTypes2 = _interopRequireDefault(_ItemTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import Wrapper from './BuilderWrapper.js';


/**
 * Specifies the drop target contract.
 * All methods are optional.
 */
var chessSquareTarget = {
    canDrop: function canDrop(props, monitor) {
        var item = monitor.getItemType();
        return true;
    },
    hover: function hover(props, monitor, component) {
        //
        //
    },
    drop: function drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return;
        }
        return;

        return;
        var item = monitor.getItem();
        //  console.log('DROP');
        // 

        var el = {};
        el.rowId = component.props.row.index;
        el.colId = component.props.colId;
        el.type = 'text';

        //   

        component.props.addElement(el);
    }
};

/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
}

var DroppableElement = function (_React$Component) {
    _inherits(DroppableElement, _React$Component);

    function DroppableElement(props) {
        _classCallCheck(this, DroppableElement);

        return _possibleConstructorReturn(this, (DroppableElement.__proto__ || Object.getPrototypeOf(DroppableElement)).call(this, props));
    }

    _createClass(DroppableElement, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.isOver && nextProps.isOver) {
                // You can use this as enter handler
                // console.log('1');
            }

            if (this.props.isOver && !nextProps.isOver) {
                // You can use this as leave handler
                // console.log('2');
            }

            if (this.props.isOverCurrent && !nextProps.isOverCurrent) {
                // You can be more specific and track enter/leave
                // shallowly, not including nested targets
                // console.log('3');
            }
        }
    }, {
        key: 'renderPlaceholder',
        value: function renderPlaceholder(child) {
            var _props = this.props,
                isOver = _props.isOver,
                canDrop = _props.canDrop,
                connectDropTarget = _props.connectDropTarget;


            var elementsToRender = [];

            //if(!isOver && canDrop) {
            if (isOver && canDrop) {
                elementsToRender.push(_react2.default.createElement(
                    'div',
                    { key: 'a', className: 'drop-placeholder' },
                    'Drop here ty'
                ));
            } else {
                elementsToRender.push(_react2.default.cloneElement(child, child.props));
            }

            return elementsToRender;
        }
    }, {
        key: 'render',
        value: function render() {
            // Your component receives its own props as usual
            var position = this.props.position;


            var classes = "";
            if (this.props.classes) {
                classes = this.props.classes;
            }

            var styles = {};
            if (this.props.styles) {
                styles = this.props.styles;
            }

            //

            // These props are injected by React DnD,
            // as defined by your `collect` function above:
            var _props2 = this.props,
                isOver = _props2.isOver,
                canDrop = _props2.canDrop,
                connectDropTarget = _props2.connectDropTarget;


            return connectDropTarget(_react2.default.createElement(
                this.props.type,
                { style: styles, className: classes },
                this.props.children
            ));
        }
    }]);

    return DroppableElement;
}(_react2.default.Component);

exports.default = (0, _reactDnd.DropTarget)(function (props) {
    return _ItemTypes2.default.CARD;
}, chessSquareTarget, collect)(DroppableElement);

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnPicker = function (_React$Component) {
    _inherits(ColumnPicker, _React$Component);

    function ColumnPicker(props) {
        _classCallCheck(this, ColumnPicker);

        var _this = _possibleConstructorReturn(this, (ColumnPicker.__proto__ || Object.getPrototypeOf(ColumnPicker)).call(this, props));

        _this.renderOption = _this.renderOption.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.isChecked = _this.isChecked.bind(_this);

        if (!localStorage.getItem('columns_' + _this.props.storage)) {
            var items = [];

            for (var i in _this.props.columns) {
                if (_this.props.columns[i].default === true) {
                    items.push(_this.props.columns[i].key);
                }
            }
            localStorage.setItem('columns_' + _this.props.storage, items);
        }
        return _this;
    }

    _createClass(ColumnPicker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.update(localStorage.getItem('columns_' + this.props.storage).split(','));
        }
    }, {
        key: 'isChecked',
        value: function isChecked(key) {
            var data = localStorage.getItem('columns_' + this.props.storage);

            if (!data) {
                return false;
            }

            return data.split(',').includes(key);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var key = e.target.getAttribute('data-key');
            var data = localStorage.getItem('columns_' + this.props.storage);

            if (!data) {
                data = '';
            }

            data = data.split(',');

            if (data.includes(key)) {
                data = data.filter(function (item) {
                    return item == key ? false : true;
                });
            } else {
                data.push(key);
            }

            data = data.filter(function (item) {
                return item == '' ? false : true;
            });

            localStorage.setItem('columns_' + this.props.storage, data.join(','));

            this.props.update(data);
        }
    }, {
        key: 'renderOption',
        value: function renderOption(type) {
            return _react2.default.createElement(
                'a',
                { className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', key: type.key },
                _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block', marginRight: '10px' }, className: 'checkbox-custom checkbox-primary' },
                    _react2.default.createElement('input', { type: 'checkbox', id: this.props.storage + '_' + type.key, 'data-key': type.key, onChange: this.handleChange, checked: this.isChecked(type.key) }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: this.props.storage + '_' + type.key },
                        type.text
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { style: { marginRight: '10px' }, className: 'column-picker btn-group dropdown' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
                    _react2.default.createElement('i', { className: 'icon wb-settings' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu dropdown-menu-bullet dropdown-menu-right', role: 'menu' },
                    this.props.columns.map(function (type) {
                        return _this2.renderOption(type);
                    })
                )
            );
        }
    }]);

    return ColumnPicker;
}(_react2.default.Component);

exports.default = ColumnPicker;

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.email) {
        errors.email = 'Required';
    } else if (!_General2.default.validateEmail(values.email)) {
        errors.email = 'Invalid e-mail format';
    }

    if (!values.name) {
        errors.name = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var EmailDetails = function (_React$Component) {
    _inherits(EmailDetails, _React$Component);

    function EmailDetails() {
        _classCallCheck(this, EmailDetails);

        return _possibleConstructorReturn(this, (EmailDetails.__proto__ || Object.getPrototypeOf(EmailDetails)).apply(this, arguments));
    }

    _createClass(EmailDetails, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Acme Inc', name: 'name', className: 'form-control', title: 'Name' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'email', placeholder: 'support@acme.com', title: 'E-mail', className: 'form-control' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 text-center' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-sm-8 offset-sm-2', style: { border: '1px solid #ccc', backgroundColor: '#fff', borderRadius: '5px', padding: '10px' } },
                            _react2.default.createElement(
                                'label',
                                { className: 'control-label' },
                                'What your customers will see as sender in their inbox'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'span',
                                { className: 'sender-name', style: { fontWeight: 'bold' } },
                                this.props.name ? this.props.name : 'Acme Inc'
                            ),
                            '\xA0\xA0 <',
                            _react2.default.createElement(
                                'span',
                                { className: 'sender-email', style: { fontWeight: 'bold' } },
                                this.props.email ? this.props.email : 'support@acme.com'
                            ),
                            ' >'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row m-t-20' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { type: 'submit', className: 'btn btn-dark btn-block' },
                                'Update'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return EmailDetails;
}(_react2.default.Component);

var selector = (0, _reduxForm.formValueSelector)('EmailDetails');

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
EmailDetails = (0, _reduxForm.reduxForm)({
    form: 'EmailDetails',
    validate: validate
})(EmailDetails);

EmailDetails = (0, _reactRedux.connect)(function (state) {
    return {
        name: selector(state, 'name'),
        email: selector(state, 'email'),
        initialValues: {
            name: state.general.settings.EMAIL_SENDER_NAME,
            email: state.general.settings.EMAIL_SENDER_EMAIL
        }
    };
})(EmailDetails);

exports.default = EmailDetails;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.year) {
        errors.year = 'Required';
    }

    if (!values.cvc) {
        errors.cvc = 'Required';
    }

    if (!values.month) {
        errors.month = 'Required';
    }

    if (!values.cardnumber) {
        errors.cardnumber = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var BillingInformation = function (_React$Component) {
    _inherits(BillingInformation, _React$Component);

    function BillingInformation() {
        _classCallCheck(this, BillingInformation);

        return _possibleConstructorReturn(this, (BillingInformation.__proto__ || Object.getPrototypeOf(BillingInformation)).apply(this, arguments));
    }

    _createClass(BillingInformation, [{
        key: 'years',
        value: function years() {
            var years = [];
            var today = new Date().getFullYear();
            for (var i = today; i <= parseInt(today) + 10; i++) {
                years.push({
                    'value': i,
                    'label': i
                });
            }
            return years;
        }
    }, {
        key: 'month',
        value: function month() {
            var month = [];

            for (var i = 1; i <= 12; i++) {
                month.push({
                    'value': i,
                    'label': i
                });
            }
            return month;
        }
    }, {
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 offset-sm-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-heading' },
                                _react2.default.createElement(
                                    'h3',
                                    { className: 'panel-title' },
                                    'Payment'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-body' },
                                this.props.errorMessage !== false ? _react2.default.createElement(
                                    'div',
                                    { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                                    _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                                    this.props.errorMessage
                                ) : null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'cardnumber', placeholder: '123412341234', title: 'Credit card number', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: select, options: this.month(), name: 'month', title: 'Expiry month' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: select, options: this.years(), name: 'year', title: 'Expiry year' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'cvc', placeholder: '123', title: 'CVC', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row m-t-20' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                            'button',
                                            { type: 'submit', className: 'btn btn-dark btn-block' },
                                            this.props.buttonText ? this.props.buttonText : 'Confirm payment'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return BillingInformation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
BillingInformation = (0, _reduxForm.reduxForm)({
    form: 'BillingInformation',
    validate: validate
})(BillingInformation);

BillingInformation = (0, _reactRedux.connect)(function (state) {
    return {
        initialValues: {
            year: new Date().getFullYear(),
            month: new Date().getMonth()
        }
    };
})(BillingInformation);

exports.default = BillingInformation;

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SplitRow = function SplitRow() {
    return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
            "div",
            { className: "offset-sm-1 col-md-10" },
            _react2.default.createElement("hr", null)
        )
    );
};

exports.default = SplitRow;

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Row = function () {
	function Row(r) {
		_classCallCheck(this, Row);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Row, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('innerBackgroundColor')) {
				this.item.innerBackgroundColor = 'transparent';
			}
			if (!this.isset('outerBackgroundColor')) {
				this.item.outerBackgroundColor = 'transparent';
			}
			if (!this.isset('outerBorderTop')) {
				this.item.outerBorderTop = 'none';
			}
			if (!this.isset('outerBorderBottom')) {
				this.item.outerBorderBottom = 'none';
			}
			if (!this.isset('innerBorderTop')) {
				this.item.innerBorderTop = 'none';
			}
			if (!this.isset('innerPadding')) {
				this.item.innerPadding = '0px 0px 0px 0px';
			}
			if (!this.isset('innerBorderBottom')) {
				this.item.innerBorderBottom = 'none';
			}

			if (!this.isset('elements')) {
				this.item.elements = [];
			}

			if (!this.isset('sorting')) {
				this.item.sorting = 1;
			}

			if (!this.isset('type')) {
				this.item.placeholder = 'row';
			}

			if (!this.isset('id')) {
				this.item.id = (0, _v2.default)();
			}

			if (!this.isset('columns')) {
				this.item.columns = 1;
			}
		}
	}]);

	return Row;
}();

exports.default = Row;

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactDropzone = __webpack_require__(116);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUpload = function (_React$Component) {
    _inherits(FileUpload, _React$Component);

    function FileUpload(props) {
        _classCallCheck(this, FileUpload);

        var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, props));

        _this.onOpenClick = _this.onOpenClick.bind(_this);
        _this.renderIsUploading = _this.renderIsUploading.bind(_this);
        _this.renderUpload = _this.renderUpload.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.el = _this.el.bind(_this);
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.onPaddingChange = _this.onPaddingChange.bind(_this);
        _this.handleLinkChange = _this.handleLinkChange.bind(_this);

        return _this;
    }

    _createClass(FileUpload, [{
        key: 'onDrop',
        value: function onDrop(files) {
            var _this2 = this;

            if (files.length == 0) {
                return;
            }

            this.setState({ isUploading: true });

            var data = new FormData();
            data.append('file', files[0]);

            _axios2.default.post('/ajax/upload_image', data).then(function (res) {
                _this2.props.setComponentState(_this2.el().id, {
                    isUploading: false,
                    image: res.data.url,
                    original_width: res.data.original_width,
                    original_height: res.data.original_height
                });
            }).catch(function (err) {
                _this2.setState({ isUploading: false });
            });

            return;
            this.props.setComponentState(this.el().id, { isUploading: true });
            var ret = '{"success":true,"message":"File uploaded","url":"http:\/\/cdn.crall.io\/dev-uploads\/3a944de9e086f9dff282d60ce24cde14.jpg","filename":"3a944de9e086f9dff282d60ce24cde14.jpg"}';
            ret = JSON.parse(ret);

            setTimeout(function () {
                _this2.doneUploading(ret);
            }, 1000);
        }
    }, {
        key: 'onPaddingChange',
        value: function onPaddingChange(id, padding) {
            var changes = {};
            changes[id] = padding;
            this.props.setComponentState(this.el().id, changes);
        }
    }, {
        key: 'onOpenClick',
        value: function onOpenClick() {
            this.refs.dropzone.open();
        }
    }, {
        key: 'renderIsUploading',
        value: function renderIsUploading() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'state-is-uploading' },
                    _react2.default.createElement('img', { src: '/images/ajax.gif' }),
                    _react2.default.createElement('br', null),
                    'Uploading..'
                );
            }
            return _react2.default.createElement(
                'td',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                    'div',
                    { className: 'state-is-uploading' },
                    _react2.default.createElement('img', { src: '/images/ajax.gif' }),
                    _react2.default.createElement('br', null),
                    'Uploading..'
                )
            );
        }
    }, {
        key: 'renderUpload',
        value: function renderUpload() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Upload image' }),
                    _react2.default.createElement(
                        _SidebarElementWrapper2.default,
                        null,
                        _react2.default.createElement(
                            _reactDropzone2.default,
                            { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark btn-block' },
                                _react2.default.createElement('i', { className: 'icon wb-search', 'aria-hidden': 'true' }),
                                ' Browse'
                            )
                        )
                    )
                );
            }
            return _react2.default.createElement(
                'td',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                    _reactDropzone2.default,
                    { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
                    _react2.default.createElement(
                        'div',
                        { className: 'state-waiting-for-file' },
                        _react2.default.createElement('img', { src: '/images/builder/image.png', style: { width: '90px' } }),
                        _react2.default.createElement('br', null),
                        'Drop a file here',
                        _react2.default.createElement('br', null),
                        'or',
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark btn-sm' },
                            _react2.default.createElement('i', { className: 'icon wb-search', 'aria-hidden': 'true' }),
                            ' Browse'
                        )
                    )
                )
            );
        }
    }, {
        key: 'renderSidebarUpload',
        value: function renderSidebarUpload() {
            return _react2.default.createElement(
                _reactDropzone2.default,
                { ref: 'dropzone', style: {}, disableClick: true, multiple: false, onDrop: this.onDrop },
                _react2.default.createElement(
                    'button',
                    { type: 'button', onClick: this.onOpenClick, className: 'btn btn-dark btn-sm' },
                    _react2.default.createElement('i', { className: 'icon wb-search', 'aria-hidden': 'true' }),
                    ' Browse'
                )
            );
        }
    }, {
        key: 'renderImage',
        value: function renderImage() {
            var max = 600 / (this.props.row_cols ? this.props.row_cols : 1);

            var w = max;

            if (this.el().original_width < max) {
                w = this.el().original_width;
            }

            if (w == 0) {
                w = max;
            }

            return _react2.default.createElement(
                'td',
                { style: { textAlign: this.el().align, padding: this.el().padding } },
                _react2.default.createElement(
                    'div',
                    { className: 'image' },
                    _react2.default.createElement('img', { src: this.el().image, style: { width: w } })
                )
            );
        }
    }, {
        key: 'el',
        value: function el() {
            return this.props.builder.components[this.props.id];
        }
    }, {
        key: 'removeImage',
        value: function removeImage(e) {
            e.stopPropagation();
            this.props.setComponentState(this.props.id, { image: false });
        }
    }, {
        key: 'handleLinkChange',
        value: function handleLinkChange(id, s) {
            this.props.setComponentState(this.el().id, s);
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'panel-group panel-group-continuous', id: 'cart-settings', 'aria-multiselectable': 'true', role: 'tablist' },
                _react2.default.createElement(
                    _SidebarSettingAccordion2.default,
                    { selectedSetting: false, optionKey: 'image', parent: 'cart-settings', title: 'Image' },
                    _react2.default.createElement(
                        _SidebarElementWrapper2.default,
                        null,
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-dark btn-block', style: { marginBottom: '20px' }, onClick: function onClick(e) {
                                    _this3.removeImage(e);
                                } },
                            'Remove image'
                        )
                    ),
                    _react2.default.createElement(
                        _SidebarElementSetting2.default,
                        { text: 'Horizontal position' },
                        _react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.onPaddingChange })
                    ),
                    _react2.default.createElement(
                        _SidebarElementSetting2.default,
                        { text: 'Padding' },
                        _react2.default.createElement(_PaddingPicker2.default, { id: 'padding', handlePaddingChange: this.onPaddingChange, data: this.el().padding })
                    )
                ),
                _react2.default.createElement(
                    _SidebarSettingAccordion2.default,
                    { selectedSetting: false, optionKey: 'link', parent: 'cart-settings', title: 'Link' },
                    _react2.default.createElement(
                        _SidebarElementWrapper2.default,
                        null,
                        _react2.default.createElement(_LinkPicker2.default, { handleLinkChange: this.handleLinkChange, data: this.props.builder.components[this.props.id] })
                    )
                )
            );
        }
    }, {
        key: 'handleBackClick',
        value: function handleBackClick() {
            this.props.setSidebarState({ 'visible': false });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.sidebar == true) {
                return _react2.default.createElement(
                    'div',
                    null,
                    this.props.sidebar ? _react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Image' }) : null,
                    !this.el().isUploading && this.el().image == false ? this.renderUpload() : null,
                    this.el().isUploading ? this.renderIsUploading() : null,
                    !this.el().isUploading && this.el().image != false ? this.renderSettings() : null
                );
            } else {
                return _react2.default.createElement(
                    'table',
                    { className: 'table-block', style: { width: '100%' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            this.el().isUploading ? this.renderIsUploading() : null,
                            !this.el().isUploading && this.el().image == false ? this.renderUpload() : null,
                            !this.el().isUploading && this.el().image != false ? this.renderImage() : null
                        )
                    )
                );
            }
        }
    }]);

    return FileUpload;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        builder: state.builder
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

FileUpload = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FileUpload);

exports.default = FileUpload;

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(4);

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

var _General3 = __webpack_require__(8);

var _General4 = _interopRequireDefault(_General3);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _BrowserNotification = __webpack_require__(535);

var _BrowserNotification2 = _interopRequireDefault(_BrowserNotification);

var _Chat = __webpack_require__(161);

var _Login = __webpack_require__(75);

var _Segment = __webpack_require__(536);

var _General5 = __webpack_require__(53);

var _reactRouter = __webpack_require__(6);

var _socket = __webpack_require__(1080);

var _socket2 = _interopRequireDefault(_socket);

var _index = __webpack_require__(128);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SocketManager = function () {
    function SocketManager() {
        _classCallCheck(this, SocketManager);

        this.ws = false;

        if (typeof localStorage.isOnline === 'undefined') {
            localStorage.setItem('isOnline', false);
        }
        this.hasStarted = false;
    }

    _createClass(SocketManager, [{
        key: 'loadStaticVisitorList',
        value: function loadStaticVisitorList() {
            _axios2.default.get('/dashboard').then(function (data) {

                var res = {};
                var cart = {};
                var pages = {};
                var conversations = data.data.conversations;

                var s = _store2.default.getState();

                data.data.visitors.map(function (visitor) {

                    Object.keys(visitor).map(function (i) {
                        visitor[i] = _General2.default.parseValue(visitor[i]);
                    });

                    cart[visitor.uid] = JSON.parse(visitor.cart);
                    pages[visitor.uid] = JSON.parse(visitor.pages);
                    delete visitor.cart;
                    res[visitor.uid] = visitor;
                });
                _store2.default.dispatch((0, _Chat.chatSetGlobalKey)('conversations', conversations));
                _store2.default.dispatch((0, _Chat.addVisitors)(res));
                _store2.default.dispatch((0, _Chat.addCarts)(cart));
                _store2.default.dispatch((0, _Chat.addPages)(pages));
                _store2.default.dispatch((0, _Chat.setInit)(true));
            });
        }
    }, {
        key: 'isOnline',
        value: function isOnline() {
            return _store2.default.getState().chat.isOnline;
        }
    }, {
        key: 'setOnlineStatus',
        value: function setOnlineStatus(status) {
            if ((typeof status === 'undefined' ? 'undefined' : _typeof(status)) === 'object') {
                status = status.payload;
            }
            _store2.default.dispatch((0, _Chat.switchChatStatus)(status));
        }
    }, {
        key: 'segmentComplete',
        value: function segmentComplete(data) {
            var state = _store2.default.getState();

            state.segments.list.map(function (item, i) {
                if (item.id == data.payload.id) {
                    _store2.default.dispatch((0, _Segment.updateSegment)(i, data.payload));
                }
            });

            //


            //store.dis
        }
    }, {
        key: 'getOnlineStatus',
        value: function getOnlineStatus() {
            var status = localStorage.isOnline;
            if (status == 'true') {
                status = true;
            }

            if (status == 'false') {
                status = false;
            }

            return status;
        }
    }, {
        key: 'canStartConnection',
        value: function canStartConnection() {
            if (_store2.default.getState().auth.token !== '' && _store2.default.getState().auth.currentAccount !== false) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isTyping',
        value: function isTyping(data) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(data.payload.uid, 'isTyping', data.payload.status));
        }
    }, {
        key: 'offline',
        value: function offline(data) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(data.payload, 'online', 0));
        }
    }, {
        key: 'hasConnection',
        value: function hasConnection() {
            return this.ws.connected;
        }
    }, {
        key: 'closeConversation',
        value: function closeConversation(data) {
            var state = _store2.default.getState();

            if (state.chat.visitors[data.payload]) {

                if (state.chat.visitors[data.payload] === false) {
                    _store2.default.dispatch((0, _Chat.removeVisitor)(data.payload));
                } else {
                    _store2.default.dispatch((0, _Chat.setAssignee)(0, data.payload));
                }
            }
        }
    }, {
        key: 'view',
        value: function view(data) {
            Object.keys(data.payload).map(function (i) {
                data.payload[i] = _General2.default.parseValue(data.payload[i]);
            });
            _store2.default.dispatch((0, _Chat.addVisitor)(data.payload));
        }
    }, {
        key: 'visitorList',
        value: function visitorList(data) {
            var res = {};
            var cart = {};
            var s = _store2.default.getState();

            data.payload.map(function (visitor) {
                if (typeof s.chat.visitors[visitor.info.uid] === 'undefined') {
                    res[visitor.info.uid] = visitor.info;
                    cart[visitor.info.uid] = JSON.parse(visitor.cart);
                }
            });

            _store2.default.dispatch((0, _Chat.addVisitors)(res));
            _store2.default.dispatch((0, _Chat.addCarts)(cart));
            _store2.default.dispatch((0, _Chat.setInit)(true));
        }
    }, {
        key: 'onDisconnect',
        value: function onDisconnect() {
            if (_store2.default.getState().auth.hadConnection === true && _store2.default.getState().auth.wsStatus === true) {
                _store2.default.dispatch((0, _Login.setConnectionStatus)(false));
            }
        }
    }, {
        key: 'onConnected',
        value: function onConnected() {
            if (_store2.default.getState().auth.hadConnection === true && _store2.default.getState().auth.wsStatus === false) {
                _store2.default.dispatch((0, _Login.setConnectionStatus)(true));
            }
        }
    }, {
        key: 'onReady',
        value: function onReady() {
            //		this.setOnline(this.getOnlineStatus());
            this.ws.send('getVisitorList');
        }
    }, {
        key: 'isDisconnected',
        value: function isDisconnected() {
            return this.ws.disconnected && this.hasStarted;
        }

        // NEW

    }, {
        key: 'visitor',
        value: function visitor(data) {
            var subscribers = [];
            var messages = data.messages;
            var pages = data.pages;
            var cart = data.cart;

            if (!messages) {
                messages = [];
            }

            if (!pages) {
                pages = [];
            } else {
                pages = JSON.parse(pages);
            }

            if (!cart) {
                cart = [];
            } else {
                cart = JSON.parse(cart);
            }

            if (data.subscribers) {
                subscribers = data.payload.subscribers;
            }

            _store2.default.dispatch((0, _Chat.addVisitorData)('pages', data.uid, pages));
            _store2.default.dispatch((0, _Chat.addVisitorData)('cart', data.uid, cart));

            delete data.pages;
            delete data.cart;

            Object.keys(data).map(function (i) {
                data[i] = _General2.default.parseValue(data[i]);
            });

            _store2.default.dispatch((0, _Chat.addVisitor)(data));
        }
    }, {
        key: 'setOnline',
        value: function setOnline(status) {
            var state = _store2.default.getState();
            localStorage.setItem('isOnline', status);
            _store2.default.dispatch((0, _Chat.switchChatStatus)(status));
            this.ws.emit('isOnline', status);
        }
    }, {
        key: 'setClientOnlineStatus',
        value: function setClientOnlineStatus(payload) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(payload.uid, 'online', payload.status));
        }
    }, {
        key: 'leave',
        value: function leave(data) {
            _store2.default.dispatch((0, _Chat.removeVisitor)(data));
        }
    }, {
        key: 'read',
        value: function read(uid) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(uid, 'unreadMessages', 0));
            this.ws.emit('read', uid);
        }
    }, {
        key: 'setAssignee',
        value: function setAssignee(user_id, uid) {
            this.ws.emit('setAssignee', {
                user_id: user_id,
                uid: uid,
                s: _store2.default.getState().auth.user.id
            });
        }
    }, {
        key: 'assign',
        value: function assign(data) {
            _store2.default.dispatch((0, _Chat.setAssignee)(data.user_id, data.uid));
        }
    }, {
        key: 'newMessage',
        value: function newMessage(data) {
            var s = _store2.default.getState();

            if (!s.chat.visitors[data.uid]) {
                return;
            }

            _store2.default.dispatch((0, _Chat.addMessage)(data.uid, JSON.stringify(data)));
            _store2.default.dispatch((0, _Chat.setVisitorKey)(data.uid, 'isTyping', 0));
            _store2.default.dispatch((0, _Chat.setVisitorKey)(data.uid, 'online', 1));

            if (s.chat.visitors[data.uid].assignee_id != s.auth.user.id && s.chat.visitors[data.uid].assignee_id != 0) {
                return;
            }

            if (parseInt(data.from) == 0 && this.getOnlineStatus()) {
                _BrowserNotification2.default.new({
                    'title': 'New chat message',
                    'message': data.text,
                    'sound': true,
                    'link': _General4.default.Link('/chat/' + s.auth.user.id + '/' + data.uid)
                });
            }
        }
    }, {
        key: 'clientIsTyping',
        value: function clientIsTyping(payload) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(payload.uid, 'online', 1));
            _store2.default.dispatch((0, _Chat.setVisitorKey)(payload.uid, 'isTyping', parseInt(payload.status)));
        }
    }, {
        key: 'operatorIsTyping',
        value: function operatorIsTyping(uid, user_id, status) {
            this.ws.emit('operatorIsTyping', {
                uid: uid, user_id: user_id, status: status
            });
        }
    }, {
        key: 'closeConversation',
        value: function closeConversation(uid) {
            this.ws.emit('closeConversation', uid);
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(message) {
            _store2.default.dispatch((0, _Chat.setVisitorKey)(message.uid, 'unreadMessages', 0));
            _store2.default.dispatch((0, _Chat.addMessage)(message.uid, JSON.stringify(message)));
            this.ws.emit('messageFromOperator', message);
        }
    }, {
        key: 'start',
        value: function start() {
            var _this = this;

            if (this.hasConnection()) {
                return false;
            }

            if (!this.canStartConnection()) {
                return false;
            }

            if (this.hasStarted == true) {
                return;
            }

            this.hasStarted = true;

            this.ws = (0, _socket2.default)(_index2.default.url().ws, {
                transports: ['websocket']
            });

            this.ws.on('connect', function () {

                var current_state = _extends({}, _store2.default.getState().auth);

                _this.ws.emit('newOperator', {
                    token: current_state.token,
                    account: current_state.currentAccount,
                    email: current_state.user.email,
                    image: current_state.user.image,
                    firstname: current_state.user.firstname,
                    lastname: current_state.user.lastname,
                    isOnline: localStorage.isOnline
                });
            });

            this.ws.on('disconnect', function () {
                console.dir('disconnect');
            });

            this.ws.on('clientIsTyping', function (payload) {
                _this.clientIsTyping(payload);
            });

            this.ws.on('setClientOnlineStatus', function (payload) {
                _this.setClientOnlineStatus(payload);
            });

            this.ws.on('messageFromClient', function (payload) {
                _this.newMessage(payload);
            });

            this.ws.on('messageFromOperator', function (payload) {
                _this.newMessage(payload);
            });

            this.ws.on('setAssignee', function (payload) {
                _this.assign(payload);
            });

            this.ws.on('clientDisconnect', function (uid) {
                _this.leave(uid);
            });

            this.ws.on('reconnect', function () {
                _this.loadStaticVisitorList();
            });

            this.ws.on('view', function (data) {
                _this.visitor(data);
            });

            this.ws.on('ready', function (status) {
                _store2.default.dispatch((0, _Login.setConnectionStatus)(true));

                if (_this.getOnlineStatus() == true && status == false) {
                    _store2.default.dispatch((0, _General5.setGlobalKey)('showChatReconnection', true));
                }

                _store2.default.dispatch((0, _Chat.switchChatStatus)(status));
            });
        }
    }]);

    return SocketManager;
}();

exports.default = new SocketManager();

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addElement = addElement;
exports.changeRule = changeRule;
exports.setTag = setTag;
exports.addRow = addRow;
exports.deleteRow = deleteRow;
exports.deleteElement = deleteElement;
exports.setUiState = setUiState;
exports.setGlobalKeyState = setGlobalKeyState;
exports.setGlobalTypeState = setGlobalTypeState;
exports.setSidebarState = setSidebarState;
exports.setComponentState = setComponentState;
exports.setSelectedTab = setSelectedTab;
exports.removeElement = removeElement;
exports.setSelectedRow = setSelectedRow;
exports.convertToElement = convertToElement;
exports.addRowPlaceholder = addRowPlaceholder;
exports.moveRow = moveRow;
exports.addPlaceholder = addPlaceholder;
exports.moveElement = moveElement;
function addElement(el) {
	return {
		type: 'BUILDER_ADD_ELEMENT',
		payload: el
	};
}

function changeRule(index, key, value) {
	return {
		type: 'BUILDER_CHANGE_RULE',
		payload: {
			index: index, key: key, value: value
		}
	};
}

function setTag(key, value) {
	return {
		type: 'SET_TAG',
		payload: {
			key: key, value: value
		}
	};
}

function addRow(row) {
	return {
		type: 'BUILDER_ADD_ROW',
		payload: row
	};
}

function deleteRow(id) {
	return {
		type: 'BUILDER_DELETE_ROW',
		payload: id
	};
}

function deleteElement(id) {
	return {
		type: 'BUILDER_DELETE_ELEMENT',
		payload: id

	};
}
function setUiState(changes) {
	return {
		type: 'BUILDER_SET_UI_STATE',
		payload: changes

	};
}

function setGlobalKeyState(key, value) {
	return {
		type: 'BUILDER_SET_GLOBAL_KEY_STATE',
		payload: { key: key, value: value }

	};
}

function setGlobalTypeState(key, id, changes) {
	return {
		type: 'BUILDER_SET_GLOBAL_TYPE_STATE',
		payload: { key: key, id: id, changes: changes }

	};
}

function setSidebarState(changes) {
	return {
		type: 'BUILDER_SET_SIDEBAR_STATE',
		payload: changes

	};
}

function setComponentState(id, changes) {
	return {
		type: 'BUILDER_SET_COMPONENT_STATE',
		payload: { id: id, changes: changes }
	};
}

function setSelectedTab(tab) {
	return {
		type: 'BUILDER_SET_SIDEBAR_TAB',
		payload: tab
	};
}

function removeElement(el) {
	return {
		type: 'BUILDER_REMOVE_ELEMENT',
		payload: el
	};
}

function setSelectedRow(id) {
	return {
		type: 'BUILDER_SET_SELECTED_ROW',
		payload: id
	};
}

function convertToElement(element, el) {
	return {
		type: 'BUILDER_CONVERT_TO_ELEMENT',
		payload: { element: element, el: el }
	};
}

function addRowPlaceholder(newPosition, newSorting) {
	return {
		type: 'BUILDER_ADD_ROW_PLACEHOLDER',
		payload: { newPosition: newPosition, newSorting: newSorting }
	};
}

function moveRow(newPosition, newSorting) {
	return {
		type: 'BUILDER_MOVE_ROW',
		payload: { newPosition: newPosition, newSorting: newSorting }
	};
}

function addPlaceholder(newPosition, newSorting) {
	return {
		type: 'BUILDER_ADD_PLACEHOLDER',
		payload: { newPosition: newPosition, newSorting: newSorting }
	};
}

function moveElement(newPosition, newSorting) {
	return {
		type: 'BUILDER_MOVE_ELEMENT',
		payload: { newPosition: newPosition, newSorting: newSorting }
	};
}

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarElementHeader = function SidebarElementHeader(_ref) {
	var text = _ref.text,
	    handleBackClick = _ref.handleBackClick;
	return _react2.default.createElement(
		"div",
		{ className: "header" },
		_react2.default.createElement(
			"button",
			{ type: "button", onClick: handleBackClick, className: "btn btn-primary btn-outline" },
			_react2.default.createElement("i", { className: "icon wb-chevron-left" })
		),
		_react2.default.createElement("i", { className: "icon wb-more-vertical" }),
		" ",
		text
	);
};

exports.default = SidebarElementHeader;

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarElementSpacing = function SidebarElementSpacing(_ref) {
	var text = _ref.text;
	return _react2.default.createElement(
		"div",
		{ className: "spacing" },
		_react2.default.createElement(
			"h2",
			null,
			_react2.default.createElement(
				"span",
				null,
				text
			)
		)
	);
};

exports.default = SidebarElementSpacing;

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nav = function (_React$Component) {
	_inherits(Nav, _React$Component);

	function Nav(props) {
		_classCallCheck(this, Nav);

		return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this, props));
	}

	_createClass(Nav, [{
		key: 'handleSave',
		value: function handleSave(e) {
			e.stopPropagation();
			this.props.save();
		}
	}, {
		key: 'getLinkType',
		value: function getLinkType() {
			if (!this.props.backLink) {
				return _react2.default.createElement(
					_reactRouter.Link,
					{ to: this.props.backLink ? this.props.backLink : '/dashboard', className: 'btn btn-default' },
					this.props.backText ? this.props.backText : 'Back'
				);
			}

			if (this.props.backLink.includes("https://")) {
				return _react2.default.createElement(
					'a',
					{ href: this.props.backLink, className: 'btn btn-default' },
					this.props.backText ? this.props.backText : 'Back'
				);
			}

			return _react2.default.createElement(
				_reactRouter.Link,
				{ to: this.props.backLink ? this.props.backLink : '/dashboard', className: 'btn btn-default' },
				this.props.backText ? this.props.backText : 'Back'
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'nav',
				{ className: 'site-navbar navbar navbar-default navbar-fixed-top navbar-mega builder', role: 'navigation' },
				_react2.default.createElement(
					'div',
					{ className: 'navbar-header' },
					_react2.default.createElement(
						'div',
						{ className: 'p-15', 'data-toggle': 'gridmenu' },
						this.getLinkType()
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'navbar-container container-fluid' },
					_react2.default.createElement(
						'div',
						{ className: 'collapse navbar-collapse navbar-collapse-toolbar', id: 'site-navbar-collapse' },
						_react2.default.createElement(
							'ul',
							{ className: 'nav navbar-toolbar navbar-right navbar-toolbar-right' },
							this.props.children
						)
					)
				)
			);
		}
	}]);

	return Nav;
}(_react2.default.Component);

exports.default = Nav;

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarElementWrapper = function SidebarElementWrapper(props) {
	return _react2.default.createElement(
		"div",
		{ className: "element-wrapper" },
		props.children
	);
};

exports.default = SidebarElementWrapper;

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItemObject = getItemObject;
exports.getItemComponent = getItemComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _text = __webpack_require__(588);

var _text2 = _interopRequireDefault(_text);

var _upload = __webpack_require__(589);

var _upload2 = _interopRequireDefault(_upload);

var _row = __webpack_require__(328);

var _row2 = _interopRequireDefault(_row);

var _spacing = __webpack_require__(590);

var _spacing2 = _interopRequireDefault(_spacing);

var _button = __webpack_require__(1242);

var _button2 = _interopRequireDefault(_button);

var _cart = __webpack_require__(591);

var _cart2 = _interopRequireDefault(_cart);

var _socialfollow = __webpack_require__(1243);

var _socialfollow2 = _interopRequireDefault(_socialfollow);

var _divider = __webpack_require__(1244);

var _divider2 = _interopRequireDefault(_divider);

var _header = __webpack_require__(1245);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(1246);

var _footer2 = _interopRequireDefault(_footer);

var _ordersummary = __webpack_require__(1247);

var _ordersummary2 = _interopRequireDefault(_ordersummary);

var _recommendation = __webpack_require__(1248);

var _recommendation2 = _interopRequireDefault(_recommendation);

var _discount = __webpack_require__(1249);

var _discount2 = _interopRequireDefault(_discount);

var _list = __webpack_require__(1250);

var _list2 = _interopRequireDefault(_list);

var _productselection = __webpack_require__(1251);

var _productselection2 = _interopRequireDefault(_productselection);

var _customhtml = __webpack_require__(1252);

var _customhtml2 = _interopRequireDefault(_customhtml);

var _crallrecommendation = __webpack_require__(1253);

var _crallrecommendation2 = _interopRequireDefault(_crallrecommendation);

var _crallrecommendationdynamo = __webpack_require__(1254);

var _crallrecommendationdynamo2 = _interopRequireDefault(_crallrecommendationdynamo);

var _shippingtracker = __webpack_require__(1255);

var _shippingtracker2 = _interopRequireDefault(_shippingtracker);

var _recheckout = __webpack_require__(1256);

var _recheckout2 = _interopRequireDefault(_recheckout);

var _Button = __webpack_require__(592);

var _Button2 = _interopRequireDefault(_Button);

var _Cart = __webpack_require__(1380);

var _Cart2 = _interopRequireDefault(_Cart);

var _Spacing = __webpack_require__(619);

var _Spacing2 = _interopRequireDefault(_Spacing);

var _FileUpload = __webpack_require__(329);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _Text = __webpack_require__(628);

var _Text2 = _interopRequireDefault(_Text);

var _Divider = __webpack_require__(1421);

var _Divider2 = _interopRequireDefault(_Divider);

var _Socialfollow = __webpack_require__(1422);

var _Socialfollow2 = _interopRequireDefault(_Socialfollow);

var _Header = __webpack_require__(1423);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(1424);

var _Footer2 = _interopRequireDefault(_Footer);

var _OrderSummary = __webpack_require__(1425);

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _Recommendation = __webpack_require__(1426);

var _Recommendation2 = _interopRequireDefault(_Recommendation);

var _Discount = __webpack_require__(1427);

var _Discount2 = _interopRequireDefault(_Discount);

var _List = __webpack_require__(1439);

var _List2 = _interopRequireDefault(_List);

var _ProductSelection = __webpack_require__(1440);

var _ProductSelection2 = _interopRequireDefault(_ProductSelection);

var _CustomHtml = __webpack_require__(1441);

var _CustomHtml2 = _interopRequireDefault(_CustomHtml);

var _ShippingTracker = __webpack_require__(1445);

var _ShippingTracker2 = _interopRequireDefault(_ShippingTracker);

var _Recheckout = __webpack_require__(1446);

var _Recheckout2 = _interopRequireDefault(_Recheckout);

var _Crallrecommendation = __webpack_require__(1447);

var _Crallrecommendation2 = _interopRequireDefault(_Crallrecommendation);

var _crallrecommendationdynamo3 = __webpack_require__(1448);

var _crallrecommendationdynamo4 = _interopRequireDefault(_crallrecommendationdynamo3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getItemObject(type, data) {
    var el = false;

    switch (type) {
        case "upload":
            el = new _upload2.default(data);
            break;

        case "text":
            el = new _text2.default(data);
            break;

        case "button":
            el = new _button2.default(data);
            break;

        case "cart":
            el = new _cart2.default(data);
            break;

        case "spacing":
            el = new _spacing2.default(data);
            break;

        case "divider":
            el = new _divider2.default(data);
            break;

        case "socialfollow":
            el = new _socialfollow2.default(data);
            break;

        case "header":
            el = new _header2.default(data);
            break;

        case "footer":
            el = new _footer2.default(data);
            break;

        case "ordersummary":
            el = new _ordersummary2.default(data);
            break;

        case "recommendation":
            el = new _recommendation2.default(data);
            break;
        case "crallrecommendation":
            el = new _crallrecommendation2.default(data);
            break;
        case "crallrecommendationdynamo":
            el = new _crallrecommendationdynamo2.default(data);
            break;

        case "list":
            el = new _list2.default(data);
            break;

        case "productselection":
            el = new _productselection2.default(data);
            break;

        case "discount":
            el = new _discount2.default(data);
            break;

        case "customhtml":
            el = new _customhtml2.default(data);
            break;

        case "shippingtracker":
            el = new _shippingtracker2.default(data);
            break;

        case "recheckout":
            el = new _recheckout2.default(data);
            break;
    }

    return el;
}

function getItemComponent(element, row_cols) {
    var sidebar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    switch (element.type) {
        case "upload":
            return _react2.default.createElement(_FileUpload2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "text":
            return _react2.default.createElement(_Text2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "button":
            return _react2.default.createElement(_Button2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "cart":
            return _react2.default.createElement(_Cart2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "spacing":
            return _react2.default.createElement(_Spacing2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "divider":
            return _react2.default.createElement(_Divider2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "socialfollow":
            return _react2.default.createElement(_Socialfollow2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "recheckout":
            return _react2.default.createElement(_Recheckout2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "list":
            return _react2.default.createElement(_List2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "header":
            return _react2.default.createElement(_Header2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "footer":
            return _react2.default.createElement(_Footer2.default, { row_cols: row_cols, sidebar: sidebar, id: element.id });
            break;

        case "ordersummary":
            return _react2.default.createElement(_OrderSummary2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "recommendation":
            return _react2.default.createElement(_Recommendation2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;
        case "crallrecommendation":
            return _react2.default.createElement(_Crallrecommendation2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;
        case "crallrecommendationdynamo":
            return _react2.default.createElement(_crallrecommendationdynamo4.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "productselection":
            return _react2.default.createElement(_ProductSelection2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "discount":
            return _react2.default.createElement(_Discount2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "customhtml":
            return _react2.default.createElement(_CustomHtml2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;

        case "shippingtracker":
            return _react2.default.createElement(_ShippingTracker2.default, {
                row_cols: row_cols,
                sidebar: sidebar,
                id: element.id
            });
            break;
    }

    return false;
}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarElementSetting = function SidebarElementSetting(props) {
	return _react2.default.createElement(
		"div",
		{ className: "form-group col-sm-12" },
		_react2.default.createElement(
			"label",
			{ className: "control-label" },
			props.text
		),
		props.children
	);
};

exports.default = SidebarElementSetting;

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Discount = __webpack_require__(631);

var _Discount2 = _interopRequireDefault(_Discount);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiscountPicker = function (_React$Component) {
    _inherits(DiscountPicker, _React$Component);

    function DiscountPicker(props) {
        _classCallCheck(this, DiscountPicker);

        var _this = _possibleConstructorReturn(this, (DiscountPicker.__proto__ || Object.getPrototypeOf(DiscountPicker)).call(this, props));

        _this.state = {
            isLoading: true,
            discounts: [],
            isAdding: false,
            isWaiting: false,
            add: false
        };

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.select = _this.select.bind(_this);

        return _this;
    }

    _createClass(DiscountPicker, [{
        key: 'handleSubmit',
        value: function handleSubmit(values) {
            var _this2 = this;

            _Notification2.default.info('Saving...');
            this.setState({
                'isAdding': false
            });
            var method = 'post';
            var url = '/discounts';

            _axios2.default[method](url, values).then(function (response) {
                _this2.update();
                window.scrollTo(0, 0);
                _this2.select(response.data.id);
                _Notification2.default.success('Discount saved');
            }).catch(function (error) {
                _Notification2.default.error(error.message);
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            _axios2.default.get('/discounts').then(function (res) {
                _this3.setState({
                    'isLoading': false,
                    'discounts': res.data
                });
            });
        }
    }, {
        key: 'select',
        value: function select(id) {
            this.setState({
                add: id
            });

            if (this.props.sidebar === true) {
                this.props.useDiscount(id);
            } else {
                this.setState({
                    add: id
                });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'overview m-t-30 col-sm-6 offset-sm-3 m-b-40 text-center' },
                        _react2.default.createElement(
                            'h1',
                            null,
                            'Add discount'
                        ),
                        _react2.default.createElement(
                            'h2',
                            null,
                            'Select a existing, or add a new discount'
                        ),
                        this.state.isLoading ? _react2.default.createElement(_LoadingSmall2.default, null) : null,
                        this.state.add ? _react2.default.createElement(
                            'div',
                            { className: 'alert alert-primary alert-dismissible m-t-30 m-b-30', role: 'alert' },
                            'Copy and paste the code below into the location where you want the code to appear.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h2',
                                { style: { color: '#62a8ea' } },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '@@DISCOUNT-',
                                    this.state.add,
                                    '@@'
                                )
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary', onClick: this.props.onClose, type: 'button' },
                                'Close window'
                            )
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'm-t-0 col-sm-10 offset-sm-1' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'list-group list-group-full' },
                                this.state.discounts.map(function (discount) {
                                    return _react2.default.createElement(
                                        'li',
                                        { key: discount.id, className: 'list-group-item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'media' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'media-left', style: { verticalAlign: 'middle' } },
                                                _react2.default.createElement(
                                                    'a',
                                                    { className: 'avatar', href: 'javascript:void(0)', style: { width: '40px' } },
                                                    _react2.default.createElement('img', { className: 'img-fluid', src: '/images/svg/select.svg', alt: '...', style: { borderRadius: 0 } })
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'media-body' },
                                                _react2.default.createElement(
                                                    'h4',
                                                    { className: 'media-heading' },
                                                    discount.name
                                                ),
                                                discount.auto_update == '1' ? _react2.default.createElement(
                                                    'small',
                                                    null,
                                                    'Codes from this discount will be automatically generated in your store.'
                                                ) : _react2.default.createElement(
                                                    'small',
                                                    null,
                                                    'Manual discount.'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'media-right' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { onClick: function onClick() {
                                                            return _this4.select(discount.id);
                                                        }, className: 'btn btn-dark btn-block' },
                                                    'Use'
                                                )
                                            )
                                        )
                                    );
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'm-b-20 strike' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'New discount'
                                )
                            ),
                            this.state.isAdding ? _react2.default.createElement(_Discount2.default, { errorMessage: this.state.error, initialValues: this.state.discount ? this.state.discount : { expire: 1, type: 'percent' }, isWaiting: this.state.isWaiting, onSubmit: this.handleSubmit }) : _react2.default.createElement(
                                'button',
                                { className: 'btn btn-dark btn-lg', onClick: function onClick() {
                                        return _this4.setState({ isAdding: true });
                                    } },
                                'Add new discount'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return DiscountPicker;
}(_react2.default.Component);

exports.default = DiscountPicker;

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.state = {
            isLoading: true,
            initialProducts: {}
        };

        _this.getOptions = _this.getOptions.bind(_this);
        _this.parseValue = _this.parseValue.bind(_this);
        _this.fetchData = _this.fetchData.bind(_this);

        return _this;
    }

    _createClass(Rule, [{
        key: 'parseValue',
        value: function parseValue(values) {
            if (typeof values == 'string') {
                var ret = [];
                values.split(',').map(function (value) {
                    ret.push({
                        id: value,
                        manufacturer: value
                    });
                });
                return ret;
            }

            return values;
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var _this2 = this;

            if (this.props.rule.value === false || this.props.rule.value == 'false') {
                this.setState({ isLoading: false });
                return;
            }

            _axios2.default.get('/products?manufacturer=' + this.props.rule.value).then(function (res) {
                var products = {};

                res.data.map(function (p) {
                    products[p.manufacturer] = p.manufacturer;
                });

                _this2.setState({
                    isLoading: false,
                    initialProducts: products
                });
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.rule.id != prevProps.rule.id) {
                this.setState({ isLoading: true });
                this.fetchData();
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.props.rule.value || this.props.rule.value == '') {
                this.setState({ isLoading: false });
                return true;
            }

            this.fetchData();
        }
    }, {
        key: 'getOptions',
        value: function getOptions(value) {
            var _this3 = this;

            var param = 'manufacturer=' + value;

            if (!value) {
                return Promise.resolve({ options: [] });
            }

            return _axios2.default.get('/products?' + param).then(function (res) {

                var products = _extends({}, _this3.state.initialProducts);

                for (var i in res.data) {
                    products[res.data[i].manufacturer] = res.data[i].manufacturer;
                }

                _this3.setState({
                    initialProducts: products
                });

                return { options: res.data };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                null,
                this.state.isLoading ? null : _react2.default.createElement(_reactSelect2.default.Async, {
                    autoload: true,
                    valueKey: 'manufacturer',
                    labelKey: 'manufacturer',
                    simpleValue: false,
                    multi: true,
                    name: 'form-field-name',
                    value: this.parseValue(this.props.rule.value),
                    loadOptions: this.getOptions,
                    onChange: function onChange(e) {
                        return _this4.props.handleRuleChange(_this4.props.index, 'operator', e);
                    }
                })
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_React$Component) {
    _inherits(Rule, _React$Component);

    function Rule(props) {
        _classCallCheck(this, Rule);

        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, props));

        _this.fetchData = function () {
            if (_this.props.rule.value === false || _this.props.rule.value == 'false') {
                _this.setState({ isLoading: false });
                return;
            }

            var url = '/categories?id=' + _this.props.rule.value;

            if (_this.props.useExternalId) {
                url += '&externalId';
            }

            _axios2.default.get(url).then(function (res) {
                var products = {};

                res.data.map(function (p) {
                    var id = p.id;
                    if (_this.props.useExternalId) {
                        id = parseInt(p.category_id);
                    }

                    products[id] = p.name;
                });

                _this.setState({
                    isLoading: false,
                    initialProducts: products
                });
            });
        };

        _this.getOptions = function (value) {
            var param = 'id=' + _this.props.rule.value;

            if (_this.props.useExternalId) {
                param += '&externalId';
            }

            if (value) {
                param = 'name=' + value;
            }
            return _axios2.default.get('/categories?' + param).then(function (res) {
                var products = _extends({}, _this.state.initialProducts);

                var result = [];

                for (var i in res.data) {
                    var id = res.data[i].id;
                    if (_this.props.useExternalId) {
                        id = parseInt(res.data[i].category_id);
                        res.data[i].id = res.data[i].category_id;
                    }

                    products[id] = res.data[i].name;
                }

                _this.setState({
                    initialProducts: products
                });

                return { options: res.data };
            });
        };

        _this.state = {
            isLoading: true,
            value: 'chocolate',
            initialProducts: {}
        };

        _this.getOptions = _this.getOptions.bind(_this);
        _this.parseValue = _this.parseValue.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.fetchData = _this.fetchData.bind(_this);
        return _this;
    }

    _createClass(Rule, [{
        key: 'handleSelectChange',
        value: function handleSelectChange(value) {
            this.setState({ value: value });
        }
    }, {
        key: 'parseValue',
        value: function parseValue(values) {
            var _this2 = this;

            if (typeof values == 'string') {
                var ret = [];
                values.split(',').map(function (value) {
                    value = parseInt(value);
                    ret.push({
                        id: value,
                        name: _this2.state.initialProducts[value]
                    });
                });
                return ret;
            }

            return values;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.rule.id != prevProps.rule.id) {
                this.setState({ isLoading: true });
                this.fetchData();
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.props.rule.value || this.props.rule.value == '') {
                this.setState({ isLoading: false });
                return true;
            }

            this.fetchData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                this.state.isLoading ? null : _react2.default.createElement(_reactSelect2.default.Async, {

                    autoload: true,
                    valueKey: 'id',
                    labelKey: 'name',
                    simpleValue: false,
                    multi: true,
                    name: 'form-field-name',
                    value: this.parseValue(this.props.rule.value),
                    loadOptions: this.getOptions,
                    onChange: function onChange(e) {
                        return _this3.props.handleRuleChange(_this3.props.index, 'operator', e);
                    }
                })
            );
        }
    }]);

    return Rule;
}(_react2.default.Component);

exports.default = Rule;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarSettingAccordion = function SidebarSettingAccordion(props) {
    return _react2.default.createElement(
        "div",
        { className: "panel", onClick: props.click },
        _react2.default.createElement(
            "div",
            { className: "panel-heading", id: props.parent + "-option-" + props.optionKey, role: "tab" },
            _react2.default.createElement(
                "a",
                { className: "panel-title", "data-parent": "#" + props.parent, "data-toggle": "collapse", href: "#" + props.parent + "-content-" + props.optionKey, "aria-controls": props.parent + "-content-" + props.optionKey, "aria-expanded": "false" },
                props.title
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "panel-collapse collapse " + (props.selectedSetting == props.optionKey ? 'in' : ''), id: props.parent + "-content-" + props.optionKey, "aria-labelledby": props.parent + "-option-" + props.optionKey, role: "tabpanel" },
            _react2.default.createElement(
                "div",
                { className: "panel-body  font-size-12" },
                props.children
            )
        )
    );
};

exports.default = SidebarSettingAccordion;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _Rule = __webpack_require__(1483);

var _Rule2 = _interopRequireDefault(_Rule);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _AudiencePicker = __webpack_require__(1545);

var _AudiencePicker2 = _interopRequireDefault(_AudiencePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SegmentsNew = function (_React$Component) {
    _inherits(SegmentsNew, _React$Component);

    function SegmentsNew(props) {
        _classCallCheck(this, SegmentsNew);

        var _this = _possibleConstructorReturn(this, (SegmentsNew.__proto__ || Object.getPrototypeOf(SegmentsNew)).call(this, props));

        _this.state = {
            name: '',
            isLoading: true,
            isError: false,
            segment: {},
            rules: [],
            errors: {}
        };

        _this.renderTimeline = _this.renderTimeline.bind(_this);
        _this.renderAddCondition = _this.renderAddCondition.bind(_this);
        _this.handleRuleChange = _this.handleRuleChange.bind(_this);
        _this.newCondition = _this.newCondition.bind(_this);
        _this.handleRuleRemove = _this.handleRuleRemove.bind(_this);
        _this.save = _this.save.bind(_this);
        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.handleRuleError = _this.handleRuleError.bind(_this);
        _this.changeSegmentProp = _this.changeSegmentProp.bind(_this);
        _this.hasFacebook = _this.hasFacebook.bind(_this);
        return _this;
    }

    _createClass(SegmentsNew, [{
        key: 'hasFacebook',
        value: function hasFacebook() {
            return this.props.general.apps.filter(function (item) {
                return item.key == 'FacebookAds';
            }).length > 0;
        }
    }, {
        key: 'changeSegmentProp',
        value: function changeSegmentProp(key, value) {
            this.setState({
                segment: _extends({}, this.state.segment, _defineProperty({}, key, value))
            });
        }
    }, {
        key: 'handleRuleError',
        value: function handleRuleError(isError, id, value) {
            var errors = _extends({}, this.state.errors);

            if (isError) {
                errors[id] = value;
            } else {
                delete errors[id];
            }

            this.setState({ errors: errors });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            if (this.state.name == '') {
                _Notification2.default.error('You need to give this segment a name.');
                return false;
            }

            if (this.state.rules.length <= 0) {
                _Notification2.default.error('Not worth saving a segment without conditions..');
                return false;
            }

            var errors = _extends({}, this.state.errors);

            for (var i in this.state.rules) {
                if (this.refs[this.state.rules[i].id].validate()) {
                    if (errors[this.state.rules[i].id]) {
                        delete errors[this.state.rules[i].id];
                    }
                }

                this.setState({ errors: errors });
            }

            if (Object.keys(errors).length > 0) {
                _Notification2.default.error('Please correct rules with errors before saving');
                return false;
            }

            this.setState({
                isLoading: true
            });

            var method = 'post';
            var url = '/segments';

            if (this.props.segmentId) {
                method = 'put';
                url += '/' + this.props.segmentId;
            }

            var rules = [];

            this.state.rules.map(function (rule) {
                if (_typeof(rule.value) === 'object') {
                    var values = [];
                    for (var _i in rule.value) {
                        if (rule.key == 'BoughtManufacturer') {
                            values.push(rule.value[_i].manufacturer);
                        } else {
                            values.push(rule.value[_i].id);
                        }
                    }
                    rule.value = values.join(',');
                }
                rules.push(rule);
            });

            var data = {
                'name': this.state.name,
                'rules': rules,
                'exportable': this.props.exportable,
                'remove_on_interaction': this.state.segment.remove_on_interaction,
                'audience_id': this.state.segment.audience_id
            };

            if (this.props.type) {
                data.type = this.props.type;
            }

            _axios2.default[method](url, data).then(function (res) {
                _Notification2.default.success('Segment saved');
                _this2.setState({
                    isLoading: false
                });

                _this2.props.handleSave(res.data);
                _this2.props.onClose();
            });
        }
    }, {
        key: 'handleRuleRemove',
        value: function handleRuleRemove(id) {
            var s = this.state.rules.filter(function (rule) {
                return rule.id !== id;
            });

            var errors = _extends({}, this.state.errors);

            delete errors[id];

            this.setState({
                rules: s,
                errors: errors
            });
        }
    }, {
        key: 'newCondition',
        value: function newCondition() {
            var s = this.state.rules.slice();

            s.push({
                'id': (0, _v2.default)(),
                'segment_id': (0, _v2.default)(),
                'key': 'OrderCount',
                'operator': '==',
                'value': false,
                'use_limit': false,
                'is_and': false,
                'from': null,
                'to': null,
                'use_relative': false,
                'relative': 30,
                'limit': 30
            });

            this.setState({
                rules: s
            });
        }
    }, {
        key: 'handleRuleChange',
        value: function handleRuleChange(index, key, value) {
            var s = this.state.rules.slice();

            if (s[index].key != key && key == 'key') {
                s[index].value = false;
                s[index].operator = false;
            }

            s[index][key] = value;
            this.setState({
                rules: s
            });
        }
    }, {
        key: 'renderAddCondition',
        value: function renderAddCondition() {
            return _react2.default.createElement(
                'li',
                { className: 'timeline-item timeline-reverse timeline-add' },
                _react2.default.createElement(
                    'div',
                    { className: 'timeline-dot bg-blue-grey-600' },
                    _react2.default.createElement('i', { className: 'icon wb-plus', 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'btn btn-dark', onClick: this.newCondition },
                    'New condition'
                )
            );
        }
    }, {
        key: 'renderTimeline',
        value: function renderTimeline() {
            var _this3 = this;

            var rules = [];

            this.state.rules.map(function (rule, i) {
                rules.push(_react2.default.createElement(_Rule2.default, { exportable: _this3.props.exportable, ref: rule.id, rules: _this3.state.rules, handleRuleError: _this3.handleRuleError, remove: _this3.handleRuleRemove, segment: _this3.state.segment, segmentId: _this3.props.segmentId, handleRuleChange: _this3.handleRuleChange, index: i, key: rule.id, rule: rule }));

                if (i + 1 < _this3.state.rules.length) {
                    rules.push(_react2.default.createElement(
                        'li',
                        { key: i + '-and', className: 'timeline-item timeline-reverse timeline-and' },
                        _react2.default.createElement(
                            'div',
                            { className: 'timeline-dot bg-blue-grey-600' },
                            'AND'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'timeline-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'card card-article' },
                                _react2.default.createElement('div', { className: 'card-block' })
                            )
                        )
                    ));
                }
            });

            return rules;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this4 = this;

            if (!this.props.segmentId) {
                this.setState({ 'isLoading': false });
                return true;
            }
            _axios2.default.get('/segments/' + this.props.segmentId).then(function (res) {
                res.data.rules = res.data.rules.map(function (r) {
                    return _extends({}, r, {
                        value: r.value === '' || !r.value ? false : r.value
                    });
                });
                _this4.setState({
                    'isLoading': false,
                    segment: res.data,
                    rules: res.data.rules,
                    name: res.data.name
                });
            }).catch(function (res) {
                _this4.setState({ 'isError': 'Segment not found' });
            });
        }
    }, {
        key: 'handleNameChange',
        value: function handleNameChange(e) {
            this.setState({
                name: e.target.value
            });
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                'div',
                { className: 'overview m-t-30 col-sm-8 offset-sm-2 text-center' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'Segment'
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    'This will create a exportable segment you can import to any ESP.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Description'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0 offset-sm-0' },
                        _react2.default.createElement('input', { type: 'text', onChange: this.handleNameChange, className: 'form-control form-control-lg', value: this.state.name, placeholder: 'Explain what this segment does..' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Conditions'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0 ' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'timeline timeline-icon' },
                            this.state.rules.length > 0 ? this.renderTimeline() : null,
                            this.renderAddCondition()
                        )
                    )
                ),
                (typeof this.props.exportable === 'undefined' || this.props.exportable == '0') && this.hasFacebook() ? _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 m-t-40 m-b-40 offset-sm-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Sync segment to a Custom Facebook Audience'
                        )
                    ),
                    _react2.default.createElement(_AudiencePicker2.default, { change: this.changeSegmentProp, segment: this.state.segment })
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 m-t-40 m-b-40 offset-sm-0' },
                    this.props.enabled == '0' ? _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to enable segments, you need to upgrade your account to a larger package' }) : _react2.default.createElement(
                        'button',
                        { type: 'button', onClick: this.save, className: 'btn btn-dark btn-block' },
                        'Save'
                    )
                )
            );
        }
    }]);

    return SegmentsNew;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

SegmentsNew = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SegmentsNew);
exports.default = SegmentsNew;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NumberPicker = function (_React$Component) {
    _inherits(NumberPicker, _React$Component);

    function NumberPicker(props) {
        _classCallCheck(this, NumberPicker);

        var _this = _possibleConstructorReturn(this, (NumberPicker.__proto__ || Object.getPrototypeOf(NumberPicker)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.minus = _this.minus.bind(_this);
        _this.plus = _this.plus.bind(_this);
        _this.getValue = _this.getValue.bind(_this);
        return _this;
    }

    _createClass(NumberPicker, [{
        key: "minus",
        value: function minus(e) {
            e.stopPropagation();
            var newVal = parseInt(this.props.value);
            newVal--;
            if (newVal < 0) {
                newVal = 0;
            }

            this.onChange(newVal);
        }
    }, {
        key: "getValue",
        value: function getValue() {
            var newVal = this.formatValue(this.props.value);

            if (!isNaN(parseFloat(this.props.value)) && isFinite(this.props.value)) {
                newVal = parseInt(this.props.value);
            } else {
                newVal = 0;
            }

            return newVal;
        }
    }, {
        key: "plus",
        value: function plus(e) {
            e.stopPropagation();
            var newVal = this.getValue();
            newVal++;
            this.onChange(newVal);
        }
    }, {
        key: "handleChange",
        value: function handleChange(e) {
            var val = e.target.value;
            this.onChange(val);
        }
    }, {
        key: "handleBlur",
        value: function handleBlur(e) {
            var val = e.target.value;

            if (val < 0) {
                val = 0;
            }

            this.onChange(val);
        }
    }, {
        key: "formatValue",
        value: function formatValue(val) {
            if (this.props.max) {
                if (val > this.props.max) {
                    val = this.props.max;
                }
            }

            if (this.props.min) {
                if (val < this.props.min) {
                    val = this.props.min;
                }
            }

            return val;
        }
    }, {
        key: "onChange",
        value: function onChange(val) {
            val = this.formatValue(val);

            this.props.handleChange(val);
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "input-group" },
                _react2.default.createElement(
                    "span",
                    { className: "input-group-btn" },
                    _react2.default.createElement(
                        "button",
                        { className: "btn btn-outline btn-default", onClick: this.minus, type: "button" },
                        _react2.default.createElement("i", { className: "wb-minus" })
                    )
                ),
                _react2.default.createElement("input", { type: "text", className: "form-control", onBlur: this.handleBlur, onChange: this.handleChange, value: this.getValue(), style: { textAlign: 'center' } }),
                _react2.default.createElement(
                    "span",
                    { className: "input-group-btn" },
                    _react2.default.createElement(
                        "button",
                        { onClick: this.plus, className: "btn btn-outline btn-default", type: "button" },
                        _react2.default.createElement("i", { className: "wb-plus" })
                    )
                ),
                this.props.type ? _react2.default.createElement(
                    "span",
                    { className: "input-group-addon" },
                    this.props.type
                ) : null
            );
        }
    }]);

    return NumberPicker;
}(_react2.default.Component);

exports.default = NumberPicker;

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

var _reactTabs = __webpack_require__(1726);

var _reactCodemirror = __webpack_require__(202);

var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);

__webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var product = "<div class=\"crall-product-item\">\n\t<div class=\"crall-product-image\">\n\t\t<a href=\"{{url}}\">\n\t\t\t<img src=\"{{ image }}\">\n\t\t</a>\n\t</div>\n\t{% if on_sale %}\n\t\t<div class=\"crall-banner\">\n\t\t\t<div>{{ percent_off }}%</div>\n\t\t</div>\n\t{% endif %}\n\t<div class=\"crall-product-name\">{{ name }}</div>\n\t<div class=\"crall-price\">\n\t\t{% if on_sale %}\n\t\t\t<span class=\"crall-old-price\">{{list_price | money:eu }}-</span>\n\t\t{% endif %}\n\t\t<span class=\"crall-price\">{{price | money:eu }}</span>\n\t</div>\n\t<a href=\"{{url}}\" class=\"crall-buy\">Buy</a>\n</div>";

var css = ".crall-product-list {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tposition: relative;\n}\n\n.crall-product-item {\n\twidth: 100%!important;\n\tmax-width:200px;\n\tdisplay:inline-block;\n\tposition:relative;\n\tfloat:none;\n\ttext-align:center;\n\toverflow:hidden;\n\twidth:180px;\n\ttransition: left 700ms;\n\tleft:0px;\n\tmargin-left:0px;\n}\n\n.crall-old-price {\n\ttext-decoration: line-through;\n\tcolor:#ccc;\n\tpadding-right: 5px;\n}\n\n.crall-buy {\n    padding: 4px 0;\n\tmargin-top:5px;\n\tdisplay:block;\n\tbackground-color: #b26da8;\n\tborder:0;\n\tcolor:#fff;\n\twidth: 100%;\n\ttext-decoration:none;\n}\n\n.crall-buy:hover {\n\tcolor:#ffffff;\n}\n\n.crall-banner > div {\n\tbackground-color: #f6eaf4;\n\twidth: 200px;\n\tfont-size: 16px;\n\tmargin-left: -60px;\n\tmargin-top: 20px;\n\tcolor: #333;\n\tpadding: 4px;\n\ttransform: rotate(-45deg);\n\tfont-weight: bold;\n}\n\n.crall-banner {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 200px;\n\theight: 200px;\n\tpointer-events: none;\n}\n";

var Template = function (_React$Component) {
    _inherits(Template, _React$Component);

    function Template(props) {
        _classCallCheck(this, Template);

        var _this = _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            recommendation: {
                id: 0,
                description: "",
                container: "",
                product: product,
                css: css,
                config: '{"spaceBetween":4}'
            }
        };
        _this.handleHtmlChange = _this.handleHtmlChange.bind(_this);

        _this.codeMirrorOptions = {
            lineNumbers: true,
            mode: "text/html",
            indentWithTabs: true,
            styleSelectedText: true,
            tabSize: 5,
            indentUnit: 5
        };

        _this.codeMirrorOptionsCss = {
            lineNumbers: true,
            mode: "text/css",
            indentWithTabs: true,
            styleSelectedText: true,
            tabSize: 5,
            indentUnit: 5
        };

        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.save = _this.save.bind(_this);
        return _this;
    }

    _createClass(Template, [{
        key: "handleHtmlChange",
        value: function handleHtmlChange(key, code) {
            this.setState({
                recommendation: _extends({}, this.state.recommendation, _defineProperty({}, key, code))
            });
        }
    }, {
        key: "save",
        value: function save(closeAfterSave) {
            var _this2 = this;

            if (this.state.recommendation.description == "") {
                _Notification2.default.error("You need to give this template a description.");
                return false;
            }

            if (this.state.recommendation.config != "") {
                try {
                    JSON.parse(this.state.recommendation.config);
                } catch (e) {
                    _Notification2.default.error('"Slider" is not valid JSON.');
                    return false;
                }
            }

            this.setState({
                isLoading: true
            });

            var method = "post";
            var url = "/recommendations/templates";

            if (this.props.recommendationId) {
                method = "put";
                url += "/" + this.props.recommendationId;
            }

            _axios2.default[method](url, this.state.recommendation).then(function (res) {
                _Notification2.default.success("Template saved");
                _this2.setState({
                    isLoading: false
                });

                _this2.props.handleSave(res.data);
                if (closeAfterSave) {
                    _this2.props.onClose();
                }
            });
        }
    }, {
        key: "handleNameChange",
        value: function handleNameChange(e) {
            this.setState(_extends({}, this.state, {
                recommendation: _extends({}, this.state.recommendation, {
                    description: e.target.value
                })
            }));
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            var _this3 = this;

            if (this.props.recommendationId) {
                _axios2.default.get("/recommendations/templates/" + this.props.recommendationId).then(function (res) {
                    _this3.setState({
                        isLoading: false,
                        recommendation: res.data
                    });
                }).catch(function (res) {
                    _this3.setState({ isError: "Recommendation not found" });
                });
            } else {
                this.setState({
                    isLoading: false
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                "div",
                {
                    id: "recommendation-template",
                    className: "overview m-t-30 col-sm-8 offset-sm-2 text-center"
                },
                _react2.default.createElement(
                    "h1",
                    null,
                    "Template"
                ),
                _react2.default.createElement(
                    "h2",
                    null,
                    "This will create a recommendation template. You can use this template to show recommendation boxes in your store."
                ),
                _react2.default.createElement(
                    "div",
                    { className: "m-t-40 col-sm-12" },
                    _react2.default.createElement(
                        "div",
                        { className: "m-b-20 strike" },
                        _react2.default.createElement(
                            "span",
                            null,
                            "Description"
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12 p-0 offset-sm-0" },
                        _react2.default.createElement("input", {
                            type: "text",
                            onChange: this.handleNameChange,
                            className: "form-control form-control-lg",
                            value: this.state.recommendation.description,
                            placeholder: "Give this test a description."
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "m-t-40 col-sm-12" },
                    _react2.default.createElement(
                        "div",
                        { className: "m-b-20 strike" },
                        _react2.default.createElement(
                            "span",
                            null,
                            "Code"
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12 p-0 offset-sm-0 text-left" },
                        _react2.default.createElement(
                            _reactTabs.Tabs,
                            null,
                            _react2.default.createElement(
                                _reactTabs.TabList,
                                null,
                                _react2.default.createElement(
                                    _reactTabs.Tab,
                                    null,
                                    "Product HTML"
                                ),
                                _react2.default.createElement(
                                    _reactTabs.Tab,
                                    null,
                                    "Container HTML"
                                ),
                                _react2.default.createElement(
                                    _reactTabs.Tab,
                                    null,
                                    "CSS"
                                ),
                                _react2.default.createElement(
                                    _reactTabs.Tab,
                                    null,
                                    "Advanced"
                                )
                            ),
                            _react2.default.createElement(
                                _reactTabs.TabPanel,
                                null,
                                _react2.default.createElement(_reactCodemirror2.default, {
                                    value: this.state.recommendation.product,
                                    onChange: function onChange(v) {
                                        _this4.handleHtmlChange("product", v);
                                    },
                                    options: this.codeMirrorOptions
                                })
                            ),
                            _react2.default.createElement(
                                _reactTabs.TabPanel,
                                null,
                                _react2.default.createElement(_reactCodemirror2.default, {
                                    value: this.state.recommendation.container,
                                    onChange: function onChange(v) {
                                        _this4.handleHtmlChange("container", v);
                                    },
                                    options: this.codeMirrorOptions
                                })
                            ),
                            _react2.default.createElement(
                                _reactTabs.TabPanel,
                                null,
                                _react2.default.createElement(_reactCodemirror2.default, {
                                    value: this.state.recommendation.css,
                                    onChange: function onChange(v) {
                                        _this4.handleHtmlChange("css", v);
                                    },
                                    options: this.codeMirrorOptionsCss
                                })
                            ),
                            _react2.default.createElement(
                                _reactTabs.TabPanel,
                                null,
                                _react2.default.createElement(_reactCodemirror2.default, {
                                    value: this.state.recommendation.config,
                                    onChange: function onChange(v) {
                                        _this4.handleHtmlChange("config", v);
                                    },
                                    options: this.codeMirrorOptions
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-12 m-t-40 m-b-40 offset-sm-0" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6" },
                        _react2.default.createElement(
                            "button",
                            {
                                type: "button",
                                onClick: function onClick() {
                                    return _this4.save(false);
                                },
                                className: "btn btn-dark btn-block"
                            },
                            "Save and continue"
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6" },
                        _react2.default.createElement(
                            "button",
                            {
                                type: "button",
                                onClick: function onClick() {
                                    return _this4.save(true);
                                },
                                className: "btn btn-dark btn-block"
                            },
                            "Save and close"
                        )
                    )
                )
            );
        }
    }]);

    return Template;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Template = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Template);
exports.default = Template;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(9);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var General = function () {
    function General() {
        _classCallCheck(this, General);
    }

    _createClass(General, null, [{
        key: "createDangerousHtml",
        value: function createDangerousHtml(html) {
            return { __html: html };
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }, {
        key: "countries",
        value: function countries() {
            var country_list = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

            return country_list;
        }
    }, {
        key: "toLocalTime",
        value: function toLocalTime(d) {
            return _moment2.default.utc(d);
        }
    }, {
        key: "parseValue",
        value: function parseValue(val) {
            if (val == 'true') {
                return true;
            } else if (val == 'false') {
                return false;
            }

            if (typeof val == 'undefined') {
                return false;
            }

            if (/^\d+$/.test(val)) {
                return parseInt(val);
            }

            return val;
        }
    }, {
        key: "linkify",
        value: function linkify(inputText) {
            var replacedText, replacePattern1, replacePattern2, replacePattern3;

            replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

            replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

            replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
            replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
            return replacedText;
        }
    }, {
        key: "secondsToString",
        value: function secondsToString(seconds) {
            var ret = '';
            var numyears = Math.floor(seconds / 31536000);
            var numdays = Math.floor(seconds % 31536000 / 86400);
            var numhours = Math.floor(seconds % 31536000 % 86400 / 3600);
            var numminutes = Math.floor(seconds % 31536000 % 86400 % 3600 / 60);
            var numseconds = seconds % 31536000 % 86400 % 3600 % 60;
            if (numyears != 0) {
                ret += numyears + "y ";
            }

            if (numdays != 0) {
                ret += numdays + "d ";
            }

            if (numhours != 0) {
                ret += numhours + "h ";
            }

            if (numminutes != 0) {
                ret += numminutes + "m ";
            }

            if (numseconds != 0) {
                ret += numseconds + "s ";
            }

            return ret;
        }
    }, {
        key: "stripHtml",
        value: function stripHtml(text) {
            if (text == '') {
                return text;
            }

            text = text.replace('<br>', 'XXbrXX');

            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };

            var t = text.replace(/[&<>"']/g, function (m) {
                return map[m];
            });

            t = t.replace('XXbrXX', '<br>');

            return t;
        }
    }, {
        key: "timeAgoFormatter",
        value: function timeAgoFormatter(value, unit, suffix) {
            if (unit !== 'second') {
                return [value, unit + (value !== 1 ? 's' : ''), suffix].join(' ');
            }

            if (suffix === 'ago') {
                return 'a few seconds ago';
            }

            if (suffix === 'from now') {
                return 'in a few seconds';
            }
        }
    }]);

    return General;
}();

exports.default = General;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(11);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _reactColor = __webpack_require__(610);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_React$Component) {
    _inherits(ColorPicker, _React$Component);

    function ColorPicker(props) {
        _classCallCheck(this, ColorPicker);

        var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, props));

        _this.state = {};

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.renderPicker = _this.renderPicker.bind(_this);
        _this.onTransparentChange = _this.onTransparentChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);
        _this.defaultState(props);

        return _this;
    }

    _createClass(ColorPicker, [{
        key: 'defaultState',
        value: function defaultState(props) {
            var show = false;
            if (this.state.displayColorPicker) {
                show = true;
            }

            this.state = {
                isTransparent: props.color == 'transparent' ? true : false,
                displayColorPicker: show,
                color: {
                    hex: props.color
                }
            };
        }
    }, {
        key: 'onTransparentChange',
        value: function onTransparentChange() {
            this.setState(_extends({}, this.state, {
                isTransparent: !this.state.isTransparent,
                color: {
                    hex: !this.state.isTransparent == true ? 'transparent' : this.state.color.hex
                }
            }));

            this.props.handleColorChange(this.props.id, !this.state.isTransparent == true ? 'transparent' : this.state.color.hex);
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.setState({ displayColorPicker: !this.state.displayColorPicker });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({ displayColorPicker: false });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.defaultState(nextProps);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(color) {
            color = color.hex;

            if (this.props.transparent === true) {
                if (this.state.isTransparent) {
                    this.setState(_extends({}, this.state, { isTransparent: false, color: { hex: color } }));
                } else {
                    this.setState(_extends({}, this.state, { color: { hex: color } }));
                }
            } else {
                this.setState(_extends({}, this.state, { color: { hex: color } }));
            }

            this.props.handleColorChange(this.props.id, color);
        }
    }, {
        key: 'renderPicker',
        value: function renderPicker() {
            var styles = (0, _reactcss2.default)({
                'default': {
                    color: {
                        width: '100%',
                        height: '100%',
                        borderRadius: '2px',
                        backgroundColor: this.state.color.hex
                    },
                    swatch: {
                        width: '100%',
                        height: '36px',
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        display: 'inline-block',
                        cursor: 'pointer'
                    },
                    popover: {
                        position: 'absolute',
                        zIndex: '2'
                    },
                    cover: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px'
                    }
                }
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { style: styles.swatch, onClick: this.handleClick },
                    _react2.default.createElement('div', { style: styles.color })
                ),
                this.state.displayColorPicker ? _react2.default.createElement(
                    'div',
                    { style: styles.popover },
                    _react2.default.createElement('div', { style: styles.cover, onClick: this.handleClose }),
                    _react2.default.createElement(_reactColor.SketchPicker, { color: this.state.color, onChange: this.handleChange })
                ) : null
            );
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.props.transparent === true) {
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-8 p-0' },
                        this.renderPicker()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'checkbox-custom checkbox-default' },
                            _react2.default.createElement('input', { type: 'checkbox', checked: this.state.isTransparent, onChange: this.onTransparentChange }),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Transparent'
                            )
                        )
                    )
                );
            }

            return this.renderPicker();
        }
    }]);

    return ColorPicker;
}(_react2.default.Component);

exports.default = ColorPicker;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = __webpack_require__(1428);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
	_inherits(Modal, _React$Component);

	function Modal() {
		_classCallCheck(this, Modal);

		return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));
	}

	_createClass(Modal, [{
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'render',
		value: function render() {

			var backdrop_style = {};
			if (this.props.zIndex) {
				backdrop_style.zIndex = this.props.zIndex;
			}

			return _react2.default.createElement(
				'div',
				{ className: 'fullscreen-overlay' },
				_react2.default.createElement(
					_reactAddonsCssTransitionGroup2.default,
					{
						transitionName: 'modal-backdrop',
						transitionEnterTimeout: 200,
						transitionLeaveTimeout: 200,
						transitionAppear: true,
						transitionAppearTimeout: 200
					},
					_react2.default.createElement('div', { className: 'fullscreen-backdrop', style: backdrop_style }),
					this.props.hideCloseButton ? null : _react2.default.createElement(
						'div',
						{ className: 'close-btn', onClick: this.props.closePortal },
						_react2.default.createElement('i', { className: 'icon fa-close' })
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'fullscreen-wrapper' },
					_react2.default.createElement(
						_reactAddonsCssTransitionGroup2.default,
						{
							transitionName: 'zoom-in',
							transitionEnterTimeout: 200,
							transitionLeaveTimeout: 200,
							transitionAppear: true,
							transitionAppearTimeout: 200 },
						this.props.children
					)
				)
			);
		}
	}]);

	return Modal;
}(_react2.default.Component);

exports.default = Modal;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddRuleItem = function (_React$Component) {
    _inherits(AddRuleItem, _React$Component);

    function AddRuleItem() {
        _classCallCheck(this, AddRuleItem);

        return _possibleConstructorReturn(this, (AddRuleItem.__proto__ || Object.getPrototypeOf(AddRuleItem)).apply(this, arguments));
    }

    _createClass(AddRuleItem, [{
        key: 'select',
        value: function select() {
            this.props.select({
                'key': this.props.ruleKey,
                'operator': this.props.operator,
                'value': this.props.value,
                'action': this.props.action
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'li',
                { className: 'list-group-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'media' },
                    _react2.default.createElement(
                        'div',
                        { className: 'media-left', style: { verticalAlign: 'middle' } },
                        _react2.default.createElement(
                            'a',
                            { className: 'avatar', href: 'javascript:void(0)', style: { width: '40px' } },
                            _react2.default.createElement('img', { className: 'img-fluid', src: '/images/svg/select.svg', alt: '...', style: { borderRadius: 0 } })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'media-body' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'media-heading' },
                            this.props.title
                        ),
                        _react2.default.createElement(
                            'small',
                            null,
                            this.props.description
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'media-right' },
                        _react2.default.createElement(
                            'button',
                            { onClick: this.select.bind(this), className: 'btn btn-dark btn-block' },
                            'Select'
                        )
                    )
                )
            );
        }
    }]);

    return AddRuleItem;
}(_react2.default.Component);

exports.default = AddRuleItem;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});
exports.addUsers = addUsers;
exports.addScript = addScript;
exports.setGlobalKey = setGlobalKey;
exports.addNotificationMessage = addNotificationMessage;
exports.setSetting = setSetting;
exports.setOpenConversation = setOpenConversation;
exports.setUnreadMessages = setUnreadMessages;
function addUsers(users) {
				return {
								type: 'GENERAL_ADD_USERS',
								payload: users
				};
}
function addScript(src) {
				return {
								type: 'GENERAL_ADD_SCRIPT',
								payload: src
				};
}
function setGlobalKey(key, value) {
				return {
								type: 'GENERAL_SET_GLOBAL_KEY',
								payload: { key: key, value: value }
				};
}

function addNotificationMessage(value) {
				return {
								type: 'GENERAL_ADD_MESSAGE',
								payload: value
				};
}

function setSetting(key, value) {
				return {
								type: 'GENERAL_SET_SETTING',
								payload: { key: key, value: value }
				};
}

function setOpenConversation(num) {
				return {
								type: 'GENERAL_SET_OPEN_CONVERSATIONS',
								payload: num
				};
}

function setUnreadMessages(num) {
				return {
								type: 'GENERAL_SET_UNREAD_MESSAGES',
								payload: num
				};
}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wsclient = __webpack_require__(1078);

var _wsclient2 = _interopRequireDefault(_wsclient);

var _redux = __webpack_require__(4);

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

var _General = __webpack_require__(44);

var _General2 = _interopRequireDefault(_General);

var _reactRouter = __webpack_require__(6);

var _General3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrowserNotifications = function () {
    function BrowserNotifications() {
        _classCallCheck(this, BrowserNotifications);

        if (typeof localStorage.notifications !== "undefined") {
            _store2.default.dispatch((0, _General3.setGlobalKey)("notifications", localStorage.notifications));
        }
    }

    _createClass(BrowserNotifications, [{
        key: "new",
        value: function _new(data) {
            if (!("Notification" in window)) {
                return false;
            }

            if (_store2.default.getState().general.windowHasFocus !== false) {
                //return;
            }

            if (Notification.permission == "granted") {
                if (data.sound == true) {
                    window.crall_audio.message_pling.play();
                }
                var notification = new Notification(data.title, {
                    icon: "/icon/android-chrome-72x72.png",
                    body: data.message
                });

                notification.onclick = function () {
                    window.focus();
                    if (data.link) {
                        _reactRouter.hashHistory.push(data.link);
                    }
                    notification.close();
                };

                setTimeout(notification.close.bind(notification), 10000);
            }
        }
    }, {
        key: "askForNotifications",
        value: function askForNotifications() {
            if (!("Notification" in window)) {
                return false;
            }

            if (typeof localStorage.notifications !== "undefined") {
                return false;
            }

            if (_store2.default.getState().general.notifications !== null) {
                return false;
            }

            return true;
        }
    }, {
        key: "dontAskAgain",
        value: function dontAskAgain() {
            localStorage.setItem("notifications", false);
            _store2.default.dispatch((0, _General3.setGlobalKey)("notifications", false));
        }
    }, {
        key: "getPermission",
        value: function getPermission() {
            if (Notification.permission !== "denied") {
                Notification.requestPermission(function (permission) {
                    if (permission === "granted") {
                        localStorage.setItem("notifications", true);
                        _store2.default.dispatch((0, _General3.setGlobalKey)("notifications", true));
                    }
                });
            } else {
                this.dontAskAgain();
            }
        }
    }]);

    return BrowserNotifications;
}();

exports.default = new BrowserNotifications();

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setSegments = setSegments;
exports.updateSegment = updateSegment;
function setSegments(segments) {
    return {
        type: 'SEGMENT_SET',
        payload: segments
    };
}

function updateSegment(index, segment) {
    return {
        type: 'SEGMENT_UPDATE',
        payload: { index: index, segment: segment }
    };
}

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Confirm = function (_React$Component) {
	_inherits(Confirm, _React$Component);

	function Confirm(props) {
		_classCallCheck(this, Confirm);

		return _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this, props));
	}

	_createClass(Confirm, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_reactPortal2.default,
				{ closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
				_react2.default.createElement(
					_FullScreenOverlay2.default,
					null,
					_react2.default.createElement(
						'div',
						{ className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
						_react2.default.createElement(
							'h1',
							null,
							this.props.title
						),
						_react2.default.createElement(
							'h2',
							null,
							this.props.body
						),
						_react2.default.createElement(
							'div',
							{ className: 'm-t-30' },
							_react2.default.createElement(
								'button',
								{ onClick: this.props.onClose, className: 'btn btn-lg btn-danger' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('i', { style: { color: '#fff' }, className: 'icon wb-close' }),
									this.props.cancel ? this.props.cancel : 'Cancel'
								)
							),
							'\xA0\xA0\xA0',
							_react2.default.createElement(
								'button',
								{ onClick: function onClick(e) {
										e.stopPropagation();_this2.props.onAccept(_this2.props.param);
									}, className: 'btn btn-lg btn-dark' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('i', { className: 'icon wb-check' }),
									this.props.accept ? this.props.accept : "Let's do it!"
								)
							)
						)
					)
				)
			);
		}
	}]);

	return Confirm;
}(_react2.default.Component);

exports.default = Confirm;

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Text = function () {
	function Text(r) {
		_classCallCheck(this, Text);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Text, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('value')) {
				this.item.value = 'This is an example text.';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('padding')) {
				this.item.padding = '10px 10px 10px 10px';
			}
		}
	}]);

	return Text;
}();

exports.default = Text;

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Upload = function () {
	function Upload(r) {
		_classCallCheck(this, Upload);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Upload, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('image')) {
				this.item.image = false;
			}

			if (!this.isset('isUploading')) {
				this.item.isUploading = false;
			}

			if (!this.isset('url')) {
				this.item.url = '';
			}

			if (!this.isset('enabled')) {
				this.item.enabled = false;
			}

			if (!this.isset('align')) {
				this.item.align = 'center';
			}

			if (!this.isset('original_width')) {
				this.item.original_width = 0;
			}

			if (!this.isset('original_height')) {
				this.item.original_height = 0;
			}

			if (!this.isset('padding')) {
				this.item.padding = '10px 10px 10px 10px';
			}

			if (!this.isset('openInNewWindow')) {
				this.item.openInNewWindow = true;
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}
		}
	}]);

	return Upload;
}();

exports.default = Upload;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingPicker = function (_React$Component) {
    _inherits(PaddingPicker, _React$Component);

    function PaddingPicker(props) {
        _classCallCheck(this, PaddingPicker);

        var _this = _possibleConstructorReturn(this, (PaddingPicker.__proto__ || Object.getPrototypeOf(PaddingPicker)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.output = _this.output.bind(_this);

        _this.defaultState(props);

        return _this;
    }

    _createClass(PaddingPicker, [{
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                timestamp: new Date().getMilliseconds()
            };

            if (props.data != '') {
                var val = props.data.replace(/px/g, "");
                var data = props.data.replace(/px/g, "").split(' ');
                this.state = {
                    top: data[0],
                    right: data[1],
                    bottom: data[2],
                    left: data[3],
                    timestamp: new Date().getMilliseconds()
                };
            }
        }
    }, {
        key: 'fixEmpty',
        value: function fixEmpty(val) {
            return val;
        }
    }, {
        key: 'output',
        value: function output() {
            var change = this.fixEmpty(this.state.top) + 'px ' + this.fixEmpty(this.state.right) + 'px ' + this.fixEmpty(this.state.bottom) + 'px ' + this.fixEmpty(this.state.left) + 'px';
            console.log(change);
            this.props.handlePaddingChange(this.props.id, change);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.defaultState(nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevObject, prevState) {
            if (this.state.timestamp != prevState.timestamp) {
                this.output();
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _setState;

            var val = e.target.value.replace(/[^0-9.]+/g, "");

            this.setState((_setState = {}, _defineProperty(_setState, e.target.id, val), _defineProperty(_setState, 'timestamp', new Date().getMilliseconds()), _setState));
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'top', value: this.state.top, onChange: this.onChange, placeholder: 'Top' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-addon' },
                            'px'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6 p-2' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'right', value: this.state.right, onChange: this.onChange, placeholder: 'Right' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-addon' },
                            'px'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'bottom', value: this.state.bottom, onChange: this.onChange, placeholder: 'Bottom' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-addon' },
                            'px'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-6 p-2' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'left', value: this.state.left, onChange: this.onChange, placeholder: 'Left' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-addon' },
                            'px'
                        )
                    )
                )
            );
        }
    }]);

    return PaddingPicker;
}(_react2.default.Component);

exports.default = PaddingPicker;

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Spacing = function () {
	function Spacing(r) {
		_classCallCheck(this, Spacing);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Spacing, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('value')) {
				this.item.value = '40px';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}
		}
	}]);

	return Spacing;
}();

exports.default = Spacing;

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cart = function () {
	function Cart(r) {
		_classCallCheck(this, Cart);

		this.item = {};
		if (r != false) {
			this.item = r;
		}

		this.defaults();
	}

	_createClass(Cart, [{
		key: 'isset',
		value: function isset(key) {
			if (typeof this.item[key] === 'undefined') {
				return false;
			}

			return true;
		}
	}, {
		key: 'output',
		value: function output() {
			return this.item;
		}
	}, {
		key: 'defaults',
		value: function defaults() {
			if (!this.isset('button_align')) {
				this.item.button_align = 'right';
			}

			if (!this.isset('button_text')) {
				this.item.button_text = 'Go to checkout';
			}

			if (!this.isset('button_border')) {
				this.item.button_border = '1px|solid|#4e97d9';
			}

			if (!this.isset('button_background')) {
				this.item.button_background = '#4e97d9';
			}
			if (!this.isset('button_font')) {
				this.item.button_font = 'inherit';
			}

			if (!this.isset('button_size')) {
				this.item.button_size = 'inherit';
			}

			if (!this.isset('button_color')) {
				this.item.button_color = 'inherit';
			}

			if (!this.isset('text_color')) {
				this.item.text_color = 'inherit';
			}

			if (!this.isset('text_size')) {
				this.item.text_size = 'inherit';
			}

			if (!this.isset('text_font')) {
				this.item.text_font = 'inherit';
			}

			if (!this.isset('link_color')) {
				this.item.link_color = 'inherit';
			}

			if (!this.isset('link_size')) {
				this.item.link_size = 'inherit';
			}

			if (!this.isset('link_font')) {
				this.item.link_font = 'inherit';
			}

			if (!this.isset('id')) {
				this.item.id = false;
			}

			if (!this.isset('padding')) {
				this.item.padding = '10px 10px 10px 10px';
			}
		}
	}]);

	return Cart;
}();

exports.default = Cart;

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _LinkPicker = __webpack_require__(93);

var _LinkPicker2 = _interopRequireDefault(_LinkPicker);

var _AlignPicker = __webpack_require__(74);

var _AlignPicker2 = _interopRequireDefault(_AlignPicker);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _BorderPicker = __webpack_require__(66);

var _BorderPicker2 = _interopRequireDefault(_BorderPicker);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_React$Component) {
	_inherits(Button, _React$Component);

	function Button(props) {
		_classCallCheck(this, Button);

		var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

		_this.onPaddingChange = _this.onPaddingChange.bind(_this);
		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.componentDidMount = _this.componentDidMount.bind(_this);
		_this.handleLinkChange = _this.handleLinkChange.bind(_this);
		_this.handleAlignChange = _this.handleAlignChange.bind(_this);
		_this.handleBorderChange = _this.handleBorderChange.bind(_this);

		return _this;
	}

	_createClass(Button, [{
		key: 'handleAlignChange',
		value: function handleAlignChange(id, s) {
			this.props.setComponentState(this.el().id, { 'align': s });
		}
	}, {
		key: 'handleLinkChange',
		value: function handleLinkChange(id, s) {

			this.props.setComponentState(this.el().id, s);
		}
	}, {
		key: 'onPaddingChange',
		value: function onPaddingChange(id, padding) {
			var changes = {};
			changes[id] = padding;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { value: v.target.value });
		}
	}, {
		key: 'handleBorderChange',
		value: function handleBorderChange(id, border) {
			var changes = {};
			changes[id] = border;

			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Button' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'button-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'button', parent: 'button-settings', title: 'Button' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Text' },
								_react2.default.createElement('input', { type: 'text', value: this.el().value, onChange: this.onChange, className: 'form-control' })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Border' },
								_react2.default.createElement(_BorderPicker2.default, { id: 'border', handleBorderChange: this.handleBorderChange, data: this.el().border })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Background color' },
								_react2.default.createElement(_ColorPicker2.default, { transparent: true, id: 'backgroundColor', color: this.el().backgroundColor, handleColorChange: this.handleBorderChange })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Text color' },
								_react2.default.createElement(_ColorPicker2.default, { transparent: false, id: 'color', color: this.el().color, handleColorChange: this.handleBorderChange })
							),
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Horizontal position' },
								_react2.default.createElement(_AlignPicker2.default, { id: 'align', align: this.el().align, handleChange: this.handleAlignChange })
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'link', parent: 'button-settings', title: 'Link' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Link' },
								_react2.default.createElement(_LinkPicker2.default, { onlyPickUrl: true, handleLinkChange: this.handleLinkChange, data: this.props.builder.components[this.props.id] })
							)
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'spacing', parent: 'button-settings', title: 'Spacing' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Padding' },
								_react2.default.createElement(_PaddingPicker2.default, { id: 'padding', handlePaddingChange: this.onPaddingChange, data: this.el().padding })
							)
						)
					)
				);
			} else {
				var button_style = {
					border: this.el().border.replace(/\|/g, ' '),
					backgroundColor: this.el().backgroundColor,
					color: this.el().color ? this.el().color : '#ffffff'
				};

				return _react2.default.createElement(
					'table',
					{ className: 'table-block', style: { width: '100%' } },
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ style: { textAlign: this.el().align, padding: this.el().padding } },
								_react2.default.createElement(
									'a',
									{ className: 'click-button', style: button_style, href: 'javascript:void(0)' },
									this.el().value
								)
							)
						)
					)
				);
			}
		}
	}]);

	return Button;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Button = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Button);

exports.default = Button;

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _rcSlider = __webpack_require__(200);

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spacing = function (_React$Component) {
	_inherits(Spacing, _React$Component);

	function Spacing(props) {
		_classCallCheck(this, Spacing);

		var _this = _possibleConstructorReturn(this, (Spacing.__proto__ || Object.getPrototypeOf(Spacing)).call(this, props));

		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		return _this;
	}

	_createClass(Spacing, [{
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'renderSettings',
		value: function renderSettings() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
				'Dette er en test'
			);
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { value: v + 'px' });
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Spacing' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'spacing-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'spacing', parent: 'spacing-settings', title: 'Spacing' },
							_react2.default.createElement(
								_SidebarElementSetting2.default,
								{ text: 'Height' },
								_react2.default.createElement(_rcSlider2.default, { value: parseInt(this.el().value.toString().replace('px', '')),
									onChange: this.onChange,
									min: 10,
									max: 400
								})
							)
						)
					)
				);
			} else {
				return _react2.default.createElement('div', { className: 'text main', style: { height: this.el().value } });
			}
		}
	}]);

	return Spacing;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Spacing = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Spacing);

exports.default = Spacing;

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _Builder = __webpack_require__(34);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _SidebarElementSpacing = __webpack_require__(36);

var _SidebarElementSpacing2 = _interopRequireDefault(_SidebarElementSpacing);

var _PaddingPicker = __webpack_require__(59);

var _PaddingPicker2 = _interopRequireDefault(_PaddingPicker);

var _SidebarElementWrapper = __webpack_require__(37);

var _SidebarElementWrapper2 = _interopRequireDefault(_SidebarElementWrapper);

var _SidebarElementSetting = __webpack_require__(38);

var _SidebarElementSetting2 = _interopRequireDefault(_SidebarElementSetting);

var _SidebarSettingAccordion = __webpack_require__(39);

var _SidebarSettingAccordion2 = _interopRequireDefault(_SidebarSettingAccordion);

var _SidebarElementHeader = __webpack_require__(35);

var _SidebarElementHeader2 = _interopRequireDefault(_SidebarElementHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = function (_React$Component) {
	_inherits(Text, _React$Component);

	function Text(props) {
		_classCallCheck(this, Text);

		var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props));

		_this.onPaddingChange = _this.onPaddingChange.bind(_this);
		_this.el = _this.el.bind(_this);
		_this.handleBackClick = _this.handleBackClick.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		_this.componentDidMount = _this.componentDidMount.bind(_this);
		_this.renderEditor = _this.renderEditor.bind(_this);
		_this.instance = false;

		_this.state = {
			// Bytt mellom textarea virker ikke. TEkst blir ikke oppdatert.
		};
		return _this;
	}

	_createClass(Text, [{
		key: 'onPaddingChange',
		value: function onPaddingChange(id, padding) {
			var changes = {};
			changes[id] = padding;
			this.props.setComponentState(this.el().id, changes);
		}
	}, {
		key: 'el',
		value: function el() {
			return this.props.builder.components[this.props.id];
		}
	}, {
		key: 'renderSettings',
		value: function renderSettings() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_SidebarElementSpacing2.default, { text: 'Settings' }),
				'Dette er en test'
			);
		}
	}, {
		key: 'handleBackClick',
		value: function handleBackClick() {
			this.props.setSidebarState({ 'visible': false });
		}
	}, {
		key: 'onChange',
		value: function onChange(v) {
			this.props.setComponentState(this.el().id, { value: v });
		}
	}, {
		key: 'renderEditor',
		value: function renderEditor() {
			var _this2 = this;

			if (this.instance !== false) {
				this.instance.destroy();
				this.instance = false;
			}

			this.instance = CKEDITOR.replace(this.textInput, {
				customConfig: '/assets/js/ckeditor/editorConfig.js',
				width: '100%',
				height: '100%',
				on: {
					change: function change(evt) {
						_this2.onChange(_this2.instance.getData());
					}
				}
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.sidebar) {
				this.renderEditor();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			if (this.props.sidebar) {
				if (next.builder.components[next.id].id != this.props.id) {
					this.instance.destroy();
				}
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.props.sidebar) {
				this.renderEditor();
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(props, state) {
			if (this.props.sidebar && props.id == this.props.id) {
				return false;
			}
			return true;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (this.props.sidebar == true) {
				return _react2.default.createElement(
					'div',
					{ className: 'sidebar text', style: this.props.style },
					_react2.default.createElement(_SidebarElementHeader2.default, { handleBackClick: this.handleBackClick, text: 'Text' }),
					_react2.default.createElement(
						'div',
						{ className: 'panel-group panel-group-continuous', id: 'text-settings', 'aria-multiselectable': 'true', role: 'tablist' },
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'content', parent: 'text-settings', title: 'Content' },
							_react2.default.createElement('textarea', { ref: function ref(input) {
									_this3.textInput = input;
								}, onChange: function onChange() {
									return null;
								}, value: this.el().value })
						),
						_react2.default.createElement(
							_SidebarSettingAccordion2.default,
							{ selectedSetting: false, optionKey: 'padding', parent: 'text-settings', title: 'Padding' },
							_react2.default.createElement(_PaddingPicker2.default, { id: 'padding', handlePaddingChange: this.onPaddingChange, data: this.el().padding })
						)
					)
				);
			} else {
				return _react2.default.createElement('div', { className: 'text main', style: { textAlign: 'left', padding: this.el().padding }, dangerouslySetInnerHTML: { __html: this.el().value } });
			}
		}
	}]);

	return Text;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		builder: state.builder
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return (0, _redux.bindActionCreators)({ setComponentState: _Builder.setComponentState, setSidebarState: _Builder.setSidebarState }, dispatch);
};

Text = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Text);

exports.default = Text;

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.name) {
        errors.name = 'Required';
    }

    if (values.auto_update === true) {
        if (!values.amount && !values.clone) {
            errors.amount = 'Required';
        } else {
            if (values.clone && !values.code) {
                errors.code = 'Required';
            }
        }
    } else {
        if (!values.code) {
            errors.code = 'Required';
        }
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        disabled = _ref.disabled,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type, disabled: disabled })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var checkbox = function checkbox(_ref2) {
    var input = _ref2.input,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'checkbox-custom checkbox-primary' },
        _react2.default.createElement('input', _extends({}, input, { name: name, type: type })),
        _react2.default.createElement(
            'label',
            null,
            title
        )
    );
};

var select = function select(_ref3) {
    var input = _ref3.input,
        options = _ref3.options,
        name = _ref3.name,
        className = _ref3.className,
        disabled = _ref3.disabled,
        placeholder = _ref3.placeholder,
        title = _ref3.title,
        type = _ref3.type,
        _ref3$meta = _ref3.meta,
        touched = _ref3$meta.touched,
        error = _ref3$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, disabled: disabled, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var CreateDiscount = function (_React$Component) {
    _inherits(CreateDiscount, _React$Component);

    function CreateDiscount() {
        _classCallCheck(this, CreateDiscount);

        return _possibleConstructorReturn(this, (CreateDiscount.__proto__ || Object.getPrototypeOf(CreateDiscount)).apply(this, arguments));
    }

    _createClass(CreateDiscount, [{
        key: 'type',
        value: function type() {
            return [{
                value: 'percent',
                label: 'Percent'
            }, {
                value: 'sum',
                label: 'Amount off'
            }];
        }
    }, {
        key: 'expire',
        value: function expire() {
            return [{
                value: 1,
                label: '24 hours'
            }, {
                value: 2,
                label: '2 days'
            }, {
                value: 3,
                label: '3 days'
            }, {
                value: 4,
                label: '4 days'
            }, {
                value: 5,
                label: '5 days'
            }, {
                value: 6,
                label: '6 days'
            }, {
                value: 7,
                label: '7 days'
            }];
        }
    }, {
        key: 'isCodeDisabled',
        value: function isCodeDisabled() {
            if (this.props.auto_update === true && this.props.clone === true) {
                return false;
            }

            if (this.props.auto_update === true && !this.props.clone) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isCloning',
        value: function isCloning() {
            if (this.props.auto_update === true && this.props.clone === true) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'name', placeholder: 'My first discount', title: 'Name', className: 'form-control' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6' },
                            _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'code', disabled: this.isCodeDisabled(), placeholder: '20PERCENTOFF', title: 'Code', className: 'form-control' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reduxForm.Field, { component: checkbox, type: 'checkbox', name: 'auto_update', title: 'Automatically create codes as needed in your store', className: 'form-control' })
                        ),
                        this.props.auto_update ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: renderField, disabled: this.isCloning(), type: 'text', name: 'amount', placeholder: '20', title: 'Amount', className: 'form-control' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: select, disabled: this.isCloning(), options: this.type(), name: 'type', title: 'Type' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(_reduxForm.Field, { component: select, options: this.expire(), name: 'expire', title: 'Expire after' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(_reduxForm.Field, { component: checkbox, type: 'checkbox', name: 'clone', title: 'Clone existing code', className: 'form-control' })
                            )
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            this.props.isWaiting ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                'button',
                                { type: 'submit', className: 'btn btn-dark btn-block' },
                                'Save'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CreateDiscount;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

var selector = (0, _reduxForm.formValueSelector)('CreateDiscount');

// Decorate the form component
CreateDiscount = (0, _reduxForm.reduxForm)({
    form: 'CreateDiscount',
    validate: validate
})(CreateDiscount);

CreateDiscount = (0, _reactRedux.connect)(function (state) {
    return {
        auto_update: selector(state, 'auto_update'),
        clone: selector(state, 'clone')
    };
})(CreateDiscount);

exports.default = CreateDiscount;

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecommendationHelper = function () {
    function RecommendationHelper() {
        _classCallCheck(this, RecommendationHelper);

        this.provider = {
            mailchimp: {
                timestamp: '*|DATE:Y-m-d|*',
                email: '*|EMAIL|*'
            },
            apsis: {
                email: '##SubscriberEmail##',
                timestamp: '##TodayDate##'
            },
            crall: {
                email: '@@EMAIL@@',
                timestamp: '@@TODAY@@'
            },
            custom: {
                email: '[INSERT_EMAIL_ADDRESS]',
                timestamp: '[INSERT_DATE]'
            }
        };
    }

    _createClass(RecommendationHelper, [{
        key: 'getProvider',
        value: function getProvider(provider) {
            return this.provider[provider];
        }
    }, {
        key: 'emailCode',
        value: function emailCode(recommendation, provider) {
            var code = '<center>';
            for (var i = 0; i < recommendation.number_of_products; i++) {
                code += '\n    <a href="https://app.crall.io/beacon/v1/recommendation/' + recommendation.id + '/embed/click?i=' + i + '&email=' + this.getProvider(provider).email + '" style="text-decoration: none;" target="_blank">\n        <img style="max-width:165px;width:23%;" width="23%" src="https://app.crall.io/beacon/v2/recommendation/' + recommendation.account_id + '/' + recommendation.description + '/embed?i=' + i + '&timestamp=' + this.getProvider(provider).timestamp + '&email=' + this.getProvider(provider).email + '" />\n    </a>';
            }
            code += '\n</center>';

            return code;
        }
    }]);

    return RecommendationHelper;
}();

exports.default = new RecommendationHelper();

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarTabButton = function SidebarTabButton(_ref) {
	var setSelectedTab = _ref.setSelectedTab,
	    text = _ref.text,
	    tab = _ref.tab,
	    selectedTab = _ref.selectedTab,
	    colSize = _ref.colSize,
	    disabled = _ref.disabled;
	return _react2.default.createElement(
		'a',
		{ href: 'javascript:void(0)', onClick: function onClick() {
				return setSelectedTab(tab);
			}, className: (tab == selectedTab ? 'current' : '') + ' ' + (colSize ? colSize : 'col-sm-4') + ' ' + (disabled === true ? 'disabled' : '') + ' btn btn-outline btn-default' },
		text
	);
};

exports.default = SidebarTabButton;

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OperatorPicker = function (_React$Component) {
    _inherits(OperatorPicker, _React$Component);

    function OperatorPicker(props) {
        _classCallCheck(this, OperatorPicker);

        var _this = _possibleConstructorReturn(this, (OperatorPicker.__proto__ || Object.getPrototypeOf(OperatorPicker)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.showSelector = _this.showSelector.bind(_this);
        _this.swapEdit = _this.swapEdit.bind(_this);
        _this.defaultState(props);
        _this.dropdownItem = _this.dropdownItem.bind(_this);
        _this.displayValue = _this.displayValue.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.available = {
            '<=': 'is less or equal to',
            '>=': 'is greater or equal to',
            '==': 'is equal to',
            '%%': 'contains',
            '!=': 'is not equal to'
        };

        return _this;
    }

    _createClass(OperatorPicker, [{
        key: 'swapEdit',
        value: function swapEdit(e) {
            this.setState({ 'isEditing': !this.state.isEditing });
        }
    }, {
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'isEditing': false
            };
        }
    }, {
        key: 'displayValue',
        value: function displayValue(value) {
            return this.available[value];
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            /*if(this.props.rule.operator == '' || typeof this.available[this.props.rule.value] == 'undefined' ) {
                this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':4});
            }*/
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(i) {
            this.swapEdit();
            this.props.setGlobalTypeState('rules', this.props.rule.id, { 'operator': i });
        }
    }, {
        key: 'dropdownItem',
        value: function dropdownItem(i, value) {
            var _this2 = this;

            if (typeof this.props.include === 'undefined') {
                return _react2.default.createElement(
                    'a',
                    { key: i, onClick: function onClick(e) {
                            e.stopPropagation();_this2.handleOnChange(i);
                        }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                    value
                );
            }

            if (this.props.include.includes(i)) {
                return _react2.default.createElement(
                    'a',
                    { key: i, onClick: function onClick(e) {
                            e.stopPropagation();_this2.handleOnChange(i);
                        }, className: 'dropdown-item', href: 'javascript:void(0)', role: 'menuitem', tabIndex: '-1' },
                    value
                );
            }

            return null;
        }
    }, {
        key: 'showSelector',
        value: function showSelector() {
            var _this3 = this;

            if (!this.state.isEditing) {
                return _react2.default.createElement(
                    'span',
                    { onClick: function onClick(e) {
                            e.stopPropagation();_this3.swapEdit(e);
                        }, className: 'selected-rule' },
                    this.displayValue(this.props.rule.operator)
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'dropdown open' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-dark dropdown-toggle btn-sm', 'aria-expanded': 'true', 'data-toggle': 'dropdown' },
                    this.displayValue(this.props.rule.operator),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu' },
                    Object.keys(this.available).map(function (i) {
                        return _this3.dropdownItem(i, _this3.available[i]);
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'span',
                null,
                this.showSelector(),
                ' \xA0'
            );
        }
    }]);

    return OperatorPicker;
}(_react2.default.Component);

exports.default = OperatorPicker;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ColorPicker = __webpack_require__(46);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BorderPicker = function (_React$Component) {
    _inherits(BorderPicker, _React$Component);

    function BorderPicker(props) {
        _classCallCheck(this, BorderPicker);

        var _this = _possibleConstructorReturn(this, (BorderPicker.__proto__ || Object.getPrototypeOf(BorderPicker)).call(this, props));

        _this.changeWidth = _this.changeWidth.bind(_this);
        _this.changeType = _this.changeType.bind(_this);
        _this.output = _this.output.bind(_this);
        _this.handleColorChange = _this.handleColorChange.bind(_this);
        _this.defaultState = _this.defaultState.bind(_this);

        _this.defaultState(props);

        return _this;
    }

    _createClass(BorderPicker, [{
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                color: '#000000',
                width: 0,
                type: 'none',
                timestamp: new Date().getMilliseconds()
            };

            if (props.data != 'none') {
                var data = [];
                if (props.format == true) {
                    data = props.data.split(' ');
                } else {
                    data = props.data.split('|');
                }

                this.state = {
                    color: data[2],
                    width: data[0].replace('px', ''),
                    type: data[1]
                };
            }
        }
    }, {
        key: 'output',
        value: function output() {
            var change = this.state.width + 'px|' + this.state.type + '|' + this.state.color;

            if (this.props.format === true) {
                change = this.state.width + 'px ' + this.state.type + ' ' + this.state.color;
            }

            this.props.handleBorderChange(this.props.id, change);
        }
    }, {
        key: 'changeType',
        value: function changeType(val) {
            this.setState({ type: val.value, timestamp: new Date().getMilliseconds() });
        }
    }, {
        key: 'handleColorChange',
        value: function handleColorChange(key, color) {
            this.setState({ color: color, timestamp: new Date().getMilliseconds() });
        }
    }, {
        key: 'renderLabel',
        value: function renderLabel(key, name) {
            return _react2.default.createElement(
                'div',
                { className: 'picker-value' },
                _react2.default.createElement(
                    'div',
                    { className: 'picker-preview' },
                    _react2.default.createElement(
                        'div',
                        { className: 'pre ' + key },
                        '\xA0'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'picker-description' },
                    name
                ),
                _react2.default.createElement('div', { className: 'clearfix' })
            );
        }
    }, {
        key: 'changeWidth',
        value: function changeWidth(e) {
            var val = e.target.value.replace(/[^0-9.]+/g, "");

            this.setState({ width: val, timestamp: new Date().getMilliseconds() });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.defaultState(nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevObject, prevState) {
            if (this.state.timestamp != prevState.timestamp) {
                this.output();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var options = [{ value: 'none', clearableValue: false, label: this.renderLabel('none', 'None') }, { value: 'solid', clearableValue: false, label: this.renderLabel('solid', 'Solid') }, { value: 'dashed', clearableValue: false, label: this.renderLabel('dashed', 'Dashed') }, { value: 'dotted', clearableValue: false, label: this.renderLabel('dotted', 'Dotted') }];

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-5 p-0' },
                    _react2.default.createElement(_reactSelect2.default, {
                        allowCreate: false,
                        searchable: false,
                        clearable: false,
                        name: 'form-field-name',
                        value: this.state.type,
                        options: options,
                        onChange: this.changeType
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-5' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.width, onChange: this.changeWidth, placeholder: 'Border width' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-addon' },
                            'px'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-2' },
                    _react2.default.createElement(_ColorPicker2.default, { id: 'innerBackgroundColor', color: this.state.color, handleColorChange: this.handleColorChange })
                )
            );
        }
    }]);

    return BorderPicker;
}(_react2.default.Component);

exports.default = BorderPicker;

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _reactPortal = __webpack_require__(47);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _FullScreenOverlay = __webpack_require__(48);

var _FullScreenOverlay2 = _interopRequireDefault(_FullScreenOverlay);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RulePicker = function (_React$Component) {
    _inherits(RulePicker, _React$Component);

    function RulePicker(props) {
        _classCallCheck(this, RulePicker);

        var _this = _possibleConstructorReturn(this, (RulePicker.__proto__ || Object.getPrototypeOf(RulePicker)).call(this, props));

        _this.state = {};

        _this.addRule = _this.addRule.bind(_this);

        return _this;
    }

    _createClass(RulePicker, [{
        key: 'addRule',
        value: function addRule(rule) {
            rule.key = rule.key.replace('Rule', '');
            rule.id = (0, _v2.default)();
            this.props.addRule(rule);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _reactPortal2.default,
                { closeOnEsc: true, onClose: this.props.onClose, isOpened: this.props.param !== false ? true : false },
                _react2.default.createElement(
                    _FullScreenOverlay2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                        _react2.default.createElement(
                            'h1',
                            null,
                            'New rule'
                        ),
                        _react2.default.createElement(
                            'h2',
                            null,
                            'Select the rule you want to add'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'm-t-30 col-sm-8 offset-sm-2' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'list-group list-group-full' },
                                Object.keys(this.props.available).map(function (key) {
                                    for (var i in _this2.props.rules) {
                                        if ('Rule' + _this2.props.rules[i].key == key) {
                                            return null;
                                        }
                                    }
                                    var Comp = _this2.props.available[key];
                                    return _react2.default.createElement(Comp, { key: key, addRule: _this2.addRule, ruleKey: key, onlyDescription: true });
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RulePicker;
}(_react2.default.Component);

exports.default = RulePicker;

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
			value: true
});
exports.popupSetGlobalKey = popupSetGlobalKey;
exports.popupRemoveRule = popupRemoveRule;
exports.popupSetRule = popupSetRule;
exports.popupSetSettingData = popupSetSettingData;
exports.popupSetContentData = popupSetContentData;
exports.popupSetStyleData = popupSetStyleData;
exports.popupSetPopupKey = popupSetPopupKey;
exports.popupSetStyle = popupSetStyle;
exports.popupSetComponentData = popupSetComponentData;
function popupSetGlobalKey(key, value) {
			return {
						type: 'POPUP_SET_GLOBAL_KEY',
						payload: { key: key, value: value }
			};
}

function popupRemoveRule(key) {
			return {
						type: 'POPUP_REMOVE_RULE',
						payload: key
			};
}
function popupSetRule(key, value) {
			return {
						type: 'POPUP_SET_RULE',
						payload: { key: key, value: value }
			};
}

function popupSetSettingData(key, value) {
			return {
						type: 'POPUP_SET_SETTING_DATA',
						payload: { key: key, value: value }
			};
}

function popupSetContentData(key, value) {
			return {
						type: 'POPUP_SET_CONTENT_DATA',
						payload: { key: key, value: value }
			};
}

function popupSetStyleData(selector, key, value) {
			return {
						type: 'POPUP_SET_STYLE_DATA',
						payload: { selector: selector, key: key, value: value }
			};
}

function popupSetPopupKey(key, value) {
			return {
						type: 'POPUP_SET_POPUP_KEY',
						payload: { key: key, value: value }
			};
}

function popupSetStyle(key, value) {
			return {
						type: 'POPUP_SET_STYLE',
						payload: { key: key, value: value }
			};
}

function popupSetComponentData(key, value) {
			return {
						type: 'POPUP_SET_COMPONENT_DATA',
						payload: { key: key, value: value }
			};
}

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelToken = _axios2.default.CancelToken;
var cancel = void 0;

var NewsletterListPicker = function (_React$Component) {
    _inherits(NewsletterListPicker, _React$Component);

    function NewsletterListPicker(props) {
        _classCallCheck(this, NewsletterListPicker);

        var _this = _possibleConstructorReturn(this, (NewsletterListPicker.__proto__ || Object.getPrototypeOf(NewsletterListPicker)).call(this, props));

        _this.state = {
            isWaiting: false,
            isEditing: false,
            app: 0,
            list_id: 0,
            list_fields: [],
            fields: _this.getFields(),
            lists: [],
            hideFields: false,
            canSave: false
        };
        var c = _axios2.default.CancelToken;
        _this.ct = c.source();
        _this.setDefaults();

        _this.onChangeApp = _this.onChangeApp.bind(_this);
        _this.onChangeList = _this.onChangeList.bind(_this);
        _this.renderListSelect = _this.renderListSelect.bind(_this);
        _this.renderFieldSelect = _this.renderFieldSelect.bind(_this);
        _this.discard = _this.discard.bind(_this);
        _this.handleFieldChange = _this.handleFieldChange.bind(_this);
        _this.setField = _this.setField.bind(_this);
        _this.save = _this.save.bind(_this);
        _this.checkIfSaveable = _this.checkIfSaveable.bind(_this);
        return _this;
    }

    _createClass(NewsletterListPicker, [{
        key: 'setDefaults',
        value: function setDefaults() {
            if (this.props.data.app) {
                this.state.app = this.props.data.app;
            }

            if (this.props.data.list_id) {
                this.state.list_id = this.props.data.list_id;
            }

            if (this.props.data.fields) {
                this.state.fields = this.props.data.fields;
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var data = {};
            data.app = this.state.app;
            data.list_id = this.state.list_id;
            data.fields = this.state.fields;

            this.props.handleSave(data);
            this.discard();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.ct.cancel();
        }
    }, {
        key: 'checkIfSaveable',
        value: function checkIfSaveable() {
            var save = true;

            if (this.state.app == false || this.state.app == 0) {
                save = false;
            }

            if (this.state.list_id == false || this.state.list_id == 0) {
                save = false;
            }

            return save;
        }
    }, {
        key: 'getFields',
        value: function getFields() {
            var f = {};

            console.dir(this.props.inputs);
            for (var i in this.props.inputs) {
                if (this.props.inputs[i].styles.placeholder) {
                    f[this.props.inputs[i].id] = false;
                }
            }
            return f;
        }
    }, {
        key: 'fetchLists',
        value: function fetchLists() {
            var _this2 = this;

            this.setState({
                isWaiting: true,
                lists: []
            });

            _axios2.default.get('/apps/' + this.state.app + '/lists', {
                cancelToken: this.ct.token
            }).then(function (res) {
                _this2.setState({ isWaiting: false, lists: res.data });
            }).catch(function (err) {
                if (!_axios2.default.isCancel(err)) {
                    _Notification2.default.error('Error fetching lists. Please try again.');
                    _this2.setState({ isWaiting: false, isEditing: false });
                }
            });
        }
    }, {
        key: 'handleFieldChange',
        value: function handleFieldChange(e) {
            this.setField(e.target.getAttribute('data-key'), e.target.value);
        }
    }, {
        key: 'setField',
        value: function setField(key, value) {
            this.setState(_extends({}, this.state, {
                fields: _extends({}, this.state.fields, _defineProperty({}, key, value))
            }));
        }
    }, {
        key: 'fetchFields',
        value: function fetchFields() {
            var _this3 = this;

            this.setState({
                isWaiting: true,
                list_fields: [],
                field_id: 0,
                hideFields: false
            });
            _axios2.default.get('/apps/' + this.state.app + '/lists/' + this.state.list_id, {
                cancelToken: this.ct.token
            }).then(function (res) {
                var newState = { isWaiting: false, list_fields: res.data };

                if (res.data.length == 0) {
                    newState.hideFields = true;
                } else {
                    for (var i in res.data) {
                        if (res.data[i].isEmail) {
                            if (_this3.state.fields.email == '') {
                                _this3.setField('email', res.data[i].value);
                            }
                        }
                    }
                }

                _this3.setState(newState);
            }).catch(function (err) {
                if (!_axios2.default.isCancel(err)) {
                    _Notification2.default.error('Error fetching fields. Please try again.');
                    _this3.setState({ isWaiting: false, isEditing: false });
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(props, state) {
            if (Object.keys(this.state.fields).length == 0) {
                this.setState({ fields: this.getFields() });
            }

            if (this.state.canSave != this.checkIfSaveable()) {
                this.setState({ canSave: this.checkIfSaveable() });
            }

            if (state.app != this.state.app && this.state.app != 0) {
                this.fetchLists();
            }

            if (state.list_id != this.state.list_id && this.state.list_id != 0) {
                this.fetchFields();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.app != 0) {
                this.fetchLists();
            }

            if (this.state.list_id != 0) {
                this.fetchFields();
            }
        }
    }, {
        key: 'renderFieldSelect',
        value: function renderFieldSelect() {
            var _this4 = this;

            if (this.state.list_id == 0) {
                return null;
            }

            if (this.state.hideFields === true) {
                return null;
            }

            ////// HUSK!!! Push av ordrer, sidevisninger og produkter gjøres direkte mot apiet, ikke over ws
            return _react2.default.createElement(
                'div',
                { className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
                _react2.default.createElement(
                    'table',
                    { style: { width: '100%' } },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                'Popup input'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Newsletter field '
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        Object.keys(this.state.fields).map(function (key, i) {
                            return _react2.default.createElement(
                                'tr',
                                { key: i },
                                _react2.default.createElement(
                                    'td',
                                    { style: { width: '50%' } },
                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', defaultValue: key.charAt(0).toUpperCase() + key.slice(1), disabled: true })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { width: '50%' } },
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control', 'data-key': key, onChange: _this4.handleFieldChange, value: _this4.state.fields[key] },
                                        _react2.default.createElement(
                                            'option',
                                            { value: '0' },
                                            'Select field map'
                                        ),
                                        _this4.state.list_fields.map(function (f) {
                                            return _react2.default.createElement(
                                                'option',
                                                { key: f.key, value: f.key },
                                                f.value
                                            );
                                        })
                                    )
                                )
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: 'renderListSelect',
        value: function renderListSelect() {
            if (this.state.app == 0) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
                _react2.default.createElement(
                    'select',
                    { className: 'form-control', value: this.state.list_id, onChange: this.onChangeList },
                    _react2.default.createElement(
                        'option',
                        { value: '0' },
                        'None'
                    ),
                    this.state.lists.map(function (item, i) {
                        return _react2.default.createElement(
                            'option',
                            { key: i, value: item.id },
                            item.name
                        );
                    })
                ),
                _react2.default.createElement(
                    'label',
                    { className: 'floating-label' },
                    'List'
                )
            );
        }
    }, {
        key: 'discard',
        value: function discard() {
            this.setState({
                isWaiting: false,
                isEditing: false
            });
        }
    }, {
        key: 'onChangeApp',
        value: function onChangeApp(e) {
            this.setState({ app: e.target.value });
        }
    }, {
        key: 'onChangeList',
        value: function onChangeList(e) {
            this.setState({ list_id: e.target.value });
        }
    }, {
        key: 'edit',
        value: function edit() {
            this.setState({ isEditing: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12' },
                this.state.isWaiting ? _react2.default.createElement(
                    'div',
                    { className: 'locked-overlay' },
                    _react2.default.createElement(_LoadingSmall2.default, null)
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        !this.state.isEditing ? _react2.default.createElement(
                            'button',
                            { type: 'button', onClick: function onClick(e) {
                                    e.stopPropagation();_this5.edit();
                                }, className: 'btn btn-dark btn-block' },
                            'Configure'
                        ) : null,
                        this.state.isEditing ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group form-material floating', 'data-plugin': 'formMaterial' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', value: this.state.app, onChange: this.onChangeApp },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '0' },
                                        'None'
                                    ),
                                    this.props.apps.map(function (item, i) {
                                        return _react2.default.createElement(
                                            'option',
                                            { key: i, value: item.key },
                                            item.key
                                        );
                                    })
                                ),
                                _react2.default.createElement(
                                    'label',
                                    { className: 'floating-label' },
                                    'App'
                                )
                            ),
                            this.renderListSelect(),
                            this.renderFieldSelect(),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6 p-l-0' },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-danger btn-block', onClick: this.discard },
                                    'Discard'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6 p-r-0' },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-dark btn-block', disabled: !this.state.canSave, onClick: this.save },
                                    'Save'
                                )
                            )
                        ) : null
                    )
                )
            );
        }
    }]);

    return NewsletterListPicker;
}(_react2.default.Component);

exports.default = NewsletterListPicker;

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickerWidget = function PickerWidget(_ref) {
    var heading = _ref.heading,
        description = _ref.description,
        image = _ref.image,
        onSelect = _ref.onSelect,
        item = _ref.item;
    return _react2.default.createElement(
        "li",
        { className: "list-group-item" },
        _react2.default.createElement(
            "div",
            { className: "media" },
            _react2.default.createElement(
                "div",
                { className: "media-left", style: { verticalAlign: 'middle' } },
                _react2.default.createElement(
                    "a",
                    { className: "avatar", style: { width: '40px' }, href: "javascript:void(0)" },
                    _react2.default.createElement("img", { className: "img-fluid", style: { borderRadius: 0 }, src: "/images/svg/select.svg", alt: "..." })
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "media-body" },
                _react2.default.createElement(
                    "h4",
                    { className: "media-heading" },
                    heading
                ),
                _react2.default.createElement(
                    "small",
                    null,
                    description
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "media-right" },
                _react2.default.createElement(
                    "button",
                    { onClick: function onClick(e) {
                            e.stopPropagation();onSelect(item);
                        }, className: "btn btn-dark btn-block" },
                    "Select"
                )
            )
        )
    );
};

exports.default = PickerWidget;

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _UpgradeRequired = __webpack_require__(177);

var _UpgradeRequired2 = _interopRequireDefault(_UpgradeRequired);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _rcSwitch = __webpack_require__(77);

var _rcSwitch2 = _interopRequireDefault(_rcSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Abtest = function (_React$Component) {
    _inherits(Abtest, _React$Component);

    function Abtest(props) {
        _classCallCheck(this, Abtest);

        var _this = _possibleConstructorReturn(this, (Abtest.__proto__ || Object.getPrototypeOf(Abtest)).call(this, props));

        _this.state = {
            isLoading: true,
            isError: false,
            test: {
                'id': 0,
                'description': '',
                'email_id_a': 0,
                'email_id_b': 0,
                'status': false
            },
            emails: [],
            isLoadingA: true,
            isLoadingB: false
        };
        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.buildA = _this.buildA.bind(_this);
        _this.onChangeA = _this.onChangeA.bind(_this);
        _this.onChangeB = _this.onChangeB.bind(_this);
        _this.renderSelectB = _this.renderSelectB.bind(_this);
        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
        _this.save = _this.save.bind(_this);

        return _this;
    }

    _createClass(Abtest, [{
        key: 'save',
        value: function save() {
            var _this2 = this;

            if (this.state.test.description == '') {
                _Notification2.default.error('You need to give this test a name.');
                return false;
            }

            this.setState({
                isLoading: true
            });

            var method = 'post';
            var url = '/emails/abtests';

            if (this.props.testId) {
                method = 'put';
                url += '/' + this.props.testId;
            }

            _axios2.default[method](url, this.state.test).then(function (res) {
                _Notification2.default.success('Test saved');
                _this2.setState({
                    isLoading: false
                });

                _this2.props.handleSave(res.data);
                _this2.props.onClose();
            });
        }
    }, {
        key: 'handleStatusChange',
        value: function handleStatusChange(value) {
            var val = value == true ? 1 : 0;

            if (val == 1 && (this.state.test.email_id_a == 0 || this.state.test.email_id_b == 0)) {
                _Notification2.default.error('You must select A and B e-mail before you can activate the test');
                return;
            }

            this.setState(_extends({}, this.state, {
                test: _extends({}, this.state.test, {
                    status: val
                })
            }));
        }
    }, {
        key: 'renderSelectB',
        value: function renderSelectB() {
            var _this3 = this;

            var type = '';

            for (var i in this.state.emails) {
                if (this.state.emails[i].id == this.state.test.email_id_a) {
                    type = this.state.emails[i].type;
                }
            }

            return _react2.default.createElement(
                'select',
                { className: 'form-control', onChange: this.onChangeB, value: this.state.test.email_id_b, disabled: this.state.test.email_id_a == 0 ? true : false },
                _react2.default.createElement(
                    'option',
                    { value: 0 },
                    'Select an e-mail to test'
                ),
                this.state.emails.map(function (item) {
                    return !_this3.props.testId && item.isAbtesting || _this3.props.testId && item.isAbtesting && item.id !== _this3.state.test.email_id_b || item.type != type || item.id == _this3.state.test.email_id_a ? null : _react2.default.createElement(
                        'option',
                        { key: item.id, value: item.id },
                        '#',
                        item.id,
                        ' - ',
                        item.subject
                    );
                })
            );
        }
    }, {
        key: 'handleNameChange',
        value: function handleNameChange(e) {
            this.setState(_extends({}, this.state, {
                test: _extends({}, this.state.test, {
                    description: e.target.value
                })
            }));
        }
    }, {
        key: 'onChangeB',
        value: function onChangeB(e) {
            this.setState(_extends({}, this.state, {
                test: _extends({}, this.state.test, {
                    email_id_b: parseInt(e.target.value)
                })
            }));
        }
    }, {
        key: 'onChangeA',
        value: function onChangeA(e) {
            this.setState(_extends({}, this.state, {
                test: _extends({}, this.state.test, {
                    email_id_a: parseInt(e.target.value),
                    email_id_b: 0,
                    status: 0
                })
            }));
        }
    }, {
        key: 'buildA',
        value: function buildA() {
            return [];
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this4 = this;

            _axios2.default.get('/emails').then(function (res) {
                var emails = res.data;

                if (_this4.props.testId) {
                    _axios2.default.get('/emails/abtests/' + _this4.props.testId).then(function (res) {
                        _this4.setState({
                            'isLoading': false,
                            emails: emails,
                            test: res.data
                        });
                    }).catch(function (res) {
                        _this4.setState({ 'isError': 'Segment not found' });
                    });
                } else {
                    _this4.setState({
                        emails: res.data,
                        isLoading: false
                    });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }
            {
                console.dir(this.state);
            }
            return _react2.default.createElement(
                'div',
                { className: 'overview m-t-30 col-sm-8 offset-sm-2 text-center' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'A/B test'
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    'This will create a A/B split test to see which of your e-mails perform the best.',
                    _react2.default.createElement('br', null),
                    'A/B split test allows you to send two different versions of the same e-mail.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Description'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12 p-0 offset-sm-0' },
                        _react2.default.createElement('input', { type: 'text', onChange: this.handleNameChange, className: 'form-control form-control-lg', value: this.state.test.description, placeholder: 'Give this test a description.' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-6' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'E-mail A'
                        )
                    ),
                    _react2.default.createElement(
                        'select',
                        { className: 'form-control', onChange: this.onChangeA, value: parseInt(this.state.test.email_id_a) },
                        _react2.default.createElement(
                            'option',
                            { value: 0 },
                            'Select an e-mail to test'
                        ),
                        this.state.emails.map(function (item) {
                            return !_this5.props.testId && item.isAbtesting || _this5.props.testId && item.isAbtesting && item.id !== _this5.state.test.email_id_a || item.type == 'TEMPLATE' ? null : _react2.default.createElement(
                                'option',
                                { key: item.id, value: parseInt(item.id) },
                                '#',
                                item.id,
                                ' - ',
                                item.subject
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-6' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'E-mail B'
                        )
                    ),
                    this.renderSelectB()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-40 col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'm-b-20 strike' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Test status'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-10 offset-sm-1' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4 text-right' },
                                'Activate test'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6 text-right' },
                                _react2.default.createElement(_rcSwitch2.default, { onChange: this.handleStatusChange,
                                    checked: this.state.test.status == 1 ? true : false,
                                    checkedChildren: _react2.default.createElement('i', { className: 'icon fa-check' }),
                                    unCheckedChildren: _react2.default.createElement('i', { className: 'icon fa-close' })
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 m-t-40 m-b-40 offset-sm-0' },
                    this.props.enabled == '0' ? _react2.default.createElement(_UpgradeRequired2.default, { message: 'If you want to use A/B tests, you need to upgrade your account to a larger package' }) : _react2.default.createElement(
                        'button',
                        { type: 'button', onClick: this.save, className: 'btn btn-dark btn-block' },
                        'Save'
                    )
                )
            );
        }
    }]);

    return Abtest;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth,
        general: state.general
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Abtest = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Abtest);
exports.default = Abtest;

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(6);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoResult = __webpack_require__(21);

var _NoResult2 = _interopRequireDefault(_NoResult);

var _reactHelmet = __webpack_require__(16);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _rcTooltip = __webpack_require__(51);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Confirm = __webpack_require__(54);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _v = __webpack_require__(86);

var _v2 = _interopRequireDefault(_v);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _ChatTemplate = __webpack_require__(681);

var _ChatTemplate2 = _interopRequireDefault(_ChatTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Template = function (_React$Component) {
    _inherits(Template, _React$Component);

    function Template(props) {
        _classCallCheck(this, Template);

        var _this = _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).call(this, props));

        _this.state = {
            name: '',
            message: '',
            isError: false,
            isLoading: true
        };

        _this.handleTemplateSubmit = _this.handleTemplateSubmit.bind(_this);

        return _this;
    }

    _createClass(Template, [{
        key: 'handleTemplateSubmit',
        value: function handleTemplateSubmit(values) {
            var _this2 = this;

            this.setState({
                isLoading: true
            });

            var method = 'post';
            var url = '/chat/templates';

            if (this.props.templateId) {
                method = 'put';
                url += '/' + this.props.templateId;
            }

            _axios2.default[method](url, values).then(function (res) {
                _Notification2.default.success('Template saved');
                _this2.setState({
                    isLoading: false
                });

                _this2.props.handleSave(res.data);
                _this2.props.onClose();
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            if (!this.props.templateId) {
                this.setState({ 'isLoading': false });
                return true;
            }
            _axios2.default.get('/chat/templates/' + this.props.templateId).then(function (res) {
                _this3.setState({
                    'isLoading': false,
                    name: res.data.name,
                    message: res.data.message
                });
            }).catch(function (res) {
                console.dir(res);
                _this3.setState({ 'isError': 'Template not found' });
            });
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.isLoading) {
                return _react2.default.createElement(_Loading2.default, { error: this.state.isError });
            }

            return _react2.default.createElement(
                'div',
                { className: 'overview m-t-30 col-sm-6 offset-sm-3 text-center' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'Message template'
                ),
                _react2.default.createElement(_ChatTemplate2.default, { initialValues: { name: this.state.name, message: this.state.message }, onSubmit: this.handleTemplateSubmit })
            );
        }
    }]);

    return Template;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: state.auth
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

Template = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Template);
exports.default = Template;

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};

    if (!values.name) {
        errors.name = 'Required';
    }

    if (!values.message) {
        errors.message = 'Required';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var textarea = function textarea(_ref2) {
    var input = _ref2.input,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('textarea', _extends({}, input, { placeholder: placeholder, name: name, className: className })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var ChatTemplate = function (_React$Component) {
    _inherits(ChatTemplate, _React$Component);

    function ChatTemplate() {
        _classCallCheck(this, ChatTemplate);

        return _possibleConstructorReturn(this, (ChatTemplate.__proto__ || Object.getPrototypeOf(ChatTemplate)).apply(this, arguments));
    }

    _createClass(ChatTemplate, [{
        key: 'render',
        value: function render() {
            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', placeholder: 'Name', name: 'name', className: 'form-control', title: 'Short description' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(_reduxForm.Field, { component: textarea, type: 'text', placeholder: 'Type your message', name: 'message', className: 'form-control', title: 'Message' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row m-t-20' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        this.props.isSavingTemplate ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn btn-dark btn-block' },
                            'Save'
                        )
                    )
                )
            );
        }
    }]);

    return ChatTemplate;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {};
};

// Decorate the form component
ChatTemplate = (0, _reduxForm.reduxForm)({
    form: 'ChatTemplate',
    validate: validate
})(ChatTemplate);

ChatTemplate = (0, _reactRedux.connect)(function (state) {
    return {};
})(ChatTemplate);

exports.default = ChatTemplate;

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxForm = __webpack_require__(41);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(3);

var _LoadingSmall = __webpack_require__(15);

var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(values) {
    var errors = {};
    if (!values.firstname) {
        errors.firstname = 'Required';
    }

    if (!values.lastname) {
        errors.lastname = 'Required';
    }

    if (!values.address) {
        errors.address = 'Required';
    }

    if (!values.invoice_email) {
        errors.invoice_email = 'Required';
    }

    if (!values.city) {
        errors.city = 'Required';
    }

    if (!values.zip) {
        errors.zip = 'Required';
    }

    if (!values.company_name) {
        errors.company_name = 'Required';
    }

    if (!values.year) {
        errors.year = 'Required';
    }

    if (!values.cvc) {
        errors.cvc = 'Required';
    }

    if (!values.month) {
        errors.month = 'Required';
    }

    if (!values.cardnumber) {
        errors.cardnumber = 'Required';
    }

    if (!values.password) {
        errors.password = 'Required';
    } else if (values.password.length < 6) {
        errors.password = 'Password must have minimum 6 characters';
    }

    return errors;
};

var renderField = function renderField(_ref) {
    var input = _ref.input,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement('input', _extends({}, input, { placeholder: placeholder, name: name, className: className, type: type })),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var select = function select(_ref2) {
    var input = _ref2.input,
        options = _ref2.options,
        name = _ref2.name,
        className = _ref2.className,
        placeholder = _ref2.placeholder,
        title = _ref2.title,
        type = _ref2.type,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group form-material floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(
            'select',
            { name: name, className: 'form-control', value: input.value, onChange: input.onChange },
            options.map(function (item, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    item.label
                );
            })
        ),
        _react2.default.createElement(
            'label',
            { className: 'floating-label' },
            title
        ),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

var BillingInformation = function (_React$Component) {
    _inherits(BillingInformation, _React$Component);

    function BillingInformation(props) {
        _classCallCheck(this, BillingInformation);

        var _this = _possibleConstructorReturn(this, (BillingInformation.__proto__ || Object.getPrototypeOf(BillingInformation)).call(this, props));

        _this.calculatePrice = _this.calculatePrice.bind(_this);
        return _this;
    }

    _createClass(BillingInformation, [{
        key: 'years',
        value: function years() {
            var years = [];
            var today = new Date().getFullYear();
            for (var i = today; i <= parseInt(today) + 10; i++) {
                years.push({
                    'value': i,
                    'label': i
                });
            }
            return years;
        }
    }, {
        key: 'calculatePrice',
        value: function calculatePrice(price) {
            if (this.props.promo === false) {
                return price;
            }

            return parseInt(price) - parseInt(this.props.promo);
        }
    }, {
        key: 'month',
        value: function month() {
            var month = [];

            for (var i = 1; i <= 12; i++) {
                month.push({
                    'value': i,
                    'label': i
                });
            }
            return month;
        }
    }, {
        key: 'countries',
        value: function countries() {
            var country_list = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

            var options = [];

            for (var i in country_list) {
                options.push({ 'label': country_list[i], 'value': country_list[i] });
            }

            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var handleSubmit = this.props.handleSubmit;

            return _react2.default.createElement(
                'form',
                { onSubmit: handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-heading' },
                                _react2.default.createElement(
                                    'h3',
                                    { className: 'panel-title' },
                                    'Customer details'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-body' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'invoice_email', placeholder: 'Billing e-mail', title: 'Billing e-mail', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'firstname', placeholder: 'John', title: 'Firstname', className: 'form-control' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'lastname', placeholder: 'Doe', title: 'Lastname', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'company_name', placeholder: 'Acme Inc', title: 'Company name', className: 'form-control' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'vat', placeholder: '133731337', title: this.props.country == 'Norway' ? 'Orgnumber (Norwegian)' : 'VAT number', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'address', placeholder: 'Street address 1', title: 'Address', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'zip', placeholder: '12353', title: 'Zip', className: 'form-control' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-6' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'city', placeholder: 'Oslo', title: 'City', className: 'form-control' })
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-bordered', style: { border: "1px solid #e4eaec" } },
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-heading' },
                                _react2.default.createElement(
                                    'h3',
                                    { className: 'panel-title' },
                                    'Payment'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'panel-actions col-sm-5 p-0' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-group' },
                                        _react2.default.createElement('input', { type: 'text', value: this.props.promo_code, onChange: this.props.handlePromoChange, className: 'form-control', placeholder: 'Promo code' }),
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'input-group-btn' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', onClick: this.props.applyPromo, className: 'btn btn-dark' },
                                                'Apply'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'panel-body' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        this.props.errorMessage !== false ? _react2.default.createElement(
                                            'div',
                                            { className: 'alert dark alert-icon alert-danger alert-dismissible', role: 'alert' },
                                            _react2.default.createElement('i', { className: 'icon wb-close', 'aria-hidden': 'true' }),
                                            this.props.errorMessage
                                        ) : null,
                                        _react2.default.createElement(
                                            'table',
                                            { className: 'table table-bordered' },
                                            _react2.default.createElement(
                                                'thead',
                                                null,
                                                _react2.default.createElement(
                                                    'tr',
                                                    { className: 'table-active' },
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Package'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Description'
                                                    ),
                                                    _react2.default.createElement(
                                                        'th',
                                                        null,
                                                        'Price'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tbody',
                                                null,
                                                Object.keys(this.props.p).map(function (key, i) {
                                                    var p = _this2.props.p[key];
                                                    return _react2.default.createElement(
                                                        'tr',
                                                        { key: i },
                                                        _react2.default.createElement(
                                                            'td',
                                                            null,
                                                            p.name,
                                                            ' - ',
                                                            _react2.default.createElement(
                                                                'a',
                                                                { href: 'javascript:void(0)', onClick: function onClick(e) {
                                                                        e.stopPropagation();_this2.props.changePackage();
                                                                    } },
                                                                '(change)'
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'td',
                                                            null,
                                                            '- Billed each month',
                                                            _this2.props.country == 'Norway' ? _react2.default.createElement(
                                                                'p',
                                                                null,
                                                                '- Priser uten mva'
                                                            ) : ''
                                                        ),
                                                        _react2.default.createElement(
                                                            'td',
                                                            null,
                                                            _react2.default.createElement(
                                                                'strong',
                                                                null,
                                                                _this2.props.country == 'Norway' ? _react2.default.createElement(
                                                                    'p',
                                                                    null,
                                                                    _this2.calculatePrice(p.amount),
                                                                    ',- NOK'
                                                                ) : _react2.default.createElement(
                                                                    'p',
                                                                    null,
                                                                    '$',
                                                                    _this2.calculatePrice(p.amount)
                                                                )
                                                            )
                                                        )
                                                    );
                                                }),
                                                this.props.promo !== false ? _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        'Discount'
                                                    ),
                                                    _react2.default.createElement('td', null),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        this.props.promo
                                                    )
                                                ) : null,
                                                _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        'Total'
                                                    ),
                                                    _react2.default.createElement('td', null),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        this.props.sumToPay()
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'cardnumber', placeholder: '123412341234', title: 'Credit card number', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: select, options: this.month(), name: 'month', title: 'Expiry month' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: select, options: this.years(), name: 'year', title: 'Expiry year' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-4' },
                                        _react2.default.createElement(_reduxForm.Field, { component: renderField, type: 'text', name: 'cvc', placeholder: '123', title: 'CVC', className: 'form-control' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row m-t-20' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-sm-12' },
                                        this.props.isPaying ? _react2.default.createElement(_LoadingSmall2.default, null) : _react2.default.createElement(
                                            'button',
                                            { type: 'submit', className: 'btn btn-dark btn-block' },
                                            'Confirm payment'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return BillingInformation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        initialValues: {}
    };
};
var selector = (0, _reduxForm.formValueSelector)('BillingInformation');

// Decorate the form component
BillingInformation = (0, _reduxForm.reduxForm)({
    form: 'BillingInformation',
    validate: validate
})(BillingInformation);

BillingInformation = (0, _reactRedux.connect)(function (state) {
    return {
        country: selector(state, 'country'),
        initialValues: {
            year: new Date().getFullYear(),
            month: new Date().getMonth(),

            country: 'Norway'
        }
    };
})(BillingInformation);

exports.default = BillingInformation;

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(14);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = function field(_ref) {
    var input = _ref.input,
        options = _ref.options,
        name = _ref.name,
        className = _ref.className,
        placeholder = _ref.placeholder,
        title = _ref.title,
        type = _ref.type,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error;
    return _react2.default.createElement(
        'div',
        { className: 'form-group floating ' + (touched && error ? 'has-danger' : ''), 'data-plugin': 'formMaterial' },
        _react2.default.createElement(_reactSelect2.default, {
            value: input.value,
            onChange: input.onChange,
            onBlur: function onBlur() {
                return input.onBlur(input.value);
            },
            options: options,
            placeholder: placeholder,
            simpleValue: true
        }),
        _react2.default.createElement(
            'small',
            { className: 'text-help' },
            touched && error && _react2.default.createElement(
                'span',
                null,
                error
            )
        )
    );
};

exports.default = field;

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _routes = __webpack_require__(821);

var _routes2 = _interopRequireDefault(_routes);

var _reactRouter = __webpack_require__(6);

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(1742);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (true) {
    _ravenJs2.default.config('https://8a255dd068a144bdb7552748e724a0c3@sentry.io/150538', {
        release: current_version,
        dataCallback: function dataCallback(data) {
            var state = _store2.default.getState();

            data.extra.user = state.auth.user;
            data.extra.auth = state.auth.auth;
            data.extra.platform = state.general.platform;
            return data;
        }
    }).install();
}

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: _store2.default },
    _react2.default.createElement(_reactRouter.Router, { history: _store.history, routes: _routes2.default })
), window.document.getElementById("app"));

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlignPicker = function (_React$Component) {
    _inherits(AlignPicker, _React$Component);

    function AlignPicker(props) {
        _classCallCheck(this, AlignPicker);

        var _this = _possibleConstructorReturn(this, (AlignPicker.__proto__ || Object.getPrototypeOf(AlignPicker)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.onChange = _this.onChange.bind(_this);

        _this.defaultState(props);

        return _this;
    }

    _createClass(AlignPicker, [{
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                'align': 'center'
            };

            if (props.align) {
                this.state.align = props.align;
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.defaultState(nextProps);
        }
    }, {
        key: 'onChange',
        value: function onChange(e, align) {
            this.setState({ align: align });
            this.props.handleChange(this.props.id, align);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'btn-group col-sm-12 p-0', 'aria-label': 'Default button group', role: 'group' },
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                return _this2.onChange(e, 'left');
                            }, className: 'col-sm-4 ' + (this.state.align == 'left' ? 'current' : '') + ' btn btn-outline btn-default' },
                        'Left'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                return _this2.onChange(e, 'center');
                            }, className: 'col-sm-4 ' + (this.state.align == 'center' ? 'current' : '') + ' btn btn-outline btn-default' },
                        'Center'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:void(0)', onClick: function onClick(e) {
                                return _this2.onChange(e, 'right');
                            }, className: 'col-sm-4 ' + (this.state.align == 'right' ? 'current' : '') + ' btn btn-outline btn-default' },
                        'Right'
                    )
                )
            );
        }
    }]);

    return AlignPicker;
}(_react2.default.Component);

exports.default = AlignPicker;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setCurrentUser = setCurrentUser;
exports.setGlobalKey = setGlobalKey;
exports.setCurrentAccount = setCurrentAccount;
exports.setConnectionStatus = setConnectionStatus;
exports.setUserSetting = setUserSetting;
exports.setLoadedVisitors = setLoadedVisitors;
exports.setUserKey = setUserKey;
function setCurrentUser(token, user) {
	return {
		type: 'AUTH_SET_CURRENT_USER',
		payload: { token: token, user: user }
	};
}

function setGlobalKey(key, value) {
	return {
		type: 'AUTH_SET_GLOBAL_KEY',
		payload: { key: key, value: value }
	};
}

function setCurrentAccount(account_id) {
	return {
		type: 'AUTH_SET_CURRENT_ACCOUNT',
		payload: account_id
	};
}

function setConnectionStatus(status) {
	return {
		type: 'AUTH_SET_CONNECTION_STATUS',
		payload: status
	};
}
function setUserSetting(key, value) {
	return {
		type: 'UPDATE_SETTING_KEY',
		payload: {
			key: key, value: value
		}
	};
}

function setLoadedVisitors(status) {
	return {
		type: 'AUTH_SET_LOADED_VISITORS',
		payload: status
	};
}

function setUserKey(key, value) {
	return {
		type: 'AUTH_SET_USER_KEY',
		payload: { key: key, value: value }
	};
}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(160);

var _store2 = _interopRequireDefault(_store);

var _General = __webpack_require__(53);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _Login = __webpack_require__(75);

var _Notification = __webpack_require__(12);

var _Notification2 = _interopRequireDefault(_Notification);

var _helpers = __webpack_require__(128);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var General = function () {
	function General() {
		_classCallCheck(this, General);
	}

	_createClass(General, [{
		key: 'Link2',
		value: function Link2(path) {
			var state = _store2.default.getState();
			var url = '';

			if (state.auth.currentAccount == false) {
				path = '/login';
			}

			if (_helpers2.default.isProduction()) {
				url = "https://app.crall.io/v2/#/" + state.auth.currentAccount + path;
			} else {
				url = "https://app.crall.dev:3000/#/" + state.auth.currentAccount + path;
			}

			return url;
		}
	}, {
		key: 'Link',
		value: function Link(path) {
			var state = _store2.default.getState();
			if (state.auth.currentAccount == false) {
				return '/login';
			} else {
				return '/' + state.auth.currentAccount + path;
			}
		}
	}, {
		key: 'requestAccessToken',
		value: function requestAccessToken(path) {
			_axios2.default.get('/me/token').then(function (res) {
				window.location.href = path + '?token=' + res.data;
			});
		}
	}, {
		key: 'LinkIsActive',
		value: function LinkIsActive(path) {
			var state = _store2.default.getState();
			if (state.auth.currentAccount == false) {
				return '/login';
			} else {
				return '/' + state.auth.currentAccount + path;
			}
		}
	}, {
		key: 'appHasType',
		value: function appHasType(type) {
			for (var i in _store2.default.getState().general.apps) {
				if (_store2.default.getState().general.apps[i].type == type) {
					return _store2.default.getState().general.apps[i];
				}
			}

			return false;
		}
	}, {
		key: 'appGetType',
		value: function appGetType(type) {
			var apps = [];

			for (var i in _store2.default.getState().general.apps) {
				if (_store2.default.getState().general.apps[i].type == type) {
					apps.push(_store2.default.getState().general.apps[i]);
				}
			}

			return apps;
		}
	}, {
		key: 'loadScript',
		value: function loadScript(src) {
			var state = _store2.default.getState();
			return new Promise(function (resolve, reject) {

				if (state.general.scripts.includes(src)) {
					resolve();
					return;
				}

				_store2.default.dispatch((0, _General.addScript)(src));

				var scr = document.createElement('script');
				scr.type = 'text/javascript';

				if (scr.readyState) {
					// IE
					scr.onreadystatechange = function () {
						if (scr.readyState == 4 || scr.readyState === 'complete') {
							scr.onreadystatechange = null;
							resolve();
						}
					};
				} else {
					// Others
					scr.onload = function () {
						return resolve();
					};
				}

				scr.src = src;
				document.getElementsByTagName('head')[0].appendChild(scr);
			});
		}
	}, {
		key: 'fetchGeneral',
		value: function fetchGeneral() {
			return _axios2.default.get('/general').then(function (res) {
				if (_store2.default.getState().general.platform.version) {
					if (_store2.default.getState().general.platform.version != res.data.platform.version) {
						_store2.default.dispatch((0, _General.setGlobalKey)('needUpdate', true));
					}
				}
				_store2.default.dispatch((0, _Login.setCurrentUser)(_Auth2.default.getToken(), res.data.me));
				_Auth2.default.authenticate(_Auth2.default.getToken());

				var shownMessages = _store2.default.getState().general.shownMessages;

				if (res.data.notifications.length > 0) {
					for (var i in res.data.notifications) {
						if (!shownMessages.includes(res.data.notifications[i].id)) {
							_store2.default.dispatch((0, _General.addNotificationMessage)(res.data.notifications[i].id));
							_Notification2.default[res.data.notifications[i].type](res.data.notifications[i].message);
						}
					}
				}

				_store2.default.dispatch((0, _General.addUsers)(res.data.users));
				_store2.default.dispatch((0, _General.setGlobalKey)('settings', res.data.settings));
				_store2.default.dispatch((0, _General.setGlobalKey)('apps', res.data.apps));
				_store2.default.dispatch((0, _General.setGlobalKey)('plans', res.data.plans));
				_store2.default.dispatch((0, _General.setGlobalKey)('app', res.data.settings));
				_store2.default.dispatch((0, _General.setGlobalKey)('platform', res.data.platform));
				_store2.default.dispatch((0, _General.setGlobalKey)('account', res.data.account));
			});
		}
	}]);

	return General;
}();

//store.dispatch(addVisitors('test'));

exports.default = new General();

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(6);

var _requireAuthentication = __webpack_require__(845);

var _App = __webpack_require__(1050);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(1104);

var _index2 = _interopRequireDefault(_index);

var _email = __webpack_require__(1105);

var _email2 = _interopRequireDefault(_email);

var _Picker = __webpack_require__(1550);

var _Picker2 = _interopRequireDefault(_Picker);

var _Popup = __webpack_require__(1551);

var _Popup2 = _interopRequireDefault(_Popup);

var _step = __webpack_require__(1576);

var _step2 = _interopRequireDefault(_step);

var _step3 = __webpack_require__(1577);

var _step4 = _interopRequireDefault(_step3);

var _step5 = __webpack_require__(1578);

var _step6 = _interopRequireDefault(_step5);

var _dashboard = __webpack_require__(1580);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _Protected = __webpack_require__(1633);

var _Protected2 = _interopRequireDefault(_Protected);

var _FullPage = __webpack_require__(1634);

var _FullPage2 = _interopRequireDefault(_FullPage);

var _index3 = __webpack_require__(1646);

var _index4 = _interopRequireDefault(_index3);

var _forgot = __webpack_require__(1647);

var _forgot2 = _interopRequireDefault(_forgot);

var _reset = __webpack_require__(1648);

var _reset2 = _interopRequireDefault(_reset);

var _Logout = __webpack_require__(1649);

var _Logout2 = _interopRequireDefault(_Logout);

var _NotFound = __webpack_require__(1650);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Invitation = __webpack_require__(1651);

var _Invitation2 = _interopRequireDefault(_Invitation);

var _signup = __webpack_require__(1653);

var _signup2 = _interopRequireDefault(_signup);

var _emails = __webpack_require__(1655);

var _emails2 = _interopRequireDefault(_emails);

var _abtests = __webpack_require__(1656);

var _abtests2 = _interopRequireDefault(_abtests);

var _templates = __webpack_require__(1657);

var _templates2 = _interopRequireDefault(_templates);

var _popups = __webpack_require__(1658);

var _popups2 = _interopRequireDefault(_popups);

var _discounts = __webpack_require__(1659);

var _discounts2 = _interopRequireDefault(_discounts);

var _DiscountNew = __webpack_require__(1660);

var _DiscountNew2 = _interopRequireDefault(_DiscountNew);

var _Chat = __webpack_require__(1661);

var _Chat2 = _interopRequireDefault(_Chat);

var _ChatOverview = __webpack_require__(1663);

var _ChatOverview2 = _interopRequireDefault(_ChatOverview);

var _ChatConversation = __webpack_require__(1670);

var _ChatConversation2 = _interopRequireDefault(_ChatConversation);

var _Settings = __webpack_require__(1680);

var _Settings2 = _interopRequireDefault(_Settings);

var _SettingsProfile = __webpack_require__(1681);

var _SettingsProfile2 = _interopRequireDefault(_SettingsProfile);

var _SettingsUsers = __webpack_require__(1684);

var _SettingsUsers2 = _interopRequireDefault(_SettingsUsers);

var _SettingsEmails = __webpack_require__(1685);

var _SettingsEmails2 = _interopRequireDefault(_SettingsEmails);

var _SettingsChat = __webpack_require__(1687);

var _SettingsChat2 = _interopRequireDefault(_SettingsChat);

var _SettingsPush = __webpack_require__(1689);

var _SettingsPush2 = _interopRequireDefault(_SettingsPush);

var _SettingsCompany = __webpack_require__(1691);

var _SettingsCompany2 = _interopRequireDefault(_SettingsCompany);

var _Billing = __webpack_require__(1692);

var _Billing2 = _interopRequireDefault(_Billing);

var _BillingOverview = __webpack_require__(1693);

var _BillingOverview2 = _interopRequireDefault(_BillingOverview);

var _BillingInvoices = __webpack_require__(1694);

var _BillingInvoices2 = _interopRequireDefault(_BillingInvoices);

var _BillingSubscribe = __webpack_require__(1695);

var _BillingSubscribe2 = _interopRequireDefault(_BillingSubscribe);

var _BillingPlan = __webpack_require__(1697);

var _BillingPlan2 = _interopRequireDefault(_BillingPlan);

var _BillingCard = __webpack_require__(1698);

var _BillingCard2 = _interopRequireDefault(_BillingCard);

var _BillingCancel = __webpack_require__(1699);

var _BillingCancel2 = _interopRequireDefault(_BillingCancel);

var _BillingDealer = __webpack_require__(1700);

var _BillingDealer2 = _interopRequireDefault(_BillingDealer);

var _Apps = __webpack_require__(1701);

var _Apps2 = _interopRequireDefault(_Apps);

var _AppBrowse = __webpack_require__(1702);

var _AppBrowse2 = _interopRequireDefault(_AppBrowse);

var _AppIndex = __webpack_require__(1704);

var _AppIndex2 = _interopRequireDefault(_AppIndex);

var _analytics = __webpack_require__(1710);

var _analytics2 = _interopRequireDefault(_analytics);

var _setup = __webpack_require__(1711);

var _setup2 = _interopRequireDefault(_setup);

var _segments = __webpack_require__(1716);

var _segments2 = _interopRequireDefault(_segments);

var _events = __webpack_require__(1717);

var _events2 = _interopRequireDefault(_events);

var _orders = __webpack_require__(1718);

var _orders2 = _interopRequireDefault(_orders);

var _startup = __webpack_require__(1719);

var _startup2 = _interopRequireDefault(_startup);

var _Push = __webpack_require__(1720);

var _Push2 = _interopRequireDefault(_Push);

var _PushNew = __webpack_require__(1721);

var _PushNew2 = _interopRequireDefault(_PushNew);

var _SettingsDiscount = __webpack_require__(1723);

var _SettingsDiscount2 = _interopRequireDefault(_SettingsDiscount);

var _SettingsSync = __webpack_require__(1724);

var _SettingsSync2 = _interopRequireDefault(_SettingsSync);

var _recommendations = __webpack_require__(1725);

var _recommendations2 = _interopRequireDefault(_recommendations);

var _templates3 = __webpack_require__(1732);

var _templates4 = _interopRequireDefault(_templates3);

var _new = __webpack_require__(1733);

var _new2 = _interopRequireDefault(_new);

var _stats = __webpack_require__(1740);

var _stats2 = _interopRequireDefault(_stats);

var _index5 = __webpack_require__(1741);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
    _reactRouter.Route,
    { path: "/", component: _App2.default },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: "login" }),
    _react2.default.createElement(
        _reactRouter.Route,
        {
            path: ":account_id/builder",
            component: (0, _requireAuthentication.requireAuthentication)(_index2.default)
        },
        _react2.default.createElement(
            _reactRouter.Route,
            { path: ":type/picker", component: _Picker2.default },
            _react2.default.createElement(_reactRouter.IndexRedirect, { to: "1" }),
            _react2.default.createElement(_reactRouter.Route, { path: "1", component: _step2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "2", component: _step4.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "3", component: _step6.default })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: "email/:email_id/:type", component: _email2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "email/:email_id", component: _email2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "popup/:popup_id", component: _Popup2.default })
    ),
    _react2.default.createElement(_reactRouter.Route, {
        path: ":account_id/setup",
        component: (0, _requireAuthentication.requireAuthentication)(_setup2.default)
    }),
    _react2.default.createElement(
        _reactRouter.Route,
        { path: ":account_id/", component: (0, _requireAuthentication.requireAuthentication)(_FullPage2.default) },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: "dashboard" }),
        _react2.default.createElement(_reactRouter.Route, { path: "dashboard", component: _dashboard2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "emails", component: _emails2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "emails/tests", component: _abtests2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "emails/templates", component: _templates2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "recommendations", component: _recommendations2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "recommendations/new", component: _new2.default }),
        _react2.default.createElement(_reactRouter.Route, {
            path: "recommendations/templates",
            component: _templates4.default
        }),
        _react2.default.createElement(_reactRouter.Route, {
            path: "recommendations/:recommendation_id",
            component: _new2.default
        }),
        _react2.default.createElement(_reactRouter.Route, { path: "newsletters", component: _index6.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "popups", component: _popups2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "discounts", component: _discounts2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "discounts/new", component: _DiscountNew2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "discounts/:discount_id", component: _DiscountNew2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "push", component: _Push2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "push/new", component: _PushNew2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "push/:discount_id", component: _PushNew2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "stats/:type/:id", component: _stats2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "segments", component: _segments2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "segments/:id", component: _segments2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "events", component: _events2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "orders", component: _orders2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: "welcome", component: _startup2.default }),
        _react2.default.createElement(
            _reactRouter.Route,
            { path: "chat", component: _Chat2.default },
            _react2.default.createElement(_reactRouter.IndexRedirect, { to: "overview" }),
            _react2.default.createElement(_reactRouter.Route, { path: "overview", component: _ChatOverview2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: ":user_id", component: _ChatConversation2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: ":user_id/:uid", component: _ChatConversation2.default })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: "insights", component: _analytics2.default }),
        _react2.default.createElement(
            _reactRouter.Route,
            { path: "settings", component: _Settings2.default },
            _react2.default.createElement(_reactRouter.IndexRedirect, { to: "me" }),
            _react2.default.createElement(_reactRouter.Route, { path: "me", component: _SettingsProfile2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "users", component: _SettingsUsers2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "emails", component: _SettingsEmails2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "chat", component: _SettingsChat2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "push", component: _SettingsPush2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "company", component: _SettingsCompany2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "discount", component: _SettingsDiscount2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: "sync", component: _SettingsSync2.default }),
            _react2.default.createElement(
                _reactRouter.Route,
                { path: "billing", component: _Billing2.default },
                _react2.default.createElement(_reactRouter.IndexRedirect, { to: "overview" }),
                _react2.default.createElement(_reactRouter.Route, { path: "overview", component: _BillingOverview2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "subscribe", component: _BillingSubscribe2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "invoices", component: _BillingInvoices2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "plan", component: _BillingPlan2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "card", component: _BillingCard2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "cancel", component: _BillingCancel2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: "dealer", component: _BillingDealer2.default })
            )
        ),
        _react2.default.createElement(
            _reactRouter.Route,
            { path: "apps", component: _Apps2.default },
            _react2.default.createElement(_reactRouter.IndexRedirect, { to: "browse" }),
            _react2.default.createElement(_reactRouter.Route, { path: "browse", component: _AppBrowse2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: ":app", component: _AppIndex2.default })
        )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: ":account_id/invitation", component: _Invitation2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "signup", component: _signup2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "forgot", component: _forgot2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "reset/:token", component: _reset2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "login", component: (0, _requireAuthentication.requireAuthentication)(_index4.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: "*", component: _NotFound2.default })
);

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.requireAuthentication = requireAuthentication;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouter = __webpack_require__(6);

var _Auth = __webpack_require__(102);

var _Auth2 = _interopRequireDefault(_Auth);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _redux = __webpack_require__(4);

var _Login = __webpack_require__(75);

var _Loading = __webpack_require__(10);

var _Loading2 = _interopRequireDefault(_Loading);

var _General = __webpack_require__(8);

var _General2 = _interopRequireDefault(_General);

var _reactIntercom = __webpack_require__(1042);

var _reactIntercom2 = _interopRequireDefault(_reactIntercom);

var _ravenJs = __webpack_require__(129);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _index = __webpack_require__(128);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function requireAuthentication(Component) {
    var AuthenticatedComponent = function (_React$Component) {
        _inherits(AuthenticatedComponent, _React$Component);

        function AuthenticatedComponent(props) {
            _classCallCheck(this, AuthenticatedComponent);

            var _this = _possibleConstructorReturn(this, (AuthenticatedComponent.__proto__ || Object.getPrototypeOf(AuthenticatedComponent)).call(this, props));

            _this.shouldRender = function () {

                if (_this.props.location.pathname === '/login') {
                    _this.forceLogin();
                    return;
                }

                if (_this.props.auth.isAuthenticated === true) {

                    if (_this.state.didIdentify === false) {
                        if (typeof zE === 'function') {
                            zE(function () {
                                zE.identify({ name: _this.props.auth.user.firstname + ' ' + _this.props.auth.user.lastname, email: _this.props.auth.user.email });
                            });

                            _this.setState({
                                didIdentify: true
                            });
                        }
                    }

                    if (_this.props.router.isActive('/login')) {
                        return _react2.default.createElement(Component, _this.props);
                    } else {
                        if (_this.state.isLoading) {
                            return _react2.default.createElement(_Loading2.default, { withLogo: true, error: false });
                        } else {
                            return _react2.default.createElement(Component, _this.props);
                        }
                    }
                } else {
                    if (_this.props.router.isActive('/login')) {
                        return _react2.default.createElement(Component, _this.props);
                    } else {
                        return _react2.default.createElement(_Loading2.default, { withLogo: true, error: false });
                    }
                }
            };

            _this.state = {
                isLoading: true,
                didIdentify: false
            };

            _this.shouldRender = _this.shouldRender.bind(_this);
            return _this;
        }

        _createClass(AuthenticatedComponent, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (!this.props.location.query.next) {
                    this.getAuthentication(this.props);
                }
            }
        }, {
            key: 'getAuthentication',
            value: function getAuthentication(props) {
                var _this2 = this;

                if (props.auth.isAuthenticated) {
                    this.setState({ isLoading: false });
                    return true;
                }

                var auth = _Auth2.default.authenticate(_Auth2.default.getToken(), this.props.router.params.account_id);

                if (auth.action == 'redirect') {
                    this.props.router.push(_General2.default.Link(auth.url));
                    return;
                }

                _General2.default.fetchGeneral().then(function (res) {
                    if (_this2.props.auth.user.is_staff && !_Auth2.default.isStaff()) {
                        localStorage.setItem('is_staff', true);
                    }
                    _this2.setState({ isLoading: false });
                }).catch(function (res) {

                    if (!_this2.props.router.isActive('/login') && res.response) {
                        _this2.forceLogin();
                    } else {
                        console.dir(res);
                        _ravenJs2.default.captureException(res);
                    }
                });
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                return;
                if (this.props.route.path != nextProps.route.path) {
                    return true;
                }

                this.getAuthentication(nextProps);
            }
        }, {
            key: 'forceLogin',
            value: function forceLogin() {

                _index2.default.redirectToNewAdmin();

                return;
                _Auth2.default.authenticate(false);
                this.props.setCurrentUser(false);
                var redirectAfterLogin = this.props.location.pathname;
                this.props.router.push('/login?next=' + redirectAfterLogin);
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    { className: 'full-height' },
                    this.shouldRender()
                );
            }
        }]);

        return AuthenticatedComponent;
    }(_react2.default.Component);

    var mapStateToProps = function mapStateToProps(state) {
        return {
            auth: state.auth,
            general: state.general
        };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return (0, _redux.bindActionCreators)({ setCurrentUser: _Login.setCurrentUser }, dispatch);
    };

    AuthenticatedComponent = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);
    return AuthenticatedComponent;
}

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(4);

var _reactRouterRedux = __webpack_require__(487);

var _reduxForm = __webpack_require__(41);

var _builderReducer = __webpack_require__(1029);

var _builderReducer2 = _interopRequireDefault(_builderReducer);

var _authReducer = __webpack_require__(1033);

var _authReducer2 = _interopRequireDefault(_authReducer);

var _chatReducer = __webpack_require__(1034);

var _chatReducer2 = _interopRequireDefault(_chatReducer);

var _generalReducer = __webpack_require__(1035);

var _generalReducer2 = _interopRequireDefault(_generalReducer);

var _appReducer = __webpack_require__(1036);

var _appReducer2 = _interopRequireDefault(_appReducer);

var _builderPopupReducer = __webpack_require__(1037);

var _builderPopupReducer2 = _interopRequireDefault(_builderPopupReducer);

var _segmentReducer = __webpack_require__(1038);

var _segmentReducer2 = _interopRequireDefault(_segmentReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
	routing: _reactRouterRedux.routerReducer,
	builder: _builderReducer2.default,
	auth: _authReducer2.default,
	chat: _chatReducer2.default,
	general: _generalReducer2.default,
	form: _reduxForm.reducer,
	app: _appReducer2.default,
	builderPopup: _builderPopupReducer2.default,
	segments: _segmentReducer2.default
});

exports.default = rootReducer;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkPicker = function (_React$Component) {
    _inherits(LinkPicker, _React$Component);

    function LinkPicker(props) {
        _classCallCheck(this, LinkPicker);

        var _this = _possibleConstructorReturn(this, (LinkPicker.__proto__ || Object.getPrototypeOf(LinkPicker)).call(this, props));

        _this.defaultState = _this.defaultState.bind(_this);
        _this.onUrlChange = _this.onUrlChange.bind(_this);
        _this.onCheckboxChange = _this.onCheckboxChange.bind(_this);
        _this.output = _this.output.bind(_this);

        _this.defaultState(props);

        return _this;
    }

    _createClass(LinkPicker, [{
        key: 'defaultState',
        value: function defaultState(props) {
            this.state = {
                enabled: false,
                url: '',
                timestamp: new Date().getMilliseconds()
            };

            if (props.data) {
                this.state.enabled = props.data.enabled;
                this.state.url = props.data.url;
            }
        }
    }, {
        key: 'output',
        value: function output() {
            var changes = {
                'url': this.state.url,
                'enabled': this.state.enabled
            };

            this.props.handleLinkChange(this.props.data.id, changes);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.defaultState(nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevObject, prevState) {
            if (this.state.timestamp != prevState.timestamp) {
                this.output();
            }
        }
    }, {
        key: 'onUrlChange',
        value: function onUrlChange(e) {
            var change = { url: e.target.value, timestamp: new Date().getMilliseconds() };
            if (e.target.value != '') {
                change.enabled = true;
            }
            this.setState(change);
        }
    }, {
        key: 'onCheckboxChange',
        value: function onCheckboxChange(e) {
            var _change;

            var key = e.target.getAttribute('data-key');
            var val = !this.state[key];
            var change = (_change = {}, _defineProperty(_change, key, val), _defineProperty(_change, 'timestamp', new Date().getMilliseconds()), _change);

            if (key == 'enabled' && val == false) {
                change.url = '';
            }

            this.setState(change);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = 'col-sm-9 p-2';

            if (this.props.onlyPickUrl === true) {
                style = 'col-sm-12 p-0';
            }
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 p-0' },
                this.props.onlyPickUrl !== true ? _react2.default.createElement(
                    'div',
                    { className: 'col-sm-3 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox-custom checkbox-default' },
                        _react2.default.createElement('input', { type: 'checkbox', checked: this.state.enabled, 'data-key': 'enabled', onChange: this.onCheckboxChange }),
                        _react2.default.createElement(
                            'label',
                            null,
                            'Enabled'
                        )
                    )
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: style },
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.url, onChange: this.onUrlChange, placeholder: 'Web address' })
                )
            );
        }
    }]);

    return LinkPicker;
}(_react2.default.Component);

exports.default = LinkPicker;

/***/ })

},[717]);


// WEBPACK FOOTER //
// app.bac0e6a5e79a30ba7f5f.js